import { DateTime, UTCDate, DateOrDateTime } from "@ankaadia/ankaadia-shared";
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AnkaadiaDateTime scalar (<utcIso>|<offset>|<zone>) preserving offset and zone */
  AnkaadiaDateTime: { input: DateTime; output: DateTime; }
  DateOrDateTime: { input: DateOrDateTime; output: DateOrDateTime; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** UTCDate scalar (date-only YYYY-MM-DD at UTC midnight) */
  UTCDate: { input: UTCDate; output: UTCDate; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

export class AccountBalance {
  __typename?: 'AccountBalance';
  amount: Scalars['Float']['output'];
  currency: SupportedBillingCurrency;
  organizationId?: Maybe<Scalars['ID']['output']>;
};

export class AccountBalanceGetInput {
  calculateOverallTotal?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AccountingRecordType {
  Cost = 'Cost',
  Revenue = 'Revenue'
}

export class AccrualCalculationInput {
  month: Scalars['UTCDate']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AccrualMonthlySnapshotEntity {
  __typename?: 'AccrualMonthlySnapshotEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  accountBalances: AccrualSnapshotAccountBalances;
  billingYear?: Maybe<AccrualSnapshotBillingYear>;
  calculatedAt: Scalars['AnkaadiaDateTime']['output'];
  contingentSnapshots?: Maybe<Array<AccrualSnapshotContingent>>;
  contractId?: Maybe<Scalars['String']['output']>;
  deferredRevenueByStrategy: AccrualSnapshotDeferredRevenueByStrategy;
  floor?: Maybe<AccrualSnapshotFloor>;
  id?: Maybe<Scalars['ID']['output']>;
  month: Scalars['UTCDate']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  targetOrganizationId: Scalars['ID']['output'];
};

export class AccrualPosting {
  __typename?: 'AccrualPosting';
  accrualType: AccrualType;
  amount: Scalars['Float']['output'];
  bookingIds?: Maybe<Array<Scalars['ID']['output']>>;
  bookingNumbers?: Maybe<Array<Scalars['String']['output']>>;
  creditAccount: Scalars['String']['output'];
  currency: SupportedBillingCurrency;
  debitAccount: Scalars['String']['output'];
  debitorNumber: Scalars['String']['output'];
  description: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  organizationCode?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  postingDate: Scalars['UTCDate']['output'];
  reference: Scalars['String']['output'];
  revenueCategory: RevenueCategory;
};

export class AccrualRangeCalculationInput {
  fromMonth: Scalars['UTCDate']['input'];
  organizationId: Scalars['ID']['input'];
  toMonth: Scalars['UTCDate']['input'];
};

export class AccrualSnapshotAccountBalances {
  __typename?: 'AccrualSnapshotAccountBalances';
  deferredRevenue3902: Scalars['Float']['output'];
  unbilledRevenue4815: Scalars['Float']['output'];
  unbilledRevenueReceivable1080: Scalars['Float']['output'];
};

export class AccrualSnapshotBillingYear {
  __typename?: 'AccrualSnapshotBillingYear';
  endDate: Scalars['UTCDate']['output'];
  periodIndex: Scalars['Int']['output'];
  startDate: Scalars['UTCDate']['output'];
  totalPeriods: Scalars['Int']['output'];
};

export class AccrualSnapshotContingent {
  __typename?: 'AccrualSnapshotContingent';
  contingentId: Scalars['String']['output'];
  contingentNumber: Scalars['String']['output'];
  definitionId: Scalars['String']['output'];
  remainingSlots: Scalars['Int']['output'];
  totalSlots: Scalars['Int']['output'];
  tranches: Array<AccrualSnapshotContingentTranche>;
  usageCount: Scalars['Int']['output'];
};

export class AccrualSnapshotContingentTranche {
  __typename?: 'AccrualSnapshotContingentTranche';
  accumulatedRelease: Scalars['Float']['output'];
  accumulatedUnbilledRevenue?: Maybe<Scalars['Float']['output']>;
  bookingAmount: Scalars['Float']['output'];
  bookingId: Scalars['String']['output'];
  bookingNumber: Scalars['String']['output'];
  remainingAmount: Scalars['Float']['output'];
};

export class AccrualSnapshotDeferredRevenueByStrategy {
  __typename?: 'AccrualSnapshotDeferredRevenueByStrategy';
  addOn: Scalars['Float']['output'];
  candidate: Scalars['Float']['output'];
  contingent: Scalars['Float']['output'];
  license: Scalars['Float']['output'];
  recurringFee?: Maybe<Scalars['Float']['output']>;
};

export class AccrualSnapshotFilterInput {
  month?: InputMaybe<Scalars['UTCDate']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AccrualSnapshotFloor {
  __typename?: 'AccrualSnapshotFloor';
  accumulatedUnbilledRevenue: Scalars['Float']['output'];
  cumulatedBillings: Scalars['Float']['output'];
  monthlyBilling: Scalars['Float']['output'];
  yearlyFloor: Scalars['Float']['output'];
};

export class AccrualSummary {
  __typename?: 'AccrualSummary';
  currency: SupportedBillingCurrency;
  month: Scalars['UTCDate']['output'];
  postings: Array<AccrualPosting>;
};

export enum AccrualTreatment {
  Accrue = 'Accrue',
  DirectRevenue = 'DirectRevenue'
}

export enum AccrualType {
  DeferredRevenue = 'DeferredRevenue',
  DeferredRevenueReversal = 'DeferredRevenueReversal',
  UnbilledRevenue = 'UnbilledRevenue',
  UnbilledRevenueReversal = 'UnbilledRevenueReversal'
}

export class ActivationConditionActivationInfo {
  __typename?: 'ActivationConditionActivationInfo';
  expression?: Maybe<Scalars['String']['output']>;
  isExisting: Scalars['Boolean']['output'];
  isFinished: Scalars['Boolean']['output'];
  result?: Maybe<Scalars['String']['output']>;
};

export type ActivationConditionEvent = ClarificationRequiredEmitEvent | FinishEmitEvent | GenerateActivationConditionResult | MessageEmitEvent | ProgressEmitEvent | SubagentProgressEmitEvent | SubagentResultEmitEvent | SubagentStartEmitEvent | ToolErrorEmitEvent;

export class ActiveUserPriceInfo {
  __typename?: 'ActiveUserPriceInfo';
  billingOrganizationId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<SupportedBillingCurrency>;
  includedUsers: Scalars['Float']['output'];
  isPartnerOrganization: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
};

export class Activity {
  __typename?: 'Activity';
  _etag?: Maybe<Scalars['String']['output']>;
  additionalOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  candidate?: Maybe<CandidateActivityParameter>;
  collection?: Maybe<ActivityParameter>;
  contract?: Maybe<ContractActivityParameter>;
  date: Scalars['AnkaadiaDateTime']['output'];
  educationExam?: Maybe<EducationExamActivityParameter>;
  id?: Maybe<Scalars['ID']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  localizedSourceTaskDisplayName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  parameters?: Maybe<Scalars['JSONObject']['output']>;
  previewableFiles?: Maybe<Array<PreviewableFile>>;
  process?: Maybe<ActivityParameter>;
  processModel?: Maybe<ProcessModelActivityParameter>;
  sharing?: Maybe<SharingActivityParameter>;
  source: ActivitySource;
  sourceProcessDisplayName?: Maybe<Scalars['String']['output']>;
  sourceTaskDisplayNames?: Maybe<Array<ProcessOptionalString>>;
  task?: Maybe<TaskActivityParameter>;
  taskState?: Maybe<TaskActivityParameter>;
  type: ActivityType;
  user: ActivityParameter;
};

export class ActivityCandidateFilterInput {
  organizationId: Scalars['ID']['input'];
  selectedOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class ActivityChangeRecord {
  __typename?: 'ActivityChangeRecord';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['ID']['output']>;
  approval?: Maybe<Approval>;
  change?: Maybe<Scalars['JSONObject']['output']>;
};

export class ActivityCollectionFilterInput {
  organizationId: Scalars['ID']['input'];
  selectedOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class ActivityDiff {
  __typename?: 'ActivityDiff';
  children?: Maybe<Array<ActivityDiff>>;
  data: ActivityDiffData;
};

export class ActivityDiffData {
  __typename?: 'ActivityDiffData';
  captionKey: Scalars['String']['output'];
  captionParameter?: Maybe<Scalars['JSONObject']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  property: Scalars['String']['output'];
};

export class ActivityDiffInput {
  activityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ActivityFilterOption {
  __typename?: 'ActivityFilterOption';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class ActivityOrganizationFilterInput {
  organizationId: Scalars['ID']['input'];
};

export class ActivityPageInput {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export class ActivityParameter {
  __typename?: 'ActivityParameter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class ActivitySource {
  __typename?: 'ActivitySource';
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  typeName: Scalars['String']['output'];
};

export enum ActivityType {
  AutoProcessOperationFailed = 'AutoProcessOperationFailed',
  AutoProcessOperationTriggered = 'AutoProcessOperationTriggered',
  AutoTeamNoResponsibleUser = 'AutoTeamNoResponsibleUser',
  AutoTeamRoleNotSetOrOwner = 'AutoTeamRoleNotSetOrOwner',
  BaseProcessNotFound = 'BaseProcessNotFound',
  CandidateAdded = 'CandidateAdded',
  CandidateAddedToCollection = 'CandidateAddedToCollection',
  CandidateAddedToExam = 'CandidateAddedToExam',
  CandidateBirthday = 'CandidateBirthday',
  CandidateBirthdaySoon = 'CandidateBirthdaySoon',
  CandidateDeleted = 'CandidateDeleted',
  CandidateDeletionReminder = 'CandidateDeletionReminder',
  CandidateDroppedOut = 'CandidateDroppedOut',
  CandidateLoggedIn = 'CandidateLoggedIn',
  CandidateNotFound = 'CandidateNotFound',
  CandidateOptedIn = 'CandidateOptedIn',
  CandidateOptedOut = 'CandidateOptedOut',
  CandidateRemovedFromCollection = 'CandidateRemovedFromCollection',
  CandidateRemovedFromExam = 'CandidateRemovedFromExam',
  CandidateRequestDeletion = 'CandidateRequestDeletion',
  CandidateTransferred = 'CandidateTransferred',
  CandidateUpdated = 'CandidateUpdated',
  ChildOrganizationLinksSynced = 'ChildOrganizationLinksSynced',
  CollectionAdded = 'CollectionAdded',
  CollectionDeleted = 'CollectionDeleted',
  CollectionEmbeddedIntoCollection = 'CollectionEmbeddedIntoCollection',
  CollectionNotFound = 'CollectionNotFound',
  CollectionRemovedFromCollection = 'CollectionRemovedFromCollection',
  CollectionUpdated = 'CollectionUpdated',
  ConsentFeedback = 'ConsentFeedback',
  ContractAnnulled = 'ContractAnnulled',
  ContractCancellationWithdrawn = 'ContractCancellationWithdrawn',
  ContractCancelled = 'ContractCancelled',
  ContractCreated = 'ContractCreated',
  ContractPlanChanged = 'ContractPlanChanged',
  CvParsingRequested = 'CvParsingRequested',
  DocumentNotFound = 'DocumentNotFound',
  DocumentSetMetaDataModified = 'DocumentSetMetaDataModified',
  EducationExamCreated = 'EducationExamCreated',
  EducationExamDeleted = 'EducationExamDeleted',
  EducationExamResultCreated = 'EducationExamResultCreated',
  EducationExamResultDeleted = 'EducationExamResultDeleted',
  EducationExamUpdated = 'EducationExamUpdated',
  EmailNotDelivered = 'EmailNotDelivered',
  FeedbackCommentAdded = 'FeedbackCommentAdded',
  FeedbackProvided = 'FeedbackProvided',
  FileDeleted = 'FileDeleted',
  FileExpiresSoon = 'FileExpiresSoon',
  FileModified = 'FileModified',
  FileUploaded = 'FileUploaded',
  FreeFormatFileDeleted = 'FreeFormatFileDeleted',
  FreeFormatFileUploaded = 'FreeFormatFileUploaded',
  InterviewCommentAdded = 'InterviewCommentAdded',
  InterviewCommentDeleted = 'InterviewCommentDeleted',
  InterviewCommentUpdated = 'InterviewCommentUpdated',
  InterviewEmployerUpdated = 'InterviewEmployerUpdated',
  InterviewFeedbackAdded = 'InterviewFeedbackAdded',
  InterviewFeedbackDeleted = 'InterviewFeedbackDeleted',
  InterviewFeedbackUpdated = 'InterviewFeedbackUpdated',
  InterviewIterationAdded = 'InterviewIterationAdded',
  InterviewIterationDeleted = 'InterviewIterationDeleted',
  InvalidSharingTemplate = 'InvalidSharingTemplate',
  InvalidUserGroupRoleMapping = 'InvalidUserGroupRoleMapping',
  InvoicePaid = 'InvoicePaid',
  OnlineApplicationRun = 'OnlineApplicationRun',
  OrganizationLinkInvitationAccepted = 'OrganizationLinkInvitationAccepted',
  OrganizationNotFound = 'OrganizationNotFound',
  OrganizationNotLinked = 'OrganizationNotLinked',
  ProcessCreated = 'ProcessCreated',
  ProcessDeleted = 'ProcessDeleted',
  ProcessModelDeleted = 'ProcessModelDeleted',
  ProcessModelNotFound = 'ProcessModelNotFound',
  ProcessModelPublished = 'ProcessModelPublished',
  ProcessModelReleaseCreated = 'ProcessModelReleaseCreated',
  ProcessModelUnpublished = 'ProcessModelUnpublished',
  ProcessNotFound = 'ProcessNotFound',
  ProcessReset = 'ProcessReset',
  ProfileMaskUpdated = 'ProfileMaskUpdated',
  SharingAdded = 'SharingAdded',
  SharingDeleted = 'SharingDeleted',
  SharingDisabled = 'SharingDisabled',
  SharingEnabled = 'SharingEnabled',
  SharingTypeModified = 'SharingTypeModified',
  SharingUpdated = 'SharingUpdated',
  TalentPoolRequestApproved = 'TalentPoolRequestApproved',
  TalentPoolRequestReceived = 'TalentPoolRequestReceived',
  TalentPoolRequestRejected = 'TalentPoolRequestRejected',
  TaskCancelled = 'TaskCancelled',
  TaskChanged = 'TaskChanged',
  TaskDelegatedByRule = 'TaskDelegatedByRule',
  TaskDelegationRevokedByRule = 'TaskDelegationRevokedByRule',
  TaskDeleted = 'TaskDeleted',
  TaskFailed = 'TaskFailed',
  TaskFinished = 'TaskFinished',
  TaskManuallyChanged = 'TaskManuallyChanged',
  TaskManuallyCreated = 'TaskManuallyCreated',
  TaskNotFound = 'TaskNotFound',
  TaskNoteAdded = 'TaskNoteAdded',
  TaskReminderSent = 'TaskReminderSent',
  TaskReset = 'TaskReset',
  TaskStarted = 'TaskStarted',
  TaskStateChanged = 'TaskStateChanged',
  TaskStateManuallyChanged = 'TaskStateManuallyChanged',
  TaskStopped = 'TaskStopped',
  TranslationFailed = 'TranslationFailed',
  TranslationUploaded = 'TranslationUploaded',
  UserLoggedIn = 'UserLoggedIn',
  UserNotFound = 'UserNotFound'
}

export class ActivityUserFilterInput {
  organizationId: Scalars['ID']['input'];
  selectedOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class AdHocEducationExam {
  __typename?: 'AdHocEducationExam';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  examDateAndTime?: Maybe<DateWithTime>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  examLocation?: Maybe<Scalars['String']['output']>;
  examModules?: Maybe<Array<ExamModuleType>>;
  examType: ExamType;
  id?: Maybe<Scalars['ID']['output']>;
  languageLevel?: Maybe<Scalars['String']['output']>;
  moduleType: EducationModuleType;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  plannedExamDateAndTime?: Maybe<DateTimeOrRange>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['output'];
  plannedExamResultDate?: Maybe<Scalars['UTCDate']['output']>;
  responsibleRolePayment?: Maybe<Scalars['String']['output']>;
};

export class AdHocEducationExamCreateInput {
  examDateAndTime?: InputMaybe<DateWithTimeInput>;
  examInstitution?: InputMaybe<Scalars['String']['input']>;
  examLocation?: InputMaybe<Scalars['String']['input']>;
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType: ExamType;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
  moduleType: EducationModuleType;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  plannedExamDateAndTime?: InputMaybe<DateOrDateRangeInput>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['input'];
  plannedExamResultDate?: InputMaybe<Scalars['UTCDate']['input']>;
  responsibleRolePayment?: InputMaybe<Scalars['String']['input']>;
};

export class AdHocEducationExamDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AdHocEducationExamForCandidate {
  __typename?: 'AdHocEducationExamForCandidate';
  exam?: Maybe<AdHocEducationExam>;
  level: Scalars['String']['output'];
  participant?: Maybe<EducationExamParticipantEntity>;
  result?: Maybe<EducationExamResultFullData>;
};

export class AdHocEducationExamGetByCandidateIdInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class AdHocEducationExamGetByCriteriaInput {
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType?: InputMaybe<ExamType>;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<ExamStatus>;
};

export class AdHocEducationExamUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  examDateAndTime?: InputMaybe<DateWithTimeInput>;
  examInstitution?: InputMaybe<Scalars['String']['input']>;
  examLocation?: InputMaybe<Scalars['String']['input']>;
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType: ExamType;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
  moduleType: EducationModuleType;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  plannedExamDateAndTime?: InputMaybe<DateOrDateRangeInput>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['input'];
  plannedExamResultDate?: InputMaybe<Scalars['UTCDate']['input']>;
  responsibleRolePayment?: InputMaybe<Scalars['String']['input']>;
};

export class AddCandidatesToCollectionsInput {
  candidateId: Scalars['ID']['input'];
  collections: Array<CollectionInput>;
  organizationId: Scalars['ID']['input'];
  sourceCollectionId?: InputMaybe<Scalars['ID']['input']>;
  sourceCollectionOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export class AddCandidatesToCollectionsResult {
  __typename?: 'AddCandidatesToCollectionsResult';
  error?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  notAddedCollectionIds?: Maybe<Array<Scalars['String']['output']>>;
};

export class AddDiscountInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  maxUses?: InputMaybe<Scalars['Float']['input']>;
  phaseId: Scalars['String']['input'];
  startDate: Scalars['UTCDate']['input'];
  type: DiscountType;
  value: Scalars['Float']['input'];
};

export class AddForeignGroupsToGroupInput {
  _etag: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  groupsIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AddInServiceConfiguration {
  __typename?: 'AddInServiceConfiguration';
  _etag?: Maybe<Scalars['String']['output']>;
  ankaadiaDocumentExtraction?: Maybe<AnkaadiaDocumentExtractionServiceConfiguration>;
  budgetLimitThreshold?: Maybe<Scalars['Float']['output']>;
  budgetWarningThreshold?: Maybe<Scalars['Float']['output']>;
  category: AddOnServiceCategoryEnum;
  documentSigning?: Maybe<DocumentSigningServiceConfiguration>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  propertyAndCasualtyInsurance?: Maybe<PropertyAndCasualtyInsuranceServiceConfiguration>;
  selectedPartners?: Maybe<Array<Scalars['ID']['output']>>;
  serviceAvailability?: Maybe<AddOnServiceAvailabilityForPartners>;
  serviceId: AddOnServicesEnum;
  serviceStatus: AddOnServiceStatus;
};

export class AddOnBookingDetail {
  __typename?: 'AddOnBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
};

export class AddOnBookingDetailGetByBookingIdInput {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum AddOnServiceAvailabilityForPartners {
  All = 'All',
  None = 'None',
  Selected = 'Selected'
}

export class AddOnServiceBaseResolverInput {
  category: AddOnServiceCategoryEnum;
  organizationId: Scalars['ID']['input'];
  serviceId: AddOnServicesEnum;
};

export enum AddOnServiceCategoryEnum {
  ChatService = 'ChatService',
  DocumentExtractionService = 'DocumentExtractionService',
  DocumentSigningService = 'DocumentSigningService',
  DocumentTranslationService = 'DocumentTranslationService',
  GeneralBrokerInsuranceService = 'GeneralBrokerInsuranceService',
  HealthInsuranceApplicationService = 'HealthInsuranceApplicationService',
  PropertyAndCasualtyInsuranceService = 'PropertyAndCasualtyInsuranceService',
  TalentPoolService = 'TalentPoolService'
}

export class AddOnServiceConfigurationInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  ankaadiaDocumentExtraction?: InputMaybe<AnkaadiaDocumentExtractionServiceConfigurationInput>;
  budgetLimitThreshold?: InputMaybe<Scalars['Float']['input']>;
  budgetWarningThreshold?: InputMaybe<Scalars['Float']['input']>;
  category: AddOnServiceCategoryEnum;
  documentSigning?: InputMaybe<DocumentSigningServiceConfigurationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  propertyAndCasualtyInsurance?: InputMaybe<PropertyAndCasualtyInsuranceServiceConfigurationInput>;
  selectedPartners?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAvailability?: InputMaybe<AddOnServiceAvailabilityForPartners>;
  serviceId: AddOnServicesEnum;
  serviceStatus: AddOnServiceStatus;
};

export class AddOnServiceInfo {
  __typename?: 'AddOnServiceInfo';
  category: AddOnServiceCategoryEnum;
  consentIdentifier?: Maybe<KnownConsentIdentifiers>;
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  registrationInfo?: Maybe<Scalars['String']['output']>;
  registrationLink?: Maybe<Scalars['String']['output']>;
  serviceDependencies: Array<AddOnServicesEnum>;
  serviceId: AddOnServicesEnum;
  serviceStatus: AddOnServiceStatus;
};

export enum AddOnServiceStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export enum AddOnServicesEnum {
  AnkaadiaCvParsing = 'AnkaadiaCvParsing',
  AnkaadiaDocumentExtraction = 'AnkaadiaDocumentExtraction',
  BarmerHealthInsuranceApplication = 'BarmerHealthInsuranceApplication',
  CometChat = 'CometChat',
  DocuSealDocumentSigning = 'DocuSealDocumentSigning',
  GeneralBrokerInsuranceService = 'GeneralBrokerInsuranceService',
  LingoKingDocumentTranslation = 'LingoKingDocumentTranslation',
  PropertyAndCasualtyInsurance = 'PropertyAndCasualtyInsurance',
  TalentPoolEmployerPoolService = 'TalentPoolEmployerPoolService',
  TalentPoolPsaPoolService = 'TalentPoolPSAPoolService',
  TalentPoolWebsiteService = 'TalentPoolWebsiteService'
}

export class AddRecurringFeeInput {
  bookingText: Scalars['String']['input'];
  bookingType: BookingType;
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  currency: SupportedBillingCurrency;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  paymentTime: PaymentTime;
  period: PaymentPeriod;
  price: Scalars['Float']['input'];
  revenueCategory: RevenueCategory;
  startDate: Scalars['UTCDate']['input'];
  targetInvoiceType: InvoiceType;
};

export class AddUsersToGroupInput {
  _etag: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export class AdditionalModules {
  __typename?: 'AdditionalModules';
  gueteSiegel?: Maybe<Scalars['Boolean']['output']>;
  organizationProfile?: Maybe<Scalars['Boolean']['output']>;
  processAgent?: Maybe<Scalars['Boolean']['output']>;
  professions?: Maybe<Scalars['Boolean']['output']>;
  talentPool?: Maybe<Scalars['Boolean']['output']>;
};

export class AdhocProcessAcquireInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AdhocProcessTaskBulkCreateInput {
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentError?: InputMaybe<Scalars['String']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessOptionalStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  avgPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  cancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  candidateDocuments?: InputMaybe<Array<CandidateDocTypeAttachmentInput>>;
  candidateIds?: InputMaybe<Array<CandidateIdInput>>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<TaskDelayInput>;
  delayHistory?: InputMaybe<Array<TaskDelayInput>>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  delegations?: InputMaybe<Array<TaskDelegationInput>>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayAttachmentError?: InputMaybe<Scalars['Boolean']['input']>;
  displayAttachmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayMissingOrganizationDocument?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<ProcessDocumentRequirementInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadableAttachmentsLink?: InputMaybe<Scalars['String']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  fieldsToExcludeFromSync?: InputMaybe<Array<Scalars['String']['input']>>;
  finishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<Scalars['String']['input']>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationFieldsInput>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lastUpdateManualStarted?: InputMaybe<Scalars['Boolean']['input']>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  maxFileSize?: InputMaybe<Scalars['Float']['input']>;
  maxFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  maxPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  maxUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  milestoneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minDuration?: InputMaybe<Scalars['Float']['input']>;
  minFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  minPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  minUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  missingOrganizationDocument?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Float']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Float']['input']>;
  organizationDocuments?: InputMaybe<Array<DocTypeAttachmentInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pertPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  previousAttempts?: InputMaybe<Array<Scalars['String']['input']>>;
  previousTaskId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Float']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<ProcessDocumentToUploadTypeInput>>;
  processInstanceState?: InputMaybe<ProcessInstanceStateEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivatedByTask?: InputMaybe<Scalars['ID']['input']>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleUserGroups: Array<OrganizationUserGroupMappingInput>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  ruleExecutionError?: InputMaybe<RuleExecutionErrorInput>;
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  signingRoleOrganizationUserGroups?: InputMaybe<Array<SigningRoleOrganizationUserGroupMappingInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRolesChangedBy?: InputMaybe<Scalars['String']['input']>;
  targetUserGroupConfig: UserGroupConfigurationInput;
  taskDisplayId?: InputMaybe<Scalars['String']['input']>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName: Scalars['String']['input'];
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForUserGroupConfig: UserGroupConfigurationInput;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AdhocProcessTaskCreateInput {
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentError?: InputMaybe<Scalars['String']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessOptionalStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  avgPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  cancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateDocuments?: InputMaybe<Array<CandidateDocTypeAttachmentInput>>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<TaskDelayInput>;
  delayHistory?: InputMaybe<Array<TaskDelayInput>>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  delegations?: InputMaybe<Array<TaskDelegationInput>>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayAttachmentError?: InputMaybe<Scalars['Boolean']['input']>;
  displayAttachmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayMissingOrganizationDocument?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<ProcessDocumentRequirementInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadableAttachmentsLink?: InputMaybe<Scalars['String']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  fieldsToExcludeFromSync?: InputMaybe<Array<Scalars['String']['input']>>;
  finishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<Scalars['String']['input']>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationFieldsInput>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lastUpdateManualStarted?: InputMaybe<Scalars['Boolean']['input']>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  maxFileSize?: InputMaybe<Scalars['Float']['input']>;
  maxFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  maxPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  maxUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  milestoneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minDuration?: InputMaybe<Scalars['Float']['input']>;
  minFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  minPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  minUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  missingOrganizationDocument?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Float']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Float']['input']>;
  organizationDocuments?: InputMaybe<Array<DocTypeAttachmentInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pertPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  previousAttempts?: InputMaybe<Array<Scalars['String']['input']>>;
  previousTaskId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Float']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<ProcessDocumentToUploadTypeInput>>;
  processInstanceState?: InputMaybe<ProcessInstanceStateEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivatedByTask?: InputMaybe<Scalars['ID']['input']>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleUserGroups: Array<OrganizationUserGroupMappingInput>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  ruleExecutionError?: InputMaybe<RuleExecutionErrorInput>;
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  signingRoleOrganizationUserGroups?: InputMaybe<Array<SigningRoleOrganizationUserGroupMappingInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRolesChangedBy?: InputMaybe<Scalars['String']['input']>;
  targetUserGroupConfig: UserGroupConfigurationInput;
  taskDisplayId?: InputMaybe<Scalars['String']['input']>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName: Scalars['String']['input'];
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForUserGroupConfig: UserGroupConfigurationInput;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AdhocProcessTaskUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentError?: InputMaybe<Scalars['String']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessOptionalStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  avgPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  cancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateDocuments?: InputMaybe<Array<CandidateDocTypeAttachmentInput>>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<TaskDelayInput>;
  delayHistory?: InputMaybe<Array<TaskDelayInput>>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  delegations?: InputMaybe<Array<TaskDelegationInput>>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayAttachmentError?: InputMaybe<Scalars['Boolean']['input']>;
  displayAttachmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayMissingOrganizationDocument?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<ProcessDocumentRequirementInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadableAttachmentsLink?: InputMaybe<Scalars['String']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  fieldsToExcludeFromSync?: InputMaybe<Array<Scalars['String']['input']>>;
  finishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<Scalars['String']['input']>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationFieldsInput>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lastUpdateManualStarted?: InputMaybe<Scalars['Boolean']['input']>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  maxFileSize?: InputMaybe<Scalars['Float']['input']>;
  maxFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  maxPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  maxUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  milestoneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minDuration?: InputMaybe<Scalars['Float']['input']>;
  minFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  minPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  minUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  missingOrganizationDocument?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Float']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Float']['input']>;
  organizationDocuments?: InputMaybe<Array<DocTypeAttachmentInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserGroupConfig: UserGroupConfigurationInput;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pertPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  previousAttempts?: InputMaybe<Array<Scalars['String']['input']>>;
  previousTaskId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Float']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<ProcessDocumentToUploadTypeInput>>;
  processInstanceState?: InputMaybe<ProcessInstanceStateEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivatedByTask?: InputMaybe<Scalars['ID']['input']>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleUserGroups: Array<OrganizationUserGroupMappingInput>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  ruleExecutionError?: InputMaybe<RuleExecutionErrorInput>;
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  selectedChildTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  signingRoleOrganizationUserGroups?: InputMaybe<Array<SigningRoleOrganizationUserGroupMappingInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRolesChangedBy?: InputMaybe<Scalars['String']['input']>;
  targetUserGroupConfig: UserGroupConfigurationInput;
  taskDisplayId?: InputMaybe<Scalars['String']['input']>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName: Scalars['String']['input'];
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForUserGroupConfig: UserGroupConfigurationInput;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AfterRecognition {
  __typename?: 'AfterRecognition';
  confirmationSignedDate?: Maybe<Scalars['UTCDate']['output']>;
  contractExtension?: Maybe<Scalars['Boolean']['output']>;
  contractSignDate?: Maybe<Scalars['UTCDate']['output']>;
  contractTemplate?: Maybe<RecognitionPathContractTemplate>;
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  contractTemplateName?: Maybe<Scalars['String']['output']>;
  contractTemplateOrganizationId?: Maybe<Scalars['ID']['output']>;
  employerHistory?: Maybe<Array<EmployerHistoryEntry>>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employerRegion?: Maybe<Scalars['String']['output']>;
  employerZipcode?: Maybe<Scalars['String']['output']>;
  employmentRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  endOfProbationDate?: Maybe<Scalars['UTCDate']['output']>;
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  isTemporaryEmployee?: Maybe<Scalars['Boolean']['output']>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['UTCDate']['output']>;
  typeOfWorkLocation?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workLocationOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class AfterRecognitionInput {
  confirmationSignedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  contractExtension?: InputMaybe<Scalars['Boolean']['input']>;
  contractSignDate?: InputMaybe<Scalars['UTCDate']['input']>;
  contractTemplate?: InputMaybe<RecognitionPathContractTemplateInput>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  contractTemplateName?: InputMaybe<Scalars['String']['input']>;
  contractTemplateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  employerHistory?: InputMaybe<Array<EmployerHistoryEntryInput>>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerRegion?: InputMaybe<Scalars['String']['input']>;
  employerZipcode?: InputMaybe<Scalars['String']['input']>;
  employmentRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  endOfProbationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  isTemporaryEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['UTCDate']['input']>;
  typeOfWorkLocation?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workLocationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AgentRunHandle {
  __typename?: 'AgentRunHandle';
  runId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
};

export class AggregatedMilestoneData {
  __typename?: 'AggregatedMilestoneData';
  avgDurationInDays: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  milestoneData?: Maybe<Array<GlobalMilestoneWithMeta>>;
};

export class AggregatedMilestoneState {
  __typename?: 'AggregatedMilestoneState';
  activeCount: Scalars['Float']['output'];
  finishedCount: Scalars['Float']['output'];
  localizedName: Scalars['String']['output'];
  milestoneId: Scalars['String']['output'];
  overdueCount: Scalars['Float']['output'];
  pendingCount: Scalars['Float']['output'];
  scheduleDistribution: MilestoneScheduleBreakdown;
};

export class AggregatedMilestoneStates {
  __typename?: 'AggregatedMilestoneStates';
  candidateCount: Scalars['Float']['output'];
  milestones: Array<AggregatedMilestoneState>;
  summaryDistribution: MilestoneScheduleBreakdown;
};

export enum AiChatContextType {
  ProcessModel = 'ProcessModel'
}

export class AiChatHistoryEntry {
  __typename?: 'AiChatHistoryEntry';
  content: Scalars['String']['output'];
  role: AiChatHistoryRole;
};

export enum AiChatHistoryRole {
  Assistant = 'Assistant',
  User = 'User'
}

export class AiChatSessionDetail {
  __typename?: 'AiChatSessionDetail';
  contextDisplayName: Scalars['String']['output'];
  contextId: Scalars['ID']['output'];
  contextType: AiChatContextType;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isLastContextTokensEstimated: Scalars['Boolean']['output'];
  lastActivityAt: Scalars['AnkaadiaDateTime']['output'];
  lastContextTokens?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSource: AiChatTitleSource;
  turnCount: Scalars['Int']['output'];
  turns: Array<AiChatTurn>;
};

export class AiChatSessionListInput {
  contextId: Scalars['ID']['input'];
  contextType: AiChatContextType;
};

export class AiChatSessionListResult {
  __typename?: 'AiChatSessionListResult';
  items: Array<AiChatSessionSummary>;
  policy: AiChatSessionPolicy;
};

export class AiChatSessionPolicy {
  __typename?: 'AiChatSessionPolicy';
  contextBudgetTokens: Scalars['Int']['output'];
  maxSessionsPerContext: Scalars['Int']['output'];
  retentionDays: Scalars['Int']['output'];
  softWarningRatio: Scalars['Float']['output'];
  strongWarningRatio: Scalars['Float']['output'];
  titleMaxLength: Scalars['Int']['output'];
};

export class AiChatSessionSummary {
  __typename?: 'AiChatSessionSummary';
  contextDisplayName: Scalars['String']['output'];
  contextId: Scalars['ID']['output'];
  contextType: AiChatContextType;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isLastContextTokensEstimated: Scalars['Boolean']['output'];
  lastActivityAt: Scalars['AnkaadiaDateTime']['output'];
  lastContextTokens?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSource: AiChatTitleSource;
  turnCount: Scalars['Int']['output'];
};

export class AiChatSessionTitledEvent {
  __typename?: 'AiChatSessionTitledEvent';
  sessionId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum AiChatTitleSource {
  Auto = 'Auto',
  Manual = 'Manual'
}

export class AiChatTurn {
  __typename?: 'AiChatTurn';
  contextTokens?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  historyEntries: Array<AiChatHistoryEntry>;
  id?: Maybe<Scalars['ID']['output']>;
  isContextTokensEstimated: Scalars['Boolean']['output'];
  renderedMessages?: Maybe<Scalars['JSON']['output']>;
  renderedRevision: Scalars['Int']['output'];
  renderedSchemaVersion?: Maybe<Scalars['Int']['output']>;
  sequence: Scalars['Int']['output'];
  startedAt: Scalars['AnkaadiaDateTime']['output'];
  status: AiChatTurnStatus;
};

export enum AiChatTurnStatus {
  Cancelled = 'Cancelled',
  Clarification = 'Clarification',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export enum AiFeedbackRating {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export enum AiResponseType {
  Clarification = 'CLARIFICATION',
  Decline = 'DECLINE',
  Expression = 'EXPRESSION'
}

export class AllCollectionsAutoFilterTemplateSyncInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class AlternativeInstiutionNames {
  __typename?: 'AlternativeInstiutionNames';
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum AmountType {
  Gross = 'Gross',
  Net = 'Net'
}

export enum AnabinAssetType {
  AnabinAbschluesse = 'AnabinAbschluesse',
  AnabinDegreeTypes = 'AnabinDegreeTypes',
  AnabinInstitutions = 'AnabinInstitutions'
}

export class AnabinByIdInput {
  id: Scalars['String']['input'];
  type: AnabinAssetType;
};

export class AnabinDegreeInstitutionInfoViewDetails {
  __typename?: 'AnabinDegreeInstitutionInfoViewDetails';
  class?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export class AnabinDegreesForInfoView {
  __typename?: 'AnabinDegreesForInfoView';
  description: Array<Scalars['JSONObject']['output']>;
  institutions?: Maybe<Array<AnabinInstiutionDegreeInfoViewDetails>>;
  ratings?: Maybe<Array<EquivalentDegrees>>;
};

export class AnabinInstitutionInfoViewDetails {
  __typename?: 'AnabinInstitutionInfoViewDetails';
  alternativeNames?: Maybe<Array<AlternativeInstiutionNames>>;
  degrees?: Maybe<Array<AnabinDegreeInstitutionInfoViewDetails>>;
  description: Array<Scalars['JSONObject']['output']>;
};

export class AnabinInstiutionDegreeInfoViewDetails {
  __typename?: 'AnabinInstiutionDegreeInfoViewDetails';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export class AnabinMinimalInput {
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: AnabinAssetType;
};

export class AnkaadiaDocumentExtractionServiceConfiguration {
  __typename?: 'AnkaadiaDocumentExtractionServiceConfiguration';
  documentTypes?: Maybe<Array<Scalars['String']['output']>>;
  extractForAllDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
};

export class AnkaadiaDocumentExtractionServiceConfigurationInput {
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  extractForAllDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AnkaadiaRelease {
  __typename?: 'AnkaadiaRelease';
  changes: Scalars['String']['output'];
  date: Scalars['AnkaadiaDateTime']['output'];
  isSeen: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export class AnnulContractInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  annulmentDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AnonymizationTypeEnum {
  Address = 'Address',
  BankDetails = 'BankDetails',
  BirthDate = 'BirthDate',
  BirthPlace = 'BirthPlace',
  Citizenship = 'Citizenship',
  CountryOfOrigin = 'CountryOfOrigin',
  EmailAddress = 'EmailAddress',
  ExternalCharacteristics = 'ExternalCharacteristics',
  FamilyAndChildren = 'FamilyAndChildren',
  Gender = 'Gender',
  HealthInsurance = 'HealthInsurance',
  IdDocuments = 'IdDocuments',
  InternalData = 'InternalData',
  IntroductionVideoUrl = 'IntroductionVideoUrl',
  Name = 'Name',
  OtherDetails = 'OtherDetails',
  PhoneNumber = 'PhoneNumber',
  Picture = 'Picture',
  RecommendationNote = 'RecommendationNote',
  SocialAndTaxInformation = 'SocialAndTaxInformation'
}

export class ApplicationMaskCustomQuestion {
  __typename?: 'ApplicationMaskCustomQuestion';
  answerType: ApplicationMaskCustomQuestionAnswerType;
  id: Scalars['ID']['output'];
  infoText?: Maybe<Array<ApplicationMaskLocalizedString>>;
  question: Array<ApplicationMaskLocalizedString>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export enum ApplicationMaskCustomQuestionAnswerType {
  Checkbox = 'Checkbox',
  FreeText = 'FreeText'
}

export class ApplicationMaskCustomQuestionInput {
  answerType: ApplicationMaskCustomQuestionAnswerType;
  id: Scalars['ID']['input'];
  infoText?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  question: Array<ApplicationMaskLocalizedStringInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ApplicationMaskDocumentUpload {
  __typename?: 'ApplicationMaskDocumentUpload';
  alternatives?: Maybe<Array<ApplicationMaskDocumentUploadAlternative>>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentTags: Array<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  infoText?: Maybe<Array<ApplicationMaskLocalizedString>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  uploadType: ApplicationMaskUploadType;
};

export class ApplicationMaskDocumentUploadAlternative {
  __typename?: 'ApplicationMaskDocumentUploadAlternative';
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
};

export class ApplicationMaskDocumentUploadAlternativeInput {
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
};

export class ApplicationMaskDocumentUploadInput {
  alternatives?: InputMaybe<Array<ApplicationMaskDocumentUploadAlternativeInput>>;
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentTags: Array<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  infoText?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  uploadType: ApplicationMaskUploadType;
};

export class ApplicationMaskFreeFormatFile {
  __typename?: 'ApplicationMaskFreeFormatFile';
  blob: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export class ApplicationMaskFreeFormatFileInput {
  blob: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

export class ApplicationMaskLink {
  __typename?: 'ApplicationMaskLink';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  linkText?: Maybe<Array<ApplicationMaskLocalizedString>>;
};

export class ApplicationMaskLinkInput {
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  linkText?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
};

export class ApplicationMaskLocalizedRichText {
  __typename?: 'ApplicationMaskLocalizedRichText';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class ApplicationMaskLocalizedRichTextInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export class ApplicationMaskLocalizedString {
  __typename?: 'ApplicationMaskLocalizedString';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class ApplicationMaskLocalizedStringInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export class ApplicationMaskOrganizationImage {
  __typename?: 'ApplicationMaskOrganizationImage';
  id: Scalars['ID']['output'];
  image?: Maybe<ApplicationMaskFreeFormatFile>;
};

export class ApplicationMaskOrganizationImageInput {
  id: Scalars['ID']['input'];
  image?: InputMaybe<ApplicationMaskFreeFormatFileInput>;
};

export class ApplicationMaskQrCode {
  __typename?: 'ApplicationMaskQrCode';
  freeFormatFile?: Maybe<ApplicationMaskFreeFormatFile>;
  qrCodeLabel?: Maybe<Array<ApplicationMaskLocalizedString>>;
};

export class ApplicationMaskQrCodeInput {
  freeFormatFile?: InputMaybe<ApplicationMaskFreeFormatFileInput>;
  qrCodeLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
};

export class ApplicationMaskSelectedField {
  __typename?: 'ApplicationMaskSelectedField';
  allowedOptionValues?: Maybe<Array<Scalars['String']['output']>>;
  infoText?: Maybe<Array<ApplicationMaskLocalizedString>>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  subFields?: Maybe<Array<ApplicationMaskSelectedFieldConfig>>;
};

export class ApplicationMaskSelectedFieldConfig {
  __typename?: 'ApplicationMaskSelectedFieldConfig';
  allowedOptionValues?: Maybe<Array<Scalars['String']['output']>>;
  infoText?: Maybe<Array<ApplicationMaskLocalizedString>>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export class ApplicationMaskSelectedFieldConfigInput {
  allowedOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  infoText?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export class ApplicationMaskSelectedFieldInput {
  allowedOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  infoText?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  subFields?: InputMaybe<Array<ApplicationMaskSelectedFieldConfigInput>>;
};

export class ApplicationMaskStyle {
  __typename?: 'ApplicationMaskStyle';
  font?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontSizeHeader?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export class ApplicationMaskStyleInput {
  font?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontSizeHeader?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export enum ApplicationMaskUploadType {
  Alternatives = 'Alternatives',
  Single = 'Single'
}

export class ApplyAutoFilterTemplateOnAllCandidatesInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ApplyProgressSubscriptionInput {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  invocationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ApplySubagentResultInput {
  kind: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  result: ApplySubagentResultPayloadInput;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  subagentInvocationId: Scalars['ID']['input'];
  targetItemId?: InputMaybe<Scalars['ID']['input']>;
  targetScope: Scalars['String']['input'];
  targetTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export class ApplySubagentResultOutcome {
  __typename?: 'ApplySubagentResultOutcome';
  commandId?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  subagentInvocationId: Scalars['ID']['output'];
  targetScope: Scalars['String']['output'];
  targetSection: Scalars['String']['output'];
  targetTaskId?: Maybe<Scalars['ID']['output']>;
  taskName: Scalars['String']['output'];
};

export class ApplySubagentResultPayloadInput {
  explanation?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionExplanation?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSONObject']['input']>;
  runConditionExplanation?: InputMaybe<Scalars['String']['input']>;
};

export class Approval {
  __typename?: 'Approval';
  approvedAt: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export class ApproveCandidateDiffPathsInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  paths: Array<Scalars['String']['input']>;
};

export class Archive {
  __typename?: 'Archive';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export class ArchiveCustomPlanInput {
  _etag: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export enum Asset {
  AnabinAbschluesse = 'AnabinAbschluesse',
  AnabinDegreeTypes = 'AnabinDegreeTypes',
  AnabinInstitutions = 'AnabinInstitutions',
  CertificateRecognitionAuthoritiesDe = 'CertificateRecognitionAuthoritiesDE',
  ChamberOfCrafts = 'ChamberOfCrafts',
  CityCoordinatesDe = 'CityCoordinatesDE',
  CountryInformation = 'CountryInformation',
  CountrySpokenLanguages = 'CountrySpokenLanguages',
  DiplomaticMissionsAbroadDe = 'DiplomaticMissionsAbroadDE',
  DiplomaticMissionsAtHomeDe = 'DiplomaticMissionsAtHomeDE',
  EmploymentApprovalAuthoritiesDe = 'EmploymentApprovalAuthoritiesDE',
  EscoOccupationSkills = 'EscoOccupationSkills',
  EscoSkills = 'EscoSkills',
  ImmigrationAuthoritiesDe = 'ImmigrationAuthoritiesDE',
  ProfessionMapping = 'ProfessionMapping',
  RecognitionAuthoritiesAt = 'RecognitionAuthoritiesAT',
  RecognitionAuthoritiesDe = 'RecognitionAuthoritiesDE',
  RecognitionCentersDe = 'RecognitionCentersDE',
  ZipCodesAt = 'ZipCodesAT',
  ZipCodesDe = 'ZipCodesDE'
}

export class AssetDownload {
  __typename?: 'AssetDownload';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export class AssignCollectionInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  assignedId: Scalars['ID']['input'];
  assignedOrganizationId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AssignableMember {
  __typename?: 'AssignableMember';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export class AttachProcessToActionInput {
  actionId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processAndOperations: Array<ProcessAndOperationInput>;
};

export class AttachableAutoCollection {
  __typename?: 'AttachableAutoCollection';
  _etag?: Maybe<Scalars['String']['output']>;
  assignedCandidateIds?: Maybe<Array<CandidateId>>;
  assignedCandidates?: Maybe<Array<Candidate>>;
  assignedCollectionIds?: Maybe<Array<CollectionId>>;
  assignedCollections?: Maybe<Array<Collection>>;
  assignmentExceptions?: Maybe<Array<CandidateAssignmentException>>;
  autoCollectionSettings?: Maybe<AutoCollectionSettingsForUi>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAttachable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  processes?: Maybe<Array<Process>>;
  sharings?: Maybe<Array<Sharing>>;
  targetSize?: Maybe<Scalars['Float']['output']>;
  totalCandidates?: Maybe<Scalars['Float']['output']>;
  totalCandidatesFromAssignedCollections?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CollectionType>;
};

export class AttachableProcess {
  __typename?: 'AttachableProcess';
  collectionId: Scalars['String']['output'];
  collectionName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDelegation: Scalars['Boolean']['output'];
  operationId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export class AttachableProcessesGetInput {
  actionId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class AttachmentTemplateFileType {
  conversionType: TemplateToDocumentTypeConversion;
  templateName: Scalars['String']['input'];
};

export class AttachmentTemplateFileTypeMapping {
  __typename?: 'AttachmentTemplateFileTypeMapping';
  conversionType: TemplateToDocumentTypeConversion;
  templateName: Scalars['String']['output'];
};

export class AttendanceEntry {
  __typename?: 'AttendanceEntry';
  comment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EducationCourseAttendance>;
};

export class AttendanceEntryInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EducationCourseAttendance>;
};

export class Audit {
  __typename?: 'Audit';
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  userOrganizationName?: Maybe<Scalars['String']['output']>;
};

export class AuditDefinition {
  __typename?: 'AuditDefinition';
  _etag?: Maybe<Scalars['String']['output']>;
  definitionDescription?: Maybe<Scalars['String']['output']>;
  definitionName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  tree?: Maybe<Array<AuditDefinitionTreeNode>>;
};

export class AuditDefinitionCreateInput {
  definitionDescription?: InputMaybe<Scalars['String']['input']>;
  definitionName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  tree?: InputMaybe<Array<TreeNodeInput>>;
};

export class AuditDefinitionDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AuditDefinitionGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AuditDefinitionListInput {
  organizationId: Scalars['ID']['input'];
};

export class AuditDefinitionTreeNode {
  __typename?: 'AuditDefinitionTreeNode';
  children?: Maybe<Array<AuditDefinitionTreeNode>>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionOwnRecruitment?: Maybe<Scalars['String']['output']>;
  filesAreMandatory?: Maybe<Scalars['Boolean']['output']>;
  forEmployer?: Maybe<Scalars['Boolean']['output']>;
  forPSA?: Maybe<Scalars['Boolean']['output']>;
  helptext?: Maybe<Scalars['String']['output']>;
  helptextProof?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reCertificationOnly?: Maybe<Scalars['Boolean']['output']>;
};

export class AuditDefinitionUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  definitionDescription?: InputMaybe<Scalars['String']['input']>;
  definitionName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  tree?: InputMaybe<Array<TreeNodeInput>>;
};

export class AuditDefinitionUpdateMetaInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  definitionDescription?: InputMaybe<Scalars['String']['input']>;
  definitionName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AuditFile {
  __typename?: 'AuditFile';
  containerName: Scalars['String']['output'];
  fileBlob: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
};

export class AuditFileInput {
  containerName: Scalars['String']['input'];
  fileBlob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  fileType: Scalars['String']['input'];
};

export class AuditGetInput {
  entityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum AuditTaskModeEnum {
  AdditionalInformationAfterFinalVotum = 'AdditionalInformationAfterFinalVotum',
  AdditionalInformationAuditAfterFinalVotum = 'AdditionalInformationAuditAfterFinalVotum',
  AdditionalInformationAuditAfterFinalVotumConfidante = 'AdditionalInformationAuditAfterFinalVotumCONFIDANTE',
  AdditionalInformationAuditAfterFinalVotumGuete = 'AdditionalInformationAuditAfterFinalVotumGUETE',
  AdditionalInformationAuditAfterFinalVotumGueteboard = 'AdditionalInformationAuditAfterFinalVotumGUETEBOARD',
  AuditAdditionalInformation = 'AuditAdditionalInformation',
  EnterAdditionalInformation = 'EnterAdditionalInformation',
  GatherAuditInformation = 'GatherAuditInformation',
  GatherFinalVotum = 'GatherFinalVotum',
  None = 'None',
  PerformAudit = 'PerformAudit',
  ViewConfidante = 'ViewCONFIDANTE',
  ViewExaminee = 'ViewExaminee',
  ViewQualityComittee = 'ViewQualityComittee'
}

export class AugmentedAfterRecognition {
  __typename?: 'AugmentedAfterRecognition';
  confirmationSignedDate?: Maybe<Scalars['UTCDate']['output']>;
  contractExtension?: Maybe<Scalars['Boolean']['output']>;
  contractSignDate?: Maybe<Scalars['UTCDate']['output']>;
  contractTemplate?: Maybe<RecognitionPathContractTemplate>;
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  contractTemplateName?: Maybe<Scalars['String']['output']>;
  contractTemplateOrganizationId?: Maybe<Scalars['ID']['output']>;
  employerHistory?: Maybe<Array<EmployerHistoryEntry>>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employerRegion?: Maybe<Scalars['String']['output']>;
  employerZipcode?: Maybe<Scalars['String']['output']>;
  employmentRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  endOfProbationDate?: Maybe<Scalars['UTCDate']['output']>;
  firstContractExtension?: Maybe<SetInfo>;
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  isTemporaryEmployee?: Maybe<Scalars['Boolean']['output']>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  secondContractExtension?: Maybe<SetInfo>;
  startDate?: Maybe<Scalars['UTCDate']['output']>;
  typeOfWorkLocation?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workLocationOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class AugmentedAfterRecognitionInput {
  confirmationSignedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  contractExtension?: InputMaybe<Scalars['Boolean']['input']>;
  contractSignDate?: InputMaybe<Scalars['UTCDate']['input']>;
  contractTemplate?: InputMaybe<RecognitionPathContractTemplateInput>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  contractTemplateName?: InputMaybe<Scalars['String']['input']>;
  contractTemplateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  employerHistory?: InputMaybe<Array<EmployerHistoryEntryInput>>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerRegion?: InputMaybe<Scalars['String']['input']>;
  employerZipcode?: InputMaybe<Scalars['String']['input']>;
  employmentRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  endOfProbationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  firstContractExtension?: InputMaybe<SetInfoInput>;
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  isTemporaryEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  secondContractExtension?: InputMaybe<SetInfoInput>;
  startDate?: InputMaybe<Scalars['UTCDate']['input']>;
  typeOfWorkLocation?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workLocationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AugmentedBeforeRecognition {
  __typename?: 'AugmentedBeforeRecognition';
  contractExtension?: Maybe<Scalars['Boolean']['output']>;
  contractSignedByAllParties?: Maybe<SetInfo>;
  contractSignedByOneParty?: Maybe<SetInfo>;
  contractTemplate?: Maybe<RecognitionPathContractTemplate>;
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  contractTemplateName?: Maybe<Scalars['String']['output']>;
  contractTemplateOrganizationId?: Maybe<Scalars['ID']['output']>;
  employerHistory?: Maybe<Array<EmployerHistoryEntry>>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employerRegion?: Maybe<Scalars['String']['output']>;
  employerZipcode?: Maybe<Scalars['String']['output']>;
  employmentOffer?: Maybe<SetInfo>;
  employmentRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  endOfProbationDate?: Maybe<Scalars['UTCDate']['output']>;
  firstContractExtension?: Maybe<SetInfo>;
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  isTemporaryEmployee?: Maybe<Scalars['Boolean']['output']>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  secondContractExtension?: Maybe<SetInfo>;
  typeOfWorkLocation?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workLocationOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class AugmentedBeforeRecognitionInput {
  contractExtension?: InputMaybe<Scalars['Boolean']['input']>;
  contractSignedByAllParties?: InputMaybe<SetInfoInput>;
  contractSignedByOneParty?: InputMaybe<SetInfoInput>;
  contractTemplate?: InputMaybe<RecognitionPathContractTemplateInput>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  contractTemplateName?: InputMaybe<Scalars['String']['input']>;
  contractTemplateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  employerHistory?: InputMaybe<Array<EmployerHistoryEntryInput>>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerRegion?: InputMaybe<Scalars['String']['input']>;
  employerZipcode?: InputMaybe<Scalars['String']['input']>;
  employmentOffer?: InputMaybe<SetInfoInput>;
  employmentRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  endOfProbationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  firstContractExtension?: InputMaybe<SetInfoInput>;
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  isTemporaryEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  secondContractExtension?: InputMaybe<SetInfoInput>;
  typeOfWorkLocation?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workLocationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AugmentedEmploymentRelationship {
  __typename?: 'AugmentedEmploymentRelationship';
  afterRecognition?: Maybe<AugmentedAfterRecognition>;
  beforeRecognition?: Maybe<AugmentedBeforeRecognition>;
  hasDifferentRelationships?: Maybe<Scalars['Boolean']['output']>;
};

export class AugmentedEmploymentRelationshipInput {
  afterRecognition?: InputMaybe<AugmentedAfterRecognitionInput>;
  beforeRecognition?: InputMaybe<AugmentedBeforeRecognitionInput>;
  hasDifferentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AugmentedHousing {
  __typename?: 'AugmentedHousing';
  additionalCosts?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  cancellationOfContractSignDate?: Maybe<Scalars['UTCDate']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coldRent?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<SetInfo>;
  country?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyHandoverDateTime?: Maybe<DateWithTime>;
  movingInDate?: Maybe<Scalars['UTCDate']['output']>;
  movingOutDate?: Maybe<Scalars['UTCDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameOfContactPerson?: Maybe<Scalars['String']['output']>;
  operatingCosts?: Maybe<Scalars['Float']['output']>;
  phoneOfContactPerson?: Maybe<Scalars['String']['output']>;
  readinessForOccupancyDate?: Maybe<Scalars['UTCDate']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class AugmentedHousingAcquisition {
  __typename?: 'AugmentedHousingAcquisition';
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  housings?: Maybe<Array<AugmentedHousing>>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleHousingAcquisition?: Maybe<Scalars['String']['output']>;
};

export class AugmentedHousingAcquisitionInput {
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  housings?: InputMaybe<Array<AugmentedHousingInput>>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleHousingAcquisition?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedHousingInput {
  additionalCosts?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  cancellationOfContractSignDate?: InputMaybe<Scalars['UTCDate']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coldRent?: InputMaybe<Scalars['Float']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<SetInfoInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  keyHandoverDateTime?: InputMaybe<DateWithTimeInput>;
  movingInDate?: InputMaybe<Scalars['UTCDate']['input']>;
  movingOutDate?: InputMaybe<Scalars['UTCDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOfContactPerson?: InputMaybe<Scalars['String']['input']>;
  operatingCosts?: InputMaybe<Scalars['Float']['input']>;
  phoneOfContactPerson?: InputMaybe<Scalars['String']['input']>;
  readinessForOccupancyDate?: InputMaybe<Scalars['UTCDate']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedLaborMarketAdmissionCandidateDataDe {
  __typename?: 'AugmentedLaborMarketAdmissionCandidateDataDE';
  employmentApproval?: Maybe<SetInfo>;
  employmentApprovalAuthority?: Maybe<Scalars['String']['output']>;
  employmentApprovalRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  employmentApprovalRequested?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoleLaborMarket?: Maybe<Scalars['String']['output']>;
};

export class AugmentedLaborMarketAdmissionCandidateDataDeInput {
  employmentApproval?: InputMaybe<SetInfoInput>;
  employmentApprovalAuthority?: InputMaybe<Scalars['String']['input']>;
  employmentApprovalRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  employmentApprovalRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoleLaborMarket?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedMigrationCandidateDataAt {
  __typename?: 'AugmentedMigrationCandidateDataAT';
  employmentRelationship?: Maybe<AugmentedEmploymentRelationship>;
  healthProfessionsRegister?: Maybe<HealthProfessionsRegisterCandidateDataAt>;
  qualificationMeasure?: Maybe<QualificationMeasureCandidateDataAt>;
  recognitionPath?: Maybe<AugmentedRecognitionPathEntryAt>;
  residence?: Maybe<ResidenceCandidateDataAt>;
  visa?: Maybe<VisaCandidateDataAt>;
  vocationalSchool?: Maybe<AugmentedVocationalSchoolCandidateDataAt>;
};

export class AugmentedMigrationCandidateDataAtInput {
  employmentRelationship?: InputMaybe<AugmentedEmploymentRelationshipInput>;
  healthProfessionsRegister?: InputMaybe<HealthProfessionsRegisterCandidateDataAtInput>;
  qualificationMeasure?: InputMaybe<QualificationMeasureCandidateDataAtInput>;
  recognitionPath?: InputMaybe<AugmentedRecognitionPathEntryAtInput>;
  residence?: InputMaybe<ResidenceCandidateDataAtInput>;
  visa?: InputMaybe<VisaCandidateDataAtInput>;
  vocationalSchool?: InputMaybe<AugmentedVocationalSchoolCandidateDataAtInput>;
};

export class AugmentedMigrationCandidateDataContainer {
  __typename?: 'AugmentedMigrationCandidateDataContainer';
  at?: Maybe<AugmentedMigrationCandidateDataAt>;
  de?: Maybe<AugmentedMigrationCandidateDataDe>;
  housingAcquisition?: Maybe<AugmentedHousingAcquisition>;
};

export class AugmentedMigrationCandidateDataContainerInput {
  at?: InputMaybe<AugmentedMigrationCandidateDataAtInput>;
  de?: InputMaybe<AugmentedMigrationCandidateDataDeInput>;
  housingAcquisition?: InputMaybe<AugmentedHousingAcquisitionInput>;
};

export class AugmentedMigrationCandidateDataDe {
  __typename?: 'AugmentedMigrationCandidateDataDE';
  employmentRelationship?: Maybe<AugmentedEmploymentRelationship>;
  laborMarketAdmission?: Maybe<AugmentedLaborMarketAdmissionCandidateDataDe>;
  qualificationEvaluation?: Maybe<AugmentedQualificationEvaluationDataDe>;
  qualificationMeasure?: Maybe<AugmentedQualificationMeasureCandidateDataDe>;
  recognitionPath?: Maybe<AugmentedRecognitionPathCandidateDataDe>;
  residence?: Maybe<AugmentedResidenceCandidateDataDe>;
  visa?: Maybe<AugmentedVisaCandidateDataDe>;
  vocationalSchool?: Maybe<AugmentedVocationalSchoolCandidateDataDe>;
};

export class AugmentedMigrationCandidateDataDeInput {
  employmentRelationship?: InputMaybe<AugmentedEmploymentRelationshipInput>;
  laborMarketAdmission?: InputMaybe<AugmentedLaborMarketAdmissionCandidateDataDeInput>;
  qualificationEvaluation?: InputMaybe<AugmentedQualificationEvaluationDataDeInput>;
  qualificationMeasure?: InputMaybe<AugmentedQualificationMeasureCandidateDataDeInput>;
  recognitionPath?: InputMaybe<AugmentedRecognitionPathCandidateDataDeInput>;
  residence?: InputMaybe<AugmentedResidenceCandidateDataDeInput>;
  visa?: InputMaybe<AugmentedVisaCandidateDataDeInput>;
  vocationalSchool?: InputMaybe<AugmentedVocationalSchoolCandidateDataDeInput>;
};

export class AugmentedQualificationEvaluationDataDe {
  __typename?: 'AugmentedQualificationEvaluationDataDE';
  noQualificationEvaluation?: Maybe<Scalars['Boolean']['output']>;
  qualificationEvaluationFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationRepresentativeId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluations?: Maybe<Array<AugmentedQualificationEvaluationsDe>>;
  responsibleQualificationEvaluationOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleQualificationEvaluation?: Maybe<Scalars['String']['output']>;
  responsibleRoleQualificationEvaluationPayment?: Maybe<Scalars['String']['output']>;
};

export class AugmentedQualificationEvaluationDataDeInput {
  noQualificationEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationEvaluationFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluations?: InputMaybe<Array<AugmentedQualificationEvaluationsDeInput>>;
  responsibleQualificationEvaluationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleQualificationEvaluation?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleQualificationEvaluationPayment?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedQualificationEvaluationsDe {
  __typename?: 'AugmentedQualificationEvaluationsDE';
  evaluatedQualification?: Maybe<Scalars['String']['output']>;
  evaluationByAnabinDB?: Maybe<SetInfo>;
  evaluationByCentralDepartment?: Maybe<SetInfo>;
  evaluationByDAB?: Maybe<SetInfo>;
  evaluationByFederalStateAuthority?: Maybe<SetInfo>;
  evaluationByGeneralRuling?: Maybe<SetInfo>;
  evaluationNoticeKind?: Maybe<Scalars['String']['output']>;
  evaluationRejection?: Maybe<SetInfo>;
  evaluationRequest?: Maybe<SetInfo>;
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  responsibleAuthorityForQualification?: Maybe<Scalars['String']['output']>;
  responsibleAuthorityForQualificationInOrigin?: Maybe<Scalars['String']['output']>;
};

export class AugmentedQualificationEvaluationsDeInput {
  evaluatedQualification?: InputMaybe<Scalars['String']['input']>;
  evaluationByAnabinDB?: InputMaybe<SetInfoInput>;
  evaluationByCentralDepartment?: InputMaybe<SetInfoInput>;
  evaluationByDAB?: InputMaybe<SetInfoInput>;
  evaluationByFederalStateAuthority?: InputMaybe<SetInfoInput>;
  evaluationByGeneralRuling?: InputMaybe<SetInfoInput>;
  evaluationNoticeKind?: InputMaybe<Scalars['String']['input']>;
  evaluationRejection?: InputMaybe<SetInfoInput>;
  evaluationRequest?: InputMaybe<SetInfoInput>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  responsibleAuthorityForQualification?: InputMaybe<Scalars['String']['input']>;
  responsibleAuthorityForQualificationInOrigin?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedQualificationMeasureCandidateDataDe {
  __typename?: 'AugmentedQualificationMeasureCandidateDataDE';
  careSituations?: Maybe<Scalars['Float']['output']>;
  courseNumber?: Maybe<Scalars['String']['output']>;
  educationVoucher?: Maybe<SetInfo>;
  educationVoucherFileNumber?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  educationVoucherFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  educationVoucherRepresentativeId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  educationVoucherRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  educationVoucherRequested?: Maybe<Scalars['Boolean']['output']>;
  endOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  noDetailedEquivalence?: Maybe<Scalars['Boolean']['output']>;
  practiceExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  practiceHours?: Maybe<Scalars['Float']['output']>;
  practiceInstitution?: Maybe<Scalars['String']['output']>;
  qualificationExams?: Maybe<Array<QualificationExam>>;
  qualificationIsSend?: Maybe<Scalars['Boolean']['output']>;
  qualificationIsSendDate?: Maybe<Scalars['UTCDate']['output']>;
  qualificationMeasure?: Maybe<Scalars['String']['output']>;
  qualificationMeasureFileNumber?: Maybe<Scalars['String']['output']>;
  qualificationModules?: Maybe<Array<QualificationModule>>;
  qualificationParticipation?: Maybe<SetInfo>;
  qualificationPlan?: Maybe<SetInfo>;
  qualificationPlanRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  qualificationPlanRequested?: Maybe<Scalars['Boolean']['output']>;
  qualificationType?: Maybe<Scalars['String']['output']>;
  responsibleEducationVoucherOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleEducationVoucher?: Maybe<Scalars['String']['output']>;
  responsibleRoleQualification?: Maybe<Scalars['String']['output']>;
  startOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  theoryExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  theoryHours?: Maybe<Scalars['Float']['output']>;
  theoryInstitution?: Maybe<Scalars['String']['output']>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  totalMonths?: Maybe<Scalars['Float']['output']>;
};

export class AugmentedQualificationMeasureCandidateDataDeInput {
  careSituations?: InputMaybe<Scalars['Float']['input']>;
  courseNumber?: InputMaybe<Scalars['String']['input']>;
  educationVoucher?: InputMaybe<SetInfoInput>;
  educationVoucherFileNumber?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  educationVoucherRequested?: InputMaybe<Scalars['Boolean']['input']>;
  endOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  noDetailedEquivalence?: InputMaybe<Scalars['Boolean']['input']>;
  practiceExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  practiceHours?: InputMaybe<Scalars['Float']['input']>;
  practiceInstitution?: InputMaybe<Scalars['String']['input']>;
  qualificationExams?: InputMaybe<Array<QualificationExamInput>>;
  qualificationIsSend?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationIsSendDate?: InputMaybe<Scalars['UTCDate']['input']>;
  qualificationMeasure?: InputMaybe<Scalars['String']['input']>;
  qualificationMeasureFileNumber?: InputMaybe<Scalars['String']['input']>;
  qualificationModules?: InputMaybe<Array<QualificationModuleInput>>;
  qualificationParticipation?: InputMaybe<SetInfoInput>;
  qualificationPlan?: InputMaybe<SetInfoInput>;
  qualificationPlanRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  qualificationPlanRequested?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationType?: InputMaybe<Scalars['String']['input']>;
  responsibleEducationVoucherOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleEducationVoucher?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleQualification?: InputMaybe<Scalars['String']['input']>;
  startOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  theoryExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  theoryHours?: InputMaybe<Scalars['Float']['input']>;
  theoryInstitution?: InputMaybe<Scalars['String']['input']>;
  totalHours?: InputMaybe<Scalars['Float']['input']>;
  totalMonths?: InputMaybe<Scalars['Float']['input']>;
};

export class AugmentedRecognitionPathCandidateDataDe {
  __typename?: 'AugmentedRecognitionPathCandidateDataDE';
  alternative?: Maybe<AugmentedRecognitionPathEntryDe>;
  current?: Maybe<AugmentedRecognitionPathEntryDe>;
};

export class AugmentedRecognitionPathCandidateDataDeInput {
  alternative?: InputMaybe<AugmentedRecognitionPathEntryDeInput>;
  current?: InputMaybe<AugmentedRecognitionPathEntryDeInput>;
};

export class AugmentedRecognitionPathEntryAt {
  __typename?: 'AugmentedRecognitionPathEntryAT';
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  legalBasis?: Maybe<Scalars['String']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  psaFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  recognitionApplication?: Maybe<SetInfo>;
  recognitionAuthority?: Maybe<Scalars['String']['output']>;
  recognitionReceiveDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionReceived?: Maybe<Scalars['Boolean']['output']>;
  recognitionStartDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionStarted?: Maybe<Scalars['Boolean']['output']>;
  responsibleRecognitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleRecognition?: Maybe<Scalars['String']['output']>;
  targetRecognition?: Maybe<Scalars['String']['output']>;
};

export class AugmentedRecognitionPathEntryAtInput {
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  legalBasis?: InputMaybe<Scalars['String']['input']>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  psaFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  recognitionApplication?: InputMaybe<SetInfoInput>;
  recognitionAuthority?: InputMaybe<Scalars['String']['input']>;
  recognitionReceiveDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionStarted?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRecognitionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleRecognition?: InputMaybe<Scalars['String']['input']>;
  targetRecognition?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedRecognitionPathEntryDe {
  __typename?: 'AugmentedRecognitionPathEntryDE';
  acceleratedProcedureDigitalRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedureDigitalRequested?: Maybe<Scalars['Boolean']['output']>;
  acceleratedProcedurePaperRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedurePaperRequested?: Maybe<Scalars['Boolean']['output']>;
  applicationReceipt?: Maybe<SetInfo>;
  careAssistantCertificate?: Maybe<SetInfo>;
  certificate?: Maybe<SetInfo>;
  certificateRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  certificateRequested?: Maybe<Scalars['Boolean']['output']>;
  chamberOfCrafts?: Maybe<Scalars['String']['output']>;
  deficitNote?: Maybe<SetInfo>;
  districtGovernment?: Maybe<Scalars['String']['output']>;
  equivalenceTest?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  fileNumberAcceleratedProcedure?: Maybe<Scalars['String']['output']>;
  fullEquivalenceReceived?: Maybe<Scalars['Boolean']['output']>;
  immigrationApplication?: Maybe<SetInfo>;
  immigrationAuthority?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  partialEquivalenceFollowUp?: Maybe<SetInfo>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  psaFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  recognition?: Maybe<SetInfo>;
  recognitionApplication?: Maybe<SetInfo>;
  recognitionAuthority?: Maybe<Scalars['String']['output']>;
  recognitionCenter?: Maybe<Scalars['String']['output']>;
  recognitionNoticeKind?: Maybe<Scalars['String']['output']>;
  recognitionPartnership?: Maybe<Scalars['Boolean']['output']>;
  recognitionPaymentRole?: Maybe<Scalars['String']['output']>;
  recognitionPaymentRoleAccelerated?: Maybe<Scalars['String']['output']>;
  recognitionRejection?: Maybe<SetInfo>;
  recognitionStartDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionStarted?: Maybe<Scalars['Boolean']['output']>;
  recognitionType?: Maybe<Scalars['String']['output']>;
  responsibleRecognitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleRecognition?: Maybe<Scalars['String']['output']>;
};

export class AugmentedRecognitionPathEntryDeInput {
  acceleratedProcedureDigitalRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  acceleratedProcedureDigitalRequested?: InputMaybe<Scalars['Boolean']['input']>;
  acceleratedProcedurePaperRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  acceleratedProcedurePaperRequested?: InputMaybe<Scalars['Boolean']['input']>;
  applicationReceipt?: InputMaybe<SetInfoInput>;
  careAssistantCertificate?: InputMaybe<SetInfoInput>;
  certificate?: InputMaybe<SetInfoInput>;
  certificateRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  certificateRequested?: InputMaybe<Scalars['Boolean']['input']>;
  chamberOfCrafts?: InputMaybe<Scalars['String']['input']>;
  deficitNote?: InputMaybe<SetInfoInput>;
  districtGovernment?: InputMaybe<Scalars['String']['input']>;
  equivalenceTest?: InputMaybe<Scalars['String']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  fileNumberAcceleratedProcedure?: InputMaybe<Scalars['String']['input']>;
  fullEquivalenceReceived?: InputMaybe<Scalars['Boolean']['input']>;
  immigrationApplication?: InputMaybe<SetInfoInput>;
  immigrationAuthority?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  partialEquivalenceFollowUp?: InputMaybe<SetInfoInput>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  psaFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  recognition?: InputMaybe<SetInfoInput>;
  recognitionApplication?: InputMaybe<SetInfoInput>;
  recognitionAuthority?: InputMaybe<Scalars['String']['input']>;
  recognitionCenter?: InputMaybe<Scalars['String']['input']>;
  recognitionNoticeKind?: InputMaybe<Scalars['String']['input']>;
  recognitionPartnership?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionPaymentRole?: InputMaybe<Scalars['String']['input']>;
  recognitionPaymentRoleAccelerated?: InputMaybe<Scalars['String']['input']>;
  recognitionRejection?: InputMaybe<SetInfoInput>;
  recognitionStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionStarted?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionType?: InputMaybe<Scalars['String']['input']>;
  responsibleRecognitionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleRecognition?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedResidenceCandidateDataDe {
  __typename?: 'AugmentedResidenceCandidateDataDE';
  appointmentHealthDepartmentDate?: Maybe<DateWithTime>;
  appointmentHealthDepartmentKept?: Maybe<Scalars['Boolean']['output']>;
  bankAppointmentDate?: Maybe<DateWithTime>;
  certificateOfConduct?: Maybe<Array<Scalars['String']['output']>>;
  certificateOfConductRequested?: Maybe<Scalars['Boolean']['output']>;
  companyDoctorAppointmentDate?: Maybe<DateWithTime>;
  medicalExaminationAppointmentDate?: Maybe<DateWithTime>;
  personalOnboardingDateTime?: Maybe<DateWithTime>;
  policeRecordAppointmentDate?: Maybe<DateWithTime>;
  recognitionMedicalCertificate?: Maybe<Scalars['Boolean']['output']>;
  registrationAuthority?: Maybe<Scalars['String']['output']>;
  registrationAuthorityAppointmentNumber?: Maybe<Scalars['String']['output']>;
  registrationOfficeDate?: Maybe<DateWithTime>;
  residenceBank?: Maybe<Scalars['String']['output']>;
  residenceBankContactPartner?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  residenceFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  residencePermits?: Maybe<Array<AugmentedResidencePermit>>;
  residenceRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeId?: Maybe<Scalars['ID']['output']>;
  residenceRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleResidenceOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleResidence?: Maybe<Scalars['String']['output']>;
  suitabilityForWork?: Maybe<Scalars['String']['output']>;
  workStartDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class AugmentedResidenceCandidateDataDeInput {
  appointmentHealthDepartmentDate?: InputMaybe<DateWithTimeInput>;
  appointmentHealthDepartmentKept?: InputMaybe<Scalars['Boolean']['input']>;
  bankAppointmentDate?: InputMaybe<DateWithTimeInput>;
  certificateOfConduct?: InputMaybe<Array<Scalars['String']['input']>>;
  certificateOfConductRequested?: InputMaybe<Scalars['Boolean']['input']>;
  companyDoctorAppointmentDate?: InputMaybe<DateWithTimeInput>;
  medicalExaminationAppointmentDate?: InputMaybe<DateWithTimeInput>;
  personalOnboardingDateTime?: InputMaybe<DateWithTimeInput>;
  policeRecordAppointmentDate?: InputMaybe<DateWithTimeInput>;
  recognitionMedicalCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
  registrationAuthorityAppointmentNumber?: InputMaybe<Scalars['String']['input']>;
  registrationOfficeDate?: InputMaybe<DateWithTimeInput>;
  residenceBank?: InputMaybe<Scalars['String']['input']>;
  residenceBankContactPartner?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  residenceFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  residencePermits?: InputMaybe<Array<AugmentedResidencePermitInput>>;
  residenceRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  residenceRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleResidenceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleResidence?: InputMaybe<Scalars['String']['input']>;
  suitabilityForWork?: InputMaybe<Scalars['String']['input']>;
  workStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class AugmentedResidencePermit {
  __typename?: 'AugmentedResidencePermit';
  fictionalCertificate?: Maybe<SetInfo>;
  fictionalCertificateAvailable?: Maybe<Scalars['Boolean']['output']>;
  fictionalCertificateDoesNotAuthorisesWorking?: Maybe<Scalars['Boolean']['output']>;
  fictionalCertificateNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  immigrationAuthority?: Maybe<Scalars['String']['output']>;
  immigrationAuthorityAppointmentDate?: Maybe<DateWithTime>;
  notes?: Maybe<QuillContent>;
  residencePermit?: Maybe<Scalars['String']['output']>;
  residencePermitDocument?: Maybe<SetInfo>;
  residenceRequestedByPostDate?: Maybe<Scalars['UTCDate']['output']>;
  residenceRequestedElectronicallyDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class AugmentedResidencePermitInput {
  fictionalCertificate?: InputMaybe<SetInfoInput>;
  fictionalCertificateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fictionalCertificateDoesNotAuthorisesWorking?: InputMaybe<Scalars['Boolean']['input']>;
  fictionalCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  immigrationAuthority?: InputMaybe<Scalars['String']['input']>;
  immigrationAuthorityAppointmentDate?: InputMaybe<DateWithTimeInput>;
  notes?: InputMaybe<QuillContentInput>;
  residencePermit?: InputMaybe<Scalars['String']['input']>;
  residencePermitDocument?: InputMaybe<SetInfoInput>;
  residenceRequestedByPostDate?: InputMaybe<Scalars['UTCDate']['input']>;
  residenceRequestedElectronicallyDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class AugmentedVisaCandidateDataDe {
  __typename?: 'AugmentedVisaCandidateDataDE';
  arrivalAirport?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<DateWithTime>;
  arrivalTrainStation?: Maybe<Scalars['String']['output']>;
  contactAtArrivalLocation?: Maybe<Scalars['String']['output']>;
  departureAirport?: Maybe<Scalars['String']['output']>;
  departureTrainStation?: Maybe<Scalars['String']['output']>;
  diplomaticMissionOfGermanyInCountry?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  flightArrivalDate?: Maybe<DateWithTime>;
  flightDate?: Maybe<DateWithTime>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  pickUpVehicle?: Maybe<Scalars['String']['output']>;
  residencePermit?: Maybe<Scalars['String']['output']>;
  responsibleForTransfer?: Maybe<Scalars['String']['output']>;
  responsibleRoleVisa?: Maybe<Scalars['String']['output']>;
  trainArrivalDate?: Maybe<DateWithTime>;
  trainDepartureDate?: Maybe<DateWithTime>;
  trainNumber?: Maybe<Scalars['String']['output']>;
  visaDocument?: Maybe<SetInfo>;
  visaEnquired?: Maybe<Scalars['Boolean']['output']>;
  visaEnquiredDate?: Maybe<Scalars['UTCDate']['output']>;
  visaRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  visaRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  visaRequested?: Maybe<Scalars['Boolean']['output']>;
};

export class AugmentedVisaCandidateDataDeInput {
  arrivalAirport?: InputMaybe<Scalars['String']['input']>;
  arrivalDate?: InputMaybe<DateWithTimeInput>;
  arrivalTrainStation?: InputMaybe<Scalars['String']['input']>;
  contactAtArrivalLocation?: InputMaybe<Scalars['String']['input']>;
  departureAirport?: InputMaybe<Scalars['String']['input']>;
  departureTrainStation?: InputMaybe<Scalars['String']['input']>;
  diplomaticMissionOfGermanyInCountry?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flightArrivalDate?: InputMaybe<DateWithTimeInput>;
  flightDate?: InputMaybe<DateWithTimeInput>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  pickUpVehicle?: InputMaybe<Scalars['String']['input']>;
  residencePermit?: InputMaybe<Scalars['String']['input']>;
  responsibleForTransfer?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleVisa?: InputMaybe<Scalars['String']['input']>;
  trainArrivalDate?: InputMaybe<DateWithTimeInput>;
  trainDepartureDate?: InputMaybe<DateWithTimeInput>;
  trainNumber?: InputMaybe<Scalars['String']['input']>;
  visaDocument?: InputMaybe<SetInfoInput>;
  visaEnquired?: InputMaybe<Scalars['Boolean']['input']>;
  visaEnquiredDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  visaRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export class AugmentedVocationalSchoolCandidateDataAt {
  __typename?: 'AugmentedVocationalSchoolCandidateDataAT';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentTrainingYear?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  expectedEndDate?: Maybe<Scalars['UTCDate']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  medicalCheckAttended?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckAttendedDate?: Maybe<Scalars['UTCDate']['output']>;
  medicalCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckPassedDate?: Maybe<Scalars['UTCDate']['output']>;
  schoolCourse?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  trainingContract?: Maybe<SetInfo>;
  trainingTimeInPartTime?: Maybe<Scalars['Boolean']['output']>;
  trainingTimeInYearsTotal?: Maybe<Scalars['String']['output']>;
  trainingTimeShortened?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class AugmentedVocationalSchoolCandidateDataAtInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentTrainingYear?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['UTCDate']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  medicalCheckAttended?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckAttendedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  medicalCheckPassed?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckPassedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  schoolCourse?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  trainingContract?: InputMaybe<SetInfoInput>;
  trainingTimeInPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  trainingTimeInYearsTotal?: InputMaybe<Scalars['String']['input']>;
  trainingTimeShortened?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class AugmentedVocationalSchoolCandidateDataDe {
  __typename?: 'AugmentedVocationalSchoolCandidateDataDE';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentTrainingYear?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  expectedEndDate?: Maybe<Scalars['UTCDate']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  medicalCheckAttended?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckAttendedDate?: Maybe<Scalars['UTCDate']['output']>;
  medicalCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckPassedDate?: Maybe<Scalars['UTCDate']['output']>;
  schoolCourse?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  trainingContract?: Maybe<SetInfo>;
  trainingTimeInPartTime?: Maybe<Scalars['Boolean']['output']>;
  trainingTimeInYearsTotal?: Maybe<Scalars['String']['output']>;
  trainingTimeShortened?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class AugmentedVocationalSchoolCandidateDataDeInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentTrainingYear?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['UTCDate']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  medicalCheckAttended?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckAttendedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  medicalCheckPassed?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckPassedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  schoolCourse?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  trainingContract?: InputMaybe<SetInfoInput>;
  trainingTimeInPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  trainingTimeInYearsTotal?: InputMaybe<Scalars['String']['input']>;
  trainingTimeShortened?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class AutoCvResponse {
  __typename?: 'AutoCVResponse';
  hideCandidateName?: Maybe<Scalars['Boolean']['output']>;
  state: AutoCvResponseStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export class AutoCollectionSettings {
  __typename?: 'AutoCollectionSettings';
  filterId: Scalars['String']['output'];
  templateMapping?: Maybe<AutoCollectionTemplateMapping>;
};

export class AutoCollectionSettingsForUi {
  __typename?: 'AutoCollectionSettingsForUI';
  filterId: Scalars['String']['output'];
  templateMapping?: Maybe<AutoCollectionTemplateMappingForUi>;
};

export class AutoCollectionSettingsInput {
  filterId: Scalars['String']['input'];
  templateMapping?: InputMaybe<AutoCollectionTemplateMappingInput>;
};

export class AutoCollectionTemplateMapping {
  __typename?: 'AutoCollectionTemplateMapping';
  templateId: Scalars['ID']['output'];
  templateLatestChangedAtWithChildren?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  variableMappings?: Maybe<Array<VariableMapping>>;
};

export class AutoCollectionTemplateMappingForUi {
  __typename?: 'AutoCollectionTemplateMappingForUI';
  templateId: Scalars['ID']['output'];
  templateLatestChangedAtWithChildren?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  variableMappings?: Maybe<Array<VariableMappingForUi>>;
};

export class AutoCollectionTemplateMappingInput {
  templateId: Scalars['ID']['input'];
  templateLatestChangedAtWithChildren?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  variableMappings?: InputMaybe<Array<VariableMappingInput>>;
};

export enum AutoCvResponseStatus {
  Available = 'Available',
  Processing = 'Processing',
  Unavailable = 'Unavailable'
}

export class AutoGeneratedCvUrlInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  selectedSharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  templateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class AutoStartPossibleActivationInfo {
  __typename?: 'AutoStartPossibleActivationInfo';
  isAutoStartPossible: Scalars['Boolean']['output'];
  localizedInfo: Scalars['String']['output'];
};

export class AutoStateChange {
  __typename?: 'AutoStateChange';
  condition: AutoStateChangeCondition;
  mutations: Array<AutoStateChangeMutation>;
};

export class AutoStateChangeCondition {
  __typename?: 'AutoStateChangeCondition';
  daysInstanceStateUnchanged: Scalars['Float']['output'];
  instanceState: InstanceStateEnum;
};

export class AutoStateChangeConditionInput {
  daysInstanceStateUnchanged: Scalars['Float']['input'];
  instanceState: InstanceStateEnum;
};

export class AutoStateChangeConditionModel {
  __typename?: 'AutoStateChangeConditionModel';
  daysInstanceStateUnchanged: Scalars['Float']['output'];
  instanceState: InstanceStateEnum;
};

export class AutoStateChangeConditionModelInput {
  daysInstanceStateUnchanged: Scalars['Float']['input'];
  instanceState: InstanceStateEnum;
};

export class AutoStateChangeInput {
  condition: AutoStateChangeConditionInput;
  mutations: Array<AutoStateChangeMutationInput>;
};

export class AutoStateChangeModel {
  __typename?: 'AutoStateChangeModel';
  condition: AutoStateChangeConditionModel;
  mutations: Array<AutoStateChangeMutationModel>;
};

export class AutoStateChangeModelInput {
  condition: AutoStateChangeConditionModelInput;
  mutations: Array<AutoStateChangeMutationModelInput>;
};

export class AutoStateChangeMutation {
  __typename?: 'AutoStateChangeMutation';
  instanceState?: Maybe<InstanceStateEnum>;
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class AutoStateChangeMutationInput {
  instanceState?: InputMaybe<InstanceStateEnum>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class AutoStateChangeMutationModel {
  __typename?: 'AutoStateChangeMutationModel';
  instanceState?: Maybe<InstanceStateEnum>;
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class AutoStateChangeMutationModelInput {
  instanceState?: InputMaybe<InstanceStateEnum>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class AvailableAutogenTemplateListInput {
  organizationId: Scalars['ID']['input'];
};

export class AvailableDocumentTemplate {
  __typename?: 'AvailableDocumentTemplate';
  name: Scalars['String']['output'];
  type: DocumentTemplateType;
};

export class AvailableDocumentTemplateGetInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class AvailableDocumentTemplateGroup {
  __typename?: 'AvailableDocumentTemplateGroup';
  immigrationCountry?: Maybe<Scalars['String']['output']>;
  templates: Array<AvailableDocumentTemplate>;
};

export class AvailableDocumentTemplateInput {
  name: Scalars['String']['input'];
  type: DocumentTemplateType;
};

export class AvailableKpiMonths {
  __typename?: 'AvailableKpiMonths';
  months: Array<KpiMonth>;
};

export class AvailableProcessModelGetListInput {
  organizationId: Scalars['String']['input'];
  selectableModelsOnly: Scalars['Boolean']['input'];
};

export class AvailableProcessModelVersionsGetInput {
  language: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId: Scalars['ID']['input'];
};

export class AvailableReportsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class AvatarUploadDefinition {
  __typename?: 'AvatarUploadDefinition';
  id: Scalars['String']['output'];
  pictureType: Scalars['String']['output'];
};

export class AvatarUploadDefinitionInput {
  id: Scalars['String']['input'];
  pictureType: Scalars['String']['input'];
};

export class BaseProcessDefinition {
  __typename?: 'BaseProcessDefinition';
  baseProcessType: BaseProcessTypeEnum;
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
};

export class BaseProcessDefinitionInput {
  baseProcessType: BaseProcessTypeEnum;
  id: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
};

export enum BaseProcessTypeEnum {
  CreateProcessOperation = 'CreateProcessOperation',
  ExistingProcess = 'ExistingProcess'
}

export class BatchApplyItemOutcomeGql {
  __typename?: 'BatchApplyItemOutcomeGql';
  commandId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  subagentInvocationId: Scalars['ID']['output'];
  targetSection?: Maybe<Scalars['String']['output']>;
  targetTaskId?: Maybe<Scalars['ID']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
};

export class BatchApplyOutcome {
  __typename?: 'BatchApplyOutcome';
  items: Array<BatchApplyItemOutcomeGql>;
};

export class BatchApplySubagentResultInput {
  batchId: Scalars['ID']['input'];
  items: Array<ApplySubagentResultInput>;
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export class BeforeRecognition {
  __typename?: 'BeforeRecognition';
  contractExtension?: Maybe<Scalars['Boolean']['output']>;
  contractTemplate?: Maybe<RecognitionPathContractTemplate>;
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  contractTemplateName?: Maybe<Scalars['String']['output']>;
  contractTemplateOrganizationId?: Maybe<Scalars['ID']['output']>;
  employerHistory?: Maybe<Array<EmployerHistoryEntry>>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employerRegion?: Maybe<Scalars['String']['output']>;
  employerZipcode?: Maybe<Scalars['String']['output']>;
  employmentRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  endOfProbationDate?: Maybe<Scalars['UTCDate']['output']>;
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  isTemporaryEmployee?: Maybe<Scalars['Boolean']['output']>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  typeOfWorkLocation?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workLocationOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class BeforeRecognitionInput {
  contractExtension?: InputMaybe<Scalars['Boolean']['input']>;
  contractTemplate?: InputMaybe<RecognitionPathContractTemplateInput>;
  contractTemplateId?: InputMaybe<Scalars['ID']['input']>;
  contractTemplateName?: InputMaybe<Scalars['String']['input']>;
  contractTemplateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  employerHistory?: InputMaybe<Array<EmployerHistoryEntryInput>>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerRegion?: InputMaybe<Scalars['String']['input']>;
  employerZipcode?: InputMaybe<Scalars['String']['input']>;
  employmentRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  endOfProbationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  isTemporaryEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  typeOfWorkLocation?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workLocationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BenefitTimeInterval {
  Monthly = 'Monthly',
  OneTimeOnly = 'OneTimeOnly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly'
}

export class BillableUserBreakdown {
  __typename?: 'BillableUserBreakdown';
  entries: Array<BillableUserBreakdownEntry>;
};

export class BillableUserBreakdownEntry {
  __typename?: 'BillableUserBreakdownEntry';
  countedAtOrganizationId: Scalars['String']['output'];
  countedAtOrganizationName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<SupportedBillingCurrency>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  isIncluded: Scalars['Boolean']['output'];
  isManageable: Scalars['Boolean']['output'];
  isPartnerOrganization: Scalars['Boolean']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export class BillableUserCount {
  __typename?: 'BillableUserCount';
  billableUsers: Scalars['Float']['output'];
  billingOrganizationId?: Maybe<Scalars['String']['output']>;
  includedUsers: Scalars['Float']['output'];
  isPartnerOrganization: Scalars['Boolean']['output'];
  ownerOrganizationName?: Maybe<Scalars['String']['output']>;
  totalActiveUsers: Scalars['Float']['output'];
  unlimitedIncludedUsers: Scalars['Boolean']['output'];
};

export class BillingAccount {
  __typename?: 'BillingAccount';
  _etag?: Maybe<Scalars['String']['output']>;
  accrualTreatment?: Maybe<AccrualTreatment>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountType?: Maybe<AmountType>;
  billingEvent?: Maybe<BillingEventType>;
  bookedBy?: Maybe<Scalars['String']['output']>;
  bookingDate: Scalars['AnkaadiaDateTime']['output'];
  bookingNumber: Scalars['String']['output'];
  bookingText: Scalars['String']['output'];
  bookingType: BookingType;
  candidateBookingDetail?: Maybe<CandidateBookingDetail>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateExists?: Maybe<Scalars['Boolean']['output']>;
  candidateId?: Maybe<CandidateId>;
  challengeBooking?: Maybe<ChallengeBooking>;
  commissionId?: Maybe<Scalars['String']['output']>;
  contingentId?: Maybe<Scalars['String']['output']>;
  contingentNumber?: Maybe<Scalars['String']['output']>;
  creditNoteId?: Maybe<Scalars['String']['output']>;
  currency: SupportedBillingCurrency;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  hasMultipleInvoiceRecipients?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  isCandidateAccessible?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  recurringFeeId?: Maybe<Scalars['String']['output']>;
  referencedBookingIds?: Maybe<Array<Scalars['ID']['output']>>;
  referencedBookings?: Maybe<Array<Scalars['String']['output']>>;
  revenueCategory?: Maybe<RevenueCategory>;
  serviceEndDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  serviceStartDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  source: BookingSource;
  targetInvoiceType?: Maybe<InvoiceType>;
  userId?: Maybe<Scalars['String']['output']>;
  valueDate: Scalars['AnkaadiaDateTime']['output'];
};

export class BillingAccountFilter {
  bookingTypes?: InputMaybe<Array<BookingType>>;
  valueEndDate?: InputMaybe<Scalars['UTCDate']['input']>;
  valueStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class BillingAccountGetFilteredInput {
  filter?: InputMaybe<BillingAccountFilter>;
  forAllOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class BillingAccountGetMultipleInput {
  bookingIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class BillingAccountInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  accrualTreatment?: InputMaybe<AccrualTreatment>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<AmountType>;
  billingEvent?: InputMaybe<BillingEventType>;
  bookedBy?: InputMaybe<Scalars['String']['input']>;
  bookingDate: Scalars['AnkaadiaDateTime']['input'];
  bookingNumber: Scalars['String']['input'];
  bookingText: Scalars['String']['input'];
  bookingType: BookingType;
  candidateBookingDetail?: InputMaybe<CandidateBookingDetailInput>;
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateExists?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId?: InputMaybe<CandidateIdInput>;
  challengeBooking?: InputMaybe<ChallengeBookingInput>;
  commissionId?: InputMaybe<Scalars['String']['input']>;
  contingentId?: InputMaybe<Scalars['String']['input']>;
  contingentNumber?: InputMaybe<Scalars['String']['input']>;
  creditNoteId?: InputMaybe<Scalars['String']['input']>;
  currency: SupportedBillingCurrency;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  hasMultipleInvoiceRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  isCandidateAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentId?: InputMaybe<Scalars['String']['input']>;
  recurringFeeId?: InputMaybe<Scalars['String']['input']>;
  referencedBookingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  referencedBookings?: InputMaybe<Array<Scalars['String']['input']>>;
  revenueCategory?: InputMaybe<RevenueCategory>;
  serviceEndDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  serviceStartDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  source: BookingSource;
  targetInvoiceType?: InputMaybe<InvoiceType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  valueDate: Scalars['AnkaadiaDateTime']['input'];
};

export class BillingAddress {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export class BillingData {
  __typename?: 'BillingData';
  invoiceRecipients?: Maybe<Array<Scalars['ID']['output']>>;
  notBillable?: Maybe<Scalars['Boolean']['output']>;
};

export class BillingDataInput {
  invoiceRecipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  notBillable?: InputMaybe<Scalars['Boolean']['input']>;
};

export class BillingEventProcessingLog {
  __typename?: 'BillingEventProcessingLog';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<CandidateId>;
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  processedAt: Scalars['AnkaadiaDateTime']['output'];
  result: ProcessingResultType;
  type: BillingEventTriggerType;
};

export class BillingEventProcessingLogGetAllInput {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BillingEventTriggerType {
  CandidateAged150Days = 'CandidateAged150Days',
  CandidateAgreementSponsorshipUploaded = 'CandidateAgreementSponsorshipUploaded',
  CandidateArrivalDateChanged = 'CandidateArrivalDateChanged',
  CandidateBillingDeferredToNextMonth = 'CandidateBillingDeferredToNextMonth',
  CandidateDeclarationOfEmploymentUploaded = 'CandidateDeclarationOfEmploymentUploaded',
  CandidateEmployerChanged = 'CandidateEmployerChanged',
  CandidateEmploymentConfirmationChanged = 'CandidateEmploymentConfirmationChanged',
  CandidateEstimatedArrivalDateChanged = 'CandidateEstimatedArrivalDateChanged',
  CandidateEstimatedWorkingStartChanged = 'CandidateEstimatedWorkingStartChanged',
  CandidateFirstContractExtensionAfterUploaded = 'CandidateFirstContractExtensionAfterUploaded',
  CandidateFirstContractExtensionPreUploaded = 'CandidateFirstContractExtensionPreUploaded',
  CandidateHealthMembershipCertificateUploaded = 'CandidateHealthMembershipCertificateUploaded',
  CandidateInternContractUploaded = 'CandidateInternContractUploaded',
  CandidateMatchedTriggeredManually = 'CandidateMatchedTriggeredManually',
  CandidatePreContractUploaded = 'CandidatePreContractUploaded',
  CandidateRecognitionSponsorshipCandidateUploaded = 'CandidateRecognitionSponsorshipCandidateUploaded',
  CandidateRecognitionSponsorshipEmployerUploaded = 'CandidateRecognitionSponsorshipEmployerUploaded',
  CandidateSecondContractExtensionAfterUploaded = 'CandidateSecondContractExtensionAfterUploaded',
  CandidateSecondContractExtensionPreUploaded = 'CandidateSecondContractExtensionPreUploaded',
  CandidateStatusSetToInRecognition = 'CandidateStatusSetToInRecognition',
  CandidateStatusSetToLabourMigrationFinished = 'CandidateStatusSetToLabourMigrationFinished',
  CandidateStatusSetToMatched = 'CandidateStatusSetToMatched',
  CandidateStatusSetToTransferred = 'CandidateStatusSetToTransferred',
  CandidateTrainingCommitmentUploaded = 'CandidateTrainingCommitmentUploaded',
  CandidateTrainingContractUploaded = 'CandidateTrainingContractUploaded',
  CandidateTransferredTriggeredManually = 'CandidateTransferredTriggeredManually',
  CandidateVisaUploaded = 'CandidateVisaUploaded',
  CandidateVisumChanged = 'CandidateVisumChanged',
  CandidateWorkingContractUploaded = 'CandidateWorkingContractUploaded',
  CandidateWorkingStartChanged = 'CandidateWorkingStartChanged',
  ChatAddonFee = 'ChatAddonFee',
  CommissionCredited = 'CommissionCredited',
  ContingentOrderedAutomatically = 'ContingentOrderedAutomatically',
  ContingentOrderedManually = 'ContingentOrderedManually',
  CvParsingFee = 'CvParsingFee',
  DocuSealIdVerificationFee = 'DocuSealIdVerificationFee',
  DocuSealSigningFeeAes = 'DocuSealSigningFeeAes',
  DocuSealSigningFeeQes = 'DocuSealSigningFeeQes',
  DocuSealSigningFeeSes = 'DocuSealSigningFeeSes',
  LicenseFee = 'LicenseFee',
  RecurringFee = 'RecurringFee',
  TalentPoolWebsiteAddonFee = 'TalentPoolWebsiteAddonFee',
  UserAccountFee = 'UserAccountFee'
}

export enum BillingEventType {
  CandidateAged150Days = 'CandidateAged150Days',
  CandidateMatched = 'CandidateMatched',
  CandidateTransferred = 'CandidateTransferred',
  ChatAddonFee = 'ChatAddonFee',
  CommissionCredited = 'CommissionCredited',
  Contingent = 'Contingent',
  CvParsingFee = 'CvParsingFee',
  DocuSealIdVerificationFee = 'DocuSealIdVerificationFee',
  DocuSealSigningFeeAes = 'DocuSealSigningFeeAes',
  DocuSealSigningFeeQes = 'DocuSealSigningFeeQes',
  DocuSealSigningFeeSes = 'DocuSealSigningFeeSes',
  LicenseFee = 'LicenseFee',
  RecurringFee = 'RecurringFee',
  TalentPoolWebsiteAddonFee = 'TalentPoolWebsiteAddonFee',
  UserAdded = 'UserAdded'
}

export class BillingHistory {
  __typename?: 'BillingHistory';
  _etag?: Maybe<Scalars['String']['output']>;
  candidates: Array<BillingHistoryCandidate>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class BillingHistoryCandidate {
  __typename?: 'BillingHistoryCandidate';
  candidateDisplayId: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  details: Array<BillingHistoryDetail>;
  organizationId: Scalars['ID']['output'];
};

export class BillingHistoryCandidateInput {
  candidateDisplayId: Scalars['String']['input'];
  candidateId: Scalars['ID']['input'];
  details: Array<BillingHistoryDetailInput>;
  organizationId: Scalars['ID']['input'];
};

export class BillingHistoryDetail {
  __typename?: 'BillingHistoryDetail';
  billedAt: Scalars['AnkaadiaDateTime']['output'];
  billingEvent: Scalars['String']['output'];
};

export class BillingHistoryDetailInput {
  billedAt: Scalars['AnkaadiaDateTime']['input'];
  billingEvent: Scalars['String']['input'];
};

export class BillingHistoryGetInput {
  organizationId: Scalars['ID']['input'];
};

export class BillingHistoryInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidates: Array<BillingHistoryCandidateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class BillingHistorySetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidates: Array<BillingHistoryCandidateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class BillingOfAgedCandidates {
  __typename?: 'BillingOfAgedCandidates';
  billAfterDays: Scalars['Float']['output'];
  nonBillableStates: Array<CandidateStatus>;
  price: Scalars['Float']['output'];
};

export class BillingOfAgedCandidatesInput {
  billAfterDays: Scalars['Float']['input'];
  nonBillableStates: Array<CandidateStatus>;
  price: Scalars['Float']['input'];
};

export class BillingPeriod {
  __typename?: 'BillingPeriod';
  endDate: Scalars['UTCDate']['output'];
  isFirstPeriod: Scalars['Boolean']['output'];
  isLastPeriod: Scalars['Boolean']['output'];
  startDate: Scalars['UTCDate']['output'];
};

export class BillingPeriodInput {
  endDate: Scalars['UTCDate']['input'];
  isFirstPeriod: Scalars['Boolean']['input'];
  isLastPeriod: Scalars['Boolean']['input'];
  startDate: Scalars['UTCDate']['input'];
};

export class BillingSettings {
  __typename?: 'BillingSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  collectionMethod?: Maybe<CollectionMethod>;
  dueDays?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  taxRateId?: Maybe<Scalars['String']['output']>;
};

export class BillingSettingsGetCustomerPortalUrlInput {
  organizationId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export enum BillingTableType {
  BookingTable = 'BookingTable',
  CancellationBookingTable = 'CancellationBookingTable'
}

export class BillingYear {
  __typename?: 'BillingYear';
  endDate: Scalars['UTCDate']['output'];
  periods: Array<BillingPeriod>;
  startDate: Scalars['UTCDate']['output'];
};

export class BillingYearGetAllInput {
  organizationId: Scalars['ID']['input'];
};

export class BillingYearInput {
  endDate: Scalars['UTCDate']['input'];
  periods: Array<BillingPeriodInput>;
  startDate: Scalars['UTCDate']['input'];
};

export class BirthDayCandidate {
  __typename?: 'BirthDayCandidate';
  _etag?: Maybe<Scalars['String']['output']>;
  age: Scalars['Float']['output'];
  billingDetails?: Maybe<Array<CandidateBillingDetail>>;
  country?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  deletionDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  family?: Maybe<CandidateFamily>;
  function: Scalars['String']['output'];
  governance?: Maybe<GovernanceCandidateData>;
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  internal?: Maybe<InternalCandidateData>;
  lastLoginDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  licensedOrganizationData?: Maybe<CandidateForLicensedOrganizationData>;
  messagesReception?: Maybe<MessagesReception>;
  migration?: Maybe<MigrationCandidateDataContainer>;
  organizationId: Scalars['ID']['output'];
  os?: Maybe<Scalars['JSONObject']['output']>;
  presentation?: Maybe<PresentationCandidateData>;
  processStatus?: Maybe<ProcessStatusCandidateData>;
  profession: Scalars['String']['output'];
  status: CandidateStatus;
  systemOnboarding?: Maybe<CandidateSystemOnboarding>;
  technicalSource?: Maybe<TechnicalSourceEnum>;
  transferData?: Maybe<TransferData>;
  verification?: Maybe<CandidateVerification>;
};

export class BlobDeleteInput {
  blobName: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  fromImageContainer?: InputMaybe<Scalars['Boolean']['input']>;
  onlyIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class BlobUploadCheckInput {
  items: Array<BlobUploadCheckItemInput>;
};

export class BlobUploadCheckItemInput {
  blobId: Scalars['String']['input'];
  containerId: Scalars['String']['input'];
  expectedSize: Scalars['Int']['input'];
};

export class BlockUserInput {
  cascadeToPartnerOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum BookingPostponeType {
  Never = 'Never',
  NextPeriod = 'NextPeriod',
  NextTrigger = 'NextTrigger'
}

export enum BookingSource {
  Manual = 'Manual',
  System = 'System'
}

export enum BookingType {
  Candidate = 'Candidate',
  CandidateCancellation = 'CandidateCancellation',
  CandidateDiscount = 'CandidateDiscount',
  CandidateDiscountCancellation = 'CandidateDiscountCancellation',
  CandidateTransfer = 'CandidateTransfer',
  Commission = 'Commission',
  CommissionCancellation = 'CommissionCancellation',
  CompensationAmount = 'CompensationAmount',
  CompensationCandidateByMonthlyFloor = 'CompensationCandidateByMonthlyFloor',
  CompensationCandidateDiscount = 'CompensationCandidateDiscount',
  CompensationCap = 'CompensationCap',
  CompensationContingent = 'CompensationContingent',
  CompensationFloor = 'CompensationFloor',
  CompensationMonthlyFloor = 'CompensationMonthlyFloor',
  CompensationMonthlyFloorOverpay = 'CompensationMonthlyFloorOverpay',
  CompensationReplacement = 'CompensationReplacement',
  Contingent = 'Contingent',
  CreditBalanceSettlement = 'CreditBalanceSettlement',
  CreditBalanceSettlementCancellation = 'CreditBalanceSettlementCancellation',
  CreditNote = 'CreditNote',
  DailyRateBasedService = 'DailyRateBasedService',
  DailyRateBasedServiceCancellation = 'DailyRateBasedServiceCancellation',
  IncomingPayment = 'IncomingPayment',
  IncomingPaymentCancellation = 'IncomingPaymentCancellation',
  License = 'License',
  LicenseCancellation = 'LicenseCancellation',
  LicenseCompensationAmount = 'LicenseCompensationAmount',
  LicenseDiscount = 'LicenseDiscount',
  LicenseDiscountCancellation = 'LicenseDiscountCancellation',
  LicenseDiscountCompensationAmount = 'LicenseDiscountCompensationAmount',
  MonthlyFloorPaidInAdvance = 'MonthlyFloorPaidInAdvance',
  Other = 'Other',
  RecurringFee = 'RecurringFee',
  RecurringFeeCancellation = 'RecurringFeeCancellation',
  ServiceBarmer = 'ServiceBarmer',
  ServiceChat = 'ServiceChat',
  ServiceChatCancellation = 'ServiceChatCancellation',
  ServiceCvParsing = 'ServiceCvParsing',
  ServiceCvParsingCancellation = 'ServiceCvParsingCancellation',
  ServiceDocuSealIdVerification = 'ServiceDocuSealIdVerification',
  ServiceDocuSealSigningAes = 'ServiceDocuSealSigningAes',
  ServiceDocuSealSigningQes = 'ServiceDocuSealSigningQes',
  ServiceDocuSealSigningSes = 'ServiceDocuSealSigningSes',
  ServiceLingoking = 'ServiceLingoking',
  ServiceTalentPoolWebsite = 'ServiceTalentPoolWebsite',
  ServiceTalentPoolWebsiteCancellation = 'ServiceTalentPoolWebsiteCancellation',
  UserAccount = 'UserAccount',
  UserAccountCancellation = 'UserAccountCancellation'
}

export class BooleanInput {
  value: Scalars['Boolean']['input'];
};

export class CalculateCandidateProperties {
  __typename?: 'CalculateCandidateProperties';
  languageSkills?: Maybe<Array<CalculatedLanguageSkillForView>>;
  recognitionState?: Maybe<RecognitionState>;
  sourceOrganizationName?: Maybe<Scalars['String']['output']>;
};

export class CalculatedLanguageSkillForView {
  __typename?: 'CalculatedLanguageSkillForView';
  examCertificateDate?: Maybe<Scalars['UTCDate']['output']>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageLevelSource?: Maybe<LanguageLevelSource>;
  languageTrainingStatus?: Maybe<LanguageTrainingStatus>;
  skillLevel?: Maybe<Scalars['String']['output']>;
  skillLevelName?: Maybe<Scalars['String']['output']>;
};

export enum CalculationBasis {
  AbsoluteAmount = 'AbsoluteAmount',
  Percentage = 'Percentage'
}

export class CancelContractInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  cancellationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export class Candidate {
  __typename?: 'Candidate';
  _etag?: Maybe<Scalars['String']['output']>;
  billingDetails?: Maybe<Array<CandidateBillingDetail>>;
  country?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  deletionDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  family?: Maybe<CandidateFamily>;
  function: Scalars['String']['output'];
  governance?: Maybe<GovernanceCandidateData>;
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  internal?: Maybe<InternalCandidateData>;
  lastLoginDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  licensedOrganizationData?: Maybe<CandidateForLicensedOrganizationData>;
  messagesReception?: Maybe<MessagesReception>;
  migration?: Maybe<MigrationCandidateDataContainer>;
  organizationId: Scalars['ID']['output'];
  os?: Maybe<Scalars['JSONObject']['output']>;
  presentation?: Maybe<PresentationCandidateData>;
  processStatus?: Maybe<ProcessStatusCandidateData>;
  profession: Scalars['String']['output'];
  status: CandidateStatus;
  systemOnboarding?: Maybe<CandidateSystemOnboarding>;
  technicalSource?: Maybe<TechnicalSourceEnum>;
  transferData?: Maybe<TransferData>;
  verification?: Maybe<CandidateVerification>;
};

export class CandidateAccess {
  __typename?: 'CandidateAccess';
  canAccess: Scalars['Boolean']['output'];
  redirectToOrganization?: Maybe<Scalars['ID']['output']>;
};

export class CandidateAccessInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateAccountingRecord {
  __typename?: 'CandidateAccountingRecord';
  _etag?: Maybe<Scalars['String']['output']>;
  bookingOrganizationId: Scalars['ID']['output'];
  candidateId: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['UTCDate']['output']>;
  grossAmount: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  multiEditBatchId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  ownerOrganizationId?: Maybe<Scalars['ID']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  type: AccountingRecordType;
};

export class CandidateAccountingRecordCreateInput {
  bookingOrganizationId: Scalars['ID']['input'];
  candidateId: Scalars['ID']['input'];
  category: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  grossAmount: Scalars['Float']['input'];
  multiEditBatchId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  type: AccountingRecordType;
};

export class CandidateAccountingRecordDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateAccountingRecordForList {
  __typename?: 'CandidateAccountingRecordForList';
  _etag?: Maybe<Scalars['String']['output']>;
  bookingOrganizationId: Scalars['ID']['output'];
  bookingOrganizationName: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['UTCDate']['output']>;
  grossAmount: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  multiEditBatchId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  ownerOrganizationId?: Maybe<Scalars['ID']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  type: AccountingRecordType;
};

export class CandidateAccountingRecordGetInput {
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateAccountingRecordListInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateAccountingRecordMultiEditBatch {
  __typename?: 'CandidateAccountingRecordMultiEditBatch';
  batchId: Scalars['ID']['output'];
  candidateCount: Scalars['Int']['output'];
  record?: Maybe<CandidateAccountingRecord>;
};

export class CandidateAccountingRecordMultiEditCandidatesInput {
  candidateIds: Array<CandidateIdInput>;
  licenseOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export class CandidateAccountingRecordMultiEditInput {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  candidateIds: Array<CandidateIdInput>;
  licenseOwner?: InputMaybe<Scalars['Boolean']['input']>;
  operation: ListMultiEditOperation;
  record?: InputMaybe<CandidateAccountingRecordMultiEditValueInput>;
};

export class CandidateAccountingRecordMultiEditPreview {
  __typename?: 'CandidateAccountingRecordMultiEditPreview';
  affected: Array<Candidate>;
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  rows: Array<CandidateMultiEditPreview>;
  skipped: Array<Candidate>;
};

export class CandidateAccountingRecordMultiEditResult {
  __typename?: 'CandidateAccountingRecordMultiEditResult';
  affectedCount: Scalars['Int']['output'];
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  skippedCount: Scalars['Int']['output'];
};

export class CandidateAccountingRecordMultiEditSummary {
  __typename?: 'CandidateAccountingRecordMultiEditSummary';
  batches: Array<CandidateAccountingRecordMultiEditBatch>;
};

export class CandidateAccountingRecordMultiEditValueInput {
  category: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  grossAmount: Scalars['Float']['input'];
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  type: AccountingRecordType;
};

export class CandidateAccountingRecordUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  bookingOrganizationId: Scalars['ID']['input'];
  candidateId: Scalars['ID']['input'];
  category: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  grossAmount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  multiEditBatchId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  type: AccountingRecordType;
};

export class CandidateActivityInput {
  activityType?: InputMaybe<ActivityType>;
  candidateId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export class CandidateActivityParameter {
  __typename?: 'CandidateActivityParameter';
  displayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class CandidateAndCollectionIdInput {
  candidate: CandidateIdInput;
  collection: CollectionIdInput;
};

export class CandidateAndRecipeId {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  recipeId: Scalars['String']['input'];
};

export class CandidateApplicationMaskAnabinByIdInput {
  id: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: AnabinAssetType;
};

export class CandidateApplicationMaskAnabinMinimalInput {
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  type: AnabinAssetType;
};

export class CandidateApplicationMaskBaseInput {
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskCandidateInput {
  communicationLanguage?: InputMaybe<Scalars['String']['input']>;
  function: Scalars['String']['input'];
  os?: InputMaybe<Scalars['JSONObject']['input']>;
  profession: Scalars['String']['input'];
  totalExperienceInMonth?: InputMaybe<Scalars['Float']['input']>;
};

export class CandidateApplicationMaskCandidateObject {
  __typename?: 'CandidateApplicationMaskCandidateObject';
  communicationLanguage?: Maybe<Scalars['String']['output']>;
  function: Scalars['String']['output'];
  os?: Maybe<Scalars['JSONObject']['output']>;
  profession: Scalars['String']['output'];
  totalExperienceInMonth?: Maybe<Scalars['Float']['output']>;
};

export class CandidateApplicationMaskConfig {
  __typename?: 'CandidateApplicationMaskConfig';
  _etag?: Maybe<Scalars['String']['output']>;
  avatarInfoText?: Maybe<Array<ApplicationMaskLocalizedRichText>>;
  avatarUploadRequired?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  customQuestions?: Maybe<Array<ApplicationMaskCustomQuestion>>;
  customQuestionsLabel?: Maybe<Array<ApplicationMaskLocalizedString>>;
  documentDownloads?: Maybe<Array<Scalars['String']['output']>>;
  documentDownloadsLabel?: Maybe<Array<ApplicationMaskLocalizedString>>;
  documentUploads?: Maybe<Array<ApplicationMaskDocumentUpload>>;
  documentUploadsLabel?: Maybe<Array<ApplicationMaskLocalizedString>>;
  generalInfoText?: Maybe<Array<ApplicationMaskLocalizedRichText>>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<ApplicationMaskOrganizationImage>>;
  immigrationCountry: SupportedImmigrationCountry;
  infoTextAfterApplication?: Maybe<Array<ApplicationMaskLocalizedString>>;
  languages: Array<Scalars['String']['output']>;
  links?: Maybe<Array<ApplicationMaskLink>>;
  linksAfterApplication?: Maybe<Array<ApplicationMaskLink>>;
  logoFile?: Maybe<ApplicationMaskFreeFormatFile>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  privacyPolicyLinks?: Maybe<Array<ApplicationMaskLink>>;
  qrCode?: Maybe<ApplicationMaskQrCode>;
  redirectLinkAfterApplication?: Maybe<Scalars['String']['output']>;
  selectedFields?: Maybe<Array<ApplicationMaskSelectedField>>;
  showAvatarUpload?: Maybe<Scalars['Boolean']['output']>;
  sourceOrganizationId?: Maybe<Scalars['ID']['output']>;
  style?: Maybe<ApplicationMaskStyle>;
};

export class CandidateApplicationMaskConfigCreateInput {
  avatarInfoText?: InputMaybe<Array<ApplicationMaskLocalizedRichTextInput>>;
  avatarUploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  customQuestions?: InputMaybe<Array<ApplicationMaskCustomQuestionInput>>;
  customQuestionsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  documentDownloads?: InputMaybe<Array<Scalars['String']['input']>>;
  documentDownloadsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  documentUploads?: InputMaybe<Array<ApplicationMaskDocumentUploadInput>>;
  documentUploadsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  generalInfoText?: InputMaybe<Array<ApplicationMaskLocalizedRichTextInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<ApplicationMaskOrganizationImageInput>>;
  immigrationCountry: SupportedImmigrationCountry;
  infoTextAfterApplication?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  languages: Array<Scalars['String']['input']>;
  links?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  linksAfterApplication?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  logoFile?: InputMaybe<ApplicationMaskFreeFormatFileInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  privacyPolicyLinks?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  qrCode?: InputMaybe<ApplicationMaskQrCodeInput>;
  redirectLinkAfterApplication?: InputMaybe<Scalars['String']['input']>;
  selectedFields?: InputMaybe<Array<ApplicationMaskSelectedFieldInput>>;
  showAvatarUpload?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<ApplicationMaskStyleInput>;
};

export class CandidateApplicationMaskConfigDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskConfigDocumentDownloadUrlGetInput {
  blob: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class CandidateApplicationMaskConfigForCandidateCreation {
  immigrationCountry: SupportedImmigrationCountry;
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateApplicationMaskConfigGetDownloadableDocumentsInput {
  candidate?: InputMaybe<PartialCandidateApplicationMaskCandidateInput>;
  documentDownloads?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  immigrationCountry: SupportedImmigrationCountry;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskConfigGetDownloadableDocumentsPublicInput {
  candidate?: InputMaybe<PartialCandidateApplicationMaskCandidateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskConfigGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskConfigListInput {
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskConfigPublicDocumentDownloadUrlGetInput {
  blob: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  maskId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class CandidateApplicationMaskConfigUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  avatarInfoText?: InputMaybe<Array<ApplicationMaskLocalizedRichTextInput>>;
  avatarUploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  customQuestions?: InputMaybe<Array<ApplicationMaskCustomQuestionInput>>;
  customQuestionsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  documentDownloads?: InputMaybe<Array<Scalars['String']['input']>>;
  documentDownloadsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  documentUploads?: InputMaybe<Array<ApplicationMaskDocumentUploadInput>>;
  documentUploadsLabel?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  generalInfoText?: InputMaybe<Array<ApplicationMaskLocalizedRichTextInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<ApplicationMaskOrganizationImageInput>>;
  immigrationCountry: SupportedImmigrationCountry;
  infoTextAfterApplication?: InputMaybe<Array<ApplicationMaskLocalizedStringInput>>;
  languages: Array<Scalars['String']['input']>;
  links?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  linksAfterApplication?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  logoFile?: InputMaybe<ApplicationMaskFreeFormatFileInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  privacyPolicyLinks?: InputMaybe<Array<ApplicationMaskLinkInput>>;
  qrCode?: InputMaybe<ApplicationMaskQrCodeInput>;
  redirectLinkAfterApplication?: InputMaybe<Scalars['String']['input']>;
  selectedFields?: InputMaybe<Array<ApplicationMaskSelectedFieldInput>>;
  showAvatarUpload?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<ApplicationMaskStyleInput>;
};

export class CandidateApplicationMaskCustomAnswer {
  __typename?: 'CandidateApplicationMaskCustomAnswer';
  checked?: Maybe<Scalars['Boolean']['output']>;
  questionId: Scalars['ID']['output'];
  textAnswer?: Maybe<Scalars['String']['output']>;
};

export class CandidateApplicationMaskCustomAnswerInput {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  questionId: Scalars['ID']['input'];
  textAnswer?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateApplicationMaskData {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  avatars?: InputMaybe<Array<AvatarUploadDefinitionInput>>;
  candidate: CandidateApplicationMaskCandidateInput;
  customAnswers?: InputMaybe<Array<CandidateApplicationMaskCustomAnswerInput>>;
  documents?: InputMaybe<Array<CandidateApplicationMaskDocumentInput>>;
  maskId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  privacyPolicyAccepted: Scalars['Boolean']['input'];
};

export class CandidateApplicationMaskDegreeOrInstitutionByIdInput {
  id: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskDocument {
  __typename?: 'CandidateApplicationMaskDocument';
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentTag: Scalars['String']['output'];
  documentType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<CandidateApplicationMaskFile>;
  uploadConfigId: Scalars['ID']['output'];
};

export class CandidateApplicationMaskDocumentInput {
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentTag: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<CandidateApplicationMaskFileInput>;
  uploadConfigId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskDownloadableDocument {
  __typename?: 'CandidateApplicationMaskDownloadableDocument';
  blob: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
};

export class CandidateApplicationMaskError {
  __typename?: 'CandidateApplicationMaskError';
  _etag?: Maybe<Scalars['String']['output']>;
  applicationData: CandidateApplicationMaskErrorData;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  translatedErrorMessage?: Maybe<Scalars['String']['output']>;
};

export class CandidateApplicationMaskErrorData {
  __typename?: 'CandidateApplicationMaskErrorData';
  avatars?: Maybe<Array<AvatarUploadDefinition>>;
  candidate: CandidateApplicationMaskCandidateObject;
  customAnswers?: Maybe<Array<CandidateApplicationMaskCustomAnswer>>;
  documents?: Maybe<Array<CandidateApplicationMaskDocument>>;
  maskId: Scalars['String']['output'];
};

export class CandidateApplicationMaskErrorGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateApplicationMaskFile {
  __typename?: 'CandidateApplicationMaskFile';
  fileName: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  tempUploadId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export class CandidateApplicationMaskFileInput {
  fileName: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tempUploadId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export class CandidateApplicationMaskInput {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  avatars?: InputMaybe<Array<AvatarUploadDefinitionInput>>;
  candidate: CandidateApplicationMaskCandidateInput;
  captchaToken: Scalars['String']['input'];
  customAnswers?: InputMaybe<Array<CandidateApplicationMaskCustomAnswerInput>>;
  documents?: InputMaybe<Array<CandidateApplicationMaskDocumentInput>>;
  maskId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  privacyPolicyAccepted: Scalars['Boolean']['input'];
};

export class CandidateApplicationMaskResubmitInput {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  avatars?: InputMaybe<Array<AvatarUploadDefinitionInput>>;
  candidate: CandidateApplicationMaskCandidateInput;
  customAnswers?: InputMaybe<Array<CandidateApplicationMaskCustomAnswerInput>>;
  documents?: InputMaybe<Array<CandidateApplicationMaskDocumentInput>>;
  errorEntityId: Scalars['ID']['input'];
  maskId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  privacyPolicyAccepted: Scalars['Boolean']['input'];
};

export class CandidateApplicationMaskSetting {
  __typename?: 'CandidateApplicationMaskSetting';
  configToken?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  supportedImmigrationCountries?: Maybe<Array<SupportedImmigrationCountry>>;
};

export class CandidateApplicationMaskStaticDataModelInput {
  contexts?: InputMaybe<Array<StaticDataInputContext>>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: StaticDataType;
};

export class CandidateApplicationMaskValidationInput {
  applicationData: CandidateApplicationMaskData;
  config: CandidateApplicationMaskConfigForCandidateCreation;
};

export class CandidateArchiveInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  requiredDocumentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  requiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class CandidateAssignmentException {
  __typename?: 'CandidateAssignmentException';
  assignmentExceptionType: CandidateAssignmentExceptionType;
  country?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  function: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  implicitType: CandidateAssignmentExceptionType;
  organizationId: Scalars['ID']['output'];
  profession: Scalars['String']['output'];
  status: CandidateStatus;
};

export class CandidateAssignmentExceptionIdInput {
  assignmentExceptionType: CandidateAssignmentExceptionType;
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  originalColId?: InputMaybe<Scalars['ID']['input']>;
  originalOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CandidateAssignmentExceptionOperation {
  AddException = 'AddException',
  RemoveException = 'RemoveException'
}

export enum CandidateAssignmentExceptionType {
  Exclude = 'Exclude',
  Include = 'Include'
}

export class CandidateBillingDetail {
  __typename?: 'CandidateBillingDetail';
  billedAt: Scalars['AnkaadiaDateTime']['output'];
  billingEvent: Scalars['String']['output'];
};

export class CandidateBillingDetailInput {
  billedAt: Scalars['AnkaadiaDateTime']['input'];
  billingEvent: Scalars['String']['input'];
};

export class CandidateBillingExclusion {
  __typename?: 'CandidateBillingExclusion';
  sourceOrganizationId?: Maybe<Scalars['String']['output']>;
  technicalSource?: Maybe<TechnicalSourceEnum>;
};

export class CandidateBillingExclusionInput {
  sourceOrganizationId?: InputMaybe<Scalars['String']['input']>;
  technicalSource?: InputMaybe<TechnicalSourceEnum>;
};

export class CandidateBookingDetail {
  __typename?: 'CandidateBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  capDetails?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountId?: Maybe<Scalars['String']['output']>;
  discountInfo?: Maybe<Scalars['String']['output']>;
  floorDetails?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPartPayment: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  partPaymentPercentage?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
  priceRowId?: Maybe<Scalars['String']['output']>;
  referencedBookings?: Maybe<Scalars['String']['output']>;
  segmentCap?: Maybe<Scalars['Float']['output']>;
  totalCap?: Maybe<Scalars['Float']['output']>;
};

export class CandidateBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateBookingDetailInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  billingTriggerEvent?: InputMaybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  capDetails?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  discountInfo?: InputMaybe<Scalars['String']['input']>;
  floorDetails?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPartPayment: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  partPaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceInfo?: InputMaybe<Scalars['String']['input']>;
  priceRowId?: InputMaybe<Scalars['String']['input']>;
  referencedBookings?: InputMaybe<Scalars['String']['input']>;
  segmentCap?: InputMaybe<Scalars['Float']['input']>;
  totalCap?: InputMaybe<Scalars['Float']['input']>;
};

export enum CandidateChatGroupConversationType {
  Collection = 'Collection',
  CollectionExclusive = 'CollectionExclusive',
  Configuration = 'Configuration',
  Default = 'Default',
  Process = 'Process'
}

export class CandidateChatGroupData {
  __typename?: 'CandidateChatGroupData';
  candidateContextId: Scalars['ID']['output'];
  candidateContextOrganizationId: Scalars['ID']['output'];
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateGroupType: CandidateChatGroupConversationType;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  includeCandidateInGroup?: Maybe<Scalars['Boolean']['output']>;
};

export class CandidateChatGroupDataInput {
  candidateContextId: Scalars['ID']['input'];
  candidateContextOrganizationId: Scalars['ID']['input'];
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateGroupType: CandidateChatGroupConversationType;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  includeCandidateInGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export class CandidateChatGroupExistsInput {
  user: ChatUserOrCandidateIdInput;
};

export class CandidateChatPreviewGroup {
  __typename?: 'CandidateChatPreviewGroup';
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateGroups: Array<ChatConversationPreview>;
  candidateId?: Maybe<ChatUserOrCandidateId>;
  isDeletedCandidate?: Maybe<Scalars['Boolean']['output']>;
};

export enum CandidateColumn {
  AcceleratedProcedureDigitalRequestDate = 'AcceleratedProcedureDigitalRequestDate',
  AcceleratedProcedureDigitalRequested = 'AcceleratedProcedureDigitalRequested',
  AcceleratedProcedurePaperRequestDate = 'AcceleratedProcedurePaperRequestDate',
  AcceleratedProcedurePaperRequested = 'AcceleratedProcedurePaperRequested',
  AfterRecognitionWorkLocation = 'AfterRecognitionWorkLocation',
  AfterRecognitionWorkLocationOrganizationName = 'AfterRecognitionWorkLocationOrganizationName',
  CandidateState = 'CandidateState',
  CertifiedGermanLanguageLevel = 'CertifiedGermanLanguageLevel',
  Citizenship = 'Citizenship',
  CostCenter = 'CostCenter',
  DisplayId = 'DisplayId',
  EmployerName = 'EmployerName',
  EmploymentApprovalReceiveDate = 'EmploymentApprovalReceiveDate',
  EmploymentApprovalRequestDate = 'EmploymentApprovalRequestDate',
  EntryVisaReceived = 'EntryVisaReceived',
  EntryVisaRequestDate = 'EntryVisaRequestDate',
  EntryVisaValidFromDate = 'EntryVisaValidFromDate',
  EstimatedArrivalDate = 'EstimatedArrivalDate',
  FirstName = 'FirstName',
  Function = 'Function',
  Gender = 'Gender',
  GermanLanguageLevel = 'GermanLanguageLevel',
  LastName = 'LastName',
  Profession = 'Profession',
  ProfessionSubArea = 'ProfessionSubArea',
  RecognitionNoticeReceiveDate = 'RecognitionNoticeReceiveDate',
  RecognitionNoticeReceived = 'RecognitionNoticeReceived',
  RecognitionStartDate = 'RecognitionStartDate',
  RecognitionStarted = 'RecognitionStarted',
  RecognitionType = 'RecognitionType',
  RecruitingSourceOrganizationName = 'RecruitingSourceOrganizationName',
  ResponsibleEmployees = 'ResponsibleEmployees',
  WorkLocation = 'WorkLocation',
  WorkLocationOrganizationName = 'WorkLocationOrganizationName'
}

export class CandidateColumnCandidateInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum CandidateColumnDataType {
  Boolean = 'Boolean',
  Date = 'Date',
  String = 'String'
}

export class CandidateColumnDescriptor {
  __typename?: 'CandidateColumnDescriptor';
  column: CandidateColumn;
  dataType: CandidateColumnDataType;
  label: Scalars['String']['output'];
  sortable: Scalars['Boolean']['output'];
};

export class CandidateColumnValue {
  __typename?: 'CandidateColumnValue';
  column: CandidateColumn;
  value?: Maybe<Scalars['String']['output']>;
};

export class CandidateColumnValues {
  __typename?: 'CandidateColumnValues';
  candidateId: Scalars['ID']['output'];
  values: Array<CandidateColumnValue>;
};

export class CandidateCommentDeleteInput {
  commentId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  iterationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateCommentUpsertInput {
  candidateId: Scalars['ID']['input'];
  comment: CommentDataInput;
  feedbackIterationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateCreateCurrentSelection {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateCreateInput {
  family?: InputMaybe<CandidateFamilyInput>;
  function: Scalars['String']['input'];
  governance?: InputMaybe<GovernanceCandidateDataInput>;
  immigrationCountry: SupportedImmigrationCountry;
  internal?: InputMaybe<InternalCandidateDataInput>;
  licensedOrganizationData?: InputMaybe<CandidateForLicenseOrganizationDataInput>;
  migration?: InputMaybe<MigrationCandidateDataContainerInput>;
  organizationId: Scalars['ID']['input'];
  os?: InputMaybe<Scalars['JSONObject']['input']>;
  presentation?: InputMaybe<PresentationCandidateDataInput>;
  processStatus?: InputMaybe<ProcessStatusCandidateDataInput>;
  profession: Scalars['String']['input'];
  status: CandidateStatus;
};

export class CandidateData {
  __typename?: 'CandidateData';
  candidateId: Scalars['ID']['output'];
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class CandidateDataEvent {
  __typename?: 'CandidateDataEvent';
  candidateId: Scalars['ID']['output'];
  candidateStatus?: Maybe<CandidateStatus>;
  country?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateOrDateTime']['output'];
  dateEnd?: Maybe<Scalars['DateOrDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class CandidateDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingEtag?: InputMaybe<Scalars['String']['input']>;
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateDeletionRequest {
  __typename?: 'CandidateDeletionRequest';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CandidateDeletionRequestInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateDeletionSetting {
  __typename?: 'CandidateDeletionSetting';
  candidateStatusForDeletion: CandidateStatus;
  daysAfterDeletion?: Maybe<Scalars['Float']['output']>;
  isEnabled: Scalars['Boolean']['output'];
};

export class CandidateDeletionSettingInput {
  candidateStatusForDeletion: CandidateStatus;
  daysAfterDeletion?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
};

export class CandidateDiff {
  __typename?: 'CandidateDiff';
  children?: Maybe<Array<CandidateDiff>>;
  data: CandidateDiffData;
};

export class CandidateDiffData {
  __typename?: 'CandidateDiffData';
  approval?: Maybe<Approval>;
  captionKey: Scalars['String']['output'];
  captionParameter?: Maybe<Scalars['JSONObject']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  originalPath?: Maybe<Scalars['String']['output']>;
  property: Scalars['String']['output'];
};

export class CandidateDiffInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateDocTypeAttachment {
  __typename?: 'CandidateDocTypeAttachment';
  comment?: Maybe<Scalars['String']['output']>;
  docOrganizationRole?: Maybe<Scalars['String']['output']>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentTag?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  isOptional?: Maybe<Scalars['Boolean']['output']>;
};

export class CandidateDocTypeAttachmentInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  docOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentTag?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
};

export class CandidateDocumentListInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  isInTaskActContext: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateDocumentMetadataInput {
  blob: Scalars['String']['input'];
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class CandidateDocumentModel {
  __typename?: 'CandidateDocumentModel';
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentTag: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
};

export class CandidateDocumentModelInput {
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentTag: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
};

export class CandidateEmployerUpsertInput {
  candidateId: Scalars['ID']['input'];
  employer: EmployerDataInput;
  feedbackIterationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CandidateEvent = CandidateDataEvent | CourseExamDataEvent | DocumentDataEvent;

export class CandidateEventsInput {
  candidateId: Scalars['ID']['input'];
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateExecutionId {
  candidateId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  processId?: InputMaybe<Scalars['String']['input']>;
  processOrganizationId?: InputMaybe<Scalars['String']['input']>;
  recipeId: Scalars['String']['input'];
  validationResultId: Scalars['String']['input'];
};

export class CandidateFamily {
  __typename?: 'CandidateFamily';
  members?: Maybe<Array<CandidateFamilyMember>>;
};

export class CandidateFamilyInput {
  members?: InputMaybe<Array<CandidateFamilyMemberInput>>;
};

export class CandidateFamilyMember {
  __typename?: 'CandidateFamilyMember';
  address?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['UTCDate']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  bodyHeight?: Maybe<Scalars['Float']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityOfBirth?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eyeColor?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  germanLanguageSkill?: Maybe<Scalars['String']['output']>;
  hasSharedCustody?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isEmergencyContact?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  otherCustodian?: Maybe<Scalars['ID']['output']>;
  passNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  relation: CandidateRelation;
  reunification: Scalars['Boolean']['output'];
  salutation: Scalars['String']['output'];
  sameAddressAsCandidate?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class CandidateFamilyMemberInput {
  address?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['UTCDate']['input']>;
  birthName?: InputMaybe<Scalars['String']['input']>;
  bodyHeight?: InputMaybe<Scalars['Float']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityOfBirth?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eyeColor?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  germanLanguageSkill?: InputMaybe<Scalars['String']['input']>;
  hasSharedCustody?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  otherCustodian?: InputMaybe<Scalars['ID']['input']>;
  passNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  relation: CandidateRelation;
  reunification: Scalars['Boolean']['input'];
  salutation: Scalars['String']['input'];
  sameAddressAsCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateFeedbackDeleteInput {
  feedbackId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  iterationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateFeedbackGetInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateFeedbackUpsertInput {
  candidateId: Scalars['ID']['input'];
  feedback: FeedbackDataInput;
  feedbackIterationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateForEdit {
  __typename?: 'CandidateForEdit';
  candidate: Candidate;
  deletionRequest?: Maybe<CandidateDeletionRequest>;
  favorite?: Maybe<Favorite>;
  messagesReception?: Maybe<MessagesReception>;
  tags?: Maybe<Array<CandidateTag>>;
};

export class CandidateForLicenseOrganizationDataInput {
  internal?: InputMaybe<InternalCandidateDataInput>;
};

export class CandidateForLicensedOrganizationData {
  __typename?: 'CandidateForLicensedOrganizationData';
  internal?: Maybe<InternalCandidateData>;
};

export class CandidateForView {
  __typename?: 'CandidateForView';
  _etag?: Maybe<Scalars['String']['output']>;
  calculatedProperties: CalculateCandidateProperties;
  country?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  deletionDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  family?: Maybe<CandidateFamily>;
  function: Scalars['String']['output'];
  governance?: Maybe<GovernanceCandidateData>;
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  internal?: Maybe<InternalCandidateData>;
  licensedOrganizationData?: Maybe<CandidateForLicensedOrganizationData>;
  migration?: Maybe<MigrationCandidateDataContainerForView>;
  organizationId: Scalars['ID']['output'];
  os?: Maybe<Scalars['JSONObject']['output']>;
  presentation?: Maybe<PresentationCandidateData>;
  processStatus?: Maybe<ProcessStatusCandidateData>;
  profession: Scalars['String']['output'];
  status: CandidateStatus;
  technicalSource?: Maybe<TechnicalSourceEnum>;
  transferData?: Maybe<TransferData>;
  verification?: Maybe<CandidateVerification>;
};

export class CandidateId {
  __typename?: 'CandidateId';
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  originalColId?: Maybe<Scalars['ID']['output']>;
  originalOrgId?: Maybe<Scalars['ID']['output']>;
};

export class CandidateIdInput {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  originalColId?: InputMaybe<Scalars['ID']['input']>;
  originalOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateImportIssue {
  __typename?: 'CandidateImportIssue';
  candidateName?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
};

export class CandidateImportIssueInput {
  candidateName?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Float']['input']>;
  message: Scalars['String']['input'];
};

export class CandidateInboxInput {
  candidateId?: InputMaybe<CandidateIdInput>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateInternalRatingData {
  __typename?: 'CandidateInternalRatingData';
  aptitude?: Maybe<Scalars['Int']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['Int']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
};

export class CandidateInternalRatingDataInput {
  aptitude?: InputMaybe<Scalars['Int']['input']>;
  experience?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['Int']['input']>;
  overall?: InputMaybe<Scalars['Float']['input']>;
};

export class CandidateInterviewIterationDeleteInput {
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  interviewFeedbackId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateInterviewMultiEditBatch {
  __typename?: 'CandidateInterviewMultiEditBatch';
  batchId: Scalars['ID']['output'];
  candidateCount: Scalars['Int']['output'];
  comments?: Maybe<Array<CommentData>>;
  employer?: Maybe<EmployerData>;
  feedback?: Maybe<FeedbackData>;
};

export class CandidateInterviewMultiEditCandidatesInput {
  candidateIds: Array<CandidateIdInput>;
  licenseOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export class CandidateInterviewMultiEditExistingInterview {
  __typename?: 'CandidateInterviewMultiEditExistingInterview';
  batchId?: Maybe<Scalars['ID']['output']>;
  candidateId: Scalars['ID']['output'];
  interviewDate?: Maybe<DateWithTime>;
};

export class CandidateInterviewMultiEditInput {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  candidateIds: Array<CandidateIdInput>;
  comments?: InputMaybe<Array<CommentDataInput>>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  feedback?: InputMaybe<FeedbackDataInput>;
  licenseOwner?: InputMaybe<Scalars['Boolean']['input']>;
  operation: ListMultiEditOperation;
};

export class CandidateInterviewMultiEditPreview {
  __typename?: 'CandidateInterviewMultiEditPreview';
  affected: Array<Candidate>;
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  rows: Array<CandidateMultiEditPreview>;
  sameDay: Array<Candidate>;
  skipped: Array<Candidate>;
};

export class CandidateInterviewMultiEditResult {
  __typename?: 'CandidateInterviewMultiEditResult';
  affectedCount: Scalars['Int']['output'];
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  skippedCount: Scalars['Int']['output'];
};

export class CandidateInterviewMultiEditSummary {
  __typename?: 'CandidateInterviewMultiEditSummary';
  batches: Array<CandidateInterviewMultiEditBatch>;
  existingInterviews: Array<CandidateInterviewMultiEditExistingInterview>;
};

export class CandidateInterviewsFeedback {
  __typename?: 'CandidateInterviewsFeedback';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  interviewsFeedback?: Maybe<Array<FeedbackIterationData>>;
  organizationId: Scalars['ID']['output'];
  ownerOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class CandidateInvoiceCreationValidationResult {
  __typename?: 'CandidateInvoiceCreationValidationResult';
  candidatesWithMultipleInvoiceRecipients: Array<Candidate>;
  hasPendingChallenges: Scalars['Boolean']['output'];
};

export class CandidateLicensedOrganizationDataUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
  internalMaskHash?: InputMaybe<Scalars['String']['input']>;
  licensedOrganizationData?: InputMaybe<CandidateForLicenseOrganizationDataInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateListMultiEditBatch {
  __typename?: 'CandidateListMultiEditBatch';
  batchId: Scalars['ID']['output'];
  candidateCount: Scalars['Int']['output'];
  element?: Maybe<Scalars['JSONObject']['output']>;
};

export class CandidateListMultiEditCandidatesInput {
  candidateIds: Array<CandidateIdInput>;
  listPath: Scalars['String']['input'];
};

export class CandidateListMultiEditInput {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  candidateIds: Array<CandidateIdInput>;
  element?: InputMaybe<Scalars['JSONObject']['input']>;
  listPath: Scalars['String']['input'];
  operation: ListMultiEditOperation;
  sharing?: InputMaybe<CandidateUpdateInputSharing>;
};

export class CandidateListMultiEditPreview {
  __typename?: 'CandidateListMultiEditPreview';
  affected: Array<Candidate>;
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  rows: Array<CandidateMultiEditPreview>;
  skipped: Array<Candidate>;
};

export class CandidateListMultiEditResult {
  __typename?: 'CandidateListMultiEditResult';
  affectedCount: Scalars['Int']['output'];
  batchId: Scalars['ID']['output'];
  operation: ListMultiEditOperation;
  skippedCount: Scalars['Int']['output'];
};

export class CandidateListMultiEditSummary {
  __typename?: 'CandidateListMultiEditSummary';
  batches: Array<CandidateListMultiEditBatch>;
  listPath: Scalars['String']['output'];
};

export class CandidateMultiEditConfiguration {
  __typename?: 'CandidateMultiEditConfiguration';
  fields: Array<Scalars['String']['output']>;
  lists: Array<Scalars['String']['output']>;
  tabs: Array<Scalars['String']['output']>;
};

export class CandidateMultiEditConfigurationInput {
  organizationId: Scalars['ID']['input'];
};

export class CandidateMultiEditExecuteInput {
  candidate: CandidateUpdateInput;
  candidateIds: Array<CandidateIdInput>;
  sharing?: InputMaybe<CandidateUpdateInputSharing>;
};

export class CandidateMultiEditPreview {
  __typename?: 'CandidateMultiEditPreview';
  candidates: CandidateMultiEditPreviewDetails;
  caption: Scalars['String']['output'];
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class CandidateMultiEditPreviewCandidate {
  __typename?: 'CandidateMultiEditPreviewCandidate';
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CandidateMultiEditPreviewDetails {
  __typename?: 'CandidateMultiEditPreviewDetails';
  withDifferentValue?: Maybe<Array<CandidateMultiEditPreviewCandidate>>;
  withNoValue?: Maybe<Array<CandidateMultiEditPreviewCandidate>>;
  withTheValue?: Maybe<Array<CandidateMultiEditPreviewCandidate>>;
};

export class CandidateMultiEditPreviewInput {
  candidate: CandidateUpdateInput;
  candidateIds: Array<CandidateIdInput>;
  sharing?: InputMaybe<CandidateUpdateInputSharing>;
};

export class CandidateMultiInviteExecuteInput {
  candidateIds: Array<CandidateIdInput>;
};

export class CandidateMultiInvitePreviewInput {
  candidateIds: Array<CandidateIdInput>;
};

export enum CandidateOrigin {
  AlreadyMigrated = 'AlreadyMigrated',
  EuropeanUnion = 'EuropeanUnion',
  NonEuropeanUnion = 'NonEuropeanUnion'
}

export class CandidatePage {
  __typename?: 'CandidatePage';
  nodes?: Maybe<Array<Candidate>>;
  totalCount: Scalars['Int']['output'];
};

export class CandidatePageInput {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCandidatesForPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  includeHistoricCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export class CandidatePrice {
  __typename?: 'CandidatePrice';
  billingExclusions?: Maybe<Array<CandidateBillingExclusion>>;
  cap?: Maybe<Scalars['Float']['output']>;
  floor?: Maybe<Scalars['Float']['output']>;
  floorPaymentType?: Maybe<FloorPaymentType>;
  priceRows: Array<PriceRow>;
};

export class CandidatePriceInput {
  billingExclusions?: InputMaybe<Array<CandidateBillingExclusionInput>>;
  cap?: InputMaybe<Scalars['Float']['input']>;
  floor?: InputMaybe<Scalars['Float']['input']>;
  floorPaymentType?: InputMaybe<FloorPaymentType>;
  priceRows: Array<PriceRowInput>;
};

export class CandidateProfileConfig {
  __typename?: 'CandidateProfileConfig';
  _etag?: Maybe<Scalars['String']['output']>;
  appliesToNewCandidates?: Maybe<Scalars['Boolean']['output']>;
  candidateFunction?: Maybe<Array<Scalars['String']['output']>>;
  candidateStatus?: Maybe<Array<CandidateStatus>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  setId?: Maybe<Scalars['String']['output']>;
  tabs: Array<CandidateProfileConfigTab>;
  targetType: CandidateProfileConfigTargetType;
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export class CandidateProfileConfigCreateInput {
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  candidateFunction?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateStatus?: InputMaybe<Array<CandidateStatus>>;
  organizationId: Scalars['ID']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
  tabs: Array<CandidateProfileConfigTabInput>;
  targetType: CandidateProfileConfigTargetType;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateProfileConfigDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateProfileConfigGetByFunctionAndStatusInput {
  candidateFunction: Scalars['String']['input'];
  candidateStatus: CandidateStatus;
  organizationId: Scalars['ID']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
  targetType: CandidateProfileConfigTargetType;
};

export class CandidateProfileConfigGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateProfileConfigGetListAllInput {
  organizationId: Scalars['ID']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
  targetType: CandidateProfileConfigTargetType;
};

export class CandidateProfileConfigTab {
  __typename?: 'CandidateProfileConfigTab';
  fullTabPermission?: Maybe<TabPermission>;
  key: Scalars['String']['output'];
  tabFields?: Maybe<Array<TabField>>;
};

export class CandidateProfileConfigTabInput {
  fullTabPermission?: InputMaybe<TabPermission>;
  key: Scalars['String']['input'];
  tabFields?: InputMaybe<Array<TabFieldInput>>;
};

export enum CandidateProfileConfigTargetType {
  Candidate = 'Candidate',
  Partner = 'Partner',
  User = 'User'
}

export class CandidateProfileConfigUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  candidateFunction?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateStatus?: InputMaybe<Array<CandidateStatus>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
  tabs: Array<CandidateProfileConfigTabInput>;
  targetType: CandidateProfileConfigTargetType;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateProfileProperty {
  __typename?: 'CandidateProfileProperty';
  expression?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export class CandidateProfilePropertyInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export class CandidateProfileTabFieldLabel {
  __typename?: 'CandidateProfileTabFieldLabel';
  alternativeOf?: Maybe<Scalars['String']['output']>;
  appliesWhen: Array<FieldApplicabilityRule>;
  fieldGroup?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  labelKey: Scalars['String']['output'];
  mutuallyExclusiveWith: Array<Scalars['String']['output']>;
  neverMandatory: Scalars['Boolean']['output'];
  parentLabelKey?: Maybe<Scalars['String']['output']>;
  paths: Array<Scalars['String']['output']>;
  requires: Array<Scalars['String']['output']>;
  tabKey: Scalars['String']['output'];
};

export class CandidateProfileUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  profile: Scalars['JSONObject']['input'];
};

export class CandidateReceipt {
  __typename?: 'CandidateReceipt';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  status: CandidateReceiptStatus;
};

export enum CandidateReceiptStatus {
  Error = 'Error',
  InProgress = 'InProgress',
  Success = 'Success'
}

export enum CandidateRelation {
  Child = 'Child',
  Father = 'Father',
  Mother = 'Mother',
  Other = 'Other',
  Partner = 'Partner'
}

export class CandidateReplacedByInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateRequestDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateScholarship {
  __typename?: 'CandidateScholarship';
  amountOfMoney?: Maybe<Scalars['Float']['output']>;
  awardFrequency?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  id: Scalars['ID']['output'];
  responsibleRoleScholarship?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class CandidateScholarshipInput {
  amountOfMoney?: InputMaybe<Scalars['Float']['input']>;
  awardFrequency?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  responsibleRoleScholarship?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export enum CandidateSheetModeEnum {
  Full = 'Full',
  Simple = 'Simple'
}

export enum CandidateSource {
  Direct = 'Direct',
  Indirect = 'Indirect'
}

export class CandidateSpecialization {
  __typename?: 'CandidateSpecialization';
  candidateFunction?: Maybe<Scalars['String']['output']>;
  candidateOrigin?: Maybe<CandidateOrigin>;
  candidateSource?: Maybe<CandidateSource>;
  professionCategory?: Maybe<ProfessionCategory>;
};

export class CandidateSpecializationInput {
  candidateFunction?: InputMaybe<Scalars['String']['input']>;
  candidateOrigin?: InputMaybe<CandidateOrigin>;
  candidateSource?: InputMaybe<CandidateSource>;
  professionCategory?: InputMaybe<ProfessionCategory>;
};

export class CandidateStaticDataContextInformation {
  __typename?: 'CandidateStaticDataContextInformation';
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  organizationId: Scalars['ID']['output'];
};

export enum CandidateStatus {
  Approved = 'Approved',
  Archived = 'Archived',
  Associated = 'Associated',
  DroppedOut = 'DroppedOut',
  ForSelection = 'ForSelection',
  InRecognition = 'InRecognition',
  Inactive = 'Inactive',
  LabourMigrationFinished = 'LabourMigrationFinished',
  Matched = 'Matched',
  New = 'New',
  Paused = 'Paused',
  Rejected = 'Rejected',
  Transferred = 'Transferred',
  Unknown = 'Unknown'
}

export class CandidateStatusChangeInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateStatusChangeUpdateInput {
  candidateId: Scalars['ID']['input'];
  changeId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  reasonId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateStatusHistoryEntry {
  __typename?: 'CandidateStatusHistoryEntry';
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedByName?: Maybe<Scalars['String']['output']>;
  changedByProcess: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  reasonArchived?: Maybe<Scalars['Boolean']['output']>;
  reasonId?: Maybe<Scalars['ID']['output']>;
  reasonName?: Maybe<Scalars['String']['output']>;
  status: CandidateStatus;
};

export class CandidateStatusHistoryGetInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CandidateSystemOnboarding {
  __typename?: 'CandidateSystemOnboarding';
  authId?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  facebookPageId?: Maybe<Scalars['String']['output']>;
  invitedToSystem?: Maybe<Scalars['Boolean']['output']>;
  invitedToSystemDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  messagingOpt_In?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditionsAcceptedDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
};

export class CandidateTag {
  __typename?: 'CandidateTag';
  color: CandidateTagColor;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export enum CandidateTagColor {
  Danger = 'Danger',
  Info = 'Info',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Success = 'Success',
  Warning = 'Warning'
}

export class CandidateTagConfiguration {
  __typename?: 'CandidateTagConfiguration';
  color: CandidateTagColor;
  variable: Scalars['String']['output'];
};

export class CandidateTagConfigurationInput {
  color: CandidateTagColor;
  variable: Scalars['String']['input'];
};

export class CandidateTagDescription {
  __typename?: 'CandidateTagDescription';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
  variable: Scalars['String']['output'];
};

export class CandidateTagGetInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class CandidateTaskInbox {
  __typename?: 'CandidateTaskInbox';
  processTasksData: Array<ProcessWithTasks>;
};

export class CandidateTransferInput {
  autoShareBack: Scalars['Boolean']['input'];
  candidateIds: Array<CandidateIdInput>;
  keepCandidateCopy: Scalars['Boolean']['input'];
  mask: CandidateTransferMaskInput;
  organizationId: Scalars['ID']['input'];
  targetOrganizationId: Scalars['ID']['input'];
  transferInternalDocuments: Scalars['Boolean']['input'];
};

export class CandidateTransferLog {
  __typename?: 'CandidateTransferLog';
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  sourceCandidateDisplayId: Scalars['String']['output'];
  sourceCandidateId: Scalars['ID']['output'];
  sourceOrganizationId: Scalars['ID']['output'];
  sourceOrganizationName: Scalars['String']['output'];
  targetCandidateDisplayId: Scalars['String']['output'];
  targetCandidateId: Scalars['ID']['output'];
  targetOrganizationId: Scalars['ID']['output'];
  targetOrganizationName: Scalars['String']['output'];
  transferDate: Scalars['AnkaadiaDateTime']['output'];
  transferUserId: Scalars['ID']['output'];
  transferUserName: Scalars['String']['output'];
};

export class CandidateTransferLogGetInput {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class CandidateTransferMaskInput {
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  transferAllData: Scalars['Boolean']['input'];
};

export class CandidateTransferResult {
  __typename?: 'CandidateTransferResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newCollectionName?: Maybe<Scalars['String']['output']>;
  notTransferredCandidatesDisplayIds?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  transferredCandidatesDisplayIds?: Maybe<Array<Scalars['String']['output']>>;
  validationMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export class CandidateTransferTargetOrganizationsInput {
  candidateIds: Array<CandidateIdInput>;
  organizationId: Scalars['ID']['input'];
};

export class CandidateUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<CandidateFamilyInput>;
  function?: InputMaybe<Scalars['String']['input']>;
  governance?: InputMaybe<GovernanceCandidateDataInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  immigrationCountry?: InputMaybe<SupportedImmigrationCountry>;
  internal?: InputMaybe<InternalCandidateDataInput>;
  licensedOrganizationData?: InputMaybe<CandidateForLicenseOrganizationDataInput>;
  migration?: InputMaybe<MigrationCandidateDataContainerInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  os?: InputMaybe<Scalars['JSONObject']['input']>;
  presentation?: InputMaybe<PresentationCandidateDataInput>;
  processStatus?: InputMaybe<ProcessStatusCandidateDataInput>;
  profession?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CandidateStatus>;
  statusChange?: InputMaybe<CandidateStatusChangeInput>;
};

export class CandidateUpdateInputSharing {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
  internalMaskHash?: InputMaybe<Scalars['String']['input']>;
  sharedTabHash?: InputMaybe<Scalars['String']['input']>;
};

export class CandidateVaccinationStatus {
  __typename?: 'CandidateVaccinationStatus';
  candidateId: Scalars['ID']['output'];
  candidateOrgId: Scalars['ID']['output'];
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  vaccinations: Array<VaccinationStatus>;
};

export class CandidateVerification {
  __typename?: 'CandidateVerification';
  level: CandidateVerificationLevel;
  verifiedAt: Scalars['AnkaadiaDateTime']['output'];
};

export enum CandidateVerificationLevel {
  Aes = 'AES',
  Qes = 'QES'
}

export class CandidatesOfCollectionForViewInput {
  colId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  selectedSharingId?: InputMaybe<Scalars['ID']['input']>;
};

export class CertificateValuationAuthority {
  __typename?: 'CertificateValuationAuthority';
  city: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  federalState: Scalars['String']['output'];
  homepage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  title: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export class CertificateValuationAuthorityInput {
  federalStates?: InputMaybe<Array<Scalars['String']['input']>>;
  immigrationCountry: SupportedImmigrationCountry;
};

export class CertifiedEducationExam {
  __typename?: 'CertifiedEducationExam';
  examDateAndTime?: Maybe<DateWithTime>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  examResult?: Maybe<Scalars['String']['output']>;
  examResultId: Scalars['ID']['output'];
  languageLevel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  passedModules?: Maybe<Array<ExamModuleType>>;
};

export class CertifiedEducationExamGroup {
  __typename?: 'CertifiedEducationExamGroup';
  examResultId?: Maybe<Scalars['String']['output']>;
  exams?: Maybe<Array<CertifiedEducationExam>>;
  institution?: Maybe<Scalars['String']['output']>;
  isFullyCertified: Scalars['Boolean']['output'];
  level: Scalars['String']['output'];
};

export class ChallengeBooking {
  __typename?: 'ChallengeBooking';
  _etag?: Maybe<Scalars['String']['output']>;
  bookingId: Scalars['ID']['output'];
  challengeBy: Scalars['String']['output'];
  challengeByUserId?: Maybe<Scalars['String']['output']>;
  challengeDate: Scalars['AnkaadiaDateTime']['output'];
  challengeReason: Scalars['String']['output'];
  challengeStatus: ChallengeBookingStatus;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  postponeType?: Maybe<BookingPostponeType>;
  responseBy?: Maybe<Scalars['String']['output']>;
  responseByUserId?: Maybe<Scalars['String']['output']>;
  responseDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  responseMessage?: Maybe<Scalars['String']['output']>;
};

export class ChallengeBookingAcceptInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  postponeType?: InputMaybe<BookingPostponeType>;
};

export class ChallengeBookingCreateInput {
  bookingId: Scalars['ID']['input'];
  challengeReason: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ChallengeBookingGetAllInput {
  organizationId: Scalars['ID']['input'];
};

export class ChallengeBookingGetMultipleInput {
  bookingIds: Array<Scalars['ID']['input']>;
};

export class ChallengeBookingInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['ID']['input'];
  challengeBy: Scalars['String']['input'];
  challengeByUserId?: InputMaybe<Scalars['String']['input']>;
  challengeDate: Scalars['AnkaadiaDateTime']['input'];
  challengeReason: Scalars['String']['input'];
  challengeStatus: ChallengeBookingStatus;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  postponeType?: InputMaybe<BookingPostponeType>;
  responseBy?: InputMaybe<Scalars['String']['input']>;
  responseByUserId?: InputMaybe<Scalars['String']['input']>;
  responseDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  responseMessage?: InputMaybe<Scalars['String']['input']>;
};

export class ChallengeBookingRejectInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  responseMessage?: InputMaybe<Scalars['String']['input']>;
};

export class ChallengeBookingRevokeResponseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum ChallengeBookingStatus {
  ChallengeAccepted = 'ChallengeAccepted',
  ChallengeRejected = 'ChallengeRejected',
  Challenged = 'Challenged',
  Valid = 'Valid'
}

export class ChallengeBookingWithdrawInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChamberOfCrafts {
  __typename?: 'ChamberOfCrafts';
  hwkCity?: Maybe<Scalars['String']['output']>;
  hwkDepartmentEmail?: Maybe<Scalars['String']['output']>;
  hwkDepartmentPhone?: Maybe<Scalars['String']['output']>;
  hwkFederalState?: Maybe<Scalars['String']['output']>;
  hwkFederalStateCode?: Maybe<Scalars['String']['output']>;
  hwkHouseNumber: Scalars['Float']['output'];
  hwkId: Scalars['String']['output'];
  hwkInstitutionName?: Maybe<Scalars['String']['output']>;
  hwkStreet?: Maybe<Scalars['String']['output']>;
  hwkZipCode?: Maybe<Scalars['String']['output']>;
};

export class ChamberOfCraftsInput {
  federalStates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ChangePlanInput {
  contingentDefinitionSetId?: InputMaybe<Scalars['String']['input']>;
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  startDate: Scalars['UTCDate']['input'];
  type: PhaseType;
};

export class ChatConfiguration {
  __typename?: 'ChatConfiguration';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  collectionUserGroupMappings?: Maybe<Array<CollectionUserGroupMapping>>;
  defaultCandidateChatPartnerGroups?: Maybe<Array<Scalars['ID']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class ChatConfigurationGetInput {
  organizationId: Scalars['ID']['input'];
};

export class ChatConfigurationUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  collectionUserGroupMappings?: InputMaybe<Array<CollectionUserGroupMappingInput>>;
  defaultCandidateChatPartnerGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChatConversationPreview {
  __typename?: 'ChatConversationPreview';
  chatUserOrGroupId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<Scalars['String']['output']>;
  lastMessageSender?: Maybe<Scalars['String']['output']>;
  lastUpdatedAtTs?: Maybe<Scalars['Float']['output']>;
  metaData?: Maybe<ChatConversationPreviewMetaData>;
  organizationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unreadMessagesCount?: Maybe<Scalars['Float']['output']>;
  userOrGroupId?: Maybe<Scalars['String']['output']>;
};

export class ChatConversationPreviewMetaData {
  __typename?: 'ChatConversationPreviewMetaData';
  candidateChatGroupContextId?: Maybe<Scalars['String']['output']>;
  candidateChatGroupType?: Maybe<CandidateChatGroupConversationType>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class ChatConversationReference {
  __typename?: 'ChatConversationReference';
  type: ChatConversationTypeEnum;
  userOrChatGroupId: Scalars['String']['output'];
};

export class ChatConversationReferenceInput {
  type: ChatConversationTypeEnum;
  userOrChatGroupId: Scalars['String']['input'];
};

export enum ChatConversationTypeEnum {
  Group = 'Group',
  User = 'User'
}

export class ChatGroup {
  __typename?: 'ChatGroup';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateChatGroupData?: Maybe<CandidateChatGroupData>;
  candidates?: Maybe<Array<ChatUserOrCandidateId>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  chatGroupId: Scalars['String']['output'];
  groupConfigurationId?: Maybe<Scalars['ID']['output']>;
  groupType: ChatGroupType;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  userGroups?: Maybe<Array<ChatUserGroupForGroup>>;
  users?: Maybe<Array<ChatUserOrCandidateForGroup>>;
};

export class ChatGroupConfiguration {
  __typename?: 'ChatGroupConfiguration';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  userGroups?: Maybe<Array<ChatUserGroupForGroup>>;
  users?: Maybe<Array<ChatUserOrCandidateForGroup>>;
};

export class ChatGroupConfigurationCreateInput {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userGroups?: InputMaybe<Array<ChatGroupInput>>;
  users?: InputMaybe<Array<ChatUserOrCandidateCreateInput>>;
};

export class ChatGroupConfigurationDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChatGroupConfigurationGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChatGroupConfigurationListInput {
  organizationId: Scalars['ID']['input'];
};

export class ChatGroupConfigurationUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userGroups?: InputMaybe<Array<ChatGroupInput>>;
  users?: InputMaybe<Array<ChatUserOrCandidateCreateInput>>;
};

export class ChatGroupCreateInput {
  candidateChatGroupData?: InputMaybe<CandidateChatGroupDataInput>;
  candidates?: InputMaybe<Array<ChatUserOrCandidateIdInput>>;
  chatGroupId: Scalars['String']['input'];
  groupConfigurationId?: InputMaybe<Scalars['ID']['input']>;
  groupType: ChatGroupType;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userGroups?: InputMaybe<Array<ChatGroupInput>>;
  users?: InputMaybe<Array<ChatUserOrCandidateCreateInput>>;
};

export class ChatGroupDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChatGroupGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ChatGroupInput {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  role: ChatUserRole;
};

export enum ChatGroupType {
  Configured = 'Configured',
  Custom = 'Custom'
}

export class ChatGroupUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateChatGroupData?: InputMaybe<CandidateChatGroupDataInput>;
  candidates?: InputMaybe<Array<ChatUserOrCandidateIdInput>>;
  chatGroupId: Scalars['String']['input'];
  groupConfigurationId?: InputMaybe<Scalars['ID']['input']>;
  groupType: ChatGroupType;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userGroups?: InputMaybe<Array<ChatGroupInput>>;
  users?: InputMaybe<Array<ChatUserOrCandidateCreateInput>>;
};

export enum ChatMessageRole {
  Assistant = 'Assistant',
  User = 'User'
}

export class ChatPartnerOrganizationInput {
  onlyWithChatEnabled: Scalars['Boolean']['input'];
};

export class ChatPartnerUserGroup {
  __typename?: 'ChatPartnerUserGroup';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class ChatPartnerUserGroupsInput {
  organizationId: Scalars['ID']['input'];
};

export class ChatPartnerUserInput {
  organizationId: Scalars['ID']['input'];
};

export class ChatRequestDto {
  history?: InputMaybe<Array<ConversationHistoryEntryDto>>;
  mentionedTasks?: InputMaybe<Array<ChatRequestMentionDto>>;
  message: Scalars['String']['input'];
  openProposals?: InputMaybe<Array<ChatRequestOpenProposalDto>>;
  organizationId: Scalars['ID']['input'];
  pendingClarificationContinuation?: InputMaybe<PendingClarificationContinuationDto>;
  processModelId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  taskModelId?: InputMaybe<Scalars['ID']['input']>;
  turnId: Scalars['ID']['input'];
};

export class ChatRequestMentionDto {
  displayName: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export class ChatRequestOpenProposalDto {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  kind: Scalars['String']['input'];
  subagentInvocationId: Scalars['ID']['input'];
  summary: Scalars['String']['input'];
  targetItemId?: InputMaybe<Scalars['ID']['input']>;
  targetScope: Scalars['String']['input'];
  targetTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export class ChatSessionInput {
  organizationId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export class ChatSessionReadyEvent {
  __typename?: 'ChatSessionReadyEvent';
  sessionId: Scalars['String']['output'];
};

export class ChatUsage {
  __typename?: 'ChatUsage';
  numberOfUsers: Scalars['String']['output'];
};

export class ChatUser {
  __typename?: 'ChatUser';
  _etag?: Maybe<Scalars['String']['output']>;
  authToken: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  chatUserId: Scalars['String']['output'];
  favoriteChats?: Maybe<Array<ChatConversationReference>>;
  id?: Maybe<Scalars['ID']['output']>;
  mutedChats?: Maybe<Array<ChatConversationReference>>;
  organizationId: Scalars['ID']['output'];
  userOrCandidateId: Scalars['String']['output'];
};

export class ChatUserDeleteConversationInput {
  chatUserId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ChatUserExistsInput {
  createIfNotExists: Scalars['Boolean']['input'];
  user: ChatUserOrCandidateIdInput;
};

export class ChatUserGroupForGroup {
  __typename?: 'ChatUserGroupForGroup';
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  role: ChatUserRole;
};

export class ChatUserOrCandidateCreateInput {
  organizationId: Scalars['String']['input'];
  role: ChatUserRole;
  userOrCandidateId: Scalars['String']['input'];
};

export class ChatUserOrCandidateForGroup {
  __typename?: 'ChatUserOrCandidateForGroup';
  organizationId: Scalars['String']['output'];
  role: ChatUserRole;
  userOrCandidateId: Scalars['String']['output'];
};

export class ChatUserOrCandidateId {
  __typename?: 'ChatUserOrCandidateId';
  organizationId: Scalars['String']['output'];
  userOrCandidateId: Scalars['String']['output'];
};

export class ChatUserOrCandidateIdInput {
  organizationId: Scalars['String']['input'];
  userOrCandidateId: Scalars['String']['input'];
};

export enum ChatUserRole {
  Admin = 'Admin',
  Participant = 'Participant'
}

export class ChatUserToggleFavoriteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  favorite: ChatConversationReferenceInput;
};

export class ChatUserToggleMutedInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  muted: ChatConversationReferenceInput;
};

export class CheckPublicUserByEmailResult {
  __typename?: 'CheckPublicUserByEmailResult';
  auth0Exists: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
};

export enum ClaimSigningSlotFailureReason {
  AlreadyCompletedInDocuSeal = 'AlreadyCompletedInDocuSeal',
  Locked = 'Locked',
  NotClaimable = 'NotClaimable'
}

export class ClaimSigningSlotInput {
  candidateId: Scalars['String']['input'];
  docusealSubmissionId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};

export class ClaimSigningSlotResult {
  __typename?: 'ClaimSigningSlotResult';
  embed?: Maybe<SignerEmbed>;
  failureReason?: Maybe<ClaimSigningSlotFailureReason>;
  submission?: Maybe<SigningSubmissionOutput>;
};

export class ClarificationAnswerInput {
  freeText?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  questionText: Scalars['String']['input'];
  selectedLabel?: InputMaybe<Scalars['String']['input']>;
  selectedValue?: InputMaybe<Scalars['String']['input']>;
  selectedValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ClarificationAnswerPayloadDto {
  freeText?: InputMaybe<Scalars['String']['input']>;
  offeredOptions?: InputMaybe<Array<ClarificationOfferedOptionDto>>;
  questionId: Scalars['ID']['input'];
  questionText: Scalars['String']['input'];
  selectedLabel?: InputMaybe<Scalars['String']['input']>;
  selectedValue?: InputMaybe<Scalars['String']['input']>;
  selectedValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ClarificationMode {
  Confirmation = 'CONFIRMATION',
  MultiSelection = 'MULTI_SELECTION',
  Selection = 'SELECTION'
}

export class ClarificationOfferedOptionDto {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export class ClarificationOption {
  __typename?: 'ClarificationOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class ClarificationQuestion {
  __typename?: 'ClarificationQuestion';
  id: Scalars['String']['output'];
  mode: ClarificationMode;
  options: Array<ClarificationOption>;
  proposedPath?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  searchTerm?: Maybe<Scalars['String']['output']>;
  slotType: Scalars['String']['output'];
};

export class ClarificationRequiredEmitEvent {
  __typename?: 'ClarificationRequiredEmitEvent';
  batchId?: Maybe<Scalars['String']['output']>;
  originalDescription: Scalars['String']['output'];
  questions: Array<ClarificationQuestion>;
  subagentId: Scalars['String']['output'];
  subagentName: Scalars['String']['output'];
  targetItemId?: Maybe<Scalars['String']['output']>;
  targetScope: Scalars['String']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
};

export class Collection {
  __typename?: 'Collection';
  _etag?: Maybe<Scalars['String']['output']>;
  assignedCandidateIds?: Maybe<Array<CandidateId>>;
  assignedCandidates: Array<Candidate>;
  assignedCollectionIds?: Maybe<Array<CollectionId>>;
  assignedCollections: Array<CollectionSlim>;
  assignmentExceptions: Array<CandidateAssignmentException>;
  autoCollectionSettings?: Maybe<AutoCollectionSettingsForUi>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  processes: Array<Process>;
  sharings: Array<Sharing>;
  targetSize?: Maybe<Scalars['Float']['output']>;
  totalCandidates: Scalars['Float']['output'];
  totalCandidatesFromAssignedCollections: Scalars['Float']['output'];
  type?: Maybe<CollectionType>;
};

export class CollectionAccess {
  __typename?: 'CollectionAccess';
  canAccess: Scalars['Boolean']['output'];
  redirectToOrganization?: Maybe<Scalars['ID']['output']>;
};

export class CollectionAccessInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionAndSharing {
  __typename?: 'CollectionAndSharing';
  collection: Collection;
  sharing?: Maybe<Sharing>;
};

export class CollectionAndSharingInput {
  collection: CollectionCreateInput;
  existing?: InputMaybe<CandidatesOfCollectionForViewInput>;
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  sharing?: InputMaybe<SharingForCollectionCreateInput>;
};

export class CollectionAutoFilter {
  __typename?: 'CollectionAutoFilter';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  filters: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  includeSharedCandidates?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CollectionAutoFilterGetInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionAutoFilterSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  includeSharedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplate {
  __typename?: 'CollectionAutoFilterTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters: Scalars['JSONObject']['output'];
  hasCollections: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includeSharedCandidates?: Maybe<Scalars['Boolean']['output']>;
  latestChangedAtWithChildren: Scalars['AnkaadiaDateTime']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  sharingTemplates: Array<SharingTemplate>;
  specialPurpose?: Maybe<CollectionAutoFilterTemplateSpecialPurpose>;
  templateName: Scalars['String']['output'];
};

export class CollectionAutoFilterTemplateAttachInput {
  collectionIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplateDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  deletionBehavior: CollectionAutoFilterTemplateDeletionBehavior;
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum CollectionAutoFilterTemplateDeletionBehavior {
  Delete = 'Delete',
  Detach = 'Detach'
}

export class CollectionAutoFilterTemplateDetachAllInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplateDetachInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplateGetAllInput {
  organizationId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplateGetInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionAutoFilterTemplateSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  includeSharedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  specialPurpose?: InputMaybe<CollectionAutoFilterTemplateSpecialPurpose>;
  templateName: Scalars['String']['input'];
};

export enum CollectionAutoFilterTemplateSpecialPurpose {
  ForApplication = 'ForApplication',
  ForInterview = 'ForInterview'
}

export class CollectionAutoFilterTemplateSyncInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export class CollectionCandidatePageInput {
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  collectionId: Scalars['ID']['input'];
  excludeAssignmentExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCandidatesForPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  selectedSharingId?: InputMaybe<Scalars['ID']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export class CollectionCreateInput {
  autoCollectionSettings?: InputMaybe<AutoCollectionSettingsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  targetSize?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CollectionType>;
};

export class CollectionDefinition {
  __typename?: 'CollectionDefinition';
  collectionType: CollectionKindEnum;
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
};

export class CollectionDefinitionInput {
  collectionType: CollectionKindEnum;
  id: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
};

export class CollectionDeleteInput {
  _etag: Scalars['String']['input'];
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionEmptyStatus {
  __typename?: 'CollectionEmptyStatus';
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
};

export class CollectionEnumerationInput {
  includeEmptyGeneratedCollections?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CollectionEventsInput {
  collectionId: Scalars['ID']['input'];
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionFilterPreset {
  __typename?: 'CollectionFilterPreset';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  filters: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export class CollectionFilterPresetChangeStateInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionFilterPresetCreateInput {
  filters: Scalars['JSONObject']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionFilterPresetDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export class CollectionFilterPresetGetInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export class CollectionFilterPresetListInput {
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export class CollectionFilterPresetUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionForAssignmentInput {
  collectionId: Scalars['ID']['input'];
  fromOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionForDelegationInput {
  collectionId: Scalars['ID']['input'];
  collectionOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionId {
  __typename?: 'CollectionId';
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
};

export class CollectionIdInput {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export class CollectionInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum CollectionKindEnum {
  AutoOrGenerated = 'AutoOrGenerated',
  AutoTemplate = 'AutoTemplate',
  Standard = 'Standard'
}

export class CollectionListDto {
  __typename?: 'CollectionListDTO';
  collection?: Maybe<Array<CollectionListEntry>>;
  orgId: Scalars['String']['output'];
};

export class CollectionListEntry {
  __typename?: 'CollectionListEntry';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type CollectionListEvent = CollectionListDto | ProgressEvent;

export class CollectionListInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum CollectionMethod {
  ChargeAutomatically = 'ChargeAutomatically',
  SendInvoice = 'SendInvoice'
}

export class CollectionQueryInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CollectionSharingByOrgAndTypeInput {
  organizationId: Scalars['ID']['input'];
  sharedTabs?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedToOrganizationId: Scalars['ID']['input'];
  sharingTypes: Array<SharingTypeEnum>;
};

export class CollectionSlim {
  __typename?: 'CollectionSlim';
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  type?: Maybe<CollectionType>;
};

export class CollectionTransferInput {
  autoShareBack: Scalars['Boolean']['input'];
  collectionId: Scalars['ID']['input'];
  keepCandidateCopy: Scalars['Boolean']['input'];
  mask: CandidateTransferMaskInput;
  organizationId: Scalars['ID']['input'];
  targetOrganizationId: Scalars['ID']['input'];
  transferInternalDocuments: Scalars['Boolean']['input'];
};

export class CollectionTransferResult {
  __typename?: 'CollectionTransferResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newCollectionName?: Maybe<Scalars['String']['output']>;
  notTransferredCandidatesDisplayIds?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  transferredCandidatesDisplayIds?: Maybe<Array<Scalars['String']['output']>>;
  validationMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CollectionType {
  Auto = 'Auto',
  FromTemplate = 'FromTemplate',
  Standard = 'Standard'
}

export class CollectionUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  autoCollectionSettings?: InputMaybe<AutoCollectionSettingsInput>;
  creationDate: Scalars['AnkaadiaDateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  targetSize?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CollectionType>;
};

export class CollectionUserGroupMapping {
  __typename?: 'CollectionUserGroupMapping';
  collectionIds: Array<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  userGroupIds: Array<Scalars['ID']['output']>;
};

export class CollectionUserGroupMappingInput {
  collectionIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  userGroupIds: Array<Scalars['ID']['input']>;
};

export class CollectionsForCandidateResult {
  __typename?: 'CollectionsForCandidateResult';
  _etag?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  embedded?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  type?: Maybe<CollectionType>;
};

export class ColumnWidth {
  __typename?: 'ColumnWidth';
  id: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export class ColumnWidthInput {
  id: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export class Comment {
  __typename?: 'Comment';
  _etag?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  comment: Scalars['String']['output'];
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  feedbackId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CommentCreateInput {
  author?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  feedbackId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CommentData {
  __typename?: 'CommentData';
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  multiEditBatchId?: Maybe<Scalars['ID']['output']>;
};

export class CommentDataInput {
  changedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  changedBy?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  multiEditBatchId?: InputMaybe<Scalars['ID']['input']>;
};

export class CommentDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CommentUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  creationDate: Scalars['AnkaadiaDateTime']['input'];
  feedbackId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class Commission {
  __typename?: 'Commission';
  _etag?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  amountType: AmountType;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  originator: Scalars['String']['output'];
  serviceType: ServiceType;
};

export class CommissionBookingDetail {
  __typename?: 'CommissionBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountInfo?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  candidateId?: Maybe<Scalars['String']['output']>;
  candidateOrganizationId?: Maybe<Scalars['String']['output']>;
  commissionId: Scalars['ID']['output'];
  commissionInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CommissionBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CommissionCreditBalanceGetInput {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CompensationType {
  PerHour = 'PerHour',
  PerMonth = 'PerMonth'
}

export enum CompletionState {
  Complete = 'Complete',
  Incomplete = 'Incomplete'
}

export enum CompletionStatus {
  AllRequired = 'allRequired',
  FullyCompleted = 'fullyCompleted',
  IncompatibleFiles = 'incompatibleFiles',
  Incomplete = 'incomplete'
}

export class ConditionDataFormated {
  __typename?: 'ConditionDataFormated';
  conditions?: Maybe<Array<ConditionFormated>>;
  logicOperators?: Maybe<Array<LogicOperatorsFormated>>;
  noConditions: Scalars['Boolean']['output'];
  pathDescription?: Maybe<Scalars['String']['output']>;
};

export class ConditionFormated {
  __typename?: 'ConditionFormated';
  condition: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  parentPath: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ConfigurableTable {
  Bookings = 'Bookings',
  Candidates = 'Candidates',
  CollectionAssignedCandidates = 'CollectionAssignedCandidates',
  ProcessTasksFlat = 'ProcessTasksFlat',
  TranslationOrders = 'TranslationOrders'
}

export class Consent {
  __typename?: 'Consent';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  contents: Scalars['String']['output'];
  contentsAsHtml?: Maybe<Scalars['String']['output']>;
  delta: Scalars['JSONObject']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  language: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  target: UserRole;
};

export class ConsentCreateInput {
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  target: UserRole;
};

export class ConsentDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ConsentForUser {
  browserLanguage?: InputMaybe<Scalars['String']['input']>;
  isCandidate: Scalars['Boolean']['input'];
  isTalentpoolUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  userOrCandidateId: Scalars['ID']['input'];
};

export class ConsentListInput {
  organizationId: Scalars['ID']['input'];
};

export class ConsentRenderedOption {
  __typename?: 'ConsentRenderedOption';
  htmlText: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  language: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export class ConsentRenderedSection {
  __typename?: 'ConsentRenderedSection';
  consentText: Array<ConsentRenderedText>;
  headerText?: Maybe<Array<ConsentRenderedText>>;
};

export class ConsentRenderedText {
  __typename?: 'ConsentRenderedText';
  htmlText: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export class ConsentUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  target: UserRole;
};

export class ConsistencyViolation {
  __typename?: 'ConsistencyViolation';
  blobId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  leadingCount: Scalars['Int']['output'];
  leadingDb: Scalars['String']['output'];
  mismatchedCount: Scalars['Int']['output'];
  mismatchedIds: Array<Scalars['String']['output']>;
  missingInLeading: Array<Scalars['String']['output']>;
  missingInLeadingCount: Scalars['Int']['output'];
  missingInSecondary: Array<Scalars['String']['output']>;
  missingInSecondaryCount: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  postgresQuery?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['String']['output'];
  sampleDiff?: Maybe<Scalars['String']['output']>;
  secondaryCount: Scalars['Int']['output'];
  secondaryDb: Scalars['String']['output'];
};

export enum ContactSharingMode {
  ShareAll = 'ShareAll',
  ShareDefault = 'ShareDefault',
  ShareSelected = 'ShareSelected'
}

export class Contingent {
  __typename?: 'Contingent';
  amount: Scalars['Float']['output'];
  contingentDefinitionId: Scalars['String']['output'];
  contractId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  number: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  purchasedAt: Scalars['AnkaadiaDateTime']['output'];
  usage: Scalars['Float']['output'];
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
};

export class ContingentBookingDetail {
  __typename?: 'ContingentBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPartPayment: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  partPaymentPercentage?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
  referencedBookings?: Maybe<Scalars['String']['output']>;
};

export class ContingentBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ContingentBookingDetailInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  billingTriggerEvent?: InputMaybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPartPayment: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  partPaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceInfo?: InputMaybe<Scalars['String']['input']>;
  referencedBookings?: InputMaybe<Scalars['String']['input']>;
};

export class ContingentCorrectionEntity {
  __typename?: 'ContingentCorrectionEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  contingentId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  month: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  remainingAmount: Scalars['Float']['output'];
  targetOrganizationId: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

export class ContingentCorrectionInput {
  contingentId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  remainingAmount: Scalars['Float']['input'];
  targetOrganizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export class ContingentDefinition {
  __typename?: 'ContingentDefinition';
  availableForMasterUserOnly?: Maybe<Scalars['Boolean']['output']>;
  currency: SupportedBillingCurrency;
  expirationType: ContingentExpirationType;
  id: Scalars['String']['output'];
  isAutomaticOrderDisabled?: Maybe<Scalars['Boolean']['output']>;
  numberOfCandidates: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  purchaseSettings?: Maybe<PurchaseSettings>;
  specializations: Array<CandidateSpecialization>;
};

export class ContingentDefinitionInput {
  availableForMasterUserOnly?: InputMaybe<Scalars['Boolean']['input']>;
  currency: SupportedBillingCurrency;
  expirationType: ContingentExpirationType;
  id: Scalars['String']['input'];
  isAutomaticOrderDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCandidates: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  purchaseSettings?: InputMaybe<PurchaseSettingsInput>;
  specializations: Array<CandidateSpecializationInput>;
};

export class ContingentDefinitionSet {
  __typename?: 'ContingentDefinitionSet';
  bookableContingents?: Maybe<Array<ContingentDefinition>>;
  id: Scalars['String']['output'];
  labelKey: Scalars['String']['output'];
  mandatoryContingents?: Maybe<Array<ContingentDefinition>>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ContingentExpirationType {
  EndOfBillingYear = 'EndOfBillingYear',
  Never = 'Never'
}

export class ContingentPaymentTranche {
  __typename?: 'ContingentPaymentTranche';
  dueDate: Timespan;
  percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export class ContingentPaymentTrancheInput {
  dueDate: TimespanInput;
  percentage: Scalars['Float']['input'];
  type?: Scalars['String']['input'];
};

export class Contract {
  __typename?: 'Contract';
  _etag?: Maybe<Scalars['String']['output']>;
  annulmentDate?: Maybe<Scalars['UTCDate']['output']>;
  billingOfAgedCandidates?: Maybe<BillingOfAgedCandidates>;
  cancellationDate?: Maybe<Scalars['UTCDate']['output']>;
  candidatePaymentSettings: Array<PaymentSettings>;
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  licensePaymentSettings: Array<PaymentSettings>;
  noDoubleBilling?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  ownOrganizationUserPriceRows: Array<UserPriceRow>;
  partnerOrganizationUserPriceRows: Array<UserPriceRow>;
  phases: Array<Phase>;
  recurringFees?: Maybe<Array<RecurringFee>>;
  startDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class ContractActivityParameter {
  __typename?: 'ContractActivityParameter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class ContractChangeAmendmentsInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  noDoubleBilling?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ContractCreateInput {
  billingOfAgedCandidates?: InputMaybe<BillingOfAgedCandidatesInput>;
  candidatePaymentSettings: Array<PaymentSettingsInput>;
  currency: SupportedBillingCurrency;
  licensePaymentSettings: Array<PaymentSettingsInput>;
  noDoubleBilling?: InputMaybe<Scalars['Boolean']['input']>;
  ownOrganizationUserPriceRows: Array<UserPriceRowInput>;
  partnerOrganizationUserPriceRows: Array<UserPriceRowInput>;
  phases: Array<PhaseInput>;
  recurringFees?: InputMaybe<Array<RecurringFeeInput>>;
  startDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class ContractPaymentTranche {
  __typename?: 'ContractPaymentTranche';
  dueDate: DayOfYear;
  percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export class ContractPaymentTrancheInput {
  dueDate: DayOfYearInput;
  percentage: Scalars['Float']['input'];
  type?: Scalars['String']['input'];
};

export class ContractTemplate {
  __typename?: 'ContractTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  allowances?: Maybe<Array<ContractTemplateAllowance>>;
  benefits?: Maybe<Array<ContractTemplateBenefit>>;
  canBeDeleted: Scalars['Boolean']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  compensationRate?: Maybe<Scalars['Float']['output']>;
  compensationType?: Maybe<CompensationType>;
  contractType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<SupportedImmigrationCountry>;
  customLaborAgreement?: Maybe<CustomLaborAgreement>;
  employmentRelationshipType?: Maybe<EmploymentRelationshipType>;
  ezbAdditionalInformation?: Maybe<Scalars['String']['output']>;
  holidayEntitlement?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  laborAgreementSelection?: Maybe<LaborAgreementSelection>;
  name: Scalars['String']['output'];
  noticePeriod?: Maybe<Scalars['Float']['output']>;
  noticePeriodUnit?: Maybe<ContractTermTimePeriod>;
  numberOfSalaries?: Maybe<Scalars['Float']['output']>;
  organizationId: Scalars['ID']['output'];
  otherPaymentRegulation?: Maybe<Scalars['String']['output']>;
  overtimeCompensation?: Maybe<Scalars['String']['output']>;
  overtimeHours?: Maybe<Scalars['Float']['output']>;
  overtimeWithinLimitsPermittedByLaw?: Maybe<Scalars['Boolean']['output']>;
  probationPeriod?: Maybe<Scalars['Float']['output']>;
  probationPeriodUnit?: Maybe<ContractTermTimePeriod>;
  professionDescription?: Maybe<Scalars['String']['output']>;
  professionTitle?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
  variableCompensationRate?: Maybe<Scalars['Float']['output']>;
  workSchedule?: Maybe<Scalars['String']['output']>;
  workingHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  workingTimeType?: Maybe<WorkingTimeTypeEnum>;
};

export class ContractTemplateAllowance {
  __typename?: 'ContractTemplateAllowance';
  amount?: Maybe<Scalars['Float']['output']>;
  calculationBasis?: Maybe<CalculationBasis>;
  comment?: Maybe<Scalars['String']['output']>;
  customType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export class ContractTemplateAllowanceInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  calculationBasis?: InputMaybe<CalculationBasis>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export class ContractTemplateBenefit {
  __typename?: 'ContractTemplateBenefit';
  amount?: Maybe<Scalars['Float']['output']>;
  calculationBasis?: Maybe<CalculationBasis>;
  id: Scalars['ID']['output'];
  timeInterval?: Maybe<BenefitTimeInterval>;
  type: Scalars['String']['output'];
};

export class ContractTemplateBenefitInput {
  amount?: InputMaybe<Scalars['Float']['input']>;
  calculationBasis?: InputMaybe<CalculationBasis>;
  id: Scalars['ID']['input'];
  timeInterval?: InputMaybe<BenefitTimeInterval>;
  type: Scalars['String']['input'];
};

export class ContractTemplateDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ContractTemplateGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ContractTemplateListInput {
  country?: InputMaybe<SupportedImmigrationCountry>;
  includeRootOrg?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ContractTemplateSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowances?: InputMaybe<Array<ContractTemplateAllowanceInput>>;
  benefits?: InputMaybe<Array<ContractTemplateBenefitInput>>;
  compensationRate?: InputMaybe<Scalars['Float']['input']>;
  compensationType?: InputMaybe<CompensationType>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<SupportedImmigrationCountry>;
  customLaborAgreement?: InputMaybe<CustomLaborAgreementInput>;
  employmentRelationshipType?: InputMaybe<EmploymentRelationshipType>;
  ezbAdditionalInformation?: InputMaybe<Scalars['String']['input']>;
  holidayEntitlement?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  laborAgreementSelection?: InputMaybe<LaborAgreementSelectionInput>;
  name: Scalars['String']['input'];
  noticePeriod?: InputMaybe<Scalars['Float']['input']>;
  noticePeriodUnit?: InputMaybe<ContractTermTimePeriod>;
  numberOfSalaries?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['ID']['input'];
  otherPaymentRegulation?: InputMaybe<Scalars['String']['input']>;
  overtimeCompensation?: InputMaybe<Scalars['String']['input']>;
  overtimeHours?: InputMaybe<Scalars['Float']['input']>;
  overtimeWithinLimitsPermittedByLaw?: InputMaybe<Scalars['Boolean']['input']>;
  probationPeriod?: InputMaybe<Scalars['Float']['input']>;
  probationPeriodUnit?: InputMaybe<ContractTermTimePeriod>;
  professionDescription?: InputMaybe<Scalars['String']['input']>;
  professionTitle?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
  variableCompensationRate?: InputMaybe<Scalars['Float']['input']>;
  workSchedule?: InputMaybe<Scalars['String']['input']>;
  workingHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  workingTimeType?: InputMaybe<WorkingTimeTypeEnum>;
};

export enum ContractTemplateSharingMode {
  ShareAll = 'ShareAll',
  ShareSelected = 'ShareSelected'
}

export enum ContractTermTimePeriod {
  Months = 'Months',
  Weeks = 'Weeks'
}

export class ConversationHistoryEntryDto {
  content: Scalars['String']['input'];
  role: ChatMessageRole;
};

export class ConvertManyDocumentsInput {
  candidateId: Scalars['ID']['input'];
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  requiredDocumentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  requiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CopyDataTypeEnum {
  All = 'All',
  AutoListTemplates = 'AutoListTemplates',
  Documents = 'Documents',
  Emails = 'Emails',
  RequiredDocuments = 'RequiredDocuments',
  SendOutRules = 'SendOutRules',
  Templates = 'Templates'
}

export class CopyResult {
  __typename?: 'CopyResult';
  failedCopies: Array<Scalars['String']['output']>;
  successfulCopies: Array<Scalars['String']['output']>;
};

export class CourseEventsInput {
  courseId: Scalars['ID']['input'];
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CourseExamDataEvent {
  __typename?: 'CourseExamDataEvent';
  candidateId: Scalars['ID']['output'];
  candidateStatus?: Maybe<CandidateStatus>;
  country?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateOrDateTime']['output'];
  dateEnd?: Maybe<Scalars['DateOrDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  examId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
};

export class CreatableInvoice {
  __typename?: 'CreatableInvoice';
  billingPeriodEndDate: Scalars['UTCDate']['output'];
  billingPeriodStartDate: Scalars['UTCDate']['output'];
  invoiceType: InvoiceType;
};

export class CreatableInvoiceForOrganization {
  __typename?: 'CreatableInvoiceForOrganization';
  billingPeriodEndDate: Scalars['UTCDate']['output'];
  billingPeriodStartDate: Scalars['UTCDate']['output'];
  invoiceType: InvoiceType;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

export class CreateApplicationMaskResponse {
  __typename?: 'CreateApplicationMaskResponse';
  candidateDisplayId: Scalars['String']['output'];
  candidateId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export class CreateApplicationMaskUploadUrl {
  __typename?: 'CreateApplicationMaskUploadUrl';
  tempUploadId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export class CreateCommissionInput {
  amount: Scalars['Float']['input'];
  amountType: AmountType;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  currency: SupportedBillingCurrency;
  organizationId: Scalars['ID']['input'];
  originator: Scalars['String']['input'];
  serviceType: ServiceType;
};

export class CreateCustomContingentDefinitionSetInput {
  bookableContingents?: InputMaybe<Array<ContingentDefinitionInput>>;
  mandatoryContingents?: InputMaybe<Array<ContingentDefinitionInput>>;
  name: Scalars['String']['input'];
};

export class CreateCustomPlanInput {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  candidatePrice: CandidatePriceInput;
  currency: SupportedBillingCurrency;
  labelKey: Scalars['String']['input'];
  licensePrice: LicensePriceInput;
  name: Scalars['String']['input'];
  type: PlanType;
};

export class CreateManualBookingInput {
  accrualTreatment?: InputMaybe<AccrualTreatment>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<AmountType>;
  billingEvent?: InputMaybe<BillingEventType>;
  bookedBy?: InputMaybe<Scalars['String']['input']>;
  bookingText: Scalars['String']['input'];
  bookingType: BookingType;
  candidateId?: InputMaybe<CandidateIdInput>;
  commissionId?: InputMaybe<Scalars['String']['input']>;
  contingentId?: InputMaybe<Scalars['String']['input']>;
  contingentNumber?: InputMaybe<Scalars['String']['input']>;
  creditNoteId?: InputMaybe<Scalars['String']['input']>;
  currency: SupportedBillingCurrency;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentId?: InputMaybe<Scalars['String']['input']>;
  recurringFeeId?: InputMaybe<Scalars['String']['input']>;
  referencedBookingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  revenueCategory?: InputMaybe<RevenueCategory>;
  serviceEndDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  serviceStartDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  sign: Scalars['String']['input'];
  targetInvoiceType?: InputMaybe<InvoiceType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  valueDate: Scalars['AnkaadiaDateTime']['input'];
};

export class CreateManualBookingResult {
  __typename?: 'CreateManualBookingResult';
  booking?: Maybe<BillingAccount>;
  error?: Maybe<Scalars['String']['output']>;
};

export class CreatePublicTalentpoolRequestingOrganizationAndUserInput {
  captchaToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  salutation: UserSalutation;
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
};

export class CreatePublicTalentpoolRequestingOrganizationAndUserResult {
  __typename?: 'CreatePublicTalentpoolRequestingOrganizationAndUserResult';
  firstLoginUrl: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
};

export class CreatedCollectionsOfAutoFilterTemplateGetInput {
  id: Scalars['ID']['input'];
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CredentialsInput {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  recipeId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export class CredentialsUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  recipeId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};

export class CreditNote {
  __typename?: 'CreditNote';
  _etag?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  creditNoteNumber: Scalars['String']['output'];
  currency: SupportedBillingCurrency;
  effectiveAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId: Scalars['String']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  status?: Maybe<CreditNoteStatus>;
  stripeCreditNoteId: Scalars['String']['output'];
};

export class CreditNoteBookingDetail {
  __typename?: 'CreditNoteBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  bookingId: Scalars['ID']['output'];
  creditNoteId: Scalars['ID']['output'];
  creditNoteNumber: Scalars['String']['output'];
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoiceType: InvoiceType;
  memo?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  referencedBookings?: Maybe<Array<Scalars['String']['output']>>;
  valueDate: Scalars['AnkaadiaDateTime']['output'];
};

export class CreditNoteBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class CreditNoteBookingDetailInput {
  referencedBookings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CreditNoteStatus {
  Issued = 'Issued',
  Void = 'Void'
}

export class CustomContingentDefinitionSet {
  __typename?: 'CustomContingentDefinitionSet';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  bookableContingents?: Maybe<Array<ContingentDefinition>>;
  id?: Maybe<Scalars['ID']['output']>;
  labelKey: Scalars['String']['output'];
  mandatoryContingents?: Maybe<Array<ContingentDefinition>>;
  name: Scalars['String']['output'];
};

export class CustomLaborAgreement {
  __typename?: 'CustomLaborAgreement';
  collectiveAgreement?: Maybe<Scalars['String']['output']>;
  salaryGroup?: Maybe<Scalars['String']['output']>;
};

export class CustomLaborAgreementInput {
  collectiveAgreement?: InputMaybe<Scalars['String']['input']>;
  salaryGroup?: InputMaybe<Scalars['String']['input']>;
};

export class CustomPlan {
  __typename?: 'CustomPlan';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  candidatePrice: CandidatePrice;
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  labelKey: Scalars['String']['output'];
  licensePrice: LicensePrice;
  name?: Maybe<Scalars['String']['output']>;
  type: PlanType;
};

export class CustomSkillSet {
  __typename?: 'CustomSkillSet';
  additionalInformationLabel?: Maybe<Scalars['String']['output']>;
  additionalInformationTypes?: Maybe<Array<ProfessionalFieldAdditionalInformationType>>;
  description: Scalars['String']['output'];
  preferredLabel: Scalars['String']['output'];
  requireAdditionalInformation?: Maybe<Scalars['Boolean']['output']>;
  skillType: OccupationSkillType;
  skills?: Maybe<Array<OccupationSkill>>;
};

export class CustomSkillSetInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  professionId: Scalars['String']['input'];
};

export class Customer {
  __typename?: 'Customer';
  balance?: Maybe<Scalars['Float']['output']>;
  billingAddress: BillingAddress;
  currency?: Maybe<Scalars['String']['output']>;
  debitorId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceReminderEmail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  taxExempt: Scalars['Boolean']['output'];
};

export class CustomerResult {
  __typename?: 'CustomerResult';
  customer?: Maybe<Customer>;
  errors: Array<StripeErrorMessageKeys>;
};

export class CvParsingAddOnConfig {
  __typename?: 'CvParsingAddOnConfig';
  _etag?: Maybe<Scalars['String']['output']>;
  allowBackgroundExtraction?: Maybe<Scalars['Boolean']['output']>;
  allowDirectExtractionViaUI?: Maybe<Scalars['Boolean']['output']>;
  availableForCandidates?: Maybe<Scalars['Boolean']['output']>;
  availableForOwnOrganization?: Maybe<Scalars['Boolean']['output']>;
  availableForPartnerOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  backgroundExtractionDocumentTypes?: Maybe<Array<Scalars['String']['output']>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  monthlyBudget?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class CvParsingAddOnConfigGetInput {
  organizationId: Scalars['ID']['input'];
};

export class CvParsingAddOnConfigSetInput {
  allowBackgroundExtraction?: InputMaybe<Scalars['Boolean']['input']>;
  allowDirectExtractionViaUI?: InputMaybe<Scalars['Boolean']['input']>;
  availableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  availableForOwnOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  availableForPartnerOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  backgroundExtractionDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  monthlyBudget?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class CvParsingConsumption {
  __typename?: 'CvParsingConsumption';
  currency?: Maybe<SupportedBillingCurrency>;
  includedFreeParsings: Scalars['Int']['output'];
  monthlyBudget?: Maybe<Scalars['Int']['output']>;
  remainingFreeParsings: Scalars['Int']['output'];
  unitPrice?: Maybe<Scalars['Float']['output']>;
  usedFreeParsings: Scalars['Int']['output'];
};

export class DailyEducationCourseAttendance {
  __typename?: 'DailyEducationCourseAttendance';
  day1?: Maybe<AttendanceEntry>;
  day2?: Maybe<AttendanceEntry>;
  day3?: Maybe<AttendanceEntry>;
  day4?: Maybe<AttendanceEntry>;
  day5?: Maybe<AttendanceEntry>;
  day6?: Maybe<AttendanceEntry>;
  day7?: Maybe<AttendanceEntry>;
};

export class DailyEducationCourseAttendanceInput {
  day1?: InputMaybe<AttendanceEntryInput>;
  day2?: InputMaybe<AttendanceEntryInput>;
  day3?: InputMaybe<AttendanceEntryInput>;
  day4?: InputMaybe<AttendanceEntryInput>;
  day5?: InputMaybe<AttendanceEntryInput>;
  day6?: InputMaybe<AttendanceEntryInput>;
  day7?: InputMaybe<AttendanceEntryInput>;
};

export class DailyEducationCoursePerformance {
  __typename?: 'DailyEducationCoursePerformance';
  day1?: Maybe<PerformanceEntry>;
  day2?: Maybe<PerformanceEntry>;
  day3?: Maybe<PerformanceEntry>;
  day4?: Maybe<PerformanceEntry>;
  day5?: Maybe<PerformanceEntry>;
  day6?: Maybe<PerformanceEntry>;
  day7?: Maybe<PerformanceEntry>;
};

export class DailyEducationCoursePerformanceInput {
  day1?: InputMaybe<PerformanceEntryInput>;
  day2?: InputMaybe<PerformanceEntryInput>;
  day3?: InputMaybe<PerformanceEntryInput>;
  day4?: InputMaybe<PerformanceEntryInput>;
  day5?: InputMaybe<PerformanceEntryInput>;
  day6?: InputMaybe<PerformanceEntryInput>;
  day7?: InputMaybe<PerformanceEntryInput>;
};

export class DashboardAnkaadiaUpdates {
  __typename?: 'DashboardAnkaadiaUpdates';
  metricType: MetricType;
  releases: Array<AnkaadiaRelease>;
};

export class DashboardBirthdays {
  __typename?: 'DashboardBirthdays';
  candidates: Array<BirthDayCandidate>;
  metricType: MetricType;
};

export class DashboardCandidateBirthdayData {
  __typename?: 'DashboardCandidateBirthdayData';
  candidateId: Scalars['ID']['output'];
  date: Scalars['DateOrDateTime']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class DashboardCandidateEventData {
  __typename?: 'DashboardCandidateEventData';
  date: Scalars['DateOrDateTime']['output'];
  displayName: Scalars['String']['output'];
  documentSetName?: Maybe<Scalars['String']['output']>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
};

export class DashboardCount {
  __typename?: 'DashboardCount';
  days: Scalars['Float']['output'];
  metricType: MetricType;
  value: Scalars['Float']['output'];
};

export class DashboardCountPerDay {
  __typename?: 'DashboardCountPerDay';
  days: Scalars['Float']['output'];
  metricType: MetricType;
  values: Array<Scalars['Float']['output']>;
};

export type DashboardMetric = DashboardAnkaadiaUpdates | DashboardBirthdays | DashboardCount | DashboardCountPerDay;

export class DashboardMetricInput {
  organizationId: Scalars['ID']['input'];
};

export enum DashboardVisibilityOptions {
  Candidate = 'Candidate',
  Employer = 'Employer',
  OwnOrganization = 'OwnOrganization',
  Partner = 'Partner',
  Subsidiary = 'Subsidiary'
}

export class DashboardWidget {
  __typename?: 'DashboardWidget';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  hasOwnLogo: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  logoSize: DashboardWidgetLogoSize;
  organizationId: Scalars['ID']['output'];
  organizationLogoUrl?: Maybe<Scalars['String']['output']>;
  ownLogoUrl?: Maybe<Scalars['String']['output']>;
  widgets: Array<DashboardWidgetItem>;
};

export enum DashboardWidgetAudience {
  Candidates = 'Candidates',
  OwnOrganization = 'OwnOrganization',
  PartnerOrganizations = 'PartnerOrganizations',
  SubOrganizations = 'SubOrganizations'
}

export class DashboardWidgetGetInput {
  organizationId: Scalars['ID']['input'];
};

export class DashboardWidgetItem {
  __typename?: 'DashboardWidgetItem';
  audiences: Array<DashboardWidgetAudience>;
  cooperationTypes?: Maybe<Array<Scalars['String']['output']>>;
  dashboardWidgetLinks?: Maybe<Array<DashboardWidgetLink>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  texts: Array<DashboardWidgetLocalizedText>;
};

export class DashboardWidgetItemInput {
  audiences: Array<DashboardWidgetAudience>;
  cooperationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  dashboardWidgetLinks?: InputMaybe<Array<DashboardWidgetLinkInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  texts: Array<DashboardWidgetLocalizedTextInput>;
};

export class DashboardWidgetLink {
  __typename?: 'DashboardWidgetLink';
  linkText?: Maybe<Array<DashboardWidgetLocalizedLinkText>>;
  linkUrl?: Maybe<Scalars['String']['output']>;
};

export class DashboardWidgetLinkInput {
  linkText?: InputMaybe<Array<DashboardWidgetLocalizedLinkTextInput>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
};

export class DashboardWidgetLinkView {
  __typename?: 'DashboardWidgetLinkView';
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl: Scalars['String']['output'];
};

export class DashboardWidgetLocalizedLinkText {
  __typename?: 'DashboardWidgetLocalizedLinkText';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class DashboardWidgetLocalizedLinkTextInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export class DashboardWidgetLocalizedText {
  __typename?: 'DashboardWidgetLocalizedText';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class DashboardWidgetLocalizedTextInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum DashboardWidgetLogoSize {
  Large = 'Large',
  Standard = 'Standard'
}

export class DashboardWidgetSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  hasOwnLogo: Scalars['Boolean']['input'];
  logoSize: DashboardWidgetLogoSize;
  organizationId: Scalars['ID']['input'];
  widgets: Array<DashboardWidgetItemInput>;
};

export class DashboardWidgetView {
  __typename?: 'DashboardWidgetView';
  dashboardWidgetLinks: Array<DashboardWidgetLinkView>;
  logoSize: DashboardWidgetLogoSize;
  logoUrl?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  textHtml?: Maybe<Scalars['String']['output']>;
  widgetId: Scalars['ID']['output'];
};

export class DataStrategyConfigurationDescription {
  __typename?: 'DataStrategyConfigurationDescription';
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  strategyId: Scalars['String']['output'];
};

export class DataStrategyConfigurationDescriptionInput {
  configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  strategyId: Scalars['String']['input'];
};

export class DataStrategyGenerationDescription {
  configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  strategyId: Scalars['String']['input'];
};

export class DatabaseConfiguration {
  __typename?: 'DatabaseConfiguration';
  consistencyHashMode: Scalars['String']['output'];
  cosmosDbName?: Maybe<Scalars['String']['output']>;
  leadingDatabase: Scalars['String']['output'];
  pgPools: Array<PgPoolStats>;
  postgresDbName?: Maybe<Scalars['String']['output']>;
  postgresEnabled: Scalars['Boolean']['output'];
  postgresLeadingOvercommit: Scalars['Boolean']['output'];
  postgresLegacyEnvVars: Array<Scalars['String']['output']>;
  postgresSemaphoreOvercommit: Scalars['Boolean']['output'];
};

export class DatabaseConnectionStats {
  __typename?: 'DatabaseConnectionStats';
  activeParallelWriteTransactions: Scalars['Int']['output'];
  consistencyHashMode: Scalars['String']['output'];
  cosmosDbName?: Maybe<Scalars['String']['output']>;
  leadingDatabase: Scalars['String']['output'];
  parallelWrite: SemaphoreStats;
  pgLeading: Array<PgLeadingLimiterStats>;
  pgPools: Array<PgPoolStats>;
  poolConnections: Array<PoolConnectionStats>;
  postgresDbName?: Maybe<Scalars['String']['output']>;
  postgresEnabled: Scalars['Boolean']['output'];
  postgresLeadingOvercommit: Scalars['Boolean']['output'];
  postgresLegacyEnvVars: Array<Scalars['String']['output']>;
  postgresSemaphoreOvercommit: Scalars['Boolean']['output'];
  processHealth: ProcessHealthStats;
  secondaryRead: SemaphoreStats;
  secondaryWrite: SemaphoreStats;
  shadowRead: ShadowReadStats;
};

export class DateOrDateRangeInput {
  dateEnd?: InputMaybe<DateWithTimeInput>;
  dateStart?: InputMaybe<DateWithTimeInput>;
  hasRange?: InputMaybe<Scalars['Boolean']['input']>;
};

export class DateTimeOrRange {
  __typename?: 'DateTimeOrRange';
  dateEnd?: Maybe<DateWithTime>;
  dateStart?: Maybe<DateWithTime>;
  hasRange?: Maybe<Scalars['Boolean']['output']>;
};

export class DateWithTime {
  __typename?: 'DateWithTime';
  date?: Maybe<Scalars['DateOrDateTime']['output']>;
  hasTime?: Maybe<Scalars['Boolean']['output']>;
};

export class DateWithTimeInput {
  date?: InputMaybe<Scalars['DateOrDateTime']['input']>;
  hasTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export class DayOfYear {
  __typename?: 'DayOfYear';
  day: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
};

export class DayOfYearInput {
  day: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
};

export class DegressionRow {
  __typename?: 'DegressionRow';
  amount: Scalars['Float']['output'];
  from: Scalars['Float']['output'];
};

export class DegressionRowInput {
  amount: Scalars['Float']['input'];
  from: Scalars['Float']['input'];
};

export class DelayStartActivationInfo {
  __typename?: 'DelayStartActivationInfo';
  delayStartByDays: Scalars['Float']['output'];
  delayStartFrom?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  delayStartUntil?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  isActivated: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
};

export class DelegatedTaskItem {
  __typename?: 'DelegatedTaskItem';
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  delegations: Array<TaskDelegation>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  processId: Scalars['String']['output'];
};

export class DelegatedTaskListInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class DeleteAccrualSnapshotsFromMonthInput {
  fromMonth: Scalars['UTCDate']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class DeleteAccrualSnapshotsInput {
  ids: Array<Scalars['ID']['input']>;
};

export class DeleteAiChatSessionInput {
  id: Scalars['ID']['input'];
};

export class DeleteCustomContingentDefinitionSetInput {
  _etag: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export class DeleteCustomPlanInput {
  _etag: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export class DeleteUserInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  cascadeToPartnerOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DeleteUserPriceInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export class DerivableProcessModelDeclarationGetInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class DetachProcessFromActionInput {
  actionId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};

export class DetectedDocumentLanguage {
  __typename?: 'DetectedDocumentLanguage';
  accuracy: Scalars['Float']['output'];
  language: Scalars['String']['output'];
};

export class DiplomaticMission {
  __typename?: 'DiplomaticMission';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leader?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  misc?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export class DiplomaticMissionInput {
  country?: InputMaybe<Scalars['String']['input']>;
  immigrationCountry: SupportedImmigrationCountry;
};

export class Discount {
  __typename?: 'Discount';
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  id: Scalars['ID']['output'];
  maxUses?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['UTCDate']['output'];
  type: DiscountType;
  value: Scalars['Float']['output'];
};

export class DiscountInput {
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  maxUses?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['UTCDate']['input'];
  type: DiscountType;
  value: Scalars['Float']['input'];
};

export enum DiscountType {
  Absolute = 'Absolute',
  Percentage = 'Percentage'
}

export class DocTypeAttachment {
  __typename?: 'DocTypeAttachment';
  docOrganizationRole?: Maybe<Scalars['String']['output']>;
  documentTag?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
};

export class DocTypeAttachmentInput {
  docOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  documentTag?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
};

export class Document {
  __typename?: 'Document';
  _etag?: Maybe<Scalars['String']['output']>;
  alwaysGenerate?: Maybe<Scalars['Boolean']['output']>;
  availableForCandidates?: Maybe<Scalars['Boolean']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  completionState?: Maybe<CompletionState>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentGenerationLanguageHandling?: Maybe<DocumentGenerationLanguageHandling>;
  documentSets?: Maybe<Array<DocumentSet>>;
  familyMemberId?: Maybe<Scalars['ID']['output']>;
  freeFormatFiles?: Maybe<Array<DocumentFreeFormatFile>>;
  generationMode?: Maybe<DocumentGenerationMode>;
  generationStrategy?: Maybe<DataStrategyConfigurationDescription>;
  hasTranslationOrders?: Maybe<Scalars['Boolean']['output']>;
  hideCandidateNameInFileName?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includeProcessData?: Maybe<Scalars['Boolean']['output']>;
  isInternalByRequirement: Scalars['Boolean']['output'];
  isInternalDocument?: Maybe<Scalars['Boolean']['output']>;
  isTranslationPending?: Maybe<Scalars['Boolean']['output']>;
  lockState?: Maybe<DocumentLockMode>;
  lockTimeStamp?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lockingOrganizationId?: Maybe<Scalars['ID']['output']>;
  mode: DocumentMode;
  organizationId: Scalars['ID']['output'];
  selectionCriteria?: Maybe<Array<DocumentSelectionCriterion>>;
  sharedToOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  signingConfig?: Maybe<DocumentSigningConfig>;
  templateMode?: Maybe<DocumentTemplateMode>;
  throwErrorOnNoSelection?: Maybe<Scalars['Boolean']['output']>;
  touchedOnlyByCandidate: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export enum DocumentAccess {
  None = 'None',
  ReadDocument = 'ReadDocument',
  ReadDocumentAndReadWriteMetadata = 'ReadDocumentAndReadWriteMetadata',
  ReadDocumentWhenNotInternal = 'ReadDocumentWhenNotInternal',
  ReadDocumentWhenNotInternalAndReadWriteMetadata = 'ReadDocumentWhenNotInternalAndReadWriteMetadata',
  ReadWriteDocument = 'ReadWriteDocument',
  ReadWriteDocumentWhenNotInternal = 'ReadWriteDocumentWhenNotInternal',
  ReadWriteMetadata = 'ReadWriteMetadata'
}

export class DocumentAccessInfo {
  __typename?: 'DocumentAccessInfo';
  access: DocumentAccess;
};

export class DocumentAiExtractionInput {
  blobName: Scalars['String']['input'];
  candidateId?: InputMaybe<CandidateIdInput>;
  collectionId?: InputMaybe<CollectionIdInput>;
  fileName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
  selectedSharingId?: InputMaybe<Scalars['ID']['input']>;
};

export class DocumentAiExtractionResult {
  __typename?: 'DocumentAiExtractionResult';
  data?: Maybe<DocumentAiExtractionResultData>;
  done: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  requestId: Scalars['ID']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export class DocumentAiExtractionResultData {
  __typename?: 'DocumentAiExtractionResultData';
  candidateId?: Maybe<CandidateId>;
  candidateOrFamilyMemberFullName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  familyMemberId?: Maybe<Scalars['ID']['output']>;
  localizedDocumentType?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  requestId: Scalars['ID']['output'];
};

export class DocumentAiPerformanceCreateInput {
  organizationId: Scalars['ID']['input'];
  performanceEntries: Array<DocumentAiPerformanceInput>;
};

export class DocumentAiPerformanceInput {
  candidateId: CandidateIdInput;
  documentSetId?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  fileId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  predictedCandidateId?: InputMaybe<CandidateIdInput>;
  predictedDocumentType?: InputMaybe<Scalars['String']['input']>;
  predictedFamilyMemberId?: InputMaybe<Scalars['ID']['input']>;
  predictionFinished: Scalars['Boolean']['input'];
  predictionSuccess: Scalars['Boolean']['input'];
};

export class DocumentAiUploadInput {
  blob: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  timeSpanInHours?: InputMaybe<Scalars['Float']['input']>;
};

export class DocumentAiUrl {
  __typename?: 'DocumentAiUrl';
  containerName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export class DocumentAiUrlInput {
  containerName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export class DocumentCandidateStatus {
  __typename?: 'DocumentCandidateStatus';
  additionalFormatsInDocumentSets?: Maybe<Array<DocumentRelatedFormats>>;
  candidateId: Scalars['ID']['output'];
  candidateOrgId: Scalars['ID']['output'];
  completionState?: Maybe<CompletionState>;
  missingFormats?: Maybe<Array<Scalars['String']['output']>>;
  missingPhysicalFormats?: Maybe<Array<Scalars['String']['output']>>;
  status: DocumentStatusEnum;
};

export class DocumentConfigFormat {
  __typename?: 'DocumentConfigFormat';
  count?: Maybe<Scalars['Float']['output']>;
  requiredDeliveryFormats?: Maybe<Array<DocumentDeliveryFormat>>;
  value?: Maybe<Scalars['String']['output']>;
};

export class DocumentConfigFormatInput {
  count?: InputMaybe<Scalars['Float']['input']>;
  requiredDeliveryFormats?: InputMaybe<Array<DocumentDeliveryFormat>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export class DocumentConfigurationAt implements DocumentConfigurationBase {
  __typename?: 'DocumentConfigurationAT';
  alternatives: Array<DocumentConfigurationAlternative>;
  countryOfHabitualResidence?: Maybe<Array<Scalars['String']['output']>>;
  countryOfOrigin: Array<Scalars['String']['output']>;
  employerAfterRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  employerBeforeRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  federalStateDestination: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  legalBasis?: Maybe<Array<Scalars['String']['output']>>;
  minAlternatives?: Maybe<Scalars['Float']['output']>;
  notNecessary: Scalars['Boolean']['output'];
  pathOfRecognition?: Maybe<Array<Scalars['String']['output']>>;
  profession: Array<Scalars['String']['output']>;
  qualification: Array<Scalars['String']['output']>;
  targetRecognition?: Maybe<Array<Scalars['String']['output']>>;
};

export class DocumentConfigurationAlternative {
  __typename?: 'DocumentConfigurationAlternative';
  documentFormat?: Maybe<Array<DocumentConfigFormat>>;
  documentFormatOther?: Maybe<Array<DocumentConfigFormat>>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
};

export class DocumentConfigurationAlternativeInput {
  documentFormat?: InputMaybe<Array<DocumentConfigFormatInput>>;
  documentFormatOther?: InputMaybe<Array<DocumentConfigFormatInput>>;
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
};

export interface DocumentConfigurationBase {
  alternatives: Array<DocumentConfigurationAlternative>;
  countryOfOrigin: Array<Scalars['String']['output']>;
  employerAfterRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  employerBeforeRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  federalStateDestination: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  minAlternatives?: Maybe<Scalars['Float']['output']>;
  notNecessary: Scalars['Boolean']['output'];
  profession: Array<Scalars['String']['output']>;
  qualification: Array<Scalars['String']['output']>;
}

export class DocumentConfigurationDe implements DocumentConfigurationBase {
  __typename?: 'DocumentConfigurationDE';
  alternatives: Array<DocumentConfigurationAlternative>;
  countryOfHabitualResidence?: Maybe<Array<Scalars['String']['output']>>;
  countryOfOrigin: Array<Scalars['String']['output']>;
  diplomaticMission?: Maybe<Array<Scalars['String']['output']>>;
  employerAfterRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  employerBeforeRecognitionIds?: Maybe<Array<Scalars['String']['output']>>;
  equivalenceTest?: Maybe<Array<Scalars['String']['output']>>;
  federalStateDestination: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  minAlternatives?: Maybe<Scalars['Float']['output']>;
  notNecessary: Scalars['Boolean']['output'];
  profession: Array<Scalars['String']['output']>;
  qualification: Array<Scalars['String']['output']>;
  recognitionType?: Maybe<Array<Scalars['String']['output']>>;
  residencePermit?: Maybe<Array<Scalars['String']['output']>>;
};

export class DocumentConfigurationInput {
  alternatives: Array<DocumentConfigurationAlternativeInput>;
  countryOfHabitualResidence?: InputMaybe<Array<Scalars['String']['input']>>;
  countryOfOrigin: Array<Scalars['String']['input']>;
  diplomaticMission?: InputMaybe<Array<Scalars['String']['input']>>;
  employerAfterRecognitionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  employerBeforeRecognitionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  equivalenceTest?: InputMaybe<Array<Scalars['String']['input']>>;
  federalStateDestination: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  legalBasis?: InputMaybe<Array<Scalars['String']['input']>>;
  minAlternatives?: InputMaybe<Scalars['Float']['input']>;
  notNecessary: Scalars['Boolean']['input'];
  pathOfRecognition?: InputMaybe<Array<Scalars['String']['input']>>;
  profession: Array<Scalars['String']['input']>;
  qualification: Array<Scalars['String']['input']>;
  recognitionType?: InputMaybe<Array<Scalars['String']['input']>>;
  residencePermit?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRecognition?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentConfigurationResultType = DocumentConfigurationAt | DocumentConfigurationDe;

export class DocumentCreateInput {
  alwaysGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  availableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completionState?: InputMaybe<CompletionState>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentGenerationLanguageHandling?: InputMaybe<DocumentGenerationLanguageHandling>;
  documentSets?: InputMaybe<Array<DocumentSetInput>>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  freeFormatFiles?: InputMaybe<Array<DocumentFreeFormatFileInput>>;
  generationMode?: InputMaybe<DocumentGenerationMode>;
  generationStrategy?: InputMaybe<DataStrategyConfigurationDescriptionInput>;
  hideCandidateNameInFileName?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreConcurrencyError?: InputMaybe<Scalars['Boolean']['input']>;
  includeProcessData?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalDocument?: InputMaybe<Scalars['Boolean']['input']>;
  lockState?: InputMaybe<DocumentLockMode>;
  lockTimeStamp?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lockingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  mode: DocumentMode;
  organizationId: Scalars['ID']['input'];
  selectionCriteria?: InputMaybe<Array<DocumentSelectionCriterion>>;
  sharedToOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  signingConfig?: InputMaybe<DocumentSigningConfigInput>;
  templateMode?: InputMaybe<DocumentTemplateMode>;
  throwErrorOnNoSelection?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  writeMode: DocumentWriteMode;
};

export class DocumentDataEvent {
  __typename?: 'DocumentDataEvent';
  candidateId: Scalars['ID']['output'];
  candidateStatus?: Maybe<CandidateStatus>;
  country?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateOrDateTime']['output'];
  dateEnd?: Maybe<Scalars['DateOrDateTime']['output']>;
  displayId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  documentField: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentSetName?: Maybe<Scalars['String']['output']>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  isDefaultSet: Scalars['Boolean']['output'];
  isInternalDocument?: Maybe<Scalars['Boolean']['output']>;
  isShared: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  resubmissionReason?: Maybe<Scalars['String']['output']>;
};

export class DocumentDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum DocumentDeliveryFormat {
  Digital = 'Digital',
  Paper = 'Paper'
}

export class DocumentFile {
  __typename?: 'DocumentFile';
  blob: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  docusealSubmissionId?: Maybe<Scalars['Int']['output']>;
  isInTranslation?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  selectionValues?: Maybe<Array<Array<Scalars['String']['output']>>>;
  signingRoles?: Maybe<Array<Scalars['String']['output']>>;
  singleSetConfig?: Maybe<Array<SingleSetConfig>>;
  size: Scalars['Float']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export class DocumentFileInput {
  blob: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  docusealSubmissionId?: InputMaybe<Scalars['Int']['input']>;
  isInTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  selectionValues?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  signingRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  singleSetConfig?: InputMaybe<Array<SingleSetConfigInput>>;
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};

export enum DocumentFinishingMode {
  Detail = 'Detail',
  Global = 'Global'
}

export class DocumentFormatEqualityMapping {
  __typename?: 'DocumentFormatEqualityMapping';
  equalDocumentFormats: Array<Scalars['String']['output']>;
  sourceDocumentFormat: Scalars['String']['output'];
};

export class DocumentFormatEqualityMappingInput {
  equalDocumentFormats: Array<Scalars['String']['input']>;
  sourceDocumentFormat: Scalars['String']['input'];
};

export class DocumentFormats {
  __typename?: 'DocumentFormats';
  availableFormats: Array<Scalars['String']['output']>;
  formatsUploadedAsDocumentSets: Array<Scalars['String']['output']>;
};

export class DocumentFormatsInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  immigrationCountry?: InputMaybe<SupportedImmigrationCountry>;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export class DocumentFreeFormatFile {
  __typename?: 'DocumentFreeFormatFile';
  blob: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export class DocumentFreeFormatFileInput {
  blob: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

export enum DocumentGenerationLanguageHandling {
  BestFittingOnly = 'BestFittingOnly',
  ImmigrationCountryLanguagePlusAll = 'ImmigrationCountryLanguagePlusAll',
  ImmigrationCountryLanguagePlusNextBest = 'ImmigrationCountryLanguagePlusNextBest'
}

export enum DocumentGenerationMode {
  AllCandidates = 'AllCandidates',
  OneCandidate = 'OneCandidate'
}

export class DocumentGetByTypeInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export class DocumentGetByTypesInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  types: Array<Scalars['String']['input']>;
};

export class DocumentGetInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DocumentListInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  mode: DocumentMode;
  organizationId: Scalars['ID']['input'];
  requiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requiredDocumentsOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export class DocumentLoadInput {
  blob: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  fromImageContainer?: InputMaybe<Scalars['Boolean']['input']>;
  isInTaskActContext: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  timeSpanInHours?: InputMaybe<Scalars['Float']['input']>;
};

export class DocumentLoadWithContainerInput {
  blob: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  container: Scalars['String']['input'];
  isInTaskActContext: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  timeSpanInHours?: InputMaybe<Scalars['Float']['input']>;
};

export class DocumentLoadWithFileNameInput {
  blob: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  isInTaskActContext: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class DocumentLockAllInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  lockMode: DocumentLockMode;
  lockingOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class DocumentLockInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  documents: Array<DocumentLockItemInput>;
  lockMode: DocumentLockMode;
  lockingOrganizationId: Scalars['String']['input'];
};

export class DocumentLockItemInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum DocumentLockMode {
  LockedByAProcessOwner = 'LockedByAProcessOwner',
  LockedByCandidateOwner = 'LockedByCandidateOwner',
  LockedByExternalSubmission = 'LockedByExternalSubmission',
  Unlocked = 'Unlocked'
}

export class DocumentMapping {
  __typename?: 'DocumentMapping';
  formats?: Maybe<Array<Scalars['String']['output']>>;
  setTypes?: Maybe<Array<Scalars['String']['output']>>;
  standardDocumentTypeId: Scalars['String']['output'];
};

export class DocumentMappingInput {
  formats?: InputMaybe<Array<Scalars['String']['input']>>;
  setTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardDocumentTypeId: Scalars['String']['input'];
};

export enum DocumentMode {
  Candidate = 'Candidate',
  Organization = 'Organization',
  Template = 'Template'
}

export class DocumentOverviewInputCandidate {
  candidateId: Scalars['ID']['input'];
  consideredDeliveryFormats: Array<DocumentDeliveryFormat>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  requiredDocumentSetIds: Array<Scalars['ID']['input']>;
  requiredDocumentSetOrganizationId: Scalars['ID']['input'];
};

export class DocumentOverviewInputCollection {
  candidateId?: InputMaybe<CandidateIdInput>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  consideredDeliveryFormats: Array<DocumentDeliveryFormat>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  requiredDocumentSetIds: Array<Scalars['ID']['input']>;
  requiredDocumentSetOrganizationId: Scalars['ID']['input'];
};

export class DocumentOverviewInputProcess {
  candidateId?: InputMaybe<CandidateIdInput>;
  consideredDeliveryFormats: Array<DocumentDeliveryFormat>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processId: Scalars['ID']['input'];
};

export class DocumentProcessUploadType {
  __typename?: 'DocumentProcessUploadType';
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  documentId: Scalars['String']['output'];
  documentType?: Maybe<Scalars['String']['output']>;
  fileformats: Array<Scalars['String']['output']>;
};

export class DocumentProcessUploadTypeInput {
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  documentId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  fileformats: Array<Scalars['String']['input']>;
};

export enum DocumentPurpose {
  Recognition = 'Recognition',
  Visum = 'Visum'
}

export class DocumentRelatedFormats {
  __typename?: 'DocumentRelatedFormats';
  documentType: Scalars['String']['output'];
  formats?: Maybe<Array<Scalars['String']['output']>>;
};

export class DocumentRequirement {
  __typename?: 'DocumentRequirement';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  checkSpecificSets: Scalars['Boolean']['output'];
  comment: Scalars['Boolean']['output'];
  completionState: Scalars['Boolean']['output'];
  dateOfReceipt: Scalars['Boolean']['output'];
  documentSetTypes?: Maybe<Array<Scalars['String']['output']>>;
  files: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isInternal: Scalars['Boolean']['output'];
  issueDate: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  physicalTypes: Scalars['Boolean']['output'];
  resubmissionDate: Scalars['Boolean']['output'];
  resubmissionReason: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['Boolean']['output'];
  validUntil: Scalars['Boolean']['output'];
};

export class DocumentRequirementAlternativeModel {
  __typename?: 'DocumentRequirementAlternativeModel';
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileformats: Array<Scalars['String']['output']>;
  minfileFormatsRequired?: Maybe<Scalars['Float']['output']>;
};

export class DocumentRequirementAlternativeModelInput {
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  fileformats: Array<Scalars['String']['input']>;
  minfileFormatsRequired?: InputMaybe<Scalars['Float']['input']>;
};

export class DocumentRequirementGetByTypeInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export class DocumentRequirementGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DocumentRequirementInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  changedAt: Scalars['AnkaadiaDateTime']['input'];
  changedBy: Scalars['String']['input'];
  checkSpecificSets?: Scalars['Boolean']['input'];
  comment?: Scalars['Boolean']['input'];
  completionState?: Scalars['Boolean']['input'];
  dateOfReceipt?: Scalars['Boolean']['input'];
  documentSetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isInternal?: Scalars['Boolean']['input'];
  issueDate?: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  physicalTypes?: Scalars['Boolean']['input'];
  resubmissionDate?: Scalars['Boolean']['input'];
  resubmissionReason?: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  validFrom?: Scalars['Boolean']['input'];
  validUntil?: Scalars['Boolean']['input'];
};

export class DocumentRequirementListInput {
  organizationId: Scalars['ID']['input'];
};

export class DocumentRequirementModel {
  __typename?: 'DocumentRequirementModel';
  alternatives?: Maybe<Array<DocumentRequirementAlternativeModel>>;
  description?: Maybe<Array<ProcessOptionalString>>;
  minAlternatives?: Maybe<Scalars['Float']['output']>;
  requireNewUpload?: Maybe<Scalars['Boolean']['output']>;
};

export class DocumentRequirementModelInput {
  alternatives?: InputMaybe<Array<DocumentRequirementAlternativeModelInput>>;
  description?: InputMaybe<Array<ProcessOptionalStringInput>>;
  minAlternatives?: InputMaybe<Scalars['Float']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export class DocumentRequirementUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  checkSpecificSets?: Scalars['Boolean']['input'];
  comment?: Scalars['Boolean']['input'];
  completionState?: Scalars['Boolean']['input'];
  dateOfReceipt?: Scalars['Boolean']['input'];
  documentSetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: Scalars['Boolean']['input'];
  isInternal?: Scalars['Boolean']['input'];
  issueDate?: Scalars['Boolean']['input'];
  physicalTypes?: Scalars['Boolean']['input'];
  resubmissionDate?: Scalars['Boolean']['input'];
  resubmissionReason?: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  validFrom?: Scalars['Boolean']['input'];
  validUntil?: Scalars['Boolean']['input'];
};

export class DocumentRequirementsUpsertInput {
  organizationId: Scalars['ID']['input'];
  requirements: Array<DocumentRequirementUpsertInput>;
};

export enum DocumentSelectionCriterion {
  ChamberOfCrafts = 'ChamberOfCrafts',
  CountryOfHabitualResidence = 'CountryOfHabitualResidence',
  CountryOfOrigin = 'CountryOfOrigin',
  DiplomaticMission = 'DiplomaticMission',
  Employer = 'Employer',
  EmployerAfterRecognition = 'EmployerAfterRecognition',
  FederalState = 'FederalState',
  Function = 'Function',
  ImmigrationAuthority = 'ImmigrationAuthority',
  ImmigrationCountry = 'ImmigrationCountry',
  Language = 'Language',
  PlacementPartner = 'PlacementPartner',
  Profession = 'Profession',
  Qualification = 'Qualification',
  QualificationMeasure = 'QualificationMeasure',
  RecognitionAuthority = 'RecognitionAuthority',
  RecognitionCenter = 'RecognitionCenter',
  Source = 'Source',
  TheoryInstitution = 'TheoryInstitution',
  WorkLocation = 'WorkLocation',
  WorkLocationAfterRecognition = 'WorkLocationAfterRecognition'
}

export class DocumentSet {
  __typename?: 'DocumentSet';
  dateOfReceipt?: Maybe<Scalars['UTCDate']['output']>;
  files?: Maybe<Array<DocumentFile>>;
  foreignKey?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isDefaultSet: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['UTCDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  physicalTypes?: Maybe<Array<Scalars['String']['output']>>;
  resubmissionDate?: Maybe<Scalars['UTCDate']['output']>;
  resubmissionReason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class DocumentSetInput {
  dateOfReceipt?: InputMaybe<Scalars['UTCDate']['input']>;
  files?: InputMaybe<Array<DocumentFileInput>>;
  foreignKey?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDefaultSet: Scalars['Boolean']['input'];
  issueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  physicalTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  resubmissionDate?: InputMaybe<Scalars['UTCDate']['input']>;
  resubmissionReason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class DocumentSharingInput {
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
};

export class DocumentSigningConfig {
  __typename?: 'DocumentSigningConfig';
  enabled: Scalars['Boolean']['output'];
  roles: Array<DocumentSigningRole>;
  targetCandidateDocument: TargetCandidateDocument;
};

export class DocumentSigningConfigInput {
  enabled: Scalars['Boolean']['input'];
  roles: Array<DocumentSigningRoleInput>;
  targetCandidateDocument: TargetCandidateDocumentInput;
};

export class DocumentSigningRole {
  __typename?: 'DocumentSigningRole';
  assignedUserGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  processOrganizationId?: Maybe<Scalars['String']['output']>;
  roleName: Scalars['String']['output'];
  signatureType: SignatureType;
};

export class DocumentSigningRoleInput {
  assignedUserGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  processOrganizationId?: InputMaybe<Scalars['String']['input']>;
  roleName: Scalars['String']['input'];
  signatureType: SignatureType;
};

export class DocumentSigningServiceConfiguration {
  __typename?: 'DocumentSigningServiceConfiguration';
  aes?: Maybe<DocumentSigningTypeConfiguration>;
  qes?: Maybe<DocumentSigningTypeConfiguration>;
  ses?: Maybe<DocumentSigningTypeConfiguration>;
};

export class DocumentSigningServiceConfigurationInput {
  aes?: InputMaybe<DocumentSigningTypeConfigurationInput>;
  qes?: InputMaybe<DocumentSigningTypeConfigurationInput>;
  ses?: InputMaybe<DocumentSigningTypeConfigurationInput>;
};

export class DocumentSigningTypeConfiguration {
  __typename?: 'DocumentSigningTypeConfiguration';
  activatedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  isEnabled: Scalars['Boolean']['output'];
};

export class DocumentSigningTypeConfigurationInput {
  activatedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  isEnabled: Scalars['Boolean']['input'];
};

export class DocumentStatus {
  __typename?: 'DocumentStatus';
  candidateStatus: Array<DocumentCandidateStatus>;
  documentName: Scalars['String']['output'];
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  isOptional: Scalars['Boolean']['output'];
  requiredFormats: Array<Scalars['String']['output']>;
};

export enum DocumentStatusEnum {
  Available = 'Available',
  AvailableButExpired = 'AvailableButExpired',
  Missing = 'Missing',
  MissingButStatusTakenOver = 'MissingButStatusTakenOver',
  MissingNotRequired = 'MissingNotRequired',
  NotShared = 'NotShared',
  Partial = 'Partial'
}

export class DocumentTemplate {
  __typename?: 'DocumentTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  blob?: Maybe<Scalars['String']['output']>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  candidateOriginCountry?: Maybe<Scalars['String']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includeProcessData?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  signingConfig?: Maybe<DocumentSigningConfig>;
  status: DocumentTemplateStatus;
  throwErrorOnNoSelection?: Maybe<Scalars['Boolean']['output']>;
  type: DocumentTemplateType;
  warnings?: Maybe<Array<DocumentTemplateWarning>>;
};

export class DocumentTemplateAllInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class DocumentTemplateCandidateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DocumentTemplateCollectionInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  templates: Array<AvailableDocumentTemplateInput>;
};

export class DocumentTemplateEditedInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  type: DocumentTemplateType;
};

export class DocumentTemplateGenerateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['String']['input']>;
  conversionType?: InputMaybe<TemplateToDocumentTypeConversion>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: DocumentTemplateType;
};

export class DocumentTemplateGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  parameters?: InputMaybe<Scalars['JSONObject']['input']>;
  type: DocumentTemplateType;
};

export enum DocumentTemplateMode {
  Docx = 'Docx',
  Json = 'Json',
  Xlsx = 'Xlsx'
}

export class DocumentTemplateProcessUsageInput {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum DocumentTemplateStatus {
  Deprecated = 'Deprecated',
  Edited = 'Edited',
  Error = 'Error',
  InProgress = 'InProgress',
  NotAvailable = 'NotAvailable',
  NotGenerated = 'NotGenerated',
  Success = 'Success',
  Warning = 'Warning'
}

export enum DocumentTemplateType {
  Docx = 'Docx',
  Json = 'Json',
  Pdf = 'Pdf',
  Xlsx = 'Xlsx'
}

export class DocumentTemplateWarning {
  __typename?: 'DocumentTemplateWarning';
  parameters?: Maybe<Scalars['JSONObject']['output']>;
  translationKey: Scalars['String']['output'];
};

export class DocumentTemplateWarningInput {
  parameters?: InputMaybe<Scalars['JSONObject']['input']>;
  translationKey: Scalars['String']['input'];
};

export class DocumentThumbnailInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum DocumentTranslationMode {
  Certified = 'Certified',
  Sworn = 'Sworn'
}

export enum DocumentTranslationProvider {
  Lingoking = 'Lingoking'
}

export class DocumentTranslationState {
  __typename?: 'DocumentTranslationState';
  _etag?: Maybe<Scalars['String']['output']>;
  cancellationRequests?: Maybe<Array<TranslationCancellationRequest>>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  documents?: Maybe<Array<TranslationOrderDocument>>;
  id?: Maybe<Scalars['ID']['output']>;
  lingokingCartId?: Maybe<Scalars['String']['output']>;
  logMessages?: Maybe<Array<Scalars['String']['output']>>;
  mode: DocumentTranslationMode;
  netPrice?: Maybe<Scalars['Float']['output']>;
  orderHistory?: Maybe<Array<TranslationOrderStatusHistory>>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<ProcessStateTranslateDocumentsOrderState>;
  orderedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  priceCurrency?: Maybe<Scalars['String']['output']>;
  provider: DocumentTranslationProvider;
  targetLanguage: Scalars['String']['output'];
  taskId?: Maybe<Scalars['ID']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export class DocumentTranslationStateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  cancellationRequests?: InputMaybe<Array<TranslationCancellationRequestInput>>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  documents?: InputMaybe<Array<TranslationOrderDocumentInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lingokingCartId?: InputMaybe<Scalars['String']['input']>;
  logMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  mode: DocumentTranslationMode;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  orderHistory?: InputMaybe<Array<TranslationOrderStatusHistoryInput>>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<ProcessStateTranslateDocumentsOrderState>;
  orderedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  organizationId: Scalars['ID']['input'];
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  provider: DocumentTranslationProvider;
  targetLanguage: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

export class DocumentTypeExtractionInput {
  blob: Scalars['String']['input'];
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class DocumentTypeExtractionResult {
  __typename?: 'DocumentTypeExtractionResult';
  documentType: Scalars['String']['output'];
};

export class DocumentTypeOverwrite {
  __typename?: 'DocumentTypeOverwrite';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Array<LocalizedString>>;
  documentMappings?: Maybe<Array<DocumentMapping>>;
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  localizedDescription?: Maybe<Scalars['String']['output']>;
  localizedName?: Maybe<Scalars['String']['output']>;
  name: Array<LocalizedString>;
  organizationId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export class DocumentTypeOverwriteDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DocumentTypeOverwriteGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DocumentTypeOverwriteUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  changedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  changedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Array<LocalizedStringInput>>;
  documentMappings?: InputMaybe<Array<DocumentMappingInput>>;
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export class DocumentUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  alwaysGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  availableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completionState?: InputMaybe<CompletionState>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentGenerationLanguageHandling?: InputMaybe<DocumentGenerationLanguageHandling>;
  documentSets?: InputMaybe<Array<DocumentSetInput>>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  freeFormatFiles?: InputMaybe<Array<DocumentFreeFormatFileInput>>;
  generationMode?: InputMaybe<DocumentGenerationMode>;
  generationStrategy?: InputMaybe<DataStrategyConfigurationDescriptionInput>;
  hideCandidateNameInFileName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ignoreConcurrencyError?: InputMaybe<Scalars['Boolean']['input']>;
  includeProcessData?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalDocument?: InputMaybe<Scalars['Boolean']['input']>;
  lockState?: InputMaybe<DocumentLockMode>;
  lockTimeStamp?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lockingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  mode: DocumentMode;
  organizationId: Scalars['ID']['input'];
  selectionCriteria?: InputMaybe<Array<DocumentSelectionCriterion>>;
  sharedToOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  signingConfig?: InputMaybe<DocumentSigningConfigInput>;
  templateMode?: InputMaybe<DocumentTemplateMode>;
  throwErrorOnNoSelection?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  writeMode: DocumentWriteMode;
};

export class DocumentUpsertInput {
  alwaysGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  availableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completionState?: InputMaybe<CompletionState>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentGenerationLanguageHandling?: InputMaybe<DocumentGenerationLanguageHandling>;
  documentSets?: InputMaybe<Array<DocumentSetInput>>;
  familyMemberId?: InputMaybe<Scalars['ID']['input']>;
  freeFormatFiles?: InputMaybe<Array<DocumentFreeFormatFileInput>>;
  generationMode?: InputMaybe<DocumentGenerationMode>;
  generationStrategy?: InputMaybe<DataStrategyConfigurationDescriptionInput>;
  hideCandidateNameInFileName?: InputMaybe<Scalars['Boolean']['input']>;
  includeProcessData?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalDocument?: InputMaybe<Scalars['Boolean']['input']>;
  lockState?: InputMaybe<DocumentLockMode>;
  lockTimeStamp?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lockingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  mode: DocumentMode;
  organizationId: Scalars['ID']['input'];
  selectionCriteria?: InputMaybe<Array<DocumentSelectionCriterion>>;
  sharedToOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  signingConfig?: InputMaybe<DocumentSigningConfigInput>;
  skipCvParsing?: InputMaybe<Scalars['Boolean']['input']>;
  templateMode?: InputMaybe<DocumentTemplateMode>;
  throwErrorOnNoSelection?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  writeMode: DocumentWriteMode;
};

export class DocumentUrl {
  __typename?: 'DocumentUrl';
  containerName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export class DocumentUrlAndFileName {
  __typename?: 'DocumentUrlAndFileName';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export class DocumentValidationInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  files: Array<DocumentValidationInputFile>;
  generationMode: DocumentGenerationMode;
  organizationId: Scalars['ID']['input'];
  templateMode?: InputMaybe<DocumentTemplateMode>;
};

export class DocumentValidationInputFile {
  blob: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum DocumentWriteMode {
  Full = 'Full',
  Metadata = 'Metadata',
  None = 'None'
}

export class DownloadDocumentTemplateCandidateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['String']['input']>;
  inAllFormats?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class DownloadDocumentTemplateCollectionInput {
  collectionId: Scalars['ID']['input'];
  inAllFormats?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  templates: Array<AvailableDocumentTemplateInput>;
};

export class DownloadableFile {
  __typename?: 'DownloadableFile';
  candidateId?: Maybe<Scalars['ID']['output']>;
  containerName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fileId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  size: Scalars['Float']['output'];
  templateName?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<DocumentTemplateType>;
};

export class DownloadableFilestInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  containerName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  size: Scalars['Float']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<DocumentTemplateType>;
};

export enum DurationCalculationType {
  DurationFromPredecessorFinish = 'DurationFromPredecessorFinish',
  DurationFromTaskStart = 'DurationFromTaskStart'
}

export class EzbInfo {
  __typename?: 'EZBInfo';
  detailsOfSocialSecurityIssues?: Maybe<Scalars['String']['output']>;
  hasInsolvencyProceedingInLast5Years?: Maybe<Scalars['Boolean']['output']>;
  hasInsolvencyProceedingLackedAssets?: Maybe<Scalars['Boolean']['output']>;
  hasPendingSecurityPayments?: Maybe<Scalars['Boolean']['output']>;
  hasSocialSecurityIssuesInLast5Years?: Maybe<Scalars['Boolean']['output']>;
};

export class EzbInfoInput {
  detailsOfSocialSecurityIssues?: InputMaybe<Scalars['String']['input']>;
  hasInsolvencyProceedingInLast5Years?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsolvencyProceedingLackedAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingSecurityPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSocialSecurityIssuesInLast5Years?: InputMaybe<Scalars['Boolean']['input']>;
};

export class EditFutureRecurringFeeInput {
  bookingText: Scalars['String']['input'];
  bookingType: BookingType;
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  currency: SupportedBillingCurrency;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  paymentTime: PaymentTime;
  period: PaymentPeriod;
  price: Scalars['Float']['input'];
  revenueCategory: RevenueCategory;
  startDate: Scalars['UTCDate']['input'];
  targetInvoiceType: InvoiceType;
};

export class EditPaymentSettingsInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  paymentTime: PaymentTime;
  paymentTranches?: InputMaybe<Array<ContractPaymentTrancheInput>>;
  period: PaymentPeriod;
  startDate: Scalars['UTCDate']['input'];
};

export class EditUserPriceInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  currency: SupportedBillingCurrency;
  id: Scalars['String']['input'];
  includedUsers: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  validFrom: Scalars['UTCDate']['input'];
};

export class EducationCourse {
  __typename?: 'EducationCourse';
  _etag?: Maybe<Scalars['String']['output']>;
  attendanceTrackingMode?: Maybe<EducationCourseTrackingMode>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  courseVisibility?: Maybe<EducationCourseVisibility>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['UTCDate']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  inactive?: Maybe<Scalars['Boolean']['output']>;
  languageLevel?: Maybe<Scalars['String']['output']>;
  maxParticipants: Scalars['Float']['output'];
  moduleId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  participantCollectionId: Scalars['ID']['output'];
  participantCount: Scalars['Float']['output'];
  performanceTrackingMode?: Maybe<EducationCourseTrackingMode>;
  readOnlyCourseViewOrgIds?: Maybe<Array<Scalars['ID']['output']>>;
  startDate: Scalars['UTCDate']['output'];
  teacherUserIds: Array<Scalars['ID']['output']>;
  trackedWeekdays?: Maybe<TrackedWeekdays>;
  weeks?: Maybe<Array<EducationCourseWeek>>;
};

export enum EducationCourseAttendance {
  Absent = 'Absent',
  AbsentAndUnexcused = 'AbsentAndUnexcused',
  PartiallyPresent = 'PartiallyPresent',
  Present = 'Present'
}

export class EducationCourseCandidatePerformance {
  __typename?: 'EducationCourseCandidatePerformance';
  candidateDisplayId: Scalars['String']['output'];
  candidateDisplayName: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  candidateState?: Maybe<EducationCourseCandidateStatus>;
  droppedOutDate?: Maybe<Scalars['UTCDate']['output']>;
  weeks: Array<EducationCourseCandidateWeeklyPerformance>;
};

export enum EducationCourseCandidateStatus {
  DroppedOut = 'DroppedOut',
  InterventionRequired = 'InterventionRequired',
  OnTrack = 'OnTrack',
  Warning = 'Warning'
}

export class EducationCourseCandidateWeeklyPerformance {
  __typename?: 'EducationCourseCandidateWeeklyPerformance';
  attendance?: Maybe<EducationCourseAttendance>;
  comment?: Maybe<Scalars['String']['output']>;
  dailyAttendance?: Maybe<DailyEducationCourseAttendance>;
  dailyPerformance?: Maybe<DailyEducationCoursePerformance>;
  performance?: Maybe<EducationCoursePerformanceStatus>;
  week: EducationCourseWeekPointer;
};

export class EducationCourseCandidateWeeklyPerformanceView {
  __typename?: 'EducationCourseCandidateWeeklyPerformanceView';
  attendance?: Maybe<EducationCourseAttendance>;
  comment?: Maybe<Scalars['String']['output']>;
  dailyAttendance?: Maybe<DailyEducationCourseAttendance>;
  dailyPerformance?: Maybe<DailyEducationCoursePerformance>;
  id?: Maybe<Scalars['ID']['output']>;
  performance?: Maybe<EducationCoursePerformanceStatus>;
  week: EducationCourseWeek;
};

export class EducationCourseCollectionCreateInput {
  collection: CollectionCreateInput;
  moduleId: Scalars['ID']['input'];
};

export class EducationCourseCreateInput {
  attendanceTrackingMode?: InputMaybe<EducationCourseTrackingMode>;
  courseVisibility?: InputMaybe<EducationCourseVisibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['UTCDate']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  maxParticipants: Scalars['Float']['input'];
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  participantCollectionId: Scalars['ID']['input'];
  performanceTrackingMode?: InputMaybe<EducationCourseTrackingMode>;
  readOnlyCourseViewOrgIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['UTCDate']['input'];
  teacherUserIds: Array<Scalars['ID']['input']>;
  trackedWeekdays?: InputMaybe<TrackedWeekdaysInput>;
  weeks?: InputMaybe<Array<EducationCourseWeekInput>>;
};

export class EducationCourseDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationCourseGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationCourseListForCandidateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
};

export class EducationCourseListInput {
  organizationId: Scalars['ID']['input'];
};

export class EducationCoursePerformance {
  __typename?: 'EducationCoursePerformance';
  candidates: Array<EducationCourseCandidatePerformance>;
  courseId: Scalars['ID']['output'];
  currentWeek: EducationCourseWeekPointer;
  organizationId: Scalars['ID']['output'];
  weeks: Array<EducationCourseWeek>;
};

export class EducationCoursePerformanceByCandidate {
  __typename?: 'EducationCoursePerformanceByCandidate';
  candidateState?: Maybe<EducationCourseCandidateStatus>;
  courseId: Scalars['ID']['output'];
  droppedOutDate?: Maybe<Scalars['UTCDate']['output']>;
  weeks: Array<EducationCourseCandidateWeeklyPerformanceView>;
};

export class EducationCoursePerformanceByCandidateGetInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationCoursePerformanceListInput {
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum EducationCoursePerformanceStatus {
  Average = 'Average',
  Bad = 'Bad',
  Good = 'Good'
}

export class EducationCourseTotalPerformance {
  __typename?: 'EducationCourseTotalPerformance';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  candidateState?: Maybe<EducationCourseCandidateStatus>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  courseId: Scalars['ID']['output'];
  droppedOutDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class EducationCourseTotalPerformanceGetInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationCourseTotalPerformanceStateUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  candidateState?: InputMaybe<EducationCourseCandidateStatus>;
  courseId: Scalars['ID']['input'];
  droppedOutDate?: InputMaybe<Scalars['UTCDate']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationCourseTotalPerformancesForCandidateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum EducationCourseTrackingMode {
  Daily = 'Daily',
  Weekly = 'Weekly'
}

export class EducationCourseUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  attendanceTrackingMode?: InputMaybe<EducationCourseTrackingMode>;
  courseVisibility?: InputMaybe<EducationCourseVisibility>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['UTCDate']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  maxParticipants: Scalars['Float']['input'];
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  participantCollectionId: Scalars['ID']['input'];
  performanceTrackingMode?: InputMaybe<EducationCourseTrackingMode>;
  readOnlyCourseViewOrgIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['UTCDate']['input'];
  teacherUserIds: Array<Scalars['ID']['input']>;
  trackedWeekdays?: InputMaybe<TrackedWeekdaysInput>;
  weeks?: InputMaybe<Array<EducationCourseWeekInput>>;
};

export enum EducationCourseVisibility {
  All = 'All',
  TeacherOnly = 'TeacherOnly'
}

export class EducationCourseWeek {
  __typename?: 'EducationCourseWeek';
  number: Scalars['Float']['output'];
  trackedWeekdays?: Maybe<TrackedWeekdays>;
  year: Scalars['Float']['output'];
};

export class EducationCourseWeekInput {
  number: Scalars['Float']['input'];
  trackedWeekdays?: InputMaybe<TrackedWeekdaysInput>;
  year: Scalars['Float']['input'];
};

export class EducationCourseWeekPointer {
  __typename?: 'EducationCourseWeekPointer';
  number: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export class EducationCourseWeekPointerInput {
  number: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export class EducationCourseWeekPrefillInput {
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  week: EducationCourseWeekPointerInput;
};

export class EducationCourseWeekUpdateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  week: EducationCourseWeekInput;
};

export class EducationCourseWeeklyAttendanceUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  attendance?: InputMaybe<EducationCourseAttendance>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  dailyAttendance?: InputMaybe<DailyEducationCourseAttendanceInput>;
  organizationId: Scalars['ID']['input'];
  week: EducationCourseWeekPointerInput;
};

export class EducationCourseWeeklyCommentUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  week: EducationCourseWeekPointerInput;
};

export class EducationCourseWeeklyPerformance {
  __typename?: 'EducationCourseWeeklyPerformance';
  _etag?: Maybe<Scalars['String']['output']>;
  attendance?: Maybe<EducationCourseAttendance>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  courseId: Scalars['ID']['output'];
  dailyAttendance?: Maybe<DailyEducationCourseAttendance>;
  dailyPerformance?: Maybe<DailyEducationCoursePerformance>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  performance?: Maybe<EducationCoursePerformanceStatus>;
  week: EducationCourseWeekPointer;
};

export class EducationCourseWeeklyPerformanceGetInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  week: EducationCourseWeekPointerInput;
};

export class EducationCourseWeeklyPerformanceUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  dailyPerformance?: InputMaybe<DailyEducationCoursePerformanceInput>;
  organizationId: Scalars['ID']['input'];
  performance?: InputMaybe<EducationCoursePerformanceStatus>;
  week: EducationCourseWeekPointerInput;
};

export class EducationExam {
  __typename?: 'EducationExam';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  educationCourseIds?: Maybe<Array<Scalars['ID']['output']>>;
  educationModuleId?: Maybe<Scalars['ID']['output']>;
  examDateAndTime?: Maybe<DateWithTime>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  examLocation?: Maybe<Scalars['String']['output']>;
  examModules?: Maybe<Array<ExamModuleType>>;
  examType: ExamType;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  plannedExamDateAndTime?: Maybe<DateTimeOrRange>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['output'];
  plannedExamResultDate?: Maybe<Scalars['UTCDate']['output']>;
  responsibleRolePayment?: Maybe<Scalars['String']['output']>;
};

export class EducationExamActivityParameter {
  __typename?: 'EducationExamActivityParameter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class EducationExamBaseData {
  __typename?: 'EducationExamBaseData';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  examDateAndTime?: Maybe<DateWithTime>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  examLocation?: Maybe<Scalars['String']['output']>;
  examModules?: Maybe<Array<ExamModuleType>>;
  examType: ExamType;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  plannedExamDateAndTime?: Maybe<DateTimeOrRange>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['output'];
  plannedExamResultDate?: Maybe<Scalars['UTCDate']['output']>;
  responsibleRolePayment?: Maybe<Scalars['String']['output']>;
};

export class EducationExamCandidateIdInput {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export class EducationExamCreateInput {
  educationCourseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  educationModuleId?: InputMaybe<Scalars['ID']['input']>;
  examDateAndTime?: InputMaybe<DateWithTimeInput>;
  examInstitution?: InputMaybe<Scalars['String']['input']>;
  examLocation?: InputMaybe<Scalars['String']['input']>;
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType: ExamType;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  plannedExamDateAndTime?: InputMaybe<DateOrDateRangeInput>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['input'];
  plannedExamResultDate?: InputMaybe<Scalars['UTCDate']['input']>;
  responsibleRolePayment?: InputMaybe<Scalars['String']['input']>;
};

export class EducationExamDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationExamForCandidate {
  __typename?: 'EducationExamForCandidate';
  exam?: Maybe<EducationExam>;
  level: Scalars['String']['output'];
  participant?: Maybe<EducationExamParticipantEntity>;
  result?: Maybe<EducationExamResultFullData>;
};

export class EducationExamForCandidateGetByCriteriaInput {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType: ExamType;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type EducationExamForCandidateUnion = AdHocEducationExamForCandidate | EducationExamForCandidate;

export class EducationExamGetByCandidateIdInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamGetByCourseIdInput {
  courseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamGetByCriteriaInput {
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType?: InputMaybe<ExamType>;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<ExamStatus>;
};

export class EducationExamGetByIdInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationExamGetByOrgIdInput {
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<ExamStatus>;
};

export class EducationExamModuleResultInformation {
  __typename?: 'EducationExamModuleResultInformation';
  examModule: ExamModuleType;
  id: Scalars['ID']['output'];
  resultDetails?: Maybe<Scalars['String']['output']>;
};

export class EducationExamModuleResultInformationInput {
  examModule: ExamModuleType;
  id: Scalars['ID']['input'];
  resultDetails?: InputMaybe<Scalars['String']['input']>;
};

export class EducationExamOption {
  __typename?: 'EducationExamOption';
  examModules?: Maybe<Array<ExamModuleType>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class EducationExamOptionsForTaskInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class EducationExamParticipant {
  __typename?: 'EducationExamParticipant';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  examId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class EducationExamParticipantCreateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamParticipantCreateManyInput {
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participants: Array<EducationExamCandidateIdInput>;
};

export class EducationExamParticipantDeleteInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamParticipantEntity {
  __typename?: 'EducationExamParticipantEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  examId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class EducationExamParticipantGetInput {
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamParticipationForTaskInput {
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class EducationExamResult {
  __typename?: 'EducationExamResult';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  examId: Scalars['ID']['output'];
  examModuleInformation?: Maybe<Array<EducationExamModuleResultInformation>>;
  examResult?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  passedExamModules?: Maybe<Array<ExamModuleType>>;
};

export class EducationExamResultDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  examId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationExamResultFullData {
  __typename?: 'EducationExamResultFullData';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateName?: Maybe<Scalars['String']['output']>;
  candidateOrganizationId: Scalars['ID']['output'];
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  educationProviderOrganizationId?: Maybe<Scalars['String']['output']>;
  examId: Scalars['ID']['output'];
  examModuleInformation?: Maybe<Array<EducationExamModuleResultInformation>>;
  examResult?: Maybe<Scalars['String']['output']>;
  examType: ExamType;
  id?: Maybe<Scalars['ID']['output']>;
  languageLevel?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  participantId?: Maybe<Scalars['String']['output']>;
  passedExamModules?: Maybe<Array<ExamModuleType>>;
};

export class EducationExamResultListInput {
  examId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EducationExamResultUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  examId: Scalars['ID']['input'];
  examModuleInformation?: InputMaybe<Array<EducationExamModuleResultInformationInput>>;
  examResult?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  passedExamModules?: InputMaybe<Array<ExamModuleType>>;
};

export class EducationExamResultsByCandidateIdInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
};

export class EducationExamUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  educationCourseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  educationModuleId?: InputMaybe<Scalars['ID']['input']>;
  examDateAndTime?: InputMaybe<DateWithTimeInput>;
  examInstitution?: InputMaybe<Scalars['String']['input']>;
  examLocation?: InputMaybe<Scalars['String']['input']>;
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType: ExamType;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  plannedExamDateAndTime?: InputMaybe<DateOrDateRangeInput>;
  plannedExamDateAndTimeConfirmed: Scalars['Boolean']['input'];
  plannedExamResultDate?: InputMaybe<Scalars['UTCDate']['input']>;
  responsibleRolePayment?: InputMaybe<Scalars['String']['input']>;
};

export enum EducationMode {
  Blended = 'Blended',
  FaceToFace = 'FaceToFace',
  Online = 'Online'
}

export class EducationModule {
  __typename?: 'EducationModule';
  _etag?: Maybe<Scalars['String']['output']>;
  allowCourseListCreation?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  languageLevel: Scalars['String']['output'];
  mode: EducationMode;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  providerOrganizationId: Scalars['ID']['output'];
  status: EducationModuleStatus;
  type: EducationModuleType;
  units: Scalars['Float']['output'];
};

export class EducationModuleCreateInput {
  allowCourseListCreation?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  languageLevel: Scalars['String']['input'];
  mode: EducationMode;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  providerOrganizationId: Scalars['ID']['input'];
  status: EducationModuleStatus;
  type: EducationModuleType;
  units: Scalars['Float']['input'];
};

export class EducationModuleDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationModuleGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EducationModuleListInput {
  organizationId: Scalars['ID']['input'];
};

export enum EducationModuleStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum EducationModuleType {
  LanguageLearning = 'LanguageLearning'
}

export class EducationModuleUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowCourseListCreation?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageLevel: Scalars['String']['input'];
  mode: EducationMode;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  providerOrganizationId: Scalars['ID']['input'];
  status: EducationModuleStatus;
  type: EducationModuleType;
  units: Scalars['Float']['input'];
};

export class EffectiveSharingForMultiEditInput {
  candidateIds: Array<CandidateIdInput>;
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export class EffectiveSharingInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId: Scalars['ID']['input'];
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<EffectiveSharingOptionsInput>;
  organizationId: Scalars['ID']['input'];
};

export class EffectiveSharingOptionsInput {
  candidateFunction?: InputMaybe<Scalars['String']['input']>;
  candidateStatus?: InputMaybe<CandidateStatus>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class EffectiveSharingOutput {
  __typename?: 'EffectiveSharingOutput';
  canSeeInternalDocuments: Scalars['Boolean']['output'];
  internalMaskHash?: Maybe<Scalars['String']['output']>;
  shareAllFileTypes?: Maybe<Scalars['Boolean']['output']>;
  sharedFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  sharedTabs?: Maybe<Array<SharedTab>>;
  sharingType?: Maybe<SharingTypeEnum>;
  showCompletionStateAtDocuments: Scalars['Boolean']['output'];
  tabHash?: Maybe<Scalars['String']['output']>;
};

export class Email {
  __typename?: 'Email';
  _etag?: Maybe<Scalars['String']['output']>;
  actualProcessId?: Maybe<Scalars['ID']['output']>;
  attachDownloadableTaskFiles?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<FileAttachment>>;
  bcc?: Maybe<Array<EmailParty>>;
  body?: Maybe<Scalars['String']['output']>;
  candidateIds?: Maybe<Array<CandidateId>>;
  cc?: Maybe<Array<EmailParty>>;
  events?: Maybe<Array<EmailEvent>>;
  from: EmailParty;
  id?: Maybe<Scalars['ID']['output']>;
  includeListUnsubscribe?: Maybe<Scalars['Boolean']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  messengerMessageIds?: Maybe<Array<Scalars['String']['output']>>;
  organizationId: Scalars['ID']['output'];
  organizationLinkInvitationIds?: Maybe<Array<Scalars['ID']['output']>>;
  processId?: Maybe<Scalars['ID']['output']>;
  processName?: Maybe<Scalars['String']['output']>;
  processOrganizationId?: Maybe<Scalars['ID']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<EmailParty>;
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  ruleId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
  taskStateIds?: Maybe<Array<Scalars['ID']['output']>>;
  templateId?: Maybe<Scalars['ID']['output']>;
  to: Array<EmailParty>;
  userIds?: Maybe<Array<UserId>>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class EmailEvent {
  __typename?: 'EmailEvent';
  date: Scalars['AnkaadiaDateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stopReason?: Maybe<EmailStopReason>;
  type: EmailEventType;
};

export enum EmailEventType {
  Blocked = 'Blocked',
  Bounced = 'Bounced',
  Delivered = 'Delivered',
  Dropped = 'Dropped',
  Failed = 'Failed',
  NotSent = 'NotSent',
  Opened = 'Opened',
  OptedOut = 'OptedOut',
  Resent = 'Resent',
  Sent = 'Sent',
  Stopped = 'Stopped'
}

export class EmailForList {
  __typename?: 'EmailForList';
  _etag?: Maybe<Scalars['String']['output']>;
  actualProcessId?: Maybe<Scalars['ID']['output']>;
  attachDownloadableTaskFiles?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<FileAttachment>>;
  bcc?: Maybe<Array<EmailParty>>;
  candidateIds?: Maybe<Array<CandidateId>>;
  cc?: Maybe<Array<EmailParty>>;
  events?: Maybe<Array<EmailEvent>>;
  from: EmailParty;
  id?: Maybe<Scalars['ID']['output']>;
  includeListUnsubscribe?: Maybe<Scalars['Boolean']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  messengerMessageIds?: Maybe<Array<Scalars['String']['output']>>;
  organizationId: Scalars['ID']['output'];
  organizationLinkInvitationIds?: Maybe<Array<Scalars['ID']['output']>>;
  processId?: Maybe<Scalars['ID']['output']>;
  processName?: Maybe<Scalars['String']['output']>;
  processOrganizationId?: Maybe<Scalars['ID']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<EmailParty>;
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  ruleId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
  taskStateIds?: Maybe<Array<Scalars['ID']['output']>>;
  templateId?: Maybe<Scalars['ID']['output']>;
  to: Array<EmailParty>;
  userIds?: Maybe<Array<UserId>>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class EmailGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EmailListForCandidateInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EmailListForOrganizationLinkInvitationInput {
  invitationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EmailListForProcessInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class EmailListForUserInput {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export class EmailListSendInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class EmailParty {
  __typename?: 'EmailParty';
  allowUninvited?: Maybe<Scalars['Boolean']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  invited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optedIn?: Maybe<Scalars['Boolean']['output']>;
};

export class EmailSendInput {
  body: Scalars['String']['input'];
  emailId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export class EmailSendOutRule {
  __typename?: 'EmailSendOutRule';
  _etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  matchedRolesOnly?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  recipientRoles: Scalars['JSON']['output'];
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  template: Scalars['String']['output'];
};

export class EmailSendOutRuleCreateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matchedRolesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientRoles: Scalars['JSON']['input'];
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  template: Scalars['String']['input'];
};

export class EmailSendOutRuleInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matchedRolesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientRoles: Scalars['JSON']['input'];
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  template: Scalars['String']['input'];
};

export class EmailSendOutRuleUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matchedRolesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientRoles: Scalars['JSON']['input'];
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  template: Scalars['String']['input'];
};

export enum EmailStopReason {
  Manual = 'Manual',
  Skipped = 'Skipped',
  TestProcess = 'TestProcess'
}

export class EmailTemplate {
  __typename?: 'EmailTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  allowSendToUninvitedCandidates?: Maybe<Scalars['Boolean']['output']>;
  autoTranslate?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isContentTemplate?: Maybe<Scalars['Boolean']['output']>;
  items: Array<EmailTemplateItem>;
  organizationId: Scalars['ID']['output'];
  sendSeparateUserEmailsForEachCandidate?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<EmailTemplateTarget>;
  type: EmailTemplateType;
};

export class EmailTemplateCreateInput {
  allowSendToUninvitedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  isContentTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<EmailTemplateItemInput>;
  organizationId: Scalars['ID']['input'];
  sendSeparateUserEmailsForEachCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<EmailTemplateTarget>;
  type: EmailTemplateType;
};

export class EmailTemplateDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EmailTemplateDescription {
  __typename?: 'EmailTemplateDescription';
  condition?: Maybe<Scalars['String']['output']>;
  conditionExplanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matchedRolesOnly?: Maybe<Scalars['Boolean']['output']>;
  recipientRoles: Scalars['JSON']['output'];
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  template: Scalars['String']['output'];
};

export class EmailTemplateDescriptionInput {
  condition?: InputMaybe<Scalars['String']['input']>;
  conditionExplanation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  matchedRolesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles: Scalars['JSON']['input'];
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  state: Array<InstanceStateEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  template: Scalars['String']['input'];
};

export class EmailTemplateDuplicateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EmailTemplateGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class EmailTemplateItem {
  __typename?: 'EmailTemplateItem';
  contents?: Maybe<Scalars['String']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export class EmailTemplateItemInput {
  contents?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export class EmailTemplateListInput {
  organizationId: Scalars['ID']['input'];
};

export class EmailTemplateMutationResult {
  __typename?: 'EmailTemplateMutationResult';
  template?: Maybe<EmailTemplate>;
  validationErrorMessage?: Maybe<Scalars['String']['output']>;
  validationWarningMessage?: Maybe<Scalars['String']['output']>;
};

export class EmailTemplateProcessUsageInput {
  displayName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EmailTemplateRender {
  __typename?: 'EmailTemplateRender';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export class EmailTemplateRenderInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  customHtml?: InputMaybe<Scalars['String']['input']>;
  customSubject?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  roles: Array<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export enum EmailTemplateTarget {
  Candidate = 'Candidate',
  NewUser = 'NewUser',
  Participant = 'Participant',
  SpecialPurpose = 'SpecialPurpose'
}

export enum EmailTemplateType {
  Automatic = 'Automatic',
  Draft = 'Draft',
  Layout = 'Layout'
}

export class EmailTemplateTypeInput {
  organizationId: Scalars['ID']['input'];
  type: EmailTemplateType;
};

export class EmailTemplateUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowSendToUninvitedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoTranslate?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isContentTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<EmailTemplateItemInput>;
  organizationId: Scalars['ID']['input'];
  sendSeparateUserEmailsForEachCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<EmailTemplateTarget>;
  type: EmailTemplateType;
};

export class EmailTemplateWithUsageInfo {
  __typename?: 'EmailTemplateWithUsageInfo';
  _etag?: Maybe<Scalars['String']['output']>;
  allowSendToUninvitedCandidates?: Maybe<Scalars['Boolean']['output']>;
  autoTranslate?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isContentTemplate?: Maybe<Scalars['Boolean']['output']>;
  isDefaultTemplate?: Maybe<Scalars['Boolean']['output']>;
  isUsedInProcess?: Maybe<Scalars['Boolean']['output']>;
  isUsedInSendOutRules?: Maybe<Scalars['Boolean']['output']>;
  items: Array<EmailTemplateItem>;
  organizationId: Scalars['ID']['output'];
  sendSeparateUserEmailsForEachCandidate?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<EmailTemplateTarget>;
  type: EmailTemplateType;
};

export class Employer {
  __typename?: 'Employer';
  description: Array<OrganizationProfileDescription>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  locations: Array<EmployerLocation>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

export class EmployerApplication {
  __typename?: 'EmployerApplication';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  coverLetter?: Maybe<Scalars['String']['output']>;
  date: Scalars['AnkaadiaDateTime']['output'];
  employerOrganizationId: Scalars['ID']['output'];
  employerOrganizationName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  selectedLocations: Array<Scalars['String']['output']>;
  selectedPosition?: Maybe<Scalars['String']['output']>;
};

export class EmployerApplicationGetInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EmployerApplicationInput {
  candidateId: Scalars['ID']['input'];
  coverLetter?: InputMaybe<Scalars['String']['input']>;
  employerOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  selectedLocations: Array<Scalars['String']['input']>;
  selectedPosition: Scalars['String']['input'];
};

export class EmployerData {
  __typename?: 'EmployerData';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export class EmployerDataInput {
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export class EmployerFilterDefaults {
  __typename?: 'EmployerFilterDefaults';
  candidateId?: Maybe<Scalars['ID']['output']>;
  careFacility?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Array<Scalars['String']['output']>>;
  employmentType?: Maybe<Array<EmploymentRelationshipType>>;
  experienceField?: Maybe<Array<Scalars['String']['output']>>;
  interviewLanguageLevel?: Maybe<Array<Scalars['String']['output']>>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  pathOfRecognition?: Maybe<Array<Scalars['String']['output']>>;
  state?: Maybe<Array<Scalars['String']['output']>>;
  temporalScope?: Maybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: Maybe<Array<Scalars['String']['output']>>;
};

export class EmployerFilterFields {
  __typename?: 'EmployerFilterFields';
  careFacility: Scalars['Boolean']['output'];
  city: Scalars['Boolean']['output'];
  employmentType: Scalars['Boolean']['output'];
  experienceField: Scalars['Boolean']['output'];
  interviewLanguageLevel: Scalars['Boolean']['output'];
  pathOfRecognition: Scalars['Boolean']['output'];
  state: Scalars['Boolean']['output'];
  temporalScope: Scalars['Boolean']['output'];
  transferLanguageLevel: Scalars['Boolean']['output'];
};

export class EmployerGetInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  careFacility?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  employerOrganizationId: Scalars['ID']['input'];
  employmentType?: InputMaybe<Array<EmploymentRelationshipType>>;
  experienceField?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewLanguageLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  pathOfRecognition?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  temporalScope?: InputMaybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class EmployerHistoryEntry {
  __typename?: 'EmployerHistoryEntry';
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  employerId: Scalars['ID']['output'];
  employerName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class EmployerHistoryEntryInput {
  createdAt: Scalars['AnkaadiaDateTime']['input'];
  employerId: Scalars['ID']['input'];
  employerName: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class EmployerListInput {
  candidateId: Scalars['ID']['input'];
  careFacility?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  employmentType?: InputMaybe<Array<EmploymentRelationshipType>>;
  experienceField?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewLanguageLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  pathOfRecognition?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  temporalScope?: InputMaybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class EmployerLocation {
  __typename?: 'EmployerLocation';
  address: Scalars['String']['output'];
  beds?: Maybe<Scalars['Float']['output']>;
  careFacility?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  experienceField?: Maybe<Array<Scalars['String']['output']>>;
  hasInternationalExperience: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  measuresAndInstrumentsForIntegration?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfHiresAtLocation?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vacancies: Array<EmployerLocationVacancy>;
  website?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export class EmployerLocationVacancy {
  __typename?: 'EmployerLocationVacancy';
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  countryOfOrigin?: Maybe<Array<Scalars['String']['output']>>;
  employmentType?: Maybe<Array<EmploymentRelationshipType>>;
  function?: Maybe<Array<Scalars['String']['output']>>;
  interviewLanguageLevel?: Maybe<Scalars['String']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  requiredStaff?: Maybe<Array<Scalars['String']['output']>>;
  requiredStaffAmount?: Maybe<Scalars['Float']['output']>;
  temporalScope?: Maybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: Maybe<Scalars['String']['output']>;
};

export class EmploymentApprovalAuthority {
  __typename?: 'EmploymentApprovalAuthority';
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  responsibility: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export class EmploymentApprovalAuthorityByIdInput {
  id: Scalars['String']['input'];
  immigrationCountry: SupportedImmigrationCountry;
  organizationId: Scalars['String']['input'];
};

export class EmploymentApprovalAuthorityInput {
  immigrationCountry: SupportedImmigrationCountry;
  organizationId: Scalars['String']['input'];
};

export class EmploymentRelationship {
  __typename?: 'EmploymentRelationship';
  afterRecognition?: Maybe<AfterRecognition>;
  beforeRecognition?: Maybe<BeforeRecognition>;
  hasDifferentRelationships?: Maybe<Scalars['Boolean']['output']>;
};

export class EmploymentRelationshipInput {
  afterRecognition?: InputMaybe<AfterRecognitionInput>;
  beforeRecognition?: InputMaybe<BeforeRecognitionInput>;
  hasDifferentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EmploymentRelationshipType {
  Internship = 'Internship',
  JobShadowing = 'JobShadowing',
  Permanent = 'Permanent',
  SecondJob = 'SecondJob',
  Temporary = 'Temporary'
}

export class EnableMatchingInput {
  destinationOrganizationId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export class EndAndReplaceRecurringFeeInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  endDate: Scalars['UTCDate']['input'];
  endingFeeId: Scalars['String']['input'];
  replacement: RecurringFeeInput;
};

export class EndDiscountInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
};

export enum EnterMissingInformation {
  ArrivalDate = 'ArrivalDate',
  BankAppointmentDate = 'BankAppointmentDate',
  CompanyDoctorAppointmentDate = 'CompanyDoctorAppointmentDate',
  EndOfComplementaryMeasure = 'EndOfComplementaryMeasure',
  EndOfFurtherEducation = 'EndOfFurtherEducation',
  EndOfProbationDate = 'EndOfProbationDate',
  EquivalenceTest = 'EquivalenceTest',
  EstimatedArrivalDate = 'EstimatedArrivalDate',
  EstimatedWorkStartDate = 'EstimatedWorkStartDate',
  ExamInstitution = 'ExamInstitution',
  FederalState = 'FederalState',
  FederalStateAt = 'FederalStateAt',
  FingerPrintDate = 'FingerPrintDate',
  FirstExamDate = 'FirstExamDate',
  FirstExamPassed = 'FirstExamPassed',
  FirstFinalInterviewDate = 'FirstFinalInterviewDate',
  FirstFinalInterviewPassed = 'FirstFinalInterviewPassed',
  FlightDate = 'FlightDate',
  HealthProfessionRegisterAppointmentDate = 'HealthProfessionRegisterAppointmentDate',
  HealthProfessionRegisterSubmission = 'HealthProfessionRegisterSubmission',
  HealthProfessionRegistrationDate = 'HealthProfessionRegistrationDate',
  ImmigrationAuthority = 'ImmigrationAuthority',
  LegalBasis = 'LegalBasis',
  LocationOfComplementaryMeasure = 'LocationOfComplementaryMeasure',
  MedicalExaminationAppointmentDate = 'MedicalExaminationAppointmentDate',
  NoQualificationEvaluation = 'NoQualificationEvaluation',
  PathOfRecognition = 'PathOfRecognition',
  PathOfRecognitionAt = 'PathOfRecognitionAt',
  PickUpDetails = 'PickUpDetails',
  PlannedEntryDate = 'PlannedEntryDate',
  PoliceRecordAppointmentDate = 'PoliceRecordAppointmentDate',
  PsaFirstDeputy = 'PsaFirstDeputy',
  PsaRepresentative = 'PsaRepresentative',
  QualificationMeasure = 'QualificationMeasure',
  QualificationType = 'QualificationType',
  RatingAptitude = 'RatingAptitude',
  RatingExperience = 'RatingExperience',
  RatingLanguage = 'RatingLanguage',
  RecognitionAuthority = 'RecognitionAuthority',
  RecognitionAuthorityAt = 'RecognitionAuthorityAt',
  RecognitionFileNumber = 'RecognitionFileNumber',
  RecognitionFileNumberAcceleratedProcedure = 'RecognitionFileNumberAcceleratedProcedure',
  RecognitionPaymentRole = 'RecognitionPaymentRole',
  RecognitionPaymentRoleAccelerated = 'RecognitionPaymentRoleAccelerated',
  RecognitionType = 'RecognitionType',
  RegistrationOfficeDate = 'RegistrationOfficeDate',
  ResidencePermit = 'ResidencePermit',
  ResponsibleRecognitionOrganization = 'ResponsibleRecognitionOrganization',
  ResponsibleRoleLaborMarket = 'ResponsibleRoleLaborMarket',
  ResponsibleRoleQualification = 'ResponsibleRoleQualification',
  ResponsibleRoleQualificationEvaluation = 'ResponsibleRoleQualificationEvaluation',
  ResponsibleRoleQualificationEvaluationPayment = 'ResponsibleRoleQualificationEvaluationPayment',
  ResponsibleRoleRecognition = 'ResponsibleRoleRecognition',
  ResponsibleRoleResidence = 'ResponsibleRoleResidence',
  ResponsibleRoleVisa = 'ResponsibleRoleVisa',
  RwrCardFileNumber = 'RwrCardFileNumber',
  StartOfComplementaryMeasure = 'StartOfComplementaryMeasure',
  StartOfFurtherEducation = 'StartOfFurtherEducation',
  TargetRecognition = 'TargetRecognition',
  WorkConfirmationSignedDate = 'WorkConfirmationSignedDate',
  WorkContractSignDate = 'WorkContractSignDate',
  WorkContractStartDate = 'WorkContractStartDate',
  WorkContractTypeOfWorkLocation = 'WorkContractTypeOfWorkLocation',
  WorkContractWorkLocation = 'WorkContractWorkLocation',
  WorkEmployer = 'WorkEmployer',
  WorkEmployerAt = 'WorkEmployerAt',
  WorkStartDate = 'WorkStartDate'
}

export class EnterMissingInformationPreview {
  __typename?: 'EnterMissingInformationPreview';
  previews: Array<CandidateMultiEditPreview>;
  totalCandidates: Scalars['Float']['output'];
};

export class EnterMissingInformationPreviewInput {
  organizationId: Scalars['ID']['input'];
  requiredInformation: Scalars['JSONObject']['input'];
  selectedChildTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId: Scalars['ID']['input'];
};

export class EnterMissingInformationRequestedInformation {
  __typename?: 'EnterMissingInformationRequestedInformation';
  canAdd?: Maybe<Scalars['Boolean']['output']>;
  canRemove?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<EnterMissingInformationRequestedInformation>>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  isReadonly?: Maybe<Scalars['Boolean']['output']>;
  propertyPath: Scalars['String']['output'];
};

export class EnterMissingInformationRequiredInformationInput {
  canAdd?: InputMaybe<Scalars['Boolean']['input']>;
  canRemove?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  propertyPath: Scalars['String']['input'];
};

export class EnterMissingInformationV2MultiEditBaseline {
  __typename?: 'EnterMissingInformationV2MultiEditBaseline';
  candidateOrganizationId?: Maybe<Scalars['String']['output']>;
  childEntityData?: Maybe<Scalars['JSONObject']['output']>;
  data?: Maybe<Scalars['JSONObject']['output']>;
};

export class EnterMissingInformationV2MultiEditBaselineInput {
  organizationId: Scalars['ID']['input'];
  selectedChildTaskIds: Array<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export class EnterMissingInformationV2Preview {
  __typename?: 'EnterMissingInformationV2Preview';
  previews: Array<CandidateMultiEditPreview>;
  totalCandidates: Scalars['Float']['output'];
};

export class EnterMissingInformationV2PreviewInput {
  data: Scalars['JSONObject']['input'];
  organizationId: Scalars['ID']['input'];
  selectedChildTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId: Scalars['ID']['input'];
};

export class EquivalentDegrees {
  __typename?: 'EquivalentDegrees';
  comment?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  equivalence?: Maybe<Scalars['String']['output']>;
};

export class EscoSkillByProfessionAndOrganizationInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  professionId: Scalars['String']['input'];
};

export class EscoSkillByProfessionInput {
  language: Scalars['String']['input'];
  professionId: Scalars['String']['input'];
};

export enum ExamModuleType {
  Listening = 'Listening',
  Oral = 'Oral',
  Reading = 'Reading',
  Speaking = 'Speaking',
  Writing = 'Writing',
  Written = 'Written'
}

export enum ExamStatus {
  Active = 'Active',
  Finished = 'Finished'
}

export enum ExamType {
  ExamSimulation = 'ExamSimulation',
  ExternalCertifiedExam = 'ExternalCertifiedExam',
  InternalExam = 'InternalExam',
  PlacementTest = 'PlacementTest'
}

export class ExcelAddInBillingDataInput {
  allOrganizations: Scalars['Boolean']['input'];
  fromDate: Scalars['UTCDate']['input'];
  includeVirtualBookings: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  tables: Array<BillingTableType>;
  toDate: Scalars['UTCDate']['input'];
};

export class ExcelAddInDto {
  __typename?: 'ExcelAddInDTO';
  dataTables: Array<ExcelTable>;
};

export type ExcelAddInEvent = ExcelAddInDto | ProgressEvent;

export class ExcelAddInGetCandidateDataInput {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionOwnerId?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tableMode: TableMode;
};

export class ExcelAddInLingokingDataInput {
  fromDate: Scalars['UTCDate']['input'];
  language: Scalars['String']['input'];
  organizationIds: Array<Scalars['String']['input']>;
  tables: Array<LingokingTableType>;
  toDate: Scalars['UTCDate']['input'];
};

export class ExcelAddInSalesDataInput {
  fromDate: Scalars['UTCDate']['input'];
  includeAllOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tables: Array<SalesTableType>;
  toDate: Scalars['UTCDate']['input'];
};

export class ExcelAddinGetChangeStatisticsInput {
  fromDate: Scalars['UTCDate']['input'];
  language: Scalars['String']['input'];
  toDate: Scalars['UTCDate']['input'];
};

export class ExcelColumn {
  __typename?: 'ExcelColumn';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export class ExcelTable {
  __typename?: 'ExcelTable';
  columns?: Maybe<Array<ExcelColumn>>;
  dataCells: Array<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export class ExperienceData {
  __typename?: 'ExperienceData';
  country?: Maybe<Scalars['String']['output']>;
  experienceEndDate?: Maybe<Scalars['UTCDate']['output']>;
  experienceFacility?: Maybe<Scalars['String']['output']>;
  experienceFields?: Maybe<Array<Scalars['String']['output']>>;
  experienceFunction?: Maybe<Scalars['String']['output']>;
  experienceMonth?: Maybe<Scalars['Float']['output']>;
  experienceStartDate?: Maybe<Scalars['UTCDate']['output']>;
  experienceYears?: Maybe<Scalars['Float']['output']>;
  occupation: Scalars['String']['output'];
  occupationOther?: Maybe<Scalars['String']['output']>;
  typeOfEmployment?: Maybe<Array<TypeOfEmployment>>;
};

export enum ExperienceType {
  Normal = 'Normal',
  OtherActivities = 'OtherActivities'
}

export class ExplanationAvailability {
  __typename?: 'ExplanationAvailability';
  available: Scalars['Boolean']['output'];
  pendingCount: Scalars['Int']['output'];
  reason: ExplanationUnavailableReason;
};

export class ExplanationAvailabilityInput {
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['String']['input'];
};

export enum ExplanationUnavailableReason {
  FeatureOff = 'FeatureOff',
  NoModelConfigured = 'NoModelConfigured',
  Ok = 'Ok',
  ProviderUnavailable = 'ProviderUnavailable'
}

export class ExportAssetInput {
  assetType: Asset;
};

export enum ExportCategoryEnum {
  CandidateFiles = 'CandidateFiles',
  Processes = 'Processes'
}

export class ExportStaticDataInput {
  lang: Scalars['String']['input'];
};

export enum ExpressionType {
  ActivationCondition = 'ActivationCondition',
  EmailCondition = 'EmailCondition',
  PropertyValue = 'PropertyValue',
  RuleRunCondition = 'RuleRunCondition'
}

export enum EzbDataSharingMode {
  Share = 'Share'
}

export class Favorite {
  __typename?: 'Favorite';
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionOrganizationId?: Maybe<Scalars['ID']['output']>;
  isFavorite: Scalars['Boolean']['output'];
  isReadonly: Scalars['Boolean']['output'];
};

export class FavoriteCandidateInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class FavoriteCollectionInput {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class FavoriteCollectionsInput {
  collections: Array<CollectionIdInput>;
};

export class FavoriteCollectionsWithSharingByOrgInput {
  organizationId: Scalars['ID']['input'];
  sharedToOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class Feedback {
  __typename?: 'Feedback';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  comments: Array<Comment>;
  destinationOrganizationId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  interviewConducted?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  sharingId: Scalars['ID']['output'];
  statusPhaseOne?: Maybe<FeedbackStatusPhaseOne>;
  statusPhaseOneAuthor?: Maybe<Scalars['String']['output']>;
  statusPhaseOneDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  statusPhaseTwo?: Maybe<FeedbackStatusPhaseTwo>;
  statusPhaseTwoAuthor?: Maybe<Scalars['String']['output']>;
  statusPhaseTwoDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
};

export class FeedbackCreateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  destinationOrganizationId: Scalars['ID']['input'];
  interviewConducted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
  statusPhaseOne?: InputMaybe<FeedbackStatusPhaseOne>;
  statusPhaseOneAuthor?: InputMaybe<Scalars['String']['input']>;
  statusPhaseOneDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  statusPhaseTwo?: InputMaybe<FeedbackStatusPhaseTwo>;
  statusPhaseTwoAuthor?: InputMaybe<Scalars['String']['input']>;
  statusPhaseTwoDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
};

export class FeedbackData {
  __typename?: 'FeedbackData';
  candidateFeedback?: Maybe<FeedbackDetailsData>;
  id?: Maybe<Scalars['ID']['output']>;
  interviewDate?: Maybe<DateWithTime>;
  interviewerFeedback?: Maybe<FeedbackDetailsData>;
  multiEditBatchId?: Maybe<Scalars['ID']['output']>;
  participants?: Maybe<Array<Scalars['String']['output']>>;
  taskId?: Maybe<Scalars['ID']['output']>;
};

export class FeedbackDataInput {
  candidateFeedback?: InputMaybe<FeedbackDetailsDataInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interviewDate?: InputMaybe<DateWithTimeInput>;
  interviewerFeedback?: InputMaybe<FeedbackDetailsDataInput>;
  multiEditBatchId?: InputMaybe<Scalars['ID']['input']>;
  participants?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export class FeedbackDetailsData {
  __typename?: 'FeedbackDetailsData';
  comment?: Maybe<Scalars['String']['output']>;
  vote?: Maybe<VoteType>;
};

export class FeedbackDetailsDataInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  vote?: InputMaybe<VoteType>;
};

export class FeedbackIterationData {
  __typename?: 'FeedbackIterationData';
  comments?: Maybe<Array<CommentData>>;
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  createdByMultiEditBatchId?: Maybe<Scalars['ID']['output']>;
  employer?: Maybe<EmployerData>;
  feedbacks?: Maybe<Array<FeedbackData>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export class FeedbackIterationDataInput {
  comments?: InputMaybe<Array<CommentDataInput>>;
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  createdByMultiEditBatchId?: InputMaybe<Scalars['ID']['input']>;
  employer?: InputMaybe<EmployerDataInput>;
  feedbacks?: InputMaybe<Array<FeedbackDataInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export class FeedbackReportInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
};

export enum FeedbackStatusPhaseOne {
  Backlogged = 'Backlogged',
  InterviewRequested = 'InterviewRequested',
  Rejected = 'Rejected'
}

export enum FeedbackStatusPhaseTwo {
  Rejected = 'Rejected',
  Selected = 'Selected'
}

export class FeedbackUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  destinationOrganizationId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  interviewConducted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
  statusPhaseOne?: InputMaybe<FeedbackStatusPhaseOne>;
  statusPhaseOneAuthor?: InputMaybe<Scalars['String']['input']>;
  statusPhaseOneDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  statusPhaseTwo?: InputMaybe<FeedbackStatusPhaseTwo>;
  statusPhaseTwoAuthor?: InputMaybe<Scalars['String']['input']>;
  statusPhaseTwoDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
};

export class FieldActivityDiffInput {
  entityId: Scalars['ID']['input'];
  entityTypeName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  parentEntryId?: InputMaybe<Scalars['ID']['input']>;
  parentPath?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};

export class FieldApplicabilityRule {
  __typename?: 'FieldApplicabilityRule';
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  in?: Maybe<Array<Scalars['String']['output']>>;
  negate?: Maybe<Scalars['Boolean']['output']>;
  notIn?: Maybe<Array<Scalars['String']['output']>>;
  onlyFor?: Maybe<Scalars['String']['output']>;
  predicate?: Maybe<Scalars['String']['output']>;
  whenAbsent?: Maybe<Scalars['String']['output']>;
};

export class FieldRequiredByTemplates {
  __typename?: 'FieldRequiredByTemplates';
  key: Scalars['String']['output'];
  templates: Array<RequiredByTemplateReference>;
};

export class FieldsRequiredByTemplatesInput {
  organizationId: Scalars['ID']['input'];
};

export enum FileAccess {
  Full = 'Full',
  None = 'None'
}

export class FileAccessInfo {
  __typename?: 'FileAccessInfo';
  access: FileAccess;
};

export class FileAdjustment {
  __typename?: 'FileAdjustment';
  adjustmentType: FileAdjustmentType;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  originalMimeType: Scalars['String']['output'];
  originalSizeBytes: Scalars['Float']['output'];
  resultFileName: Scalars['String']['output'];
  resultMimeType: Scalars['String']['output'];
  resultSizeBytes: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export enum FileAdjustmentType {
  Compressed = 'Compressed',
  Converted = 'Converted',
  ConvertedAndCompressed = 'ConvertedAndCompressed',
  Failed = 'Failed',
  NoChange = 'NoChange'
}

export class FileAttachment {
  __typename?: 'FileAttachment';
  containerName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fileId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  templateName?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<DocumentTemplateType>;
};

export class FileAttachmentInput {
  containerName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<DocumentTemplateType>;
};

export class FileIdentifier {
  __typename?: 'FileIdentifier';
  documentType: Scalars['String']['output'];
  familyMemberId?: Maybe<Scalars['String']['output']>;
  organizationContact?: Maybe<Scalars['String']['output']>;
  setTypeAsString?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export class FindChatsInput {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export class FinishEmitEvent {
  __typename?: 'FinishEmitEvent';
  contextTokens?: Maybe<Scalars['Int']['output']>;
  isContextTokensEstimated?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export class FloorCorrectionEntity {
  __typename?: 'FloorCorrectionEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  accumulatedPrior: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  month: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  remainingFloor: Scalars['Float']['output'];
  remainingPeriods?: Maybe<Scalars['Int']['output']>;
  targetOrganizationId: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

export class FloorCorrectionInput {
  accumulatedPrior: Scalars['Float']['input'];
  month: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  remainingFloor: Scalars['Float']['input'];
  remainingPeriods?: InputMaybe<Scalars['Int']['input']>;
  targetOrganizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export enum FloorPaymentType {
  AtEndOfContractYear = 'AtEndOfContractYear',
  EquallyDistributedPerPeriodInAdvance = 'EquallyDistributedPerPeriodInAdvance',
  EquallyDistributedPerPeriodInArrears = 'EquallyDistributedPerPeriodInArrears',
  EquallyDistributedPerPeriodInArrearsWithFloorStop = 'EquallyDistributedPerPeriodInArrearsWithFloorStop'
}

export class FurtherEducationData {
  __typename?: 'FurtherEducationData';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  fieldOfEducation?: Maybe<Scalars['String']['output']>;
  nameOfEducation?: Maybe<Scalars['String']['output']>;
  nameOfInstitution?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class GeneralBrokerAddOnConfig {
  __typename?: 'GeneralBrokerAddOnConfig';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  disableBrokerMandateForCandidates?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class GeneralBrokerAddOnConfigGetInput {
  organizationId: Scalars['ID']['input'];
};

export class GeneralBrokerAddOnConfigSetInput {
  disableBrokerMandateForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class GeneralDocumentRequirement {
  __typename?: 'GeneralDocumentRequirement';
  _etag?: Maybe<Scalars['String']['output']>;
  documentFormatEqualityMapping?: Maybe<Array<DocumentFormatEqualityMapping>>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class GeneralDocumentRequirementInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  documentFormatEqualityMapping?: InputMaybe<Array<DocumentFormatEqualityMappingInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class GenerateActivationConditionInput {
  clarificationAnswers?: InputMaybe<Array<ClarificationAnswerInput>>;
  description: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processModelId: Scalars['String']['input'];
  resolvedAmbiguities?: InputMaybe<Scalars['JSON']['input']>;
  taskModelId: Scalars['String']['input'];
};

export class GenerateActivationConditionResult {
  __typename?: 'GenerateActivationConditionResult';
  cacheCreationTokens?: Maybe<Scalars['Int']['output']>;
  cacheReadTokens?: Maybe<Scalars['Int']['output']>;
  clarificationQuestions?: Maybe<Array<ClarificationQuestion>>;
  confidence?: Maybe<Scalars['Float']['output']>;
  declineAttemptedApproach?: Maybe<Scalars['String']['output']>;
  declineContext?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  declineSuggestion?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  iterationCount: Scalars['Int']['output'];
  latencyMs: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  tokensUsed: Scalars['Int']['output'];
  type: AiResponseType;
  valid?: Maybe<Scalars['Boolean']['output']>;
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export class GenerateCvAsDocxResponse {
  __typename?: 'GenerateCVAsDocxResponse';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateTemplateReportEvent = GenerateTemplateReportResult | ProgressEvent;

export class GenerateTemplateReportInput {
  CandidatePageInput?: InputMaybe<CandidatePageInput>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  conversionType?: InputMaybe<TemplateToDocumentTypeConversion>;
  generationStrategy?: InputMaybe<DataStrategyGenerationDescription>;
  mailReport?: InputMaybe<Scalars['Boolean']['input']>;
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
  templateOrganizationId: Scalars['ID']['input'];
};

export class GenerateTemplateReportResult {
  __typename?: 'GenerateTemplateReportResult';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  status: DocumentTemplateStatus;
  warnings?: Maybe<Array<DocumentTemplateWarning>>;
  willBeMailt?: Maybe<Scalars['Boolean']['output']>;
};

export class GeoZipCode {
  __typename?: 'GeoZipCode';
  city: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  state: Scalars['String']['output'];
};

export class GeoZipCodeInput {
  country: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export class GetAggregatedMilestoneStatesInput {
  candidateFilter?: InputMaybe<Scalars['JSONObject']['input']>;
  milestoneListId: Scalars['String']['input'];
  milestoneListOrganizationId: Scalars['String']['input'];
};

export class GetAllCandidateTasksOfTypeInput {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  taskType: Scalars['String']['input'];
};

export class GetApplicationMaskUploadUrl {
  fileName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetAttachableAutoCollectionsInput {
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export class GetCandidateColumnValuesInput {
  candidates: Array<CandidateColumnCandidateInput>;
  columns: Array<CandidateColumn>;
};

export class GetCandidateForEdit {
  candidateId: Scalars['ID']['input'];
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class GetCandidateInput {
  candidateId: Scalars['ID']['input'];
  internalMaskConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class GetCandidatesByDisplayIdInput {
  displayIds: Array<Scalars['String']['input']>;
  includeCandidatesOfOtherOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class GetCommentsInput {
  onlyLatest?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class GetDataStrategiesInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetDataStrategyConfigurationInput {
  dataStrategyId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetDataStrategyGenerationInput {
  dataStrategyId: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetDocumentTranslationStateForDocumentInput {
  allPending: Scalars['Boolean']['input'];
  candidateId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetDocumentTranslationStateForDocumentResult {
  __typename?: 'GetDocumentTranslationStateForDocumentResult';
  order: TranslationOrderDocument;
  state: DocumentTranslationState;
};

export class GetMilestoneCandidateStatesInput {
  candidateFilter?: InputMaybe<Scalars['JSONObject']['input']>;
  milestoneId: Scalars['String']['input'];
  milestoneListId: Scalars['String']['input'];
  milestoneListOrganizationId: Scalars['String']['input'];
};

export class GetMilestoneDataInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  milestoneListId: Scalars['String']['input'];
  milestoneOrganizationId: Scalars['String']['input'];
};

export class GetMyChatUserInput {
  createIfNotExists: Scalars['Boolean']['input'];
};

export class GetOutstandingConsentsInput {
  consentGiverId: Scalars['ID']['input'];
  consentIdentifier?: InputMaybe<KnownConsentIdentifiers>;
  organizationId: Scalars['ID']['input'];
  overwriteRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export class GetQueueInfoInput {
  onlyWaiting: Scalars['Boolean']['input'];
  queueName: QueueType;
};

export class GetRequiredConsentsInput {
  consentGiverId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GetSigningInitiationRolesInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  templateNames: Array<Scalars['String']['input']>;
};

export class GetSigningInitiationTemplateInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
};

export class GetTaskReferenceByInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class GetTranslationOrderOverviewInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  mode: TranslationOrderOverviewMode;
  organizationId: Scalars['ID']['input'];
};

export class GiveConsentInput {
  accepted: Scalars['Boolean']['input'];
  chosenLanguage?: InputMaybe<Scalars['String']['input']>;
  consentGiverId: Scalars['ID']['input'];
  consentIdentifier: KnownConsentIdentifiers;
  consentOptionsClicked?: InputMaybe<Array<Scalars['String']['input']>>;
  consentVersion: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  signatureBase64?: InputMaybe<Scalars['String']['input']>;
};

export class GlobalMilestone {
  __typename?: 'GlobalMilestone';
  defaultDurationInDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName?: Maybe<Array<ProcessModelString>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  visibility?: Maybe<Array<MilestoneVisibility>>;
};

export class GlobalMilestoneInput {
  defaultDurationInDays?: InputMaybe<Scalars['Float']['input']>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  visibility?: InputMaybe<Array<MilestoneVisibility>>;
};

export class GlobalMilestoneMapping {
  __typename?: 'GlobalMilestoneMapping';
  mappingIdentifier: Array<TaskIdentifierInput>;
  milestoneId: Scalars['ID']['output'];
};

export class GlobalMilestoneMappingInput {
  mappingIdentifier: Array<MappingIdentifier>;
  milestoneId: Scalars['ID']['input'];
};

export class GlobalMilestoneWithMeta {
  __typename?: 'GlobalMilestoneWithMeta';
  activeTaskIds?: Maybe<Array<TaskIdentifier>>;
  avgDurationInDays?: Maybe<Scalars['Float']['output']>;
  defaultDurationInDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName?: Maybe<Array<ProcessModelString>>;
  endDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  localizedName: Scalars['String']['output'];
  status?: Maybe<MilestoneStatus>;
  visibility?: Maybe<Array<MilestoneVisibility>>;
};

export enum GlobalTalentPoolCategory {
  Employer = 'Employer',
  Psa = 'PSA'
}

export class GovernanceCandidateData {
  __typename?: 'GovernanceCandidateData';
  communicationLanguage?: Maybe<Scalars['String']['output']>;
  matching?: Maybe<MatchingStatus>;
  profileDataEditStatus?: Maybe<ProfileDataEditStatus>;
};

export class GovernanceCandidateDataInput {
  communicationLanguage?: InputMaybe<Scalars['String']['input']>;
  matching?: InputMaybe<MatchingStatus>;
  profileDataEditStatus?: InputMaybe<ProfileDataEditStatus>;
};

export enum Granularity {
  AllTasks = 'AllTasks',
  Milestones = 'Milestones',
  VisibleTasks = 'VisibleTasks'
}

export class GroupWithOrgId {
  groupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class GuetegemeinschaftOrganizationLinkInput {
  organizationId: Scalars['ID']['input'];
};

export class GuetegemeinschaftOrganizationLinkOutput {
  __typename?: 'GuetegemeinschaftOrganizationLinkOutput';
  organizationId: Scalars['ID']['output'];
  processId: Scalars['ID']['output'];
};

export class GuetegemeinschaftOrganizationReCertificationInput {
  emailAddress: Scalars['String']['input'];
  emailAddress2: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  organizationType: Scalars['String']['input'];
  salutation: Scalars['String']['input'];
};

export class HasUserAccessToChatGroupInput {
  checkEdit?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class HealthProfessionsRegisterCandidateDataAt {
  __typename?: 'HealthProfessionsRegisterCandidateDataAT';
  appointmentDate?: Maybe<Scalars['UTCDate']['output']>;
  registrationDate?: Maybe<Scalars['UTCDate']['output']>;
  submission?: Maybe<Scalars['String']['output']>;
};

export class HealthProfessionsRegisterCandidateDataAtInput {
  appointmentDate?: InputMaybe<Scalars['UTCDate']['input']>;
  registrationDate?: InputMaybe<Scalars['UTCDate']['input']>;
  submission?: InputMaybe<Scalars['String']['input']>;
};

export class HighestPlacementEducationExam {
  __typename?: 'HighestPlacementEducationExam';
  examDateAndTime?: Maybe<DateWithTime>;
  languageLevel?: Maybe<Scalars['String']['output']>;
};

export class Housing {
  __typename?: 'Housing';
  additionalCosts?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  cancellationOfContractSignDate?: Maybe<Scalars['UTCDate']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coldRent?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyHandoverDateTime?: Maybe<DateWithTime>;
  movingInDate?: Maybe<Scalars['UTCDate']['output']>;
  movingOutDate?: Maybe<Scalars['UTCDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameOfContactPerson?: Maybe<Scalars['String']['output']>;
  operatingCosts?: Maybe<Scalars['Float']['output']>;
  phoneOfContactPerson?: Maybe<Scalars['String']['output']>;
  readinessForOccupancyDate?: Maybe<Scalars['UTCDate']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class HousingAcquisition {
  __typename?: 'HousingAcquisition';
  firstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  firstDeputyId?: Maybe<Scalars['ID']['output']>;
  firstDeputyLastName?: Maybe<Scalars['String']['output']>;
  firstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  housings?: Maybe<Array<Housing>>;
  representativeFirstName?: Maybe<Scalars['String']['output']>;
  representativeId?: Maybe<Scalars['ID']['output']>;
  representativeLastName?: Maybe<Scalars['String']['output']>;
  representativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleHousingAcquisition?: Maybe<Scalars['String']['output']>;
};

export class HousingAcquisitionInput {
  firstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  firstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  firstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  housings?: InputMaybe<Array<HousingInput>>;
  representativeFirstName?: InputMaybe<Scalars['String']['input']>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  representativeLastName?: InputMaybe<Scalars['String']['input']>;
  representativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleHousingAcquisition?: InputMaybe<Scalars['String']['input']>;
};

export class HousingInput {
  additionalCosts?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  cancellationOfContractSignDate?: InputMaybe<Scalars['UTCDate']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coldRent?: InputMaybe<Scalars['Float']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  keyHandoverDateTime?: InputMaybe<DateWithTimeInput>;
  movingInDate?: InputMaybe<Scalars['UTCDate']['input']>;
  movingOutDate?: InputMaybe<Scalars['UTCDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOfContactPerson?: InputMaybe<Scalars['String']['input']>;
  operatingCosts?: InputMaybe<Scalars['Float']['input']>;
  phoneOfContactPerson?: InputMaybe<Scalars['String']['input']>;
  readinessForOccupancyDate?: InputMaybe<Scalars['UTCDate']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class HumanResourcesData {
  __typename?: 'HumanResourcesData';
  contactPartnerFirstName?: Maybe<Scalars['String']['output']>;
  contactPartnerId?: Maybe<Scalars['ID']['output']>;
  contactPartnerLastName?: Maybe<Scalars['String']['output']>;
  contactPartnerOrganizationId?: Maybe<Scalars['ID']['output']>;
  personnelArea?: Maybe<Scalars['String']['output']>;
  personnelAreaOrganizationId?: Maybe<Scalars['ID']['output']>;
  personnelDepartment?: Maybe<Scalars['String']['output']>;
  personnelDepartmentOrganizationId?: Maybe<Scalars['ID']['output']>;
  personnelNumber?: Maybe<Scalars['String']['output']>;
  supervisorFirstName?: Maybe<Scalars['String']['output']>;
  supervisorId?: Maybe<Scalars['ID']['output']>;
  supervisorLastName?: Maybe<Scalars['String']['output']>;
  supervisorOrganizationId?: Maybe<Scalars['ID']['output']>;
  terminationEmploymentActor?: Maybe<TerminationEmploymentActor>;
  terminationEmploymentDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class HumanResourcesDataInput {
  contactPartnerFirstName?: InputMaybe<Scalars['String']['input']>;
  contactPartnerId?: InputMaybe<Scalars['ID']['input']>;
  contactPartnerLastName?: InputMaybe<Scalars['String']['input']>;
  contactPartnerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  personnelArea?: InputMaybe<Scalars['String']['input']>;
  personnelAreaOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  personnelDepartment?: InputMaybe<Scalars['String']['input']>;
  personnelDepartmentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  personnelNumber?: InputMaybe<Scalars['String']['input']>;
  supervisorFirstName?: InputMaybe<Scalars['String']['input']>;
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  supervisorLastName?: InputMaybe<Scalars['String']['input']>;
  supervisorOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  terminationEmploymentActor?: InputMaybe<TerminationEmploymentActor>;
  terminationEmploymentDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class ImageAccessInput {
  organizationId: Scalars['ID']['input'];
};

export class ImageAccessTokenResult {
  __typename?: 'ImageAccessTokenResult';
  expiresOn: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  origin: Scalars['String']['output'];
  sasToken: Scalars['String']['output'];
};

export class ImmigrationAuthority {
  __typename?: 'ImmigrationAuthority';
  id: Scalars['String']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export class ImmigrationAuthorityInput {
  federalStates?: InputMaybe<Array<Scalars['String']['input']>>;
  immigrationCountry: SupportedImmigrationCountry;
  organizationId: Scalars['String']['input'];
};

export class ImportUploadUrlResult {
  __typename?: 'ImportUploadUrlResult';
  url: Scalars['String']['output'];
};

export type ImportUploadUrlResultEvent = ImportUploadUrlResult | ProgressEvent;

export class ImportUrlInput {
  blob: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class InitiateSigningInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  signerMappings: Array<SignerMappingInput>;
  templateName: Scalars['String']['input'];
};

export enum InstanceStateEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Error = 'Error',
  Finished = 'Finished',
  Inactive = 'Inactive',
  Started = 'Started',
  Stopped = 'Stopped'
}

export class InternalCandidateData {
  __typename?: 'InternalCandidateData';
  billing?: Maybe<BillingData>;
  category?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  creditorNumber?: Maybe<Scalars['String']['output']>;
  headerComment?: Maybe<Scalars['String']['output']>;
  hr?: Maybe<HumanResourcesData>;
  isReplacementForCandidate?: Maybe<Scalars['Boolean']['output']>;
  languageSchooldId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<QuillContent>;
  placementPartnerOrganizationIds?: Maybe<Array<Scalars['ID']['output']>>;
  potentialEmployerOrganizationIds?: Maybe<Array<Scalars['ID']['output']>>;
  preferredEmployerOrganizationIds?: Maybe<Array<Scalars['ID']['output']>>;
  rating?: Maybe<CandidateInternalRatingData>;
  replacementForCandidateId?: Maybe<Scalars['ID']['output']>;
  replacementForDisplayId?: Maybe<Scalars['String']['output']>;
  replacementForDisplayName?: Maybe<Scalars['String']['output']>;
  replacementForOrganizationId?: Maybe<Scalars['String']['output']>;
  responsibleEmployees?: Maybe<Array<Scalars['ID']['output']>>;
  scholarships?: Maybe<Array<CandidateScholarship>>;
  sourceOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class InternalCandidateDataInput {
  billing?: InputMaybe<BillingDataInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  creditorNumber?: InputMaybe<Scalars['String']['input']>;
  headerComment?: InputMaybe<Scalars['String']['input']>;
  hr?: InputMaybe<HumanResourcesDataInput>;
  isReplacementForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  languageSchooldId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<QuillContentInput>;
  placementPartnerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  potentialEmployerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  preferredEmployerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rating?: InputMaybe<CandidateInternalRatingDataInput>;
  replacementForCandidateId?: InputMaybe<Scalars['ID']['input']>;
  replacementForDisplayId?: InputMaybe<Scalars['String']['input']>;
  replacementForDisplayName?: InputMaybe<Scalars['String']['input']>;
  replacementForOrganizationId?: InputMaybe<Scalars['String']['input']>;
  responsibleEmployees?: InputMaybe<Array<Scalars['ID']['input']>>;
  scholarships?: InputMaybe<Array<CandidateScholarshipInput>>;
  sourceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class InterviewFeedbackMultiEditBaseline {
  __typename?: 'InterviewFeedbackMultiEditBaseline';
  candidateOrganizationId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSONObject']['output']>;
};

export class InterviewFeedbackMultiEditBaselineInput {
  organizationId: Scalars['ID']['input'];
  selectedChildTaskIds: Array<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export class Invoice {
  __typename?: 'Invoice';
  _etag?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  billingPeriodEndDate: Scalars['UTCDate']['output'];
  billingPeriodStartDate: Scalars['UTCDate']['output'];
  bookings: Array<Scalars['ID']['output']>;
  contractId: Scalars['ID']['output'];
  currency: SupportedBillingCurrency;
  dueDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoiceType: InvoiceType;
  organizationId: Scalars['ID']['output'];
  paymentDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  statusHistory?: Maybe<Array<InvoiceStatusHistory>>;
  stripeInvoiceGrossAmount?: Maybe<Scalars['Float']['output']>;
  stripeInvoiceId: Scalars['String']['output'];
  stripeRevisions?: Maybe<Array<InvoiceStripeRevision>>;
  supersedesInvoiceId?: Maybe<Scalars['ID']['output']>;
};

export class InvoiceAndCreditNoteMonthDownloadInput {
  language?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Float']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Float']['input'];
};

export class InvoiceCreateInput {
  billingPeriodEndDate: Scalars['UTCDate']['input'];
  billingPeriodStartDate: Scalars['UTCDate']['input'];
  organizationId: Scalars['ID']['input'];
};

export class InvoicePaymentBookingDetail {
  __typename?: 'InvoicePaymentBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  bookingId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  invoiceDueDate: Scalars['UTCDate']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  invoiceType: InvoiceType;
  organizationId: Scalars['ID']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentCurrency: SupportedBillingCurrency;
  paymentDate: Scalars['AnkaadiaDateTime']['output'];
  referencedBookings?: Maybe<Scalars['String']['output']>;
};

export class InvoicePaymentBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum InvoiceStatus {
  Annulled = 'Annulled',
  Cancelled = 'Cancelled',
  Created = 'Created',
  Draft = 'Draft',
  Ignored = 'Ignored',
  ManuallySent = 'ManuallySent',
  Open = 'Open',
  Paid = 'Paid',
  PartiallyPaid = 'PartiallyPaid',
  Uncollectible = 'Uncollectible',
  Void = 'Void'
}

export class InvoiceStatusHistory {
  __typename?: 'InvoiceStatusHistory';
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  status: InvoiceStatus;
};

export class InvoiceStripeRevision {
  __typename?: 'InvoiceStripeRevision';
  invoiceNumber: Scalars['String']['output'];
  revisedAt: Scalars['AnkaadiaDateTime']['output'];
  stripeInvoiceId: Scalars['String']['output'];
};

export class InvoiceStripeSyncInput {
  month: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  year: Scalars['Int']['input'];
};

export class InvoiceStripeSyncResult {
  __typename?: 'InvoiceStripeSyncResult';
  creditNotesImported: Scalars['Int']['output'];
  creditNotesUpdated: Scalars['Int']['output'];
  invoices: Array<Invoice>;
  invoicesMarkedAnnulled: Array<Scalars['String']['output']>;
  invoicesMarkedCancelled: Array<Scalars['String']['output']>;
  invoicesUncancelled: Array<Scalars['String']['output']>;
};

export enum InvoiceType {
  AddOnService = 'AddOnService',
  Candidate = 'Candidate',
  Contingent = 'Contingent',
  License = 'License'
}

export class IsMatchingEnabled {
  __typename?: 'IsMatchingEnabled';
  destinationOrganizationId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
};

export class IsMatchingEnabledInput {
  destinationOrganizationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum KnownConsentIdentifiers {
  AnkaadiaCvParsingConsent = 'AnkaadiaCvParsingConsent',
  AnkaadiaDocumentExtractionConsent = 'AnkaadiaDocumentExtractionConsent',
  DocuSealDocumentSigningService = 'DocuSealDocumentSigningService',
  GeneralBrokerMandateCandidate = 'GeneralBrokerMandateCandidate',
  GeneralBrokerMandateOrganization = 'GeneralBrokerMandateOrganization',
  GeneralTermsAndConditions = 'GeneralTermsAndConditions',
  LingoKingAddOnService = 'LingoKingAddOnService',
  OrganisationConsentBarmerHealthCare = 'OrganisationConsentBarmerHealthCare',
  OrganisationConsentChatCometChat = 'OrganisationConsentChatCometChat',
  OrganizationConsentStarnormInsurances = 'OrganizationConsentStarnormInsurances',
  TalentPoolEmployerPoolService = 'TalentPoolEmployerPoolService',
  TalentPoolPsaPoolService = 'TalentPoolPSAPoolService',
  TalentPoolWebsiteService = 'TalentPoolWebsiteService',
  DeprecatedCandidateConsentBarmerHealthCare = 'deprecated_CandidateConsentBarmerHealthCare'
}

export enum KnownFormToken {
  CandidateAllowence = 'CandidateAllowence',
  InterviewAppointmentConfirmationForm = 'InterviewAppointmentConfirmationForm',
  InterviewAppointmentProposalForm = 'InterviewAppointmentProposalForm',
  InterviewAppointmentScheduleForm = 'InterviewAppointmentScheduleForm',
  InterviewAppointmentScheduleSingleDateForm = 'InterviewAppointmentScheduleSingleDateForm',
  InterviewFeedbackForm = 'InterviewFeedbackForm',
  MatchingAgreementForm = 'MatchingAgreementForm',
  MatchingAgreementFormV2 = 'MatchingAgreementFormV2',
  QualificationEvaluationConfiguration = 'QualificationEvaluationConfiguration',
  QualificationEvaluationReceived = 'QualificationEvaluationReceived',
  QualificationEvaluationRequest = 'QualificationEvaluationRequest',
  RecruitingConcept = 'RecruitingConcept',
  ShippingInformationForm = 'ShippingInformationForm',
  SubmissionDate = 'SubmissionDate',
  TravelBookingForm = 'TravelBookingForm'
}

export enum KnownPdfFormTokens {
  AgreementAcceleratedRecognition = 'AgreementAcceleratedRecognition',
  AgreementGuetezeichen = 'AgreementGuetezeichen',
  AgreementRecognitionPartnership = 'AgreementRecognitionPartnership',
  AgreementRecognitionPartnershipRegular = 'AgreementRecognitionPartnershipRegular',
  AllocationTaxId = 'AllocationTaxId',
  AnnexSupportQualificationEmployee = 'AnnexSupportQualificationEmployee',
  ApplicationAcceleratedRecognition = 'ApplicationAcceleratedRecognition',
  ApplicationEquivalenceDetermination = 'ApplicationEquivalenceDetermination',
  ApplicationExtendResidencePermit = 'ApplicationExtendResidencePermit',
  ApplicationRegistrationOffice = 'ApplicationRegistrationOffice',
  ApplicationResidencePermit = 'ApplicationResidencePermit',
  ApplicationResidencePermitUniklinikDuesseldorf = 'ApplicationResidencePermitUniklinikDuesseldorf',
  ApplicationTechnikerInsurance = 'ApplicationTechnikerInsurance',
  ApplicationValuationDegrees = 'ApplicationValuationDegrees',
  ApplicationWageSubsidyEmployeeAbsenceTraining = 'ApplicationWageSubsidyEmployeeAbsenceTraining',
  CandidateProfileTalentCountry = 'CandidateProfileTalentCountry',
  CertificateApplicationWageSubsidy = 'CertificateApplicationWageSubsidy',
  CertificateEmployerSupport = 'CertificateEmployerSupport',
  CertificateOfConduct = 'CertificateOfConduct',
  CertificateOfGoodStanding = 'CertificateOfGoodStanding',
  CollectiveApplicationWageSubsidyQuestionnaire = 'CollectiveApplicationWageSubsidyQuestionnaire',
  CompensationConfirmation = 'CompensationConfirmation',
  CompensatoryMeasure = 'CompensatoryMeasure',
  ConfirmationNoMatching = 'ConfirmationNoMatching',
  ConfirmationOfLandlord = 'ConfirmationOfLandlord',
  ConstitutionInstruction = 'ConstitutionInstruction',
  CostAbsorption = 'CostAbsorption',
  CostAbsorptionValuation = 'CostAbsorptionValuation',
  DataApplication = 'DataApplication',
  DecisionAdaptionCourse = 'DecisionAdaptionCourse',
  DecisionQualificationMeasure = 'DecisionQualificationMeasure',
  DeclarationCancellationJobTitle = 'DeclarationCancellationJobTitle',
  DeclarationEmployeeWageSubsidyTraining = 'DeclarationEmployeeWageSubsidyTraining',
  DeclarationExecutionAccaleratedRecognition = 'DeclarationExecutionAccaleratedRecognition',
  DeclarationOfCorrespondence = 'DeclarationOfCorrespondence',
  DeclarationOfEmployerAt = 'DeclarationOfEmployerAT',
  DeclarationOfEmployment = 'DeclarationOfEmployment',
  DeclarationOfEmploymentAfterRecognition = 'DeclarationOfEmploymentAfterRecognition',
  DeclarationOfEmploymentBeforeRecognition = 'DeclarationOfEmploymentBeforeRecognition',
  DeclarationOfEmploymentBeforeRecognitionHiRe = 'DeclarationOfEmploymentBeforeRecognitionHIRe',
  DeclarationOfEmploymentVocationalSchool = 'DeclarationOfEmploymentVocationalSchool',
  DeclarationOfImpunity = 'DeclarationOfImpunity',
  DeclarationOfParticipationQualificationMeasure = 'DeclarationOfParticipationQualificationMeasure',
  DeclarationRecognitionProcedure = 'DeclarationRecognitionProcedure',
  DeclarationSchengenResidence = 'DeclarationSchengenResidence',
  DeclarationVisaProcess = 'DeclarationVisaProcess',
  DoctorCertificateStudyPurpose = 'DoctorCertificateStudyPurpose',
  DutyToInformEmployees = 'DutyToInformEmployees',
  EducationVoucher = 'EducationVoucher',
  EducationVoucherAg = 'EducationVoucherAG',
  EducationVoucherOsnabrueck = 'EducationVoucherOsnabrueck',
  FamilyReunionChildren = 'FamilyReunionChildren',
  FamilyReunionDeclaration = 'FamilyReunionDeclaration',
  FamilyReunionPartner = 'FamilyReunionPartner',
  FinalStatementApplicationWageSubsidy = 'FinalStatementApplicationWageSubsidy',
  FollowUpEquivalenceDetermination = 'FollowUpEquivalenceDetermination',
  GeneralBrokerMandate = 'GeneralBrokerMandate',
  HealthProfessionsRegister = 'HealthProfessionsRegister',
  KnowledgeExamApplication = 'KnowledgeExamApplication',
  LanguageExamApplication = 'LanguageExamApplication',
  MedicalCertificate = 'MedicalCertificate',
  MedicalCertificateDoctor = 'MedicalCertificateDoctor',
  NrwEquivalenceDetermination = 'NRWEquivalenceDetermination',
  NrwPermitApplication = 'NRWPermitApplication',
  NostrificationGovernmentOberoesterreich = 'NostrificationGovernmentOberoesterreich',
  NostrificationGuKg = 'NostrificationGuKG',
  NostrificationGuKgTraining = 'NostrificationGuKGTraining',
  NostrificationMabg = 'NostrificationMABG',
  NostrificationMtdg = 'NostrificationMTDG',
  NostrifizierungFh = 'NostrifizierungFH',
  NostrifizierungFhPowerOfAttorney = 'NostrifizierungFHPowerOfAttorney',
  PowerOfAttorney = 'PowerOfAttorney',
  PowerOfAttorneyDelivery = 'PowerOfAttorneyDelivery',
  PowerOfAttorneyQualificationMeasure = 'PowerOfAttorneyQualificationMeasure',
  PowerOfAttorneyRegular = 'PowerOfAttorneyRegular',
  PowerOfAttorneyTechnikerInsurance = 'PowerOfAttorneyTechnikerInsurance',
  PowerOfAttorneyValuation = 'PowerOfAttorneyValuation',
  PowerOfRepresentation = 'PowerOfRepresentation',
  QuestionnaireMedimovers = 'QuestionnaireMedimovers',
  QuestionnaireScientology = 'QuestionnaireScientology',
  QuestionnaireTrainingGrant = 'QuestionnaireTrainingGrant',
  Rwr = 'RWR',
  RecognitionApplication = 'RecognitionApplication',
  RecognitionCv = 'RecognitionCV',
  RegistrationCertificateTrainingVoucher = 'RegistrationCertificateTrainingVoucher',
  SubPowerOfAttorney = 'SubPowerOfAttorney',
  SupplementarySheetA = 'SupplementarySheetA',
  SupplementarySheetC = 'SupplementarySheetC',
  TrainingCoursePermitQuestionnaire = 'TrainingCoursePermitQuestionnaire',
  VisaApplication = 'VisaApplication',
  VisaApplicationAt = 'VisaApplicationAT',
  VisaExtension = 'VisaExtension',
  VocationalTrainingQuestionnaire = 'VocationalTrainingQuestionnaire',
  WorkGuarantee = 'WorkGuarantee'
}

export class KnownVarsNode {
  __typename?: 'KnownVarsNode';
  data: TreeNodeData;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  parentKey?: Maybe<Scalars['String']['output']>;
};

export class KnownVarsTreeDto {
  __typename?: 'KnownVarsTreeDTO';
  knownVars: Array<KnownVarsNode>;
  metaData?: Maybe<Scalars['String']['output']>;
};

export type KnownVarsTreeEvent = KnownVarsTreeDto | ProgressEvent;

export class KpiGetInput {
  month: KpiMonthInput;
  types: Array<KpiType>;
};

export class KpiMonth {
  __typename?: 'KpiMonth';
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export class KpiMonthInput {
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export class KpiResult {
  __typename?: 'KpiResult';
  asOfDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endOfLastMonth: Scalars['UTCDate']['output'];
  endOfMonth: Scalars['UTCDate']['output'];
  startOfLastMonth: Scalars['UTCDate']['output'];
  type: KpiType;
  unitType: KpiUnit;
  units?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
  valueEndOfLastMonth: Scalars['Float']['output'];
};

export class KpiResults {
  __typename?: 'KpiResults';
  date: Scalars['AnkaadiaDateTime']['output'];
  endOfLastMonth: Scalars['UTCDate']['output'];
  endOfMonth: Scalars['UTCDate']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  includesVirtualBookings: Scalars['Boolean']['output'];
  month: KpiMonth;
  organizationId: Scalars['ID']['output'];
  results: Array<KpiResult>;
  startOfLastMonth: Scalars['UTCDate']['output'];
};

export enum KpiType {
  AccountsReceivableAddOnService = 'AccountsReceivableAddOnService',
  AccountsReceivableCandidate = 'AccountsReceivableCandidate',
  AccountsReceivableCreditNote = 'AccountsReceivableCreditNote',
  AccountsReceivableLicense = 'AccountsReceivableLicense',
  AccountsReceivableNet = 'AccountsReceivableNet',
  CandidateActive = 'CandidateActive',
  CandidateInactive = 'CandidateInactive',
  CandidateMatched = 'CandidateMatched',
  CandidateOnContingent = 'CandidateOnContingent',
  CandidateTotal = 'CandidateTotal',
  OrganizationLicensed = 'OrganizationLicensed',
  OrganizationTotal = 'OrganizationTotal',
  OrganizationWithActiveUser = 'OrganizationWithActiveUser',
  RevenueAddOnService = 'RevenueAddOnService',
  RevenueCandidate = 'RevenueCandidate',
  RevenueCreditNote = 'RevenueCreditNote',
  RevenueLicense = 'RevenueLicense',
  RevenueTotal = 'RevenueTotal',
  UserActive = 'UserActive',
  UserTotal = 'UserTotal'
}

export enum KpiUnit {
  Count = 'Count',
  Currency = 'Currency',
  Percentage = 'Percentage'
}

export class LaborAgreement {
  __typename?: 'LaborAgreement';
  _etag?: Maybe<Scalars['String']['output']>;
  allowances?: Maybe<Array<LaborAgreementAllowance>>;
  benefits?: Maybe<Array<LaborAgreementBenefit>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  country: SupportedImmigrationCountry;
  federalStates: Array<Scalars['String']['output']>;
  holidayEntitlement?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institutionA?: Maybe<Scalars['String']['output']>;
  institutionB?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noticePeriod: Scalars['Float']['output'];
  noticePeriodUnit: ContractTermTimePeriod;
  organizationId: Scalars['ID']['output'];
  payGrades: Array<LaborAgreementPayGrade>;
  probationPeriod: Scalars['Float']['output'];
  probationPeriodUnit: ContractTermTimePeriod;
  type: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class LaborAgreementAllowance {
  __typename?: 'LaborAgreementAllowance';
  amount: Scalars['Float']['output'];
  calculationBasis: CalculationBasis;
  comment?: Maybe<Scalars['String']['output']>;
  customType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export class LaborAgreementAllowanceInput {
  amount: Scalars['Float']['input'];
  calculationBasis: CalculationBasis;
  comment?: InputMaybe<Scalars['String']['input']>;
  customType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export class LaborAgreementBenefit {
  __typename?: 'LaborAgreementBenefit';
  amount: Scalars['Float']['output'];
  calculationBasis: CalculationBasis;
  id: Scalars['ID']['output'];
  timeInterval: BenefitTimeInterval;
  type: Scalars['String']['output'];
};

export class LaborAgreementBenefitInput {
  amount: Scalars['Float']['input'];
  calculationBasis: CalculationBasis;
  id: Scalars['ID']['input'];
  timeInterval: BenefitTimeInterval;
  type: Scalars['String']['input'];
};

export class LaborAgreementCreateInput {
  allowances?: InputMaybe<Array<LaborAgreementAllowanceInput>>;
  benefits?: InputMaybe<Array<LaborAgreementBenefitInput>>;
  country: SupportedImmigrationCountry;
  federalStates: Array<Scalars['String']['input']>;
  holidayEntitlement?: InputMaybe<Scalars['Float']['input']>;
  institutionA?: InputMaybe<Scalars['String']['input']>;
  institutionB?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  noticePeriod: Scalars['Float']['input'];
  noticePeriodUnit: ContractTermTimePeriod;
  organizationId: Scalars['ID']['input'];
  payGrades: Array<LaborAgreementPayGradeInput>;
  probationPeriod: Scalars['Float']['input'];
  probationPeriodUnit: ContractTermTimePeriod;
  type: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class LaborAgreementDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LaborAgreementForContract {
  __typename?: 'LaborAgreementForContract';
  _etag?: Maybe<Scalars['String']['output']>;
  allowances?: Maybe<Array<LaborAgreementAllowance>>;
  benefits?: Maybe<Array<LaborAgreementBenefit>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  country: SupportedImmigrationCountry;
  federalStates: Array<Scalars['String']['output']>;
  holidayEntitlement?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institutionA?: Maybe<Scalars['String']['output']>;
  institutionB?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noticePeriod: Scalars['Float']['output'];
  noticePeriodUnit: ContractTermTimePeriod;
  organizationCode: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  payGrades: Array<LaborAgreementPayGrade>;
  probationPeriod: Scalars['Float']['output'];
  probationPeriodUnit: ContractTermTimePeriod;
  type: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class LaborAgreementForOverview {
  __typename?: 'LaborAgreementForOverview';
  _etag?: Maybe<Scalars['String']['output']>;
  allowances?: Maybe<Array<LaborAgreementAllowance>>;
  benefits?: Maybe<Array<LaborAgreementBenefit>>;
  canBeDeleted: Scalars['Boolean']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  country: SupportedImmigrationCountry;
  federalStates: Array<Scalars['String']['output']>;
  holidayEntitlement?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  institutionA?: Maybe<Scalars['String']['output']>;
  institutionB?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noticePeriod: Scalars['Float']['output'];
  noticePeriodUnit: ContractTermTimePeriod;
  organizationId: Scalars['ID']['output'];
  payGrades: Array<LaborAgreementPayGrade>;
  probationPeriod: Scalars['Float']['output'];
  probationPeriodUnit: ContractTermTimePeriod;
  type: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class LaborAgreementGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LaborAgreementListInput {
  country?: InputMaybe<SupportedImmigrationCountry>;
  organizationId: Scalars['ID']['input'];
};

export class LaborAgreementPayGrade {
  __typename?: 'LaborAgreementPayGrade';
  compensationRate: Scalars['Float']['output'];
  compensationType: CompensationType;
  id: Scalars['ID']['output'];
  salaryGroup: Scalars['String']['output'];
  salaryStep: Scalars['String']['output'];
  workingHoursPerWeek: Scalars['Float']['output'];
};

export class LaborAgreementPayGradeInput {
  compensationRate: Scalars['Float']['input'];
  compensationType: CompensationType;
  id: Scalars['ID']['input'];
  salaryGroup: Scalars['String']['input'];
  salaryStep: Scalars['String']['input'];
  workingHoursPerWeek: Scalars['Float']['input'];
};

export class LaborAgreementSelection {
  __typename?: 'LaborAgreementSelection';
  laborAgreementId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  payGradeId?: Maybe<Scalars['ID']['output']>;
};

export class LaborAgreementSelectionInput {
  laborAgreementId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  payGradeId?: InputMaybe<Scalars['ID']['input']>;
};

export enum LaborAgreementSharingMode {
  ShareAll = 'ShareAll',
  ShareSelected = 'ShareSelected'
}

export class LaborAgreementUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowances?: InputMaybe<Array<LaborAgreementAllowanceInput>>;
  benefits?: InputMaybe<Array<LaborAgreementBenefitInput>>;
  country: SupportedImmigrationCountry;
  federalStates: Array<Scalars['String']['input']>;
  holidayEntitlement?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  institutionA?: InputMaybe<Scalars['String']['input']>;
  institutionB?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  noticePeriod: Scalars['Float']['input'];
  noticePeriodUnit: ContractTermTimePeriod;
  organizationId: Scalars['ID']['input'];
  payGrades: Array<LaborAgreementPayGradeInput>;
  probationPeriod: Scalars['Float']['input'];
  probationPeriodUnit: ContractTermTimePeriod;
  type: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class LaborMarketAdmissionCandidateDataDe {
  __typename?: 'LaborMarketAdmissionCandidateDataDE';
  employmentApprovalAuthority?: Maybe<Scalars['String']['output']>;
  employmentApprovalRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  employmentApprovalRequested?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoleLaborMarket?: Maybe<Scalars['String']['output']>;
};

export class LaborMarketAdmissionCandidateDataDeInput {
  employmentApprovalAuthority?: InputMaybe<Scalars['String']['input']>;
  employmentApprovalRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  employmentApprovalRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoleLaborMarket?: InputMaybe<Scalars['String']['input']>;
};

export class LanguageEducationFields {
  __typename?: 'LanguageEducationFields';
  examModules?: Maybe<Array<ExamModuleType>>;
  examType?: Maybe<ExamType>;
  languageLevel?: Maybe<Scalars['String']['output']>;
};

export class LanguageEducationFieldsInput {
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType?: InputMaybe<ExamType>;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
};

export class LanguageEducationModelFields {
  __typename?: 'LanguageEducationModelFields';
  examModules?: Maybe<Array<ExamModuleType>>;
  examType?: Maybe<ExamType>;
  languageLevel?: Maybe<Scalars['String']['output']>;
};

export class LanguageEducationModelFieldsInput {
  examModules?: InputMaybe<Array<ExamModuleType>>;
  examType?: InputMaybe<ExamType>;
  languageLevel?: InputMaybe<Scalars['String']['input']>;
};

export class LanguageExamResult {
  __typename?: 'LanguageExamResult';
  examResult?: Maybe<Scalars['String']['output']>;
  passedExamModules?: Maybe<Array<ExamModuleType>>;
  resultDetails?: Maybe<Array<ResultDetails>>;
};

export class LanguageExamResultInput {
  examResult?: InputMaybe<Scalars['String']['input']>;
  passedExamModules?: InputMaybe<Array<ExamModuleType>>;
  resultDetails?: InputMaybe<Array<ResultDetailsInput>>;
};

export enum LanguageLevelSource {
  CurriculumVitae = 'CurriculumVitae',
  CurriculumVitaeNotValidated = 'CurriculumVitaeNotValidated',
  EducationModule = 'EducationModule',
  LanguageCourse = 'LanguageCourse',
  PlacementTest = 'PlacementTest',
  UploadedCertificate = 'UploadedCertificate'
}

export class LanguageSkill {
  __typename?: 'LanguageSkill';
  examInstitution?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  languageLevelSource?: Maybe<LanguageLevelSource>;
  languageTrainingStatus?: Maybe<LanguageTrainingStatus>;
  skillLevel?: Maybe<Scalars['String']['output']>;
};

export enum LanguageTrainingStatus {
  Canceled = 'Canceled',
  Certified = 'Certified',
  Finished = 'Finished',
  Paused = 'Paused',
  RegisterToLanguageCourse = 'RegisterToLanguageCourse',
  Registered = 'Registered',
  Started = 'Started'
}

export class LastUserLoginInput {
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export class LatestFinalizedInvoiceGetInput {
  invoiceType: InvoiceType;
  organizationId: Scalars['ID']['input'];
};

export class LicenseBookingDetail {
  __typename?: 'LicenseBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountId?: Maybe<Scalars['String']['output']>;
  discountInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPartPayment: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  partPaymentPercentage?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
  priceRowId?: Maybe<Scalars['String']['output']>;
  referencedBookings?: Maybe<Scalars['String']['output']>;
};

export class LicenseBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class LicenseBookingDetailInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  billingTriggerEvent?: InputMaybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  discountInfo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPartPayment: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  partPaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceInfo?: InputMaybe<Scalars['String']['input']>;
  priceRowId?: InputMaybe<Scalars['String']['input']>;
  referencedBookings?: InputMaybe<Scalars['String']['input']>;
};

export class LicensePrice {
  __typename?: 'LicensePrice';
  amount: Scalars['Float']['output'];
};

export class LicensePriceInput {
  amount: Scalars['Float']['input'];
};

export class LingokingAccount {
  __typename?: 'LingokingAccount';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  sendCustomer?: Maybe<Scalars['Boolean']['output']>;
};

export class LingokingAccountCheckExistingCredentialsInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LingokingAccountCheckNewCredentialsInput {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export class LingokingAccountCreateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  sendCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export class LingokingAccountDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LingokingAccountGetInput {
  organizationId: Scalars['ID']['input'];
};

export class LingokingAccountUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  sendCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export class LingokingContactInput {
  includeMobile: Scalars['Boolean']['input'];
  includePhone: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  requestCancellation: Scalars['Boolean']['input'];
  taskId: Scalars['ID']['input'];
};

export class LingokingOrder {
  __typename?: 'LingokingOrder';
  documentSet?: Maybe<Scalars['String']['output']>;
  documentTags: Array<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  numberOfPages: Scalars['Float']['output'];
  orderCanceledAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  orderCompletedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  orderName: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceCurrency: Scalars['String']['output'];
  sourceLanguage: Scalars['String']['output'];
  targetLanguage: Scalars['String']['output'];
  tax: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export class LingokingOrderInput {
  documentSet?: InputMaybe<Scalars['String']['input']>;
  documentTags: Array<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  numberOfPages: Scalars['Float']['input'];
  orderCanceledAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  orderCompletedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  orderName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  priceCurrency: Scalars['String']['input'];
  sourceLanguage: Scalars['String']['input'];
  targetLanguage: Scalars['String']['input'];
  tax: Scalars['Float']['input'];
  totalPrice: Scalars['Float']['input'];
};

export enum LingokingTableType {
  CartTable = 'CartTable',
  OrderTable = 'OrderTable'
}

export class LinkableOrganizationsInput {
  linkedOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LinkedRenderedText {
  __typename?: 'LinkedRenderedText';
  assetPath: Scalars['String']['output'];
  href: Scalars['String']['output'];
  htmlText: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export class LinkedText {
  __typename?: 'LinkedText';
  assetPath: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export class LinkedTextInput {
  assetPath: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export enum ListMultiEditOperation {
  Add = 'Add',
  Remove = 'Remove',
  Update = 'Update'
}

export class LocalPartnerProfileConfigSet {
  __typename?: 'LocalPartnerProfileConfigSet';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  setName: Scalars['String']['output'];
};

export class LocalPartnerProfileConfigSetCreateInput {
  organizationId: Scalars['ID']['input'];
  setName: Scalars['String']['input'];
};

export class LocalPartnerProfileConfigSetDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LocalPartnerProfileConfigSetGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class LocalPartnerProfileConfigSetGetListAllInput {
  organizationId: Scalars['ID']['input'];
};

export class LocalPartnerProfileConfigSetUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  setName: Scalars['String']['input'];
};

export class LocalizedString {
  __typename?: 'LocalizedString';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class LocalizedStringInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export class LogicOperatorsFormated {
  __typename?: 'LogicOperatorsFormated';
  index: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  length: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
};

export class MappingIdentifier {
  processModelId: Scalars['String']['input'];
  startTaskModelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskModelId: Scalars['String']['input'];
};

export class MatchingAgreement {
  __typename?: 'MatchingAgreement';
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  careFacilities?: Maybe<Array<Scalars['String']['output']>>;
  hasExperienceWithInternationalRecruitment?: Maybe<Scalars['Boolean']['output']>;
  measuresAndInstrumentsForIntegration?: Maybe<Scalars['String']['output']>;
  numberOfHiresAtLocation?: Maybe<Scalars['String']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  professionalFields?: Maybe<Array<Scalars['String']['output']>>;
  transferLanguageLevel?: Maybe<Scalars['String']['output']>;
};

export class MatchingAgreementInput {
  benefits?: InputMaybe<Array<Scalars['String']['input']>>;
  careFacilities?: InputMaybe<Array<Scalars['String']['input']>>;
  hasExperienceWithInternationalRecruitment?: InputMaybe<Scalars['Boolean']['input']>;
  measuresAndInstrumentsForIntegration?: InputMaybe<Scalars['String']['input']>;
  numberOfHiresAtLocation?: InputMaybe<Scalars['String']['input']>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  professionalFields?: InputMaybe<Array<Scalars['String']['input']>>;
  transferLanguageLevel?: InputMaybe<Scalars['String']['input']>;
};

export enum MatchingStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Viewable = 'Viewable'
}

export class Menu {
  __typename?: 'Menu';
  employerSearch?: Maybe<MenuEmployerSearch>;
  profile?: Maybe<MenuProfile>;
  tasks?: Maybe<MenuTasks>;
};

export class MenuEmployerSearch {
  __typename?: 'MenuEmployerSearch';
  canApply?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export class MenuProfile {
  __typename?: 'MenuProfile';
  enabled: Scalars['Boolean']['output'];
  tabs?: Maybe<Array<CandidateProfileConfigTab>>;
};

export class MenuTasks {
  __typename?: 'MenuTasks';
  enabled: Scalars['Boolean']['output'];
};

export class MergeDocumentsInput {
  candidateId: Scalars['ID']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  files: Array<DocumentFreeFormatFileInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class MessageAnswerFinalizedEmitEvent {
  __typename?: 'MessageAnswerFinalizedEmitEvent';
  messageId: Scalars['String']['output'];
};

export class MessageDeltaEmitEvent {
  __typename?: 'MessageDeltaEmitEvent';
  delta: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
};

export class MessageEmitEvent {
  __typename?: 'MessageEmitEvent';
  text: Scalars['String']['output'];
};

export class MessageThinkingFinalizedEmitEvent {
  __typename?: 'MessageThinkingFinalizedEmitEvent';
  messageId: Scalars['String']['output'];
};

export class MessagesReception {
  __typename?: 'MessagesReception';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateOrUserId: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifier?: Maybe<Modifier>;
  organizationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
};

export enum MessengerEventType {
  Failed = 'Failed',
  Sent = 'Sent'
}

export class MessengerMessage {
  __typename?: 'MessengerMessage';
  _etag?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<MessengerMessageEvent>>;
  id?: Maybe<Scalars['ID']['output']>;
  language: Scalars['String']['output'];
  lastSentDate: Scalars['AnkaadiaDateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messenger: Scalars['String']['output'];
  messengerMessageId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  reason: MessengerMessageReason;
  relatedProcessId?: Maybe<Scalars['String']['output']>;
  relatedProcessOrganizationId?: Maybe<Scalars['String']['output']>;
  relatesToEmailId?: Maybe<Scalars['ID']['output']>;
  userOrCandidateId: Scalars['ID']['output'];
};

export class MessengerMessageEvent {
  __typename?: 'MessengerMessageEvent';
  date: Scalars['AnkaadiaDateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  type: MessengerEventType;
};

export enum MessengerMessageReason {
  AdHocMessage = 'AdHocMessage',
  Email = 'Email',
  StandardReply = 'StandardReply',
  WelcomeAfterOptIn = 'WelcomeAfterOptIn'
}

export class MessengerUserOptIn {
  __typename?: 'MessengerUserOptIn';
  _etag?: Maybe<Scalars['String']['output']>;
  allowMessaging: Scalars['Boolean']['output'];
  candidateOrUserId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  userAskedDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
};

export class MeteredTranslationInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  propertyPath: Array<Scalars['String']['input']>;
  sourceText?: InputMaybe<Scalars['String']['input']>;
  sourceTextAsDelta?: InputMaybe<Scalars['JSONObject']['input']>;
  targetTextAsDelta?: InputMaybe<Scalars['JSONObject']['input']>;
  translationItemId: Scalars['String']['input'];
};

export enum MetricType {
  AnkaadiaUpdates = 'AnkaadiaUpdates',
  CandidateBirthdays = 'CandidateBirthdays',
  CandidatesCreated = 'CandidatesCreated',
  CandidatesLoggedIn = 'CandidatesLoggedIn',
  DocumentsExpiring = 'DocumentsExpiring',
  DocumentsUploaded = 'DocumentsUploaded',
  TasksFinished = 'TasksFinished'
}

export class MigrationCandidateDataAt {
  __typename?: 'MigrationCandidateDataAT';
  employmentRelationship?: Maybe<EmploymentRelationship>;
  healthProfessionsRegister?: Maybe<HealthProfessionsRegisterCandidateDataAt>;
  qualificationMeasure?: Maybe<QualificationMeasureCandidateDataAt>;
  recognitionPath?: Maybe<RecognitionPathEntryAt>;
  residence?: Maybe<ResidenceCandidateDataAt>;
  visa?: Maybe<VisaCandidateDataAt>;
  vocationalSchool?: Maybe<VocationalSchoolCandidateDataAt>;
};

export class MigrationCandidateDataAtInput {
  employmentRelationship?: InputMaybe<EmploymentRelationshipInput>;
  healthProfessionsRegister?: InputMaybe<HealthProfessionsRegisterCandidateDataAtInput>;
  qualificationMeasure?: InputMaybe<QualificationMeasureCandidateDataAtInput>;
  recognitionPath?: InputMaybe<RecognitionPathEntryAtInput>;
  residence?: InputMaybe<ResidenceCandidateDataAtInput>;
  visa?: InputMaybe<VisaCandidateDataAtInput>;
  vocationalSchool?: InputMaybe<VocationalSchoolCandidateDataAtInput>;
};

export class MigrationCandidateDataContainer {
  __typename?: 'MigrationCandidateDataContainer';
  at?: Maybe<MigrationCandidateDataAt>;
  de?: Maybe<MigrationCandidateDataDe>;
  housingAcquisition?: Maybe<HousingAcquisition>;
};

export class MigrationCandidateDataContainerForView {
  __typename?: 'MigrationCandidateDataContainerForView';
  at?: Maybe<MigrationCandidateDataAt>;
  de?: Maybe<MigrationCandidateDataDeForView>;
  housingAcquisition?: Maybe<HousingAcquisition>;
};

export class MigrationCandidateDataContainerInput {
  at?: InputMaybe<MigrationCandidateDataAtInput>;
  de?: InputMaybe<MigrationCandidateDataDeInput>;
  housingAcquisition?: InputMaybe<HousingAcquisitionInput>;
};

export class MigrationCandidateDataDe {
  __typename?: 'MigrationCandidateDataDE';
  employmentRelationship?: Maybe<EmploymentRelationship>;
  laborMarketAdmission?: Maybe<LaborMarketAdmissionCandidateDataDe>;
  qualificationEvaluation?: Maybe<QualificationEvaluationDataDe>;
  qualificationMeasure?: Maybe<QualificationMeasureCandidateDataDe>;
  recognitionPath?: Maybe<RecognitionPathCandidateDataDe>;
  residence?: Maybe<ResidenceCandidateDataDe>;
  visa?: Maybe<VisaCandidateDataDe>;
  vocationalSchool?: Maybe<VocationalSchoolCandidateDataDe>;
};

export class MigrationCandidateDataDeForView {
  __typename?: 'MigrationCandidateDataDEForView';
  employmentRelationship?: Maybe<EmploymentRelationship>;
  laborMarketAdmission?: Maybe<LaborMarketAdmissionCandidateDataDe>;
  qualificationEvaluation?: Maybe<QualificationEvaluationDataDe>;
  qualificationMeasure?: Maybe<QualificationMeasureCandidateDataDe>;
  recognitionPath?: Maybe<RecognitionPathCandidateDataDeForView>;
  residence?: Maybe<ResidenceCandidateDataDe>;
  visa?: Maybe<VisaCandidateDataDe>;
  vocationalSchool?: Maybe<VocationalSchoolCandidateDataDe>;
};

export class MigrationCandidateDataDeInput {
  employmentRelationship?: InputMaybe<EmploymentRelationshipInput>;
  laborMarketAdmission?: InputMaybe<LaborMarketAdmissionCandidateDataDeInput>;
  qualificationEvaluation?: InputMaybe<QualificationEvaluationDataDeInput>;
  qualificationMeasure?: InputMaybe<QualificationMeasureCandidateDataDeInput>;
  recognitionPath?: InputMaybe<RecognitionPathCandidateDataDeInput>;
  residence?: InputMaybe<ResidenceCandidateDataDeInput>;
  visa?: InputMaybe<VisaCandidateDataDeInput>;
  vocationalSchool?: InputMaybe<VocationalSchoolCandidateDataDeInput>;
};

export class MilestoneCandidateProcess {
  __typename?: 'MilestoneCandidateProcess';
  displayName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  processId: Scalars['String']['output'];
};

export class MilestoneCandidateState {
  __typename?: 'MilestoneCandidateState';
  activeTaskIds: Array<TaskIdentifier>;
  candidateCountry?: Maybe<Scalars['String']['output']>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['String']['output'];
  candidateOrganizationId: Scalars['String']['output'];
  candidateOrganizationName?: Maybe<Scalars['String']['output']>;
  candidateStatus?: Maybe<CandidateStatus>;
  currentTaskName?: Maybe<Scalars['String']['output']>;
  delayInDays?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  processes: Array<MilestoneCandidateProcess>;
  scheduleSegment: MilestoneScheduleSegmentName;
  status: MilestoneStatus;
};

export class MilestoneDashboardSharing {
  __typename?: 'MilestoneDashboardSharing';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  milestoneListId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  showPlanningData: Scalars['Boolean']['output'];
  showProgress: Scalars['Boolean']['output'];
  showSummary: Scalars['Boolean']['output'];
  targetGroups?: Maybe<Array<MilestoneDashboardSharingTargetGroup>>;
  targetOrganizationIds?: Maybe<Array<Scalars['ID']['output']>>;
  targetOrganizationNames?: Maybe<Array<Scalars['String']['output']>>;
};

export class MilestoneDashboardSharingCreateInput {
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  showPlanningData: Scalars['Boolean']['input'];
  showProgress: Scalars['Boolean']['input'];
  showSummary: Scalars['Boolean']['input'];
  targetGroups?: InputMaybe<Array<MilestoneDashboardSharingTargetGroup>>;
  targetOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class MilestoneDashboardSharingDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class MilestoneDashboardSharingGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class MilestoneDashboardSharingListInput {
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class MilestoneDashboardSharingSettings {
  __typename?: 'MilestoneDashboardSharingSettings';
  showPlanningData: Scalars['Boolean']['output'];
  showProgress: Scalars['Boolean']['output'];
  showSummary: Scalars['Boolean']['output'];
};

export enum MilestoneDashboardSharingTargetGroup {
  Customers = 'Customers',
  Partners = 'Partners',
  SubOrganizations = 'SubOrganizations'
}

export class MilestoneDashboardSharingUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  showPlanningData: Scalars['Boolean']['input'];
  showProgress: Scalars['Boolean']['input'];
  showSummary: Scalars['Boolean']['input'];
  targetGroups?: InputMaybe<Array<MilestoneDashboardSharingTargetGroup>>;
  targetOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class MilestoneScheduleBreakdown {
  __typename?: 'MilestoneScheduleBreakdown';
  ahead: MilestoneScheduleSegment;
  behind: MilestoneScheduleSegment;
  completed: MilestoneScheduleSegment;
  droppedOut: MilestoneScheduleSegment;
  onTime: MilestoneScheduleSegment;
};

export class MilestoneScheduleSegment {
  __typename?: 'MilestoneScheduleSegment';
  averageDelayInDays?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  maxDelayInDays?: Maybe<Scalars['Float']['output']>;
  minDelayInDays?: Maybe<Scalars['Float']['output']>;
};

export enum MilestoneScheduleSegmentName {
  Ahead = 'Ahead',
  Behind = 'Behind',
  Completed = 'Completed',
  DroppedOut = 'DroppedOut',
  OnTime = 'OnTime'
}

export enum MilestoneStatus {
  Active = 'Active',
  Finished = 'Finished',
  Pending = 'Pending'
}

export enum MilestoneVisibility {
  Candidate = 'Candidate',
  Partner = 'Partner'
}

export class ModelSwitchEmitEvent {
  __typename?: 'ModelSwitchEmitEvent';
  attempt: Scalars['Int']['output'];
  from: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export class Modifier {
  __typename?: 'Modifier';
  id: Scalars['ID']['output'];
  isCandidate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
};

export class ModifierInput {
  id: Scalars['ID']['input'];
  isCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
};

export class Mutation {
  __typename?: 'Mutation';
  acceptChallengeBooking: ChallengeBooking;
  acceptChallengeBookings: Array<ChallengeBooking>;
  acceptOrganizationLinkInvitation: OrganizationLinkInvitation;
  addAssignedCollection: Collection;
  addCandidateDeletionRequest?: Maybe<CandidateDeletionRequest>;
  addCandidateDiscount: Contract;
  addCandidateToCollections: AddCandidatesToCollectionsResult;
  addForeignGroupsToUserGroup: UserGroup;
  addLicenseDiscount: Contract;
  addRecurringFee: Contract;
  addUsersToGroup: UserGroup;
  annulContract: Contract;
  applyAutoFilterTemplateOnAllCandidates: CollectionAutoFilterTemplate;
  applyCommand: ProcessModelCommandResult;
  applyCommandBatch: ProcessModelCommandResult;
  applyEmployer: MutationResult;
  applySubagentResult: ApplySubagentResultOutcome;
  applySubagentResultBatch: BatchApplyOutcome;
  approveCandidateDiffPaths: Array<CandidateDiff>;
  archiveCustomPlan: CustomPlan;
  attachAutoCollectionsToTemplate: Array<Collection>;
  attachProcessToAction: ProcessAction;
  blockUnblockCandidate?: Maybe<CandidateSystemOnboarding>;
  blockUser: User;
  bulkCreateAdhocTasks: Array<ProcessTaskResult>;
  bulkEditTasks: MutationResult;
  cancelContract: Contract;
  changeContractAmendments: Contract;
  changeLockModeForDocuments: Array<Document>;
  changeLockModeForDocumentsByCandidate: Array<Document>;
  changeOwnOrganizationUserPrice: Contract;
  changePartnerOrganizationUserPrice: Contract;
  changePlan: Contract;
  claimSigningSlot: ClaimSigningSlotResult;
  clearAllNotifications: Scalars['Boolean']['output'];
  clearNotification: Scalars['Boolean']['output'];
  clearPdfFormTemplate: PdfFormTemplate;
  confirmOptInState: MessengerUserOptIn;
  convertDerivedProcessModelToBase: ProcessModelEntity;
  copyDataToOrg: CopyResult;
  copySharingPreset: SharingPreset;
  createAdHocEducationExam: AdHocEducationExam;
  createAddOnInvoice?: Maybe<Invoice>;
  createAdhocTask: ProcessTaskResult;
  createAuditDefinition: AuditDefinition;
  createCandidate: Candidate;
  createCandidateAccountingRecord: CandidateAccountingRecord;
  createCandidateApplicationMask?: Maybe<CreateApplicationMaskResponse>;
  createCandidateApplicationMaskConfig: CandidateApplicationMaskConfig;
  createCandidateProfileConfig: CandidateProfileConfig;
  createCandidatesInvoice?: Maybe<Invoice>;
  createChallengeBooking: ChallengeBooking;
  createChallengeBookings: Array<ChallengeBooking>;
  createChatGroup: ChatGroup;
  createChatGroupConfiguration: ChatGroupConfiguration;
  createCollection: Collection;
  createCollectionFilterPreset: CollectionFilterPreset;
  createCollectionWithSharing: Collection;
  createComment: Comment;
  createCommission: Commission;
  createConsent: Consent;
  createContract: Contract;
  createCustomContingentDefinitionSet: CustomContingentDefinitionSet;
  createCustomPlan: CustomPlan;
  createDerivedProcessModel: ProcessModelExtensionEntity;
  createDocument: Document;
  createDocumentAiPerformances: MutationResult;
  createEducationCourse: EducationCourse;
  createEducationCourseCollection: Collection;
  createEducationExam: EducationExam;
  createEducationExamParticipant: EducationExamParticipant;
  createEducationModule: EducationModule;
  createEmailSendOutRule: EmailSendOutRule;
  createEmailTemplate: EmailTemplateMutationResult;
  createEmptyProcessModel: ProcessModelEntity;
  createFeedback: Feedback;
  createLaborAgreement: LaborAgreement;
  createLicenseForOrganization?: Maybe<Scalars['Void']['output']>;
  createLicenseInvoice?: Maybe<Invoice>;
  createLocalPartnerProfileConfigSet: LocalPartnerProfileConfigSet;
  createManualBookings: Array<CreateManualBookingResult>;
  createManyEducationExamParticipants: Array<EducationExamParticipant>;
  createMilestoneDashboardSharing: MilestoneDashboardSharing;
  createNewPublicAPIAccessToken: Scalars['String']['output'];
  createNote: Note;
  createOrganization: Organization;
  createOrganizationAndCertificationProcess: ReCertificationProcessCreationResult;
  createOrganizationContact: OrganizationContact;
  createOrganizationLink: Array<OrganizationLink>;
  createOrganizationLinkInvitation: OrganizationLinkInvitation;
  createOrganizationTag: OrganizationTag;
  createPlanningSharing: PlanningSharing;
  createPlanningState: PlanningStateForList;
  createProcessAction: ProcessAction;
  createProcessMilestoneList: ProcessMilestoneList;
  createProcessMilestoneSharing: ProcessMilestoneSharing;
  createProfessionalExperience: ProfessionalExperience;
  createProfessionalField: ProfessionalField;
  createPublicTalentpoolRequestingOrganizationAndUser: CreatePublicTalentpoolRequestingOrganizationAndUserResult;
  createReCertificationProcess: ReCertificationProcessCreationResult;
  createRequiredDocument: RequiredDocument;
  createSharingPreset: SharingPreset;
  createSharingTemplate: Array<SharingTemplate>;
  createSharings: Array<Sharing>;
  createShortLink: Scalars['String']['output'];
  createStripeCustomer?: Maybe<CustomerResult>;
  createSupplementaryCandidatesInvoice?: Maybe<Invoice>;
  createTalentPool: TalentPool;
  createTalentPoolParticipants: Array<TalentPoolParticipant>;
  createTalentPoolSharing: TalentPoolSharing;
  createTask: ProcessTaskResult;
  createTaskDelegationRule: TaskDelegationRule;
  createTranslationProposal?: Maybe<MutationResult>;
  createUser: User;
  createUserFeedback: MutationResult;
  createUserGroup: UserGroup;
  createWebhookConfig: WebhookConfig;
  declineOrganizationLinkInvitation: OrganizationLinkInvitation;
  deleteAccrualSnapshots: Scalars['Int']['output'];
  deleteAccrualSnapshotsByOrganization: Scalars['Int']['output'];
  deleteAccrualSnapshotsFromMonth: Scalars['Int']['output'];
  deleteAdHocEducationExam: MutationResult;
  deleteAiChatSession: Scalars['Boolean']['output'];
  deleteAllChatData?: Maybe<Scalars['Void']['output']>;
  deleteAuditDefinition?: Maybe<Scalars['Void']['output']>;
  deleteBlob: MutationResult;
  deleteCandidate: MutationResult;
  deleteCandidateAccountingRecord?: Maybe<Scalars['Void']['output']>;
  deleteCandidateApplicationMaskConfig?: Maybe<Scalars['Void']['output']>;
  deleteChatGroup?: Maybe<Scalars['Void']['output']>;
  deleteChatGroupConfiguration?: Maybe<Scalars['Void']['output']>;
  deleteCollection: MutationResult;
  deleteCollectionAutoFilterTemplate: MutationResult;
  deleteCollectionFilterPreset: MutationResult;
  deleteComment: MutationResult;
  deleteCondidateProfileConfig: MutationResult;
  deleteConsent?: Maybe<Scalars['Void']['output']>;
  deleteContingentCorrection: Scalars['Boolean']['output'];
  deleteContractTemplate: MutationResult;
  deleteCustomContingentDefinitionSet: Scalars['Boolean']['output'];
  deleteCustomPlan: Scalars['Boolean']['output'];
  deleteDocument: MutationResult;
  deleteEducationCourse?: Maybe<Scalars['Void']['output']>;
  deleteEducationExam: MutationResult;
  deleteEducationExamParticipant: MutationResult;
  deleteEducationExamResult: MutationResult;
  deleteEducationModule?: Maybe<Scalars['Void']['output']>;
  deleteEmailSendOutRule: Scalars['Boolean']['output'];
  deleteEmailTemplate: MutationResult;
  deleteFloorCorrection: Scalars['Boolean']['output'];
  deleteInterviewComment?: Maybe<CandidateInterviewsFeedback>;
  deleteInterviewFeedback?: Maybe<CandidateInterviewsFeedback>;
  deleteInterviewIteration?: Maybe<CandidateInterviewsFeedback>;
  deleteInvoiceDraft?: Maybe<Scalars['Void']['output']>;
  deleteLaborAgreement: MutationResult;
  deleteLocalPartnerProfileConfigSet: MutationResult;
  deleteLogin?: Maybe<Scalars['Void']['output']>;
  deleteMilestoneDashboardSharing?: Maybe<Scalars['Void']['output']>;
  deleteNote?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationContact: MutationResult;
  deleteOrganizationLink: MutationResult;
  deleteOrganizationLinkInvitation: MutationResult;
  deleteOrganizationTag?: Maybe<Scalars['Void']['output']>;
  deleteOwnOrganizationUserPrice: Contract;
  deletePartnerOrganizationUserPrice: Contract;
  deletePlanningSharing: Scalars['Boolean']['output'];
  deletePlanningState: MutationResult;
  deleteProcessAction: MutationResult;
  deleteProcessMilestoneList?: Maybe<Scalars['Void']['output']>;
  deleteProcessMilestoneSharing?: Maybe<Scalars['Void']['output']>;
  deleteProcessModel: MutationResult;
  deleteProcessModelRelease: MutationResult;
  deleteProfessionalExperience?: Maybe<Scalars['Void']['output']>;
  deleteProfessionalField?: Maybe<Scalars['Void']['output']>;
  deleteRequiredDocument: MutationResult;
  deleteSharing: MutationResult;
  deleteSharingPreset?: Maybe<Scalars['Void']['output']>;
  deleteSharingTemplate: MutationResult;
  deleteTalentPool?: Maybe<Scalars['Void']['output']>;
  deleteTalentPoolParticipant?: Maybe<Scalars['Void']['output']>;
  deleteTalentPoolRequestedTalent?: Maybe<Scalars['Void']['output']>;
  deleteTalentPoolSharing?: Maybe<Scalars['Void']['output']>;
  deleteTask: MutationResult;
  deleteTaskDelegationRule: Scalars['Boolean']['output'];
  deleteUserChat?: Maybe<Scalars['Void']['output']>;
  deleteUserView?: Maybe<Scalars['Void']['output']>;
  deleteWebhookConfig?: Maybe<Scalars['Void']['output']>;
  detachAllCollectionsFromTemplate: Array<Collection>;
  detachCollectionFromTemplate: Collection;
  detachProcessFromAction: ProcessAction;
  duplicateEmailTemplate: EmailTemplateMutationResult;
  duplicateProcessModel: ProcessModelResult;
  duplicateRequiredDocument: RequiredDocument;
  editCandidatePaymentSettings: Contract;
  editFutureRecurringFee: Contract;
  editLicensePaymentSettings: Contract;
  endAndReplaceRecurringFee: Contract;
  endDiscount: Contract;
  executeCandidateAccountingRecordMultiEdit: CandidateAccountingRecordMultiEditResult;
  executeCandidateInterviewMultiEdit: CandidateInterviewMultiEditResult;
  executeCandidateListMultiEdit: CandidateListMultiEditResult;
  executeCandidateMultiEdit: Array<Candidate>;
  executeCandidateMultiInvite?: Maybe<Scalars['Void']['output']>;
  executeCandidateMultiUninvite?: Maybe<Scalars['Void']['output']>;
  finalizeInvoiceDraft?: Maybe<Invoice>;
  generateActivationCondition: GenerateActivationConditionResult;
  generateAllDocumentTemplatesForCandidate: Array<DocumentTemplate>;
  generateAllDocumentTemplatesForCollection: Array<DocumentTemplate>;
  generateCandidateReceipt: CandidateReceipt;
  generateDocumentTemplate: DocumentTemplate;
  generatePdfFormForTask: DocumentTemplate;
  getAndGenerateNonEditedTemplate: DocumentTemplate;
  getOtherChatUser?: Maybe<OtherChatUser>;
  giveConsent: MutationResult;
  giveConsentToTermsAndConditions?: Maybe<Scalars['Void']['output']>;
  ignoreInvoiceDraft?: Maybe<Invoice>;
  importXLSXProcessTranslations: XlsxTranslationImportResult;
  initiateDocxTemplateSigning: SigningSubmissionOutput;
  inviteCandidate?: Maybe<CandidateSystemOnboarding>;
  linkGuetegemeinschaftOrganization: GuetegemeinschaftOrganizationLinkOutput;
  makeCollectionFilterPresetPrivate: CollectionFilterPreset;
  makeCollectionFilterPresetPublic: CollectionFilterPreset;
  makeTenantToDemoTenant: CopyResult;
  markDocumentTemplateAsEdited: DocumentTemplate;
  markInvoiceAsPaid?: Maybe<Invoice>;
  markInvoiceDraftAsManuallySent?: Maybe<Invoice>;
  markTalent?: Maybe<Scalars['Void']['output']>;
  mergeDocuments: DocumentFreeFormatFile;
  multiEditOrganizationLink: Array<OrganizationLink>;
  openAiChatSession: AiChatSessionDetail;
  parseCv: ParsedCandidateFromCv;
  performTask: ProcessPerformResult;
  prefillEducationCourseWeek?: Maybe<Scalars['Void']['output']>;
  profilePictureUpdated: MutationResult;
  purchaseContingent: Contingent;
  reInviteUser: MutationResult;
  reconnectStripeCustomer?: Maybe<CustomerResult>;
  refreshAccrualSnapshots: Scalars['Int']['output'];
  refreshSigningSubmission?: Maybe<SigningSubmissionOutput>;
  regenerateSubagentResult: RegenerateOutcome;
  rejectChallengeBooking: ChallengeBooking;
  rejectChallengeBookings: Array<ChallengeBooking>;
  remindTask?: Maybe<TaskReminderState>;
  removeAssignedCollection: Collection;
  removeCandidateDeletionRequest?: Maybe<Scalars['Void']['output']>;
  removeCandidateFromCollection: MutationResult;
  removeDiscount: Contract;
  removeDocumentTypeOverwrite: MutationResult;
  removeForeignGroupsFromUserGroup: UserGroup;
  removeLicense?: Maybe<Scalars['Void']['output']>;
  removeOrganization: MutationResult;
  removeRecurringFee: Contract;
  removeUser: MutationResult;
  removeUserGroup: MutationResult;
  removeUsersFromGroup: UserGroup;
  renameAiChatSession: AiChatSessionSummary;
  requestTalentsRestricted?: Maybe<Scalars['Void']['output']>;
  requireConsentOrganization: Organization;
  resendOrganizationLinkInvitation: OrganizationLinkInvitation;
  resendProcessEmail: MutationResult;
  resetCandidatePassword?: Maybe<CandidateSystemOnboarding>;
  resetConsent?: Maybe<Scalars['Void']['output']>;
  /** Clears the in-memory consistency violation collector. Requires ENABLE_CONSISTENCY_REPORT=true. */
  resetConsistencyViolations: Scalars['Boolean']['output'];
  resetPassword: MutationResult;
  resubmitCandidateApplicationMask: CreateApplicationMaskResponse;
  retractProcessAgentFeedback: Scalars['Boolean']['output'];
  revokeChallengeResponse: ChallengeBooking;
  revokeChallengeResponses: Array<ChallengeBooking>;
  runAgent: AgentRunHandle;
  saveAiChatTurnMessages: AiChatTurn;
  saveProcessModelAverageDurations: MutationResult;
  saveUserView: UserSavedView;
  sendMessage: MutationResult;
  sendProcessEmail: MutationResult;
  sendProcessEmails: MutationResult;
  setBillingHistory: BillingHistory;
  setCollectionAutoFilter: CollectionAutoFilter;
  setCollectionAutoFilterTemplate: CollectionAutoFilterTemplate;
  setCommunicationLanguage: MutationResult;
  setContractTemplate: ContractTemplate;
  setCvParsingAddOnConfig: CvParsingAddOnConfig;
  setDashboardWidget: DashboardWidget;
  setFavoriteCandidate: MutationResult;
  setFavoriteCollection: MutationResult;
  setGeneralBrokerAddOnConfig: GeneralBrokerAddOnConfig;
  setLicenseIsDemo?: Maybe<Scalars['Void']['output']>;
  setMatchingEnabled: MutationResult;
  setNotificationSettings: NotificationSettings;
  setOrganizationContactSettings: OrganizationContactSettings;
  setOrganizationCrm: OrganizationCrm;
  setOrganizationProfile: OrganizationProfile;
  setPdfFormTemplate: PdfFormTemplate;
  setPdfFormTemplateSettings: PdfFormTemplateSettings;
  setProcessGraphSettings: ProcessGraphSettings;
  setProfessionConfiguration: ProfessionConfiguration;
  setServiceConfiguration: AddInServiceConfiguration;
  startCandidateChatGroupConversation: ChatGroup;
  stopProcessEmail: MutationResult;
  submitProcessAgentFeedback: Scalars['Boolean']['output'];
  submitSharing: Sharing;
  switchUserOrganization: Scalars['Boolean']['output'];
  syncAllCollectionsWithTemplate: Array<Collection>;
  syncCollectionWithTemplate: Collection;
  syncInvoiceStatusesFromStripe: InvoiceStripeSyncResult;
  syncRecentStripeChanges: RecentStripeChangesSyncResult;
  toggleFavoriteChat: ChatUser;
  toggleMessagesReception: MessagesReception;
  toggleMutedChat: ChatUser;
  transferCandidates: CandidateTransferResult;
  transferCollection: CollectionTransferResult;
  truncateAiChatSession: Scalars['Boolean']['output'];
  unBlockUser: User;
  unInviteCandidate?: Maybe<CandidateSystemOnboarding>;
  undoLastCommand: ProcessModelCommandResult;
  unmarkTalent?: Maybe<Scalars['Void']['output']>;
  unpublishProcessModel: PublishedProcessModelEntity;
  unsetFavoriteCandidate: MutationResult;
  unsetFavoriteCollection: MutationResult;
  unsubmitSharing: Sharing;
  unsubscribeCandidateByLink: Scalars['Boolean']['output'];
  updateAdHocEducationExam: AdHocEducationExam;
  updateAdhocTask: ProcessTaskResult;
  updateAssignedCandidates: Collection;
  updateAssignmentExceptions: Collection;
  updateAuditDefinition: AuditDefinition;
  updateAuditDefinitionMeta: AuditDefinition;
  updateBillingSettings: BillingSettings;
  updateCandidate: Candidate;
  updateCandidateAccountingRecord: CandidateAccountingRecord;
  updateCandidateApplicationMaskConfig: CandidateApplicationMaskConfig;
  updateCandidateLicensedOrganizationData: Candidate;
  updateCandidateProfile: Candidate;
  updateCandidateProfileConfig: CandidateProfileConfig;
  updateCandidateStatusChange?: Maybe<Scalars['Void']['output']>;
  updateChatConfiguration: ChatConfiguration;
  updateChatGroup: ChatGroup;
  updateChatGroupConfiguration: ChatGroupConfiguration;
  updateChildOrganizationLinks: Array<OrganizationLink>;
  updateCollection: Collection;
  updateCollectionFilterPreset: CollectionFilterPreset;
  updateComment: Comment;
  updateConsent: Consent;
  updateCustomContingentDefinitionSet: CustomContingentDefinitionSet;
  updateCustomPlan: CustomPlan;
  updateDocument: Document;
  updateDocumentDetectedLanguage: Scalars['Boolean']['output'];
  updateEducationCourse: EducationCourse;
  updateEducationCourseTotalPerformanceState?: Maybe<Scalars['Void']['output']>;
  updateEducationCourseWeek?: Maybe<Scalars['Void']['output']>;
  updateEducationCourseWeeklyAttendance?: Maybe<Scalars['Void']['output']>;
  updateEducationCourseWeeklyComment?: Maybe<Scalars['Void']['output']>;
  updateEducationCourseWeeklyPerformance?: Maybe<Scalars['Void']['output']>;
  updateEducationExam: EducationExam;
  updateEducationModule: EducationModule;
  updateEmailSendOutRule: EmailSendOutRule;
  updateEmailTemplate: EmailTemplateMutationResult;
  updateFeedback: Feedback;
  updateLaborAgreement: LaborAgreement;
  updateLastSelectedProfileMaskId?: Maybe<Scalars['Void']['output']>;
  updateLocalPartnerProfileConfigSet: LocalPartnerProfileConfigSet;
  updateMilestoneDashboardSharing: MilestoneDashboardSharing;
  updateNote: Note;
  updateOnlineApplicationConfiguration: Scalars['Boolean']['output'];
  updateOrganization: Organization;
  updateOrganizationContact: OrganizationContact;
  updateOrganizationContractSettings: OrganizationContractSettings;
  updateOrganizationLink: OrganizationLink;
  updateOrganizationTag: OrganizationTag;
  updatePdfFormTemplateWatch: PdfFormTemplateWatch;
  updatePlanningSharing?: Maybe<PlanningSharing>;
  updatePlanningState: PlanningStateForList;
  updateProcessAction: ProcessAction;
  updateProcessMilestoneList: ProcessMilestoneList;
  updateProcessMilestoneMapping: ProcessMilestoneMapping;
  updateProcessMilestoneSharing: ProcessMilestoneSharing;
  updateProcessModel: ProcessModelResult;
  updateProcessModelRelease: ReleasedProcessModelInfo;
  updateProfessionalExperience: ProfessionalExperience;
  updateProfessionalField: ProfessionalField;
  updateRequiredDocument: RequiredDocument;
  updateRequiredDocumentMeta: RequiredDocument;
  updateRequiredVaccinations: RequiredVaccinations;
  updateSharing: Sharing;
  updateSharingPreset: SharingPreset;
  updateSharingTemplate: SharingTemplate;
  updateSystemSetting: SystemSetting;
  updateTableColumns: TableColumnConfig;
  updateTalentPool: TalentPool;
  updateTalentPoolParticipant: TalentPoolParticipant;
  updateTalentPoolSharing: TalentPoolSharing;
  updateTalentPoolTalentRequestState?: Maybe<TalentPoolRequestedTalent>;
  updateTask: ProcessTaskResult;
  updateTaskDelay: ProcessTaskResult;
  updateTaskDelegationRule: TaskDelegationRule;
  updateUser: User;
  updateUserGroup: UserGroup;
  updateUserSettingForTaskTableModeForInbox?: Maybe<Scalars['Void']['output']>;
  updateUserSettingForTaskVisibilityForInbox?: Maybe<Scalars['Void']['output']>;
  updateWebhookConfig: WebhookConfig;
  upsertCandidateFieldTranslations: Array<PropertyTranslation>;
  upsertContingentCorrection: ContingentCorrectionEntity;
  upsertCredentials: Scalars['Boolean']['output'];
  upsertDocumentTypeOverwrite?: Maybe<DocumentTypeOverwrite>;
  upsertDocumentWithoutProcessStateChange?: Maybe<Document>;
  upsertEducationExamResult: EducationExamResult;
  upsertFloorCorrection: FloorCorrectionEntity;
  upsertGeneralDocumentRequirements: GeneralDocumentRequirement;
  upsertInterviewComment: CandidateInterviewsFeedback;
  upsertInterviewEmployer: CandidateInterviewsFeedback;
  upsertInterviewFeedback: CandidateInterviewsFeedback;
  upsertManyDocumentRequirements: Array<DocumentRequirement>;
  upsertOnlineApplicationMaintenanceMessage: Scalars['Boolean']['output'];
  upsertProfessionalFieldSettings: ProfessionalFieldSettings;
  userHasSeenNewAnkaadiaAnnouncement: UserEnvironment;
  userPrefersNewUi: UserEnvironment;
  validateCandidateGroupExists: ChatGroup;
  withdrawChallengeBooking: MutationResult;
  withdrawChallengeBookings: Array<MutationResult>;
  withdrawContractCancellation: Contract;
};


export type MutationAcceptChallengeBookingArgs = {
  input: ChallengeBookingAcceptInput;
};


export type MutationAcceptChallengeBookingsArgs = {
  input: Array<ChallengeBookingAcceptInput>;
};


export type MutationAcceptOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationAcceptInput;
};


export type MutationAddAssignedCollectionArgs = {
  input: AssignCollectionInput;
};


export type MutationAddCandidateDeletionRequestArgs = {
  candidateId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};


export type MutationAddCandidateDiscountArgs = {
  input: AddDiscountInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationAddCandidateToCollectionsArgs = {
  input: AddCandidatesToCollectionsInput;
};


export type MutationAddForeignGroupsToUserGroupArgs = {
  input: AddForeignGroupsToGroupInput;
};


export type MutationAddLicenseDiscountArgs = {
  input: AddDiscountInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationAddRecurringFeeArgs = {
  input: AddRecurringFeeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationAddUsersToGroupArgs = {
  input: AddUsersToGroupInput;
};


export type MutationAnnulContractArgs = {
  input: AnnulContractInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationApplyAutoFilterTemplateOnAllCandidatesArgs = {
  input: ApplyAutoFilterTemplateOnAllCandidatesInput;
};


export type MutationApplyCommandArgs = {
  input: ProcessTaskModelCommandInputType;
  language: Scalars['String']['input'];
  validate: Scalars['Boolean']['input'];
};


export type MutationApplyCommandBatchArgs = {
  input: ProcessModelCommandBatchInput;
  language: Scalars['String']['input'];
  validate: Scalars['Boolean']['input'];
};


export type MutationApplyEmployerArgs = {
  input: EmployerApplicationInput;
};


export type MutationApplySubagentResultArgs = {
  input: ApplySubagentResultInput;
};


export type MutationApplySubagentResultBatchArgs = {
  input: BatchApplySubagentResultInput;
};


export type MutationApproveCandidateDiffPathsArgs = {
  input: ApproveCandidateDiffPathsInput;
};


export type MutationArchiveCustomPlanArgs = {
  input: ArchiveCustomPlanInput;
};


export type MutationAttachAutoCollectionsToTemplateArgs = {
  input: CollectionAutoFilterTemplateAttachInput;
};


export type MutationAttachProcessToActionArgs = {
  input: AttachProcessToActionInput;
};


export type MutationBlockUnblockCandidateArgs = {
  blocked: Scalars['Boolean']['input'];
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationBulkCreateAdhocTasksArgs = {
  input: AdhocProcessTaskBulkCreateInput;
};


export type MutationBulkEditTasksArgs = {
  input: ProcessTaskBulkEditInput;
};


export type MutationCancelContractArgs = {
  input: CancelContractInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationChangeContractAmendmentsArgs = {
  input: ContractChangeAmendmentsInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationChangeLockModeForDocumentsArgs = {
  input: DocumentLockInput;
};


export type MutationChangeLockModeForDocumentsByCandidateArgs = {
  input: DocumentLockAllInput;
};


export type MutationChangeOwnOrganizationUserPriceArgs = {
  input: EditUserPriceInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationChangePartnerOrganizationUserPriceArgs = {
  input: EditUserPriceInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationChangePlanArgs = {
  input: ChangePlanInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationClaimSigningSlotArgs = {
  input: ClaimSigningSlotInput;
};


export type MutationClearNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearPdfFormTemplateArgs = {
  input: PdfFormTemplateClearInput;
};


export type MutationConvertDerivedProcessModelToBaseArgs = {
  input: ProcessModelConvertToBaseInput;
};


export type MutationCopyDataToOrgArgs = {
  dataType: CopyDataTypeEnum;
  organizationId: Scalars['ID']['input'];
  templateDisplayNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCopySharingPresetArgs = {
  input: SharingPresetCopyInput;
};


export type MutationCreateAdHocEducationExamArgs = {
  input: AdHocEducationExamCreateInput;
};


export type MutationCreateAddOnInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type MutationCreateAdhocTaskArgs = {
  input: AdhocProcessTaskCreateInput;
};


export type MutationCreateAuditDefinitionArgs = {
  input: AuditDefinitionCreateInput;
};


export type MutationCreateCandidateArgs = {
  currentCollection?: InputMaybe<CandidateCreateCurrentSelection>;
  input: CandidateCreateInput;
};


export type MutationCreateCandidateAccountingRecordArgs = {
  input: CandidateAccountingRecordCreateInput;
};


export type MutationCreateCandidateApplicationMaskArgs = {
  input: CandidateApplicationMaskInput;
};


export type MutationCreateCandidateApplicationMaskConfigArgs = {
  input: CandidateApplicationMaskConfigCreateInput;
};


export type MutationCreateCandidateProfileConfigArgs = {
  input: CandidateProfileConfigCreateInput;
};


export type MutationCreateCandidatesInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type MutationCreateChallengeBookingArgs = {
  input: ChallengeBookingCreateInput;
};


export type MutationCreateChallengeBookingsArgs = {
  input: Array<ChallengeBookingCreateInput>;
};


export type MutationCreateChatGroupArgs = {
  input: ChatGroupCreateInput;
};


export type MutationCreateChatGroupConfigurationArgs = {
  input: ChatGroupConfigurationCreateInput;
};


export type MutationCreateCollectionArgs = {
  input: CollectionCreateInput;
};


export type MutationCreateCollectionFilterPresetArgs = {
  input: CollectionFilterPresetCreateInput;
};


export type MutationCreateCollectionWithSharingArgs = {
  input: CollectionAndSharingInput;
};


export type MutationCreateCommentArgs = {
  input: CommentCreateInput;
};


export type MutationCreateCommissionArgs = {
  input: CreateCommissionInput;
};


export type MutationCreateConsentArgs = {
  input: ConsentCreateInput;
};


export type MutationCreateContractArgs = {
  input: ContractCreateInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateCustomContingentDefinitionSetArgs = {
  input: CreateCustomContingentDefinitionSetInput;
};


export type MutationCreateCustomPlanArgs = {
  input: CreateCustomPlanInput;
};


export type MutationCreateDerivedProcessModelArgs = {
  input: ProcessModelCreateDerivedInput;
};


export type MutationCreateDocumentArgs = {
  input: DocumentCreateInput;
};


export type MutationCreateDocumentAiPerformancesArgs = {
  input: DocumentAiPerformanceCreateInput;
};


export type MutationCreateEducationCourseArgs = {
  input: EducationCourseCreateInput;
};


export type MutationCreateEducationCourseCollectionArgs = {
  input: EducationCourseCollectionCreateInput;
};


export type MutationCreateEducationExamArgs = {
  input: EducationExamCreateInput;
};


export type MutationCreateEducationExamParticipantArgs = {
  input: EducationExamParticipantCreateInput;
};


export type MutationCreateEducationModuleArgs = {
  input: EducationModuleCreateInput;
};


export type MutationCreateEmailSendOutRuleArgs = {
  input: EmailSendOutRuleCreateInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: EmailTemplateCreateInput;
  language: Scalars['String']['input'];
};


export type MutationCreateEmptyProcessModelArgs = {
  input: ProcessModelCreateEmptyInput;
};


export type MutationCreateFeedbackArgs = {
  input: FeedbackCreateInput;
};


export type MutationCreateLaborAgreementArgs = {
  input: LaborAgreementCreateInput;
};


export type MutationCreateLicenseForOrganizationArgs = {
  isDemo?: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateLicenseInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type MutationCreateLocalPartnerProfileConfigSetArgs = {
  input: LocalPartnerProfileConfigSetCreateInput;
};


export type MutationCreateManualBookingsArgs = {
  input: Array<CreateManualBookingInput>;
};


export type MutationCreateManyEducationExamParticipantsArgs = {
  input: EducationExamParticipantCreateManyInput;
};


export type MutationCreateMilestoneDashboardSharingArgs = {
  input: MilestoneDashboardSharingCreateInput;
};


export type MutationCreateNewPublicApiAccessTokenArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationCreateNoteArgs = {
  input: NoteCreateInput;
};


export type MutationCreateOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationCreateOrganizationAndCertificationProcessArgs = {
  input: GuetegemeinschaftOrganizationReCertificationInput;
};


export type MutationCreateOrganizationContactArgs = {
  input: OrganizationContactCreateInput;
};


export type MutationCreateOrganizationLinkArgs = {
  input: OrganizationLinksCreateInput;
};


export type MutationCreateOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationCreateInput;
};


export type MutationCreateOrganizationTagArgs = {
  input: OrganizationTagCreateInput;
};


export type MutationCreatePlanningSharingArgs = {
  input: PlanningSharingInput;
};


export type MutationCreatePlanningStateArgs = {
  input: ProcessPlanningStateInput;
};


export type MutationCreateProcessActionArgs = {
  input: ProcessActionCreateInput;
};


export type MutationCreateProcessMilestoneListArgs = {
  input: ProcessMilestoneListCreateInput;
};


export type MutationCreateProcessMilestoneSharingArgs = {
  input: ProcessMilestoneSharingCreateInput;
};


export type MutationCreateProfessionalExperienceArgs = {
  input: ProfessionalExperienceCreateInput;
};


export type MutationCreateProfessionalFieldArgs = {
  input: ProfessionalFieldCreateInput;
};


export type MutationCreatePublicTalentpoolRequestingOrganizationAndUserArgs = {
  input: CreatePublicTalentpoolRequestingOrganizationAndUserInput;
};


export type MutationCreateReCertificationProcessArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationCreateRequiredDocumentArgs = {
  input: RequiredDocumentCreateInput;
};


export type MutationCreateSharingPresetArgs = {
  input: SharingPresetCreateInput;
};


export type MutationCreateSharingTemplateArgs = {
  input: SharingTemplateCreateInput;
};


export type MutationCreateSharingsArgs = {
  input: SharingCreateInput;
};


export type MutationCreateShortLinkArgs = {
  longLink: Scalars['String']['input'];
};


export type MutationCreateStripeCustomerArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateSupplementaryCandidatesInvoiceArgs = {
  input: SupplementaryInvoiceCreateInput;
};


export type MutationCreateTalentPoolArgs = {
  input: TalentPoolCreateInput;
};


export type MutationCreateTalentPoolParticipantsArgs = {
  input: TalentPoolParticipantsCreateInput;
};


export type MutationCreateTalentPoolSharingArgs = {
  input: TalentPoolSharingCreateInput;
};


export type MutationCreateTaskArgs = {
  input: ProcessTaskCreateInput;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTaskDelegationRuleArgs = {
  input: TaskDelegationRuleCreateInput;
};


export type MutationCreateTranslationProposalArgs = {
  input: TranslationProposalInput;
};


export type MutationCreateUserArgs = {
  creatorOrgId: Scalars['String']['input'];
  input: UserInput;
};


export type MutationCreateUserFeedbackArgs = {
  input: UserFeedbackCreateInput;
};


export type MutationCreateUserGroupArgs = {
  input: UserGroupInput;
};


export type MutationCreateWebhookConfigArgs = {
  input: WebhookConfigCreateInput;
};


export type MutationDeclineOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationTokenInput;
};


export type MutationDeleteAccrualSnapshotsArgs = {
  input: DeleteAccrualSnapshotsInput;
};


export type MutationDeleteAccrualSnapshotsByOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteAccrualSnapshotsFromMonthArgs = {
  input: DeleteAccrualSnapshotsFromMonthInput;
};


export type MutationDeleteAdHocEducationExamArgs = {
  input: AdHocEducationExamDeleteInput;
};


export type MutationDeleteAiChatSessionArgs = {
  input: DeleteAiChatSessionInput;
};


export type MutationDeleteAuditDefinitionArgs = {
  input: AuditDefinitionDeleteInput;
};


export type MutationDeleteBlobArgs = {
  input: BlobDeleteInput;
};


export type MutationDeleteCandidateArgs = {
  input: CandidateDeleteInput;
};


export type MutationDeleteCandidateAccountingRecordArgs = {
  input: CandidateAccountingRecordDeleteInput;
};


export type MutationDeleteCandidateApplicationMaskConfigArgs = {
  input: CandidateApplicationMaskConfigDeleteInput;
};


export type MutationDeleteChatGroupArgs = {
  input: ChatGroupDeleteInput;
};


export type MutationDeleteChatGroupConfigurationArgs = {
  input: ChatGroupConfigurationDeleteInput;
};


export type MutationDeleteCollectionArgs = {
  input: CollectionDeleteInput;
};


export type MutationDeleteCollectionAutoFilterTemplateArgs = {
  input: CollectionAutoFilterTemplateDeleteInput;
};


export type MutationDeleteCollectionFilterPresetArgs = {
  input: CollectionFilterPresetDeleteInput;
};


export type MutationDeleteCommentArgs = {
  input: CommentDeleteInput;
};


export type MutationDeleteCondidateProfileConfigArgs = {
  input: CandidateProfileConfigDeleteInput;
};


export type MutationDeleteConsentArgs = {
  input: ConsentDeleteInput;
};


export type MutationDeleteContingentCorrectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractTemplateArgs = {
  input: ContractTemplateDeleteInput;
};


export type MutationDeleteCustomContingentDefinitionSetArgs = {
  input: DeleteCustomContingentDefinitionSetInput;
};


export type MutationDeleteCustomPlanArgs = {
  input: DeleteCustomPlanInput;
};


export type MutationDeleteDocumentArgs = {
  input: DocumentDeleteInput;
};


export type MutationDeleteEducationCourseArgs = {
  input: EducationCourseDeleteInput;
};


export type MutationDeleteEducationExamArgs = {
  input: EducationExamDeleteInput;
};


export type MutationDeleteEducationExamParticipantArgs = {
  input: EducationExamParticipantDeleteInput;
};


export type MutationDeleteEducationExamResultArgs = {
  input: EducationExamResultDeleteInput;
};


export type MutationDeleteEducationModuleArgs = {
  input: EducationModuleDeleteInput;
};


export type MutationDeleteEmailSendOutRuleArgs = {
  input: EmailSendOutRuleInput;
};


export type MutationDeleteEmailTemplateArgs = {
  input: EmailTemplateDeleteInput;
};


export type MutationDeleteFloorCorrectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInterviewCommentArgs = {
  input: CandidateCommentDeleteInput;
};


export type MutationDeleteInterviewFeedbackArgs = {
  input: CandidateFeedbackDeleteInput;
};


export type MutationDeleteInterviewIterationArgs = {
  input: CandidateInterviewIterationDeleteInput;
};


export type MutationDeleteInvoiceDraftArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteLaborAgreementArgs = {
  input: LaborAgreementDeleteInput;
};


export type MutationDeleteLocalPartnerProfileConfigSetArgs = {
  input: LocalPartnerProfileConfigSetDeleteInput;
};


export type MutationDeleteLoginArgs = {
  recipeId: Scalars['String']['input'];
};


export type MutationDeleteMilestoneDashboardSharingArgs = {
  input: MilestoneDashboardSharingDeleteInput;
};


export type MutationDeleteNoteArgs = {
  input: NoteDeleteInput;
};


export type MutationDeleteOrganizationContactArgs = {
  input: OrganizationContactDeleteInput;
};


export type MutationDeleteOrganizationLinkArgs = {
  input: OrganizationLinkDeleteInput;
};


export type MutationDeleteOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationIdInput;
};


export type MutationDeleteOrganizationTagArgs = {
  input: OrganizationTagDeleteInput;
};


export type MutationDeleteOwnOrganizationUserPriceArgs = {
  input: DeleteUserPriceInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationDeletePartnerOrganizationUserPriceArgs = {
  input: DeleteUserPriceInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationDeletePlanningSharingArgs = {
  planningId: Scalars['String']['input'];
};


export type MutationDeletePlanningStateArgs = {
  input: ProcessPlanningStateInput;
};


export type MutationDeleteProcessActionArgs = {
  input: ProcessActionDeleteInput;
};


export type MutationDeleteProcessMilestoneListArgs = {
  input: ProcessMilestoneListDeleteInput;
};


export type MutationDeleteProcessMilestoneSharingArgs = {
  input: ProcessMilestoneSharingDeleteInput;
};


export type MutationDeleteProcessModelArgs = {
  input: ProcessModelDeleteInput;
};


export type MutationDeleteProcessModelReleaseArgs = {
  input: ProcessModelDeleteReleaseInput;
};


export type MutationDeleteProfessionalExperienceArgs = {
  input: ProfessionalExperienceDeleteInput;
};


export type MutationDeleteProfessionalFieldArgs = {
  input: ProfessionalFieldDeleteInput;
};


export type MutationDeleteRequiredDocumentArgs = {
  input: RequiredDocumentDeleteInput;
};


export type MutationDeleteSharingArgs = {
  input: SharingDeleteInput;
};


export type MutationDeleteSharingPresetArgs = {
  input: SharingPresetDeleteInput;
};


export type MutationDeleteSharingTemplateArgs = {
  input: SharingTemplateDeleteInput;
};


export type MutationDeleteTalentPoolArgs = {
  input: TalentPoolDeleteInput;
};


export type MutationDeleteTalentPoolParticipantArgs = {
  input: TalentPoolParticipantDeleteInput;
};


export type MutationDeleteTalentPoolRequestedTalentArgs = {
  input: TalentPoolRequestedTalentDeleteInput;
};


export type MutationDeleteTalentPoolSharingArgs = {
  input: TalentPoolSharingDeleteInput;
};


export type MutationDeleteTaskArgs = {
  input: ProcessTaskDeleteInput;
};


export type MutationDeleteTaskDelegationRuleArgs = {
  input: TaskDelegationRuleDeleteInput;
};


export type MutationDeleteUserChatArgs = {
  input: ChatUserDeleteConversationInput;
};


export type MutationDeleteUserViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebhookConfigArgs = {
  etag: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationDetachAllCollectionsFromTemplateArgs = {
  input: CollectionAutoFilterTemplateDetachAllInput;
};


export type MutationDetachCollectionFromTemplateArgs = {
  input: CollectionAutoFilterTemplateDetachInput;
};


export type MutationDetachProcessFromActionArgs = {
  input: DetachProcessFromActionInput;
};


export type MutationDuplicateEmailTemplateArgs = {
  input: EmailTemplateDuplicateInput;
};


export type MutationDuplicateProcessModelArgs = {
  input: ProcessModelDuplicateInput;
};


export type MutationDuplicateRequiredDocumentArgs = {
  input: RequiredDocumentDuplicateInput;
};


export type MutationEditCandidatePaymentSettingsArgs = {
  input: EditPaymentSettingsInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationEditFutureRecurringFeeArgs = {
  input: EditFutureRecurringFeeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationEditLicensePaymentSettingsArgs = {
  input: EditPaymentSettingsInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationEndAndReplaceRecurringFeeArgs = {
  input: EndAndReplaceRecurringFeeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationEndDiscountArgs = {
  input: EndDiscountInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationExecuteCandidateAccountingRecordMultiEditArgs = {
  input: CandidateAccountingRecordMultiEditInput;
};


export type MutationExecuteCandidateInterviewMultiEditArgs = {
  input: CandidateInterviewMultiEditInput;
};


export type MutationExecuteCandidateListMultiEditArgs = {
  input: CandidateListMultiEditInput;
};


export type MutationExecuteCandidateMultiEditArgs = {
  input: CandidateMultiEditExecuteInput;
};


export type MutationExecuteCandidateMultiInviteArgs = {
  input: CandidateMultiInviteExecuteInput;
};


export type MutationExecuteCandidateMultiUninviteArgs = {
  input: CandidateMultiInviteExecuteInput;
};


export type MutationFinalizeInvoiceDraftArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationGenerateActivationConditionArgs = {
  input: GenerateActivationConditionInput;
};


export type MutationGenerateAllDocumentTemplatesForCandidateArgs = {
  input: DocumentTemplateCandidateInput;
};


export type MutationGenerateAllDocumentTemplatesForCollectionArgs = {
  input: DocumentTemplateCollectionInput;
};


export type MutationGenerateCandidateReceiptArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationGenerateDocumentTemplateArgs = {
  input: DocumentTemplateGenerateInput;
};


export type MutationGeneratePdfFormForTaskArgs = {
  input: PdfFormForTaskInput;
};


export type MutationGetAndGenerateNonEditedTemplateArgs = {
  input: DocumentTemplateGenerateInput;
};


export type MutationGetOtherChatUserArgs = {
  input: ChatUserExistsInput;
};


export type MutationGiveConsentArgs = {
  auth0UserId: Scalars['String']['input'];
  browserLanguage?: InputMaybe<Scalars['String']['input']>;
  isCandidate: Scalars['Boolean']['input'];
  isTalentpoolUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
  userOrCandidateId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationGiveConsentToTermsAndConditionsArgs = {
  input: GiveConsentInput;
};


export type MutationIgnoreInvoiceDraftArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationImportXlsxProcessTranslationsArgs = {
  input: XlsxProcessTranslationImportInput;
  language: Scalars['String']['input'];
};


export type MutationInitiateDocxTemplateSigningArgs = {
  input: InitiateSigningInput;
};


export type MutationInviteCandidateArgs = {
  candidateId: Scalars['String']['input'];
  invitedOrganizationid: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationLinkGuetegemeinschaftOrganizationArgs = {
  input: GuetegemeinschaftOrganizationLinkInput;
};


export type MutationMakeCollectionFilterPresetPrivateArgs = {
  input: CollectionFilterPresetChangeStateInput;
};


export type MutationMakeCollectionFilterPresetPublicArgs = {
  input: CollectionFilterPresetChangeStateInput;
};


export type MutationMakeTenantToDemoTenantArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationMarkDocumentTemplateAsEditedArgs = {
  input: DocumentTemplateEditedInput;
};


export type MutationMarkInvoiceAsPaidArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationMarkInvoiceDraftAsManuallySentArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationMarkTalentArgs = {
  input: TalentInstanceInput;
};


export type MutationMergeDocumentsArgs = {
  input: MergeDocumentsInput;
};


export type MutationMultiEditOrganizationLinkArgs = {
  input: OrganizationLinkMultiEditInput;
};


export type MutationOpenAiChatSessionArgs = {
  input: OpenAiChatSessionInput;
};


export type MutationParseCvArgs = {
  input: ParseCvInput;
};


export type MutationPerformTaskArgs = {
  input: ProcessStateUpdateInput;
};


export type MutationPrefillEducationCourseWeekArgs = {
  input: EducationCourseWeekPrefillInput;
};


export type MutationProfilePictureUpdatedArgs = {
  input: DocumentThumbnailInput;
};


export type MutationPurchaseContingentArgs = {
  input: PurchaseContingentInput;
};


export type MutationReInviteUserArgs = {
  orgId: Scalars['String']['input'];
  orgIdofInviter: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationReconnectStripeCustomerArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRefreshAccrualSnapshotsArgs = {
  month: Scalars['UTCDate']['input'];
};


export type MutationRefreshSigningSubmissionArgs = {
  input: ClaimSigningSlotInput;
};


export type MutationRegenerateSubagentResultArgs = {
  input: RegenerateSubagentResultInput;
};


export type MutationRejectChallengeBookingArgs = {
  input: ChallengeBookingRejectInput;
};


export type MutationRejectChallengeBookingsArgs = {
  input: Array<ChallengeBookingRejectInput>;
};


export type MutationRemindTaskArgs = {
  orgId: Scalars['String']['input'];
  targetRolesToUse?: InputMaybe<Array<Scalars['String']['input']>>;
  taskId: Scalars['String']['input'];
};


export type MutationRemoveAssignedCollectionArgs = {
  input: AssignCollectionInput;
};


export type MutationRemoveCandidateDeletionRequestArgs = {
  input: CandidateRequestDeleteInput;
};


export type MutationRemoveCandidateFromCollectionArgs = {
  input: CandidateAndCollectionIdInput;
};


export type MutationRemoveDiscountArgs = {
  input: RemoveDiscountInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveDocumentTypeOverwriteArgs = {
  input: DocumentTypeOverwriteDeleteInput;
};


export type MutationRemoveForeignGroupsFromUserGroupArgs = {
  input: RemoveForeignGroupsFromGroupInput;
};


export type MutationRemoveLicenseArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveOrganizationArgs = {
  input: OrganizationDeleteInput;
};


export type MutationRemoveRecurringFeeArgs = {
  input: RemoveRecurringFeeInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveUserArgs = {
  input: DeleteUserInput;
};


export type MutationRemoveUserGroupArgs = {
  etag: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveUsersFromGroupArgs = {
  input: RemoveUsersFromGroupInput;
};


export type MutationRenameAiChatSessionArgs = {
  input: RenameAiChatSessionInput;
};


export type MutationRequestTalentsRestrictedArgs = {
  input: RestrictedTalentPoolTalentRequestInput;
};


export type MutationRequireConsentOrganizationArgs = {
  input: OrganizationRequireConsentInput;
};


export type MutationResendOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationIdInput;
};


export type MutationResendProcessEmailArgs = {
  input: ProcessEmailInput;
};


export type MutationResetCandidatePasswordArgs = {
  candidateId: Scalars['String']['input'];
  invitedOrganizationid: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationResetConsentArgs = {
  consentGiverId?: InputMaybe<Scalars['ID']['input']>;
  consentIdentifier: KnownConsentIdentifiers;
  organizationId: Scalars['ID']['input'];
};


export type MutationResubmitCandidateApplicationMaskArgs = {
  input: CandidateApplicationMaskResubmitInput;
};


export type MutationRetractProcessAgentFeedbackArgs = {
  input: RetractProcessAgentFeedbackInput;
};


export type MutationRevokeChallengeResponseArgs = {
  input: ChallengeBookingRevokeResponseInput;
};


export type MutationRevokeChallengeResponsesArgs = {
  input: Array<ChallengeBookingRevokeResponseInput>;
};


export type MutationRunAgentArgs = {
  input: ChatRequestDto;
};


export type MutationSaveAiChatTurnMessagesArgs = {
  input: SaveAiChatTurnMessagesInput;
};


export type MutationSaveProcessModelAverageDurationsArgs = {
  input: ProcessModelAverageDurationSaveInput;
};


export type MutationSaveUserViewArgs = {
  input: UserViewInput;
};


export type MutationSendMessageArgs = {
  message: Scalars['String']['input'];
};


export type MutationSendProcessEmailArgs = {
  input: EmailSendInput;
};


export type MutationSendProcessEmailsArgs = {
  input: EmailListSendInput;
};


export type MutationSetBillingHistoryArgs = {
  input: BillingHistorySetInput;
};


export type MutationSetCollectionAutoFilterArgs = {
  input: CollectionAutoFilterSetInput;
};


export type MutationSetCollectionAutoFilterTemplateArgs = {
  input: CollectionAutoFilterTemplateSetInput;
};


export type MutationSetCommunicationLanguageArgs = {
  communicationLanguage: Scalars['String']['input'];
};


export type MutationSetContractTemplateArgs = {
  input: ContractTemplateSetInput;
};


export type MutationSetCvParsingAddOnConfigArgs = {
  input: CvParsingAddOnConfigSetInput;
};


export type MutationSetDashboardWidgetArgs = {
  input: DashboardWidgetSetInput;
};


export type MutationSetFavoriteCandidateArgs = {
  input: FavoriteCandidateInput;
};


export type MutationSetFavoriteCollectionArgs = {
  input: FavoriteCollectionInput;
};


export type MutationSetGeneralBrokerAddOnConfigArgs = {
  input: GeneralBrokerAddOnConfigSetInput;
};


export type MutationSetLicenseIsDemoArgs = {
  isDemo: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationSetMatchingEnabledArgs = {
  input: EnableMatchingInput;
};


export type MutationSetNotificationSettingsArgs = {
  input: NotificationSettingsInput;
};


export type MutationSetOrganizationContactSettingsArgs = {
  input: OrganizationContactSettingsSetInput;
};


export type MutationSetOrganizationCrmArgs = {
  input: OrganizationCrmSetInput;
};


export type MutationSetOrganizationProfileArgs = {
  input: OrganizationProfileSetInput;
};


export type MutationSetPdfFormTemplateArgs = {
  input: PdfFormTemplateSetInput;
};


export type MutationSetPdfFormTemplateSettingsArgs = {
  input: PdfFormTemplateSettingsSetInput;
};


export type MutationSetProcessGraphSettingsArgs = {
  input: ProcessGraphSettingsInput;
};


export type MutationSetProfessionConfigurationArgs = {
  input: ProfessionConfigurationSetInput;
};


export type MutationSetServiceConfigurationArgs = {
  input: AddOnServiceConfigurationInput;
};


export type MutationStartCandidateChatGroupConversationArgs = {
  input: StartCandidateChatGroupConversation;
};


export type MutationStopProcessEmailArgs = {
  input: ProcessEmailInput;
};


export type MutationSubmitProcessAgentFeedbackArgs = {
  input: ProcessAgentFeedbackInput;
};


export type MutationSubmitSharingArgs = {
  input: SharingSubmitInput;
};


export type MutationSwitchUserOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSyncAllCollectionsWithTemplateArgs = {
  input: AllCollectionsAutoFilterTemplateSyncInput;
};


export type MutationSyncCollectionWithTemplateArgs = {
  input: CollectionAutoFilterTemplateSyncInput;
};


export type MutationSyncInvoiceStatusesFromStripeArgs = {
  input: InvoiceStripeSyncInput;
};


export type MutationSyncRecentStripeChangesArgs = {
  input: RecentStripeChangesSyncInput;
};


export type MutationToggleFavoriteChatArgs = {
  input: ChatUserToggleFavoriteInput;
};


export type MutationToggleMessagesReceptionArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidate: Scalars['Boolean']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleMutedChatArgs = {
  input: ChatUserToggleMutedInput;
};


export type MutationTransferCandidatesArgs = {
  input: CandidateTransferInput;
};


export type MutationTransferCollectionArgs = {
  input: CollectionTransferInput;
};


export type MutationTruncateAiChatSessionArgs = {
  input: TruncateAiChatSessionInput;
};


export type MutationUnBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationUnInviteCandidateArgs = {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUndoLastCommandArgs = {
  input: ProcessModelUndoCommand;
};


export type MutationUnmarkTalentArgs = {
  input: TalentInstanceInput;
};


export type MutationUnpublishProcessModelArgs = {
  input: ProcessModelUnpublishInput;
};


export type MutationUnsetFavoriteCandidateArgs = {
  input: FavoriteCandidateInput;
};


export type MutationUnsetFavoriteCollectionArgs = {
  input: FavoriteCollectionInput;
};


export type MutationUnsubmitSharingArgs = {
  input: SharingSubmitInput;
};


export type MutationUnsubscribeCandidateByLinkArgs = {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateAdHocEducationExamArgs = {
  input: AdHocEducationExamUpdateInput;
};


export type MutationUpdateAdhocTaskArgs = {
  input: AdhocProcessTaskUpdateInput;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAssignedCandidatesArgs = {
  input: UpdateAssignedCandidatesInput;
};


export type MutationUpdateAssignmentExceptionsArgs = {
  input: UpdateAssignmentExceptionsInput;
};


export type MutationUpdateAuditDefinitionArgs = {
  input: AuditDefinitionUpdateInput;
};


export type MutationUpdateAuditDefinitionMetaArgs = {
  input: AuditDefinitionUpdateMetaInput;
};


export type MutationUpdateBillingSettingsArgs = {
  input: UpdateBillingSettingsInput;
};


export type MutationUpdateCandidateArgs = {
  input: CandidateUpdateInput;
  sharing: CandidateUpdateInputSharing;
};


export type MutationUpdateCandidateAccountingRecordArgs = {
  input: CandidateAccountingRecordUpdateInput;
};


export type MutationUpdateCandidateApplicationMaskConfigArgs = {
  input: CandidateApplicationMaskConfigUpdateInput;
};


export type MutationUpdateCandidateLicensedOrganizationDataArgs = {
  input: CandidateLicensedOrganizationDataUpdateInput;
};


export type MutationUpdateCandidateProfileArgs = {
  input: CandidateProfileUpdateInput;
};


export type MutationUpdateCandidateProfileConfigArgs = {
  input: CandidateProfileConfigUpdateInput;
};


export type MutationUpdateCandidateStatusChangeArgs = {
  input: CandidateStatusChangeUpdateInput;
};


export type MutationUpdateChatConfigurationArgs = {
  input: ChatConfigurationUpsertInput;
};


export type MutationUpdateChatGroupArgs = {
  input: ChatGroupUpdateInput;
};


export type MutationUpdateChatGroupConfigurationArgs = {
  input: ChatGroupConfigurationUpdateInput;
};


export type MutationUpdateChildOrganizationLinksArgs = {
  input: OrganizationLinkUpdateChildLinksInput;
};


export type MutationUpdateCollectionArgs = {
  input: CollectionUpdateInput;
};


export type MutationUpdateCollectionFilterPresetArgs = {
  input: CollectionFilterPresetUpdateInput;
};


export type MutationUpdateCommentArgs = {
  input: CommentUpdateInput;
};


export type MutationUpdateConsentArgs = {
  input: ConsentUpdateInput;
};


export type MutationUpdateCustomContingentDefinitionSetArgs = {
  input: UpdateCustomContingentDefinitionSetInput;
};


export type MutationUpdateCustomPlanArgs = {
  input: UpdateCustomPlanInput;
};


export type MutationUpdateDocumentArgs = {
  input: DocumentUpdateInput;
};


export type MutationUpdateDocumentDetectedLanguageArgs = {
  input: UpdateDocumentDetectedLanguageInput;
};


export type MutationUpdateEducationCourseArgs = {
  input: EducationCourseUpdateInput;
};


export type MutationUpdateEducationCourseTotalPerformanceStateArgs = {
  input: EducationCourseTotalPerformanceStateUpdateInput;
};


export type MutationUpdateEducationCourseWeekArgs = {
  input: EducationCourseWeekUpdateInput;
};


export type MutationUpdateEducationCourseWeeklyAttendanceArgs = {
  input: EducationCourseWeeklyAttendanceUpdateInput;
};


export type MutationUpdateEducationCourseWeeklyCommentArgs = {
  input: EducationCourseWeeklyCommentUpdateInput;
};


export type MutationUpdateEducationCourseWeeklyPerformanceArgs = {
  input: EducationCourseWeeklyPerformanceUpdateInput;
};


export type MutationUpdateEducationExamArgs = {
  input: EducationExamUpdateInput;
};


export type MutationUpdateEducationModuleArgs = {
  input: EducationModuleUpdateInput;
};


export type MutationUpdateEmailSendOutRuleArgs = {
  input: EmailSendOutRuleUpdateInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input: EmailTemplateUpdateInput;
  language: Scalars['String']['input'];
};


export type MutationUpdateFeedbackArgs = {
  input: FeedbackUpdateInput;
};


export type MutationUpdateLaborAgreementArgs = {
  input: LaborAgreementUpdateInput;
};


export type MutationUpdateLastSelectedProfileMaskIdArgs = {
  input: UpdateLastSelectedProfileMaskIdInput;
};


export type MutationUpdateLocalPartnerProfileConfigSetArgs = {
  input: LocalPartnerProfileConfigSetUpdateInput;
};


export type MutationUpdateMilestoneDashboardSharingArgs = {
  input: MilestoneDashboardSharingUpdateInput;
};


export type MutationUpdateNoteArgs = {
  input: NoteUpdateInput;
};


export type MutationUpdateOnlineApplicationConfigurationArgs = {
  input: OnlineApplicationConfigurationUpdateInput;
};


export type MutationUpdateOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationUpdateOrganizationContactArgs = {
  input: OrganizationContactUpdateInput;
};


export type MutationUpdateOrganizationContractSettingsArgs = {
  input: OrganizationContractSettingsInput;
};


export type MutationUpdateOrganizationLinkArgs = {
  input: OrganizationLinkUpdateInput;
};


export type MutationUpdateOrganizationTagArgs = {
  input: OrganizationTagUpdateInput;
};


export type MutationUpdatePdfFormTemplateWatchArgs = {
  input: PdfFormTemplateWatchUpdateInput;
};


export type MutationUpdatePlanningSharingArgs = {
  input: PlanningSharingInput;
};


export type MutationUpdatePlanningStateArgs = {
  input: ProcessPlanningStateInput;
};


export type MutationUpdateProcessActionArgs = {
  input: ProcessActionUpdateInput;
};


export type MutationUpdateProcessMilestoneListArgs = {
  input: ProcessMilestoneListUpdateInput;
};


export type MutationUpdateProcessMilestoneMappingArgs = {
  input: ProcessMilestoneMappingUpsertInput;
};


export type MutationUpdateProcessMilestoneSharingArgs = {
  input: ProcessMilestoneSharingUpdateInput;
};


export type MutationUpdateProcessModelArgs = {
  input: ProcessModelUpdateInput;
};


export type MutationUpdateProcessModelReleaseArgs = {
  input: ProcessModelUpdateReleaseInput;
};


export type MutationUpdateProfessionalExperienceArgs = {
  input: ProfessionalExperienceUpdateInput;
};


export type MutationUpdateProfessionalFieldArgs = {
  input: ProfessionalFieldUpdateInput;
};


export type MutationUpdateRequiredDocumentArgs = {
  input: RequiredDocumentUpdateInput;
};


export type MutationUpdateRequiredDocumentMetaArgs = {
  input: RequiredDocumentUpdateMetaInput;
};


export type MutationUpdateRequiredVaccinationsArgs = {
  input: RequiredVaccinationsUpdateInput;
};


export type MutationUpdateSharingArgs = {
  input: SharingUpdateInput;
};


export type MutationUpdateSharingPresetArgs = {
  input: SharingPresetUpdateInput;
};


export type MutationUpdateSharingTemplateArgs = {
  input: SharingTemplateUpdateInput;
};


export type MutationUpdateSystemSettingArgs = {
  input: SystemSettingsUpdateInput;
};


export type MutationUpdateTableColumnsArgs = {
  input: UpdateTableColumnsInput;
};


export type MutationUpdateTalentPoolArgs = {
  input: TalentPoolUpdateInput;
};


export type MutationUpdateTalentPoolParticipantArgs = {
  input: TalentPoolParticipantUpdateInput;
};


export type MutationUpdateTalentPoolSharingArgs = {
  input: TalentPoolSharingUpdateInput;
};


export type MutationUpdateTalentPoolTalentRequestStateArgs = {
  input: TalentPoolRequestedTalentUpdateStateInput;
};


export type MutationUpdateTaskArgs = {
  input: ProcessTaskUpdateInput;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaskDelayArgs = {
  input: ProcessTaskDelayUpdateInput;
};


export type MutationUpdateTaskDelegationRuleArgs = {
  input: TaskDelegationRuleUpdateInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUpdateUserGroupArgs = {
  input: UserGroupInput;
};


export type MutationUpdateUserSettingForTaskTableModeForInboxArgs = {
  input: UpdateInboxTaskTableModeInput;
};


export type MutationUpdateUserSettingForTaskVisibilityForInboxArgs = {
  visibilityMode: UserTaskVisibilityMode;
};


export type MutationUpdateWebhookConfigArgs = {
  input: WebhookConfigUpdateInput;
};


export type MutationUpsertCandidateFieldTranslationsArgs = {
  input: PropertyTranslationUpdateInput;
};


export type MutationUpsertContingentCorrectionArgs = {
  input: ContingentCorrectionInput;
};


export type MutationUpsertCredentialsArgs = {
  input: CredentialsUpdateInput;
};


export type MutationUpsertDocumentTypeOverwriteArgs = {
  input: DocumentTypeOverwriteUpsertInput;
};


export type MutationUpsertDocumentWithoutProcessStateChangeArgs = {
  input: DocumentUpsertInput;
};


export type MutationUpsertEducationExamResultArgs = {
  input: EducationExamResultUpsertInput;
};


export type MutationUpsertFloorCorrectionArgs = {
  input: FloorCorrectionInput;
};


export type MutationUpsertGeneralDocumentRequirementsArgs = {
  input: GeneralDocumentRequirementInput;
};


export type MutationUpsertInterviewCommentArgs = {
  input: CandidateCommentUpsertInput;
};


export type MutationUpsertInterviewEmployerArgs = {
  input: CandidateEmployerUpsertInput;
};


export type MutationUpsertInterviewFeedbackArgs = {
  input: CandidateFeedbackUpsertInput;
};


export type MutationUpsertManyDocumentRequirementsArgs = {
  input: DocumentRequirementsUpsertInput;
};


export type MutationUpsertOnlineApplicationMaintenanceMessageArgs = {
  input: OnlineApplicationMaintenanceInput;
};


export type MutationUpsertProfessionalFieldSettingsArgs = {
  input: ProfessionalFieldSettingsUpsertInput;
};


export type MutationUserPrefersNewUiArgs = {
  input: BooleanInput;
};


export type MutationValidateCandidateGroupExistsArgs = {
  input: CandidateChatGroupExistsInput;
};


export type MutationWithdrawChallengeBookingArgs = {
  input: ChallengeBookingWithdrawInput;
};


export type MutationWithdrawChallengeBookingsArgs = {
  input: Array<ChallengeBookingWithdrawInput>;
};


export type MutationWithdrawContractCancellationArgs = {
  input: WithdrawContractCancellationInput;
  organizationId: Scalars['ID']['input'];
};

export class MutationResult {
  __typename?: 'MutationResult';
  _etag?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type MutationResultEvent = MutationResult | ProgressEvent;

export class NewUiDashboardAnkaadiaUpdate {
  __typename?: 'NewUiDashboardAnkaadiaUpdate';
  body: Scalars['String']['output'];
  date: Scalars['DateOrDateTime']['output'];
  image?: Maybe<Scalars['String']['output']>;
  tagName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum NewUiDashboardBirthdayRange {
  OneWeek = 'ONE_WEEK',
  Today = 'TODAY'
}

export class NewUiDashboardCandidateBirthdaysInput {
  organizationId: Scalars['ID']['input'];
  timeframe: NewUiDashboardBirthdayRange;
};

export class NewUiDashboardCandidateEventsInput {
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class NewUiDashboardCandidateEventsMetric {
  __typename?: 'NewUiDashboardCandidateEventsMetric';
  events: Array<DashboardCandidateEventData>;
  totalEvents: Scalars['Float']['output'];
};

export class NewUiDashboardCandidateStateData {
  __typename?: 'NewUiDashboardCandidateStateData';
  count: Scalars['Float']['output'];
  state: CandidateStatus;
};

export class NewUiDashboardCandidateStatesAtDateInput {
  daysBefore: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
  states: Array<CandidateStatus>;
};

export class NewUiDashboardCandidateStatesInput {
  organizationId: Scalars['ID']['input'];
  states: Array<CandidateStatus>;
};

export class NewUiDashboardOpenTasksMetric {
  __typename?: 'NewUiDashboardOpenTasksMetric';
  openTaskCount: Scalars['Float']['output'];
  openTasks: Array<OpenTaskData>;
};

export class NewUiDashboardSharedCollection {
  __typename?: 'NewUiDashboardSharedCollection';
  collections: Array<NewUiDashboardSharedCollectionData>;
  totalCount: Scalars['Float']['output'];
};

export class NewUiDashboardSharedCollectionData {
  __typename?: 'NewUiDashboardSharedCollectionData';
  candidateCount: Scalars['Float']['output'];
  collectionId: Scalars['ID']['output'];
  collectionName: Scalars['String']['output'];
  ownerOrganizationId: Scalars['ID']['output'];
  ownerOrganizationName: Scalars['String']['output'];
  sharingType: SharingTypeEnum;
};

export class NewUiDashboardTalentPoolRequestData {
  __typename?: 'NewUiDashboardTalentPoolRequestData';
  candidateDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateOrDateTime']['output'];
  state: TalentRequestState;
  stateChangedAt?: Maybe<Scalars['DateOrDateTime']['output']>;
  talentPoolName?: Maybe<Array<LocalizedString>>;
};

export class NewUiDashboardTalentPoolRequests {
  __typename?: 'NewUiDashboardTalentPoolRequests';
  incoming: Array<NewUiDashboardTalentPoolRequestData>;
  outgoing: Array<NewUiDashboardTalentPoolRequestData>;
};

export class NewUiDashboardTalentPoolSharingData {
  __typename?: 'NewUiDashboardTalentPoolSharingData';
  changedAt: Scalars['DateOrDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  talentPoolId: Scalars['ID']['output'];
  talentPoolName?: Maybe<Array<LocalizedString>>;
};

export class NewUiDashboardTalentPoolSharings {
  __typename?: 'NewUiDashboardTalentPoolSharings';
  myPoolSharings: Array<NewUiDashboardTalentPoolSharingData>;
  sharedToMe: Array<NewUiDashboardTalentPoolSharingData>;
};

export class Note {
  __typename?: 'Note';
  _etag?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  contentAsHtml?: Maybe<Scalars['String']['output']>;
  contents: Scalars['String']['output'];
  delta: Scalars['JSONObject']['output'];
  foreignId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  ownerOrganizationId?: Maybe<Scalars['ID']['output']>;
  ownerOrganizationName?: Maybe<Scalars['String']['output']>;
};

export class NoteCreateInput {
  category: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
  foreignId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class NoteDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  foreignId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class NoteGetInput {
  foreignId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class NoteListInput {
  category: Scalars['String']['input'];
  foreignId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  sharingOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class NoteUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
  foreignId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  ownerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class NotificationList {
  __typename?: 'NotificationList';
  notifications: Array<Activity>;
  since: Scalars['AnkaadiaDateTime']['output'];
};

export enum NotificationScope {
  Candidates = 'Candidates',
  OwnedCandidates = 'OwnedCandidates',
  Processes = 'Processes'
}

export class NotificationSettings {
  __typename?: 'NotificationSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  activities?: Maybe<Array<ActivityType>>;
  documents?: Maybe<Array<Scalars['String']['output']>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  scopes?: Maybe<Array<NotificationScope>>;
  userId: Scalars['ID']['output'];
};

export class NotificationSettingsInput {
  activities?: InputMaybe<Array<ActivityType>>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  scopes?: InputMaybe<Array<NotificationScope>>;
};

export class OccupationSkill {
  __typename?: 'OccupationSkill';
  description: Scalars['String']['output'];
  preferredLabel: Scalars['String']['output'];
  skillId: Scalars['String']['output'];
};

export class OccupationSkillByIdsInput {
  language: Scalars['String']['input'];
  skillIds: Array<Scalars['String']['input']>;
  skillType: OccupationSkillType;
};

export class OccupationSkillSearchInput {
  language: Scalars['String']['input'];
  professionId?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  skillType: OccupationSkillType;
};

export class OccupationSkillSet {
  __typename?: 'OccupationSkillSet';
  description: Scalars['String']['output'];
  preferredLabel: Scalars['String']['output'];
  skillType: OccupationSkillType;
  skills?: Maybe<Array<OccupationSkill>>;
};

export enum OccupationSkillType {
  Knowledge = 'Knowledge',
  SkillCompetence = 'SkillCompetence'
}

export class OnlineApplication {
  __typename?: 'OnlineApplication';
  applicationTime?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  token: OnlineApplicationToken;
};

export class OnlineApplicationBinaryOption {
  __typename?: 'OnlineApplicationBinaryOption';
  key: Scalars['String']['output'];
  labelKey: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
};

export class OnlineApplicationConfigurationRequestInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  recipeId: Scalars['String']['input'];
};

export class OnlineApplicationConfigurationUpdateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  recipeId: Scalars['String']['input'];
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

export class OnlineApplicationConfigurationWithOptions {
  __typename?: 'OnlineApplicationConfigurationWithOptions';
  _etag?: Maybe<Scalars['String']['output']>;
  binaryOptions?: Maybe<Array<OnlineApplicationBinaryOption>>;
  configurationTimeStamp: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  recipeId: Scalars['String']['output'];
  skipValidation?: Maybe<Scalars['Boolean']['output']>;
  staticDataOptions?: Maybe<Array<OnlineApplicationStaticDataSelection>>;
  userId: Scalars['String']['output'];
};

export class OnlineApplicationCredentials {
  __typename?: 'OnlineApplicationCredentials';
  _etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  recipeId: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type OnlineApplicationExecutionEvent = OnlineApplicationExecutionResult | ProgressEvent;

export class OnlineApplicationExecutionInput {
  candidateIds: Array<CandidateExecutionId>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
};

export class OnlineApplicationExecutionResult {
  __typename?: 'OnlineApplicationExecutionResult';
  applicationStatus: OnlineApplicationStatus;
  candidateId: Scalars['String']['output'];
  done?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  progressStep?: Maybe<Scalars['Int']['output']>;
  progressUpdate?: Maybe<Scalars['Boolean']['output']>;
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  totalProgressSteps?: Maybe<Scalars['Int']['output']>;
};

export class OnlineApplicationFile {
  __typename?: 'OnlineApplicationFile';
  blobName?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileCantBeConverted?: Maybe<Scalars['Boolean']['output']>;
  fileWasConverted?: Maybe<Scalars['Boolean']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  setAndTag: Scalars['String']['output'];
};

export class OnlineApplicationForList {
  __typename?: 'OnlineApplicationForList';
  _etag?: Maybe<Scalars['String']['output']>;
  applicationDisabled?: Maybe<Scalars['Boolean']['output']>;
  applicationLabel?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<OnlineApplicationStatus>;
  applicationStatusDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  appliedByUserId?: Maybe<Scalars['String']['output']>;
  binaryOptions?: Maybe<Array<OnlineApplicationBinaryOption>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['String']['output']>;
  configurationChangedByUser?: Maybe<Scalars['String']['output']>;
  configurationChangedDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  configurationId?: Maybe<Scalars['String']['output']>;
  credentialsId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Array<Scalars['String']['output']>>;
  hasCommentField?: Maybe<Scalars['Boolean']['output']>;
  hasConfiguration?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastPageHTML?: Maybe<Scalars['String']['output']>;
  maintenanceActiveSince?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  maintenanceMessage?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  previewDescriptionKey?: Maybe<Scalars['String']['output']>;
  processURL?: Maybe<Scalars['String']['output']>;
  progressStep?: Maybe<Scalars['Int']['output']>;
  progressUpdate?: Maybe<Scalars['Boolean']['output']>;
  recipeId: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  requireConsent?: Maybe<Scalars['Boolean']['output']>;
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  resultScreenshots?: Maybe<Array<DocumentFreeFormatFile>>;
  resultTermsAndConditionsIdentifier?: Maybe<KnownConsentIdentifiers>;
  staticDataOptions?: Maybe<Array<OnlineApplicationStaticDataSelection>>;
  token: OnlineApplicationToken;
  totalProgressSteps?: Maybe<Scalars['Int']['output']>;
  twoFARequired?: Maybe<Scalars['Boolean']['output']>;
};

export class OnlineApplicationInput {
  candidateIds: Array<CandidateIdInput>;
  types?: InputMaybe<Array<OnlineApplicationToken>>;
};

export enum OnlineApplicationLoginError {
  InvalidOtp = 'invalidOTP',
  InvalidUsernameOrPassword = 'invalidUsernameOrPassword'
}

export class OnlineApplicationLoginInput {
  OTP: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recipeId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  updateCredentialsOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  userName: Scalars['String']['input'];
};

export class OnlineApplicationLoginResult {
  __typename?: 'OnlineApplicationLoginResult';
  credentialsId?: Maybe<Scalars['String']['output']>;
  loginError?: Maybe<OnlineApplicationLoginError>;
  loginSuccessful: Scalars['Boolean']['output'];
  recipeId: Scalars['String']['output'];
  resultMessage: Scalars['String']['output'];
  screenshot?: Maybe<DocumentFreeFormatFile>;
  screenshotDownloadUrl?: Maybe<Scalars['String']['output']>;
};

export class OnlineApplicationMaintenanceInput {
  id?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  maintenanceActiveSince?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  recipeId: Scalars['String']['input'];
};

export class OnlineApplicationMaintenanceMessage {
  __typename?: 'OnlineApplicationMaintenanceMessage';
  _etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  maintenanceActiveSince?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  recipeId: Scalars['String']['output'];
};

export class OnlineApplicationResult {
  __typename?: 'OnlineApplicationResult';
  _etag?: Maybe<Scalars['String']['output']>;
  applicationStatus: OnlineApplicationStatus;
  applicationStatusDate: Scalars['AnkaadiaDateTime']['output'];
  applicationStatusHistory?: Maybe<Array<OnlineApplicationStatusChange>>;
  appliedByUserId?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['String']['output'];
  done?: Maybe<Scalars['Boolean']['output']>;
  downloadUrl?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  lastPageHTML?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  processURL?: Maybe<Scalars['String']['output']>;
  progressStep?: Maybe<Scalars['Int']['output']>;
  progressUpdate?: Maybe<Scalars['Boolean']['output']>;
  recipeId: Scalars['String']['output'];
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  resultScreenshots?: Maybe<Array<DocumentFreeFormatFile>>;
  resultTermsAndConditionsIdentifier?: Maybe<KnownConsentIdentifiers>;
  token: OnlineApplicationToken;
  totalProgressSteps?: Maybe<Scalars['Int']['output']>;
};

export class OnlineApplicationResultSet {
  __typename?: 'OnlineApplicationResultSet';
  applicationStatus: OnlineApplicationStatus;
  changeDate: Scalars['AnkaadiaDateTime']['output'];
  downloadUrl?: Maybe<Array<Scalars['String']['output']>>;
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
};

export class OnlineApplicationScreenshotResult {
  __typename?: 'OnlineApplicationScreenshotResult';
  applicationStatus: OnlineApplicationStatus;
  candidateId: Scalars['String']['output'];
  downloadUrl?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  resultSets?: Maybe<Array<OnlineApplicationResultSet>>;
  resultTermsAndConditionsIdentifier?: Maybe<KnownConsentIdentifiers>;
  token: OnlineApplicationToken;
};

export class OnlineApplicationState {
  __typename?: 'OnlineApplicationState';
  recipeId?: Maybe<Scalars['String']['output']>;
  resultId?: Maybe<Scalars['ID']['output']>;
};

export class OnlineApplicationStateInput {
  recipeId?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['ID']['input']>;
};

export class OnlineApplicationStaticDataSelection {
  __typename?: 'OnlineApplicationStaticDataSelection';
  key: Scalars['String']['output'];
  labelKey: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  staticDataType: StaticDataType;
  values: Array<Scalars['String']['output']>;
};

export enum OnlineApplicationStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Error = 'Error',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
  Validated = 'Validated'
}

export class OnlineApplicationStatusChange {
  __typename?: 'OnlineApplicationStatusChange';
  applicationStatus: OnlineApplicationStatus;
  changeDate: Scalars['AnkaadiaDateTime']['output'];
  processURL?: Maybe<Scalars['String']['output']>;
  resultLink?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  resultScreenshots?: Maybe<Array<DocumentFreeFormatFile>>;
  resultTermsAndConditionsIdentifier?: Maybe<KnownConsentIdentifiers>;
};

export class OnlineApplicationTaskExecutionInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  requestId?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
  validationResultId: Scalars['String']['input'];
};

export class OnlineApplicationTaskInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class OnlineApplicationTaskValidationInput {
  OTP?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  requestId?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};

export enum OnlineApplicationToken {
  AcceleratedRecognitionApplication = 'AcceleratedRecognitionApplication',
  EducationVoucher = 'EducationVoucher',
  EducationVoucherAlternative = 'EducationVoucherAlternative',
  EducationVoucherRequestFirst = 'EducationVoucherRequestFirst',
  EducationVoucherTrainingCostFirst = 'EducationVoucherTrainingCostFirst',
  EducationVoucherTrainingCostSecond = 'EducationVoucherTrainingCostSecond',
  EducationVoucherWageSubsidy = 'EducationVoucherWageSubsidy',
  LaborMarketAdmission = 'LaborMarketAdmission',
  LaborMarketAdmissionEmployerChange = 'LaborMarketAdmissionEmployerChange',
  LaborMarketAdmissionExtension = 'LaborMarketAdmissionExtension',
  LaborMarketAdmissionFirstApplication = 'LaborMarketAdmissionFirstApplication',
  PropertyAndCasualtyInsurance = 'PropertyAndCasualtyInsurance',
  RecognitionApplication = 'RecognitionApplication',
  RecognitionApplicationCareAssistant = 'RecognitionApplicationCareAssistant',
  RecognitionApplicationCareProfessional = 'RecognitionApplicationCareProfessional',
  RegistrationHealthInsurance = 'RegistrationHealthInsurance'
}

export type OnlineApplicationValidationEvent = OnlineApplicationResult | ProgressEvent;

export class OnlineApplicationValidationInput {
  OTP?: InputMaybe<Scalars['String']['input']>;
  candidateIds: Array<CandidateAndRecipeId>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
};

export class OnlineApplicationsForCandidate {
  __typename?: 'OnlineApplicationsForCandidate';
  applications: Array<OnlineApplication>;
  candidateId: Scalars['String']['output'];
  displayId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export class OnlineApplicationsForImmigrationCountryInput {
  immigrationCountry: SupportedImmigrationCountry;
};

export class OpenAiChatSessionInput {
  id: Scalars['ID']['input'];
};

export class OpenTaskData {
  __typename?: 'OpenTaskData';
  openTaskCount: Scalars['Float']['output'];
  taskName: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
};

export class Organization {
  __typename?: 'Organization';
  EZBData?: Maybe<EzbInfo>;
  _etag?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  allowOrganizationManagementbyCreator?: Maybe<Scalars['Boolean']['output']>;
  autoConnectedDaughterOrganizations?: Maybe<Array<Scalars['String']['output']>>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  companyRegistrationAuthority?: Maybe<Scalars['String']['output']>;
  configToken?: Maybe<Scalars['String']['output']>;
  cooperationType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  creatorOrganizationId?: Maybe<Scalars['ID']['output']>;
  creatorOrganizationName?: Maybe<Scalars['String']['output']>;
  emailAdress?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  hasStamp?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includeDaughterSharings?: Maybe<Scalars['Boolean']['output']>;
  isCreatorMasterOrganization?: Maybe<Scalars['Boolean']['output']>;
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  isLicensed?: Maybe<Scalars['Boolean']['output']>;
  matchingAgreement?: Maybe<MatchingAgreement>;
  name: Scalars['String']['output'];
  notifyUsersOnDeletionRequest?: Maybe<Array<Scalars['String']['output']>>;
  numberOfEmployers?: Maybe<Scalars['Float']['output']>;
  operatingNumber?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  parentOrganizationId?: Maybe<Scalars['ID']['output']>;
  parentOrganizationName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prefix: Scalars['String']['output'];
  recognitionProfessionalExperience?: Maybe<RecognitionProfessionalExperience>;
  region?: Maybe<Scalars['String']['output']>;
  registerNo?: Maybe<Scalars['String']['output']>;
  requireCandidateConsent?: Maybe<Scalars['Boolean']['output']>;
  requireTalentpoolUserConsent?: Maybe<Scalars['Boolean']['output']>;
  requireUserConsent?: Maybe<Scalars['Boolean']['output']>;
  structuringCriteria?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  urlToWebsite?: Maybe<Scalars['String']['output']>;
  yearOfEstablishment?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationAuditAdditionRequestResult {
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export class OrganizationAuditData {
  __typename?: 'OrganizationAuditData';
  additionalRequestFiles?: Maybe<Array<AuditFile>>;
  additionalRequestReply?: Maybe<Scalars['String']['output']>;
  additionalRequestResult?: Maybe<OrganizationAuditAdditionRequestResult>;
  additionalRequestResultDescription?: Maybe<Scalars['String']['output']>;
  auditResult?: Maybe<OrganizationAuditResult>;
  auditResultDescription?: Maybe<Scalars['String']['output']>;
  auditTreeNodeId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<AuditFile>>;
};

export class OrganizationAuditDataInput {
  additionalRequestFiles?: InputMaybe<Array<AuditFileInput>>;
  additionalRequestReply?: InputMaybe<Scalars['String']['input']>;
  additionalRequestResult?: InputMaybe<OrganizationAuditAdditionRequestResult>;
  additionalRequestResultDescription?: InputMaybe<Scalars['String']['input']>;
  auditResult?: InputMaybe<OrganizationAuditResult>;
  auditResultDescription?: InputMaybe<Scalars['String']['input']>;
  auditTreeNodeId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<AuditFileInput>>;
};

export class OrganizationAuditInterview {
  __typename?: 'OrganizationAuditInterview';
  interviewAssessment?: Maybe<OrganizationAuditInterviewAssessmentEnum>;
  interviewDate: Scalars['AnkaadiaDateTime']['output'];
  nameOfInterviewee: Scalars['String']['output'];
  qualitativeInterviewAssessment?: Maybe<Scalars['String']['output']>;
  questionsAndAnswers?: Maybe<Array<OrganizationAuditInterviewQuestionAndAnswer>>;
};

export enum OrganizationAuditInterviewAssessmentEnum {
  ConfirmsTheInformation = 'ConfirmsTheInformation',
  PartiallyConfirmsTheInformation = 'PartiallyConfirmsTheInformation',
  ThereAreContradictionsToTheInformation = 'ThereAreContradictionsToTheInformation'
}

export class OrganizationAuditInterviewInput {
  interviewAssessment?: InputMaybe<OrganizationAuditInterviewAssessmentEnum>;
  interviewDate: Scalars['AnkaadiaDateTime']['input'];
  nameOfInterviewee: Scalars['String']['input'];
  qualitativeInterviewAssessment?: InputMaybe<Scalars['String']['input']>;
  questionsAndAnswers?: InputMaybe<Array<OrganizationAuditInterviewQuestionAndAnswerInput>>;
};

export class OrganizationAuditInterviewQuestionAndAnswer {
  __typename?: 'OrganizationAuditInterviewQuestionAndAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export class OrganizationAuditInterviewQuestionAndAnswerInput {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationAuditInterviewSamples {
  __typename?: 'OrganizationAuditInterviewSamples';
  interviews?: Maybe<Array<OrganizationAuditInterview>>;
  qualitativeSampleAssessment?: Maybe<Scalars['String']['output']>;
  sampleAssessment?: Maybe<OrganizationAuditInterviewAssessmentEnum>;
};

export class OrganizationAuditInterviewSamplesInput {
  interviews?: InputMaybe<Array<OrganizationAuditInterviewInput>>;
  qualitativeSampleAssessment?: InputMaybe<Scalars['String']['input']>;
  sampleAssessment?: InputMaybe<OrganizationAuditInterviewAssessmentEnum>;
};

export class OrganizationAuditReportInput {
  auditDefinitionId: Scalars['String']['input'];
  auditMode: AuditTaskModeEnum;
  auditRemarksAdditionalClaim?: InputMaybe<Scalars['String']['input']>;
  auditRemarksAuditor?: InputMaybe<Scalars['String']['input']>;
  auditRemarksBoard?: InputMaybe<Scalars['String']['input']>;
  auditVotumBoard?: InputMaybe<OrganizationAuditAdditionRequestResult>;
  awardDate?: InputMaybe<Scalars['UTCDate']['input']>;
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  finalFinalVotum?: InputMaybe<OrganizationAuditAdditionRequestResult>;
  finalVotum?: InputMaybe<OrganizationAuditResult>;
  finalVotumDescription?: InputMaybe<Scalars['String']['input']>;
  interviewNotes?: InputMaybe<Scalars['String']['input']>;
  interviewSamples?: InputMaybe<OrganizationAuditInterviewSamplesInput>;
  organizationAuditData?: InputMaybe<Array<OrganizationAuditDataInput>>;
  organizationId: Scalars['ID']['input'];
  processAuditGroupName: Scalars['String']['input'];
  recruitingConcept?: InputMaybe<Scalars['JSON']['input']>;
  reportName: Scalars['String']['input'];
  rootId: Scalars['ID']['input'];
};

export enum OrganizationAuditResult {
  Approved = 'Approved',
  ApprovedWhenDemandIsMet = 'ApprovedWhenDemandIsMet',
  Rejected = 'Rejected'
}

export class OrganizationBankDetail {
  __typename?: 'OrganizationBankDetail';
  accountHolder: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export class OrganizationBankDetailInput {
  accountHolder: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
};

export class OrganizationContact {
  __typename?: 'OrganizationContact';
  _etag?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['UTCDate']['output']>;
  birthplace?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<OrganizationContactDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<OrganizationContactFunction>;
  hasSignature?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAuthorizedToRepresent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  signatureAddition?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class OrganizationContactCreateInput {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['UTCDate']['input']>;
  birthplace?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<OrganizationContactDocumentInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<OrganizationContactFunction>;
  isAuthorizedToRepresent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  signatureAddition?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationContactDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationContactDocument {
  __typename?: 'OrganizationContactDocument';
  documentType: Scalars['String']['output'];
  file: DocumentFreeFormatFile;
  organizationContact?: Maybe<Scalars['String']['output']>;
};

export class OrganizationContactDocumentInput {
  documentType: Scalars['String']['input'];
  file: DocumentFreeFormatFileInput;
  organizationContact?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationContactFunction {
  Contact = 'Contact',
  Representative = 'Representative'
}

export class OrganizationContactGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationContactListInput {
  includeRootOrg?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationContactSettings {
  __typename?: 'OrganizationContactSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  defaultFirstDeputy?: Maybe<Scalars['ID']['output']>;
  defaultRecognitionContactPerson?: Maybe<Scalars['ID']['output']>;
  defaultRepresentative?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class OrganizationContactSettingsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class OrganizationContactSettingsSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  defaultFirstDeputy?: InputMaybe<Scalars['ID']['input']>;
  defaultRecognitionContactPerson?: InputMaybe<Scalars['ID']['input']>;
  defaultRepresentative?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationContactUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['UTCDate']['input']>;
  birthplace?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<OrganizationContactDocumentInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<OrganizationContactFunction>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAuthorizedToRepresent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  signatureAddition?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationContractSettings {
  __typename?: 'OrganizationContractSettings';
  id?: Maybe<Scalars['ID']['output']>;
  recognitionProfessionalExperience?: Maybe<RecognitionProfessionalExperience>;
};

export class OrganizationContractSettingsInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  recognitionProfessionalExperience?: InputMaybe<RecognitionProfessionalExperience>;
};

export class OrganizationCrm {
  __typename?: 'OrganizationCrm';
  _etag?: Maybe<Scalars['String']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  debitorNumber?: Maybe<Scalars['String']['output']>;
  destinationOrganizationId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<OrganizationCrmNote>;
  organizationId: Scalars['ID']['output'];
  responsibleTeamIds?: Maybe<Array<Scalars['ID']['output']>>;
  responsibleUserIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export class OrganizationCrmGetInput {
  destinationOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class OrganizationCrmNote {
  __typename?: 'OrganizationCrmNote';
  contents?: Maybe<Scalars['String']['output']>;
  delta?: Maybe<Scalars['JSONObject']['output']>;
};

export class OrganizationCrmNoteInput {
  contents?: InputMaybe<Scalars['String']['input']>;
  delta?: InputMaybe<Scalars['JSONObject']['input']>;
};

export class OrganizationCrmSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  debitorNumber?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<OrganizationCrmNoteInput>;
  organizationId: Scalars['ID']['input'];
  responsibleTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  responsibleUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export class OrganizationDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export class OrganizationDocumentModel {
  __typename?: 'OrganizationDocumentModel';
  documentType: Scalars['String']['output'];
  organizationRole?: Maybe<Scalars['String']['output']>;
};

export class OrganizationDocumentModelInput {
  documentType: Scalars['String']['input'];
  organizationRole?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationEventsInput {
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class OrganizationFindInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  includeGroup?: InputMaybe<Scalars['Boolean']['input']>;
  includeMyself?: InputMaybe<Scalars['Boolean']['input']>;
};

export class OrganizationForAssignmentInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class OrganizationGetChildrenInput {
  includeParent?: InputMaybe<Scalars['Boolean']['input']>;
  parentOrganizationId: Scalars['ID']['input'];
};

export class OrganizationInput {
  EZBData?: InputMaybe<EzbInfoInput>;
  _etag?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  allowOrganizationManagementbyCreator?: InputMaybe<Scalars['Boolean']['input']>;
  autoConnectedDaughterOrganizations?: InputMaybe<Array<Scalars['String']['input']>>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationAuthority?: InputMaybe<Scalars['String']['input']>;
  configToken?: InputMaybe<Scalars['String']['input']>;
  cooperationType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  creatorOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  emailAdress?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDaughterSharings?: InputMaybe<Scalars['Boolean']['input']>;
  matchingAgreement?: InputMaybe<MatchingAgreementInput>;
  name: Scalars['String']['input'];
  notifyUsersOnDeletionRequest?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfEmployers?: InputMaybe<Scalars['Float']['input']>;
  operatingNumber?: InputMaybe<Scalars['String']['input']>;
  parentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
  recognitionProfessionalExperience?: InputMaybe<RecognitionProfessionalExperience>;
  region?: InputMaybe<Scalars['String']['input']>;
  registerNo?: InputMaybe<Scalars['String']['input']>;
  requireCandidateConsent?: InputMaybe<Scalars['Boolean']['input']>;
  requireTalentpoolUserConsent?: InputMaybe<Scalars['Boolean']['input']>;
  requireUserConsent?: InputMaybe<Scalars['Boolean']['input']>;
  structuringCriteria?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  urlToWebsite?: InputMaybe<Scalars['String']['input']>;
  yearOfEstablishment?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationLink {
  __typename?: 'OrganizationLink';
  _etag?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  linkedOrganizationId: Scalars['ID']['output'];
  organizationCode?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  partnerSharing?: Maybe<PartnerSharingConfiguration>;
  selectedContacts?: Maybe<Array<Scalars['ID']['output']>>;
  selectedContractTemplates?: Maybe<Array<Scalars['ID']['output']>>;
  selectedLaborAgreements?: Maybe<Array<Scalars['ID']['output']>>;
  selectedPartners?: Maybe<Array<SelectedPartnerSharingConfiguration>>;
  shareContacts?: Maybe<ContactSharingMode>;
  shareContractTemplates?: Maybe<ContractTemplateSharingMode>;
  shareEZBData?: Maybe<EzbDataSharingMode>;
  shareLaborAgreements?: Maybe<LaborAgreementSharingMode>;
  sharePartners?: Maybe<PartnerSharingMode>;
};

export class OrganizationLinkDeleteInput {
  linkedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class OrganizationLinkGetInput {
  invalidateGraph?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class OrganizationLinkInvitation {
  __typename?: 'OrganizationLinkInvitation';
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  emailSendFailed?: Maybe<Scalars['Boolean']['output']>;
  expiresAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationCode?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  partnerSharing?: Maybe<PartnerSharingConfiguration>;
  requestedAt: Scalars['AnkaadiaDateTime']['output'];
  requestedByUserId: Scalars['ID']['output'];
  respondedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  respondedByUserId?: Maybe<Scalars['ID']['output']>;
  resultingLinkedOrganizationId?: Maybe<Scalars['ID']['output']>;
  resultingLinkedOrganizationName?: Maybe<Scalars['String']['output']>;
  selectedContacts?: Maybe<Array<Scalars['ID']['output']>>;
  selectedContractTemplates?: Maybe<Array<Scalars['ID']['output']>>;
  selectedLaborAgreements?: Maybe<Array<Scalars['ID']['output']>>;
  selectedPartners?: Maybe<Array<SelectedPartnerSharingConfiguration>>;
  shareContacts?: Maybe<ContactSharingMode>;
  shareContractTemplates?: Maybe<ContractTemplateSharingMode>;
  shareEZBData?: Maybe<EzbDataSharingMode>;
  shareLaborAgreements?: Maybe<LaborAgreementSharingMode>;
  sharePartners?: Maybe<PartnerSharingMode>;
  status: OrganizationLinkInvitationStatus;
  targetEmail: Scalars['String']['output'];
  targetOrganizationId?: Maybe<Scalars['ID']['output']>;
  token: Scalars['String']['output'];
};

export class OrganizationLinkInvitationAcceptInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  linkBack?: InputMaybe<OrganizationLinkInvitationLinkBackInput>;
  organizationId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export class OrganizationLinkInvitationAccess {
  __typename?: 'OrganizationLinkInvitationAccess';
  canAccess: Scalars['Boolean']['output'];
  redirectToOrganization?: Maybe<Scalars['ID']['output']>;
};

export class OrganizationLinkInvitationAccessInput {
  organizationId: Scalars['ID']['input'];
};

export class OrganizationLinkInvitationCreateInput {
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  partnerSharing?: InputMaybe<PartnerSharingConfigurationInput>;
  selectedContacts?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedContractTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedLaborAgreements?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPartners?: InputMaybe<Array<SelectedPartnerSharingConfigurationInput>>;
  shareContacts?: InputMaybe<ContactSharingMode>;
  shareContractTemplates?: InputMaybe<ContractTemplateSharingMode>;
  shareEZBData?: InputMaybe<EzbDataSharingMode>;
  shareLaborAgreements?: InputMaybe<LaborAgreementSharingMode>;
  sharePartners?: InputMaybe<PartnerSharingMode>;
  targetEmail: Scalars['String']['input'];
};

export class OrganizationLinkInvitationIdInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationLinkInvitationLinkBackInput {
  partnerSharing?: InputMaybe<PartnerSharingConfigurationInput>;
  selectedContacts?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedContractTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedLaborAgreements?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPartners?: InputMaybe<Array<SelectedPartnerSharingConfigurationInput>>;
  shareContacts?: InputMaybe<ContactSharingMode>;
  shareContractTemplates?: InputMaybe<ContractTemplateSharingMode>;
  shareEZBData?: InputMaybe<EzbDataSharingMode>;
  shareLaborAgreements?: InputMaybe<LaborAgreementSharingMode>;
  sharePartners?: InputMaybe<PartnerSharingMode>;
};

export enum OrganizationLinkInvitationStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Expired = 'Expired',
  Pending = 'Pending',
  Withdrawn = 'Withdrawn'
}

export class OrganizationLinkInvitationTokenInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum OrganizationLinkMode {
  LinkByOrganization = 'LinkByOrganization',
  LinkToOrganization = 'LinkToOrganization'
}

export class OrganizationLinkMultiEditInput {
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  linkedOrganizationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  partnerSharing?: InputMaybe<PartnerSharingConfigurationInput>;
  selectedContacts?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedContractTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedLaborAgreements?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPartners?: InputMaybe<Array<SelectedPartnerSharingConfigurationInput>>;
  shareContacts?: InputMaybe<ContactSharingMode>;
  shareContractTemplates?: InputMaybe<ContractTemplateSharingMode>;
  shareEZBData?: InputMaybe<EzbDataSharingMode>;
  shareLaborAgreements?: InputMaybe<LaborAgreementSharingMode>;
  sharePartners?: InputMaybe<PartnerSharingMode>;
  writeContacts: Scalars['Boolean']['input'];
  writeContracts: Scalars['Boolean']['input'];
  writeLaborContracts: Scalars['Boolean']['input'];
  writeOrganizations: Scalars['Boolean']['input'];
  writePartners: Scalars['Boolean']['input'];
};

export class OrganizationLinkUpdateChildLinksInput {
  organizationIds: Array<Scalars['ID']['input']>;
  rootOrganizationId: Scalars['ID']['input'];
};

export class OrganizationLinkUpdateInput {
  _etag: Scalars['String']['input'];
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  id: Scalars['ID']['input'];
  linkedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  partnerSharing?: InputMaybe<PartnerSharingConfigurationInput>;
  selectedContacts?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedContractTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedLaborAgreements?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPartners?: InputMaybe<Array<SelectedPartnerSharingConfigurationInput>>;
  shareContacts?: InputMaybe<ContactSharingMode>;
  shareContractTemplates?: InputMaybe<ContractTemplateSharingMode>;
  shareEZBData?: InputMaybe<EzbDataSharingMode>;
  shareLaborAgreements?: InputMaybe<LaborAgreementSharingMode>;
  sharePartners?: InputMaybe<PartnerSharingMode>;
};

export class OrganizationLinkedInput {
  organizationId: Scalars['ID']['input'];
};

export class OrganizationLinksCreateInput {
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  linkedOrganizationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  partnerSharing?: InputMaybe<PartnerSharingConfigurationInput>;
  selectedContacts?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedContractTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedLaborAgreements?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPartners?: InputMaybe<Array<SelectedPartnerSharingConfigurationInput>>;
  shareContacts?: InputMaybe<ContactSharingMode>;
  shareContractTemplates?: InputMaybe<ContractTemplateSharingMode>;
  shareEZBData?: InputMaybe<EzbDataSharingMode>;
  shareLaborAgreements?: InputMaybe<LaborAgreementSharingMode>;
  sharePartners?: InputMaybe<PartnerSharingMode>;
};

export class OrganizationListDto {
  __typename?: 'OrganizationListDTO';
  organizations?: Maybe<Array<OrganizationListEntry>>;
};

export class OrganizationListEntry {
  __typename?: 'OrganizationListEntry';
  isLicensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationListEvent = OrganizationListDto | ProgressEvent;

export class OrganizationListInput {
  immigrationCountry?: InputMaybe<SupportedImmigrationCountry>;
  sourceOrganizationId: Scalars['ID']['input'];
  targetOrganizationId: Scalars['ID']['input'];
};

export class OrganizationProfile {
  __typename?: 'OrganizationProfile';
  _etag?: Maybe<Scalars['String']['output']>;
  contactUserGroups?: Maybe<Array<Scalars['String']['output']>>;
  description: Array<OrganizationProfileDescription>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  isMatchingEnabled: Scalars['Boolean']['output'];
  locations: Array<OrganizationProfileLocation>;
  organizationId: Scalars['ID']['output'];
};

export class OrganizationProfileDescription {
  __typename?: 'OrganizationProfileDescription';
  contents: Scalars['String']['output'];
  delta: Scalars['JSONObject']['output'];
  language: Scalars['String']['output'];
};

export class OrganizationProfileDescriptionInput {
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
  language: Scalars['String']['input'];
};

export class OrganizationProfileFields {
  __typename?: 'OrganizationProfileFields';
  careFacility: Scalars['Boolean']['output'];
  city: Scalars['Boolean']['output'];
  countryOfOrigin: Scalars['Boolean']['output'];
  employmentType: Scalars['Boolean']['output'];
  experienceField: Scalars['Boolean']['output'];
  function: Scalars['Boolean']['output'];
  interviewLanguageLevel: Scalars['Boolean']['output'];
  pathOfRecognition: Scalars['Boolean']['output'];
  requiredStaff: Scalars['Boolean']['output'];
  requiredStaffAmount: Scalars['Boolean']['output'];
  state: Scalars['Boolean']['output'];
  temporalScope: Scalars['Boolean']['output'];
  transferLanguageLevel: Scalars['Boolean']['output'];
};

export class OrganizationProfileGetInput {
  organizationId: Scalars['ID']['input'];
};

export class OrganizationProfileLocation {
  __typename?: 'OrganizationProfileLocation';
  address: Scalars['String']['output'];
  beds?: Maybe<Scalars['Float']['output']>;
  careFacility: Array<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  experienceField?: Maybe<Array<Scalars['String']['output']>>;
  hasInternationalExperience: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  measuresAndInstrumentsForIntegration?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfHiresAtLocation?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  vacancies: Array<OrganizationProfileLocationVacancy>;
  website?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export class OrganizationProfileLocationInput {
  address: Scalars['String']['input'];
  beds?: InputMaybe<Scalars['Float']['input']>;
  careFacility: Array<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  experienceField?: InputMaybe<Array<Scalars['String']['input']>>;
  hasInternationalExperience: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  measuresAndInstrumentsForIntegration?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfHiresAtLocation?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  vacancies: Array<OrganizationProfileLocationVacancyInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export class OrganizationProfileLocationVacancy {
  __typename?: 'OrganizationProfileLocationVacancy';
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  countryOfOrigin?: Maybe<Array<Scalars['String']['output']>>;
  employmentType?: Maybe<Array<EmploymentRelationshipType>>;
  function?: Maybe<Array<Scalars['String']['output']>>;
  interviewLanguageLevel?: Maybe<Scalars['String']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  requiredStaff: Array<Scalars['String']['output']>;
  requiredStaffAmount?: Maybe<Scalars['Float']['output']>;
  temporalScope?: Maybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: Maybe<Scalars['String']['output']>;
};

export class OrganizationProfileLocationVacancyInput {
  benefits?: InputMaybe<Array<Scalars['String']['input']>>;
  countryOfOrigin?: InputMaybe<Array<Scalars['String']['input']>>;
  employmentType?: InputMaybe<Array<EmploymentRelationshipType>>;
  function?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewLanguageLevel?: InputMaybe<Scalars['String']['input']>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  requiredStaff: Array<Scalars['String']['input']>;
  requiredStaffAmount?: InputMaybe<Scalars['Float']['input']>;
  temporalScope?: InputMaybe<Array<WorkingTimeTypeEnum>>;
  transferLanguageLevel?: InputMaybe<Scalars['String']['input']>;
};

export class OrganizationProfileSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  contactUserGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Array<OrganizationProfileDescriptionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isMatchingEnabled: Scalars['Boolean']['input'];
  locations: Array<OrganizationProfileLocationInput>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationRequireConsentInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  requireCandidateConsent?: InputMaybe<Scalars['Boolean']['input']>;
  requireTalentpoolUserConsent?: InputMaybe<Scalars['Boolean']['input']>;
  requireUserConsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export class OrganizationRolesInput {
  organizationId: Scalars['ID']['input'];
  roles: Array<UserRole>;
};

export class OrganizationSearchInput {
  organizationId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
};

export class OrganizationSearchResult {
  __typename?: 'OrganizationSearchResult';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  type: OrganizationSearchType;
};

export enum OrganizationSearchType {
  Contact = 'Contact',
  User = 'User'
}

export class OrganizationTag {
  __typename?: 'OrganizationTag';
  _etag?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  internalOnly?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  type: OrganizationTagType;
};

export class OrganizationTagCreateInput {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: OrganizationTagType;
};

export class OrganizationTagDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class OrganizationTagListInput {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<OrganizationTagType>;
};

export enum OrganizationTagType {
  ProcessTask = 'ProcessTask',
  StatusChangeReason = 'StatusChangeReason'
}

export class OrganizationTagUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: OrganizationTagType;
};

export class OrganizationUserCostPreview {
  __typename?: 'OrganizationUserCostPreview';
  currency?: Maybe<SupportedBillingCurrency>;
  currentBillableUsers: Scalars['Float']['output'];
  currentIncludedUsers: Scalars['Float']['output'];
  currentMonthlyCost: Scalars['Float']['output'];
  isPartnerOrganization: Scalars['Boolean']['output'];
  monthlyCostDifference: Scalars['Float']['output'];
  newBillableUsers: Scalars['Float']['output'];
  newIncludedUsers: Scalars['Float']['output'];
  newMonthlyCost: Scalars['Float']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  totalActiveUsers: Scalars['Float']['output'];
};

export class OrganizationUserGroupMapping {
  __typename?: 'OrganizationUserGroupMapping';
  assignedUserGroupId: Scalars['ID']['output'];
  processOrganizationId: Scalars['ID']['output'];
};

export class OrganizationUserGroupMappingInput {
  assignedUserGroupId: Scalars['ID']['input'];
  processOrganizationId: Scalars['ID']['input'];
};

export class OrganizationsBySharedTabInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  sharingTypes?: InputMaybe<Array<SharingTypeEnum>>;
  tab: Scalars['String']['input'];
};

export class OtherChatUser {
  __typename?: 'OtherChatUser';
  chatUserId: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  userOrCandidateId: Scalars['String']['output'];
};

export class OutboxRunInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class OwnOrganizationUserPriceChangePreview {
  __typename?: 'OwnOrganizationUserPriceChangePreview';
  contractId: Scalars['String']['output'];
  contractOrganizationId: Scalars['String']['output'];
  currency?: Maybe<SupportedBillingCurrency>;
  currentIncludedUsers: Scalars['Float']['output'];
  currentPrice: Scalars['Float']['output'];
  newIncludedUsers: Scalars['Float']['output'];
  newPrice: Scalars['Float']['output'];
  organization: OrganizationUserCostPreview;
};

export class OwnOrganizationUserPriceChangePreviewInput {
  contractId: Scalars['String']['input'];
  currency: SupportedBillingCurrency;
  newIncludedUsers: Scalars['Float']['input'];
  newPrice: Scalars['Float']['input'];
};

export class ParseCvInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId: Scalars['ID']['input'];
  documentAsBase64String: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
};

export class ParsedCandidateFromCv {
  __typename?: 'ParsedCandidateFromCv';
  addresses?: Maybe<Array<ParsedCvAddress>>;
  birthdate?: Maybe<Scalars['UTCDate']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  cityOfBirth?: Maybe<Scalars['String']['output']>;
  competencies?: Maybe<ParsedCvCompetencies>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experiences?: Maybe<Array<ParsedCvExperience>>;
  firstname?: Maybe<Scalars['String']['output']>;
  languageSkills?: Maybe<Array<ParsedCvLanguageSkill>>;
  lastname?: Maybe<Scalars['String']['output']>;
  parsingWarning?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  profilePictureAsBase64?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Array<ParsedCvQualification>>;
  salutation?: Maybe<Scalars['String']['output']>;
};

export class ParsedCvAddress {
  __typename?: 'ParsedCvAddress';
  address?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  region?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export class ParsedCvCompetencies {
  __typename?: 'ParsedCvCompetencies';
  knowledges: Array<ParsedCvCompetencyItem>;
  skills: Array<ParsedCvCompetencyItem>;
};

export class ParsedCvCompetencyItem {
  __typename?: 'ParsedCvCompetencyItem';
  proficiency: Scalars['String']['output'];
  skillId: Scalars['String']['output'];
};

export class ParsedCvExperience {
  __typename?: 'ParsedCvExperience';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  experienceCoreTasks?: Maybe<Scalars['String']['output']>;
  experienceCoreTasksDelta?: Maybe<Scalars['JSONObject']['output']>;
  experienceEndDate?: Maybe<Scalars['UTCDate']['output']>;
  experienceFacility?: Maybe<Scalars['String']['output']>;
  experienceFields?: Maybe<Array<Scalars['JSONObject']['output']>>;
  experienceInstitution?: Maybe<Scalars['String']['output']>;
  experienceStartDate?: Maybe<Scalars['UTCDate']['output']>;
  experienceType?: Maybe<ExperienceType>;
  id: Scalars['ID']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
};

export class ParsedCvLanguageSkill {
  __typename?: 'ParsedCvLanguageSkill';
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  skillLevel?: Maybe<Scalars['String']['output']>;
};

export class ParsedCvQualification {
  __typename?: 'ParsedCvQualification';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  educationFocus?: Maybe<Scalars['String']['output']>;
  endOfTraining?: Maybe<Scalars['UTCDate']['output']>;
  id: Scalars['ID']['output'];
  nameOfInstitution?: Maybe<Scalars['String']['output']>;
  qualification?: Maybe<Scalars['String']['output']>;
  startOfTraining?: Maybe<Scalars['UTCDate']['output']>;
};

export class PartialCandidateApplicationMaskCandidateInput {
  communicationLanguage?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['JSONObject']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  totalExperienceInMonth?: InputMaybe<Scalars['Float']['input']>;
};

export class ParticipationCondition {
  __typename?: 'ParticipationCondition';
  allowedValues: Array<Scalars['JSON']['output']>;
  path: Scalars['String']['output'];
};

export class ParticipationConditionInput {
  allowedValues: Array<Scalars['JSON']['input']>;
  path: Scalars['String']['input'];
};

export class PartnerOrganizationsUserPriceChangePreview {
  __typename?: 'PartnerOrganizationsUserPriceChangePreview';
  affectedOrganizations: Array<OrganizationUserCostPreview>;
  contractId: Scalars['String']['output'];
  contractOrganizationId: Scalars['String']['output'];
  currency?: Maybe<SupportedBillingCurrency>;
  currentIncludedUsers: Scalars['Float']['output'];
  currentPrice: Scalars['Float']['output'];
  newIncludedUsers: Scalars['Float']['output'];
  newPrice: Scalars['Float']['output'];
  totalCurrentMonthlyCost: Scalars['Float']['output'];
  totalMonthlyCostDifference: Scalars['Float']['output'];
  totalNewMonthlyCost: Scalars['Float']['output'];
};

export class PartnerOrganizationsUserPriceChangePreviewInput {
  contractId: Scalars['String']['input'];
  currency: SupportedBillingCurrency;
  newIncludedUsers: Scalars['Float']['input'];
  newPrice: Scalars['Float']['input'];
};

export class PartnerSharingConfiguration {
  __typename?: 'PartnerSharingConfiguration';
  allowLinkingInCaseItIsManaged?: Maybe<Scalars['Boolean']['output']>;
  shareContacts?: Maybe<Scalars['Boolean']['output']>;
  shareContractTemplates?: Maybe<Scalars['Boolean']['output']>;
  shareEZBData?: Maybe<Scalars['Boolean']['output']>;
  shareLaborAgreements?: Maybe<Scalars['Boolean']['output']>;
  sharePartners?: Maybe<Scalars['Boolean']['output']>;
};

export class PartnerSharingConfigurationInput {
  allowLinkingInCaseItIsManaged?: InputMaybe<Scalars['Boolean']['input']>;
  shareContacts?: InputMaybe<Scalars['Boolean']['input']>;
  shareContractTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  shareEZBData?: InputMaybe<Scalars['Boolean']['input']>;
  shareLaborAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  sharePartners?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PartnerSharingMode {
  ShareAll = 'ShareAll',
  ShareSelected = 'ShareSelected'
}

export enum PaymentPeriod {
  M1 = 'M1',
  M3 = 'M3',
  M6 = 'M6',
  M12 = 'M12',
  Quarterly = 'Quarterly'
}

export class PaymentSettings {
  __typename?: 'PaymentSettings';
  id: Scalars['String']['output'];
  paymentTime: PaymentTime;
  paymentTranches?: Maybe<Array<ContractPaymentTranche>>;
  period: PaymentPeriod;
  startDate: Scalars['UTCDate']['output'];
};

export class PaymentSettingsInput {
  id: Scalars['String']['input'];
  paymentTime: PaymentTime;
  paymentTranches?: InputMaybe<Array<ContractPaymentTrancheInput>>;
  period: PaymentPeriod;
  startDate: Scalars['UTCDate']['input'];
};

export enum PaymentTime {
  InAdvance = 'InAdvance',
  InArrears = 'InArrears'
}

export class PdfFormForTaskInput {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class PdfFormGenerationState {
  __typename?: 'PdfFormGenerationState';
  blob?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  status: DocumentTemplateStatus;
  warnings?: Maybe<Array<DocumentTemplateWarning>>;
};

export class PdfFormGenerationStateInput {
  blob?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  status: DocumentTemplateStatus;
  warnings?: InputMaybe<Array<DocumentTemplateWarningInput>>;
};

export class PdfFormTemplate {
  __typename?: 'PdfFormTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  blob?: Maybe<Scalars['String']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  federalStateId?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isVirtual: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  pdfFormToken: KnownPdfFormTokens;
  recipient?: Maybe<Scalars['String']['output']>;
};

export class PdfFormTemplateClearInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class PdfFormTemplateGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  isVirtual: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  pdfFormToken: KnownPdfFormTokens;
};

export class PdfFormTemplateListInput {
  organizationId: Scalars['ID']['input'];
};

export class PdfFormTemplateSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  blob?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  federalStateId?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isVirtual: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  pdfFormToken: KnownPdfFormTokens;
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export class PdfFormTemplateSettings {
  __typename?: 'PdfFormTemplateSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  alwaysGeneratedForms?: Maybe<Array<KnownPdfFormTokens>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class PdfFormTemplateSettingsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class PdfFormTemplateSettingsSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  alwaysGeneratedForms?: InputMaybe<Array<KnownPdfFormTokens>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class PdfFormTemplateWatch {
  __typename?: 'PdfFormTemplateWatch';
  _etag?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  pdfFormKey: Scalars['String']['output'];
  pdfFormToken: KnownPdfFormTokens;
  userStoryId?: Maybe<Scalars['Float']['output']>;
};

export class PdfFormTemplateWatchUpdateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  userStoryId?: InputMaybe<Scalars['Float']['input']>;
};

export class PdfFormUpdateUrlsDownload {
  __typename?: 'PdfFormUpdateUrlsDownload';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export class PendingClarificationContinuationDto {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  clarificationAnswers: Array<ClarificationAnswerPayloadDto>;
  description: Scalars['String']['input'];
  kind?: InputMaybe<Scalars['String']['input']>;
  originalSubagentInvocationId?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  targetItemId?: InputMaybe<Scalars['ID']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export class PerformanceEntry {
  __typename?: 'PerformanceEntry';
  comment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EducationCoursePerformanceStatus>;
};

export class PerformanceEntryInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EducationCoursePerformanceStatus>;
};

export class PgLeadingLimiterStats {
  __typename?: 'PgLeadingLimiterStats';
  kind: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  pool: Scalars['String']['output'];
  queued: Scalars['Int']['output'];
  rejectedQueueFull: Scalars['Float']['output'];
  rejectedTimeout: Scalars['Float']['output'];
  run: Scalars['Float']['output'];
  running: Scalars['Int']['output'];
  waitCount: Scalars['Float']['output'];
  waitMaxMs: Scalars['Float']['output'];
  waitSumMs: Scalars['Float']['output'];
};

export class PgPoolStats {
  __typename?: 'PgPoolStats';
  connectionTimeoutMs: Scalars['Int']['output'];
  idle: Scalars['Int']['output'];
  idleTimeoutMs: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export class Phase {
  __typename?: 'Phase';
  candidateDiscounts?: Maybe<Array<Discount>>;
  contingentDefinitionSetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licenseDiscounts?: Maybe<Array<Discount>>;
  planId: Scalars['String']['output'];
  startDate: Scalars['UTCDate']['output'];
  type: PhaseType;
};

export class PhaseInput {
  candidateDiscounts?: InputMaybe<Array<DiscountInput>>;
  contingentDefinitionSetId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  licenseDiscounts?: InputMaybe<Array<DiscountInput>>;
  planId: Scalars['String']['input'];
  startDate: Scalars['UTCDate']['input'];
  type: PhaseType;
};

export enum PhaseType {
  Normal = 'Normal',
  Paused = 'Paused'
}

export class Plan {
  __typename?: 'Plan';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  candidatePrice: CandidatePrice;
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  labelKey: Scalars['String']['output'];
  licensePrice: LicensePrice;
  name?: Maybe<Scalars['String']['output']>;
  type: PlanType;
};

export enum PlanType {
  Contingent = 'Contingent',
  Default = 'Default'
}

export class PlanningComparisonInput {
  durationType: ProcessPlanningDurationType;
  granularity: Granularity;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  snapshotIds: Array<Scalars['String']['input']>;
};

export class PlanningDifferenceMap {
  __typename?: 'PlanningDifferenceMap';
  candidateNames: Array<Scalars['String']['output']>;
  children?: Maybe<Array<PlanningDifferenceNode>>;
  differences: Array<Maybe<Scalars['Float']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export class PlanningDifferenceNode {
  __typename?: 'PlanningDifferenceNode';
  children?: Maybe<Array<PlanningDifferenceNode>>;
  differences: Array<Maybe<Scalars['Float']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export class PlanningSharing {
  __typename?: 'PlanningSharing';
  _etag?: Maybe<Scalars['String']['output']>;
  destinationOrganizationIds: Array<Scalars['String']['output']>;
  destinationOrganizationNames?: Maybe<Array<Scalars['String']['output']>>;
  durationTypes: Array<ProcessPlanningDurationType>;
  granularity: Granularity;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  planningName?: Maybe<Scalars['String']['output']>;
  planningTimestamp?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  processId: Scalars['ID']['output'];
  snapshotId: Scalars['String']['output'];
};

export class PlanningSharingInput {
  destinationOrganizationIds: Array<Scalars['String']['input']>;
  durationTypes: Array<ProcessPlanningDurationType>;
  granularity: Granularity;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  snapshotId: Scalars['String']['input'];
};

export class PlanningStateForList {
  __typename?: 'PlanningStateForList';
  id?: Maybe<Scalars['ID']['output']>;
  lastUpdated: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  planningName?: Maybe<Scalars['String']['output']>;
  planningTimestamp: Scalars['AnkaadiaDateTime']['output'];
  planningType?: Maybe<PlanningType>;
  snapshotId?: Maybe<Scalars['String']['output']>;
};

export enum PlanningType {
  Baseline = 'Baseline',
  Current = 'Current',
  Custom = 'Custom'
}

export class PoolConnectionStats {
  __typename?: 'PoolConnectionStats';
  closed: Scalars['Float']['output'];
  connectFailed: Scalars['Float']['output'];
  opened: Scalars['Float']['output'];
  pool: Scalars['String']['output'];
  sessionSetupFailed: Scalars['Float']['output'];
};

export class PredecessorActivationInfo {
  __typename?: 'PredecessorActivationInfo';
  id: Scalars['ID']['output'];
  instanceState?: Maybe<InstanceStateEnum>;
  isDeleted: Scalars['Boolean']['output'];
  isFinished: Scalars['Boolean']['output'];
  localizedDisplayName: Scalars['String']['output'];
};

export class PredefinedProcessModelDeclaration {
  __typename?: 'PredefinedProcessModelDeclaration';
  displayName: Array<ProcessModelString>;
  isPredefinedModel?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['String']['output'];
  organizationToken?: Maybe<Scalars['String']['output']>;
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  releaseId?: Maybe<Scalars['String']['output']>;
  rootLanguage: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export class PrepareNewTaskInput {
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['String']['input']>;
  instanceState: InstanceStateEnum;
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
  responsibleRoles: Array<Scalars['String']['input']>;
  targetObject: ProcessTargetEnum;
  typeName: Scalars['String']['input'];
  visibleForRoles: Array<Scalars['String']['input']>;
};

export class PresentationCandidateData {
  __typename?: 'PresentationCandidateData';
  introductionVideoUrl?: Maybe<Scalars['String']['output']>;
  recommendationNote?: Maybe<RecommendationNote>;
};

export class PresentationCandidateDataInput {
  introductionVideoUrl?: InputMaybe<Scalars['String']['input']>;
  recommendationNote?: InputMaybe<RecommendationNoteInput>;
};

export class PreviewableFile {
  __typename?: 'PreviewableFile';
  document: Document;
  file: DocumentFile;
  setName?: Maybe<Scalars['String']['output']>;
  setType?: Maybe<Scalars['String']['output']>;
};

export class PriceRow {
  __typename?: 'PriceRow';
  candidateFunction?: Maybe<Scalars['String']['output']>;
  candidateOrigin?: Maybe<CandidateOrigin>;
  candidateSource?: Maybe<CandidateSource>;
  cap?: Maybe<Scalars['Float']['output']>;
  degression: Array<DegressionRow>;
  events: Array<PriceRowEventAndShare>;
  floor?: Maybe<Scalars['Float']['output']>;
  professionCategory?: Maybe<ProfessionCategory>;
};

export class PriceRowEventAndShare {
  __typename?: 'PriceRowEventAndShare';
  event: BillingEventType;
  share: Scalars['Float']['output'];
};

export class PriceRowEventAndShareInput {
  event: BillingEventType;
  share: Scalars['Float']['input'];
};

export class PriceRowInput {
  candidateFunction?: InputMaybe<Scalars['String']['input']>;
  candidateOrigin?: InputMaybe<CandidateOrigin>;
  candidateSource?: InputMaybe<CandidateSource>;
  cap?: InputMaybe<Scalars['Float']['input']>;
  degression: Array<DegressionRowInput>;
  events: Array<PriceRowEventAndShareInput>;
  floor?: InputMaybe<Scalars['Float']['input']>;
  professionCategory?: InputMaybe<ProfessionCategory>;
};

export enum PriorityEnum {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export class Process {
  __typename?: 'Process';
  _etag?: Maybe<Scalars['String']['output']>;
  automaticLanguage?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  commentedStatesIds?: Maybe<Array<Scalars['String']['output']>>;
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  delegatedProcessId?: Maybe<Scalars['ID']['output']>;
  delegatedProcessOrganizationId?: Maybe<Scalars['ID']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  hasDelegation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAdhocProcess?: Maybe<Scalars['Boolean']['output']>;
  isDelegation?: Maybe<Scalars['Boolean']['output']>;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  lastTaskInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  operationMapping?: Maybe<ProcessOperationMapping>;
  organizationId: Scalars['ID']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  processModelId: Scalars['ID']['output'];
  processModelName: Array<ProcessRequiredString>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  releaseId?: Maybe<Scalars['ID']['output']>;
  releaseSelectionMode?: Maybe<ProcessReleaseSelectionModeEnum>;
  roleMappingBeforeDelegation?: Maybe<Array<RoleOrganizationUserGroupMapping>>;
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMapping>;
  roles: Array<ProcessRole>;
  rules?: Maybe<Array<ProcessRule>>;
  state: ProcessInstanceStateEnum;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
};

export class ProcessAccess {
  __typename?: 'ProcessAccess';
  canAccess: Scalars['Boolean']['output'];
  redirectToOrganization?: Maybe<Scalars['ID']['output']>;
};

export class ProcessAccessInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class ProcessAction {
  __typename?: 'ProcessAction';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  collectionNames: Array<Scalars['String']['output']>;
  collections?: Maybe<Array<CollectionDefinition>>;
  events: Array<ProcessEventEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  issues: Array<ProcessActionIssue>;
  operationTypes: Array<ProcessOperationEnum>;
  operations: Array<ProcessOperationResult>;
  organizationId: Scalars['ID']['output'];
  processes: Array<ProcessActionProcess>;
};

export class ProcessActionCreateInput {
  collections?: InputMaybe<Array<CollectionDefinitionInput>>;
  events: Array<ProcessEventEnum>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  operations: Array<ProcessOperationInput>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessActionDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessActionGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessActionIssue {
  __typename?: 'ProcessActionIssue';
  messages: Array<Scalars['String']['output']>;
  operationId: Scalars['String']['output'];
};

export class ProcessActionListInput {
  organizationId: Scalars['ID']['input'];
};

export class ProcessActionProcess {
  __typename?: 'ProcessActionProcess';
  collectionId: Scalars['String']['output'];
  collectionName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDelegation: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
};

export class ProcessActionUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<CollectionDefinitionInput>>;
  events: Array<ProcessEventEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  operations: Array<ProcessOperationInput>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessActivateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  state: ProcessInstanceStateEnum;
};

export type ProcessAgentEvent = ClarificationRequiredEmitEvent | FinishEmitEvent | MessageAnswerFinalizedEmitEvent | MessageDeltaEmitEvent | MessageEmitEvent | MessageThinkingFinalizedEmitEvent | ModelSwitchEmitEvent | ProgressEmitEvent | SubagentAppliedEmitEvent | SubagentProgressEmitEvent | SubagentResultEmitEvent | SubagentStartEmitEvent | ToolBatchStartEmitEvent | ToolDoneEmitEvent | ToolErrorEmitEvent | ToolStartEmitEvent;

export class ProcessAgentFeedbackInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processModelId: Scalars['String']['input'];
  rating: AiFeedbackRating;
  subagentInvocationId?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessAndOperation {
  __typename?: 'ProcessAndOperation';
  operationId: Scalars['String']['output'];
  processId: Scalars['String']['output'];
};

export class ProcessAndOperationInput {
  operationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};

export class ProcessAreaEntity {
  __typename?: 'ProcessAreaEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  processInstanceState: ProcessInstanceStateEnum;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  rootId: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessAreaInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceState: InstanceStateEnum;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  processInstanceState: ProcessInstanceStateEnum;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  rootId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessAreaModel {
  __typename?: 'ProcessAreaModel';
  _typeName: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  phases: Array<ProcessPhaseModel>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessAreaModelCreateInput {
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  previousAreaId?: InputMaybe<Scalars['String']['input']>;
  rootId: Scalars['ID']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessAreaModelDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessAreaModelDuplicateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessAreaModelEntity {
  __typename?: 'ProcessAreaModelEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  sortOrder: Scalars['Float']['output'];
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessAreaModelEntityInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  sortOrder: Scalars['Float']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessAreaModelGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessAreaModelMoveInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  previousAreaId?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessAreaModelUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  sortOrder: Scalars['Float']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessCheckReportDownload {
  __typename?: 'ProcessCheckReportDownload';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export class ProcessChildTasksInput {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  instanceStates?: InputMaybe<Array<InstanceStateEnum>>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class ProcessCreateInput {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  delegatedProcessId?: InputMaybe<Scalars['ID']['input']>;
  delegatedProcessOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  documentLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  isDelegation?: InputMaybe<Scalars['Boolean']['input']>;
  languages: Array<Scalars['String']['input']>;
  operationMapping?: InputMaybe<ProcessOperationMappingInput>;
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  processModelName: Array<ProcessRequiredStringInput>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  releaseId?: InputMaybe<Scalars['ID']['input']>;
  releaseSelectionMode?: InputMaybe<ProcessReleaseSelectionModeEnum>;
  roleMappingBeforeDelegation?: InputMaybe<Array<RoleOrganizationUserGroupMappingInput>>;
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMappingInput>;
  roles: Array<ProcessRoleInput>;
  rules?: InputMaybe<Array<ProcessRuleInput>>;
  state: ProcessInstanceStateEnum;
  taskVisibility?: InputMaybe<TaskVisibilityEnum>;
};

export class ProcessDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessDocumentRequirement {
  __typename?: 'ProcessDocumentRequirement';
  alternatives?: Maybe<Array<ProcessDocumentRequirementAlternative>>;
  description?: Maybe<Array<ProcessOptionalString>>;
  minAlternatives?: Maybe<Scalars['Float']['output']>;
  requireNewUpload?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessDocumentRequirementAlternative {
  __typename?: 'ProcessDocumentRequirementAlternative';
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileformats: Array<Scalars['String']['output']>;
  minfileFormatsRequired?: Maybe<Scalars['Float']['output']>;
  numberOfCopies?: Maybe<Array<Scalars['Float']['output']>>;
};

export class ProcessDocumentRequirementAlternativeInput {
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  fileformats: Array<Scalars['String']['input']>;
  minfileFormatsRequired?: InputMaybe<Scalars['Float']['input']>;
  numberOfCopies?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export class ProcessDocumentRequirementInput {
  alternatives?: InputMaybe<Array<ProcessDocumentRequirementAlternativeInput>>;
  description?: InputMaybe<Array<ProcessOptionalStringInput>>;
  minAlternatives?: InputMaybe<Scalars['Float']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessDocumentToUploadType {
  __typename?: 'ProcessDocumentToUploadType';
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayName: Array<ProcessRequiredString>;
  documentId: Scalars['String']['output'];
  documentType?: Maybe<Scalars['String']['output']>;
  fileformats: Array<Scalars['String']['output']>;
};

export class ProcessDocumentToUploadTypeInput {
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayName: Array<ProcessRequiredStringInput>;
  documentId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  fileformats: Array<Scalars['String']['input']>;
};

export class ProcessEmailInput {
  emailId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class ProcessEvaluatorExpressionError {
  __typename?: 'ProcessEvaluatorExpressionError';
  column?: Maybe<Scalars['Float']['output']>;
  line?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
};

export class ProcessEvaluatorExpressionTargetInput {
  propertyPath: Scalars['String']['input'];
  targetType: ProcessRuleTargetType;
  taskTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessEvaluatorExpressionValidatorInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionType: ExpressionType;
  target?: InputMaybe<ProcessEvaluatorExpressionTargetInput>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ProcessEventEnum {
  ApplicationReceived = 'ApplicationReceived',
  ApplicationRejected = 'ApplicationRejected',
  CandidateChanged = 'CandidateChanged',
  CandidateCreated = 'CandidateCreated',
  EmployerChanged = 'EmployerChanged',
  InterviewCanceled = 'InterviewCanceled',
  InterviewRequested = 'InterviewRequested',
  NegativeFeedback = 'NegativeFeedback',
  ProcessCompleted = 'ProcessCompleted',
  TalentPoolRequestAccepted = 'TalentPoolRequestAccepted',
  TalentPoolRequestReceived = 'TalentPoolRequestReceived',
  TalentPoolRequestRejected = 'TalentPoolRequestRejected'
}

export class ProcessForDelegation {
  __typename?: 'ProcessForDelegation';
  _etag?: Maybe<Scalars['String']['output']>;
  automaticLanguage?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  commentedStatesIds?: Maybe<Array<Scalars['String']['output']>>;
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  delegatedProcessId?: Maybe<Scalars['ID']['output']>;
  delegatedProcessOrganizationId?: Maybe<Scalars['ID']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  hasDelegation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAdhocProcess?: Maybe<Scalars['Boolean']['output']>;
  isDelegation?: Maybe<Scalars['Boolean']['output']>;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  lastTaskInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  operationMapping?: Maybe<ProcessOperationMapping>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  processModelId: Scalars['ID']['output'];
  processModelName: Array<ProcessRequiredString>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  releaseId?: Maybe<Scalars['ID']['output']>;
  releaseSelectionMode?: Maybe<ProcessReleaseSelectionModeEnum>;
  roleMappingBeforeDelegation?: Maybe<Array<RoleOrganizationUserGroupMapping>>;
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMapping>;
  roles: Array<ProcessRole>;
  rules?: Maybe<Array<ProcessRule>>;
  state: ProcessInstanceStateEnum;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
};

export class ProcessFormlyModel {
  __typename?: 'ProcessFormlyModel';
  formly?: Maybe<Array<Scalars['JSONObject']['output']>>;
};

export class ProcessFormlyModelInput {
  formly?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};

export enum ProcessGraphConnectionStyle {
  Detailed = 'Detailed',
  Simple = 'Simple'
}

export class ProcessGraphSettings {
  __typename?: 'ProcessGraphSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  collapseFinished?: Maybe<Scalars['Boolean']['output']>;
  collapseInactive?: Maybe<Scalars['Boolean']['output']>;
  connectionStyle?: Maybe<ProcessGraphConnectionStyle>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  showRules?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
};

export class ProcessGraphSettingsInput {
  collapseFinished?: InputMaybe<Scalars['Boolean']['input']>;
  collapseInactive?: InputMaybe<Scalars['Boolean']['input']>;
  connectionStyle?: InputMaybe<ProcessGraphConnectionStyle>;
  showRules?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessHealthStats {
  __typename?: 'ProcessHealthStats';
  eventLoopDelayMaxMs: Scalars['Float']['output'];
  eventLoopDelayMeanMs: Scalars['Float']['output'];
  eventLoopDelayP95Ms: Scalars['Float']['output'];
  memoryHeapTotalMb: Scalars['Float']['output'];
  memoryHeapUsedMb: Scalars['Float']['output'];
  memoryRssMb: Scalars['Float']['output'];
};

export class ProcessHeatmap {
  __typename?: 'ProcessHeatmap';
  candidateNames: Array<Scalars['String']['output']>;
  children?: Maybe<Array<ProcessHeatmapNode>>;
  id?: Maybe<Scalars['ID']['output']>;
  progresses: Array<Maybe<Scalars['Float']['output']>>;
  step?: Maybe<Scalars['String']['output']>;
};

export class ProcessHeatmapInput {
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class ProcessHeatmapNode {
  __typename?: 'ProcessHeatmapNode';
  children?: Maybe<Array<ProcessHeatmapNode>>;
  id?: Maybe<Scalars['ID']['output']>;
  progresses: Array<Maybe<Scalars['Float']['output']>>;
  step?: Maybe<Scalars['String']['output']>;
};

export enum ProcessInstanceStateEnum {
  Active = 'Active',
  Inactive = 'Inactive'
}

export class ProcessListInput {
  organizationId: Scalars['ID']['input'];
};

export class ProcessListResult {
  __typename?: 'ProcessListResult';
  processes: Array<Process>;
};

export type ProcessListResultEvent = ProcessListResult | ProgressEvent;

export class ProcessMilestoneList {
  __typename?: 'ProcessMilestoneList';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  dashboardSharing?: Maybe<MilestoneDashboardSharingSettings>;
  dashboardVisibility?: Maybe<Array<DashboardVisibilityOptions>>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  existingDashboards?: Maybe<Array<DashboardVisibilityOptions>>;
  functions: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountries: Array<Scalars['String']['output']>;
  milestones?: Maybe<Array<GlobalMilestone>>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  professions: Array<Scalars['String']['output']>;
};

export class ProcessMilestoneListCreateInput {
  dashboardVisibility?: InputMaybe<Array<DashboardVisibilityOptions>>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  functions: Array<Scalars['String']['input']>;
  immigrationCountries: Array<Scalars['String']['input']>;
  milestones?: InputMaybe<Array<GlobalMilestoneInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  professions: Array<Scalars['String']['input']>;
};

export class ProcessMilestoneListDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneListGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneListListInput {
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneListUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  dashboardVisibility?: InputMaybe<Array<DashboardVisibilityOptions>>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  functions: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  immigrationCountries: Array<Scalars['String']['input']>;
  milestones?: InputMaybe<Array<GlobalMilestoneInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  professions: Array<Scalars['String']['input']>;
};

export class ProcessMilestoneMapping {
  __typename?: 'ProcessMilestoneMapping';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  milestoneListId: Scalars['ID']['output'];
  milestoneMappings?: Maybe<Array<GlobalMilestoneMapping>>;
  organizationId: Scalars['ID']['output'];
  sharingId?: Maybe<Scalars['ID']['output']>;
  targetOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export class ProcessMilestoneMappingGetInput {
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneMappingUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milestoneListId: Scalars['ID']['input'];
  milestoneMappings?: InputMaybe<Array<GlobalMilestoneMappingInput>>;
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class ProcessMilestoneSharing {
  __typename?: 'ProcessMilestoneSharing';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  milestoneListId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  shareAllMilestones: Scalars['Boolean']['output'];
  sharedMilestoneIds?: Maybe<Array<Scalars['ID']['output']>>;
  targetOrganizationId: Scalars['ID']['output'];
  targetOrganizationName?: Maybe<Scalars['String']['output']>;
};

export class ProcessMilestoneSharingCreateInput {
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  shareAllMilestones: Scalars['Boolean']['input'];
  sharedMilestoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetOrganizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneSharingDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneSharingGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneSharingListInput {
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessMilestoneSharingUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milestoneListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  shareAllMilestones: Scalars['Boolean']['input'];
  sharedMilestoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetOrganizationId: Scalars['ID']['input'];
};

export class ProcessModel {
  __typename?: 'ProcessModel';
  _typeName: Scalars['String']['output'];
  areas?: Maybe<Array<ProcessAreaModel>>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  preset?: Maybe<ProcessPreset>;
  releaseId?: Maybe<Scalars['ID']['output']>;
  requiredTranslations?: Maybe<Array<ProcessModelRequiredTranslation>>;
  roles: Array<ProcessModelRole>;
  rootLanguage: Scalars['String']['output'];
  rules?: Maybe<Array<ProcessRule>>;
  showDocumentLanguageSelection?: Maybe<Scalars['Boolean']['output']>;
  showTaskVisibilityConfiguration?: Maybe<Scalars['Boolean']['output']>;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
  version?: Maybe<Scalars['String']['output']>;
  withoutCandidates?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessModelActivityParameter {
  __typename?: 'ProcessModelActivityParameter';
  id: Scalars['ID']['output'];
  modelId: Scalars['String']['output'];
  name: Array<ProcessModelString>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class ProcessModelAverageDurationInput {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelAverageDurationResult {
  __typename?: 'ProcessModelAverageDurationResult';
  entries: Array<TaskAverageDuration>;
};

export type ProcessModelAverageDurationResultEvent = ProcessModelAverageDurationResult | ProgressEvent;

export class ProcessModelAverageDurationSaveInput {
  entries: Array<TaskAverageDurationSaveEntry>;
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelCommandBatchInput {
  commands: Array<ProcessTaskModelCommandInputType>;
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
};

export enum ProcessModelCommandEnum {
  BulkTaskOperations = 'BulkTaskOperations',
  BulkTranslate = 'BulkTranslate',
  CreateArea = 'CreateArea',
  CreatePhase = 'CreatePhase',
  CreateTask = 'CreateTask',
  DeleteArea = 'DeleteArea',
  DeletePhase = 'DeletePhase',
  DeleteTask = 'DeleteTask',
  DuplicateArea = 'DuplicateArea',
  DuplicatePhase = 'DuplicatePhase',
  DuplicateTask = 'DuplicateTask',
  MoveArea = 'MoveArea',
  MovePhase = 'MovePhase',
  MoveTask = 'MoveTask',
  TranslateArea = 'TranslateArea',
  TranslatePhase = 'TranslatePhase',
  TranslateProcess = 'TranslateProcess',
  TranslateTask = 'TranslateTask',
  UpdateArea = 'UpdateArea',
  UpdatePhase = 'UpdatePhase',
  UpdateTask = 'UpdateTask'
}

export class ProcessModelCommandGetLatestInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
};

export class ProcessModelCommandGetLatestResult {
  __typename?: 'ProcessModelCommandGetLatestResult';
  lastCommand?: Maybe<ProcessModelCommandHistoryInfo>;
};

export class ProcessModelCommandHistoryGetInputType {
  first?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessModelCommandHistoryInfo {
  __typename?: 'ProcessModelCommandHistoryInfo';
  aiOrigin?: Maybe<Scalars['String']['output']>;
  changes: Array<Scalars['String']['output']>;
  commandId: Scalars['ID']['output'];
  commandType: Scalars['String']['output'];
  date: Scalars['AnkaadiaDateTime']['output'];
  details: Scalars['String']['output'];
  stageName: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export class ProcessModelCommandHistoryInfoPage {
  __typename?: 'ProcessModelCommandHistoryInfoPage';
  nodes?: Maybe<Array<ProcessModelCommandHistoryInfo>>;
  totalCount: Scalars['Int']['output'];
};

export class ProcessModelCommandResult {
  __typename?: 'ProcessModelCommandResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastCommand?: Maybe<ProcessModelCommandHistoryInfo>;
  node?: Maybe<ProcessModelCommandResultEntity>;
  success: Scalars['Boolean']['output'];
  tree: ProcessModelTree;
};

export class ProcessModelCommandResultEntity {
  __typename?: 'ProcessModelCommandResultEntity';
  area?: Maybe<ProcessAreaModelEntity>;
  mutationResult?: Maybe<MutationResult>;
  phase?: Maybe<ProcessPhaseModelEntity>;
  task?: Maybe<ProcessTaskModelResult>;
};

export class ProcessModelConvertToBaseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelCopySource {
  __typename?: 'ProcessModelCopySource';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: ProcessModelCopySourceKind;
  modelId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export class ProcessModelCopySourceGetInput {
  organizationId: Scalars['ID']['input'];
  source: ProcessModelCopySourceInput;
};

export class ProcessModelCopySourceInput {
  id: Scalars['ID']['input'];
  kind: ProcessModelCopySourceKind;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ProcessModelCopySourceKind {
  OrganizationModel = 'OrganizationModel',
  OtherOrganizationModel = 'OtherOrganizationModel',
  SharedRelease = 'SharedRelease'
}

export class ProcessModelCopySourceOrganization {
  __typename?: 'ProcessModelCopySourceOrganization';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export class ProcessModelCopySourceOrganizationsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelCopySourcesGetInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  targetId: Scalars['ID']['input'];
};

export class ProcessModelCreateDerivedInput {
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  importModel?: InputMaybe<ProcessModelDeclarationInput>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  rootLanguage?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessModelCreateEmptyInput {
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  isSystemProcess?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<ProcessModelRoleInput>>;
  rootLanguage?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessModelCreateReleaseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
};

export class ProcessModelDeclaration {
  __typename?: 'ProcessModelDeclaration';
  isPredefinedModel?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['String']['output'];
  organizationToken?: Maybe<Scalars['String']['output']>;
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  releaseId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export class ProcessModelDeclarationInput {
  isPredefinedModel?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['String']['input'];
  organizationToken?: InputMaybe<Scalars['String']['input']>;
  ownerOrganizationId?: InputMaybe<Scalars['String']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessModelDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelDeleteReleaseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelDirective {
  __typename?: 'ProcessModelDirective';
  directive: ProcessStageModelEntity;
  order: Scalars['Int']['output'];
  releaseId?: Maybe<Scalars['String']['output']>;
};

export class ProcessModelDuplicateInput {
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelEntity {
  __typename?: 'ProcessModelEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  preset?: Maybe<ProcessPreset>;
  requiredTranslations?: Maybe<Array<ProcessModelRequiredTranslation>>;
  roles: Array<ProcessModelRole>;
  rootLanguage: Scalars['String']['output'];
  rules?: Maybe<Array<ProcessRule>>;
  showDocumentLanguageSelection?: Maybe<Scalars['Boolean']['output']>;
  showTaskVisibilityConfiguration?: Maybe<Scalars['Boolean']['output']>;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
  withoutCandidates?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessModelEntityInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  changedAt: Scalars['AnkaadiaDateTime']['input'];
  changedBy: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  documentLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSystemProcess?: InputMaybe<Scalars['Boolean']['input']>;
  languages: Array<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  participationConditions?: InputMaybe<Array<ParticipationConditionInput>>;
  preset?: InputMaybe<ProcessPresetInputType>;
  requiredTranslations?: InputMaybe<Array<ProcessModelRequiredTranslationInput>>;
  roles: Array<ProcessModelRoleInput>;
  rootLanguage: Scalars['String']['input'];
  rules?: InputMaybe<Array<ProcessRuleInput>>;
  showDocumentLanguageSelection?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskVisibilityConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  taskVisibility?: InputMaybe<TaskVisibilityEnum>;
  withoutCandidates?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessModelExtensionEntity {
  __typename?: 'ProcessModelExtensionEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  autoUpdate?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  excludeIds?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  importModel: ProcessModelDeclaration;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  preset?: Maybe<ProcessPreset>;
  requiredTranslations?: Maybe<Array<ProcessModelRequiredTranslation>>;
  roles: Array<ProcessModelRole>;
  rootLanguage: Scalars['String']['output'];
  rules?: Maybe<Array<ProcessRule>>;
  showDocumentLanguageSelection?: Maybe<Scalars['Boolean']['output']>;
  showTaskVisibilityConfiguration?: Maybe<Scalars['Boolean']['output']>;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
  withoutCandidates?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessModelExtensionEntityInput {
  _typeName?: Scalars['String']['input'];
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  importModel: ProcessModelDeclarationInput;
  roles: Array<ProcessModelRoleInput>;
};

export class ProcessModelForReleaseSelectionInput {
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  releaseId?: InputMaybe<Scalars['ID']['input']>;
  releaseSelectionMode?: InputMaybe<ProcessReleaseSelectionModeEnum>;
};

export class ProcessModelGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelInfo {
  __typename?: 'ProcessModelInfo';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  displayName: Array<ProcessModelString>;
  id?: Maybe<Scalars['ID']['output']>;
  modelId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class ProcessModelPublishInfo {
  __typename?: 'ProcessModelPublishInfo';
  isModelPublished?: Maybe<Scalars['Boolean']['output']>;
  isModelSelectable: Scalars['Boolean']['output'];
  isModelShared?: Maybe<Scalars['Boolean']['output']>;
  isPredefinedModel: Scalars['Boolean']['output'];
  modelId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  publishedReleases?: Maybe<Array<ProcessModelPublishInfoHistoryEntry>>;
  releasedProcessModelId?: Maybe<Scalars['ID']['output']>;
  sharedReleases?: Maybe<Array<ProcessModelPublishInfoHistoryEntry>>;
};

export class ProcessModelPublishInfoHistoryEntry {
  __typename?: 'ProcessModelPublishInfoHistoryEntry';
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  createdBy: Scalars['String']['output'];
  releasedProcessModelId: Scalars['ID']['output'];
};

export class ProcessModelPublishInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isModelSelectable: Scalars['Boolean']['input'];
  isModelShared?: InputMaybe<Scalars['Boolean']['input']>;
  isPredefinedModel: Scalars['Boolean']['input'];
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  syncOptions?: InputMaybe<ProcessSyncInputOptions>;
};

export class ProcessModelReleaseListGetInput {
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelRequiredTranslation {
  __typename?: 'ProcessModelRequiredTranslation';
  language: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  property: Scalars['String']['output'];
};

export class ProcessModelRequiredTranslationInput {
  language: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  property: Scalars['String']['input'];
};

export type ProcessModelResult = ProcessModelEntity | ProcessModelExtensionEntity;

export class ProcessModelRole {
  __typename?: 'ProcessModelRole';
  displayName: Array<ProcessModelString>;
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  presetOrganizationId?: Maybe<Scalars['ID']['output']>;
  presetRoleId?: Maybe<Scalars['ID']['output']>;
  processRole: Scalars['String']['output'];
  setCreatorOrgAsDefault?: Maybe<Scalars['Boolean']['output']>;
  visibleStates?: Maybe<Array<InstanceStateEnum>>;
};

export class ProcessModelRoleInput {
  displayName: Array<ProcessModelStringInput>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  presetOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  presetRoleId?: InputMaybe<Scalars['ID']['input']>;
  processRole: Scalars['String']['input'];
  setCreatorOrgAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  visibleStates?: InputMaybe<Array<InstanceStateEnum>>;
};

export class ProcessModelString {
  __typename?: 'ProcessModelString';
  language: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export class ProcessModelStringInput {
  language: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessModelTree {
  __typename?: 'ProcessModelTree';
  areas: Array<ProcessStageInfo>;
  model: ProcessModelInfo;
  phases: Array<ProcessStageInfo>;
  tasks: Array<ProcessStageInfo>;
  validationResult?: Maybe<ProcessModelValidationResult>;
};

export class ProcessModelTreeGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  recompile: Scalars['Boolean']['input'];
  validate: Scalars['Boolean']['input'];
};

export class ProcessModelUndoCommand {
  commandId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  validate: Scalars['Boolean']['input'];
};

export class ProcessModelUnpublishInput {
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName: Scalars['String']['input'];
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  documentLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importModel?: InputMaybe<ProcessModelDeclarationInput>;
  isSystemProcess?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  modelId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  participationConditions?: InputMaybe<Array<ParticipationConditionInput>>;
  preset?: InputMaybe<ProcessPresetInputType>;
  requiredTranslations?: InputMaybe<Array<ProcessModelRequiredTranslationInput>>;
  roles?: InputMaybe<Array<ProcessModelRoleInput>>;
  rootLanguage?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<ProcessRuleInput>>;
  showDocumentLanguageSelection?: InputMaybe<Scalars['Boolean']['input']>;
  showTaskVisibilityConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  taskVisibility?: InputMaybe<TaskVisibilityEnum>;
  withoutCandidates?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessModelUpdateReleaseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelValidationInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ProcessModelValidationMessage {
  __typename?: 'ProcessModelValidationMessage';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  severity: ProcessModelValidationSeverity;
};

export class ProcessModelValidationResult {
  __typename?: 'ProcessModelValidationResult';
  errors: Array<ProcessModelValidationMessage>;
  isValid: Scalars['Boolean']['output'];
};

export enum ProcessModelValidationSeverity {
  Error = 'Error',
  Hint = 'Hint',
  Warn = 'Warn'
}

export interface ProcessOperation {
  id: Scalars['ID']['output'];
  operationType: ProcessOperationEnum;
}

export class ProcessOperationAddToList implements ProcessOperation {
  __typename?: 'ProcessOperationAddToList';
  collection: CollectionDefinition;
  id: Scalars['ID']['output'];
  operationType: ProcessOperationEnum;
};

export class ProcessOperationCreateDelegation implements ProcessOperation {
  __typename?: 'ProcessOperationCreateDelegation';
  baseProcess: BaseProcessDefinition;
  collection: CollectionDefinition;
  delegationMappings: Array<ProcessRoleMapping>;
  displayNameTemplate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operationType: ProcessOperationEnum;
  organizationId: Scalars['ID']['output'];
  taskVisibility: Scalars['String']['output'];
};

export class ProcessOperationCreateProcess implements ProcessOperation {
  __typename?: 'ProcessOperationCreateProcess';
  collection: CollectionDefinition;
  displayNameTemplate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operationType: ProcessOperationEnum;
  organizationId: Scalars['ID']['output'];
  processModelId: Scalars['String']['output'];
  roleMappings: Array<ProcessRoleMapping>;
};

export enum ProcessOperationEnum {
  AddToList = 'AddToList',
  CreateDelegation = 'CreateDelegation',
  CreateProcess = 'CreateProcess',
  RemoveFromList = 'RemoveFromList'
}

export class ProcessOperationInput {
  baseProcess?: InputMaybe<BaseProcessDefinitionInput>;
  behaviorType?: InputMaybe<RemoveFromListBehaviorEnum>;
  collection?: InputMaybe<CollectionDefinitionInput>;
  delegationMappings?: InputMaybe<Array<ProcessRoleMappingInput>>;
  displayNameTemplate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  operationType?: InputMaybe<ProcessOperationEnum>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  processModelId?: InputMaybe<Scalars['String']['input']>;
  removeFromCollection?: InputMaybe<CollectionDefinitionInput>;
  roleMappings?: InputMaybe<Array<ProcessRoleMappingInput>>;
  sharingType?: InputMaybe<Scalars['String']['input']>;
  taskVisibility?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessOperationMapping {
  __typename?: 'ProcessOperationMapping';
  processOperationId: Scalars['ID']['output'];
  variableMappings?: Maybe<Array<ProcessOperationVariableMapping>>;
};

export class ProcessOperationMappingInput {
  processOperationId: Scalars['ID']['input'];
  variableMappings?: InputMaybe<Array<ProcessOperationVariableMappingInput>>;
};

export class ProcessOperationRemoveFromList implements ProcessOperation {
  __typename?: 'ProcessOperationRemoveFromList';
  behaviorType: RemoveFromListBehaviorEnum;
  id: Scalars['ID']['output'];
  operationType: ProcessOperationEnum;
  removeFromCollection?: Maybe<CollectionDefinition>;
  sharingType?: Maybe<Scalars['String']['output']>;
};

export type ProcessOperationResult = ProcessOperationAddToList | ProcessOperationCreateDelegation | ProcessOperationCreateProcess | ProcessOperationRemoveFromList;

export class ProcessOperationVariableMapping {
  __typename?: 'ProcessOperationVariableMapping';
  value: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export class ProcessOperationVariableMappingInput {
  value: Scalars['String']['input'];
  variable: Scalars['String']['input'];
};

export class ProcessOptionalQuillDelta {
  __typename?: 'ProcessOptionalQuillDelta';
  language: Scalars['String']['output'];
  value?: Maybe<Scalars['JSONObject']['output']>;
};

export class ProcessOptionalQuillDeltaInput {
  language: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSONObject']['input']>;
};

export class ProcessOptionalString {
  __typename?: 'ProcessOptionalString';
  language: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export class ProcessOptionalStringInput {
  language: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessPerformResult {
  __typename?: 'ProcessPerformResult';
  state: ProcessStateResult;
  task: ProcessTaskResult;
};

export class ProcessPhase {
  __typename?: 'ProcessPhase';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  processInstanceState: ProcessInstanceStateEnum;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  rootId: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessPhaseEntity {
  __typename?: 'ProcessPhaseEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  processInstanceState: ProcessInstanceStateEnum;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  rootId: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessPhaseInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceState: InstanceStateEnum;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  processInstanceState: ProcessInstanceStateEnum;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  rootId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessPhaseModel {
  __typename?: 'ProcessPhaseModel';
  _typeName: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  tasks: Array<ProcessTaskModel>;
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessPhaseModelCreateInput {
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  previousPhaseId?: InputMaybe<Scalars['String']['input']>;
  rootId: Scalars['ID']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessPhaseModelDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessPhaseModelDuplicateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessPhaseModelEntity {
  __typename?: 'ProcessPhaseModelEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  sortOrder: Scalars['Float']['output'];
  visibleForRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProcessPhaseModelEntityInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  sortOrder: Scalars['Float']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessPhaseModelGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessPhaseModelMoveInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  previousPhaseId?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessPhaseModelUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName: Array<ProcessModelStringInput>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  modelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
  sortOrder: Scalars['Float']['input'];
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProcessPlanning {
  __typename?: 'ProcessPlanning';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastUpdated: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  planningName?: Maybe<Scalars['String']['output']>;
  planningNodes: Array<ProcessPlanningNode>;
  planningTimestamp: Scalars['AnkaadiaDateTime']['output'];
  planningType?: Maybe<PlanningType>;
  processId: Scalars['ID']['output'];
  processModelId: Scalars['ID']['output'];
  releaseId?: Maybe<Scalars['ID']['output']>;
  snapshotId?: Maybe<Scalars['String']['output']>;
};

export enum ProcessPlanningDurationType {
  Avg = 'Avg'
}

export class ProcessPlanningForTaskInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  snapshotId?: InputMaybe<Scalars['String']['input']>;
  taskID: Scalars['ID']['input'];
};

export class ProcessPlanningInput {
  candidateIds?: InputMaybe<Array<CandidateIdInput>>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export class ProcessPlanningListResult {
  __typename?: 'ProcessPlanningListResult';
  plannings: Array<ProcessPlanning>;
};

export class ProcessPlanningNode {
  __typename?: 'ProcessPlanningNode';
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  currentDuration?: Maybe<Scalars['Float']['output']>;
  durationCalculationType?: Maybe<DurationCalculationType>;
  durationType: ProcessPlanningDurationType;
  earlyFinish?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  earlyStart?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  expectedDuration?: Maybe<Scalars['Float']['output']>;
  finishDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  freeBackwardSlack?: Maybe<Scalars['Float']['output']>;
  freeForwardSlack?: Maybe<Scalars['Float']['output']>;
  independentSlack?: Maybe<Scalars['Float']['output']>;
  isCritical?: Maybe<Scalars['Boolean']['output']>;
  isFinished?: Maybe<Scalars['Boolean']['output']>;
  lateFinish?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lateStart?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  modelId?: Maybe<Scalars['ID']['output']>;
  predecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  processId?: Maybe<Scalars['ID']['output']>;
  realizedDuration?: Maybe<Scalars['Float']['output']>;
  slack?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  taskId?: Maybe<Scalars['ID']['output']>;
  trafficLight?: Maybe<TrafficLightType>;
};

export class ProcessPlanningNodeInput {
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDuration?: InputMaybe<Scalars['Float']['input']>;
  durationCalculationType?: InputMaybe<DurationCalculationType>;
  durationType: ProcessPlanningDurationType;
  earlyFinish?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  earlyStart?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  expectedDuration?: InputMaybe<Scalars['Float']['input']>;
  finishDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  freeBackwardSlack?: InputMaybe<Scalars['Float']['input']>;
  freeForwardSlack?: InputMaybe<Scalars['Float']['input']>;
  independentSlack?: InputMaybe<Scalars['Float']['input']>;
  isCritical?: InputMaybe<Scalars['Boolean']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  lateFinish?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lateStart?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  processId?: InputMaybe<Scalars['ID']['input']>;
  realizedDuration?: InputMaybe<Scalars['Float']['input']>;
  slack?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  trafficLight?: InputMaybe<TrafficLightType>;
};

export type ProcessPlanningResultEvent = ProcessPlanningListResult | ProgressEvent;

export class ProcessPlanningStateInput {
  organizationId: Scalars['ID']['input'];
  planningName?: InputMaybe<Scalars['String']['input']>;
  processId: Scalars['ID']['input'];
  snapshotId?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessPlanningTask {
  __typename?: 'ProcessPlanningTask';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastUpdated: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  planningData?: Maybe<ProcessPlanningNode>;
  planningName?: Maybe<Scalars['String']['output']>;
  planningTimestamp: Scalars['AnkaadiaDateTime']['output'];
  planningType?: Maybe<PlanningType>;
  processId: Scalars['ID']['output'];
  processModelId: Scalars['ID']['output'];
  releaseId?: Maybe<Scalars['ID']['output']>;
  snapshotId?: Maybe<Scalars['String']['output']>;
};

export class ProcessPredecessorPhase {
  __typename?: 'ProcessPredecessorPhase';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tasks?: Maybe<Array<ProcessPredecessorTask>>;
};

export class ProcessPredecessorTask {
  __typename?: 'ProcessPredecessorTask';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
};

export class ProcessPreset {
  __typename?: 'ProcessPreset';
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName?: Maybe<Array<ProcessModelString>>;
  roleMapping?: Maybe<Array<RoleOrganizationUserGroupMapping>>;
  runningNumberToken?: Maybe<Scalars['String']['output']>;
};

export class ProcessPresetInput {
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  releaseId?: InputMaybe<Scalars['ID']['input']>;
  releaseSelectionMode?: InputMaybe<ProcessReleaseSelectionModeEnum>;
};

export class ProcessPresetInputType {
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  roleMapping?: InputMaybe<Array<RoleOrganizationUserGroupMappingInput>>;
  runningNumberToken?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessProgress {
  __typename?: 'ProcessProgress';
  children?: Maybe<Array<ProcessProgress>>;
  id: Scalars['ID']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  level: ProcessProgressLevelEnum;
  organizationId: Scalars['ID']['output'];
  step?: Maybe<Scalars['String']['output']>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskState?: Maybe<InstanceStateEnum>;
  taskTypeName?: Maybe<Scalars['String']['output']>;
  tasksActive: Scalars['Float']['output'];
  tasksCancelled: Scalars['Float']['output'];
  tasksDone: Scalars['Float']['output'];
  tasksError: Scalars['Float']['output'];
  tasksFinished: Scalars['Float']['output'];
  tasksInactive: Scalars['Float']['output'];
  tasksStarted: Scalars['Float']['output'];
  tasksStopped: Scalars['Float']['output'];
  tasksTotal: Scalars['Float']['output'];
};

export enum ProcessProgressLevelEnum {
  Area = 'Area',
  Phase = 'Phase',
  Process = 'Process',
  Task = 'Task'
}

export enum ProcessReleaseSelectionModeEnum {
  Latest = 'Latest',
  Published = 'Published',
  Specific = 'Specific'
}

export class ProcessReportInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId?: InputMaybe<Scalars['ID']['input']>;
};

export class ProcessReportResult {
  __typename?: 'ProcessReportResult';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export class ProcessRequiredString {
  __typename?: 'ProcessRequiredString';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class ProcessRequiredStringInput {
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProcessResultEvent = Process | ProgressEvent;

export class ProcessRole {
  __typename?: 'ProcessRole';
  displayName: Array<ProcessRequiredString>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  processRole: Scalars['String']['output'];
  visibleStates?: Maybe<Array<InstanceStateEnum>>;
};

export class ProcessRoleInput {
  displayName: Array<ProcessRequiredStringInput>;
  localizedDisplayName?: InputMaybe<Scalars['String']['input']>;
  processRole: Scalars['String']['input'];
  visibleStates?: InputMaybe<Array<InstanceStateEnum>>;
};

export class ProcessRoleMapping {
  __typename?: 'ProcessRoleMapping';
  assignedUserGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  processOrganizationId?: Maybe<Scalars['String']['output']>;
  processRole: Scalars['String']['output'];
};

export class ProcessRoleMappingInput {
  assignedUserGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  processOrganizationId?: InputMaybe<Scalars['String']['input']>;
  processRole: Scalars['String']['input'];
};

export class ProcessRule {
  __typename?: 'ProcessRule';
  event: ProcessRuleTriggerEvent;
  expression?: Maybe<Scalars['String']['output']>;
  expressionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  expressionExplanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  propertyName?: Maybe<Scalars['String']['output']>;
  ruleType: ProcessRuleType;
  runCondition?: Maybe<Scalars['String']['output']>;
  runConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  runConditionExplanation?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  targetTasks?: Maybe<RuleTaskTarget>;
  targetType: ProcessRuleTargetType;
};

export class ProcessRuleInput {
  event?: ProcessRuleTriggerEvent;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  expressionExplanation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  propertyName?: InputMaybe<Scalars['String']['input']>;
  ruleType: ProcessRuleType;
  runCondition?: InputMaybe<Scalars['String']['input']>;
  runConditionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  runConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  targetTasks?: InputMaybe<RuleTaskTargetInput>;
  targetType: ProcessRuleTargetType;
};

export enum ProcessRuleTargetType {
  Candidate = 'Candidate',
  State = 'State',
  Task = 'Task'
}

export enum ProcessRuleTaskTargetType {
  All = 'All',
  AllOfAreas = 'AllOfAreas',
  AllOfPhases = 'AllOfPhases',
  Tasks = 'Tasks'
}

export enum ProcessRuleTriggerEvent {
  OnActive = 'OnActive',
  OnCancelled = 'OnCancelled',
  OnCreate = 'OnCreate',
  OnError = 'OnError',
  OnFinished = 'OnFinished',
  OnInactive = 'OnInactive',
  OnStarted = 'OnStarted',
  OnStopped = 'OnStopped'
}

export enum ProcessRuleType {
  SetProperty = 'SetProperty'
}

export class ProcessStageInfo {
  __typename?: 'ProcessStageInfo';
  _className?: Maybe<Scalars['String']['output']>;
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayName: Array<ProcessModelString>;
  hasTaskEmails?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  responsibleRoles?: Maybe<Array<Scalars['String']['output']>>;
  rootId: Scalars['ID']['output'];
  ruleTargets?: Maybe<Array<ProcessStageRuleTarget>>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  sortOrder: Scalars['Float']['output'];
  targetObject?: Maybe<ProcessTargetEnum>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmailConditionExplanations?: Maybe<Array<Scalars['String']['output']>>;
};

export interface ProcessStageModelEntity {
  _etag?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  sortOrder: Scalars['Float']['output'];
}

export class ProcessStageRuleTarget {
  __typename?: 'ProcessStageRuleTarget';
  expressionExplanation?: Maybe<Scalars['String']['output']>;
  runConditionExplanation?: Maybe<Scalars['String']['output']>;
  targetTasks?: Maybe<RuleTaskTarget>;
  targetType: ProcessRuleTargetType;
};

export interface ProcessState {
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
}

export class ProcessStateAssignmentException implements ProcessState {
  __typename?: 'ProcessStateAssignmentException';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateAutoOperation implements ProcessState {
  __typename?: 'ProcessStateAutoOperation';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateDeactivateProcess implements ProcessState {
  __typename?: 'ProcessStateDeactivateProcess';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateDocumentCheck implements ProcessState {
  __typename?: 'ProcessStateDocumentCheck';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  documentReviewResults?: Maybe<Array<ReviewDocumentResult>>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  reviewDoneByReviewers?: Maybe<Array<ReviewerVotum>>;
  reviewFinished: Scalars['Boolean']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateEducationAssignToExam implements ProcessState {
  __typename?: 'ProcessStateEducationAssignToExam';
  _etag?: Maybe<Scalars['String']['output']>;
  assignmentAlreadyExisting?: Maybe<Scalars['Boolean']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  examId?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  examType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateEducationEnterExamResult implements ProcessState {
  __typename?: 'ProcessStateEducationEnterExamResult';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  examId?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  isFinalResult?: Maybe<Scalars['Boolean']['output']>;
  languageExamResult?: Maybe<LanguageExamResult>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateEmailSend implements ProcessState {
  __typename?: 'ProcessStateEmailSend';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateLanguage?: Maybe<Scalars['String']['output']>;
};

export class ProcessStateEnterMissingInformation implements ProcessState {
  __typename?: 'ProcessStateEnterMissingInformation';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  requiredInformation?: Maybe<Scalars['JSONObject']['output']>;
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateEnterMissingInformationV2 implements ProcessState {
  __typename?: 'ProcessStateEnterMissingInformationV2';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  childEntityData?: Maybe<Scalars['JSONObject']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  data?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inaccessibleProperties?: Maybe<Array<Scalars['String']['output']>>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateInformationCollection implements ProcessState {
  __typename?: 'ProcessStateInformationCollection';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  data?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  prefillTaskId?: Maybe<Scalars['ID']['output']>;
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateInformationSendOut implements ProcessState {
  __typename?: 'ProcessStateInformationSendOut';
  _etag?: Maybe<Scalars['String']['output']>;
  agreed?: Maybe<Scalars['Boolean']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  date?: Maybe<Scalars['UTCDate']['output']>;
  downloadableFiles?: Maybe<Array<DownloadableFile>>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  received?: Maybe<Scalars['Boolean']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateInterviewWrite implements ProcessState {
  __typename?: 'ProcessStateInterviewWrite';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  feedbackIntervieweeTaskId: Scalars['String']['output'];
  feedbackInterviewerTaskId: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  interviewDateTaskId: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateInviteToPlatform implements ProcessState {
  __typename?: 'ProcessStateInviteToPlatform';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  gdprConsent?: Maybe<Scalars['Boolean']['output']>;
  gdprConsentDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateOnlineApplication implements ProcessState {
  __typename?: 'ProcessStateOnlineApplication';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  credentialsId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  state?: Maybe<OnlineApplicationState>;
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  twoFactorRequired?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateOrganizationAudit implements ProcessState {
  __typename?: 'ProcessStateOrganizationAudit';
  _etag?: Maybe<Scalars['String']['output']>;
  auditMode: AuditTaskModeEnum;
  auditRemarksAdditionalClaim?: Maybe<Scalars['String']['output']>;
  auditRemarksAuditor?: Maybe<Scalars['String']['output']>;
  auditRemarksBoard?: Maybe<Scalars['String']['output']>;
  auditRemarksConfidant?: Maybe<Scalars['String']['output']>;
  auditVotumBoard?: Maybe<OrganizationAuditAdditionRequestResult>;
  auditorFiles?: Maybe<Array<AuditFile>>;
  awardDate?: Maybe<Scalars['UTCDate']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  expiryDate?: Maybe<Scalars['UTCDate']['output']>;
  finalFinalVotum?: Maybe<OrganizationAuditAdditionRequestResult>;
  finalVotum?: Maybe<OrganizationAuditResult>;
  finalVotumDescription?: Maybe<Scalars['String']['output']>;
  finalVotumExpiryDate?: Maybe<Scalars['UTCDate']['output']>;
  finalVotumReply?: Maybe<Scalars['String']['output']>;
  finalVotumReplyFiles?: Maybe<Array<AuditFile>>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  interviewNotes?: Maybe<Scalars['String']['output']>;
  interviewSamples?: Maybe<OrganizationAuditInterviewSamples>;
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationAuditData?: Maybe<Array<OrganizationAuditData>>;
  organizationId: Scalars['ID']['output'];
  processAuditGroupName: Scalars['String']['output'];
  processDeadlineDate?: Maybe<Scalars['UTCDate']['output']>;
  rootId: Scalars['ID']['output'];
  spotCheck?: Maybe<Scalars['String']['output']>;
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStatePdfFormGeneration implements ProcessState {
  __typename?: 'ProcessStatePdfFormGeneration';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  forms?: Maybe<Array<PdfFormGenerationState>>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
  tokens?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ProcessStatePrecissionEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER'
}

export class ProcessStateReminder implements ProcessState {
  __typename?: 'ProcessStateReminder';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  dueDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  snoozed?: Maybe<Scalars['Boolean']['output']>;
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessStateResult = ProcessStateAssignmentException | ProcessStateAutoOperation | ProcessStateDeactivateProcess | ProcessStateDocumentCheck | ProcessStateEducationAssignToExam | ProcessStateEducationEnterExamResult | ProcessStateEmailSend | ProcessStateEnterMissingInformation | ProcessStateEnterMissingInformationV2 | ProcessStateInformationCollection | ProcessStateInformationSendOut | ProcessStateInterviewWrite | ProcessStateInviteToPlatform | ProcessStateOnlineApplication | ProcessStateOrganizationAudit | ProcessStatePdfFormGeneration | ProcessStateReminder | ProcessStateRoleSetup | ProcessStateSigning | ProcessStateTranslateDocuments | ProcessStateUpdateCandidateProfile | ProcessStateUpload | ProcessStateUploadAvatar | ProcessStateWork;

export class ProcessStateRoleSetup implements ProcessState {
  __typename?: 'ProcessStateRoleSetup';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMapping>;
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateSigning implements ProcessState {
  __typename?: 'ProcessStateSigning';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isAllSigned?: Maybe<Scalars['Boolean']['output']>;
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  submissions?: Maybe<Array<SigningSubmissionRecord>>;
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateTranslateDocuments implements ProcessState {
  __typename?: 'ProcessStateTranslateDocuments';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  documentTranslationState?: Maybe<DocumentTranslationState>;
  documentTranslationStateId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  mode: DocumentTranslationMode;
  organizationId: Scalars['ID']['output'];
  provider: DocumentTranslationProvider;
  requiredDocuments?: Maybe<Array<TranslationRequirementDocument>>;
  rootId: Scalars['ID']['output'];
  targetLanguage: Scalars['String']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProcessStateTranslateDocumentsOrderState {
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Error = 'Error',
  Finished = 'Finished',
  Init = 'Init',
  Processing = 'Processing',
  Setup = 'Setup'
}

export class ProcessStateUpdateCandidateProfile implements ProcessState {
  __typename?: 'ProcessStateUpdateCandidateProfile';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  agreed?: InputMaybe<Scalars['Boolean']['input']>;
  allFilesSent?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentAlreadyExisting?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  auditRemarksAdditionalClaim?: InputMaybe<Scalars['String']['input']>;
  auditRemarksAuditor?: InputMaybe<Scalars['String']['input']>;
  auditRemarksBoard?: InputMaybe<Scalars['String']['input']>;
  auditRemarksConfidant?: InputMaybe<Scalars['String']['input']>;
  auditVotumBoard?: InputMaybe<OrganizationAuditAdditionRequestResult>;
  auditorFiles?: InputMaybe<Array<AuditFileInput>>;
  awardDate?: InputMaybe<Scalars['UTCDate']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  childEntityData?: InputMaybe<Scalars['JSONObject']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  commentedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  commentedById?: InputMaybe<Scalars['ID']['input']>;
  commentedByName?: InputMaybe<Scalars['String']['input']>;
  commentedByOrgId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  credentialsId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  date?: InputMaybe<Scalars['UTCDate']['input']>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  documentReviewResults?: InputMaybe<Array<ReviewDocumentResultInput>>;
  documentTranslationStateId?: InputMaybe<Scalars['ID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  dueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  equivalentDocumentFormats?: InputMaybe<Scalars['JSONObject']['input']>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examName?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  examType?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  finalFinalVotum?: InputMaybe<OrganizationAuditAdditionRequestResult>;
  finalVotum?: InputMaybe<OrganizationAuditResult>;
  finalVotumDescription?: InputMaybe<Scalars['String']['input']>;
  finalVotumExpiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  finalVotumReply?: InputMaybe<Scalars['String']['input']>;
  finalVotumReplyFiles?: InputMaybe<Array<AuditFileInput>>;
  forms?: InputMaybe<Array<PdfFormGenerationStateInput>>;
  gdprConsent?: InputMaybe<Scalars['Boolean']['input']>;
  gdprConsentDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inaccessibleProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  interviewNotes?: InputMaybe<Scalars['String']['input']>;
  interviewSamples?: InputMaybe<OrganizationAuditInterviewSamplesInput>;
  isAllSigned?: InputMaybe<Scalars['Boolean']['input']>;
  isAlternativePictureUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  isCommentByCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalResult?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiEdit?: InputMaybe<Scalars['Boolean']['input']>;
  isPictureUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  languageExamResult?: InputMaybe<LanguageExamResultInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  organizationAuditData?: InputMaybe<Array<OrganizationAuditDataInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineDate?: InputMaybe<Scalars['UTCDate']['input']>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  received?: InputMaybe<Scalars['Boolean']['input']>;
  reply?: InputMaybe<Scalars['String']['input']>;
  requiredDocuments?: InputMaybe<Array<TranslationRequirementDocumentInput>>;
  requiredInformation?: InputMaybe<Scalars['JSONObject']['input']>;
  reviewDoneByReviewers?: InputMaybe<Array<ReviewerVotumInput>>;
  reviewFinished?: InputMaybe<Scalars['Boolean']['input']>;
  roleOrganisationUsergroupMapping?: InputMaybe<Array<RoleOrganizationUserGroupMappingInput>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  selectedChildTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  showMarkedAsCompletedFlagAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  snoozed?: InputMaybe<Scalars['Boolean']['input']>;
  spotCheck?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OnlineApplicationStateInput>;
  submissions?: InputMaybe<Array<SigningSubmissionRecordInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  taskCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  taskFinished?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  twoFactorRequired?: InputMaybe<Scalars['Boolean']['input']>;
  typeName: Scalars['String']['input'];
  uploadedFileTypes?: InputMaybe<Array<UploadedDocumentTypeInput>>;
  uploadedProcessDocuments?: InputMaybe<Array<UploadedProcessDocumentInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userOrganizationId?: InputMaybe<Scalars['String']['input']>;
};

export class ProcessStateUpload implements ProcessState {
  __typename?: 'ProcessStateUpload';
  _etag?: Maybe<Scalars['String']['output']>;
  allFilesSent?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<FileAttachment>>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  downloadableFiles?: Maybe<Array<DownloadableFile>>;
  equivalentDocumentFormats?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  showMarkedAsCompletedFlagAtDocuments?: Maybe<Scalars['Boolean']['output']>;
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
  uploadedFileTypes?: Maybe<Array<UploadedDocumentType>>;
  uploadedProcessDocuments?: Maybe<Array<UploadedProcessDocument>>;
};

export class ProcessStateUploadAvatar implements ProcessState {
  __typename?: 'ProcessStateUploadAvatar';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isAlternativePictureUploaded?: Maybe<Scalars['Boolean']['output']>;
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  isPictureUploaded?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStateWork implements ProcessState {
  __typename?: 'ProcessStateWork';
  _etag?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  commentedById?: Maybe<Scalars['ID']['output']>;
  commentedByName?: Maybe<Scalars['String']['output']>;
  commentedByOrgId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  done?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceId: Scalars['ID']['output'];
  instanceType: Scalars['String']['output'];
  isCommentByCandidate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  rootId: Scalars['ID']['output'];
  taskCanceled?: Maybe<Scalars['Boolean']['output']>;
  taskFinished?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessStatusCandidateData {
  __typename?: 'ProcessStatusCandidateData';
  estimatedArrivalDate?: Maybe<Scalars['UTCDate']['output']>;
  estimatedWorkStartDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class ProcessStatusCandidateDataInput {
  estimatedArrivalDate?: InputMaybe<Scalars['UTCDate']['input']>;
  estimatedWorkStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class ProcessSyncAllInput {
  organizationId: Scalars['ID']['input'];
  processModelId?: InputMaybe<Scalars['ID']['input']>;
};

export class ProcessSyncInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessSyncInputOptions {
  deleteAllTasksWhichAreNoLongerInModel?: InputMaybe<Scalars['Boolean']['input']>;
  doNotStartNewTasksWhoseSuccessorsAreAlreadyFinished?: InputMaybe<Scalars['Boolean']['input']>;
  finishAllTasksWhoseSuccessorsAreAlreadyFinished?: InputMaybe<Scalars['Boolean']['input']>;
  recalculateTaskState?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProcessTargetEnum {
  Candidate = 'Candidate',
  Collection = 'Collection',
  FamiliyMember = 'FamiliyMember'
}

export interface ProcessTask {
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
}

export class ProcessTaskActivationInfo {
  __typename?: 'ProcessTaskActivationInfo';
  activationCondition?: Maybe<ActivationConditionActivationInfo>;
  atLeastOnePredecessors?: Maybe<Array<PredecessorActivationInfo>>;
  autoStartPossible?: Maybe<AutoStartPossibleActivationInfo>;
  delayStart?: Maybe<DelayStartActivationInfo>;
  id: Scalars['ID']['output'];
  predecessors?: Maybe<Array<PredecessorActivationInfo>>;
};

export class ProcessTaskAndState {
  __typename?: 'ProcessTaskAndState';
  state?: Maybe<ProcessStateResult>;
  task: ProcessTaskResult;
};

export class ProcessTaskAssignmentException implements ProcessTask {
  __typename?: 'ProcessTaskAssignmentException';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  assignmentExceptionOperation?: Maybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType: CandidateAssignmentExceptionType;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskAssignmentExceptionModel {
  __typename?: 'ProcessTaskAssignmentExceptionModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  assignmentExceptionOperation: CandidateAssignmentExceptionOperation;
  assignmentExceptionType?: Maybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskAssignmentExceptionModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskAssignmentExceptionModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  assignmentExceptionOperation: CandidateAssignmentExceptionOperation;
  assignmentExceptionType?: Maybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskAutoOperation implements ProcessTask {
  __typename?: 'ProcessTaskAutoOperation';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoProcessToken: Scalars['String']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskAutoOperationModel {
  __typename?: 'ProcessTaskAutoOperationModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoProcessToken: Scalars['String']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskAutoOperationModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskAutoOperationModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoProcessToken: Scalars['String']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskBulkEditIdentifierInput {
  organizationId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export class ProcessTaskBulkEditInput {
  field: ProcessTaskEditableField;
  taskIds: Array<ProcessTaskBulkEditIdentifierInput>;
  value: ProcessTaskBulkEditValueInput;
};

export enum ProcessTaskBulkEditRoleOperation {
  Add = 'Add',
  Remove = 'Remove',
  Replace = 'Replace'
}

export class ProcessTaskBulkEditValueInput {
  delay?: InputMaybe<TaskDelayCreateInput>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  roleOperation?: InputMaybe<ProcessTaskBulkEditRoleOperation>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetUserGroupConfig?: InputMaybe<UserGroupConfigurationInput>;
};

export class ProcessTaskCopyDataInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class ProcessTaskCreateInput {
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentError?: InputMaybe<Scalars['String']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessOptionalStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  avgPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  cancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateDocuments?: InputMaybe<Array<CandidateDocTypeAttachmentInput>>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<TaskDelayInput>;
  delayHistory?: InputMaybe<Array<TaskDelayInput>>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  delegations?: InputMaybe<Array<TaskDelegationInput>>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayAttachmentError?: InputMaybe<Scalars['Boolean']['input']>;
  displayAttachmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayMissingOrganizationDocument?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<ProcessDocumentRequirementInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadableAttachmentsLink?: InputMaybe<Scalars['String']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  fieldsToExcludeFromSync?: InputMaybe<Array<Scalars['String']['input']>>;
  finishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<Scalars['String']['input']>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationFieldsInput>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lastUpdateManualStarted?: InputMaybe<Scalars['Boolean']['input']>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  maxFileSize?: InputMaybe<Scalars['Float']['input']>;
  maxFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  maxPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  maxUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  milestoneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minDuration?: InputMaybe<Scalars['Float']['input']>;
  minFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  minPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  minUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  missingOrganizationDocument?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Float']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Float']['input']>;
  organizationDocuments?: InputMaybe<Array<DocTypeAttachmentInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pertPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  previousAttempts?: InputMaybe<Array<Scalars['String']['input']>>;
  previousTaskId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Float']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<ProcessDocumentToUploadTypeInput>>;
  processInstanceState?: InputMaybe<ProcessInstanceStateEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivatedByTask?: InputMaybe<Scalars['ID']['input']>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  ruleExecutionError?: InputMaybe<RuleExecutionErrorInput>;
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRolesChangedBy?: InputMaybe<Scalars['String']['input']>;
  taskDisplayId?: InputMaybe<Scalars['String']['input']>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName: Scalars['String']['input'];
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessTaskDeactivateProcess implements ProcessTask {
  __typename?: 'ProcessTaskDeactivateProcess';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskDeactivateProcessModel {
  __typename?: 'ProcessTaskDeactivateProcessModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskDeactivateProcessModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskDeactivateProcessModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskDelayUpdateInput {
  _etag: Scalars['String']['input'];
  delay?: InputMaybe<TaskDelayReportInput>;
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['ID']['input'];
};

export class ProcessTaskDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
};

export class ProcessTaskDocumentCheck implements ProcessTask {
  __typename?: 'ProcessTaskDocumentCheck';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentCheckType: DocumentDeliveryFormat;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  lockDocumentsAfterReviewForIds?: Maybe<Array<Scalars['String']['output']>>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  numberOfReviewers: Scalars['Float']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  referenceTaskUploadIds: Array<Scalars['String']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskDocumentCheckModel {
  __typename?: 'ProcessTaskDocumentCheckModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentCheckType: DocumentDeliveryFormat;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lockDocumentsAfterReviewForIds?: Maybe<Array<Scalars['String']['output']>>;
  modelId: Scalars['ID']['output'];
  numberOfReviewers: Scalars['Int']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  referenceTaskUploadModelIds: Array<Scalars['String']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskDocumentCheckModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskDocumentCheckModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentCheckType: DocumentDeliveryFormat;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lockDocumentsAfterReviewForIds?: Maybe<Array<Scalars['String']['output']>>;
  modelId: Scalars['ID']['output'];
  numberOfReviewers: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  referenceTaskUploadModelIds: Array<Scalars['String']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export enum ProcessTaskEditableField {
  DueDate = 'DueDate',
  InstanceState = 'InstanceState',
  IsFavorite = 'IsFavorite',
  Priority = 'Priority',
  ResponsibleRoles = 'ResponsibleRoles',
  SortingCriteria = 'SortingCriteria',
  TargetRoles = 'TargetRoles'
}

export class ProcessTaskEducationAssignToExam implements ProcessTask {
  __typename?: 'ProcessTaskEducationAssignToExam';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  examId?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationFields>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEducationAssignToExamModel {
  __typename?: 'ProcessTaskEducationAssignToExamModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  examId?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationModelFields>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEducationAssignToExamModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskEducationAssignToExamModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  examId?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationModelFields>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEducationEnterExamResult implements ProcessTask {
  __typename?: 'ProcessTaskEducationEnterExamResult';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  doNotReassignAssignOnExamFailed?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  examId?: Maybe<Scalars['String']['output']>;
  examOrganizationId?: Maybe<Scalars['String']['output']>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationFields>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  maximumAttempts?: Maybe<Scalars['Float']['output']>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousAttempts?: Maybe<Array<Scalars['String']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEducationEnterExamResultModel {
  __typename?: 'ProcessTaskEducationEnterExamResultModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  doNotReassignAssignOnExamFailed?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationModelFields>;
  maximumAttempts?: Maybe<Scalars['Float']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEducationEnterExamResultModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskEducationEnterExamResultModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  doNotReassignAssignOnExamFailed?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  educationModuleType: EducationModuleType;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  languageEducationFields?: Maybe<LanguageEducationModelFields>;
  maximumAttempts?: Maybe<Scalars['Float']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEmailSend implements ProcessTask {
  __typename?: 'ProcessTaskEmailSend';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  recipientRoles?: Maybe<Array<Scalars['String']['output']>>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateLanguage?: Maybe<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEmailSendModel {
  __typename?: 'ProcessTaskEmailSendModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  recipientRoles?: Maybe<Array<Scalars['String']['output']>>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateLanguage?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEmailSendModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskEmailSendModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  recipientRoles?: Maybe<Array<Scalars['String']['output']>>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateLanguage?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformation implements ProcessTask {
  __typename?: 'ProcessTaskEnterMissingInformation';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiredInformation: Array<EnterMissingInformation>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformationModel {
  __typename?: 'ProcessTaskEnterMissingInformationModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiredInformation: Array<EnterMissingInformation>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformationModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskEnterMissingInformationModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiredInformation: Array<EnterMissingInformation>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformationV2 implements ProcessTask {
  __typename?: 'ProcessTaskEnterMissingInformationV2';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requestedInformation?: Maybe<Array<EnterMissingInformationRequestedInformation>>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformationV2Model {
  __typename?: 'ProcessTaskEnterMissingInformationV2Model';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requestedInformation?: Maybe<Array<EnterMissingInformationRequestedInformation>>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskEnterMissingInformationV2ModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskEnterMissingInformationV2ModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requestedInformation?: Maybe<Array<EnterMissingInformationRequestedInformation>>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  skipOnAlreadyEntered?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationCollection implements ProcessTask {
  __typename?: 'ProcessTaskInformationCollection';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  confirmationMode?: Maybe<Scalars['Boolean']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  formToken: Scalars['String']['output'];
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  initialModel?: Maybe<Scalars['JSONObject']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  prefillTaskId?: Maybe<Scalars['ID']['output']>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationCollectionModel {
  __typename?: 'ProcessTaskInformationCollectionModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  confirmationMode?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  formToken: KnownFormToken;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  initialModel?: Maybe<Scalars['JSONObject']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  prefillTaskId?: Maybe<Scalars['String']['output']>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationCollectionModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskInformationCollectionModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  confirmationMode?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  formToken: KnownFormToken;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  initialModel?: Maybe<Scalars['JSONObject']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  prefillTaskId?: Maybe<Scalars['String']['output']>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationSendOut implements ProcessTask {
  __typename?: 'ProcessTaskInformationSendOut';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentError?: Maybe<Scalars['String']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTaskIds?: Maybe<Array<Scalars['ID']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachments?: Maybe<Array<FileAttachment>>;
  attachmentsRequired?: Maybe<Scalars['Boolean']['output']>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateDocuments?: Maybe<Array<CandidateDocTypeAttachment>>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  consentType?: Maybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayAttachmentError?: Maybe<Scalars['Boolean']['output']>;
  displayAttachmentInfo?: Maybe<Scalars['Boolean']['output']>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayMissingOrganizationDocument?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  downloadableAttachmentsLink?: Maybe<Scalars['String']['output']>;
  downloadableFiles?: Maybe<Array<DownloadableFile>>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  missingOrganizationDocument?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['ID']['output'];
  organizationDocuments?: Maybe<Array<DocTypeAttachment>>;
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  replyType: ReplyTypeEnum;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationSendOutModel {
  __typename?: 'ProcessTaskInformationSendOutModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTasks?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachmentsRequired: Scalars['Boolean']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  consentType?: Maybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationDocuments?: Maybe<Array<OrganizationDocumentModel>>;
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  replyType: ReplyTypeEnum;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInformationSendOutModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskInformationSendOutModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTasks?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachmentsRequired: Scalars['Boolean']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  consentType?: Maybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationDocuments?: Maybe<Array<OrganizationDocumentModel>>;
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  replyType: ReplyTypeEnum;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInterviewWrite implements ProcessTask {
  __typename?: 'ProcessTaskInterviewWrite';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  feedbackIntervieweeTaskId: Scalars['String']['output'];
  feedbackInterviewerTaskId: Scalars['String']['output'];
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  interviewDateTaskId: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
  writeToLicenseOwnerData?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskInterviewWriteModel {
  __typename?: 'ProcessTaskInterviewWriteModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  feedbackIntervieweeTaskId: Scalars['String']['output'];
  feedbackInterviewerTaskId: Scalars['String']['output'];
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  interviewDateTaskId: Scalars['String']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
  writeToLicenseOwnerData?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskInterviewWriteModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskInterviewWriteModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  feedbackIntervieweeTaskId: Scalars['String']['output'];
  feedbackInterviewerTaskId: Scalars['String']['output'];
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interviewDateTaskId: Scalars['String']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
  writeToLicenseOwnerData?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskInviteToPlatform implements ProcessTask {
  __typename?: 'ProcessTaskInviteToPlatform';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInviteToPlatformModel {
  __typename?: 'ProcessTaskInviteToPlatformModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskInviteToPlatformModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskInviteToPlatformModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskListInput {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class ProcessTaskListReportInput {
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ProcessTaskModel = ProcessTaskAssignmentExceptionModel | ProcessTaskAutoOperationModel | ProcessTaskDeactivateProcessModel | ProcessTaskDocumentCheckModel | ProcessTaskEducationAssignToExamModel | ProcessTaskEducationEnterExamResultModel | ProcessTaskEmailSendModel | ProcessTaskEnterMissingInformationModel | ProcessTaskEnterMissingInformationV2Model | ProcessTaskInformationCollectionModel | ProcessTaskInformationSendOutModel | ProcessTaskInterviewWriteModel | ProcessTaskInviteToPlatformModel | ProcessTaskOnlineApplicationModel | ProcessTaskOrganizationAuditModel | ProcessTaskPdfFormGenerationModel | ProcessTaskReminderModel | ProcessTaskRoleSetupModel | ProcessTaskSigningModel | ProcessTaskTranslateDocumentsModel | ProcessTaskTriggerEventModel | ProcessTaskUpdateCandidateProfileModel | ProcessTaskUploadAvatarModel | ProcessTaskUploadModel | ProcessTaskWorkModel;

export class ProcessTaskModelCommandInputType {
  command: ProcessModelCommandEnum;
  createAreaData?: InputMaybe<ProcessAreaModelCreateInput>;
  createPhaseData?: InputMaybe<ProcessPhaseModelCreateInput>;
  createTaskData?: InputMaybe<ProcessTaskModelCreateInput>;
  deleteAreaData?: InputMaybe<ProcessAreaModelDeleteInput>;
  deletePhaseData?: InputMaybe<ProcessPhaseModelDeleteInput>;
  deleteTaskData?: InputMaybe<ProcessTaskModelDeleteInput>;
  duplicateAreaData?: InputMaybe<ProcessAreaModelDuplicateInput>;
  duplicatePhaseData?: InputMaybe<ProcessPhaseModelDuplicateInput>;
  duplicateTaskData?: InputMaybe<ProcessTaskModelDuplicateInput>;
  entityEtag?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  moveAreaData?: InputMaybe<ProcessAreaModelMoveInput>;
  movePhaseData?: InputMaybe<ProcessPhaseModelMoveInput>;
  moveTaskData?: InputMaybe<ProcessTaskModelMoveInput>;
  organizationId: Scalars['ID']['input'];
  rootId: Scalars['String']['input'];
  updateAreaData?: InputMaybe<ProcessAreaModelUpdateInput>;
  updatePhaseData?: InputMaybe<ProcessPhaseModelUpdateInput>;
  updateTaskData?: InputMaybe<ProcessTaskModelUpdateInput>;
};

export class ProcessTaskModelCreateInput {
  _className?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessModelStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditDefinitionName23?: InputMaybe<Scalars['String']['input']>;
  auditDefinitionName24?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeModelInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  cancelLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  candidateDocuments?: InputMaybe<Array<CandidateDocumentModelInput>>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<DocumentRequirementModelInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  dontSendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  dummyForGraphQL?: InputMaybe<Scalars['String']['input']>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  finishLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<KnownFormToken>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationModelFieldsInput>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  maxFileSize?: InputMaybe<Scalars['Int']['input']>;
  maxUploadedDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  minDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  minUploadedDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Int']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Int']['input']>;
  organizationDocuments?: InputMaybe<Array<OrganizationDocumentModelInput>>;
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['String']['input']>;
  previousTaskId?: InputMaybe<Scalars['String']['input']>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<DocumentProcessUploadTypeInput>>;
  processEvent?: InputMaybe<ProcessEventEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['String']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['String']['input']>>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadModelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  rootId: Scalars['ID']['input'];
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessTaskModelDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessTaskModelDuplicateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export interface ProcessTaskModelEntity {
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
}

export class ProcessTaskModelGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProcessTaskModelMoveInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  previousTaskId?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessTaskModelResult = ProcessTaskAssignmentExceptionModelEntity | ProcessTaskAutoOperationModelEntity | ProcessTaskDeactivateProcessModelEntity | ProcessTaskDocumentCheckModelEntity | ProcessTaskEducationAssignToExamModelEntity | ProcessTaskEducationEnterExamResultModelEntity | ProcessTaskEmailSendModelEntity | ProcessTaskEnterMissingInformationModelEntity | ProcessTaskEnterMissingInformationV2ModelEntity | ProcessTaskInformationCollectionModelEntity | ProcessTaskInformationSendOutModelEntity | ProcessTaskInterviewWriteModelEntity | ProcessTaskInviteToPlatformModelEntity | ProcessTaskOnlineApplicationModelEntity | ProcessTaskOrganizationAuditModelEntity | ProcessTaskPdfFormGenerationModelEntity | ProcessTaskReminderModelEntity | ProcessTaskRoleSetupModelEntity | ProcessTaskSigningModelEntity | ProcessTaskTranslateDocumentsModelEntity | ProcessTaskTriggerEventModelEntity | ProcessTaskUpdateCandidateProfileModelEntity | ProcessTaskUploadAvatarModelEntity | ProcessTaskUploadModelEntity | ProcessTaskWorkModelEntity;

export class ProcessTaskModelUpdateInput {
  _className?: InputMaybe<Scalars['String']['input']>;
  _etag?: InputMaybe<Scalars['String']['input']>;
  _typeName?: Scalars['String']['input'];
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessModelStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditDefinitionName23?: InputMaybe<Scalars['String']['input']>;
  auditDefinitionName24?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeModelInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  cancelLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  candidateDocuments?: InputMaybe<Array<CandidateDocumentModelInput>>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayDescription?: InputMaybe<Array<ProcessModelStringInput>>;
  displayName?: InputMaybe<Array<ProcessModelStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<DocumentRequirementModelInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  dontSendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  dummyForGraphQL?: InputMaybe<Scalars['String']['input']>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  finishLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<KnownFormToken>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationModelFieldsInput>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  maxFileSize?: InputMaybe<Scalars['Int']['input']>;
  maxUploadedDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  minDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  minUploadedDocumentsRequired?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Int']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Int']['input']>;
  organizationDocuments?: InputMaybe<Array<OrganizationDocumentModelInput>>;
  organizationId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['String']['input']>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<DocumentProcessUploadTypeInput>>;
  processEvent?: InputMaybe<ProcessEventEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['String']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['String']['input']>>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessModelStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadModelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  rootId: Scalars['ID']['input'];
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder: Scalars['Float']['input'];
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessTaskModelUsage {
  __typename?: 'ProcessTaskModelUsage';
  processDisplayName: Array<ProcessModelString>;
  processModelId: Scalars['String']['output'];
  storedProcessModelId?: Maybe<Scalars['ID']['output']>;
  taskDisplayName: Array<ProcessModelString>;
  taskModelId: Scalars['String']['output'];
};

export class ProcessTaskOnlineApplication implements ProcessTask {
  __typename?: 'ProcessTaskOnlineApplication';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  token: Scalars['String']['output'];
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskOnlineApplicationModel {
  __typename?: 'ProcessTaskOnlineApplicationModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  token: Scalars['String']['output'];
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskOnlineApplicationModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskOnlineApplicationModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  token: Scalars['String']['output'];
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskOrganizationAudit implements ProcessTask {
  __typename?: 'ProcessTaskOrganizationAudit';
  _etag?: Maybe<Scalars['String']['output']>;
  acceptFileTypes: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  applicantUser?: Maybe<User>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  auditDefinition?: Maybe<AuditDefinition>;
  auditDefinitionName: Scalars['String']['output'];
  auditMode: AuditTaskModeEnum;
  auditorUser?: Maybe<User>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxFileSize: Scalars['Float']['output'];
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processAuditGroupName: Scalars['String']['output'];
  processDeadlineInDays?: Maybe<Scalars['Float']['output']>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  recruitingConcept?: Maybe<Scalars['JSON']['output']>;
  recruitingConceptTaskId?: Maybe<Scalars['String']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskOrganizationAuditModel {
  __typename?: 'ProcessTaskOrganizationAuditModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  acceptFileTypes?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  auditDefinitionName: Scalars['String']['output'];
  auditDefinitionName23: Scalars['String']['output'];
  auditDefinitionName24: Scalars['String']['output'];
  auditMode: AuditTaskModeEnum;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processAuditGroupName: Scalars['String']['output'];
  processDeadlineInDays?: Maybe<Scalars['Int']['output']>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  recruitingConceptTaskId: Scalars['String']['output'];
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskOrganizationAuditModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskOrganizationAuditModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  acceptFileTypes?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  auditDefinitionName: Scalars['String']['output'];
  auditDefinitionName23: Scalars['String']['output'];
  auditDefinitionName24: Scalars['String']['output'];
  auditMode: AuditTaskModeEnum;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processAuditGroupName: Scalars['String']['output'];
  processDeadlineInDays?: Maybe<Scalars['Int']['output']>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  recruitingConceptTaskId: Scalars['String']['output'];
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskPdfFormGeneration implements ProcessTask {
  __typename?: 'ProcessTaskPdfFormGeneration';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  tokens: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskPdfFormGenerationModel {
  __typename?: 'ProcessTaskPdfFormGenerationModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  tokens: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskPdfFormGenerationModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskPdfFormGenerationModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  tokens: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskPreview {
  __typename?: 'ProcessTaskPreview';
  isTypeSpecificPartSupported: Scalars['Boolean']['output'];
  process: Process;
  state?: Maybe<ProcessStateResult>;
  task: ProcessTaskResult;
};

export class ProcessTaskPreviewInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  processModelId: Scalars['String']['input'];
  taskModel: ProcessTaskModelUpdateInput;
};

export class ProcessTaskReminder implements ProcessTask {
  __typename?: 'ProcessTaskReminder';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderDate?: Maybe<Scalars['UTCDate']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskReminderModel {
  __typename?: 'ProcessTaskReminderModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderDate?: Maybe<Scalars['UTCDate']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskReminderModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskReminderModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderDate?: Maybe<Scalars['UTCDate']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskResetInput {
  candidates?: InputMaybe<Array<CandidateIdInput>>;
  includeFinishedTasks: Scalars['Boolean']['input'];
  isProcessReset?: InputMaybe<Scalars['Boolean']['input']>;
  mode: ProcessTaskResetMode;
  organizationId: Scalars['String']['input'];
  rootId: Scalars['String']['input'];
  suppressEmails: Scalars['Boolean']['input'];
  taskIds: Array<Scalars['String']['input']>;
};

export enum ProcessTaskResetMode {
  Hard = 'Hard',
  Soft = 'Soft'
}

export class ProcessTaskResetResult {
  __typename?: 'ProcessTaskResetResult';
  resetTaskIds: Array<Scalars['String']['output']>;
  skippedTaskIds: Array<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ProcessTaskResetResultEvent = ProcessTaskResetResult | ProgressEvent;

export type ProcessTaskResult = ProcessTaskAssignmentException | ProcessTaskAutoOperation | ProcessTaskDeactivateProcess | ProcessTaskDocumentCheck | ProcessTaskEducationAssignToExam | ProcessTaskEducationEnterExamResult | ProcessTaskEmailSend | ProcessTaskEnterMissingInformation | ProcessTaskEnterMissingInformationV2 | ProcessTaskInformationCollection | ProcessTaskInformationSendOut | ProcessTaskInterviewWrite | ProcessTaskInviteToPlatform | ProcessTaskOnlineApplication | ProcessTaskOrganizationAudit | ProcessTaskPdfFormGeneration | ProcessTaskReminder | ProcessTaskRoleSetup | ProcessTaskSigning | ProcessTaskTranslateDocuments | ProcessTaskTriggerEvent | ProcessTaskUpdateCandidateProfile | ProcessTaskUpload | ProcessTaskUploadAvatar | ProcessTaskWork;

export class ProcessTaskRoleSetup implements ProcessTask {
  __typename?: 'ProcessTaskRoleSetup';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  setupRoles: Array<Scalars['String']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskRoleSetupModel {
  __typename?: 'ProcessTaskRoleSetupModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  setupRoles: Array<Scalars['String']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskRoleSetupModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskRoleSetupModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  setupRoles: Array<Scalars['String']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskRule {
  __typename?: 'ProcessTaskRule';
  event: ProcessRuleTriggerEvent;
  expression?: Maybe<Scalars['String']['output']>;
  expressionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  expressionExplanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  propertyName?: Maybe<Scalars['String']['output']>;
  ruleType: ProcessRuleType;
  runCondition?: Maybe<Scalars['String']['output']>;
  runConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  runConditionExplanation?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  targetTasks?: Maybe<RuleTaskTarget>;
  targetType: ProcessRuleTargetType;
};

export class ProcessTaskRuleInput {
  event: ProcessRuleTriggerEvent;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  expressionExplanation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  propertyName?: InputMaybe<Scalars['String']['input']>;
  ruleType: ProcessRuleType;
  runCondition?: InputMaybe<Scalars['String']['input']>;
  runConditionBlocklyWorkspace?: InputMaybe<Scalars['String']['input']>;
  runConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  targetTasks?: InputMaybe<RuleTaskTargetInput>;
  targetType: ProcessRuleTargetType;
};

export class ProcessTaskSigning implements ProcessTask {
  __typename?: 'ProcessTaskSigning';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRoleOrder?: Maybe<Array<Scalars['String']['output']>>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  signingRoleMapping?: Maybe<Array<SigningRoleMappingEntry>>;
  skippableTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateNames: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskSigningModel {
  __typename?: 'ProcessTaskSigningModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRoleOrder?: Maybe<Array<Scalars['String']['output']>>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  signingRoleMapping?: Maybe<Array<SigningRoleMappingEntry>>;
  skippableTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateNames: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskSigningModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskSigningModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRoleOrder?: Maybe<Array<Scalars['String']['output']>>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  signingRoleMapping?: Maybe<Array<SigningRoleMappingEntry>>;
  skippableTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  templateNames: Array<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskTranslateDocuments implements ProcessTask {
  __typename?: 'ProcessTaskTranslateDocuments';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateDocuments?: Maybe<Array<CandidateDocTypeAttachment>>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  mode: DocumentTranslationMode;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  provider: DocumentTranslationProvider;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetLanguage: Scalars['String']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
  waitForOptionalDocuments?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskTranslateDocumentsModel {
  __typename?: 'ProcessTaskTranslateDocumentsModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  mode: DocumentTranslationMode;
  modelId: Scalars['ID']['output'];
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  provider: DocumentTranslationProvider;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetLanguage: Scalars['String']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
  waitForOptionalDocuments?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskTranslateDocumentsModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskTranslateDocumentsModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  mode: DocumentTranslationMode;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  provider: DocumentTranslationProvider;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetLanguage: Scalars['String']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
  waitForOptionalDocuments?: Maybe<Scalars['Boolean']['output']>;
};

export class ProcessTaskTriggerEvent implements ProcessTask {
  __typename?: 'ProcessTaskTriggerEvent';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processEvent: ProcessEventEnum;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  triggerEventError?: Maybe<Scalars['String']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskTriggerEventModel {
  __typename?: 'ProcessTaskTriggerEventModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processEvent: ProcessEventEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskTriggerEventModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskTriggerEventModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processEvent: ProcessEventEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUpdateCandidateProfile implements ProcessTask {
  __typename?: 'ProcessTaskUpdateCandidateProfile';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  properties: Array<CandidateProfileProperty>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUpdateCandidateProfileModel {
  __typename?: 'ProcessTaskUpdateCandidateProfileModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  properties: Array<CandidateProfileProperty>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUpdateCandidateProfileModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskUpdateCandidateProfileModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  properties: Array<CandidateProfileProperty>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  acceptFileTypes?: InputMaybe<Scalars['String']['input']>;
  activationCondition?: InputMaybe<Scalars['String']['input']>;
  activationConditionExplanation?: InputMaybe<Scalars['String']['input']>;
  assignmentExceptionOperation?: InputMaybe<CandidateAssignmentExceptionOperation>;
  assignmentExceptionType?: InputMaybe<CandidateAssignmentExceptionType>;
  atLeastOnePredecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachDownloadableTaskFilesToEmails?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentError?: InputMaybe<Scalars['String']['input']>;
  attachmentForms?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentTemplatesFileType?: InputMaybe<Array<AttachmentTemplateFileType>>;
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  attachmentsAllowedOnTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsDisplayText?: InputMaybe<Array<ProcessOptionalStringInput>>;
  attachmentsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  auditDefinitionName?: InputMaybe<Scalars['String']['input']>;
  auditMode?: InputMaybe<AuditTaskModeEnum>;
  autoProcessToken?: InputMaybe<Scalars['String']['input']>;
  autoStateChanges?: InputMaybe<Array<AutoStateChangeInput>>;
  automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  avgPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  cancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  candidateDisplayId?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  candidateDocuments?: InputMaybe<Array<CandidateDocTypeAttachmentInput>>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  candidateRequiredDocumentSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmationMode?: InputMaybe<Scalars['Boolean']['input']>;
  consentType?: InputMaybe<KnownConsentIdentifiers>;
  createDownloadableArchiveWithLink?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<TaskDelayInput>;
  delayHistory?: InputMaybe<Array<TaskDelayInput>>;
  delayStartByDays?: InputMaybe<Scalars['Float']['input']>;
  delegations?: InputMaybe<Array<TaskDelegationInput>>;
  deliveryFormat?: InputMaybe<DocumentDeliveryFormat>;
  displayAttachmentError?: InputMaybe<Scalars['Boolean']['input']>;
  displayAttachmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  displayDescription?: InputMaybe<Array<ProcessOptionalStringInput>>;
  displayDescriptionQD?: InputMaybe<Array<ProcessOptionalQuillDeltaInput>>;
  displayMissingOrganizationDocument?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Array<ProcessOptionalStringInput>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotCreateOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  doNotReassignAssignOnExamFailed?: InputMaybe<Scalars['Boolean']['input']>;
  documentCheckType?: InputMaybe<DocumentDeliveryFormat>;
  documentRequirements?: InputMaybe<Array<ProcessDocumentRequirementInput>>;
  documentRoleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadableAttachmentsLink?: InputMaybe<Scalars['String']['input']>;
  downloadableFiles?: InputMaybe<Array<DownloadableFilestInput>>;
  durationSettings?: InputMaybe<TaskDurationSettingsInput>;
  educationModuleType?: InputMaybe<EducationModuleType>;
  examId?: InputMaybe<Scalars['String']['input']>;
  examOrganizationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIntervieweeTaskId?: InputMaybe<Scalars['String']['input']>;
  feedbackInterviewerTaskId?: InputMaybe<Scalars['String']['input']>;
  fieldsToExcludeFromSync?: InputMaybe<Array<Scalars['String']['input']>>;
  finishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  finishingMode?: InputMaybe<DocumentFinishingMode>;
  formToken?: InputMaybe<Scalars['String']['input']>;
  hideGenericTaskComment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: InputMaybe<Scalars['Boolean']['input']>;
  initialModel?: InputMaybe<Scalars['JSONObject']['input']>;
  instanceState?: InputMaybe<InstanceStateEnum>;
  interviewDateTaskId?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  languageEducationFields?: InputMaybe<LanguageEducationFieldsInput>;
  lastInstanceStateChangedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  lastUpdateManualStarted?: InputMaybe<Scalars['Boolean']['input']>;
  lockDocumentsAfterReviewForIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  maxFileSize?: InputMaybe<Scalars['Float']['input']>;
  maxFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  maxPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  maxUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  maximumAttempts?: InputMaybe<Scalars['Float']['input']>;
  milestoneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minDuration?: InputMaybe<Scalars['Float']['input']>;
  minFilesRequired?: InputMaybe<Scalars['Float']['input']>;
  minPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  minUploadedDocumentTypesRequired?: InputMaybe<Scalars['Float']['input']>;
  missingOrganizationDocument?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<DocumentTranslationMode>;
  modelId?: InputMaybe<Scalars['ID']['input']>;
  numberOfAllowedAttachments?: InputMaybe<Scalars['Float']['input']>;
  numberOfReviewers?: InputMaybe<Scalars['Float']['input']>;
  organizationDocuments?: InputMaybe<Array<DocTypeAttachmentInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pertPlanning?: InputMaybe<ProcessPlanningNodeInput>;
  preConfiguredAllowedDocumentFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentFormatOverwrite?: InputMaybe<Array<Scalars['String']['input']>>;
  preConfiguredDocumentPurpose?: InputMaybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: InputMaybe<Scalars['String']['input']>;
  preConfiguredFilterForCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  prefillTaskId?: InputMaybe<Scalars['ID']['input']>;
  previousAttempts?: InputMaybe<Array<Scalars['String']['input']>>;
  previousTaskId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
  processAuditGroupName?: InputMaybe<Scalars['String']['input']>;
  processDeadlineInDays?: InputMaybe<Scalars['Float']['input']>;
  processDocumentsToUpload?: InputMaybe<Array<ProcessDocumentToUploadTypeInput>>;
  processInstanceState?: InputMaybe<ProcessInstanceStateEnum>;
  properties?: InputMaybe<Array<CandidateProfilePropertyInput>>;
  provider?: InputMaybe<DocumentTranslationProvider>;
  reactivateTasksOnCancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivateTasksOnFinish?: InputMaybe<Array<Scalars['ID']['input']>>;
  reactivatedByTask?: InputMaybe<Scalars['ID']['input']>;
  reactivatedCancelLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedFinishLabel?: InputMaybe<Array<ProcessOptionalStringInput>>;
  reactivatedRequiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingConceptTaskId?: InputMaybe<Scalars['String']['input']>;
  referenceTaskUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['UTCDate']['input']>;
  reminderSettings?: InputMaybe<TaskReminderSettingsInput>;
  replyType?: InputMaybe<ReplyTypeEnum>;
  requestedInformation?: InputMaybe<Array<EnterMissingInformationRequiredInformationInput>>;
  requireAlternativePicture?: InputMaybe<Scalars['Boolean']['input']>;
  requireNewUpload?: InputMaybe<Scalars['Boolean']['input']>;
  requiredInformation?: InputMaybe<Array<EnterMissingInformation>>;
  requiresCancelReason?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  ruleExecutionError?: InputMaybe<RuleExecutionErrorInput>;
  rules?: InputMaybe<Array<ProcessTaskRuleInput>>;
  selectFinishByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  selectedChildTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  setupRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  signingRoleMapping?: InputMaybe<Array<SigningRoleMappingEntryInput>>;
  skipOnAlreadyEntered?: InputMaybe<Scalars['Boolean']['input']>;
  skippableTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetObject?: InputMaybe<ProcessTargetEnum>;
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRolesChangedBy?: InputMaybe<Scalars['String']['input']>;
  taskDisplayId?: InputMaybe<Scalars['String']['input']>;
  taskEmails?: InputMaybe<Array<EmailTemplateDescriptionInput>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLanguage?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName: Scalars['String']['input'];
  usePreConfiguredDocumentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  waitForOptionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  writeToLicenseOwnerData?: InputMaybe<Scalars['Boolean']['input']>;
};

export class ProcessTaskUpload implements ProcessTask {
  __typename?: 'ProcessTaskUpload';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentError?: Maybe<Scalars['String']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTaskIds?: Maybe<Array<Scalars['ID']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachments?: Maybe<Array<FileAttachment>>;
  attachmentsAllowedOnTopLevel?: Maybe<Scalars['Boolean']['output']>;
  attachmentsDisplayText?: Maybe<Array<ProcessOptionalString>>;
  attachmentsRequired?: Maybe<Scalars['Boolean']['output']>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateDocuments?: Maybe<Array<CandidateDocTypeAttachment>>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayAttachmentError?: Maybe<Scalars['Boolean']['output']>;
  displayAttachmentInfo?: Maybe<Scalars['Boolean']['output']>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayMissingOrganizationDocument?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: Maybe<Scalars['Boolean']['output']>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRequirements?: Maybe<Array<ProcessDocumentRequirement>>;
  downloadableAttachmentsLink?: Maybe<Scalars['String']['output']>;
  downloadableFiles?: Maybe<Array<DownloadableFile>>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  finishingMode?: Maybe<DocumentFinishingMode>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: Maybe<Scalars['Boolean']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isTaskConfigured: Scalars['Boolean']['output'];
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxFilesRequired?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  maxUploadedDocumentTypesRequired?: Maybe<Scalars['Float']['output']>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minFilesRequired?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  minUploadedDocumentTypesRequired?: Maybe<Scalars['Float']['output']>;
  missingOrganizationDocument?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['ID']['output'];
  numberOfAllowedAttachments?: Maybe<Scalars['Float']['output']>;
  organizationDocuments?: Maybe<Array<DocTypeAttachment>>;
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  preConfiguredAllowedDocumentFormats?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentFormatOverwrite?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentPurpose?: Maybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  preConfiguredFilterForCandidate?: Maybe<Scalars['Boolean']['output']>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processDocumentsToUpload?: Maybe<Array<ProcessDocumentToUploadType>>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  useSimpleDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUploadAvatar implements ProcessTask {
  __typename?: 'ProcessTaskUploadAvatar';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requireAlternativePicture?: Maybe<Scalars['Boolean']['output']>;
  requireNewUpload?: Maybe<Scalars['Boolean']['output']>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUploadAvatarModel {
  __typename?: 'ProcessTaskUploadAvatarModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requireAlternativePicture?: Maybe<Scalars['Boolean']['output']>;
  requireNewUpload?: Maybe<Scalars['Boolean']['output']>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUploadAvatarModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskUploadAvatarModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requireAlternativePicture?: Maybe<Scalars['Boolean']['output']>;
  requireNewUpload?: Maybe<Scalars['Boolean']['output']>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUploadModel {
  __typename?: 'ProcessTaskUploadModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTasks?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachmentsAllowedOnTopLevel?: Maybe<Scalars['Boolean']['output']>;
  attachmentsDisplayText?: Maybe<Array<ProcessModelString>>;
  attachmentsRequired: Scalars['Boolean']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: Maybe<Scalars['Boolean']['output']>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRequirements?: Maybe<Array<DocumentRequirementModel>>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  finishingMode?: Maybe<DocumentFinishingMode>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  maxDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  maxUploadedDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  minDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  minUploadedDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['ID']['output'];
  numberOfAllowedAttachments?: Maybe<Scalars['Int']['output']>;
  organizationDocuments?: Maybe<Array<OrganizationDocumentModel>>;
  preConfiguredAllowedDocumentFormats?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentFormatOverwrite?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentPurpose?: Maybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  preConfiguredFilterForCandidate?: Maybe<Scalars['Boolean']['output']>;
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processDocumentsToUpload?: Maybe<Array<DocumentProcessUploadType>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  useSimpleDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskUploadModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskUploadModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  attachDownloadableTaskFilesToEmails?: Maybe<Scalars['Boolean']['output']>;
  attachmentForms?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTasks?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  attachmentTemplatesFileType?: Maybe<Array<AttachmentTemplateFileTypeMapping>>;
  attachmentsAllowedOnTopLevel?: Maybe<Scalars['Boolean']['output']>;
  attachmentsDisplayText?: Maybe<Array<ProcessModelString>>;
  attachmentsRequired: Scalars['Boolean']['output'];
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  candidateDocuments?: Maybe<Array<CandidateDocumentModel>>;
  candidateRequiredDocumentSetIds?: Maybe<Array<Scalars['ID']['output']>>;
  createDownloadableArchiveWithLink?: Maybe<Scalars['Boolean']['output']>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  deliveryFormat?: Maybe<DocumentDeliveryFormat>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotAutoFinishTaskInCaseAllRequirementsFullfilled?: Maybe<Scalars['Boolean']['output']>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  documentRequirements?: Maybe<Array<DocumentRequirementModel>>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  finishingMode?: Maybe<DocumentFinishingMode>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includeDocumentsMarkedAsNotRelevantInRequiredCount?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  maxDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  maxUploadedDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  minDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  minUploadedDocumentsRequired?: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['ID']['output'];
  numberOfAllowedAttachments?: Maybe<Scalars['Int']['output']>;
  organizationDocuments?: Maybe<Array<OrganizationDocumentModel>>;
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  preConfiguredAllowedDocumentFormats?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentFormatOverwrite?: Maybe<Array<Scalars['String']['output']>>;
  preConfiguredDocumentPurpose?: Maybe<DocumentPurpose>;
  preConfiguredDocumentSetName?: Maybe<Scalars['String']['output']>;
  preConfiguredFilterForCandidate?: Maybe<Scalars['Boolean']['output']>;
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  processDocumentsToUpload?: Maybe<Array<DocumentProcessUploadType>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  usePreConfiguredDocumentTypes?: Maybe<Scalars['Boolean']['output']>;
  useSimpleDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskWork implements ProcessTask {
  __typename?: 'ProcessTaskWork';
  _etag?: Maybe<Scalars['String']['output']>;
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChange>>;
  automaticFinish?: Maybe<Scalars['Boolean']['output']>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgPlanning?: Maybe<ProcessPlanningNode>;
  cancelLabel?: Maybe<Array<ProcessOptionalString>>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateOrganizationId?: Maybe<Scalars['ID']['output']>;
  delay?: Maybe<TaskDelay>;
  delayHistory?: Maybe<Array<TaskDelay>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  delegations?: Maybe<Array<TaskDelegation>>;
  displayDescription?: Maybe<Array<ProcessOptionalString>>;
  displayDescriptionQD?: Maybe<Array<ProcessOptionalQuillDelta>>;
  displayName?: Maybe<Array<ProcessOptionalString>>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  fieldsToExcludeFromSync?: Maybe<Array<Scalars['String']['output']>>;
  finishLabel?: Maybe<Array<ProcessOptionalString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instanceState: InstanceStateEnum;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  lastUpdateManualStarted?: Maybe<Scalars['Boolean']['output']>;
  localizedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedDisplayDescription?: Maybe<Scalars['String']['output']>;
  localizedDisplayName?: Maybe<Scalars['String']['output']>;
  localizedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedCancelLabel?: Maybe<Scalars['String']['output']>;
  localizedReactivatedFinishLabel?: Maybe<Scalars['String']['output']>;
  localizedRuleExecutionError?: Maybe<Scalars['String']['output']>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  maxPlanning?: Maybe<ProcessPlanningNode>;
  milestoneNames?: Maybe<Array<Scalars['String']['output']>>;
  minDuration?: Maybe<Scalars['Float']['output']>;
  minPlanning?: Maybe<ProcessPlanningNode>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  ownerRoles: Array<Scalars['String']['output']>;
  parentId: Scalars['ID']['output'];
  pertPlanning?: Maybe<ProcessPlanningNode>;
  predecessorIds?: Maybe<Array<Scalars['ID']['output']>>;
  previousTaskId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<PriorityEnum>;
  processInstanceState: ProcessInstanceStateEnum;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['ID']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['ID']['output']>>;
  reactivatedByTask?: Maybe<Scalars['ID']['output']>;
  reactivatedCancelLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessOptionalString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  ruleExecutionError?: Maybe<RuleExecutionError>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  sortingCriteria?: Maybe<Array<SortingCriterion>>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetRolesChangedBy?: Maybe<Scalars['String']['output']>;
  taskDisplayId?: Maybe<Scalars['String']['output']>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskWorkModel {
  __typename?: 'ProcessTaskWorkModel';
  _className: Scalars['String']['output'];
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  automaticFinish?: Maybe<Scalars['Boolean']['output']>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessTaskWorkModelEntity implements ProcessTaskModelEntity {
  __typename?: 'ProcessTaskWorkModelEntity';
  _className: Scalars['String']['output'];
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  activationCondition?: Maybe<Scalars['String']['output']>;
  activationConditionBlocklyWorkspace?: Maybe<Scalars['String']['output']>;
  activationConditionExplanation?: Maybe<Scalars['String']['output']>;
  atLeastOnePredecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  autoStateChanges?: Maybe<Array<AutoStateChangeModel>>;
  automaticFinish?: Maybe<Scalars['Boolean']['output']>;
  cancelLabel?: Maybe<Array<ProcessModelString>>;
  delayStartByDays?: Maybe<Scalars['Float']['output']>;
  displayDescription?: Maybe<Array<ProcessModelString>>;
  displayName: Array<ProcessModelString>;
  doNotCreateOnSync?: Maybe<Scalars['Boolean']['output']>;
  dontSendEmails?: Maybe<Scalars['Boolean']['output']>;
  durationSettings?: Maybe<TaskDurationSettings>;
  finishLabel?: Maybe<Array<ProcessModelString>>;
  hideGenericTaskComment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  modelId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  predecessorsIds?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnCancel?: Maybe<Array<Scalars['String']['output']>>;
  reactivateTasksOnFinish?: Maybe<Array<Scalars['String']['output']>>;
  reactivatedCancelLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedFinishLabel?: Maybe<Array<ProcessModelString>>;
  reactivatedRequiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  reminderSettings?: Maybe<TaskReminderSettings>;
  requiresCancelReason?: Maybe<Scalars['Boolean']['output']>;
  responsibleRoles: Array<Scalars['String']['output']>;
  rootId: Scalars['ID']['output'];
  rules?: Maybe<Array<ProcessTaskRule>>;
  selectFinishByDefault?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  targetObject: ProcessTargetEnum;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  taskEmails?: Maybe<Array<EmailTemplateDescription>>;
  visibleForRoles: Array<Scalars['String']['output']>;
};

export class ProcessUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  createdAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  delegatedProcessId?: InputMaybe<Scalars['ID']['input']>;
  delegatedProcessOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  documentLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAdhocProcess?: InputMaybe<Scalars['Boolean']['input']>;
  isDelegation?: InputMaybe<Scalars['Boolean']['input']>;
  languages: Array<Scalars['String']['input']>;
  operationMapping?: InputMaybe<ProcessOperationMappingInput>;
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  processModelName: Array<ProcessRequiredStringInput>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  releaseId?: InputMaybe<Scalars['ID']['input']>;
  releaseSelectionMode?: InputMaybe<ProcessReleaseSelectionModeEnum>;
  roleMappingBeforeDelegation?: InputMaybe<Array<RoleOrganizationUserGroupMappingInput>>;
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMappingInput>;
  roles: Array<ProcessRoleInput>;
  rules?: InputMaybe<Array<ProcessRuleInput>>;
  state: ProcessInstanceStateEnum;
  taskVisibility?: InputMaybe<TaskVisibilityEnum>;
};

export class ProcessVisibleTaskListInput {
  candidateId?: InputMaybe<CandidateIdInput>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  instanceStates?: InputMaybe<Array<InstanceStateEnum>>;
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class ProcessVisibleTaskMilestoneInput {
  candidateId?: InputMaybe<CandidateIdInput>;
  instanceStates?: InputMaybe<Array<InstanceStateEnum>>;
  taskIds: Array<TaskIdInput>;
};

export class ProcessWithParticipation {
  __typename?: 'ProcessWithParticipation';
  _etag?: Maybe<Scalars['String']['output']>;
  automaticLanguage?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  commentedStatesIds?: Maybe<Array<Scalars['String']['output']>>;
  configuration?: Maybe<Scalars['JSONObject']['output']>;
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  delegatedProcessId?: Maybe<Scalars['ID']['output']>;
  delegatedProcessOrganizationId?: Maybe<Scalars['ID']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  documentLanguages?: Maybe<Array<Scalars['String']['output']>>;
  hasDelegation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAdhocProcess?: Maybe<Scalars['Boolean']['output']>;
  isDelegation?: Maybe<Scalars['Boolean']['output']>;
  isSystemProcess?: Maybe<Scalars['Boolean']['output']>;
  isUserParticipating?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  lastTaskInstanceStateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  operationMapping?: Maybe<ProcessOperationMapping>;
  organizationId: Scalars['ID']['output'];
  participationConditions?: Maybe<Array<ParticipationCondition>>;
  processModelId: Scalars['ID']['output'];
  processModelName: Array<ProcessRequiredString>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  releaseId?: Maybe<Scalars['ID']['output']>;
  releaseSelectionMode?: Maybe<ProcessReleaseSelectionModeEnum>;
  roleMappingBeforeDelegation?: Maybe<Array<RoleOrganizationUserGroupMapping>>;
  roleOrganisationUsergroupMapping: Array<RoleOrganizationUserGroupMapping>;
  roles: Array<ProcessRole>;
  rules?: Maybe<Array<ProcessRule>>;
  state: ProcessInstanceStateEnum;
  taskVisibility?: Maybe<TaskVisibilityEnum>;
};

export class ProcessWithTasks {
  __typename?: 'ProcessWithTasks';
  collection?: Maybe<Collection>;
  planningNodes?: Maybe<Array<ProcessPlanningNode>>;
  process: Process;
  tasks: Array<ProcessTaskResult>;
};

export class ProcessesForOrganizationInput {
  destinationOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export enum ProcessingResultType {
  Error = 'Error',
  Ignored = 'Ignored',
  Success = 'Success'
}

export enum ProfessionCategory {
  HealthCare = 'HealthCare',
  Other = 'Other'
}

export class ProfessionConfiguration {
  __typename?: 'ProfessionConfiguration';
  _etag?: Maybe<Scalars['String']['output']>;
  defaultFunction?: Maybe<Scalars['String']['output']>;
  defaultProfession?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  professions?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProfessionConfigurationGetInput {
  organizationId: Scalars['ID']['input'];
};

export class ProfessionConfigurationSetInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  defaultFunction?: InputMaybe<Scalars['String']['input']>;
  defaultProfession?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  professions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProfessionDefaults {
  __typename?: 'ProfessionDefaults';
  defaultFunction?: Maybe<Scalars['String']['output']>;
  defaultProfession?: Maybe<Scalars['String']['output']>;
};

export class ProfessionInput {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  subArea?: InputMaybe<Scalars['String']['input']>;
};

export class ProfessionalExperience {
  __typename?: 'ProfessionalExperience';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Array<LocalizedString>>;
  id?: Maybe<Scalars['ID']['output']>;
  localizedDescription?: Maybe<Scalars['String']['output']>;
  localizedName?: Maybe<Scalars['String']['output']>;
  name: Array<LocalizedString>;
  organizationId: Scalars['ID']['output'];
  professionalFieldId: Scalars['ID']['output'];
};

export class ProfessionalExperienceCreateInput {
  description?: InputMaybe<Array<LocalizedStringInput>>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  professionalFieldId: Scalars['ID']['input'];
};

export class ProfessionalExperienceDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalExperienceGetByTypeInput {
  organizationId: Scalars['ID']['input'];
  type: OccupationSkillType;
};

export class ProfessionalExperienceGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalExperienceListInput {
  organizationId: Scalars['ID']['input'];
  professionalFieldId: Scalars['ID']['input'];
};

export class ProfessionalExperienceUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Array<LocalizedStringInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  professionalFieldId: Scalars['ID']['input'];
};

export class ProfessionalField {
  __typename?: 'ProfessionalField';
  _etag?: Maybe<Scalars['String']['output']>;
  additionalInformationLabel?: Maybe<Array<LocalizedString>>;
  additionalInformationTypes?: Maybe<Array<ProfessionalFieldAdditionalInformationType>>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Array<LocalizedString>>;
  id?: Maybe<Scalars['ID']['output']>;
  languages: Array<Scalars['String']['output']>;
  localizedDescription?: Maybe<Scalars['String']['output']>;
  localizedName?: Maybe<Scalars['String']['output']>;
  name: Array<LocalizedString>;
  organizationId: Scalars['ID']['output'];
  professions: Array<Scalars['String']['output']>;
  requireAdditionalInformation?: Maybe<Scalars['Boolean']['output']>;
  type: OccupationSkillType;
};

export enum ProfessionalFieldAdditionalInformationType {
  WhenExperienceAvailable = 'WhenExperienceAvailable',
  WhenExperienceNotAvailable = 'WhenExperienceNotAvailable'
}

export class ProfessionalFieldCreateInput {
  additionalInformationLabel?: InputMaybe<Array<LocalizedStringInput>>;
  additionalInformationTypes?: InputMaybe<Array<ProfessionalFieldAdditionalInformationType>>;
  description?: InputMaybe<Array<LocalizedStringInput>>;
  languages: Array<Scalars['String']['input']>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  professions: Array<Scalars['String']['input']>;
  requireAdditionalInformation?: InputMaybe<Scalars['Boolean']['input']>;
  type: OccupationSkillType;
};

export class ProfessionalFieldDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalFieldGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalFieldListInput {
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalFieldSettings {
  __typename?: 'ProfessionalFieldSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  standardCompetencesProfessionIdBlackList?: Maybe<Array<Scalars['String']['output']>>;
  standardKnowledgeProfessionIdBlackList?: Maybe<Array<Scalars['String']['output']>>;
};

export class ProfessionalFieldSettingsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class ProfessionalFieldSettingsUpsertInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  standardCompetencesProfessionIdBlackList?: InputMaybe<Array<Scalars['String']['input']>>;
  standardKnowledgeProfessionIdBlackList?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class ProfessionalFieldUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  additionalInformationLabel?: InputMaybe<Array<LocalizedStringInput>>;
  additionalInformationTypes?: InputMaybe<Array<ProfessionalFieldAdditionalInformationType>>;
  description?: InputMaybe<Array<LocalizedStringInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languages: Array<Scalars['String']['input']>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  professions: Array<Scalars['String']['input']>;
  requireAdditionalInformation?: InputMaybe<Scalars['Boolean']['input']>;
  type: OccupationSkillType;
};

export enum ProfileDataEditStatus {
  Default = 'Default',
  Editable = 'Editable',
  ReadOnly = 'ReadOnly'
}

export class ProgressAggregateErrorEntry {
  __typename?: 'ProgressAggregateErrorEntry';
  errorMessageKey: Scalars['String']['output'];
  errorProperties?: Maybe<Array<ProgressErrorProperty>>;
};

export class ProgressEmitEvent {
  __typename?: 'ProgressEmitEvent';
  detail?: Maybe<Scalars['String']['output']>;
  iteration?: Maybe<Scalars['Int']['output']>;
  phase: Scalars['String']['output'];
};

export class ProgressErrorProperty {
  __typename?: 'ProgressErrorProperty';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class ProgressEvent {
  __typename?: 'ProgressEvent';
  aggregateErrors?: Maybe<Array<ProgressAggregateErrorEntry>>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessageKey?: Maybe<Scalars['String']['output']>;
  errorProperties?: Maybe<Array<ProgressErrorProperty>>;
  progress?: Maybe<Scalars['Float']['output']>;
  progressMessage?: Maybe<Scalars['String']['output']>;
  subDone?: Maybe<Scalars['Boolean']['output']>;
  subKey?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export class PropertyAndCasualtyInsuranceConfigurationOutput {
  __typename?: 'PropertyAndCasualtyInsuranceConfigurationOutput';
  bundles: Array<StarnormInsuranceBundleOutput>;
  bundlesAreSelectable: Scalars['Boolean']['output'];
};

export class PropertyAndCasualtyInsuranceServiceConfiguration {
  __typename?: 'PropertyAndCasualtyInsuranceServiceConfiguration';
  brokerKey?: Maybe<Scalars['String']['output']>;
  insurancePackageKeys?: Maybe<Array<Scalars['String']['output']>>;
  organizationBankDetail?: Maybe<OrganizationBankDetail>;
  organizationPaidInsuranceKeys?: Maybe<Array<Scalars['String']['output']>>;
};

export class PropertyAndCasualtyInsuranceServiceConfigurationInput {
  brokerKey?: InputMaybe<Scalars['String']['input']>;
  insurancePackageKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationBankDetail?: InputMaybe<OrganizationBankDetailInput>;
  organizationPaidInsuranceKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class PropertyDefinition {
  __typename?: 'PropertyDefinition';
  alternativeTo?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<PropertyDefinition>>;
  enum?: Maybe<Scalars['String']['output']>;
  isForeignKeyCompanion?: Maybe<Scalars['Boolean']['output']>;
  isMultiSelect: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  labelKey: Scalars['String']['output'];
  options?: Maybe<Array<StaticDataModel>>;
  parentLabelKeys?: Maybe<Array<Scalars['String']['output']>>;
  prefix?: Maybe<Scalars['String']['output']>;
  propertyPath: Scalars['String']['output'];
  staticDataType?: Maybe<StaticDataType>;
  type: PropertyTypeEnum;
};

export class PropertyTranslation {
  __typename?: 'PropertyTranslation';
  _etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  propertyPath: Array<Scalars['String']['output']>;
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  sourceText?: Maybe<Scalars['String']['output']>;
  sourceTextAsDelta?: Maybe<Scalars['JSONObject']['output']>;
  targetLanguage?: Maybe<Scalars['String']['output']>;
  targetText?: Maybe<Scalars['String']['output']>;
  targetTextAsDelta?: Maybe<Scalars['JSONObject']['output']>;
  translationItemId: Scalars['String']['output'];
  translationProvider?: Maybe<TranslatorType>;
};

export class PropertyTranslationEntity {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  propertyPath: Array<Scalars['String']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  sourceText?: InputMaybe<Scalars['String']['input']>;
  sourceTextAsDelta?: InputMaybe<Scalars['JSONObject']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetText?: InputMaybe<Scalars['String']['input']>;
  targetTextAsDelta?: InputMaybe<Scalars['JSONObject']['input']>;
  translationItemId: Scalars['String']['input'];
  translationProvider?: InputMaybe<TranslatorType>;
};

export class PropertyTranslationInput {
  entityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class PropertyTranslationUpdateInput {
  translations: Array<PropertyTranslationEntity>;
};

export enum PropertyTypeEnum {
  Any = 'Any',
  Array = 'Array',
  Boolean = 'Boolean',
  Date = 'Date',
  DateWithTime = 'DateWithTime',
  Email = 'Email',
  Enum = 'Enum',
  List = 'List',
  Number = 'Number',
  Object = 'Object',
  String = 'String',
  Unknown = 'Unknown',
  Url = 'Url'
}

export class PublicTalentPoolAnabinInstitutionByIdInput {
  id: Scalars['String']['input'];
};

export class PublicTalentPoolCustomSkillsInput {
  language: Scalars['String']['input'];
  skillIds: Array<Scalars['String']['input']>;
};

export class PublicTalentPoolOccupationSkillByIdsInputInput {
  language: Scalars['String']['input'];
  skillIds: Array<Scalars['String']['input']>;
  skillType: OccupationSkillType;
};

export class PublicTalentPoolSearch {
  __typename?: 'PublicTalentPoolSearch';
  count: Scalars['Float']['output'];
  facets: TalentPoolFacets;
  results: Array<Talent>;
};

export class PublicTalentPoolSearchInput {
  filters: TalentPoolFilters;
  pool: PublicTalentPoolSelection;
  skip: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export class PublicTalentPoolSelection {
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
};

export class PublicTermsAndConditionsForDisplay {
  __typename?: 'PublicTermsAndConditionsForDisplay';
  additionalLogoLink?: Maybe<Scalars['String']['output']>;
  consentDisplayName: Scalars['String']['output'];
  consentIdentifier: KnownConsentIdentifiers;
  consentOptionsHeader?: Maybe<Array<ConsentRenderedText>>;
  consentOptionsToClick: Array<ConsentRenderedOption>;
  consentSections: Array<ConsentRenderedSection>;
  linkedRenderedTexts?: Maybe<Array<LinkedRenderedText>>;
  preambleText?: Maybe<Array<ConsentRenderedText>>;
  showSignature?: Maybe<Scalars['Boolean']['output']>;
  version: Scalars['String']['output'];
};

export class PublishedProcessModelEntity {
  __typename?: 'PublishedProcessModelEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  publishedModels?: Maybe<Array<ProcessModelPublishInfo>>;
};

export class PublishedProcessModelReleaseVersion {
  __typename?: 'PublishedProcessModelReleaseVersion';
  createdAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  displayName: Scalars['String']['output'];
  isShared: Scalars['Boolean']['output'];
  modelDeclaration: ProcessModelDeclaration;
  ownerOrganizationId?: Maybe<Scalars['ID']['output']>;
  ownerOrganizationName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PublishedProcessModelResultEvent = ProgressEvent | PublishedProcessModelEntity;

export class PurchaseContingentInput {
  amount: Scalars['Float']['input'];
  contingentDefinitionId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class PurchaseSettings {
  __typename?: 'PurchaseSettings';
  autoAdvancePayment: Scalars['Boolean']['output'];
  tranches?: Maybe<Array<ContingentPaymentTranche>>;
};

export class PurchaseSettingsInput {
  autoAdvancePayment: Scalars['Boolean']['input'];
  tranches?: InputMaybe<Array<ContingentPaymentTrancheInput>>;
};

export class QualificationData {
  __typename?: 'QualificationData';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  nameOfInstitution?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  qualification?: Maybe<Scalars['String']['output']>;
};

export class QualificationEvaluationDataDe {
  __typename?: 'QualificationEvaluationDataDE';
  noQualificationEvaluation?: Maybe<Scalars['Boolean']['output']>;
  qualificationEvaluationFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationRepresentativeId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluationRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  qualificationEvaluationRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  qualificationEvaluations?: Maybe<Array<QualificationEvaluationsDe>>;
  responsibleQualificationEvaluationOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleQualificationEvaluation?: Maybe<Scalars['String']['output']>;
  responsibleRoleQualificationEvaluationPayment?: Maybe<Scalars['String']['output']>;
};

export class QualificationEvaluationDataDeInput {
  noQualificationEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationEvaluationFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluationRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  qualificationEvaluationRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  qualificationEvaluations?: InputMaybe<Array<QualificationEvaluationsDataDeInput>>;
  responsibleQualificationEvaluationOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleQualificationEvaluation?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleQualificationEvaluationPayment?: InputMaybe<Scalars['String']['input']>;
};

export class QualificationEvaluationsDe {
  __typename?: 'QualificationEvaluationsDE';
  evaluatedQualification?: Maybe<Scalars['String']['output']>;
  evaluationNoticeKind?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  responsibleAuthorityForQualification?: Maybe<Scalars['String']['output']>;
  responsibleAuthorityForQualificationInOrigin?: Maybe<Scalars['String']['output']>;
};

export class QualificationEvaluationsDataDeInput {
  evaluatedQualification?: InputMaybe<Scalars['String']['input']>;
  evaluationNoticeKind?: InputMaybe<Scalars['String']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  responsibleAuthorityForQualification?: InputMaybe<Scalars['String']['input']>;
  responsibleAuthorityForQualificationInOrigin?: InputMaybe<Scalars['String']['input']>;
};

export class QualificationExam {
  __typename?: 'QualificationExam';
  examArea?: Maybe<Scalars['String']['output']>;
  examInstitution?: Maybe<Scalars['String']['output']>;
  examType: Scalars['String']['output'];
  firstExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  firstExamPassed?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  moduleName?: Maybe<Scalars['String']['output']>;
  secondExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  secondExamPassed?: Maybe<Scalars['String']['output']>;
};

export class QualificationExamInput {
  examArea?: InputMaybe<Scalars['String']['input']>;
  examInstitution?: InputMaybe<Scalars['String']['input']>;
  examType: Scalars['String']['input'];
  firstExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  firstExamPassed?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  moduleName?: InputMaybe<Scalars['String']['input']>;
  secondExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  secondExamPassed?: InputMaybe<Scalars['String']['input']>;
};

export class QualificationMeasureCandidateDataAt {
  __typename?: 'QualificationMeasureCandidateDataAT';
  endOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  locationOfComplementaryMeasure?: Maybe<Scalars['String']['output']>;
  responsibleRoleQualification?: Maybe<Scalars['String']['output']>;
  startOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  theoryInstitution?: Maybe<Scalars['String']['output']>;
};

export class QualificationMeasureCandidateDataAtInput {
  endOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  locationOfComplementaryMeasure?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleQualification?: InputMaybe<Scalars['String']['input']>;
  startOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  theoryInstitution?: InputMaybe<Scalars['String']['input']>;
};

export class QualificationMeasureCandidateDataDe {
  __typename?: 'QualificationMeasureCandidateDataDE';
  careSituations?: Maybe<Scalars['Float']['output']>;
  courseNumber?: Maybe<Scalars['String']['output']>;
  educationVoucherFileNumber?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  educationVoucherFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  educationVoucherFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  educationVoucherRepresentativeId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  educationVoucherRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  educationVoucherRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  educationVoucherRequested?: Maybe<Scalars['Boolean']['output']>;
  endOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  noDetailedEquivalence?: Maybe<Scalars['Boolean']['output']>;
  practiceExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  practiceHours?: Maybe<Scalars['Float']['output']>;
  practiceInstitution?: Maybe<Scalars['String']['output']>;
  qualificationExams?: Maybe<Array<QualificationExam>>;
  qualificationIsSend?: Maybe<Scalars['Boolean']['output']>;
  qualificationIsSendDate?: Maybe<Scalars['UTCDate']['output']>;
  qualificationMeasure?: Maybe<Scalars['String']['output']>;
  qualificationMeasureFileNumber?: Maybe<Scalars['String']['output']>;
  qualificationModules?: Maybe<Array<QualificationModule>>;
  qualificationPlanRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  qualificationPlanRequested?: Maybe<Scalars['Boolean']['output']>;
  qualificationType?: Maybe<Scalars['String']['output']>;
  responsibleEducationVoucherOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleEducationVoucher?: Maybe<Scalars['String']['output']>;
  responsibleRoleQualification?: Maybe<Scalars['String']['output']>;
  startOfFurtherEducation?: Maybe<Scalars['UTCDate']['output']>;
  theoryExamDate?: Maybe<Array<Scalars['UTCDate']['output']>>;
  theoryHours?: Maybe<Scalars['Float']['output']>;
  theoryInstitution?: Maybe<Scalars['String']['output']>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  totalMonths?: Maybe<Scalars['Float']['output']>;
};

export class QualificationMeasureCandidateDataDeInput {
  careSituations?: InputMaybe<Scalars['Float']['input']>;
  courseNumber?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFileNumber?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  educationVoucherRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  educationVoucherRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  educationVoucherRequested?: InputMaybe<Scalars['Boolean']['input']>;
  endOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  noDetailedEquivalence?: InputMaybe<Scalars['Boolean']['input']>;
  practiceExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  practiceHours?: InputMaybe<Scalars['Float']['input']>;
  practiceInstitution?: InputMaybe<Scalars['String']['input']>;
  qualificationExams?: InputMaybe<Array<QualificationExamInput>>;
  qualificationIsSend?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationIsSendDate?: InputMaybe<Scalars['UTCDate']['input']>;
  qualificationMeasure?: InputMaybe<Scalars['String']['input']>;
  qualificationMeasureFileNumber?: InputMaybe<Scalars['String']['input']>;
  qualificationModules?: InputMaybe<Array<QualificationModuleInput>>;
  qualificationPlanRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  qualificationPlanRequested?: InputMaybe<Scalars['Boolean']['input']>;
  qualificationType?: InputMaybe<Scalars['String']['input']>;
  responsibleEducationVoucherOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleEducationVoucher?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleQualification?: InputMaybe<Scalars['String']['input']>;
  startOfFurtherEducation?: InputMaybe<Scalars['UTCDate']['input']>;
  theoryExamDate?: InputMaybe<Array<Scalars['UTCDate']['input']>>;
  theoryHours?: InputMaybe<Scalars['Float']['input']>;
  theoryInstitution?: InputMaybe<Scalars['String']['input']>;
  totalHours?: InputMaybe<Scalars['Float']['input']>;
  totalMonths?: InputMaybe<Scalars['Float']['input']>;
};

export class QualificationMeasureData {
  __typename?: 'QualificationMeasureData';
  careSituations?: Maybe<Scalars['Float']['output']>;
  practiceHours?: Maybe<Scalars['Float']['output']>;
  qualificationMeasure?: Maybe<Scalars['String']['output']>;
  theoryHours?: Maybe<Scalars['Float']['output']>;
};

export class QualificationModule {
  __typename?: 'QualificationModule';
  areaOfDeployment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  practiceHours?: Maybe<Scalars['Float']['output']>;
  theoryHours?: Maybe<Scalars['Float']['output']>;
};

export class QualificationModuleInput {
  areaOfDeployment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  practiceHours?: InputMaybe<Scalars['Float']['input']>;
  theoryHours?: InputMaybe<Scalars['Float']['input']>;
};

export class Query {
  __typename?: 'Query';
  accrualSnapshots: Array<AccrualMonthlySnapshotEntity>;
  aiChatSessions: AiChatSessionListResult;
  allContingentCorrections: Array<ContingentCorrectionEntity>;
  allFloorCorrections: Array<FloorCorrectionEntity>;
  areCollectionsFavorite: Array<Favorite>;
  areOrganizationLinked: Scalars['Boolean']['output'];
  calculateAccruals: AccrualSummary;
  calculateAccrualsForRange: Array<AccrualSummary>;
  canAccessCandidateEdit: CandidateAccess;
  canAccessCandidateView: CandidateAccess;
  canAccessCollectionEdit: CollectionAccess;
  canAccessCollectionView: CollectionAccess;
  canAccessOrganizationLinkInvitation: OrganizationLinkInvitationAccess;
  canAccessProcessView: ProcessAccess;
  canAccessTaskAct: TaskAccess;
  canChatWithCandidate: Scalars['Boolean']['output'];
  checkExistingLingokingCredentials: Scalars['Boolean']['output'];
  checkForValidLogin: Scalars['Boolean']['output'];
  checkNewLingokingCredentials: Scalars['Boolean']['output'];
  checkPublicUserByEmail: CheckPublicUserByEmailResult;
  checkRequiredData?: Maybe<Array<RequiredDataResult>>;
  checkRequiredDataOfTask?: Maybe<Array<RequiredDataResult>>;
  checkUserGroupHasUsers: Array<UserGroupHasMembers>;
  contactLingoking: Scalars['Boolean']['output'];
  convertAndGetDocumentDownloadUrl: DocumentUrlAndFileName;
  convertManyDocuments: DocumentUrlAndFileName;
  createLingokingAccount: LingokingAccount;
  createManualBooking: BillingAccount;
  createOrganizationAuditReport: ReportResult;
  deleteLingokingAccount: Scalars['Boolean']['output'];
  detectDocxSigningRolesFromBlob: SigningRolesResult;
  detectDocxSigningRolesFromContent: SigningRolesResult;
  detectDocxTemplateSigningRoles: SigningRolesResult;
  detectZipCode?: Maybe<GeoZipCode>;
  downloadAllDocumentTemplatesForCandidate: Archive;
  downloadAllDocumentTemplatesForCollection: Archive;
  downloadInvoicesAndCreditNotesForMonth: Scalars['String']['output'];
  /** Exercises read-only BarmerAddOnService queries. Requires COLLECT_QUERY_COVERAGE=true. */
  exerciseBarmerQueries: Array<QueryCoverageExerciseResult>;
  /** Exercises read-only BillingEventQueueService queries. Requires COLLECT_QUERY_COVERAGE=true. */
  exerciseBillingEventQueries: Array<QueryCoverageExerciseResult>;
  /** Exercises read-only AutoCollectionChecker queries (dry-run). Requires COLLECT_QUERY_COVERAGE=true. */
  exerciseCollectionQueries: Array<QueryCoverageExerciseResult>;
  /** Exercises read-only CustifyUsageStatsService queries. Requires COLLECT_QUERY_COVERAGE=true. */
  exerciseCustifyQueries: Array<QueryCoverageExerciseResult>;
  exportAssets: AssetDownload;
  exportPdfFormUpdateUrls: PdfFormUpdateUrlsDownload;
  exportStaticData: StaticDataDownload;
  extractDocumentType: DocumentTypeExtractionResult;
  findAllLinkableOrganizations: Array<Organization>;
  findOccupationSkills?: Maybe<OccupationSkillSet>;
  flattenPdfSignatures: Scalars['String']['output'];
  generateCVAsDocx?: Maybe<GenerateCvAsDocxResponse>;
  generateExportAndSendToUser?: Maybe<Scalars['Void']['output']>;
  generateFeedbackReport: ReportResult;
  generateProcessRoleAssignmentReport: ProcessReportResult;
  generateProcessStatusReport: ProcessReportResult;
  generateProcessTaskListReport: ProcessReportResult;
  generateSummaryReportOfAllProcesses: ProcessReportResult;
  generateVacancyReport: ReportResult;
  getAccessibleProcesses: Array<Process>;
  getAccountBalance: AccountBalance;
  getActiveContract?: Maybe<Contract>;
  getActiveUserPriceInfo: ActiveUserPriceInfo;
  getActivities: Array<Activity>;
  getActivityDiff?: Maybe<Array<ActivityDiff>>;
  getActivityFilterCandidates: Array<ActivityFilterOption>;
  getActivityFilterCollections: Array<ActivityFilterOption>;
  getActivityFilterOrganizations: Array<ActivityFilterOption>;
  getActivityFilterProcesses: Array<ActivityFilterOption>;
  getActivityFilterUsers: Array<ActivityFilterOption>;
  getAdHocEducationExams: Array<AdHocEducationExam>;
  getAdHocEducationExamsByCandidateId: Array<AdHocEducationExamForCandidate>;
  getAdHocEducationExamsByCriteria: Array<AdHocEducationExam>;
  getAddOnBookingDetail?: Maybe<AddOnBookingDetail>;
  getAggregatedMilestoneData: AggregatedMilestoneData;
  getAggregatedMilestoneStates: AggregatedMilestoneStates;
  getAllAttachableProcesses: Array<AttachableProcess>;
  getAllByTemplateGeneratedCollections: Array<Collection>;
  getAllCandidateStatesOfType?: Maybe<Array<ProcessStateResult>>;
  getAllCandidateTasksOfType: Array<ProcessTaskResult>;
  getAllCandidates: CandidatePage;
  getAllChallengeBookings: Array<ChallengeBooking>;
  getAllChildOrganizations: Array<Organization>;
  getAllCollectionAutoFilterTemplates: Array<CollectionAutoFilterTemplate>;
  getAllCollections: Array<Collection>;
  getAllConfigs: Array<CandidateProfileConfig>;
  getAllContractTemplates: Array<ContractTemplate>;
  getAllContracts: Array<Contract>;
  getAllCreditNotes: Array<CreditNote>;
  getAllDeletionRequests?: Maybe<Array<CandidateDeletionRequest>>;
  getAllDerivableModels: Array<PublishedProcessModelReleaseVersion>;
  getAllDocumentOverwrites?: Maybe<Array<DocumentTypeOverwrite>>;
  getAllDocumentTemplates: Array<DocumentTemplate>;
  getAllFeedbackForView: Array<Feedback>;
  getAllInvoices: Array<Invoice>;
  getAllLicensedOrganizations: Array<Organization>;
  getAllLocalPartnerProfileConfigSets: Array<LocalPartnerProfileConfigSet>;
  getAllManagedOrganizations?: Maybe<Array<Organization>>;
  getAllOnlineApplications?: Maybe<Array<OnlineApplicationForList>>;
  getAllOnlineApplicationsForImmigrationCountry?: Maybe<Array<OnlineApplicationForList>>;
  getAllOrganizationWhichLinkTo: Array<OrganizationLink>;
  getAllPdfFormTemplateWatches: Array<PdfFormTemplateWatch>;
  getAllProcessActions: Array<ProcessAction>;
  getAllProcessModelLanguages: Array<Scalars['String']['output']>;
  getAllProcesses: Array<Process>;
  getAllReleases: Array<ReleasedProcessModelInfo>;
  getAllSelectableLicensedOrganizations: Array<Organization>;
  getAllTemplateDisplayNamesOfDemoTenant: Array<Scalars['String']['output']>;
  getAllUserGroups: Array<UserGroup>;
  getAllowedTasksConsents: Array<KnownConsentIdentifiers>;
  getAlreadySharedOrgIds: Array<Scalars['String']['output']>;
  getAlwaysGeneratedTemplates: Array<Scalars['String']['output']>;
  getAnabinDegreeDetails?: Maybe<AnabinDegreesForInfoView>;
  getAnabinInstitutionDetails?: Maybe<AnabinInstitutionInfoViewDetails>;
  getAreaModel: ProcessAreaModelEntity;
  getAssignableCollectionsForCandidate: Array<Collection>;
  getAssignableMembers: Array<AssignableMember>;
  getAttachableAutoCollections: Array<AttachableAutoCollection>;
  getAudit?: Maybe<Audit>;
  getAuditDefinition: AuditDefinition;
  getAuditDefinitions: Array<AuditDefinition>;
  getAutoGeneratedCVUrl: AutoCvResponse;
  getAutoTeamsForProcess: Array<UserGroup>;
  getAvailableAutogenTemplates: Array<AvailableDocumentTemplate>;
  getAvailableCandidateColumns: Array<CandidateColumnDescriptor>;
  getAvailableDocumentFormats: DocumentFormats;
  getAvailableDocumentTemplates: Array<AvailableDocumentTemplateGroup>;
  getAvailableKpiMonths: AvailableKpiMonths;
  getAvailableLanguages: Array<Scalars['String']['output']>;
  getAvailablePdfFormTemplates: Array<PdfFormTemplate>;
  getAvailableProcessModelVersions: Array<PublishedProcessModelReleaseVersion>;
  getAvailableProcessModels: Array<ProcessModel>;
  getAvailableReportTemplates: Array<ReportTemplate>;
  getAvailableUserGroups: Array<UserGroup>;
  getBillableUserBreakdown: BillableUserBreakdown;
  getBillableUserCount: BillableUserCount;
  getBillingHistory?: Maybe<BillingHistory>;
  getBillingSettings: BillingSettings;
  getBillingYears: Array<BillingYear>;
  getCandidate?: Maybe<Candidate>;
  getCandidateAccountingRecord: CandidateAccountingRecord;
  getCandidateAccountingRecordMultiEditSummary: CandidateAccountingRecordMultiEditSummary;
  getCandidateAccountingRecords: Array<CandidateAccountingRecordForList>;
  getCandidateActivities: Array<Activity>;
  getCandidateApplicationMaskCandidateOwnerSpecificSettings: SystemSettingsForCandidateOrg;
  getCandidateApplicationMaskConfig: CandidateApplicationMaskConfig;
  getCandidateApplicationMaskConfigDocumentDownloadUrl: Scalars['String']['output'];
  getCandidateApplicationMaskConfigDownloadableFiles: Array<CandidateApplicationMaskDownloadableDocument>;
  getCandidateApplicationMaskConfigForWebsite: CandidateApplicationMaskConfig;
  getCandidateApplicationMaskConfigs: Array<CandidateApplicationMaskConfig>;
  getCandidateApplicationMaskDownloadableFiles: Array<CandidateApplicationMaskDownloadableDocument>;
  getCandidateApplicationMaskError?: Maybe<CandidateApplicationMaskError>;
  getCandidateApplicationMaskImageAccessToken: ImageAccessTokenResult;
  getCandidateApplicationMaskOrganization: Organization;
  getCandidateApplicationMaskProfessionAreas?: Maybe<Array<StaticDataModel>>;
  getCandidateApplicationMaskProfessionConfiguration?: Maybe<ProfessionConfiguration>;
  getCandidateApplicationMaskProfessionSubAreas?: Maybe<Array<StaticDataModel>>;
  getCandidateApplicationMaskProfessions?: Maybe<Array<StaticDataModel>>;
  getCandidateApplicationMaskPublicAnabinDegreeDetails?: Maybe<AnabinDegreesForInfoView>;
  getCandidateApplicationMaskPublicAnabinInstitutionDetails?: Maybe<AnabinInstitutionInfoViewDetails>;
  getCandidateApplicationMaskPublicAvailableCommunicationLanguages: Array<Scalars['String']['output']>;
  getCandidateApplicationMaskPublicDocumentDownloadUrl: Scalars['String']['output'];
  getCandidateApplicationMaskPublicMinimalAnabinAssetById?: Maybe<StaticDataModel>;
  getCandidateApplicationMaskPublicMinimalAnabinAssetData: Array<StaticDataModel>;
  getCandidateApplicationMaskSettings: CandidateApplicationMaskSetting;
  getCandidateApplicationMaskStaticData?: Maybe<StaticDataResult>;
  getCandidateApplicationMaskTempDownloadUrl: Scalars['String']['output'];
  getCandidateApplicationMaskUploadUrl: CreateApplicationMaskUploadUrl;
  getCandidateArchive: Archive;
  getCandidateBookingDetail?: Maybe<CandidateBookingDetail>;
  getCandidateColumnValues: Array<CandidateColumnValues>;
  getCandidateDeletionRequest?: Maybe<CandidateDeletionRequest>;
  getCandidateDiff: Array<CandidateDiff>;
  getCandidateDocumentTemplates: Array<DocumentTemplate>;
  getCandidateEvents: Array<CandidateEvent>;
  getCandidateFieldTranslations: Array<PropertyTranslation>;
  getCandidateForEdit: CandidateForEdit;
  getCandidateForView: CandidateForView;
  getCandidateInbox: TaskInbox;
  getCandidateInboxCount: Scalars['Float']['output'];
  getCandidateInfo: Scalars['String']['output'];
  getCandidateInterviewIterations?: Maybe<CandidateInterviewsFeedback>;
  getCandidateInterviewMultiEditSummary: CandidateInterviewMultiEditSummary;
  getCandidateListMultiEditSummary: CandidateListMultiEditSummary;
  getCandidateMultiEditConfiguration: CandidateMultiEditConfiguration;
  getCandidateProfileTabFieldLabels: Array<CandidateProfileTabFieldLabel>;
  getCandidateReceipt?: Maybe<CandidateReceipt>;
  getCandidateStaticDataContextInformation: CandidateStaticDataContextInformation;
  getCandidateStatusHistory: Array<CandidateStatusHistoryEntry>;
  getCandidateTagDescriptions: Array<CandidateTagDescription>;
  getCandidateTags?: Maybe<Array<CandidateTag>>;
  getCandidateTransferLog: Array<CandidateTransferLog>;
  getCandidatesByDisplayId: Array<Candidate>;
  getCandidatesForAssignment: CandidatePage;
  getCandidatesForBooking: CandidatePage;
  getCandidatesOfCollection: CandidatePage;
  getCandidatesOfCollectionForView: Array<CandidateForView>;
  getCascadedLinkedOrganizations: Array<Organization>;
  getCascadedLinkedOrganizationsFromSourceOrganization: Array<Organization>;
  getCertificateValuationAuthorities: Array<CertificateValuationAuthority>;
  getCertifiedEducationExams: Array<CertifiedEducationExamGroup>;
  getChamberOfCrafts: Array<ChamberOfCrafts>;
  getChatConfiguration: ChatConfiguration;
  getChatGroup: ChatGroup;
  getChatGroupConfiguration: ChatGroupConfiguration;
  getChatGroupConfigurations: Array<ChatGroupConfiguration>;
  getChatPartnerCandidates: Array<Candidate>;
  getChatPartnerOrganizations: Array<Organization>;
  getChatPartnerUserGroups: Array<ChatPartnerUserGroup>;
  getChatPartnerUsers: Array<User>;
  getChatUsage?: Maybe<ChatUsage>;
  getChildTasksByParentId: Array<ProcessTaskResult>;
  getCollection: Collection;
  getCollectionAutoFilter: CollectionAutoFilter;
  getCollectionAutoFilterTemplate: CollectionAutoFilterTemplate;
  getCollectionDocumentTemplates: Array<DocumentTemplate>;
  getCollectionEmptyStatus: Array<CollectionEmptyStatus>;
  getCollectionEvents: Array<CandidateEvent>;
  getCollectionFilterPreset: CollectionFilterPreset;
  getCollectionFilterPresets: Array<CollectionFilterPreset>;
  getCollectionForPreselection?: Maybe<CollectionId>;
  getCollectionOrganizations: Array<Organization>;
  getCollectionsForAssignment: Array<Collection>;
  getCollectionsForCandidate: Array<CollectionsForCandidateResult>;
  getCollectionsForDelegation: Array<Collection>;
  getCollectionsSharedToOrganization: Array<Collection>;
  getCommandHistory: ProcessModelCommandHistoryInfoPage;
  getCommentedStatesIds: Array<Scalars['String']['output']>;
  getCommissionBookingDetail?: Maybe<CommissionBookingDetail>;
  getCommissionCreditBalance: AccountBalance;
  getConfig: CandidateProfileConfig;
  getConfigByStatusAndFunction?: Maybe<CandidateProfileConfig>;
  getConsent?: Maybe<TcConsent>;
  getConsentHistoryDetail: TermsAndConditionsHistoryDetail;
  getConsentHistoryList: Array<TermsAndConditionsHistoryListElement>;
  getConsents: Array<Consent>;
  /** Returns consistency violations collected since the last reset. Requires ENABLE_CONSISTENCY_REPORT=true. */
  getConsistencyViolations: Array<ConsistencyViolation>;
  getContingentBookingDetail?: Maybe<ContingentBookingDetail>;
  getContingentDefinition: ContingentDefinition;
  getContingentDefinitionSet: ContingentDefinitionSet;
  getContingentDefinitionSetIdsInUse: Array<Scalars['ID']['output']>;
  getContingentDefinitionSets: Array<ContingentDefinitionSet>;
  getContingents: Array<Contingent>;
  getContract: Contract;
  getContractBillingEventTypes: Array<BillingEventType>;
  getContractTemplate?: Maybe<ContractTemplate>;
  getCourseEvents: Array<CandidateEvent>;
  getCoursesSharedReadonly: Array<EducationCourse>;
  getCreatableCandidateInvoicesForAllOrganizations: Array<CreatableInvoiceForOrganization>;
  getCreatableDocumentTypes: Array<StaticDataModel>;
  getCreatableInvoices: Array<CreatableInvoice>;
  getCredentials?: Maybe<Array<OnlineApplicationCredentials>>;
  getCredentialsForEdit?: Maybe<OnlineApplicationCredentials>;
  getCreditNoteBookingDetail?: Maybe<CreditNoteBookingDetail>;
  getCreditNotePdfDownloadUrl: Scalars['String']['output'];
  getCreditNotes: Array<CreditNote>;
  getCurrentPublicAPIAccessToken: Scalars['String']['output'];
  getCustomContingentDefinitionSets: Array<CustomContingentDefinitionSet>;
  getCustomPlans: Array<CustomPlan>;
  getCustomSkillSets?: Maybe<Array<CustomSkillSet>>;
  getCustomer?: Maybe<CustomerResult>;
  getCustomerPortalUrl?: Maybe<Scalars['String']['output']>;
  getCvParsingAddOnConfig?: Maybe<CvParsingAddOnConfig>;
  getCvParsingConsumption?: Maybe<CvParsingConsumption>;
  getDashboardMetrics: Array<DashboardMetric>;
  getDashboardWidget: DashboardWidget;
  getDataForFormerAudit?: Maybe<TaskStateProcessForOrganizationAudit>;
  getDataStrategies: Array<StaticDataModel>;
  getDataStrategyConfigurationFormly: Scalars['JSON']['output'];
  getDataStrategyGenerationFormly: Scalars['JSON']['output'];
  getDatabaseConfiguration: DatabaseConfiguration;
  getDatabaseConnectionStats: DatabaseConnectionStats;
  getDelegatedTasks: Array<DelegatedTaskItem>;
  getDeniedTaskTypes: Array<Scalars['String']['output']>;
  getDiplomaticMissionsAbroad: Array<DiplomaticMission>;
  getDiplomaticMissionsAtHome: Array<DiplomaticMission>;
  getDocument: Document;
  getDocumentAiUploadUrl: DocumentAiUrl;
  getDocumentByType?: Maybe<Document>;
  getDocumentDetectedLanguage: Array<DetectedDocumentLanguage>;
  getDocumentDownloadUrl: Scalars['String']['output'];
  getDocumentDownloadUrlWithFileName: DocumentUrlAndFileName;
  getDocumentDownloadWithContainerUrl: Scalars['String']['output'];
  getDocumentRequirement: DocumentRequirement;
  getDocumentRequirementByType: DocumentRequirement;
  getDocumentRequirements: Array<DocumentRequirement>;
  getDocumentTemplate: DocumentTemplate;
  getDocumentTemplateProcessUsage: Array<ProcessTaskModelUsage>;
  getDocumentTranslationStateForDocument?: Maybe<Array<GetDocumentTranslationStateForDocumentResult>>;
  getDocumentTypeOverwrite?: Maybe<DocumentTypeOverwrite>;
  getDocumentUploadUrl: DocumentUrl;
  getDocumentUploadWithContainerUrl: Scalars['String']['output'];
  getDocuments: Array<Document>;
  getDocumentsByTypes: Array<Document>;
  getDocxSigningSubmissionsByIds: Array<SigningSubmissionOutput>;
  getDocxSigningSubmissionsForCandidate: Array<SigningSubmissionOutput>;
  getEducationCourse: EducationCourse;
  getEducationCoursePerformance: EducationCoursePerformance;
  getEducationCoursePerformanceByCandidate: EducationCoursePerformanceByCandidate;
  getEducationCourseTotalPerformance?: Maybe<EducationCourseTotalPerformance>;
  getEducationCourseTotalPerformancesForCandidate: Array<EducationCourseTotalPerformance>;
  getEducationCourseWeeklyPerformance?: Maybe<EducationCourseWeeklyPerformance>;
  getEducationCourses: Array<EducationCourse>;
  getEducationCoursesForCandidate: Array<EducationCourse>;
  getEducationCoursesForCandidateToAddTo: Array<EducationCourse>;
  getEducationExamData: EducationExamBaseData;
  getEducationExamForTask?: Maybe<EducationExamOption>;
  getEducationExamOptionsForTask: Array<EducationExamOption>;
  getEducationExamParticipants: Array<EducationExamParticipant>;
  getEducationExamParticipationForTask: Scalars['Boolean']['output'];
  getEducationExamResultsByCandidateId: Array<EducationExamResultFullData>;
  getEducationExamResultsByExamId: Array<EducationExamResultFullData>;
  getEducationExamResultsUpdateTable: Array<EducationExamResultFullData>;
  getEducationExams: Array<EducationExam>;
  getEducationExamsByCandidateId: Array<EducationExamForCandidate>;
  getEducationExamsByCourseId: Array<EducationExam>;
  getEducationExamsByCriteria: Array<EducationExam>;
  getEducationExamsForCandidateByCriteria: Array<EducationExamForCandidateUnion>;
  getEducationModule: EducationModule;
  getEducationModules: Array<EducationModule>;
  getEffectiveDocumentAccess: DocumentAccessInfo;
  getEffectiveFileAccess: FileAccessInfo;
  getEffectiveSharing: EffectiveSharingOutput;
  getEffectiveSharingForMultiEdit: EffectiveSharingOutput;
  getEmail: Email;
  getEmailSendOutRule: EmailSendOutRule;
  getEmailSendOutRules: Array<EmailSendOutRule>;
  getEmailTemplate: EmailTemplate;
  getEmailTemplateProcessUsage: Array<ProcessTaskModelUsage>;
  getEmailTemplates: Array<EmailTemplate>;
  getEmailTemplatesByType: Array<EmailTemplate>;
  getEmailTemplatesWithUsageInfo: Array<EmailTemplateWithUsageInfo>;
  getEmailsForCandidate: Array<EmailForList>;
  getEmailsForOrganizationLinkInvitation: Array<EmailForList>;
  getEmailsForProcess: Array<EmailForList>;
  getEmailsForUser: Array<EmailForList>;
  getEmployer?: Maybe<Employer>;
  getEmployerApplications: Array<EmployerApplication>;
  getEmployerFilterDefaults: EmployerFilterDefaults;
  getEmployerFilterFields: EmployerFilterFields;
  getEmployers: Array<Employer>;
  getEmploymentApprovalAuthorities: Array<EmploymentApprovalAuthority>;
  getEmploymentApprovalAuthorityById: EmploymentApprovalAuthority;
  getEnabledServiceCategories: Array<AddOnServiceCategoryEnum>;
  getEnabledServices: Array<AddOnServicesEnum>;
  getEnabledSharing?: Maybe<Sharing>;
  getEnterMissingInformationV2MultiEditBaseline: EnterMissingInformationV2MultiEditBaseline;
  getEscoSkillsByProfession?: Maybe<Array<OccupationSkillSet>>;
  getEscoSkillsByProfessionAndOrganization?: Maybe<Array<OccupationSkillSet>>;
  getExplanationAvailability: ExplanationAvailability;
  getFailedEventsCount: Scalars['Float']['output'];
  getFavoriteCandidateIds: Array<CandidateId>;
  getFavoriteCandidates: Array<Candidate>;
  getFavoriteCollections: Array<Collection>;
  getFavoriteCollectionsForUser: Array<Favorite>;
  getFeedback: Feedback;
  getFieldActivityDiff?: Maybe<Array<ActivityDiff>>;
  getFieldsRequiredByTemplates: Array<FieldRequiredByTemplates>;
  getFilteredCandidateBookings: Array<BillingAccount>;
  getFullEducationExamData: EducationExam;
  getGeneralBrokerAddOnConfig?: Maybe<GeneralBrokerAddOnConfig>;
  getGeneralDocumentRequirement?: Maybe<GeneralDocumentRequirement>;
  getGenericBillingYears: Array<BillingYear>;
  getHighestPlacementTest: HighestPlacementEducationExam;
  getImageAccessToken: ImageAccessTokenResult;
  getImmigrationAuthorities: Array<ImmigrationAuthority>;
  getImmigrationCountries: Array<Scalars['String']['output']>;
  getInterviewFeedbackMultiEditBaseline: InterviewFeedbackMultiEditBaseline;
  getInvoice?: Maybe<Invoice>;
  getInvoicePaymentBookingDetail?: Maybe<InvoicePaymentBookingDetail>;
  getInvoicePdfDownloadUrl: Scalars['String']['output'];
  getInvoices: Array<Invoice>;
  getKnowTemplateVariablesDocument: Scalars['String']['output'];
  getKnownPdfFormTokens: Array<KnownPdfFormTokens>;
  getKpis?: Maybe<KpiResults>;
  getLaborAgreement: LaborAgreement;
  getLaborAgreementsForContract: Array<LaborAgreementForContract>;
  getLaborAgreementsForOverview: Array<LaborAgreementForOverview>;
  getLastCommand: ProcessModelCommandGetLatestResult;
  getLatestFinalizedInvoice?: Maybe<Invoice>;
  getLayoutEmailTemplate?: Maybe<EmailTemplate>;
  getLicenseBookingDetail?: Maybe<LicenseBookingDetail>;
  getLingokingAccount?: Maybe<LingokingAccount>;
  getLinkedOrganizations: Array<Organization>;
  getLocalPartnerProfileConfigSet: LocalPartnerProfileConfigSet;
  getMarkedTalents?: Maybe<Array<Talent>>;
  getMergeTags: Scalars['JSONObject']['output'];
  getMessagesReception: MessagesReception;
  getMessengerOptInState?: Maybe<MessengerUserOptIn>;
  getMilestoneCandidateStates: Array<MilestoneCandidateState>;
  getMilestoneDashboardSharing: MilestoneDashboardSharing;
  getMilestoneDashboardSharings: Array<MilestoneDashboardSharing>;
  getMilestoneData: Array<GlobalMilestoneWithMeta>;
  getMilestoneTasks: Array<ProcessWithTasks>;
  getMinimalAnabinAssetById?: Maybe<StaticDataModel>;
  getMinimalAnabinAssetData: Array<StaticDataModel>;
  getMissingDocumentTemplates: Array<Scalars['String']['output']>;
  getMissingEmailTemplates: Array<Scalars['String']['output']>;
  getMissingOrganizationDocuments: Array<Scalars['String']['output']>;
  getMissingSharingNotificationEmailTemplates: Array<Scalars['String']['output']>;
  getMultipleCandidateBookings: Array<BillingAccount>;
  getMultipleChallengeBookings: Array<ChallengeBooking>;
  getMultipleOnlineApplicationConfigurations?: Maybe<Array<OnlineApplicationConfigurationWithOptions>>;
  getMyChatUser?: Maybe<ChatUser>;
  getMyEffectiveInternalConfigs: Array<CandidateProfileConfig>;
  getNewUiDashboardAnkaadiaUpdate?: Maybe<NewUiDashboardAnkaadiaUpdate>;
  getNewUiDashboardCandidateBirthdays: Array<DashboardCandidateBirthdayData>;
  getNewUiDashboardCandidateEventsMetric: NewUiDashboardCandidateEventsMetric;
  getNewUiDashboardCandidateStates: Array<NewUiDashboardCandidateStateData>;
  getNewUiDashboardCandidateStatesAtDate: Array<NewUiDashboardCandidateStateData>;
  getNewUiDashboardOpenTasksMetric: NewUiDashboardOpenTasksMetric;
  getNewUiDashboardSharedCollections: NewUiDashboardSharedCollection;
  getNewUiDashboardTalentPoolRequests: NewUiDashboardTalentPoolRequests;
  getNewUiDashboardTalentPoolSharings: NewUiDashboardTalentPoolSharings;
  getNextOutboxRun: Scalars['AnkaadiaDateTime']['output'];
  getNotUploadedBlobIds?: Maybe<Array<Scalars['String']['output']>>;
  getNote: Note;
  getNotes: Array<Note>;
  getNotificationActivities: NotificationList;
  getNotificationActivityCount: Scalars['Float']['output'];
  getNotificationSettings: NotificationSettings;
  getNotifyUsersOnDeletionRequest?: Maybe<Array<User>>;
  getOnlineApplicationCondition: Array<ConditionDataFormated>;
  getOnlineApplicationConfiguration: OnlineApplicationConfigurationWithOptions;
  getOnlineApplicationConfigurationsOfTask?: Maybe<Array<OnlineApplicationConfigurationWithOptions>>;
  getOnlineApplicationMaintenanceMessages: Array<OnlineApplicationMaintenanceMessage>;
  getOnlineApplicationResultAndScreenshots: OnlineApplicationScreenshotResult;
  getOnlineApplicationResultOfTask: OnlineApplicationScreenshotResult;
  getOnlineApplicationsForCandidate?: Maybe<Array<OnlineApplicationForList>>;
  getOrganizationContact?: Maybe<OrganizationContact>;
  getOrganizationContactSettings?: Maybe<OrganizationContactSettings>;
  getOrganizationContacts: Array<OrganizationContact>;
  getOrganizationContractSettings: OrganizationContractSettings;
  getOrganizationCrm: OrganizationCrm;
  getOrganizationEvents: Array<CandidateEvent>;
  getOrganizationLink: OrganizationLink;
  getOrganizationLinkInvitationByToken: OrganizationLinkInvitation;
  getOrganizationLinkInvitationsOutgoing: Array<OrganizationLinkInvitation>;
  getOrganizationProfile?: Maybe<OrganizationProfile>;
  getOrganizationProfileFields: OrganizationProfileFields;
  getOrganizationTags: Array<OrganizationTag>;
  getOrganizationsCandidatesAreSharedTo: Array<Organization>;
  getOrganizationsForAssignment: Array<Organization>;
  getOrganizationsForCandidateTransfer: Array<Organization>;
  getOrganizationsForCollectionSelection: Array<Organization>;
  getOrganizationsLinkedTo: Array<Organization>;
  getOrganizationsOfGroup: Array<Organization>;
  getOrganizationsSharingTabOfCandidate: Array<Organization>;
  getOrganizationsWithProcesses: Array<Organization>;
  getOrganizationsWithServiceEnabled: Array<Scalars['String']['output']>;
  getOutStandingConsents: Array<TermsAndConditionsForDisplay>;
  getOutboxEmail?: Maybe<Email>;
  getOutboxForProcess: Array<EmailForList>;
  getOwnAndSharedOrganizationEvents: Array<CandidateEvent>;
  getPdfFormTemplate: PdfFormTemplate;
  getPdfFormTemplateSettings: PdfFormTemplateSettings;
  getPendingEventsCount: Scalars['Float']['output'];
  getPhaseModel: ProcessPhaseModelEntity;
  getPlan: Plan;
  getPlanIdsInUse: Array<Scalars['ID']['output']>;
  getPlanningDataForView: Array<PlanningSharing>;
  getPlanningForTask: ProcessPlanningTask;
  getPlanningNodesForProcess: Array<ProcessPlanningNode>;
  getPlanningSharing: PlanningSharing;
  getPlanningSharings: Array<PlanningSharing>;
  getPlanningSharingsForProcess: Array<PlanningSharing>;
  getPlanningStatesForList: Array<PlanningStateForList>;
  getPlanningsForComparison: PlanningDifferenceMap;
  getPlans: Array<Plan>;
  getPredecessors: Array<ProcessPredecessorPhase>;
  getPredefinedProcessModels: Array<PredefinedProcessModelDeclaration>;
  getPredefinedTaxRates: Array<TaxRate>;
  getProcess: Process;
  getProcessAction: ProcessAction;
  getProcessAutomationActivities: Array<Activity>;
  getProcessCandidates: Array<Candidate>;
  getProcessFormly: ProcessFormlyModel;
  getProcessGraphSettings: ProcessGraphSettings;
  getProcessHeatmap: ProcessHeatmap;
  getProcessMilestoneList: ProcessMilestoneList;
  getProcessMilestoneLists: Array<ProcessMilestoneList>;
  getProcessMilestoneMapping: ProcessMilestoneMapping;
  getProcessMilestoneSharing: ProcessMilestoneSharing;
  getProcessMilestoneSharings: Array<ProcessMilestoneSharing>;
  getProcessModel: ProcessModelResult;
  getProcessModelCopySource: Scalars['JSONObject']['output'];
  getProcessModelCopySourceOrganizations: Array<ProcessModelCopySourceOrganization>;
  getProcessModelCopySources: Array<ProcessModelCopySource>;
  getProcessModelForReleaseSelection: ProcessModel;
  getProcessModelTree: ProcessModelTree;
  getProcessParties: Array<Organization>;
  /** The phases of a running process, used to group its tasks in the process reset dialog (AB#9601). */
  getProcessPhases: Array<ProcessPhase>;
  getProcessPreset?: Maybe<ProcessPreset>;
  getProcessProgress: ProcessProgress;
  getProcessesForCandidate: Array<ProcessWithParticipation>;
  getProcessesForDelegation: Array<ProcessForDelegation>;
  getProcessesForOrganization: Array<ProcessWithParticipation>;
  getProcessesOrganizationsForCandidate: Array<Organization>;
  getProcessesRolesForCandidate: Array<ProcessRole>;
  getProcessingLogs: Array<BillingEventProcessingLog>;
  getProfessionAreas?: Maybe<Array<StaticDataModel>>;
  getProfessionConfiguration?: Maybe<ProfessionConfiguration>;
  getProfessionDefaults?: Maybe<ProfessionDefaults>;
  getProfessionSubAreas?: Maybe<Array<StaticDataModel>>;
  getProfessionTree?: Maybe<Array<TreeDataModel>>;
  getProfessionalExperience: ProfessionalExperience;
  getProfessionalExperiences: Array<ProfessionalExperience>;
  getProfessionalExperiencesByType: Array<ProfessionalExperience>;
  getProfessionalField: ProfessionalField;
  getProfessionalFieldSettings?: Maybe<ProfessionalFieldSettings>;
  getProfessionalFields: Array<ProfessionalField>;
  getProfessions?: Maybe<Array<StaticDataModel>>;
  getProperties: Array<PropertyDefinition>;
  getPublicStaticData?: Maybe<StaticDataResult>;
  getPublishedProcessModels?: Maybe<PublishedProcessModelEntity>;
  getQueueInfo: QueueInfo;
  getReCertificationLink: Scalars['String']['output'];
  getReadableTalentPools: Array<TalentPool>;
  getRecognitionAuthorities: Array<RecognitionAuthority>;
  getReleaseHistory: Array<ReleasedProcessModelInfo>;
  getRelevantConsentForUser: Array<Consent>;
  getReplacementsForCandidate?: Maybe<Array<Candidate>>;
  getRequiredConsents: Array<RequiredConsentSummary>;
  getRequiredDocument: RequiredDocument;
  getRequiredDocumentsForCandidate: Array<RequiredDocument>;
  getRequiredDocumentsForOrganization: Array<RequiredDocument>;
  getRequiredVaccinationStatesForCandidates?: Maybe<Array<CandidateVaccinationStatus>>;
  getRequiredVaccinations?: Maybe<Array<RequiredVaccinationsResultEntry>>;
  getRequiredVaccinationsConfiguration: RequiredVaccinations;
  getRoleDefinitions: Array<ProcessModelRole>;
  getSelectableCollections: Array<CollectionAndSharing>;
  getSelectableEducationModules: Array<EducationModule>;
  getSelectableOrganizationTags: SelectableOrganizationTags;
  getSelectableOrganizations: Array<Organization>;
  getSentMessage: MessengerMessage;
  getServiceConfiguration: AddInServiceConfiguration;
  getServiceInfos: Array<AddOnServiceInfo>;
  getSettingsForCandidateOrganization: SystemSettingsForCandidateOrg;
  getSharedCollectionEvents: Array<CandidateEvent>;
  getSharing: Sharing;
  getSharingActivities: Array<Activity>;
  getSharingDocuments: Array<Document>;
  getSharingPreset: SharingPreset;
  getSharingPresets: Array<SharingPreset>;
  getSharingState: SharingState;
  getSharingsForCollection: Array<Sharing>;
  getSharingsForOrganization: Array<Sharing>;
  getSigningAuditLogUrl?: Maybe<Scalars['String']['output']>;
  getSigningEnabledTemplates: Array<SigningEnabledTemplate>;
  getSigningInitiationRoles: Array<SigningInitiationRole>;
  getSigningInitiationTemplate: SigningInitiationTemplate;
  getStartCandidateChatGroupConversationsOptions: Array<StartCandidateChatGroupConversationOption>;
  getStartCandidateChatGroupConversationsOptionsForCandidate: Array<StartCandidateChatGroupConversationOption>;
  getState?: Maybe<ProcessStateResult>;
  getStaticData?: Maybe<StaticDataResult>;
  getStoredProcessModels: Array<ProcessModelResult>;
  getSupplementableInvoice?: Maybe<SupplementableInvoice>;
  getSupportedDashboardLists: Array<ProcessMilestoneList>;
  getSupportedMilestoneLists: Array<ProcessMilestoneList>;
  getSwitchableOrganizations: Array<Organization>;
  getSystemSetting: SystemSetting;
  getTalentByIdRestricted?: Maybe<Talent>;
  getTalentPool: TalentPool;
  getTalentPoolAnabinInstitutionById?: Maybe<StaticDataModel>;
  getTalentPoolConfig?: Maybe<TalentPoolConfiguration>;
  getTalentPoolCustomSkills: Array<TalentPoolCustomSkill>;
  getTalentPoolCv: TalentPoolCv;
  getTalentPoolCvPublic: TalentPoolCv;
  getTalentPoolFindOccupationSkills?: Maybe<OccupationSkillSet>;
  getTalentPoolImageAccessToken: ImageAccessTokenResult;
  getTalentPoolOrganization: Organization;
  getTalentPoolParticipant: TalentPoolParticipant;
  getTalentPoolParticipants: Array<TalentPoolParticipant>;
  getTalentPoolRequestedTalentsIncoming: Array<TalentPoolRequestedTalentIncoming>;
  getTalentPoolRequestedTalentsOutgoing: Array<TalentPoolRequestedTalentOutgoing>;
  getTalentPoolSharing: TalentPoolSharing;
  getTalentPoolSharings: Array<TalentPoolSharing>;
  getTalentPoolStaticData?: Maybe<StaticDataResult>;
  getTalentPools: Array<TalentPool>;
  getTalentsPublic: PublicTalentPoolSearch;
  getTalentsRestricted: RestrictedTalentPoolSearch;
  getTask: ProcessTaskResult;
  getTaskActivationInfo: ProcessTaskActivationInfo;
  getTaskActivities: Array<Activity>;
  getTaskArchive?: Maybe<Archive>;
  getTaskCopyData: Scalars['String']['output'];
  getTaskDelegationRule: TaskDelegationRule;
  getTaskDelegationRuleForTask?: Maybe<TaskDelegationRuleForTask>;
  getTaskDelegationRulePreconditionMet: Scalars['Boolean']['output'];
  getTaskDelegationRules: Array<TaskDelegationRule>;
  getTaskDelegationSourceOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  getTaskDelegationTargetSharingGaps: Array<TaskDelegationTargetSharingGap>;
  getTaskDelegationTaskModelIdsWithDelegableTasks: Array<Scalars['String']['output']>;
  getTaskDelegationTaskModels: Array<StaticDataModel>;
  getTaskForAct: ProcessTaskAndState;
  getTaskModel?: Maybe<ProcessTaskModelResult>;
  getTaskPreview?: Maybe<ProcessTaskPreview>;
  getTaskReferencedBy: TaskReferencedBy;
  getTaskReminderState?: Maybe<TaskReminderState>;
  getTemplateCondition: ConditionDataFormated;
  getTranslationOrderOverview: Array<TranslationOrderOverviewItem>;
  getUnpublishedProcessModels: Array<ProcessModel>;
  getUnreadChatMessagesCount: Scalars['Float']['output'];
  getUrlForConsent: Scalars['String']['output'];
  getUserBookingDetail?: Maybe<UserBookingDetail>;
  getUserInbox: TaskInbox;
  getUserInboxCount: Scalars['Float']['output'];
  getUserInboxForCandidateView: CandidateTaskInbox;
  getUserLoginsByOrganizationId: Array<UserLogin>;
  getVirtualBookings: VirtualBookingResultForUi;
  getVisibleAreas: Array<ProcessAreaEntity>;
  getVisibleCandidateConversations: Array<ChatConversationPreview>;
  getVisibleCandidateGroupConversations: Array<CandidateChatPreviewGroup>;
  getVisibleDashboardWidgets: Array<DashboardWidgetView>;
  getVisibleGroupConversations: Array<ChatConversationPreview>;
  getVisibleParentTasks: Array<ProcessTaskResult>;
  getVisiblePhases: Array<ProcessPhaseEntity>;
  getVisibleTasks: Array<ProcessTaskResult>;
  getVisibleUserConversations: Array<ChatConversationPreview>;
  getWebhookConfig: WebhookConfig;
  getWebhookConfigs: Array<WebhookConfig>;
  getWritableDocumentTypes: Array<StaticDataModel>;
  getWritableTalentPools: Array<TalentPool>;
  getXLSXProcessTranslationsUploadUrl: Scalars['String']['output'];
  getXLSXTemplateForProcessTranslations: XlsxTemplateResult;
  hasUserAccessToChatGroup: Scalars['Boolean']['output'];
  isBookingSuperUser: Scalars['Boolean']['output'];
  isCandidateFavorite: Favorite;
  isChatEnabled: Scalars['Boolean']['output'];
  isCollectionFavorite: Favorite;
  isMatchingEnabled: Array<IsMatchingEnabled>;
  isOrganizationLicensed: Scalars['Boolean']['output'];
  isSharingPresetUsedInTalentPoolSharing: Scalars['Boolean']['output'];
  isUiParsingEnabled: Scalars['Boolean']['output'];
  lastLoginDate?: Maybe<UserLogin>;
  managedPartnerOrganizationsForUser: Array<Organization>;
  organization: Organization;
  prepareNewTask: ProcessTaskResult;
  previewCandidateAccountingRecordMultiEdit: CandidateAccountingRecordMultiEditPreview;
  previewCandidateInterviewMultiEdit: CandidateInterviewMultiEditPreview;
  previewCandidateListMultiEdit: CandidateListMultiEditPreview;
  previewCandidateMultiEdit: Array<CandidateMultiEditPreview>;
  previewCandidateMultiInvite: Array<CandidateMultiEditPreview>;
  previewCandidateMultiUninvite: Array<CandidateMultiEditPreview>;
  previewEnterMissingInformation: EnterMissingInformationPreview;
  previewEnterMissingInformationV2: EnterMissingInformationV2Preview;
  previewOwnOrganizationUserPriceChange: OwnOrganizationUserPriceChangePreview;
  previewPartnerOrganizationsUserPriceChange: PartnerOrganizationsUserPriceChangePreview;
  processCheckReport?: Maybe<ProcessCheckReportDownload>;
  propertyAndCasualtyInsuranceConfiguration: PropertyAndCasualtyInsuranceConfigurationOutput;
  reconnectAllStripeCustomers: ReconnectAllStripeCustomersResult;
  renderAnkaadiaTerms: PublicTermsAndConditionsForDisplay;
  renderConsentHtml: RenderConsentHtmlResult;
  renderConsentPdf: RenderConsentPdfResult;
  renderEmailTemplate: EmailTemplateRender;
  requestTranslation: PropertyTranslation;
  resolveProtectedShortLink?: Maybe<Scalars['String']['output']>;
  resolveShortLink?: Maybe<Scalars['String']['output']>;
  restartFailedEvents: Scalars['Float']['output'];
  searchOccupationSkills?: Maybe<OccupationSkillSet>;
  searchOrganizations: Array<OrganizationSearchResult>;
  settings: Settings;
  triggerCandidatesBilling: Scalars['Boolean']['output'];
  triggerContingentBilling: Scalars['Boolean']['output'];
  triggerLicenseBilling: Scalars['Boolean']['output'];
  triggerPendingEvents: Scalars['Float']['output'];
  triggerRecurringFeeBilling: Scalars['Boolean']['output'];
  triggerUserAccountBilling: TriggerUserAccountBillingResult;
  updateLingokingAccount: LingokingAccount;
  user: User;
  userGroup: UserGroup;
  userGroups: Array<UserGroup>;
  users: Array<User>;
  usersWithRoles: Array<User>;
  validateApplicationMask: Scalars['Boolean']['output'];
  validateBcaBrokerKey: Scalars['Boolean']['output'];
  validateCandidateInvoiceToCreate: CandidateInvoiceCreationValidationResult;
  validateDocuments: MutationResult;
  validateExpression: Array<ProcessEvaluatorExpressionError>;
  validateProcessModel: ProcessModelValidationResult;
  version: Scalars['String']['output'];
};


export type QueryAccrualSnapshotsArgs = {
  filter?: InputMaybe<AccrualSnapshotFilterInput>;
};


export type QueryAiChatSessionsArgs = {
  input: AiChatSessionListInput;
};


export type QueryAreCollectionsFavoriteArgs = {
  input: FavoriteCollectionsInput;
};


export type QueryAreOrganizationLinkedArgs = {
  input: OrganizationLinkedInput;
};


export type QueryCalculateAccrualsArgs = {
  input: AccrualCalculationInput;
};


export type QueryCalculateAccrualsForRangeArgs = {
  input: AccrualRangeCalculationInput;
};


export type QueryCanAccessCandidateEditArgs = {
  input: CandidateAccessInput;
};


export type QueryCanAccessCandidateViewArgs = {
  input: CandidateAccessInput;
};


export type QueryCanAccessCollectionEditArgs = {
  input: CollectionAccessInput;
};


export type QueryCanAccessCollectionViewArgs = {
  input: CollectionAccessInput;
};


export type QueryCanAccessOrganizationLinkInvitationArgs = {
  input: OrganizationLinkInvitationAccessInput;
};


export type QueryCanAccessProcessViewArgs = {
  input: ProcessAccessInput;
};


export type QueryCanAccessTaskActArgs = {
  input: TaskAccessInput;
};


export type QueryCanChatWithCandidateArgs = {
  input: ChatUserExistsInput;
};


export type QueryCheckExistingLingokingCredentialsArgs = {
  input: LingokingAccountCheckExistingCredentialsInput;
};


export type QueryCheckForValidLoginArgs = {
  recipeId: Scalars['String']['input'];
};


export type QueryCheckNewLingokingCredentialsArgs = {
  input: LingokingAccountCheckNewCredentialsInput;
};


export type QueryCheckPublicUserByEmailArgs = {
  email: Scalars['String']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
};


export type QueryCheckRequiredDataArgs = {
  input: OnlineApplicationValidationInput;
  language: Scalars['String']['input'];
};


export type QueryCheckRequiredDataOfTaskArgs = {
  input: OnlineApplicationTaskInput;
  language: Scalars['String']['input'];
};


export type QueryCheckUserGroupHasUsersArgs = {
  input: UserGroupHasMembersInput;
};


export type QueryContactLingokingArgs = {
  input: LingokingContactInput;
};


export type QueryConvertAndGetDocumentDownloadUrlArgs = {
  input: DocumentLoadWithFileNameInput;
};


export type QueryConvertManyDocumentsArgs = {
  input: ConvertManyDocumentsInput;
};


export type QueryCreateLingokingAccountArgs = {
  input: LingokingAccountCreateInput;
};


export type QueryCreateManualBookingArgs = {
  input: CreateManualBookingInput;
};


export type QueryCreateOrganizationAuditReportArgs = {
  input: OrganizationAuditReportInput;
};


export type QueryDeleteLingokingAccountArgs = {
  input: LingokingAccountDeleteInput;
};


export type QueryDetectDocxSigningRolesFromBlobArgs = {
  blob: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryDetectDocxSigningRolesFromContentArgs = {
  base64Content: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryDetectDocxTemplateSigningRolesArgs = {
  organizationId: Scalars['ID']['input'];
  templateName: Scalars['String']['input'];
};


export type QueryDetectZipCodeArgs = {
  input: GeoZipCodeInput;
};


export type QueryDownloadAllDocumentTemplatesForCandidateArgs = {
  input: DownloadDocumentTemplateCandidateInput;
};


export type QueryDownloadAllDocumentTemplatesForCollectionArgs = {
  input: DownloadDocumentTemplateCollectionInput;
};


export type QueryDownloadInvoicesAndCreditNotesForMonthArgs = {
  input: InvoiceAndCreditNoteMonthDownloadInput;
};


export type QueryExerciseBillingEventQueriesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryExerciseCollectionQueriesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryExerciseCustifyQueriesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryExportAssetsArgs = {
  input: ExportAssetInput;
};


export type QueryExportStaticDataArgs = {
  input: ExportStaticDataInput;
};


export type QueryExtractDocumentTypeArgs = {
  input: DocumentTypeExtractionInput;
};


export type QueryFindAllLinkableOrganizationsArgs = {
  input: LinkableOrganizationsInput;
};


export type QueryFindOccupationSkillsArgs = {
  input: OccupationSkillByIdsInput;
};


export type QueryFlattenPdfSignaturesArgs = {
  url: Scalars['String']['input'];
};


export type QueryGenerateCvAsDocxArgs = {
  candidateId: Scalars['String']['input'];
  candidateOrgId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  sharingOrgId: Scalars['String']['input'];
};


export type QueryGenerateExportAndSendToUserArgs = {
  input: XlsxTemplateTriggerExportGetInput;
};


export type QueryGenerateFeedbackReportArgs = {
  input: FeedbackReportInput;
};


export type QueryGenerateProcessRoleAssignmentReportArgs = {
  input: ReportInput;
};


export type QueryGenerateProcessStatusReportArgs = {
  input: ProcessReportInput;
};


export type QueryGenerateProcessTaskListReportArgs = {
  input: ProcessTaskListReportInput;
};


export type QueryGenerateSummaryReportOfAllProcessesArgs = {
  input: ReportInput;
};


export type QueryGenerateVacancyReportArgs = {
  input: VacancyReportInput;
};


export type QueryGetAccountBalanceArgs = {
  input: AccountBalanceGetInput;
};


export type QueryGetActiveContractArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetActiveUserPriceInfoArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetActivitiesArgs = {
  input: ActivityPageInput;
};


export type QueryGetActivityDiffArgs = {
  input: ActivityDiffInput;
};


export type QueryGetActivityFilterCandidatesArgs = {
  input: ActivityCandidateFilterInput;
};


export type QueryGetActivityFilterCollectionsArgs = {
  input: ActivityCollectionFilterInput;
};


export type QueryGetActivityFilterOrganizationsArgs = {
  input: ActivityOrganizationFilterInput;
};


export type QueryGetActivityFilterProcessesArgs = {
  input: ActivityCandidateFilterInput;
};


export type QueryGetActivityFilterUsersArgs = {
  input: ActivityUserFilterInput;
};


export type QueryGetAdHocEducationExamsArgs = {
  input: EducationExamGetByOrgIdInput;
};


export type QueryGetAdHocEducationExamsByCandidateIdArgs = {
  input: AdHocEducationExamGetByCandidateIdInput;
};


export type QueryGetAdHocEducationExamsByCriteriaArgs = {
  input: AdHocEducationExamGetByCriteriaInput;
};


export type QueryGetAddOnBookingDetailArgs = {
  input: AddOnBookingDetailGetByBookingIdInput;
};


export type QueryGetAggregatedMilestoneDataArgs = {
  milestoneListId: Scalars['String']['input'];
};


export type QueryGetAggregatedMilestoneStatesArgs = {
  input: GetAggregatedMilestoneStatesInput;
};


export type QueryGetAllAttachableProcessesArgs = {
  input: AttachableProcessesGetInput;
};


export type QueryGetAllByTemplateGeneratedCollectionsArgs = {
  input: CreatedCollectionsOfAutoFilterTemplateGetInput;
};


export type QueryGetAllCandidateStatesOfTypeArgs = {
  input: GetAllCandidateTasksOfTypeInput;
};


export type QueryGetAllCandidateTasksOfTypeArgs = {
  input: GetAllCandidateTasksOfTypeInput;
};


export type QueryGetAllCandidatesArgs = {
  input: CandidatePageInput;
};


export type QueryGetAllChallengeBookingsArgs = {
  input: ChallengeBookingGetAllInput;
};


export type QueryGetAllChildOrganizationsArgs = {
  input: OrganizationGetChildrenInput;
};


export type QueryGetAllCollectionAutoFilterTemplatesArgs = {
  input: CollectionAutoFilterTemplateGetAllInput;
};


export type QueryGetAllCollectionsArgs = {
  input: CollectionEnumerationInput;
};


export type QueryGetAllConfigsArgs = {
  input: CandidateProfileConfigGetListAllInput;
};


export type QueryGetAllContractTemplatesArgs = {
  input: ContractTemplateListInput;
};


export type QueryGetAllContractsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAllCreditNotesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllDeletionRequestsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetAllDerivableModelsArgs = {
  input: DerivableProcessModelDeclarationGetInput;
};


export type QueryGetAllDocumentOverwritesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetAllDocumentTemplatesArgs = {
  input: DocumentTemplateAllInput;
};


export type QueryGetAllFeedbackForViewArgs = {
  orgId: Scalars['String']['input'];
  sharingId: Scalars['String']['input'];
};


export type QueryGetAllInvoicesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllLocalPartnerProfileConfigSetsArgs = {
  input: LocalPartnerProfileConfigSetGetListAllInput;
};


export type QueryGetAllManagedOrganizationsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAllOnlineApplicationsForImmigrationCountryArgs = {
  input: OnlineApplicationsForImmigrationCountryInput;
};


export type QueryGetAllOrganizationWhichLinkToArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetAllProcessActionsArgs = {
  input: ProcessActionListInput;
};


export type QueryGetAllProcessModelLanguagesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetAllProcessesArgs = {
  input: ProcessListInput;
};


export type QueryGetAllReleasesArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetAllSelectableLicensedOrganizationsArgs = {
  input: OrganizationFindInput;
};


export type QueryGetAllUserGroupsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAllowedTasksConsentsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAlreadySharedOrgIdsArgs = {
  organizationId: Scalars['String']['input'];
  planningId?: InputMaybe<Scalars['String']['input']>;
  snapshotId: Scalars['String']['input'];
};


export type QueryGetAlwaysGeneratedTemplatesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAnabinDegreeDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAnabinInstitutionDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAreaModelArgs = {
  input: ProcessAreaModelGetInput;
};


export type QueryGetAssignableCollectionsForCandidateArgs = {
  input: CollectionListInput;
};


export type QueryGetAssignableMembersArgs = {
  groupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAttachableAutoCollectionsArgs = {
  input: GetAttachableAutoCollectionsInput;
};


export type QueryGetAuditArgs = {
  input: AuditGetInput;
};


export type QueryGetAuditDefinitionArgs = {
  input: AuditDefinitionGetInput;
};


export type QueryGetAuditDefinitionsArgs = {
  input: AuditDefinitionListInput;
};


export type QueryGetAutoGeneratedCvUrlArgs = {
  input: AutoGeneratedCvUrlInput;
};


export type QueryGetAutoTeamsForProcessArgs = {
  organizationId: Scalars['ID']['input'];
  processId?: InputMaybe<Scalars['String']['input']>;
  processModelId: Scalars['String']['input'];
  releaseId?: InputMaybe<Scalars['ID']['input']>;
  releaseSelectionMode?: InputMaybe<ProcessReleaseSelectionModeEnum>;
};


export type QueryGetAvailableAutogenTemplatesArgs = {
  input: AvailableAutogenTemplateListInput;
};


export type QueryGetAvailableDocumentFormatsArgs = {
  input: DocumentFormatsInput;
};


export type QueryGetAvailableDocumentTemplatesArgs = {
  input: AvailableDocumentTemplateGetInput;
};


export type QueryGetAvailableLanguagesArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAvailablePdfFormTemplatesArgs = {
  immigrationCountry: SupportedImmigrationCountry;
  input: PdfFormTemplateListInput;
};


export type QueryGetAvailableProcessModelVersionsArgs = {
  input: AvailableProcessModelVersionsGetInput;
};


export type QueryGetAvailableProcessModelsArgs = {
  input: AvailableProcessModelGetListInput;
};


export type QueryGetAvailableReportTemplatesArgs = {
  input: AvailableReportsGetInput;
};


export type QueryGetAvailableUserGroupsArgs = {
  excludeBlockedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetBillableUserBreakdownArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBillableUserCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBillingHistoryArgs = {
  input: BillingHistoryGetInput;
};


export type QueryGetBillingSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetBillingYearsArgs = {
  input: BillingYearGetAllInput;
};


export type QueryGetCandidateArgs = {
  input: GetCandidateInput;
};


export type QueryGetCandidateAccountingRecordArgs = {
  input: CandidateAccountingRecordGetInput;
};


export type QueryGetCandidateAccountingRecordMultiEditSummaryArgs = {
  input: CandidateAccountingRecordMultiEditCandidatesInput;
};


export type QueryGetCandidateAccountingRecordsArgs = {
  input: CandidateAccountingRecordListInput;
};


export type QueryGetCandidateActivitiesArgs = {
  input: CandidateActivityInput;
};


export type QueryGetCandidateApplicationMaskCandidateOwnerSpecificSettingsArgs = {
  input: SystemSettingsGetInput;
};


export type QueryGetCandidateApplicationMaskConfigArgs = {
  input: CandidateApplicationMaskConfigGetInput;
};


export type QueryGetCandidateApplicationMaskConfigDocumentDownloadUrlArgs = {
  input: CandidateApplicationMaskConfigDocumentDownloadUrlGetInput;
};


export type QueryGetCandidateApplicationMaskConfigDownloadableFilesArgs = {
  input: CandidateApplicationMaskConfigGetDownloadableDocumentsInput;
};


export type QueryGetCandidateApplicationMaskConfigForWebsiteArgs = {
  input: CandidateApplicationMaskConfigGetInput;
};


export type QueryGetCandidateApplicationMaskConfigsArgs = {
  input: CandidateApplicationMaskConfigListInput;
};


export type QueryGetCandidateApplicationMaskDownloadableFilesArgs = {
  input: CandidateApplicationMaskConfigGetDownloadableDocumentsPublicInput;
};


export type QueryGetCandidateApplicationMaskErrorArgs = {
  input: CandidateApplicationMaskErrorGetInput;
};


export type QueryGetCandidateApplicationMaskImageAccessTokenArgs = {
  input: ImageAccessInput;
};


export type QueryGetCandidateApplicationMaskOrganizationArgs = {
  input: CandidateApplicationMaskBaseInput;
};


export type QueryGetCandidateApplicationMaskProfessionAreasArgs = {
  input: ProfessionInput;
};


export type QueryGetCandidateApplicationMaskProfessionConfigurationArgs = {
  input: ProfessionConfigurationGetInput;
};


export type QueryGetCandidateApplicationMaskProfessionSubAreasArgs = {
  input: ProfessionInput;
};


export type QueryGetCandidateApplicationMaskProfessionsArgs = {
  input: ProfessionInput;
};


export type QueryGetCandidateApplicationMaskPublicAnabinDegreeDetailsArgs = {
  input: CandidateApplicationMaskDegreeOrInstitutionByIdInput;
};


export type QueryGetCandidateApplicationMaskPublicAnabinInstitutionDetailsArgs = {
  input: CandidateApplicationMaskDegreeOrInstitutionByIdInput;
};


export type QueryGetCandidateApplicationMaskPublicAvailableCommunicationLanguagesArgs = {
  input: CandidateApplicationMaskBaseInput;
};


export type QueryGetCandidateApplicationMaskPublicDocumentDownloadUrlArgs = {
  input: CandidateApplicationMaskConfigPublicDocumentDownloadUrlGetInput;
};


export type QueryGetCandidateApplicationMaskPublicMinimalAnabinAssetByIdArgs = {
  input: CandidateApplicationMaskAnabinByIdInput;
};


export type QueryGetCandidateApplicationMaskPublicMinimalAnabinAssetDataArgs = {
  input: CandidateApplicationMaskAnabinMinimalInput;
};


export type QueryGetCandidateApplicationMaskSettingsArgs = {
  input: CandidateApplicationMaskConfigGetInput;
};


export type QueryGetCandidateApplicationMaskStaticDataArgs = {
  input: CandidateApplicationMaskStaticDataModelInput;
};


export type QueryGetCandidateApplicationMaskTempDownloadUrlArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetCandidateApplicationMaskUploadUrlArgs = {
  input: GetApplicationMaskUploadUrl;
};


export type QueryGetCandidateArchiveArgs = {
  input: CandidateArchiveInput;
};


export type QueryGetCandidateBookingDetailArgs = {
  input: CandidateBookingDetailGetInputByBookingId;
};


export type QueryGetCandidateColumnValuesArgs = {
  input: GetCandidateColumnValuesInput;
};


export type QueryGetCandidateDeletionRequestArgs = {
  input: CandidateDeletionRequestInput;
};


export type QueryGetCandidateDiffArgs = {
  input: CandidateDiffInput;
};


export type QueryGetCandidateDocumentTemplatesArgs = {
  input: DocumentTemplateCandidateInput;
};


export type QueryGetCandidateEventsArgs = {
  input: CandidateEventsInput;
};


export type QueryGetCandidateFieldTranslationsArgs = {
  input: PropertyTranslationInput;
};


export type QueryGetCandidateForEditArgs = {
  input: GetCandidateForEdit;
};


export type QueryGetCandidateForViewArgs = {
  input: CandidateIdInput;
};


export type QueryGetCandidateInboxArgs = {
  input: StatesInboxInput;
};


export type QueryGetCandidateInfoArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetCandidateInterviewIterationsArgs = {
  input: CandidateFeedbackGetInput;
};


export type QueryGetCandidateInterviewMultiEditSummaryArgs = {
  input: CandidateInterviewMultiEditCandidatesInput;
};


export type QueryGetCandidateListMultiEditSummaryArgs = {
  input: CandidateListMultiEditCandidatesInput;
};


export type QueryGetCandidateMultiEditConfigurationArgs = {
  input: CandidateMultiEditConfigurationInput;
};


export type QueryGetCandidateProfileTabFieldLabelsArgs = {
  tabKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCandidateReceiptArgs = {
  organizationId: Scalars['ID']['input'];
  receiptId: Scalars['ID']['input'];
};


export type QueryGetCandidateStaticDataContextInformationArgs = {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetCandidateStatusHistoryArgs = {
  input: CandidateStatusHistoryGetInput;
};


export type QueryGetCandidateTagsArgs = {
  input: CandidateTagGetInput;
};


export type QueryGetCandidateTransferLogArgs = {
  input: CandidateTransferLogGetInput;
};


export type QueryGetCandidatesByDisplayIdArgs = {
  input: GetCandidatesByDisplayIdInput;
};


export type QueryGetCandidatesForAssignmentArgs = {
  input: CollectionCandidatePageInput;
};


export type QueryGetCandidatesForBookingArgs = {
  input: CandidatePageInput;
};


export type QueryGetCandidatesOfCollectionArgs = {
  input: CollectionCandidatePageInput;
};


export type QueryGetCandidatesOfCollectionForViewArgs = {
  input: CandidatesOfCollectionForViewInput;
};


export type QueryGetCascadedLinkedOrganizationsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetCascadedLinkedOrganizationsFromSourceOrganizationArgs = {
  input: OrganizationListInput;
};


export type QueryGetCertificateValuationAuthoritiesArgs = {
  input: CertificateValuationAuthorityInput;
};


export type QueryGetCertifiedEducationExamsArgs = {
  input: EducationExamGetByCandidateIdInput;
};


export type QueryGetChamberOfCraftsArgs = {
  input: ChamberOfCraftsInput;
};


export type QueryGetChatConfigurationArgs = {
  input: ChatConfigurationGetInput;
};


export type QueryGetChatGroupArgs = {
  input: ChatGroupGetInput;
};


export type QueryGetChatGroupConfigurationArgs = {
  input: ChatGroupConfigurationGetInput;
};


export type QueryGetChatGroupConfigurationsArgs = {
  input: ChatGroupConfigurationListInput;
};


export type QueryGetChatPartnerCandidatesArgs = {
  input: ChatPartnerUserInput;
};


export type QueryGetChatPartnerOrganizationsArgs = {
  input: ChatPartnerOrganizationInput;
};


export type QueryGetChatPartnerUserGroupsArgs = {
  input: ChatPartnerUserGroupsInput;
};


export type QueryGetChatPartnerUsersArgs = {
  input: ChatPartnerUserInput;
};


export type QueryGetChildTasksByParentIdArgs = {
  input: ProcessChildTasksInput;
};


export type QueryGetCollectionArgs = {
  input: CollectionQueryInput;
};


export type QueryGetCollectionAutoFilterArgs = {
  input: CollectionAutoFilterGetInput;
};


export type QueryGetCollectionAutoFilterTemplateArgs = {
  input: CollectionAutoFilterTemplateGetInput;
};


export type QueryGetCollectionDocumentTemplatesArgs = {
  input: DocumentTemplateCollectionInput;
};


export type QueryGetCollectionEmptyStatusArgs = {
  collectionIds: Array<CollectionIdInput>;
};


export type QueryGetCollectionEventsArgs = {
  input: CollectionEventsInput;
};


export type QueryGetCollectionFilterPresetArgs = {
  input: CollectionFilterPresetGetInput;
};


export type QueryGetCollectionFilterPresetsArgs = {
  input: CollectionFilterPresetListInput;
};


export type QueryGetCollectionForPreselectionArgs = {
  input: GetCandidateInput;
};


export type QueryGetCollectionOrganizationsArgs = {
  colId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  withSharingEnabledParameter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCollectionsForAssignmentArgs = {
  input: CollectionForAssignmentInput;
};


export type QueryGetCollectionsForCandidateArgs = {
  candidateId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};


export type QueryGetCollectionsForDelegationArgs = {
  input: CollectionForDelegationInput;
};


export type QueryGetCollectionsSharedToOrganizationArgs = {
  input: CollectionSharingByOrgAndTypeInput;
};


export type QueryGetCommandHistoryArgs = {
  input: ProcessModelCommandHistoryGetInputType;
};


export type QueryGetCommentedStatesIdsArgs = {
  input: GetCommentsInput;
};


export type QueryGetCommissionBookingDetailArgs = {
  input: CommissionBookingDetailGetInputByBookingId;
};


export type QueryGetCommissionCreditBalanceArgs = {
  input: CommissionCreditBalanceGetInput;
};


export type QueryGetConfigArgs = {
  input: CandidateProfileConfigGetInput;
};


export type QueryGetConfigByStatusAndFunctionArgs = {
  input: CandidateProfileConfigGetByFunctionAndStatusInput;
};


export type QueryGetConsentArgs = {
  auth0UserId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetConsentHistoryDetailArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetConsentHistoryListArgs = {
  consentGiverId: Scalars['ID']['input'];
  consentIdentifier: KnownConsentIdentifiers;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetConsentsArgs = {
  input: ConsentListInput;
};


export type QueryGetContingentBookingDetailArgs = {
  input: ContingentBookingDetailGetInputByBookingId;
};


export type QueryGetContingentDefinitionArgs = {
  contingentDefinitionId: Scalars['ID']['input'];
};


export type QueryGetContingentDefinitionSetArgs = {
  contingentDefinitionSetId: Scalars['ID']['input'];
};


export type QueryGetContingentsArgs = {
  contractId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetContractArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetContractBillingEventTypesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetContractTemplateArgs = {
  input: ContractTemplateGetInput;
};


export type QueryGetCourseEventsArgs = {
  input: CourseEventsInput;
};


export type QueryGetCreatableDocumentTypesArgs = {
  input: CandidateDocumentListInput;
};


export type QueryGetCreatableInvoicesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetCredentialsArgs = {
  input: CredentialsInput;
};


export type QueryGetCredentialsForEditArgs = {
  input: CredentialsInput;
};


export type QueryGetCreditNoteBookingDetailArgs = {
  input: CreditNoteBookingDetailGetInputByBookingId;
};


export type QueryGetCreditNotePdfDownloadUrlArgs = {
  creditNoteId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetCreditNotesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetCurrentPublicApiAccessTokenArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetCustomSkillSetsArgs = {
  input: CustomSkillSetInput;
};


export type QueryGetCustomerArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetCustomerPortalUrlArgs = {
  input: BillingSettingsGetCustomerPortalUrlInput;
};


export type QueryGetCvParsingAddOnConfigArgs = {
  input: CvParsingAddOnConfigGetInput;
};


export type QueryGetCvParsingConsumptionArgs = {
  candidateOrganizationId: Scalars['String']['input'];
};


export type QueryGetDashboardMetricsArgs = {
  input: DashboardMetricInput;
};


export type QueryGetDashboardWidgetArgs = {
  input: DashboardWidgetGetInput;
};


export type QueryGetDataForFormerAuditArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryGetDataStrategiesArgs = {
  input: GetDataStrategiesInput;
};


export type QueryGetDataStrategyConfigurationFormlyArgs = {
  input: GetDataStrategyConfigurationInput;
};


export type QueryGetDataStrategyGenerationFormlyArgs = {
  input: GetDataStrategyGenerationInput;
};


export type QueryGetDelegatedTasksArgs = {
  input: DelegatedTaskListInput;
};


export type QueryGetDeniedTaskTypesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetDiplomaticMissionsAbroadArgs = {
  input: DiplomaticMissionInput;
};


export type QueryGetDiplomaticMissionsAtHomeArgs = {
  input: DiplomaticMissionInput;
};


export type QueryGetDocumentArgs = {
  input: DocumentGetInput;
};


export type QueryGetDocumentAiUploadUrlArgs = {
  input: DocumentAiUploadInput;
};


export type QueryGetDocumentByTypeArgs = {
  input: DocumentGetByTypeInput;
};


export type QueryGetDocumentDetectedLanguageArgs = {
  input: CandidateDocumentMetadataInput;
};


export type QueryGetDocumentDownloadUrlArgs = {
  input: DocumentLoadInput;
};


export type QueryGetDocumentDownloadUrlWithFileNameArgs = {
  input: DocumentLoadWithFileNameInput;
};


export type QueryGetDocumentDownloadWithContainerUrlArgs = {
  input: DocumentLoadWithContainerInput;
};


export type QueryGetDocumentRequirementArgs = {
  input: DocumentRequirementGetInput;
};


export type QueryGetDocumentRequirementByTypeArgs = {
  input: DocumentRequirementGetByTypeInput;
};


export type QueryGetDocumentRequirementsArgs = {
  input: DocumentRequirementListInput;
};


export type QueryGetDocumentTemplateArgs = {
  input: DocumentTemplateGetInput;
};


export type QueryGetDocumentTemplateProcessUsageArgs = {
  input: DocumentTemplateProcessUsageInput;
};


export type QueryGetDocumentTranslationStateForDocumentArgs = {
  input: GetDocumentTranslationStateForDocumentInput;
};


export type QueryGetDocumentTypeOverwriteArgs = {
  input: DocumentTypeOverwriteGetInput;
};


export type QueryGetDocumentUploadUrlArgs = {
  input: DocumentLoadInput;
};


export type QueryGetDocumentUploadWithContainerUrlArgs = {
  input: DocumentLoadWithContainerInput;
};


export type QueryGetDocumentsArgs = {
  input: DocumentListInput;
};


export type QueryGetDocumentsByTypesArgs = {
  input: DocumentGetByTypesInput;
};


export type QueryGetDocxSigningSubmissionsByIdsArgs = {
  candidateId: Scalars['ID']['input'];
  docusealSubmissionIds: Array<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetDocxSigningSubmissionsForCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<SigningSubmissionFilterStatus>>;
};


export type QueryGetEducationCourseArgs = {
  input: EducationCourseGetInput;
};


export type QueryGetEducationCoursePerformanceArgs = {
  input: EducationCoursePerformanceListInput;
};


export type QueryGetEducationCoursePerformanceByCandidateArgs = {
  input: EducationCoursePerformanceByCandidateGetInput;
};


export type QueryGetEducationCourseTotalPerformanceArgs = {
  input: EducationCourseTotalPerformanceGetInput;
};


export type QueryGetEducationCourseTotalPerformancesForCandidateArgs = {
  input: EducationCourseTotalPerformancesForCandidateInput;
};


export type QueryGetEducationCourseWeeklyPerformanceArgs = {
  input: EducationCourseWeeklyPerformanceGetInput;
};


export type QueryGetEducationCoursesArgs = {
  input: EducationCourseListInput;
};


export type QueryGetEducationCoursesForCandidateArgs = {
  input: EducationCourseListForCandidateInput;
};


export type QueryGetEducationExamDataArgs = {
  input: EducationExamGetByIdInput;
};


export type QueryGetEducationExamForTaskArgs = {
  input: EducationExamOptionsForTaskInput;
};


export type QueryGetEducationExamOptionsForTaskArgs = {
  input: EducationExamOptionsForTaskInput;
};


export type QueryGetEducationExamParticipantsArgs = {
  input: EducationExamParticipantGetInput;
};


export type QueryGetEducationExamParticipationForTaskArgs = {
  input: EducationExamParticipationForTaskInput;
};


export type QueryGetEducationExamResultsByCandidateIdArgs = {
  input: EducationExamResultsByCandidateIdInput;
};


export type QueryGetEducationExamResultsByExamIdArgs = {
  input: EducationExamResultListInput;
};


export type QueryGetEducationExamResultsUpdateTableArgs = {
  input: EducationExamResultListInput;
};


export type QueryGetEducationExamsArgs = {
  input: EducationExamGetByOrgIdInput;
};


export type QueryGetEducationExamsByCandidateIdArgs = {
  input: EducationExamGetByCandidateIdInput;
};


export type QueryGetEducationExamsByCourseIdArgs = {
  input: EducationExamGetByCourseIdInput;
};


export type QueryGetEducationExamsByCriteriaArgs = {
  input: EducationExamGetByCriteriaInput;
};


export type QueryGetEducationExamsForCandidateByCriteriaArgs = {
  input: EducationExamForCandidateGetByCriteriaInput;
};


export type QueryGetEducationModuleArgs = {
  input: EducationModuleGetInput;
};


export type QueryGetEducationModulesArgs = {
  input: EducationModuleListInput;
};


export type QueryGetEffectiveDocumentAccessArgs = {
  input: SharingDocumentQueryInput;
};


export type QueryGetEffectiveFileAccessArgs = {
  input: SharingFileQueryInput;
};


export type QueryGetEffectiveSharingArgs = {
  input: EffectiveSharingInput;
};


export type QueryGetEffectiveSharingForMultiEditArgs = {
  input: EffectiveSharingForMultiEditInput;
};


export type QueryGetEmailArgs = {
  input: EmailGetInput;
};


export type QueryGetEmailSendOutRuleArgs = {
  organizationId: Scalars['ID']['input'];
  ruleId: Scalars['String']['input'];
};


export type QueryGetEmailTemplateArgs = {
  input: EmailTemplateGetInput;
};


export type QueryGetEmailTemplateProcessUsageArgs = {
  input: EmailTemplateProcessUsageInput;
};


export type QueryGetEmailTemplatesArgs = {
  input: EmailTemplateListInput;
};


export type QueryGetEmailTemplatesByTypeArgs = {
  input: EmailTemplateTypeInput;
};


export type QueryGetEmailTemplatesWithUsageInfoArgs = {
  input: EmailTemplateListInput;
};


export type QueryGetEmailsForCandidateArgs = {
  input: EmailListForCandidateInput;
};


export type QueryGetEmailsForOrganizationLinkInvitationArgs = {
  input: EmailListForOrganizationLinkInvitationInput;
};


export type QueryGetEmailsForProcessArgs = {
  input: EmailListForProcessInput;
};


export type QueryGetEmailsForUserArgs = {
  input: EmailListForUserInput;
};


export type QueryGetEmployerArgs = {
  input: EmployerGetInput;
};


export type QueryGetEmployerApplicationsArgs = {
  input: EmployerApplicationGetInput;
};


export type QueryGetEmployerFilterDefaultsArgs = {
  input: EmployerListInput;
};


export type QueryGetEmployerFilterFieldsArgs = {
  input: EmployerListInput;
};


export type QueryGetEmployersArgs = {
  input: EmployerListInput;
};


export type QueryGetEmploymentApprovalAuthoritiesArgs = {
  input: EmploymentApprovalAuthorityInput;
};


export type QueryGetEmploymentApprovalAuthorityByIdArgs = {
  input: EmploymentApprovalAuthorityByIdInput;
};


export type QueryGetEnabledServiceCategoriesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetEnabledServicesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetEnabledSharingArgs = {
  input: SharingCollectionQueryInput;
};


export type QueryGetEnterMissingInformationV2MultiEditBaselineArgs = {
  input: EnterMissingInformationV2MultiEditBaselineInput;
};


export type QueryGetEscoSkillsByProfessionArgs = {
  input: EscoSkillByProfessionInput;
};


export type QueryGetEscoSkillsByProfessionAndOrganizationArgs = {
  input: EscoSkillByProfessionAndOrganizationInput;
};


export type QueryGetExplanationAvailabilityArgs = {
  input: ExplanationAvailabilityInput;
};


export type QueryGetFailedEventsCountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetFavoriteCandidatesArgs = {
  input?: InputMaybe<FavoriteCollectionInput>;
};


export type QueryGetFavoriteCollectionsArgs = {
  input: FavoriteCollectionsWithSharingByOrgInput;
};


export type QueryGetFeedbackArgs = {
  feedbackId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};


export type QueryGetFieldActivityDiffArgs = {
  input: FieldActivityDiffInput;
};


export type QueryGetFieldsRequiredByTemplatesArgs = {
  input: FieldsRequiredByTemplatesInput;
};


export type QueryGetFilteredCandidateBookingsArgs = {
  input: BillingAccountGetFilteredInput;
};


export type QueryGetFullEducationExamDataArgs = {
  input: EducationExamGetByIdInput;
};


export type QueryGetGeneralBrokerAddOnConfigArgs = {
  input: GeneralBrokerAddOnConfigGetInput;
};


export type QueryGetGeneralDocumentRequirementArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetHighestPlacementTestArgs = {
  input: EducationExamGetByCandidateIdInput;
};


export type QueryGetImageAccessTokenArgs = {
  input: ImageAccessInput;
};


export type QueryGetImmigrationAuthoritiesArgs = {
  input: ImmigrationAuthorityInput;
};


export type QueryGetImmigrationCountriesArgs = {
  input: CollectionInput;
};


export type QueryGetInterviewFeedbackMultiEditBaselineArgs = {
  input: InterviewFeedbackMultiEditBaselineInput;
};


export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetInvoicePaymentBookingDetailArgs = {
  input: InvoicePaymentBookingDetailGetInputByBookingId;
};


export type QueryGetInvoicePdfDownloadUrlArgs = {
  invoiceId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetInvoicesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetKnowTemplateVariablesDocumentArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetKnownPdfFormTokensArgs = {
  input: PdfFormTemplateListInput;
};


export type QueryGetKpisArgs = {
  input: KpiGetInput;
};


export type QueryGetLaborAgreementArgs = {
  input: LaborAgreementGetInput;
};


export type QueryGetLaborAgreementsForContractArgs = {
  input: LaborAgreementListInput;
};


export type QueryGetLaborAgreementsForOverviewArgs = {
  input: LaborAgreementListInput;
};


export type QueryGetLastCommandArgs = {
  input: ProcessModelCommandGetLatestInput;
};


export type QueryGetLatestFinalizedInvoiceArgs = {
  input: LatestFinalizedInvoiceGetInput;
};


export type QueryGetLayoutEmailTemplateArgs = {
  input: EmailTemplateListInput;
};


export type QueryGetLicenseBookingDetailArgs = {
  input: LicenseBookingDetailGetInputByBookingId;
};


export type QueryGetLingokingAccountArgs = {
  input: LingokingAccountGetInput;
};


export type QueryGetLinkedOrganizationsArgs = {
  input: OrganizationFindInput;
};


export type QueryGetLocalPartnerProfileConfigSetArgs = {
  input: LocalPartnerProfileConfigSetGetInput;
};


export type QueryGetMergeTagsArgs = {
  emailTarget?: InputMaybe<EmailTemplateTarget>;
  organizationId: Scalars['String']['input'];
  sendSeparateUserEmailsForEachCandidate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetMessagesReceptionArgs = {
  candidateOrUserId: Scalars['String']['input'];
  isCandidate: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetMilestoneCandidateStatesArgs = {
  input: GetMilestoneCandidateStatesInput;
};


export type QueryGetMilestoneDashboardSharingArgs = {
  input: MilestoneDashboardSharingGetInput;
};


export type QueryGetMilestoneDashboardSharingsArgs = {
  input: MilestoneDashboardSharingListInput;
};


export type QueryGetMilestoneDataArgs = {
  input: GetMilestoneDataInput;
};


export type QueryGetMilestoneTasksArgs = {
  input: ProcessVisibleTaskMilestoneInput;
};


export type QueryGetMinimalAnabinAssetByIdArgs = {
  input: AnabinByIdInput;
};


export type QueryGetMinimalAnabinAssetDataArgs = {
  input: AnabinMinimalInput;
};


export type QueryGetMissingDocumentTemplatesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetMissingEmailTemplatesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetMissingOrganizationDocumentsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetMissingSharingNotificationEmailTemplatesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetMultipleCandidateBookingsArgs = {
  input: BillingAccountGetMultipleInput;
};


export type QueryGetMultipleChallengeBookingsArgs = {
  input: ChallengeBookingGetMultipleInput;
};


export type QueryGetMultipleOnlineApplicationConfigurationsArgs = {
  input: OnlineApplicationValidationInput;
};


export type QueryGetMyChatUserArgs = {
  input: GetMyChatUserInput;
};


export type QueryGetNewUiDashboardCandidateBirthdaysArgs = {
  input: NewUiDashboardCandidateBirthdaysInput;
};


export type QueryGetNewUiDashboardCandidateEventsMetricArgs = {
  input: NewUiDashboardCandidateEventsInput;
};


export type QueryGetNewUiDashboardCandidateStatesArgs = {
  input: NewUiDashboardCandidateStatesInput;
};


export type QueryGetNewUiDashboardCandidateStatesAtDateArgs = {
  input: NewUiDashboardCandidateStatesAtDateInput;
};


export type QueryGetNextOutboxRunArgs = {
  input: OutboxRunInput;
};


export type QueryGetNotUploadedBlobIdsArgs = {
  input: BlobUploadCheckInput;
};


export type QueryGetNoteArgs = {
  input: NoteGetInput;
};


export type QueryGetNotesArgs = {
  input: NoteListInput;
};


export type QueryGetNotifyUsersOnDeletionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOnlineApplicationConditionArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetOnlineApplicationConfigurationArgs = {
  input: OnlineApplicationConfigurationRequestInput;
};


export type QueryGetOnlineApplicationConfigurationsOfTaskArgs = {
  input: OnlineApplicationTaskInput;
};


export type QueryGetOnlineApplicationResultAndScreenshotsArgs = {
  input: OnlineApplicationExecutionInput;
};


export type QueryGetOnlineApplicationResultOfTaskArgs = {
  input: OnlineApplicationTaskInput;
};


export type QueryGetOnlineApplicationsForCandidateArgs = {
  input: OnlineApplicationInput;
};


export type QueryGetOrganizationContactArgs = {
  input: OrganizationContactGetInput;
};


export type QueryGetOrganizationContactSettingsArgs = {
  input: OrganizationContactSettingsGetInput;
};


export type QueryGetOrganizationContactsArgs = {
  input: OrganizationContactListInput;
};


export type QueryGetOrganizationContractSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetOrganizationCrmArgs = {
  input: OrganizationCrmGetInput;
};


export type QueryGetOrganizationEventsArgs = {
  input: OrganizationEventsInput;
};


export type QueryGetOrganizationLinkArgs = {
  input: OrganizationLinkGetInput;
};


export type QueryGetOrganizationLinkInvitationByTokenArgs = {
  input: OrganizationLinkInvitationTokenInput;
};


export type QueryGetOrganizationLinkInvitationsOutgoingArgs = {
  organizationId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<OrganizationLinkInvitationStatus>>;
};


export type QueryGetOrganizationProfileArgs = {
  input: OrganizationProfileGetInput;
};


export type QueryGetOrganizationProfileFieldsArgs = {
  input: OrganizationProfileGetInput;
};


export type QueryGetOrganizationTagsArgs = {
  input: OrganizationTagListInput;
};


export type QueryGetOrganizationsCandidatesAreSharedToArgs = {
  input: CollectionQueryInput;
};


export type QueryGetOrganizationsForAssignmentArgs = {
  input: OrganizationForAssignmentInput;
};


export type QueryGetOrganizationsForCandidateTransferArgs = {
  input: CandidateTransferTargetOrganizationsInput;
};


export type QueryGetOrganizationsForCollectionSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationsLinkedToArgs = {
  input: OrganizationFindInput;
};


export type QueryGetOrganizationsOfGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationsSharingTabOfCandidateArgs = {
  input: OrganizationsBySharedTabInput;
};


export type QueryGetOrganizationsWithProcessesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationsWithServiceEnabledArgs = {
  serviceId: AddOnServicesEnum;
};


export type QueryGetOutStandingConsentsArgs = {
  input: GetOutstandingConsentsInput;
};


export type QueryGetOutboxEmailArgs = {
  input: EmailGetInput;
};


export type QueryGetOutboxForProcessArgs = {
  input: EmailListForProcessInput;
};


export type QueryGetOwnAndSharedOrganizationEventsArgs = {
  input: OrganizationEventsInput;
};


export type QueryGetPdfFormTemplateArgs = {
  input: PdfFormTemplateGetInput;
};


export type QueryGetPdfFormTemplateSettingsArgs = {
  input: PdfFormTemplateSettingsGetInput;
};


export type QueryGetPendingEventsCountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetPhaseModelArgs = {
  input: ProcessPhaseModelGetInput;
};


export type QueryGetPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryGetPlanningDataForViewArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetPlanningForTaskArgs = {
  input: ProcessPlanningForTaskInput;
};


export type QueryGetPlanningNodesForProcessArgs = {
  input: ProcessPlanningInput;
};


export type QueryGetPlanningSharingArgs = {
  planningId: Scalars['String']['input'];
};


export type QueryGetPlanningSharingsArgs = {
  processId: Scalars['String']['input'];
  snapshotId: Scalars['String']['input'];
};


export type QueryGetPlanningSharingsForProcessArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetPlanningStatesForListArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetPlanningsForComparisonArgs = {
  input: PlanningComparisonInput;
};


export type QueryGetPlansArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPredecessorsArgs = {
  input: ProcessTaskListInput;
};


export type QueryGetPredefinedProcessModelsArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetProcessArgs = {
  orgId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetProcessActionArgs = {
  input: ProcessActionGetInput;
};


export type QueryGetProcessAutomationActivitiesArgs = {
  input: ActivityPageInput;
};


export type QueryGetProcessCandidatesArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetProcessFormlyArgs = {
  orgId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetProcessHeatmapArgs = {
  input: ProcessHeatmapInput;
};


export type QueryGetProcessMilestoneListArgs = {
  input: ProcessMilestoneListGetInput;
};


export type QueryGetProcessMilestoneListsArgs = {
  input: ProcessMilestoneListListInput;
};


export type QueryGetProcessMilestoneMappingArgs = {
  input: ProcessMilestoneMappingGetInput;
};


export type QueryGetProcessMilestoneSharingArgs = {
  input: ProcessMilestoneSharingGetInput;
};


export type QueryGetProcessMilestoneSharingsArgs = {
  input: ProcessMilestoneSharingListInput;
};


export type QueryGetProcessModelArgs = {
  input: ProcessModelGetInput;
};


export type QueryGetProcessModelCopySourceArgs = {
  input: ProcessModelCopySourceGetInput;
};


export type QueryGetProcessModelCopySourceOrganizationsArgs = {
  input: ProcessModelCopySourceOrganizationsGetInput;
};


export type QueryGetProcessModelCopySourcesArgs = {
  input: ProcessModelCopySourcesGetInput;
};


export type QueryGetProcessModelForReleaseSelectionArgs = {
  input: ProcessModelForReleaseSelectionInput;
};


export type QueryGetProcessModelTreeArgs = {
  input: ProcessModelTreeGetInput;
};


export type QueryGetProcessPartiesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProcessPhasesArgs = {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
};


export type QueryGetProcessPresetArgs = {
  input: ProcessPresetInput;
};


export type QueryGetProcessProgressArgs = {
  input: ProcessTaskListInput;
};


export type QueryGetProcessesForCandidateArgs = {
  candidateId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};


export type QueryGetProcessesForDelegationArgs = {
  input: ProcessListInput;
};


export type QueryGetProcessesForOrganizationArgs = {
  input: ProcessesForOrganizationInput;
};


export type QueryGetProcessesOrganizationsForCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetProcessesRolesForCandidateArgs = {
  candidateId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetProcessingLogsArgs = {
  input: BillingEventProcessingLogGetAllInput;
};


export type QueryGetProfessionAreasArgs = {
  input: ProfessionInput;
};


export type QueryGetProfessionConfigurationArgs = {
  input: ProfessionConfigurationGetInput;
};


export type QueryGetProfessionDefaultsArgs = {
  input: ProfessionConfigurationGetInput;
};


export type QueryGetProfessionSubAreasArgs = {
  input: ProfessionInput;
};


export type QueryGetProfessionTreeArgs = {
  input: ProfessionInput;
};


export type QueryGetProfessionalExperienceArgs = {
  input: ProfessionalExperienceGetInput;
};


export type QueryGetProfessionalExperiencesArgs = {
  input: ProfessionalExperienceListInput;
};


export type QueryGetProfessionalExperiencesByTypeArgs = {
  input: ProfessionalExperienceGetByTypeInput;
};


export type QueryGetProfessionalFieldArgs = {
  input: ProfessionalFieldGetInput;
};


export type QueryGetProfessionalFieldSettingsArgs = {
  input: ProfessionalFieldSettingsGetInput;
};


export type QueryGetProfessionalFieldsArgs = {
  input: ProfessionalFieldListInput;
};


export type QueryGetProfessionsArgs = {
  input: ProfessionInput;
};


export type QueryGetPropertiesArgs = {
  includeArrays?: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  typeName: Scalars['String']['input'];
  writableOnly?: Scalars['Boolean']['input'];
};


export type QueryGetPublicStaticDataArgs = {
  input: StaticDataModelInput;
};


export type QueryGetPublishedProcessModelsArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetQueueInfoArgs = {
  input: GetQueueInfoInput;
};


export type QueryGetReadableTalentPoolsArgs = {
  input: TalentPoolListInput;
};


export type QueryGetRecognitionAuthoritiesArgs = {
  input: RecognitionAuthorityInput;
};


export type QueryGetReleaseHistoryArgs = {
  input: ProcessModelReleaseListGetInput;
};


export type QueryGetRelevantConsentForUserArgs = {
  input: ConsentForUser;
};


export type QueryGetReplacementsForCandidateArgs = {
  input: CandidateReplacedByInput;
};


export type QueryGetRequiredConsentsArgs = {
  input: GetRequiredConsentsInput;
};


export type QueryGetRequiredDocumentArgs = {
  input: RequiredDocumentGetInput;
};


export type QueryGetRequiredDocumentsForCandidateArgs = {
  input: RequiredDocumentsForCandidateInput;
};


export type QueryGetRequiredDocumentsForOrganizationArgs = {
  input: RequiredDocumentsForOrganizationInput;
};


export type QueryGetRequiredVaccinationStatesForCandidatesArgs = {
  input: RequiredVaccinationsStatesForCollectionInput;
};


export type QueryGetRequiredVaccinationsArgs = {
  input: RequiredVaccinationsForCandidateInput;
};


export type QueryGetRequiredVaccinationsConfigurationArgs = {
  input: RequiredVaccinationsGetInput;
};


export type QueryGetSelectableCollectionsArgs = {
  input: CollectionSharingByOrgAndTypeInput;
};


export type QueryGetSelectableEducationModulesArgs = {
  input: EducationModuleListInput;
};


export type QueryGetSelectableOrganizationTagsArgs = {
  input: SelectableOrganizationTagsGetInput;
};


export type QueryGetSelectableOrganizationsArgs = {
  id: Scalars['ID']['input'];
  sharingTypes?: InputMaybe<Array<SharingTypeEnum>>;
};


export type QueryGetSentMessageArgs = {
  candidateId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryGetServiceConfigurationArgs = {
  input: AddOnServiceBaseResolverInput;
};


export type QueryGetSettingsForCandidateOrganizationArgs = {
  input: SystemSettingsGetInput;
};


export type QueryGetSharedCollectionEventsArgs = {
  input: SharedCollectionEventsInput;
};


export type QueryGetSharingArgs = {
  input: SharingQueryInput;
};


export type QueryGetSharingActivitiesArgs = {
  input: SharingActivityInput;
};


export type QueryGetSharingDocumentsArgs = {
  input: DocumentSharingInput;
};


export type QueryGetSharingPresetArgs = {
  input: SharingPresetGetInput;
};


export type QueryGetSharingPresetsArgs = {
  input: SharingPresetListInput;
};


export type QueryGetSharingStateArgs = {
  input: SharingStateInput;
};


export type QueryGetSharingsForCollectionArgs = {
  input: SharingCollectionQueryInput;
};


export type QueryGetSharingsForOrganizationArgs = {
  input: SharingEnumerationInput;
};


export type QueryGetSigningAuditLogUrlArgs = {
  input: ClaimSigningSlotInput;
};


export type QueryGetSigningEnabledTemplatesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetSigningInitiationRolesArgs = {
  input: GetSigningInitiationRolesInput;
};


export type QueryGetSigningInitiationTemplateArgs = {
  input: GetSigningInitiationTemplateInput;
};


export type QueryGetStartCandidateChatGroupConversationsOptionsArgs = {
  input: StartCandidateChatGroupConversationOptionsRequest;
};


export type QueryGetStateArgs = {
  orgId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryGetStaticDataArgs = {
  input: StaticDataModelInput;
};


export type QueryGetStoredProcessModelsArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetSupplementableInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type QueryGetSupportedMilestoneListsArgs = {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
};


export type QueryGetSwitchableOrganizationsArgs = {
  search: Scalars['String']['input'];
};


export type QueryGetSystemSettingArgs = {
  input: SystemSettingsGetInput;
};


export type QueryGetTalentByIdRestrictedArgs = {
  input: TalentInstanceInput;
};


export type QueryGetTalentPoolArgs = {
  input: TalentPoolGetInput;
};


export type QueryGetTalentPoolAnabinInstitutionByIdArgs = {
  input: PublicTalentPoolAnabinInstitutionByIdInput;
};


export type QueryGetTalentPoolCustomSkillsArgs = {
  input: PublicTalentPoolCustomSkillsInput;
};


export type QueryGetTalentPoolCvArgs = {
  input: TalentPoolCvInput;
};


export type QueryGetTalentPoolCvPublicArgs = {
  input: TalentPoolCvInput;
};


export type QueryGetTalentPoolFindOccupationSkillsArgs = {
  input: PublicTalentPoolOccupationSkillByIdsInputInput;
};


export type QueryGetTalentPoolImageAccessTokenArgs = {
  input: ImageAccessInput;
};


export type QueryGetTalentPoolOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTalentPoolParticipantArgs = {
  input: TalentPoolParticipantGetInput;
};


export type QueryGetTalentPoolParticipantsArgs = {
  input: TalentPoolParticipantListInput;
};


export type QueryGetTalentPoolRequestedTalentsIncomingArgs = {
  input?: InputMaybe<TalentPoolRequestedTalentIncomingInput>;
};


export type QueryGetTalentPoolSharingArgs = {
  input: TalentPoolSharingGetInput;
};


export type QueryGetTalentPoolSharingsArgs = {
  input: TalentPoolSharingListInput;
};


export type QueryGetTalentPoolStaticDataArgs = {
  input: StaticDataModelInput;
};


export type QueryGetTalentPoolsArgs = {
  input: TalentPoolListInput;
};


export type QueryGetTalentsPublicArgs = {
  input: PublicTalentPoolSearchInput;
};


export type QueryGetTalentsRestrictedArgs = {
  input: RestrictedTalentPoolSearchInput;
};


export type QueryGetTaskArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['String']['input'];
  processId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryGetTaskActivationInfoArgs = {
  language: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryGetTaskActivitiesArgs = {
  input: TaskActivityInput;
};


export type QueryGetTaskArchiveArgs = {
  input: TaskArchiveInput;
};


export type QueryGetTaskCopyDataArgs = {
  input: ProcessTaskCopyDataInput;
};


export type QueryGetTaskDelegationRuleArgs = {
  input: TaskDelegationRuleGetInput;
};


export type QueryGetTaskDelegationRuleForTaskArgs = {
  input: TaskDelegationRuleForTaskGetInput;
};


export type QueryGetTaskDelegationRulePreconditionMetArgs = {
  input: TaskDelegationRulePreconditionGetInput;
};


export type QueryGetTaskDelegationRulesArgs = {
  input: TaskDelegationRuleListInput;
};


export type QueryGetTaskDelegationSourceOrganizationIdsArgs = {
  input: TaskDelegationRuleListInput;
};


export type QueryGetTaskDelegationTargetSharingGapsArgs = {
  input: TaskDelegationTargetSharingGetInput;
};


export type QueryGetTaskDelegationTaskModelIdsWithDelegableTasksArgs = {
  input: TaskDelegationRulePreconditionGetInput;
};


export type QueryGetTaskDelegationTaskModelsArgs = {
  input: TaskDelegationTaskModelListInput;
};


export type QueryGetTaskForActArgs = {
  language: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryGetTaskModelArgs = {
  input: ProcessTaskModelGetInput;
};


export type QueryGetTaskPreviewArgs = {
  input: ProcessTaskPreviewInput;
};


export type QueryGetTaskReferencedByArgs = {
  input: GetTaskReferenceByInput;
};


export type QueryGetTaskReminderStateArgs = {
  orgId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryGetTemplateConditionArgs = {
  input: TemplateConditionInput;
};


export type QueryGetTranslationOrderOverviewArgs = {
  input: GetTranslationOrderOverviewInput;
};


export type QueryGetUnpublishedProcessModelsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetUrlForConsentArgs = {
  consentGiverId: Scalars['ID']['input'];
  consentIdentifier: KnownConsentIdentifiers;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetUserBookingDetailArgs = {
  input: UserBookingDetailGetInputByBookingId;
};


export type QueryGetUserInboxArgs = {
  input: UserInboxInput;
};


export type QueryGetUserInboxForCandidateViewArgs = {
  input: CandidateInboxInput;
};


export type QueryGetUserLoginsByOrganizationIdArgs = {
  input: UserLoginListInput;
};


export type QueryGetVirtualBookingsArgs = {
  input: VirtualBookingGetInput;
};


export type QueryGetVisibleAreasArgs = {
  input: ProcessHeatmapInput;
};


export type QueryGetVisibleCandidateConversationsArgs = {
  input: FindChatsInput;
};


export type QueryGetVisibleCandidateGroupConversationsArgs = {
  input?: InputMaybe<FindChatsInput>;
};


export type QueryGetVisibleGroupConversationsArgs = {
  input?: InputMaybe<FindChatsInput>;
};


export type QueryGetVisibleParentTasksArgs = {
  input: ProcessVisibleTaskListInput;
};


export type QueryGetVisiblePhasesArgs = {
  input: ProcessHeatmapInput;
};


export type QueryGetVisibleTasksArgs = {
  input: ProcessVisibleTaskListInput;
};


export type QueryGetVisibleUserConversationsArgs = {
  input?: InputMaybe<FindChatsInput>;
};


export type QueryGetWebhookConfigArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetWebhookConfigsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetWritableDocumentTypesArgs = {
  input: CandidateDocumentListInput;
};


export type QueryGetWritableTalentPoolsArgs = {
  input: TalentPoolListInput;
};


export type QueryGetXlsxProcessTranslationsUploadUrlArgs = {
  input: XlsxProcessTranslationUploadUrlInput;
};


export type QueryGetXlsxTemplateForProcessTranslationsArgs = {
  input: XlsxProcessTranslationGetInput;
};


export type QueryHasUserAccessToChatGroupArgs = {
  input: HasUserAccessToChatGroupInput;
};


export type QueryIsCandidateFavoriteArgs = {
  input: FavoriteCandidateInput;
};


export type QueryIsCollectionFavoriteArgs = {
  input: FavoriteCollectionInput;
};


export type QueryIsMatchingEnabledArgs = {
  input: IsMatchingEnabledInput;
};


export type QueryIsOrganizationLicensedArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryIsSharingPresetUsedInTalentPoolSharingArgs = {
  input: SharingPresetGetInput;
};


export type QueryIsUiParsingEnabledArgs = {
  candidateOrganizationId: Scalars['String']['input'];
};


export type QueryLastLoginDateArgs = {
  input: LastUserLoginInput;
};


export type QueryManagedPartnerOrganizationsForUserArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrepareNewTaskArgs = {
  input: PrepareNewTaskInput;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewCandidateAccountingRecordMultiEditArgs = {
  input: CandidateAccountingRecordMultiEditInput;
};


export type QueryPreviewCandidateInterviewMultiEditArgs = {
  input: CandidateInterviewMultiEditInput;
};


export type QueryPreviewCandidateListMultiEditArgs = {
  input: CandidateListMultiEditInput;
};


export type QueryPreviewCandidateMultiEditArgs = {
  input: CandidateMultiEditPreviewInput;
};


export type QueryPreviewCandidateMultiInviteArgs = {
  input: CandidateMultiInvitePreviewInput;
};


export type QueryPreviewCandidateMultiUninviteArgs = {
  input: CandidateMultiInvitePreviewInput;
};


export type QueryPreviewEnterMissingInformationArgs = {
  input: EnterMissingInformationPreviewInput;
};


export type QueryPreviewEnterMissingInformationV2Args = {
  input: EnterMissingInformationV2PreviewInput;
};


export type QueryPreviewOwnOrganizationUserPriceChangeArgs = {
  input: OwnOrganizationUserPriceChangePreviewInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryPreviewPartnerOrganizationsUserPriceChangeArgs = {
  input: PartnerOrganizationsUserPriceChangePreviewInput;
  organizationId: Scalars['ID']['input'];
};


export type QueryRenderConsentHtmlArgs = {
  input: RenderConsentInput;
};


export type QueryRenderConsentPdfArgs = {
  input: RenderConsentInput;
};


export type QueryRenderEmailTemplateArgs = {
  input: EmailTemplateRenderInput;
};


export type QueryRequestTranslationArgs = {
  input: MeteredTranslationInput;
};


export type QueryResolveProtectedShortLinkArgs = {
  shortLink: Scalars['String']['input'];
};


export type QueryResolveShortLinkArgs = {
  shortLink: Scalars['String']['input'];
};


export type QueryRestartFailedEventsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySearchOccupationSkillsArgs = {
  input: OccupationSkillSearchInput;
};


export type QuerySearchOrganizationsArgs = {
  input: OrganizationSearchInput;
};


export type QuerySettingsArgs = {
  firstLoadInSession: Scalars['Boolean']['input'];
};


export type QueryTriggerCandidatesBillingArgs = {
  input: TriggerCandidatesBillingInput;
};


export type QueryTriggerContingentBillingArgs = {
  input: TriggerContingentBillingInput;
};


export type QueryTriggerLicenseBillingArgs = {
  input: TriggerLicenseBillingInput;
};


export type QueryTriggerPendingEventsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryTriggerRecurringFeeBillingArgs = {
  input: TriggerRecurringFeeBillingInput;
};


export type QueryTriggerUserAccountBillingArgs = {
  input: TriggerUserAccountBillingInput;
};


export type QueryUpdateLingokingAccountArgs = {
  input: LingokingAccountUpdateInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryUserGroupArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryUserGroupsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryUsersWithRolesArgs = {
  input: OrganizationRolesInput;
};


export type QueryValidateApplicationMaskArgs = {
  input: CandidateApplicationMaskValidationInput;
};


export type QueryValidateBcaBrokerKeyArgs = {
  brokerKey: Scalars['String']['input'];
};


export type QueryValidateCandidateInvoiceToCreateArgs = {
  input: InvoiceCreateInput;
};


export type QueryValidateDocumentsArgs = {
  input: DocumentValidationInput;
};


export type QueryValidateExpressionArgs = {
  input: ProcessEvaluatorExpressionValidatorInput;
};


export type QueryValidateProcessModelArgs = {
  input: ProcessModelValidationInput;
};

export class QueryCoverageExerciseResult {
  __typename?: 'QueryCoverageExerciseResult';
  error?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queriesTriggered: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export class QueueInfo {
  __typename?: 'QueueInfo';
  jobs: Array<Scalars['JSONObject']['output']>;
};

export enum QueueType {
  AnkaadiaPdfRequest = 'AnkaadiaPdfRequest',
  AnkaadiaPdfResult = 'AnkaadiaPdfResult',
  DocumentAiExtractionRequest = 'DocumentAiExtractionRequest',
  DocumentAiExtractionResult = 'DocumentAiExtractionResult',
  DocumentAiProcessingRequest = 'DocumentAiProcessingRequest',
  SignatureDetectionRequest = 'SignatureDetectionRequest'
}

export class QuillContent {
  __typename?: 'QuillContent';
  contents?: Maybe<Scalars['String']['output']>;
  delta?: Maybe<Scalars['JSONObject']['output']>;
};

export class QuillContentInput {
  contents?: InputMaybe<Scalars['String']['input']>;
  delta?: InputMaybe<Scalars['JSONObject']['input']>;
};

export class ReCertificationProcessCreationResult {
  __typename?: 'ReCertificationProcessCreationResult';
  orgMismatch?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  processId?: Maybe<Scalars['ID']['output']>;
  switchOrg?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['ID']['output']>;
  taskLink?: Maybe<Scalars['String']['output']>;
  userAlreadyExisted?: Maybe<Scalars['Boolean']['output']>;
};

export type RebuildSharingMatrixEvent = ProgressEvent | RebuildSharingMatrixResult;

export class RebuildSharingMatrixResult {
  __typename?: 'RebuildSharingMatrixResult';
  success: Scalars['Boolean']['output'];
};

export type RecalculateMilestoneResultsEvent = ProgressEvent | RecalculateMilestoneResultsResult;

export class RecalculateMilestoneResultsResult {
  __typename?: 'RecalculateMilestoneResultsResult';
  createdCount: Scalars['Float']['output'];
};

export class RecentStripeChangesSyncInput {
  lookbackDays: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class RecentStripeChangesSyncResult {
  __typename?: 'RecentStripeChangesSyncResult';
  creditNotesProcessed: Scalars['Int']['output'];
  organizationsSynced: Scalars['Int']['output'];
};

export class RecognitionAuthority {
  __typename?: 'RecognitionAuthority';
  id: Scalars['Float']['output'];
  locationId: Scalars['Float']['output'];
  reglementation: Scalars['Boolean']['output'];
  respCity?: Maybe<Scalars['String']['output']>;
  respCommentBottom?: Maybe<Scalars['String']['output']>;
  respCommentTop?: Maybe<Scalars['String']['output']>;
  respContacts?: Maybe<Array<RecognitionAuthorityContactPerson>>;
  respEmail?: Maybe<Scalars['String']['output']>;
  respHomepage?: Maybe<Scalars['String']['output']>;
  respId: Scalars['Float']['output'];
  respPhone?: Maybe<Scalars['String']['output']>;
  respProfComment?: Maybe<Scalars['String']['output']>;
  respState?: Maybe<Scalars['String']['output']>;
  respStreet?: Maybe<Scalars['String']['output']>;
  respTitle?: Maybe<Scalars['String']['output']>;
  respZip?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  stateReglementation?: Maybe<Scalars['String']['output']>;
  stateTitle?: Maybe<Scalars['String']['output']>;
  stateTitleAdditional?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleAdditional?: Maybe<Scalars['String']['output']>;
};

export class RecognitionAuthorityContactPerson {
  __typename?: 'RecognitionAuthorityContactPerson';
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  prof: Scalars['Float']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
};

export class RecognitionAuthorityInput {
  federalStates?: InputMaybe<Array<Scalars['String']['input']>>;
  immigrationCountry: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class RecognitionPathCandidateDataDe {
  __typename?: 'RecognitionPathCandidateDataDE';
  alternative?: Maybe<RecognitionPathEntryDe>;
  current?: Maybe<RecognitionPathEntryDe>;
};

export class RecognitionPathCandidateDataDeForView {
  __typename?: 'RecognitionPathCandidateDataDEForView';
  alternative?: Maybe<RecognitionPathEntryDeForView>;
  current?: Maybe<RecognitionPathEntryDeForView>;
};

export class RecognitionPathCandidateDataDeInput {
  alternative?: InputMaybe<RecognitionPathEntryDeInput>;
  current?: InputMaybe<RecognitionPathEntryDeInput>;
};

export class RecognitionPathContractTemplate {
  __typename?: 'RecognitionPathContractTemplate';
  allowances?: Maybe<Array<ContractTemplateAllowance>>;
  benefits?: Maybe<Array<ContractTemplateBenefit>>;
  compensationRate?: Maybe<Scalars['Float']['output']>;
  compensationType?: Maybe<CompensationType>;
  contractType?: Maybe<Scalars['String']['output']>;
  customLaborAgreement?: Maybe<CustomLaborAgreement>;
  employmentRelationshipType?: Maybe<EmploymentRelationshipType>;
  ezbAdditionalInformation?: Maybe<Scalars['String']['output']>;
  holidayEntitlement?: Maybe<Scalars['Float']['output']>;
  laborAgreementSelection?: Maybe<LaborAgreementSelection>;
  noticePeriod?: Maybe<Scalars['Float']['output']>;
  noticePeriodUnit?: Maybe<ContractTermTimePeriod>;
  numberOfSalaries?: Maybe<Scalars['Float']['output']>;
  otherPaymentRegulation?: Maybe<Scalars['String']['output']>;
  overtimeCompensation?: Maybe<Scalars['String']['output']>;
  overtimeHours?: Maybe<Scalars['Float']['output']>;
  overtimeWithinLimitsPermittedByLaw?: Maybe<Scalars['Boolean']['output']>;
  probationPeriod?: Maybe<Scalars['Float']['output']>;
  probationPeriodUnit?: Maybe<ContractTermTimePeriod>;
  professionDescription?: Maybe<Scalars['String']['output']>;
  professionTitle?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
  variableCompensationRate?: Maybe<Scalars['Float']['output']>;
  workSchedule?: Maybe<Scalars['String']['output']>;
  workingHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  workingTimeType?: Maybe<WorkingTimeTypeEnum>;
};

export class RecognitionPathContractTemplateInput {
  allowances?: InputMaybe<Array<ContractTemplateAllowanceInput>>;
  benefits?: InputMaybe<Array<ContractTemplateBenefitInput>>;
  compensationRate?: InputMaybe<Scalars['Float']['input']>;
  compensationType?: InputMaybe<CompensationType>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  customLaborAgreement?: InputMaybe<CustomLaborAgreementInput>;
  employmentRelationshipType?: InputMaybe<EmploymentRelationshipType>;
  ezbAdditionalInformation?: InputMaybe<Scalars['String']['input']>;
  holidayEntitlement?: InputMaybe<Scalars['Float']['input']>;
  laborAgreementSelection?: InputMaybe<LaborAgreementSelectionInput>;
  noticePeriod?: InputMaybe<Scalars['Float']['input']>;
  noticePeriodUnit?: InputMaybe<ContractTermTimePeriod>;
  numberOfSalaries?: InputMaybe<Scalars['Float']['input']>;
  otherPaymentRegulation?: InputMaybe<Scalars['String']['input']>;
  overtimeCompensation?: InputMaybe<Scalars['String']['input']>;
  overtimeHours?: InputMaybe<Scalars['Float']['input']>;
  overtimeWithinLimitsPermittedByLaw?: InputMaybe<Scalars['Boolean']['input']>;
  probationPeriod?: InputMaybe<Scalars['Float']['input']>;
  probationPeriodUnit?: InputMaybe<ContractTermTimePeriod>;
  professionDescription?: InputMaybe<Scalars['String']['input']>;
  professionTitle?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
  variableCompensationRate?: InputMaybe<Scalars['Float']['input']>;
  workSchedule?: InputMaybe<Scalars['String']['input']>;
  workingHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  workingTimeType?: InputMaybe<WorkingTimeTypeEnum>;
};

export class RecognitionPathEntryAt {
  __typename?: 'RecognitionPathEntryAT';
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  legalBasis?: Maybe<Scalars['String']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  psaFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  recognitionAuthority?: Maybe<Scalars['String']['output']>;
  recognitionReceiveDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionReceived?: Maybe<Scalars['Boolean']['output']>;
  recognitionStartDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionStarted?: Maybe<Scalars['Boolean']['output']>;
  responsibleRecognitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleRecognition?: Maybe<Scalars['String']['output']>;
  targetRecognition?: Maybe<Scalars['String']['output']>;
};

export class RecognitionPathEntryAtInput {
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  legalBasis?: InputMaybe<Scalars['String']['input']>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  psaFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  recognitionAuthority?: InputMaybe<Scalars['String']['input']>;
  recognitionReceiveDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionStarted?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleRecognitionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleRecognition?: InputMaybe<Scalars['String']['input']>;
  targetRecognition?: InputMaybe<Scalars['String']['input']>;
};

export class RecognitionPathEntryDe {
  __typename?: 'RecognitionPathEntryDE';
  acceleratedProcedureDigitalRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedureDigitalRequested?: Maybe<Scalars['Boolean']['output']>;
  acceleratedProcedurePaperRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedurePaperRequested?: Maybe<Scalars['Boolean']['output']>;
  certificateRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  certificateRequested?: Maybe<Scalars['Boolean']['output']>;
  chamberOfCrafts?: Maybe<Scalars['String']['output']>;
  districtGovernment?: Maybe<Scalars['String']['output']>;
  equivalenceTest?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  fileNumberAcceleratedProcedure?: Maybe<Scalars['String']['output']>;
  fullEquivalenceReceived?: Maybe<Scalars['Boolean']['output']>;
  immigrationAuthority?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  psaFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  recognitionAuthority?: Maybe<Scalars['String']['output']>;
  recognitionCenter?: Maybe<Scalars['String']['output']>;
  recognitionNoticeKind?: Maybe<Scalars['String']['output']>;
  recognitionPartnership?: Maybe<Scalars['Boolean']['output']>;
  recognitionPaymentRole?: Maybe<Scalars['String']['output']>;
  recognitionPaymentRoleAccelerated?: Maybe<Scalars['String']['output']>;
  recognitionStartDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionStarted?: Maybe<Scalars['Boolean']['output']>;
  recognitionType?: Maybe<Scalars['String']['output']>;
  responsibleRecognitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleRecognition?: Maybe<Scalars['String']['output']>;
};

export class RecognitionPathEntryDeForView {
  __typename?: 'RecognitionPathEntryDEForView';
  acceleratedProcedureDigitalRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedureDigitalRequested?: Maybe<Scalars['Boolean']['output']>;
  acceleratedProcedurePaperRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  acceleratedProcedurePaperRequested?: Maybe<Scalars['Boolean']['output']>;
  certificateRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  certificateRequested?: Maybe<Scalars['Boolean']['output']>;
  chamberOfCrafts?: Maybe<Scalars['String']['output']>;
  districtGovernment?: Maybe<Scalars['String']['output']>;
  equivalenceTest?: Maybe<Scalars['String']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  fileNumberAcceleratedProcedure?: Maybe<Scalars['String']['output']>;
  fullEquivalenceReceived?: Maybe<Scalars['Boolean']['output']>;
  immigrationAuthority?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  pathOfRecognition?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  psaFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  psaFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeId?: Maybe<Scalars['ID']['output']>;
  psaRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  psaRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  recognitionAuthority?: Maybe<Scalars['String']['output']>;
  recognitionCenter?: Maybe<Scalars['String']['output']>;
  recognitionNoticeKind?: Maybe<Scalars['String']['output']>;
  recognitionPartnership?: Maybe<Scalars['Boolean']['output']>;
  recognitionPaymentRole?: Maybe<Scalars['String']['output']>;
  recognitionPaymentRoleAccelerated?: Maybe<Scalars['String']['output']>;
  recognitionReceiveDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionReceived?: Maybe<Scalars['Boolean']['output']>;
  recognitionStartDate?: Maybe<Scalars['UTCDate']['output']>;
  recognitionStarted?: Maybe<Scalars['Boolean']['output']>;
  recognitionType?: Maybe<Scalars['String']['output']>;
  responsibleRecognitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleRecognition?: Maybe<Scalars['String']['output']>;
};

export class RecognitionPathEntryDeInput {
  acceleratedProcedureDigitalRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  acceleratedProcedureDigitalRequested?: InputMaybe<Scalars['Boolean']['input']>;
  acceleratedProcedurePaperRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  acceleratedProcedurePaperRequested?: InputMaybe<Scalars['Boolean']['input']>;
  certificateRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  certificateRequested?: InputMaybe<Scalars['Boolean']['input']>;
  chamberOfCrafts?: InputMaybe<Scalars['String']['input']>;
  districtGovernment?: InputMaybe<Scalars['String']['input']>;
  equivalenceTest?: InputMaybe<Scalars['String']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  fileNumberAcceleratedProcedure?: InputMaybe<Scalars['String']['input']>;
  fullEquivalenceReceived?: InputMaybe<Scalars['Boolean']['input']>;
  immigrationAuthority?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  pathOfRecognition?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  psaFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  psaFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  psaRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  psaRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  recognitionAuthority?: InputMaybe<Scalars['String']['input']>;
  recognitionCenter?: InputMaybe<Scalars['String']['input']>;
  recognitionNoticeKind?: InputMaybe<Scalars['String']['input']>;
  recognitionPartnership?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionPaymentRole?: InputMaybe<Scalars['String']['input']>;
  recognitionPaymentRoleAccelerated?: InputMaybe<Scalars['String']['input']>;
  recognitionStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
  recognitionStarted?: InputMaybe<Scalars['Boolean']['input']>;
  recognitionType?: InputMaybe<Scalars['String']['input']>;
  responsibleRecognitionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleRecognition?: InputMaybe<Scalars['String']['input']>;
};

export enum RecognitionProfessionalExperience {
  FullRecognition = 'FullRecognition',
  NoRecognition = 'NoRecognition',
  PartialRecognition = 'PartialRecognition'
}

export enum RecognitionState {
  DeficitNotice = 'DeficitNotice',
  FullNotice = 'FullNotice',
  NoNoticeReceived = 'NoNoticeReceived',
  RecognitionNoticeReceived = 'RecognitionNoticeReceived',
  RecognitionStarted = 'RecognitionStarted',
  RejectNotice = 'RejectNotice'
}

export class RecommendationNote {
  __typename?: 'RecommendationNote';
  contents: Scalars['String']['output'];
  delta: Scalars['JSONObject']['output'];
};

export class RecommendationNoteInput {
  contents: Scalars['String']['input'];
  delta: Scalars['JSONObject']['input'];
};

export class ReconnectAllStripeCustomersResult {
  __typename?: 'ReconnectAllStripeCustomersResult';
  errorMessages: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export class RecurringFee {
  __typename?: 'RecurringFee';
  bookingText: Scalars['String']['output'];
  bookingType: BookingType;
  currency: SupportedBillingCurrency;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  id: Scalars['ID']['output'];
  paymentTime: PaymentTime;
  period: PaymentPeriod;
  price: Scalars['Float']['output'];
  revenueCategory: RevenueCategory;
  startDate: Scalars['UTCDate']['output'];
  targetInvoiceType: InvoiceType;
};

export class RecurringFeeInput {
  bookingText: Scalars['String']['input'];
  bookingType: BookingType;
  currency: SupportedBillingCurrency;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id: Scalars['ID']['input'];
  paymentTime: PaymentTime;
  period: PaymentPeriod;
  price: Scalars['Float']['input'];
  revenueCategory: RevenueCategory;
  startDate: Scalars['UTCDate']['input'];
  targetInvoiceType: InvoiceType;
};

export class RegenerateOutcome {
  __typename?: 'RegenerateOutcome';
  error?: Maybe<Scalars['String']['output']>;
  events: Array<ProcessAgentEvent>;
  ok: Scalars['Boolean']['output'];
  subagentInvocationId: Scalars['ID']['output'];
};

export class RegenerateProgressSubscriptionInput {
  invocationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class RegenerateSubagentResultInput {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  focus?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processModelId: Scalars['ID']['input'];
  subagentInvocationId: Scalars['ID']['input'];
  targetItemId?: InputMaybe<Scalars['ID']['input']>;
  targetScope: Scalars['String']['input'];
  targetTaskId?: InputMaybe<Scalars['ID']['input']>;
};

export class ReleasedProcessModelInfo {
  __typename?: 'ReleasedProcessModelInfo';
  _etag?: Maybe<Scalars['String']['output']>;
  _typeName: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importModel?: Maybe<ProcessModelDeclaration>;
  modelId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  releasedAt: Scalars['AnkaadiaDateTime']['output'];
  releasedBy: Scalars['String']['output'];
  revision: Scalars['Float']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type ReleasedProcessModelResultEvent = ProgressEvent | ReleasedProcessModelInfo;

export class RemoveDiscountInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export class RemoveForeignGroupsFromGroupInput {
  _etag: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  groupsIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export enum RemoveFromListBehaviorEnum {
  All = 'All',
  AllWithSharing = 'AllWithSharing',
  CollectionOrTemplate = 'CollectionOrTemplate',
  Current = 'Current',
  SharedToOtherEmployers = 'SharedToOtherEmployers'
}

export class RemoveRecurringFeeInput {
  contractEtag: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export class RemoveUsersFromGroupInput {
  _etag: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export class RenameAiChatSessionInput {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export class RenderConsentHtmlResult {
  __typename?: 'RenderConsentHtmlResult';
  html: Scalars['String']['output'];
  linkedTexts: Array<LinkedText>;
};

export class RenderConsentInput {
  consentIdentifier: KnownConsentIdentifiers;
  consentVersion: Scalars['String']['input'];
  language: Scalars['String']['input'];
  linkedTexts: Array<LinkedTextInput>;
};

export class RenderConsentPdfResult {
  __typename?: 'RenderConsentPdfResult';
  downloadUrl: Scalars['String']['output'];
  size: Scalars['Float']['output'];
};

export enum ReplyTypeEnum {
  ConfirmAgreement = 'ConfirmAgreement',
  ConfirmReception = 'ConfirmReception',
  NoReply = 'NoReply',
  ReplyWithConsent = 'ReplyWithConsent',
  ReplyWithDate = 'ReplyWithDate',
  ReplyWithText = 'ReplyWithText',
  ReplyWithYesOrNo = 'ReplyWithYesOrNo',
  ReplyWithYesOrNoAndForcedCommentAtNo = 'ReplyWithYesOrNoAndForcedCommentAtNo'
}

export class ReportInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class ReportResult {
  __typename?: 'ReportResult';
  filename: Scalars['String']['output'];
  urlToReport?: Maybe<Scalars['String']['output']>;
};

export class ReportTemplate {
  __typename?: 'ReportTemplate';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  generationDataStrategyId: Scalars['String']['output'];
  sharedToOrganizationIds: Array<Scalars['String']['output']>;
  templateId: Scalars['ID']['output'];
  templateOrganizationId: Scalars['ID']['output'];
};

export class RequiredByTemplateReference {
  __typename?: 'RequiredByTemplateReference';
  name: Scalars['String']['output'];
  type: DocumentTemplateType;
};

export class RequiredConsentSummary {
  __typename?: 'RequiredConsentSummary';
  consentDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  consentGiverId: Scalars['ID']['output'];
  consentIdentifier: KnownConsentIdentifiers;
  consentName: Scalars['String']['output'];
  consented: Scalars['Boolean']['output'];
  isExemption?: Maybe<Scalars['Boolean']['output']>;
  resetByNonMasterUserIsAllowed: Scalars['Boolean']['output'];
};

export class RequiredDataResult {
  __typename?: 'RequiredDataResult';
  candidateId: Scalars['String']['output'];
  completionStatus: CompletionStatus;
  missingRequiredFields: Array<Scalars['String']['output']>;
  missionOptionalFields: Array<Scalars['String']['output']>;
  optionalFiles: Array<OnlineApplicationFile>;
  organizationId: Scalars['String']['output'];
  recipeId: Scalars['String']['output'];
  requiredFiles: Array<OnlineApplicationFile>;
};

export class RequiredDocument {
  __typename?: 'RequiredDocument';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  configData?: Maybe<Array<DocumentConfigurationResultType>>;
  description?: Maybe<Scalars['String']['output']>;
  functions: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  immigrationCountry: SupportedImmigrationCountry;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  setsAvailableForCandidates?: Maybe<Scalars['Boolean']['output']>;
};

export class RequiredDocumentCreateInput {
  configData?: InputMaybe<Array<DocumentConfigurationInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  functions: Array<Scalars['String']['input']>;
  immigrationCountry: SupportedImmigrationCountry;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  setsAvailableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
};

export class RequiredDocumentDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class RequiredDocumentDuplicateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class RequiredDocumentGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class RequiredDocumentOverview {
  __typename?: 'RequiredDocumentOverview';
  candidateData: Array<CandidateData>;
  documentStatus: Array<DocumentStatus>;
};

export type RequiredDocumentOverviewEvent = ProgressEvent | RequiredDocumentOverview;

export class RequiredDocumentUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  configData?: InputMaybe<Array<DocumentConfigurationInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  functions: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  immigrationCountry: SupportedImmigrationCountry;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  setsAvailableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
};

export class RequiredDocumentUpdateMetaInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  functions: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  setsAvailableForCandidates?: InputMaybe<Scalars['Boolean']['input']>;
};

export class RequiredDocumentsForCandidateInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class RequiredDocumentsForOrganizationInput {
  organizationId: Scalars['ID']['input'];
};

export class RequiredVaccinations {
  __typename?: 'RequiredVaccinations';
  _etag?: Maybe<Scalars['String']['output']>;
  at?: Maybe<RequiredVaccinationsAt>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  de?: Maybe<RequiredVaccinationsDe>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
};

export class RequiredVaccinationsAt {
  __typename?: 'RequiredVaccinationsAT';
  configs: Array<RequiredVaccinationsEntryAt>;
};

export class RequiredVaccinationsAtInput {
  configs: Array<RequiredVaccinationsEntryAtInput>;
};

export class RequiredVaccinationsDe {
  __typename?: 'RequiredVaccinationsDE';
  configs: Array<RequiredVaccinationsEntryDe>;
};

export class RequiredVaccinationsDeInput {
  configs: Array<RequiredVaccinationsEntryDeInput>;
};

export class RequiredVaccinationsEntryAt {
  __typename?: 'RequiredVaccinationsEntryAT';
  countryOfOrigin: Array<Scalars['String']['output']>;
  employer: Array<Scalars['String']['output']>;
  federalState: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mandatoryVaccines: Scalars['Boolean']['output'];
  notNecessary?: Maybe<Scalars['Boolean']['output']>;
  profession: Array<Scalars['String']['output']>;
  vaccineFunction: Array<Scalars['String']['output']>;
  vaccines: Array<Scalars['String']['output']>;
};

export class RequiredVaccinationsEntryAtInput {
  countryOfOrigin: Array<Scalars['String']['input']>;
  employer: Array<Scalars['String']['input']>;
  federalState: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mandatoryVaccines: Scalars['Boolean']['input'];
  notNecessary?: InputMaybe<Scalars['Boolean']['input']>;
  profession: Array<Scalars['String']['input']>;
  vaccineFunction: Array<Scalars['String']['input']>;
  vaccines: Array<Scalars['String']['input']>;
};

export class RequiredVaccinationsEntryDe {
  __typename?: 'RequiredVaccinationsEntryDE';
  countryOfOrigin: Array<Scalars['String']['output']>;
  employer: Array<Scalars['String']['output']>;
  federalState: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mandatoryVaccines: Scalars['Boolean']['output'];
  notNecessary?: Maybe<Scalars['Boolean']['output']>;
  profession: Array<Scalars['String']['output']>;
  vaccineFunction: Array<Scalars['String']['output']>;
  vaccines: Array<Scalars['String']['output']>;
};

export class RequiredVaccinationsEntryDeInput {
  countryOfOrigin: Array<Scalars['String']['input']>;
  employer: Array<Scalars['String']['input']>;
  federalState: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mandatoryVaccines: Scalars['Boolean']['input'];
  notNecessary?: InputMaybe<Scalars['Boolean']['input']>;
  profession: Array<Scalars['String']['input']>;
  vaccineFunction: Array<Scalars['String']['input']>;
  vaccines: Array<Scalars['String']['input']>;
};

export class RequiredVaccinationsForCandidateInput {
  candidateId: Scalars['String']['input'];
  candidateOrganizationId: Scalars['String']['input'];
  overviewOrganizationId: Scalars['String']['input'];
};

export class RequiredVaccinationsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class RequiredVaccinationsResultEntry {
  __typename?: 'RequiredVaccinationsResultEntry';
  mandatoryVaccines: Scalars['Boolean']['output'];
  vaccineFunction: Scalars['String']['output'];
  vaccines: Array<Scalars['String']['output']>;
};

export class RequiredVaccinationsStatesForCollectionInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class RequiredVaccinationsUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<RequiredVaccinationsAtInput>;
  de?: InputMaybe<RequiredVaccinationsDeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class ResidenceCandidateDataAt {
  __typename?: 'ResidenceCandidateDataAT';
  personalOnboardingDateTime?: Maybe<DateWithTime>;
  recognitionMedicalCertificate?: Maybe<Scalars['Boolean']['output']>;
  registrationAuthority?: Maybe<Scalars['String']['output']>;
  registrationAuthorityAppointmentNumber?: Maybe<Scalars['String']['output']>;
  registrationOfficeDate?: Maybe<DateWithTime>;
  residenceBank?: Maybe<Scalars['String']['output']>;
  residenceBankContactPartner?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  residenceFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  residenceRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeId?: Maybe<Scalars['ID']['output']>;
  residenceRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleResidenceOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleResidence?: Maybe<Scalars['String']['output']>;
  suitabilityForWork?: Maybe<Scalars['String']['output']>;
  workStartDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class ResidenceCandidateDataAtInput {
  personalOnboardingDateTime?: InputMaybe<DateWithTimeInput>;
  recognitionMedicalCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
  registrationAuthorityAppointmentNumber?: InputMaybe<Scalars['String']['input']>;
  registrationOfficeDate?: InputMaybe<DateWithTimeInput>;
  residenceBank?: InputMaybe<Scalars['String']['input']>;
  residenceBankContactPartner?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  residenceFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  residenceRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  residenceRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleResidenceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleResidence?: InputMaybe<Scalars['String']['input']>;
  suitabilityForWork?: InputMaybe<Scalars['String']['input']>;
  workStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class ResidenceCandidateDataDe {
  __typename?: 'ResidenceCandidateDataDE';
  appointmentHealthDepartmentDate?: Maybe<DateWithTime>;
  appointmentHealthDepartmentKept?: Maybe<Scalars['Boolean']['output']>;
  bankAppointmentDate?: Maybe<DateWithTime>;
  certificateOfConduct?: Maybe<Array<Scalars['String']['output']>>;
  certificateOfConductRequested?: Maybe<Scalars['Boolean']['output']>;
  companyDoctorAppointmentDate?: Maybe<DateWithTime>;
  medicalExaminationAppointmentDate?: Maybe<DateWithTime>;
  personalOnboardingDateTime?: Maybe<DateWithTime>;
  policeRecordAppointmentDate?: Maybe<DateWithTime>;
  recognitionMedicalCertificate?: Maybe<Scalars['Boolean']['output']>;
  registrationAuthority?: Maybe<Scalars['String']['output']>;
  registrationAuthorityAppointmentNumber?: Maybe<Scalars['String']['output']>;
  registrationOfficeDate?: Maybe<DateWithTime>;
  residenceBank?: Maybe<Scalars['String']['output']>;
  residenceBankContactPartner?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyFirstName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyId?: Maybe<Scalars['ID']['output']>;
  residenceFirstDeputyLastName?: Maybe<Scalars['String']['output']>;
  residenceFirstDeputyOrganizationId?: Maybe<Scalars['ID']['output']>;
  residencePermits?: Maybe<Array<ResidencePermit>>;
  residenceRepresentativeFirstName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeId?: Maybe<Scalars['ID']['output']>;
  residenceRepresentativeLastName?: Maybe<Scalars['String']['output']>;
  residenceRepresentativeOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleResidenceOrganizationId?: Maybe<Scalars['ID']['output']>;
  responsibleRoleResidence?: Maybe<Scalars['String']['output']>;
  suitabilityForWork?: Maybe<Scalars['String']['output']>;
  workStartDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class ResidenceCandidateDataDeInput {
  appointmentHealthDepartmentDate?: InputMaybe<DateWithTimeInput>;
  appointmentHealthDepartmentKept?: InputMaybe<Scalars['Boolean']['input']>;
  bankAppointmentDate?: InputMaybe<DateWithTimeInput>;
  certificateOfConduct?: InputMaybe<Array<Scalars['String']['input']>>;
  certificateOfConductRequested?: InputMaybe<Scalars['Boolean']['input']>;
  companyDoctorAppointmentDate?: InputMaybe<DateWithTimeInput>;
  medicalExaminationAppointmentDate?: InputMaybe<DateWithTimeInput>;
  personalOnboardingDateTime?: InputMaybe<DateWithTimeInput>;
  policeRecordAppointmentDate?: InputMaybe<DateWithTimeInput>;
  recognitionMedicalCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
  registrationAuthorityAppointmentNumber?: InputMaybe<Scalars['String']['input']>;
  registrationOfficeDate?: InputMaybe<DateWithTimeInput>;
  residenceBank?: InputMaybe<Scalars['String']['input']>;
  residenceBankContactPartner?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyId?: InputMaybe<Scalars['ID']['input']>;
  residenceFirstDeputyLastName?: InputMaybe<Scalars['String']['input']>;
  residenceFirstDeputyOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  residencePermits?: InputMaybe<Array<ResidencePermitDataInput>>;
  residenceRepresentativeFirstName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  residenceRepresentativeLastName?: InputMaybe<Scalars['String']['input']>;
  residenceRepresentativeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleResidenceOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  responsibleRoleResidence?: InputMaybe<Scalars['String']['input']>;
  suitabilityForWork?: InputMaybe<Scalars['String']['input']>;
  workStartDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class ResidencePermit {
  __typename?: 'ResidencePermit';
  fictionalCertificateAvailable?: Maybe<Scalars['Boolean']['output']>;
  fictionalCertificateDoesNotAuthorisesWorking?: Maybe<Scalars['Boolean']['output']>;
  fictionalCertificateNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  immigrationAuthority?: Maybe<Scalars['String']['output']>;
  immigrationAuthorityAppointmentDate?: Maybe<DateWithTime>;
  notes?: Maybe<QuillContent>;
  residencePermit?: Maybe<Scalars['String']['output']>;
  residenceRequestedByPostDate?: Maybe<Scalars['UTCDate']['output']>;
  residenceRequestedElectronicallyDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class ResidencePermitDataInput {
  fictionalCertificateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fictionalCertificateDoesNotAuthorisesWorking?: InputMaybe<Scalars['Boolean']['input']>;
  fictionalCertificateNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  immigrationAuthority?: InputMaybe<Scalars['String']['input']>;
  immigrationAuthorityAppointmentDate?: InputMaybe<DateWithTimeInput>;
  notes?: InputMaybe<QuillContentInput>;
  residencePermit?: InputMaybe<Scalars['String']['input']>;
  residenceRequestedByPostDate?: InputMaybe<Scalars['UTCDate']['input']>;
  residenceRequestedElectronicallyDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class RestrictedTalentPoolSearch {
  __typename?: 'RestrictedTalentPoolSearch';
  count: Scalars['Float']['output'];
  facets: TalentPoolFacets;
  results: Array<Talent>;
};

export class RestrictedTalentPoolSearchInput {
  approvedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filters: TalentPoolFilters;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pools: Array<RestrictedTalentPoolSelection>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export class RestrictedTalentPoolSelection {
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
};

export class RestrictedTalentPoolTalentRequest {
  organizationId: Scalars['ID']['input'];
  requestNote?: InputMaybe<Scalars['String']['input']>;
  requestingOrganizationId: Scalars['ID']['input'];
  talent: TalentInstanceInput;
};

export class RestrictedTalentPoolTalentRequestInput {
  requesterSource?: InputMaybe<TalentRequestSource>;
  talents: Array<RestrictedTalentPoolTalentRequest>;
};

export class ResultDetails {
  __typename?: 'ResultDetails';
  examModule?: Maybe<ExamModuleType>;
  examModuleResult?: Maybe<Scalars['String']['output']>;
};

export class ResultDetailsInput {
  examModule?: InputMaybe<ExamModuleType>;
  examModuleResult?: InputMaybe<Scalars['String']['input']>;
};

export class RetractProcessAgentFeedbackInput {
  messageId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export enum RevenueCategory {
  CandidateDependentFee = 'CandidateDependentFee',
  LicenseBaseFee = 'LicenseBaseFee',
  OneTimeFee = 'OneTimeFee',
  OtherProductsAndServices = 'OtherProductsAndServices',
  SoftwareModule = 'SoftwareModule'
}

export class ReviewDocumentResult {
  __typename?: 'ReviewDocumentResult';
  feedbackText?: Maybe<Scalars['String']['output']>;
  fileBlob: Scalars['String']['output'];
  fileFormats: Array<Scalars['String']['output']>;
  isOutDated?: Maybe<Scalars['Boolean']['output']>;
  reviewerVotum: Array<ReviewerVotum>;
  taskId: Scalars['ID']['output'];
};

export class ReviewDocumentResultInput {
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  fileBlob: Scalars['String']['input'];
  fileFormats: Array<Scalars['String']['input']>;
  isOutDated?: InputMaybe<Scalars['Boolean']['input']>;
  reviewerVotum: Array<ReviewerVotumInput>;
  taskId: Scalars['ID']['input'];
};

export class ReviewerVotum {
  __typename?: 'ReviewerVotum';
  confirmOk?: Maybe<Scalars['Boolean']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userorganizationId?: Maybe<Scalars['ID']['output']>;
};

export class ReviewerVotumInput {
  confirmOk?: InputMaybe<Scalars['Boolean']['input']>;
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userorganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class RoleOrganizationUserGroupMapping {
  __typename?: 'RoleOrganizationUserGroupMapping';
  assignedUserGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  processOrganizationId?: Maybe<Scalars['ID']['output']>;
  processRole: Scalars['String']['output'];
};

export class RoleOrganizationUserGroupMappingInput {
  assignedUserGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  processOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  processRole: Scalars['String']['input'];
};

export class RuleExecutionError {
  __typename?: 'RuleExecutionError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  reason: RuleExecutionErrorReason;
  ruleId: Scalars['String']['output'];
  ruleName: Scalars['String']['output'];
  technicalDetails?: Maybe<Scalars['String']['output']>;
};

export class RuleExecutionErrorInput {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  reason: RuleExecutionErrorReason;
  ruleId: Scalars['String']['input'];
  ruleName: Scalars['String']['input'];
  technicalDetails?: InputMaybe<Scalars['String']['input']>;
};

export enum RuleExecutionErrorReason {
  ExpressionError = 'ExpressionError',
  GeneralError = 'GeneralError',
  RunConditionError = 'RunConditionError',
  ValidationError = 'ValidationError'
}

export class RuleTaskTarget {
  __typename?: 'RuleTaskTarget';
  areaIds?: Maybe<Array<Scalars['String']['output']>>;
  excludeTaskIds?: Maybe<Array<Scalars['String']['output']>>;
  phaseIds?: Maybe<Array<Scalars['String']['output']>>;
  taskIds?: Maybe<Array<Scalars['String']['output']>>;
  type: ProcessRuleTaskTargetType;
};

export class RuleTaskTargetInput {
  areaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTaskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  phaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ProcessRuleTaskTargetType;
};

export enum SalesTableType {
  ActivitiesTable = 'ActivitiesTable',
  AllCandidatesTable = 'AllCandidatesTable',
  BarmerTable = 'BarmerTable',
  CandidateCountPerStateOverTime = 'CandidateCountPerStateOverTime',
  CandidateStatusMovementOverTimeNew = 'CandidateStatusMovementOverTimeNew',
  CandidateTable = 'CandidateTable',
  CollectionTable = 'CollectionTable',
  ConsentTable = 'ConsentTable',
  DocumentTable = 'DocumentTable',
  GueteSiegelTable = 'GueteSiegelTable',
  LoginTable = 'LoginTable',
  OnlineApplicationTable = 'OnlineApplicationTable',
  OrganizationMappingTable = 'OrganizationMappingTable',
  OrganizationTable = 'OrganizationTable',
  StarnormTable = 'StarnormTable',
  UserTable = 'UserTable',
  WithUsers = 'WithUsers'
}

export class SaveAiChatTurnMessagesInput {
  expectedRevision: Scalars['Int']['input'];
  messages: Scalars['JSON']['input'];
  schemaVersion: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
  turnId: Scalars['ID']['input'];
};

export class SearchFacet {
  __typename?: 'SearchFacet';
  count: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export class SelectableOrganizationTags {
  __typename?: 'SelectableOrganizationTags';
  canManage: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  tags: Array<OrganizationTag>;
};

export class SelectableOrganizationTagsGetInput {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  ownerOrganizationId: Scalars['ID']['input'];
  type: OrganizationTagType;
};

export class SelectedPartnerSharingConfiguration {
  __typename?: 'SelectedPartnerSharingConfiguration';
  allowLinkingInCaseItIsManaged?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  shareContacts?: Maybe<Scalars['Boolean']['output']>;
  shareContractTemplates?: Maybe<Scalars['Boolean']['output']>;
  shareEZBData?: Maybe<Scalars['Boolean']['output']>;
  shareLaborAgreements?: Maybe<Scalars['Boolean']['output']>;
  sharePartners?: Maybe<Scalars['Boolean']['output']>;
};

export class SelectedPartnerSharingConfigurationInput {
  allowLinkingInCaseItIsManaged?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  shareContacts?: InputMaybe<Scalars['Boolean']['input']>;
  shareContractTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  shareEZBData?: InputMaybe<Scalars['Boolean']['input']>;
  shareLaborAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  sharePartners?: InputMaybe<Scalars['Boolean']['input']>;
};

export class SemaphoreStats {
  __typename?: 'SemaphoreStats';
  max: Scalars['Int']['output'];
  queued: Scalars['Int']['output'];
  running: Scalars['Int']['output'];
};

export enum ServiceType {
  HealthInsuranceBrokerage = 'HealthInsuranceBrokerage'
}

export class SetInfo {
  __typename?: 'SetInfo';
  comment?: Maybe<Scalars['String']['output']>;
  completionState?: Maybe<CompletionState>;
  dateOfReceipt?: Maybe<Scalars['UTCDate']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  hasFiles?: Maybe<Scalars['Boolean']['output']>;
  issueDate?: Maybe<Scalars['UTCDate']['output']>;
  resubmissionDate?: Maybe<Scalars['UTCDate']['output']>;
  resubmissionReason?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class SetInfoInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  completionState?: InputMaybe<CompletionState>;
  dateOfReceipt?: InputMaybe<Scalars['UTCDate']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasFiles?: InputMaybe<Scalars['Boolean']['input']>;
  issueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  resubmissionDate?: InputMaybe<Scalars['UTCDate']['input']>;
  resubmissionReason?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class Settings {
  __typename?: 'Settings';
  additionalModules?: Maybe<AdditionalModules>;
  allowEmailToUninvitedCandidates?: Maybe<Scalars['Boolean']['output']>;
  auth0UserId?: Maybe<Scalars['String']['output']>;
  autoCVConfigured?: Maybe<Scalars['Boolean']['output']>;
  canEditOrganizationProfile?: Maybe<Scalars['Boolean']['output']>;
  candidateOrUserId?: Maybe<Scalars['String']['output']>;
  communicationLanguage?: Maybe<Scalars['String']['output']>;
  configToken?: Maybe<Scalars['String']['output']>;
  creatorOrganizationId?: Maybe<Scalars['String']['output']>;
  creatorOrganizationName?: Maybe<Scalars['String']['output']>;
  databaseCreatedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  environmentName?: Maybe<Scalars['String']['output']>;
  facebookPageId?: Maybe<Scalars['String']['output']>;
  facebookUserId?: Maybe<Scalars['String']['output']>;
  forbidNewDocumentCreationByCandidates?: Maybe<Scalars['Boolean']['output']>;
  formats?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  hasLogo?: Maybe<Scalars['Boolean']['output']>;
  hideErrorOverlays?: Maybe<Scalars['Boolean']['output']>;
  isCandidate?: Maybe<Scalars['Boolean']['output']>;
  isCreatorMasterOrganization?: Maybe<Scalars['Boolean']['output']>;
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  isEducationModuleVisible?: Maybe<Scalars['Boolean']['output']>;
  isMasterOrganization?: Maybe<Scalars['Boolean']['output']>;
  isMasterUser?: Maybe<Scalars['Boolean']['output']>;
  isNewUiEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProcessActionEnabled?: Maybe<Scalars['Boolean']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  licensedParentOrganizationId?: Maybe<Scalars['ID']['output']>;
  logoutPeriodInMinutes?: Maybe<Scalars['Float']['output']>;
  maxSize?: Maybe<Scalars['Float']['output']>;
  menu?: Maybe<Menu>;
  messagesReception?: Maybe<MessagesReception>;
  organizationCode?: Maybe<Scalars['String']['output']>;
  organizationEmail?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPrefix?: Maybe<Scalars['String']['output']>;
  persistHistoricCandidateData?: Maybe<Scalars['Boolean']['output']>;
  profileDataEditStatus?: Maybe<ProfileDataEditStatus>;
  reloadAndReAuthenticate?: Maybe<Scalars['Boolean']['output']>;
  removeCandidatesFromAllListsIfDropout?: Maybe<Scalars['Boolean']['output']>;
  requireCandidateConsent?: Maybe<Scalars['Boolean']['output']>;
  requireTalentpoolUserConsent?: Maybe<Scalars['Boolean']['output']>;
  requireUserConsent?: Maybe<Scalars['Boolean']['output']>;
  sharingSettings?: Maybe<SharingSettings>;
  showEnvironmentName?: Maybe<Scalars['Boolean']['output']>;
  standardImmigrationCountry?: Maybe<SupportedImmigrationCountry>;
  startUrl?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  supportedImmigrationCountries?: Maybe<Array<SupportedImmigrationCountry>>;
  switchableOrganizationCount?: Maybe<Scalars['Float']['output']>;
  useSimpleCandidateDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
  userDisplayId?: Maybe<Scalars['String']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userGroups?: Maybe<Array<Scalars['ID']['output']>>;
  userHasSeenNewAnkaadiaAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  userInitials?: Maybe<Scalars['String']['output']>;
  userMobileNumber?: Maybe<Scalars['String']['output']>;
  userPermissions?: Maybe<Array<Scalars['String']['output']>>;
  userPhoneNumber?: Maybe<Scalars['String']['output']>;
  userPrefersNewUi?: Maybe<Scalars['Boolean']['output']>;
  userSettings?: Maybe<UserSettings>;
};

export class ShadowReadStats {
  __typename?: 'ShadowReadStats';
  run: Scalars['Float']['output'];
  skippedQueueFull: Scalars['Float']['output'];
  skippedShutdown: Scalars['Float']['output'];
  skippedTimeout: Scalars['Float']['output'];
  waitCount: Scalars['Float']['output'];
  waitMaxMs: Scalars['Float']['output'];
  waitSumMs: Scalars['Float']['output'];
};

export class SharedCollectionEventsInput {
  collectionId: Scalars['ID']['input'];
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCategories: Array<Scalars['String']['input']>;
  eventTimeframe: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sharingId?: InputMaybe<Scalars['ID']['input']>;
};

export class SharedField {
  __typename?: 'SharedField';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export class SharedFieldInput {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export class SharedTab {
  __typename?: 'SharedTab';
  fullTabPermission?: Maybe<TabPermission>;
  key: Scalars['String']['output'];
  sharedFields?: Maybe<Array<SharedField>>;
};

export class SharedTabInput {
  fullTabPermission?: InputMaybe<TabPermission>;
  key: Scalars['String']['input'];
  sharedFields?: InputMaybe<Array<SharedFieldInput>>;
};

export class Sharing {
  __typename?: 'Sharing';
  _etag?: Maybe<Scalars['String']['output']>;
  allowBilateralChat?: Maybe<Scalars['Boolean']['output']>;
  allowChat?: Maybe<Scalars['Boolean']['output']>;
  allowChatInCollectionChat?: Maybe<Scalars['Boolean']['output']>;
  anonymizationOptions?: Maybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: Maybe<Scalars['Boolean']['output']>;
  autoCVRequested?: Maybe<Scalars['Boolean']['output']>;
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  destinationOrganizationCode?: Maybe<Scalars['String']['output']>;
  destinationOrganizationId: Scalars['ID']['output'];
  destinationOrganizationName: Scalars['String']['output'];
  disableSubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  enableNotificationEmails?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditable?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditableViaCourse?: Maybe<Scalars['Boolean']['output']>;
  notificationEmailUserGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  organizationId: Scalars['ID']['output'];
  parentSharingId?: Maybe<Scalars['ID']['output']>;
  profileAccessId?: Maybe<Scalars['String']['output']>;
  providedTemplates?: Maybe<Array<AvailableDocumentTemplate>>;
  restrictionMode?: Maybe<SharingRestrictionMode>;
  shareAllFileTypes?: Maybe<Scalars['Boolean']['output']>;
  shareInternalDocuments?: Maybe<Scalars['Boolean']['output']>;
  shareMilestoneLists?: Maybe<Scalars['Boolean']['output']>;
  sharedCollectionId: Scalars['ID']['output'];
  sharedCollectionName: Scalars['String']['output'];
  sharedFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  sharedTabs?: Maybe<Array<SharedTab>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: Maybe<Scalars['Boolean']['output']>;
  submissionDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  submitted?: Maybe<Scalars['Boolean']['output']>;
};

export class SharingActivityInput {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  sharingId: Scalars['ID']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export class SharingActivityParameter {
  __typename?: 'SharingActivityParameter';
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export class SharingCollectionQueryInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class SharingCreateInput {
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  destinationOrganizationId: Array<Scalars['ID']['input']>;
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroups?: InputMaybe<Array<SharingCreateNotificationEmailUserGroupInput>>;
  organizationId: Scalars['ID']['input'];
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCollectionId: Scalars['ID']['input'];
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  submissionDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export class SharingCreateNotificationEmailUserGroup {
  __typename?: 'SharingCreateNotificationEmailUserGroup';
  organizationId: Scalars['ID']['output'];
  userGroupIds: Array<Scalars['ID']['output']>;
};

export class SharingCreateNotificationEmailUserGroupInput {
  organizationId: Scalars['ID']['input'];
  userGroupIds: Array<Scalars['ID']['input']>;
};

export class SharingDeleteInput {
  _etag: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
};

export class SharingDocumentQueryInput {
  candidateId: Scalars['ID']['input'];
  isInTaskActContext: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export class SharingEnumerationInput {
  organizationId: Scalars['ID']['input'];
};

export class SharingFileQueryInput {
  blob: Scalars['String']['input'];
  candidateId: Scalars['ID']['input'];
  isInTaskActContext: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export class SharingForCollectionCreateInput {
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  destinationOrganizationId: Array<Scalars['ID']['input']>;
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroups?: InputMaybe<Array<SharingCreateNotificationEmailUserGroupInput>>;
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  submissionDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export class SharingPreset {
  __typename?: 'SharingPreset';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isTalentPoolSharingPreset?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  sharing: SharingPresetSharing;
  talentPoolSharingPrefix?: Maybe<Scalars['String']['output']>;
};

export class SharingPresetCopyInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class SharingPresetCreateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  isTalentPoolSharingPreset?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sharing: SharingPresetSharingInput;
  talentPoolSharingPrefix?: InputMaybe<Scalars['String']['input']>;
};

export class SharingPresetDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class SharingPresetGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class SharingPresetListInput {
  organizationId: Scalars['ID']['input'];
};

export class SharingPresetSharing {
  __typename?: 'SharingPresetSharing';
  allowBilateralChat?: Maybe<Scalars['Boolean']['output']>;
  allowChat?: Maybe<Scalars['Boolean']['output']>;
  allowChatInCollectionChat?: Maybe<Scalars['Boolean']['output']>;
  anonymizationOptions?: Maybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: Maybe<Scalars['Boolean']['output']>;
  autoCVRequested?: Maybe<Scalars['Boolean']['output']>;
  disableSubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  enableNotificationEmails?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['UTCDate']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditable?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditableViaCourse?: Maybe<Scalars['Boolean']['output']>;
  notificationEmailUserGroups?: Maybe<Array<SharingCreateNotificationEmailUserGroup>>;
  parentSharingId?: Maybe<Scalars['ID']['output']>;
  profileAccessId?: Maybe<Scalars['String']['output']>;
  providedTemplates?: Maybe<Array<AvailableDocumentTemplate>>;
  restrictionMode?: Maybe<SharingRestrictionMode>;
  shareAllFileTypes?: Maybe<Scalars['Boolean']['output']>;
  shareInternalDocuments?: Maybe<Scalars['Boolean']['output']>;
  shareMilestoneLists?: Maybe<Scalars['Boolean']['output']>;
  sharedFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  sharedTabs?: Maybe<Array<SharedTab>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: Maybe<Scalars['Boolean']['output']>;
};

export class SharingPresetSharingInput {
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroups?: InputMaybe<Array<SharingCreateNotificationEmailUserGroupInput>>;
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
};

export class SharingPresetUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTalentPoolSharingPreset?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  sharing: SharingPresetSharingInput;
  talentPoolSharingPrefix?: InputMaybe<Scalars['String']['input']>;
};

export class SharingQueryInput {
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
};

export enum SharingRestrictionMode {
  Detailed = 'Detailed',
  Mask = 'Mask',
  Simple = 'Simple'
}

export class SharingSettings {
  __typename?: 'SharingSettings';
  autoCV: Scalars['Boolean']['output'];
  disableSubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  shareAllDocuments?: Maybe<Scalars['Boolean']['output']>;
  sharedDocuments: Array<Scalars['String']['output']>;
  sharedTabs?: Maybe<Array<Scalars['String']['output']>>;
};

export class SharingState {
  __typename?: 'SharingState';
  contactsSharedByTargetOrganization: Scalars['Boolean']['output'];
  contractsSharedByTargetOrganization: Scalars['Boolean']['output'];
  organizationsSharedByCandidateOwner: Scalars['Boolean']['output'];
  specificContactsSharedByTargetOrganization: Array<SharingStateContacts>;
  specificContractSharedByTargetOrganization: Scalars['Boolean']['output'];
  targetOrganizationShared: Scalars['Boolean']['output'];
};

export class SharingStateContacts {
  __typename?: 'SharingStateContacts';
  id: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
};

export class SharingStateInput {
  candidateOwnerOrganizationId: Scalars['ID']['input'];
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  userOrganizationId: Scalars['ID']['input'];
};

export class SharingSubmitInput {
  organizationId: Scalars['ID']['input'];
  sharingId: Scalars['ID']['input'];
};

export class SharingTemplate {
  __typename?: 'SharingTemplate';
  _etag?: Maybe<Scalars['String']['output']>;
  allowBilateralChat?: Maybe<Scalars['Boolean']['output']>;
  allowChat?: Maybe<Scalars['Boolean']['output']>;
  allowChatInCollectionChat?: Maybe<Scalars['Boolean']['output']>;
  anonymizationOptions?: Maybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: Maybe<Scalars['Boolean']['output']>;
  autoCVRequested?: Maybe<Scalars['Boolean']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  creationDate: Scalars['AnkaadiaDateTime']['output'];
  destinationOrganizationCode?: Maybe<Scalars['String']['output']>;
  destinationOrganizationIdOrVariable: Scalars['String']['output'];
  destinationOrganizationIdOrVariableName: Scalars['String']['output'];
  disableSubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  enableNotificationEmails?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditable?: Maybe<Scalars['Boolean']['output']>;
  isCandidateEditableViaCourse?: Maybe<Scalars['Boolean']['output']>;
  notificationEmailUserGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  organizationId: Scalars['ID']['output'];
  parentSharingId?: Maybe<Scalars['ID']['output']>;
  profileAccessId?: Maybe<Scalars['String']['output']>;
  providedTemplates?: Maybe<Array<AvailableDocumentTemplate>>;
  restrictionMode?: Maybe<SharingRestrictionMode>;
  shareAllFileTypes?: Maybe<Scalars['Boolean']['output']>;
  shareInternalDocuments?: Maybe<Scalars['Boolean']['output']>;
  shareMilestoneLists?: Maybe<Scalars['Boolean']['output']>;
  sharedCollectionId: Scalars['ID']['output'];
  sharedFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  sharedTabs?: Maybe<Array<SharedTab>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: Maybe<Scalars['Boolean']['output']>;
  submissionDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  submitted?: Maybe<Scalars['Boolean']['output']>;
};

export class SharingTemplateCreateInput {
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  destinationOrganizationIdOrVariables: Array<Scalars['String']['input']>;
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroups?: InputMaybe<Array<SharingCreateNotificationEmailUserGroupInput>>;
  organizationId: Scalars['ID']['input'];
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCollectionId: Scalars['ID']['input'];
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  submissionDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export class SharingTemplateDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class SharingTemplateUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  destinationOrganizationIdOrVariable: Scalars['String']['input'];
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId: Scalars['ID']['input'];
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCollectionId: Scalars['ID']['input'];
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  submissionDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SharingTypeEnum {
  Collaboration = 'Collaboration',
  ReadOnlyCollaboration = 'ReadOnlyCollaboration',
  View = 'View'
}

export class SharingUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowBilateralChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowChatInCollectionChat?: InputMaybe<Scalars['Boolean']['input']>;
  anonymizationOptions?: InputMaybe<Array<AnonymizationTypeEnum>>;
  appliesToNewCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  autoCVRequested?: InputMaybe<Scalars['Boolean']['input']>;
  creationDate: Scalars['AnkaadiaDateTime']['input'];
  disableSubmitFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidateEditableViaCourse?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEmailUserGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId: Scalars['ID']['input'];
  parentSharingId?: InputMaybe<Scalars['ID']['input']>;
  profileAccessId?: InputMaybe<Scalars['String']['input']>;
  providedTemplates?: InputMaybe<Array<AvailableDocumentTemplateInput>>;
  restrictionMode?: InputMaybe<SharingRestrictionMode>;
  shareAllFileTypes?: InputMaybe<Scalars['Boolean']['input']>;
  shareInternalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shareMilestoneLists?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCollectionId: Scalars['ID']['input'];
  sharedFileTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedTabs?: InputMaybe<Array<SharedTabInput>>;
  sharingType: SharingTypeEnum;
  showCompletionStateAtDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  submissionDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SignatureType {
  Aes = 'AES',
  Qes = 'QES',
  Ses = 'SES'
}

export class SignerClaim {
  __typename?: 'SignerClaim';
  organizationId: Scalars['String']['output'];
  userOrCandidateId: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export class SignerEmbed {
  __typename?: 'SignerEmbed';
  src: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export class SignerMapping {
  __typename?: 'SignerMapping';
  assignedUserGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  processOrganizationId: Scalars['String']['output'];
};

export class SignerMappingInput {
  assignedUserGroupIds: Array<Scalars['String']['input']>;
  processOrganizationId: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
};

export enum SignerStatus {
  Awaiting = 'Awaiting',
  Completed = 'Completed',
  Declined = 'Declined',
  Opened = 'Opened',
  Sent = 'Sent'
}

export class SigningEnabledTemplate {
  __typename?: 'SigningEnabledTemplate';
  displayName: Scalars['String']['output'];
  requiredSignatureTypes: Array<SignatureType>;
};

export class SigningInitiationRole {
  __typename?: 'SigningInitiationRole';
  assignedUserGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  isCandidate: Scalars['Boolean']['output'];
  processOrganizationId?: Maybe<Scalars['String']['output']>;
  roleName: Scalars['String']['output'];
  signatureType?: Maybe<SignatureType>;
};

export class SigningInitiationTemplate {
  __typename?: 'SigningInitiationTemplate';
  roles: Array<SigningInitiationRole>;
  templateName: Scalars['String']['output'];
};

export class SigningRoleMappingEntry {
  __typename?: 'SigningRoleMappingEntry';
  documentRoleName: Scalars['String']['output'];
  processRoleName: Scalars['String']['output'];
};

export class SigningRoleMappingEntryInput {
  documentRoleName: Scalars['String']['input'];
  processRoleName: Scalars['String']['input'];
};

export class SigningRoleOrganizationUserGroupMappingInput {
  assignedUserGroupId: Scalars['ID']['input'];
  documentRoleName: Scalars['String']['input'];
  processOrganizationId: Scalars['ID']['input'];
};

export class SigningRoleResult {
  __typename?: 'SigningRoleResult';
  isUnknown: Scalars['Boolean']['output'];
  roleName: Scalars['String']['output'];
  signatureType?: Maybe<SignatureType>;
};

export class SigningRolesResult {
  __typename?: 'SigningRolesResult';
  roles: Array<SigningRoleResult>;
};

export enum SigningSubmissionFilterStatus {
  Active = 'Active',
  Failed = 'Failed',
  Finished = 'Finished'
}

export class SigningSubmissionOutput {
  __typename?: 'SigningSubmissionOutput';
  _etag?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['AnkaadiaDateTime']['output'];
  docusealSubmissionId: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  signers: Array<SigningSubmissionSigner>;
  status: SigningSubmissionStatus;
  targetCandidateDocument: TargetCandidateDocument;
  templateName: Scalars['String']['output'];
};

export class SigningSubmissionRecord {
  __typename?: 'SigningSubmissionRecord';
  completedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  docusealSubmissionId: Scalars['Int']['output'];
  status: SigningSubmissionStatus;
  templateName: Scalars['String']['output'];
};

export class SigningSubmissionRecordInput {
  completedAt?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  docusealSubmissionId: Scalars['Int']['input'];
  status: SigningSubmissionStatus;
  templateName: Scalars['String']['input'];
};

export class SigningSubmissionSigner {
  __typename?: 'SigningSubmissionSigner';
  claim?: Maybe<SignerClaim>;
  completedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  docusealSubmitterId: Scalars['Int']['output'];
  isAddOnActive?: Maybe<Scalars['Boolean']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  mapping: SignerMapping;
  roleName: Scalars['String']['output'];
  signatureType: SignatureType;
  status: SignerStatus;
  submitterSlug: Scalars['String']['output'];
};

export enum SigningSubmissionStatus {
  Completed = 'Completed',
  Declined = 'Declined',
  InProgress = 'InProgress',
  StorageBlocked = 'StorageBlocked'
}

export class SingleSetConfig {
  __typename?: 'SingleSetConfig';
  formats: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export class SingleSetConfigInput {
  formats: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export class SortingCriterion {
  __typename?: 'SortingCriterion';
  organizationId?: Maybe<Scalars['ID']['output']>;
  sortingType: SortingTypeEnum;
  value?: Maybe<Scalars['String']['output']>;
};

export class SortingCriterionInput {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sortingType: SortingTypeEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum SortingTypeEnum {
  Candidate = 'Candidate',
  Collection = 'Collection',
  Contact = 'Contact',
  Organization = 'Organization',
  Process = 'Process',
  Tag = 'Tag'
}

export class StarnormInsuranceBundleOutput {
  __typename?: 'StarnormInsuranceBundleOutput';
  insurances: Array<StarnormInsuranceOutput>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export class StarnormInsuranceOutput {
  __typename?: 'StarnormInsuranceOutput';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export class StartCandidateChatGroupConversation {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
  candidates?: InputMaybe<Array<ChatUserOrCandidateIdInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeCandidateInGroup?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  startChatGroupConversationType: CandidateChatGroupConversationType;
  userGroups?: InputMaybe<Array<ChatGroupInput>>;
  users?: InputMaybe<Array<ChatUserOrCandidateCreateInput>>;
};

export class StartCandidateChatGroupConversationOption {
  __typename?: 'StartCandidateChatGroupConversationOption';
  candidates?: Maybe<Array<ChatUserOrCandidateId>>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  startChatGroupConversationType: CandidateChatGroupConversationType;
  userGroups?: Maybe<Array<ChatUserGroupForGroup>>;
  users?: Maybe<Array<ChatUserOrCandidateForGroup>>;
};

export class StartCandidateChatGroupConversationOptionsRequest {
  includeCandidateInGroup?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
  userOrCandidateId: Scalars['String']['input'];
};

export class StatesInboxInput {
  language?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InstanceStateEnum>>;
};

export class StaticDataDownload {
  __typename?: 'StaticDataDownload';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export class StaticDataInputContext {
  immigrationCountry?: InputMaybe<SupportedImmigrationCountry>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export class StaticDataModel {
  __typename?: 'StaticDataModel';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export class StaticDataModelInput {
  contexts?: InputMaybe<Array<StaticDataInputContext>>;
  language: Scalars['String']['input'];
  type: StaticDataType;
};

export class StaticDataResult {
  __typename?: 'StaticDataResult';
  contextSensitiveFields?: Maybe<Array<Scalars['String']['output']>>;
  data: Array<StaticDataModel>;
  isLanguageIndependent?: Maybe<Scalars['Boolean']['output']>;
};

export enum StaticDataType {
  AccountingRecordCategory = 'AccountingRecordCategory',
  All = 'All',
  AllowedSharedProfileTabs = 'AllowedSharedProfileTabs',
  AllowedUploadFileTypes = 'AllowedUploadFileTypes',
  AwardFrequency = 'AwardFrequency',
  Beds = 'Beds',
  Benefits = 'Benefits',
  CandidateEvent = 'CandidateEvent',
  CandidateEventCategory = 'CandidateEventCategory',
  CandidateEventTimeframe = 'CandidateEventTimeframe',
  CareFacilities = 'CareFacilities',
  Category = 'Category',
  CertificateOfConduct = 'CertificateOfConduct',
  CooperationType = 'CooperationType',
  Countries = 'Countries',
  Currencies = 'Currencies',
  DocumentAvailabilityState = 'DocumentAvailabilityState',
  DocumentDescription = 'DocumentDescription',
  DocumentFormats = 'DocumentFormats',
  DocumentFormats2FileNameMapping = 'DocumentFormats2FileNameMapping',
  DocumentFormatsAppreviation = 'DocumentFormatsAppreviation',
  DrivingLicenses = 'DrivingLicenses',
  Education = 'Education',
  EquivalenceTest = 'EquivalenceTest',
  ExamInstitutions = 'ExamInstitutions',
  ExamResultState = 'ExamResultState',
  ExamType = 'ExamType',
  EyeColor = 'EyeColor',
  FederalStates = 'FederalStates',
  FileType2FileNameMapping = 'FileType2FileNameMapping',
  Functions = 'Functions',
  Gender = 'Gender',
  KnownCities = 'KnownCities',
  LaborAgreementType = 'LaborAgreementType',
  LaborContractAllowance = 'LaborContractAllowance',
  LaborContractType = 'LaborContractType',
  LaborContractWorkSchedule = 'LaborContractWorkSchedule',
  LanguageLevels = 'LanguageLevels',
  LanguageModules = 'LanguageModules',
  Languages = 'Languages',
  MartialStatus = 'MartialStatus',
  OrganizationType = 'OrganizationType',
  OtherActivities = 'OtherActivities',
  OwnDataProfileTabs = 'OwnDataProfileTabs',
  PathOfRecognition = 'PathOfRecognition',
  Positions = 'Positions',
  PreferredFamilyReunion = 'PreferredFamilyReunion',
  PreferredTypeOfImmigration = 'PreferredTypeOfImmigration',
  ProcessRole = 'ProcessRole',
  Profession = 'Profession',
  ProfessionArea = 'ProfessionArea',
  ProfessionalFields = 'ProfessionalFields',
  QualificationEvaluationNoticeKind = 'QualificationEvaluationNoticeKind',
  QualificationExams = 'QualificationExams',
  QualificationMeasures = 'QualificationMeasures',
  QualificationType = 'QualificationType',
  RecognitionCenter = 'RecognitionCenter',
  RecognitionNoticeKind = 'RecognitionNoticeKind',
  RecognitionState = 'RecognitionState',
  RecognitionType = 'RecognitionType',
  RelocationRequirements = 'RelocationRequirements',
  ResidencePermits = 'ResidencePermits',
  Salutation = 'Salutation',
  SignatureAddition = 'SignatureAddition',
  SuitabilityForWork = 'SuitabilityForWork',
  SupportedImmigrationCountries = 'SupportedImmigrationCountries',
  TargetRecognition = 'TargetRecognition',
  TaskDelayReason = 'TaskDelayReason',
  Title = 'Title',
  TravelVehicles = 'TravelVehicles',
  Vaccination = 'Vaccination',
  VaccinationStatus = 'VaccinationStatus',
  VaccineFunction = 'VaccineFunction',
  VocationalSchoolTrainingTimeCurrent = 'VocationalSchoolTrainingTimeCurrent',
  VocationalSchoolTrainingTimeTotal = 'VocationalSchoolTrainingTimeTotal',
  WayToUs = 'WayToUs',
  WorkArea = 'WorkArea',
  WorkEnvironment = 'WorkEnvironment',
  WorkLocations = 'WorkLocations',
  WorkingTimeType = 'WorkingTimeType'
}

export class StorageEntry {
  __typename?: 'StorageEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum StripeErrorMessageKeys {
  CustomerAddressMissing = 'CUSTOMER_ADDRESS_MISSING',
  CustomerDefaultPaymentMethodMissing = 'CUSTOMER_DEFAULT_PAYMENT_METHOD_MISSING',
  CustomerDeleted = 'CUSTOMER_DELETED',
  CustomerEmailMissing = 'CUSTOMER_EMAIL_MISSING',
  CustomerNotCreated = 'CUSTOMER_NOT_CREATED',
  CustomerNotFound = 'CUSTOMER_NOT_FOUND'
}

export class SubagentAppliedEmitEvent {
  __typename?: 'SubagentAppliedEmitEvent';
  commandId?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  subagentInvocationId: Scalars['String']['output'];
  targetItemId?: Maybe<Scalars['String']['output']>;
  targetScope: Scalars['String']['output'];
  targetSection: Scalars['String']['output'];
  targetTaskId?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
};

export class SubagentProgressEmitEvent {
  __typename?: 'SubagentProgressEmitEvent';
  detail?: Maybe<Scalars['String']['output']>;
  phase: Scalars['String']['output'];
  subagentId: Scalars['String']['output'];
  subagentName: Scalars['String']['output'];
};

export class SubagentResultEmitEvent {
  __typename?: 'SubagentResultEmitEvent';
  batchId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorKind?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  result?: Maybe<Scalars['JSONObject']['output']>;
  subagentId: Scalars['String']['output'];
  subagentInvocationId: Scalars['String']['output'];
  subagentName: Scalars['String']['output'];
  targetItemId?: Maybe<Scalars['String']['output']>;
  targetScope: Scalars['String']['output'];
  targetSection: Scalars['String']['output'];
  targetTaskId?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
};

export class SubagentStartEmitEvent {
  __typename?: 'SubagentStartEmitEvent';
  subagentId: Scalars['String']['output'];
  subagentName: Scalars['String']['output'];
};

export class Subscription {
  __typename?: 'Subscription';
  acquireAdhocProcess: ProcessResultEvent;
  agentEvents: ProcessAgentEvent;
  aiChatSessionEvents: AiChatSessionTitledEvent;
  applyProgress: ProcessAgentEvent;
  calculateProcessModelAverageDurations: ProcessModelAverageDurationResultEvent;
  convertDocumentImportToTechnicalImportSheet: XlsxImportResultForDocumentImportEvent;
  createProcess: ProcessResultEvent;
  createProcessModelRelease: ReleasedProcessModelResultEvent;
  deleteProcess: MutationResultEvent;
  executeApplicationOfTask: OnlineApplicationExecutionEvent;
  executeApplications: OnlineApplicationExecutionEvent;
  exportOrganizationsData: XlsxTemplateResultEvent;
  extractDocumentData: DocumentAiExtractionResult;
  generateActivationConditionSession: ChatSessionReadyEvent;
  generateActivationConditionStream: ActivationConditionEvent;
  generateReportTemplate: GenerateTemplateReportEvent;
  getAvailableOrganizations: OrganizationListEvent;
  getBillingData: ExcelAddInEvent;
  getCandidateData: ExcelAddInEvent;
  getChangeStatisticsData: ExcelAddInEvent;
  getCollectionList: CollectionListEvent;
  getImportUploadUrl: ImportUploadUrlResultEvent;
  getKnownVars: KnownVarsTreeEvent;
  getLingokingData: ExcelAddInEvent;
  getOverviewOfRequiredDocumentsForCandidate: RequiredDocumentOverviewEvent;
  getOverviewOfRequiredDocumentsForCollection: RequiredDocumentOverviewEvent;
  getOverviewOfRequiredDocumentsForProcess: RequiredDocumentOverviewEvent;
  getProcessPlanningSubscription: ProcessPlanningResultEvent;
  getSalesData: ExcelAddInEvent;
  getUsedVariables: UsedVariablesDownloadEvent;
  getXLSXTemplateForCandidates: XlsxTemplateResultEvent;
  getXLSXTemplateForContractTemplates: XlsxTemplateResultEvent;
  getXLSXTemplateForDocumentImport: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationCRMData: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationContactSettings: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationContacts: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationUserGroups: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationUserMemberships: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizationUsers: XlsxTemplateResultEvent;
  getXLSXTemplateForOrganizations: XlsxTemplateResultEvent;
  importFilledXLSXTemplateForCandidates: XlsxImportResultEvent;
  importFilledXLSXTemplateForContractTemplates: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationCRMData: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationContactSettings: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationContacts: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationUserGroups: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationUserMemberships: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizationUsers: XlsxImportResultEvent;
  importFilledXLSXTemplateForOrganizations: XlsxImportResultEvent;
  loginFor2FA: OnlineApplicationLoginResult;
  processAgentChat: ProcessAgentEvent;
  processAgentChatSession: ChatSessionReadyEvent;
  publishProcessModel: PublishedProcessModelResultEvent;
  recalculateMilestoneResults: RecalculateMilestoneResultsEvent;
  regenerateProgress: ProcessAgentEvent;
  /** Resets tasks of a root process to their model configuration ("Soft") or to "never started" ("Hard"), AB#9601. A subscription so large resets can report progress instead of holding one long request open. */
  resetTasks: ProcessTaskResetResultEvent;
  syncAllProcesses: ProcessListResultEvent;
  syncProcess: ProcessResultEvent;
  toggleProcessState: ProcessResultEvent;
  triggerCandidateChangedForAction: TriggerCandidateChangedEventUnion;
  triggerRebuildSharingMatrix: RebuildSharingMatrixEvent;
  updateProcess: ProcessResultEvent;
  validateApplicationOfTask: OnlineApplicationValidationEvent;
  validateApplications: OnlineApplicationValidationEvent;
};


export type SubscriptionAcquireAdhocProcessArgs = {
  input: AdhocProcessAcquireInput;
};


export type SubscriptionAgentEventsArgs = {
  runId: Scalars['ID']['input'];
};


export type SubscriptionAiChatSessionEventsArgs = {
  sessionId: Scalars['ID']['input'];
};


export type SubscriptionApplyProgressArgs = {
  input: ApplyProgressSubscriptionInput;
};


export type SubscriptionCalculateProcessModelAverageDurationsArgs = {
  input: ProcessModelAverageDurationInput;
};


export type SubscriptionConvertDocumentImportToTechnicalImportSheetArgs = {
  input: XlsxDocumentImportInput;
};


export type SubscriptionCreateProcessArgs = {
  input: ProcessCreateInput;
};


export type SubscriptionCreateProcessModelReleaseArgs = {
  input: ProcessModelCreateReleaseInput;
};


export type SubscriptionDeleteProcessArgs = {
  input: ProcessDeleteInput;
};


export type SubscriptionExecuteApplicationOfTaskArgs = {
  input: OnlineApplicationTaskExecutionInput;
};


export type SubscriptionExecuteApplicationsArgs = {
  input: OnlineApplicationExecutionInput;
};


export type SubscriptionExportOrganizationsDataArgs = {
  input: XlsxTemplateForProcessesGetInput;
};


export type SubscriptionExtractDocumentDataArgs = {
  input: DocumentAiExtractionInput;
};


export type SubscriptionGenerateActivationConditionSessionArgs = {
  input: ChatSessionInput;
};


export type SubscriptionGenerateActivationConditionStreamArgs = {
  input: GenerateActivationConditionInput;
};


export type SubscriptionGenerateReportTemplateArgs = {
  input: GenerateTemplateReportInput;
};


export type SubscriptionGetBillingDataArgs = {
  input: ExcelAddInBillingDataInput;
};


export type SubscriptionGetCandidateDataArgs = {
  input: ExcelAddInGetCandidateDataInput;
};


export type SubscriptionGetChangeStatisticsDataArgs = {
  input: ExcelAddinGetChangeStatisticsInput;
};


export type SubscriptionGetImportUploadUrlArgs = {
  input: ImportUrlInput;
};


export type SubscriptionGetLingokingDataArgs = {
  input: ExcelAddInLingokingDataInput;
};


export type SubscriptionGetOverviewOfRequiredDocumentsForCandidateArgs = {
  input: DocumentOverviewInputCandidate;
};


export type SubscriptionGetOverviewOfRequiredDocumentsForCollectionArgs = {
  input: DocumentOverviewInputCollection;
};


export type SubscriptionGetOverviewOfRequiredDocumentsForProcessArgs = {
  input: DocumentOverviewInputProcess;
};


export type SubscriptionGetProcessPlanningSubscriptionArgs = {
  input: ProcessPlanningInput;
};


export type SubscriptionGetSalesDataArgs = {
  input: ExcelAddInSalesDataInput;
};


export type SubscriptionGetXlsxTemplateForCandidatesArgs = {
  input: XlsxTemplateForCandidatesGetInput;
};


export type SubscriptionGetXlsxTemplateForContractTemplatesArgs = {
  input: XlsxTemplateForContractTemplatesGetInput;
};


export type SubscriptionGetXlsxTemplateForDocumentImportArgs = {
  input: XlsxTemplateForDocumentImportGetInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationCrmDataArgs = {
  input: XlsxTemplateForOrganizationCrmDataGetInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationContactSettingsArgs = {
  input: XlsxTemplateForOrganizationContactSettingsGetInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationContactsArgs = {
  input: XlsxTemplateForOrganizationContactsGetInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationUserGroupsArgs = {
  input: XlsxTemplateForOrganizationUserGroupsInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationUserMembershipsArgs = {
  input: XlsxTemplateForOrganizationUserMembershipsInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationUsersArgs = {
  input: XlsxTemplateForOrganizationUsersInput;
};


export type SubscriptionGetXlsxTemplateForOrganizationsArgs = {
  input: XlsxTemplateForOrganizationsGetInput;
};


export type SubscriptionImportFilledXlsxTemplateForCandidatesArgs = {
  input: XlsxCandidateImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForContractTemplatesArgs = {
  input: XlsxContractTemplateImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationCrmDataArgs = {
  input: XlsxOrganizationCrmDataImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationContactSettingsArgs = {
  input: XlsxOrganizationContactSettingsImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationContactsArgs = {
  input: XlsxOrganizationContactImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationUserGroupsArgs = {
  input: XlsxOrganizationUserGroupsImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationUserMembershipsArgs = {
  input: XlsxOrganizationUserMembershipsImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationUsersArgs = {
  input: XlsxOrganizationUsersImportInput;
};


export type SubscriptionImportFilledXlsxTemplateForOrganizationsArgs = {
  input: XlsxOrganizationImportInput;
};


export type SubscriptionLoginFor2FaArgs = {
  input: OnlineApplicationLoginInput;
};


export type SubscriptionProcessAgentChatArgs = {
  input: ChatRequestDto;
};


export type SubscriptionProcessAgentChatSessionArgs = {
  input: ChatSessionInput;
};


export type SubscriptionPublishProcessModelArgs = {
  input: ProcessModelPublishInput;
};


export type SubscriptionRegenerateProgressArgs = {
  input: RegenerateProgressSubscriptionInput;
};


export type SubscriptionResetTasksArgs = {
  input: ProcessTaskResetInput;
};


export type SubscriptionSyncAllProcessesArgs = {
  input: ProcessSyncAllInput;
  syncOptions?: InputMaybe<ProcessSyncInputOptions>;
};


export type SubscriptionSyncProcessArgs = {
  input: ProcessSyncInput;
  syncOptions?: InputMaybe<ProcessSyncInputOptions>;
};


export type SubscriptionToggleProcessStateArgs = {
  input: ProcessActivateInput;
};


export type SubscriptionTriggerCandidateChangedForActionArgs = {
  input: ProcessActionGetInput;
};


export type SubscriptionUpdateProcessArgs = {
  input: ProcessUpdateInput;
};


export type SubscriptionValidateApplicationOfTaskArgs = {
  input: OnlineApplicationTaskValidationInput;
};


export type SubscriptionValidateApplicationsArgs = {
  input: OnlineApplicationValidationInput;
};

export class SupplementableInvoice {
  __typename?: 'SupplementableInvoice';
  amount: Scalars['Float']['output'];
  billingPeriodEndDate: Scalars['UTCDate']['output'];
  billingPeriodStartDate: Scalars['UTCDate']['output'];
  bookingCount: Scalars['Int']['output'];
  currency: SupportedBillingCurrency;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceNumber: Scalars['String']['output'];
};

export class SupplementaryInvoiceCreateInput {
  organizationId: Scalars['ID']['input'];
  originalInvoiceId: Scalars['ID']['input'];
};

export enum SupportedBillingCurrency {
  Eur = 'EUR'
}

export enum SupportedImmigrationCountry {
  At = 'AT',
  De = 'DE',
  Unknown = 'UNKNOWN'
}

export class SystemSetting {
  __typename?: 'SystemSetting';
  _etag?: Maybe<Scalars['String']['output']>;
  allowEmailToUninvitedCandidates?: Maybe<Scalars['Boolean']['output']>;
  automaticRejectionEmailsEnabled: Scalars['Boolean']['output'];
  candidateDeletionSetting: Array<CandidateDeletionSetting>;
  candidateSupportEmail?: Maybe<Scalars['String']['output']>;
  candidateSupportPhone?: Maybe<Scalars['String']['output']>;
  candidateTags?: Maybe<Array<CandidateTagConfiguration>>;
  educationModuleVisibleForState?: Maybe<Array<CandidateStatus>>;
  enableCustomCandidateTags?: Maybe<Scalars['Boolean']['output']>;
  enableEducationModuleVisibleForState?: Maybe<Scalars['Boolean']['output']>;
  fileNameWithCandidateId: Scalars['Boolean']['output'];
  fileNameWithFileFormat: Scalars['Boolean']['output'];
  forbidNewDocumentCreationByCandidates?: Maybe<Scalars['Boolean']['output']>;
  hideEmptyLists?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPubliclyVisible: Scalars['Boolean']['output'];
  isSystemLogoutEnabled: Scalars['Boolean']['output'];
  logoutPeriodMinutes: Scalars['Float']['output'];
  organizationId: Scalars['ID']['output'];
  persistHistoricCandidateData?: Maybe<Scalars['Boolean']['output']>;
  precisionOfEducation?: Maybe<WorkExperiencePrecissionEnum>;
  precisionOfWorkexperience?: Maybe<WorkExperiencePrecissionEnum>;
  precisionOfestimatedArrival?: Maybe<ProcessStatePrecissionEnum>;
  precisionOfestimatedWorkStartDate?: Maybe<ProcessStatePrecissionEnum>;
  removeCandidatesFromAllListsIfDropout?: Maybe<Scalars['Boolean']['output']>;
  requiredCandidateFields?: Maybe<Array<Scalars['String']['output']>>;
  standardImmigrationCountry: SupportedImmigrationCountry;
  supportedImmigrationCountries: Array<SupportedImmigrationCountry>;
  useSimpleCandidateDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
};

export class SystemSettingsForCandidateOrg {
  __typename?: 'SystemSettingsForCandidateOrg';
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  precisionOfEducation?: Maybe<WorkExperiencePrecissionEnum>;
  precisionOfWorkexperience?: Maybe<WorkExperiencePrecissionEnum>;
  precisionOfestimatedArrival?: Maybe<ProcessStatePrecissionEnum>;
  precisionOfestimatedWorkStartDate?: Maybe<ProcessStatePrecissionEnum>;
  requiredCandidateFields?: Maybe<Array<Scalars['String']['output']>>;
  standardImmigrationCountry: SupportedImmigrationCountry;
  useSimpleCandidateDocumentUpload?: Maybe<Scalars['Boolean']['output']>;
};

export class SystemSettingsGetInput {
  organizationId: Scalars['ID']['input'];
};

export class SystemSettingsUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  allowEmailToUninvitedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  automaticRejectionEmailsEnabled: Scalars['Boolean']['input'];
  candidateDeletionSetting: Array<CandidateDeletionSettingInput>;
  candidateSupportEmail?: InputMaybe<Scalars['String']['input']>;
  candidateSupportPhone?: InputMaybe<Scalars['String']['input']>;
  candidateTags?: InputMaybe<Array<CandidateTagConfigurationInput>>;
  educationModuleVisibleForState?: InputMaybe<Array<CandidateStatus>>;
  enableCustomCandidateTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableEducationModuleVisibleForState?: InputMaybe<Scalars['Boolean']['input']>;
  fileNameWithCandidateId: Scalars['Boolean']['input'];
  fileNameWithFileFormat: Scalars['Boolean']['input'];
  forbidNewDocumentCreationByCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  hideEmptyLists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPubliclyVisible: Scalars['Boolean']['input'];
  isSystemLogoutEnabled: Scalars['Boolean']['input'];
  logoutPeriodMinutes: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
  persistHistoricCandidateData?: InputMaybe<Scalars['Boolean']['input']>;
  precisionOfEducation?: InputMaybe<WorkExperiencePrecissionEnum>;
  precisionOfWorkexperience?: InputMaybe<WorkExperiencePrecissionEnum>;
  precisionOfestimatedArrival?: InputMaybe<ProcessStatePrecissionEnum>;
  precisionOfestimatedWorkStartDate?: InputMaybe<ProcessStatePrecissionEnum>;
  removeCandidatesFromAllListsIfDropout?: InputMaybe<Scalars['Boolean']['input']>;
  requiredCandidateFields?: InputMaybe<Array<Scalars['String']['input']>>;
  standardImmigrationCountry: SupportedImmigrationCountry;
  supportedImmigrationCountries: Array<SupportedImmigrationCountry>;
  useSimpleCandidateDocumentUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export class TcConsent {
  __typename?: 'TCConsent';
  consentDate: Scalars['AnkaadiaDateTime']['output'];
  consentTexts?: Maybe<Array<TcConsentText>>;
};

export class TcConsentText {
  __typename?: 'TCConsentText';
  contents: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export class TabField {
  __typename?: 'TabField';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export class TabFieldInput {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export enum TabPermission {
  Enabled = 'Enabled',
  Mandatory = 'Mandatory',
  Selected = 'Selected'
}

export class TableColumnConfig {
  __typename?: 'TableColumnConfig';
  columnWidths?: Maybe<Array<ColumnWidth>>;
  columns: Array<Scalars['String']['output']>;
  sortField?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  table: ConfigurableTable;
};

export enum TableMode {
  Flat = 'Flat',
  Relational = 'Relational'
}

export class Talent {
  __typename?: 'Talent';
  age?: Maybe<Scalars['Float']['output']>;
  applicationSafeCompetencies?: Maybe<Array<Scalars['String']['output']>>;
  availableFrom?: Maybe<Scalars['UTCDate']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  careFacilities?: Maybe<Array<Scalars['String']['output']>>;
  contributorOrganizationId: Scalars['ID']['output'];
  country?: Maybe<Scalars['String']['output']>;
  drivingLicense?: Maybe<Array<Scalars['String']['output']>>;
  experienceFields?: Maybe<Array<Scalars['String']['output']>>;
  function: Scalars['String']['output'];
  furtherEducation?: Maybe<Array<FurtherEducationData>>;
  germanLevel?: Maybe<Scalars['String']['output']>;
  hasCv: Scalars['Boolean']['output'];
  immigrationCountry: SupportedImmigrationCountry;
  nonCertifiedGermanLevel?: Maybe<Scalars['String']['output']>;
  otherLanguageSkills?: Maybe<Array<LanguageSkill>>;
  preferredCareFacility?: Maybe<Array<Scalars['String']['output']>>;
  preferredFamilyReunion?: Maybe<Scalars['String']['output']>;
  preferredLocationState?: Maybe<Array<Scalars['String']['output']>>;
  preferredPathOfRecognition?: Maybe<Scalars['String']['output']>;
  preferredProfessions?: Maybe<Array<Scalars['String']['output']>>;
  preferredTemporalScope?: Maybe<WorkingTimeTypeEnum>;
  preferredWorkEnvironment?: Maybe<Array<Scalars['String']['output']>>;
  preferredWorkingField?: Maybe<Array<Scalars['String']['output']>>;
  profession: Scalars['String']['output'];
  professionalRecognitionState: RecognitionState;
  qualification?: Maybe<Array<QualificationData>>;
  qualificationMeasure?: Maybe<QualificationMeasureData>;
  salutation?: Maybe<Scalars['String']['output']>;
  talentId: Scalars['String']['output'];
  talentPoolId: Scalars['ID']['output'];
  talentPoolOrganizationId: Scalars['ID']['output'];
  yearsOfProfessionalExperience: YearsAndMonths;
};

export class TalentInstance {
  __typename?: 'TalentInstance';
  talentId: Scalars['String']['output'];
  talentPoolId: Scalars['ID']['output'];
  talentPoolOrganizationId: Scalars['ID']['output'];
};

export class TalentInstanceInput {
  talentId: Scalars['String']['input'];
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
};

export class TalentPool {
  __typename?: 'TalentPool';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  description?: Maybe<Array<LocalizedString>>;
  globalTalentPoolCategory?: Maybe<GlobalTalentPoolCategory>;
  id?: Maybe<Scalars['ID']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  localizedDescription?: Maybe<Scalars['String']['output']>;
  localizedName: Scalars['String']['output'];
  name: Array<LocalizedString>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  participantOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  type: TalentPoolType;
  useUniformCv?: Maybe<Scalars['Boolean']['output']>;
};

export class TalentPoolAllowedAddons {
  __typename?: 'TalentPoolAllowedAddons';
  employerPool: Scalars['Boolean']['output'];
  psaPool: Scalars['Boolean']['output'];
  websitePool: Scalars['Boolean']['output'];
};

export class TalentPoolConfiguration {
  __typename?: 'TalentPoolConfiguration';
  canContributeToAnkaadiaPool: Scalars['Boolean']['output'];
  isContributorInPool: Scalars['Boolean']['output'];
  isUserInPool: Scalars['Boolean']['output'];
  standard: Scalars['Boolean']['output'];
  standardInclContributors: Scalars['Boolean']['output'];
  talentPoolAllowedAddons: TalentPoolAllowedAddons;
  website: Scalars['Boolean']['output'];
};

export class TalentPoolCreateInput {
  description?: InputMaybe<Array<LocalizedStringInput>>;
  globalTalentPoolCategory?: InputMaybe<GlobalTalentPoolCategory>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  type: TalentPoolType;
  useUniformCv?: InputMaybe<Scalars['Boolean']['input']>;
};

export class TalentPoolCustomSkill {
  __typename?: 'TalentPoolCustomSkill';
  categoryLabel: Scalars['String']['output'];
  preferredLabel: Scalars['String']['output'];
  skillId: Scalars['String']['output'];
  skillType: OccupationSkillType;
};

export class TalentPoolCv {
  __typename?: 'TalentPoolCv';
  fileName: Scalars['String']['output'];
  status: AutoCvResponseStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export class TalentPoolCvInput {
  talent: TalentInstanceInput;
};

export class TalentPoolDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolFacets {
  __typename?: 'TalentPoolFacets';
  certifiedLanguageLevels: Array<SearchFacet>;
  countryOfOrigin: Array<SearchFacet>;
  drivingLicense: Array<SearchFacet>;
  function: Array<SearchFacet>;
  immigrationCountry: Array<SearchFacet>;
  knowledge: Array<SearchFacet>;
  notCertifiedLanguageLevels: Array<SearchFacet>;
  preferredCareFacility: Array<SearchFacet>;
  preferredEmploymentType: Array<SearchFacet>;
  preferredFamilyReunion: Array<SearchFacet>;
  preferredLocationState: Array<SearchFacet>;
  preferredProfessions: Array<SearchFacet>;
  preferredTemporalScope: Array<SearchFacet>;
  preferredTypeOfImmigration: Array<SearchFacet>;
  preferredWorkEnvironment: Array<SearchFacet>;
  preferredWorkingField: Array<SearchFacet>;
  profession: Array<SearchFacet>;
  professionArea: Array<SearchFacet>;
  professionSubArea: Array<SearchFacet>;
  recognitionReceived: Array<SearchFacet>;
  skills: Array<SearchFacet>;
  yearsOfExperience: Array<SearchFacet>;
};

export class TalentPoolFilters {
  availableFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  certifiedLanguageLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  countryOfOrigin?: InputMaybe<Array<Scalars['String']['input']>>;
  drivingLicense?: InputMaybe<Array<Scalars['String']['input']>>;
  function?: InputMaybe<Array<Scalars['String']['input']>>;
  immigrationCountry?: InputMaybe<Array<SupportedImmigrationCountry>>;
  knowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  notCertifiedLanguageLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredCareFacility?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredEmploymentType?: InputMaybe<Array<EmploymentRelationshipType>>;
  preferredFamilyReunion?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredLocationState?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredProfessions?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredTemporalScope?: InputMaybe<Array<WorkingTimeTypeEnum>>;
  preferredTypeOfImmigration?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredWorkEnvironment?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredWorkingField?: InputMaybe<Array<Scalars['String']['input']>>;
  profession?: InputMaybe<Array<Scalars['String']['input']>>;
  professionArea?: InputMaybe<Array<Scalars['String']['input']>>;
  professionSubArea?: InputMaybe<Array<Scalars['String']['input']>>;
  recognitionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  yearsOfExperience?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export class TalentPoolGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolListInput {
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolParticipant {
  __typename?: 'TalentPoolParticipant';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  participantOrganizationId: Scalars['ID']['output'];
  participantOrganizationName?: Maybe<Scalars['String']['output']>;
  relevantProfessions?: Maybe<Array<Scalars['String']['output']>>;
  talentPoolId: Scalars['ID']['output'];
  types: Array<TalentPoolParticipantType>;
};

export class TalentPoolParticipantDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolParticipantGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolParticipantListInput {
  organizationId: Scalars['ID']['input'];
  talentPoolId: Scalars['ID']['input'];
};

export enum TalentPoolParticipantType {
  Contributor = 'Contributor',
  User = 'User'
}

export class TalentPoolParticipantUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  participantOrganizationId: Scalars['ID']['input'];
  relevantProfessions?: InputMaybe<Array<Scalars['String']['input']>>;
  talentPoolId: Scalars['ID']['input'];
  types: Array<TalentPoolParticipantType>;
};

export class TalentPoolParticipantsCreateInput {
  organizationId: Scalars['ID']['input'];
  participantOrganizationIds: Array<Scalars['ID']['input']>;
  relevantProfessions?: InputMaybe<Array<Scalars['String']['input']>>;
  talentPoolId: Scalars['ID']['input'];
  types: Array<TalentPoolParticipantType>;
};

export class TalentPoolRequestedTalent {
  __typename?: 'TalentPoolRequestedTalent';
  _etag?: Maybe<Scalars['String']['output']>;
  approvalNote?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestNote?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['AnkaadiaDateTime']['output'];
  requestedByUserId?: Maybe<Scalars['ID']['output']>;
  requestingOrganizationId: Scalars['ID']['output'];
  state: TalentRequestState;
  stateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  talent: TalentInstance;
};

export class TalentPoolRequestedTalentDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolRequestedTalentIncoming {
  __typename?: 'TalentPoolRequestedTalentIncoming';
  _etag?: Maybe<Scalars['String']['output']>;
  approvalNote?: Maybe<Scalars['String']['output']>;
  candidateCountry?: Maybe<Scalars['String']['output']>;
  candidateDisplayName: Scalars['String']['output'];
  candidateFunction: Scalars['String']['output'];
  candidateId: Scalars['String']['output'];
  candidateOrganizationId: Scalars['String']['output'];
  candidateProfession: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestNote?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['AnkaadiaDateTime']['output'];
  requestedByUserId?: Maybe<Scalars['ID']['output']>;
  requestingOrganizationCode?: Maybe<Scalars['String']['output']>;
  requestingOrganizationEmail?: Maybe<Scalars['String']['output']>;
  requestingOrganizationId: Scalars['ID']['output'];
  requestingOrganizationName?: Maybe<Scalars['String']['output']>;
  requestingOrganizationPhone?: Maybe<Scalars['String']['output']>;
  state: TalentRequestState;
  stateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  talent: TalentInstance;
  talentPoolName?: Maybe<Array<LocalizedString>>;
  talentPoolType?: Maybe<TalentPoolType>;
};

export class TalentPoolRequestedTalentIncomingInput {
  candidateId: Scalars['ID']['input'];
  candidateOrganizationId: Scalars['ID']['input'];
};

export class TalentPoolRequestedTalentOutgoing {
  __typename?: 'TalentPoolRequestedTalentOutgoing';
  _etag?: Maybe<Scalars['String']['output']>;
  approvalNote?: Maybe<Scalars['String']['output']>;
  candidateCountry?: Maybe<Scalars['String']['output']>;
  candidateDisplayName: Scalars['String']['output'];
  candidateFunction: Scalars['String']['output'];
  candidateId?: Maybe<Scalars['String']['output']>;
  candidateOrganizationId?: Maybe<Scalars['String']['output']>;
  candidateProfession: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  collectionId?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  providerOrganizationCode?: Maybe<Scalars['String']['output']>;
  providerOrganizationName: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestNote?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['AnkaadiaDateTime']['output'];
  requestedByUserId?: Maybe<Scalars['ID']['output']>;
  requestingOrganizationId: Scalars['ID']['output'];
  sharingType?: Maybe<SharingTypeEnum>;
  state: TalentRequestState;
  stateChangedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  talent: TalentInstance;
  talentPoolName: Array<LocalizedString>;
};

export class TalentPoolRequestedTalentUpdateStateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  approvalNote?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  state: TalentRequestState;
};

export class TalentPoolSharing {
  __typename?: 'TalentPoolSharing';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  collectionId: Scalars['ID']['output'];
  cvKind?: Maybe<TalentPoolSharingCvKind>;
  enabled: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['UTCDate']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  sharingPresetId?: Maybe<Scalars['ID']['output']>;
  talentPoolId: Scalars['ID']['output'];
  talentPoolName?: Maybe<Scalars['String']['output']>;
  talentPoolOrganizationId: Scalars['ID']['output'];
  useCv: Scalars['Boolean']['output'];
};

export class TalentPoolSharingCreateInput {
  collectionId: Scalars['ID']['input'];
  cvKind?: InputMaybe<TalentPoolSharingCvKind>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingPresetId?: InputMaybe<Scalars['ID']['input']>;
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
  useCv: Scalars['Boolean']['input'];
};

export enum TalentPoolSharingCvKind {
  Standard = 'Standard',
  TalentPool = 'TalentPool'
}

export class TalentPoolSharingDeleteInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolSharingGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolSharingListInput {
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class TalentPoolSharingUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  collectionId: Scalars['ID']['input'];
  cvKind?: InputMaybe<TalentPoolSharingCvKind>;
  enabled: Scalars['Boolean']['input'];
  expiryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  sharingPresetId?: InputMaybe<Scalars['ID']['input']>;
  talentPoolId: Scalars['ID']['input'];
  talentPoolOrganizationId: Scalars['ID']['input'];
  useCv: Scalars['Boolean']['input'];
};

export enum TalentPoolType {
  Standard = 'Standard',
  Website = 'Website'
}

export class TalentPoolUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Array<LocalizedStringInput>>;
  globalTalentPoolCategory?: InputMaybe<GlobalTalentPoolCategory>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Array<LocalizedStringInput>;
  organizationId: Scalars['ID']['input'];
  type: TalentPoolType;
  useUniformCv?: InputMaybe<Scalars['Boolean']['input']>;
};

export class TalentRequestSource {
  companyName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentRequestState {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export class TargetCandidateDocument {
  __typename?: 'TargetCandidateDocument';
  documentSetType?: Maybe<Scalars['String']['output']>;
  documentTag: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  overwriteIfExists: Scalars['Boolean']['output'];
};

export class TargetCandidateDocumentInput {
  documentSetType?: InputMaybe<Scalars['String']['input']>;
  documentTag: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  overwriteIfExists: Scalars['Boolean']['input'];
};

export class TaskAccess {
  __typename?: 'TaskAccess';
  canAccess: Scalars['Boolean']['output'];
  redirectToDelegation?: Maybe<Scalars['ID']['output']>;
  redirectToOrganization?: Maybe<Scalars['ID']['output']>;
};

export class TaskAccessInput {
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class TaskActivityInput {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['ID']['input'];
};

export class TaskActivityParameter {
  __typename?: 'TaskActivityParameter';
  id: Scalars['ID']['output'];
  name?: Maybe<Array<ProcessOptionalString>>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  userGroupIds?: Maybe<Array<Scalars['String']['output']>>;
};

export class TaskArchiveInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export class TaskAverageDuration {
  __typename?: 'TaskAverageDuration';
  averageDurationInDays?: Maybe<Scalars['Float']['output']>;
  currentAvgDurationInDays?: Maybe<Scalars['Float']['output']>;
  foundTaskCount: Scalars['Float']['output'];
  medianDurationInDays?: Maybe<Scalars['Float']['output']>;
  modelId: Scalars['String']['output'];
  range95HighInDays?: Maybe<Scalars['Float']['output']>;
  range95LowInDays?: Maybe<Scalars['Float']['output']>;
  taskId: Scalars['ID']['output'];
  taskName?: Maybe<Scalars['String']['output']>;
};

export class TaskAverageDurationSaveEntry {
  avgDurationInDays: Scalars['Float']['input'];
  taskId: Scalars['ID']['input'];
};

export class TaskDelay {
  __typename?: 'TaskDelay';
  comment?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  delayCreatedBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newTargetDate: Scalars['UTCDate']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export class TaskDelayCreateInput {
  newTargetDate: Scalars['UTCDate']['input'];
};

export class TaskDelayInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  delayCreatedBy: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  newTargetDate: Scalars['UTCDate']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export class TaskDelayReportInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  newTargetDate: Scalars['UTCDate']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export class TaskDelegation {
  __typename?: 'TaskDelegation';
  delegatedAt: Scalars['AnkaadiaDateTime']['output'];
  ruleId: Scalars['String']['output'];
  ruleOwnerOrganizationId: Scalars['String']['output'];
  ruleOwnerOrganizationName?: Maybe<Scalars['String']['output']>;
  targetOrganizationId: Scalars['String']['output'];
  targetOrganizationName?: Maybe<Scalars['String']['output']>;
  targetUserGroupId: Scalars['String']['output'];
  targetUserGroupName?: Maybe<Scalars['String']['output']>;
};

export class TaskDelegationInput {
  delegatedAt: Scalars['AnkaadiaDateTime']['input'];
  ruleId: Scalars['String']['input'];
  ruleOwnerOrganizationId: Scalars['String']['input'];
  targetOrganizationId: Scalars['String']['input'];
  targetUserGroupId: Scalars['String']['input'];
};

export class TaskDelegationRule {
  __typename?: 'TaskDelegationRule';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  entries: Array<TaskDelegationRuleEntry>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isSourceLinked: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  sourceOrganizationId: Scalars['String']['output'];
  sourceOrganizationName?: Maybe<Scalars['String']['output']>;
  taskModelIds: Array<Scalars['String']['output']>;
  unlinkedTargetOrganizationIds: Array<Scalars['String']['output']>;
};

export class TaskDelegationRuleCreateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  entries: Array<TaskDelegationRuleEntryInput>;
  isActive: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId: Scalars['String']['input'];
  taskModelIds: Array<Scalars['String']['input']>;
};

export class TaskDelegationRuleDeleteInput {
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class TaskDelegationRuleEntry {
  __typename?: 'TaskDelegationRuleEntry';
  candidateFilter?: Maybe<Scalars['JSONObject']['output']>;
  targets: Array<TaskDelegationTarget>;
};

export class TaskDelegationRuleEntryInput {
  candidateFilter?: InputMaybe<Scalars['JSONObject']['input']>;
  targets: Array<TaskDelegationTargetInput>;
};

export class TaskDelegationRuleForTask {
  __typename?: 'TaskDelegationRuleForTask';
  allRuleId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  sourceOrganizationId: Scalars['String']['output'];
  taskModelId: Scalars['String']['output'];
};

export class TaskDelegationRuleForTaskGetInput {
  organizationId: Scalars['ID']['input'];
  taskId: Scalars['String']['input'];
  taskOrganizationId: Scalars['String']['input'];
};

export class TaskDelegationRuleGetInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class TaskDelegationRuleListInput {
  organizationId: Scalars['ID']['input'];
};

export class TaskDelegationRulePreconditionGetInput {
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId: Scalars['String']['input'];
};

export class TaskDelegationRuleUpdateInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  entries: Array<TaskDelegationRuleEntryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId: Scalars['String']['input'];
  taskModelIds: Array<Scalars['String']['input']>;
};

export class TaskDelegationTarget {
  __typename?: 'TaskDelegationTarget';
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  userGroupId: Scalars['String']['output'];
};

export class TaskDelegationTargetInput {
  organizationId: Scalars['String']['input'];
  userGroupId: Scalars['String']['input'];
};

export class TaskDelegationTargetSharingGap {
  __typename?: 'TaskDelegationTargetSharingGap';
  candidateCount: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  unsharedCandidateCount: Scalars['Int']['output'];
};

export class TaskDelegationTargetSharingGetInput {
  organizationId: Scalars['ID']['input'];
  sourceOrganizationId: Scalars['String']['input'];
  targetOrganizationIds: Array<Scalars['String']['input']>;
  taskModelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class TaskDelegationTaskModelListInput {
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  selectedTaskModelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOrganizationId: Scalars['String']['input'];
};

export enum TaskDueDateBucket {
  Future = 'Future',
  Next7Days = 'Next7Days',
  Next30Days = 'Next30Days',
  NoDate = 'NoDate',
  Overdue = 'Overdue',
  Today = 'Today'
}

export class TaskDurationSettings {
  __typename?: 'TaskDurationSettings';
  avgDurationInDays?: Maybe<Scalars['Float']['output']>;
  durationCalculationType?: Maybe<DurationCalculationType>;
};

export class TaskDurationSettingsInput {
  avgDurationInDays?: InputMaybe<Scalars['Float']['input']>;
  durationCalculationType?: InputMaybe<DurationCalculationType>;
};

export class TaskIdInput {
  organizationId: Scalars['String']['input'];
  processId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export class TaskIdentifier {
  __typename?: 'TaskIdentifier';
  organizationId: Scalars['String']['output'];
  processId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export class TaskIdentifierInput {
  __typename?: 'TaskIdentifierInput';
  processModelId: Scalars['String']['output'];
  startTaskModelIds?: Maybe<Array<Scalars['String']['output']>>;
  taskModelId: Scalars['String']['output'];
};

export class TaskInbox {
  __typename?: 'TaskInbox';
  candidates: Array<CandidateForView>;
  languages: Array<Scalars['String']['output']>;
  processTasksData: Array<ProcessWithTasks>;
};

export class TaskReferencedBy {
  __typename?: 'TaskReferencedBy';
  referencesOnActivationCondition: Array<TaskReferencedByInfo>;
  referencesOnPredecessor: Array<TaskReferencedByInfo>;
  referencesOnRules: Array<TaskReferencedByInfo>;
  referencesOnTaskFunctionality: Array<TaskReferencedByInfo>;
};

export class TaskReferencedByInfo {
  __typename?: 'TaskReferencedByInfo';
  id: Scalars['String']['output'];
  localizedDisplayName: Scalars['String']['output'];
};

export class TaskReminderSettings {
  __typename?: 'TaskReminderSettings';
  enabled: Scalars['Boolean']['output'];
  escalate?: Maybe<Scalars['Boolean']['output']>;
  escalationAfterAttemps?: Maybe<Scalars['Int']['output']>;
  firstReminderInDays: Scalars['Int']['output'];
  followUpReminderInDays?: Maybe<Scalars['Int']['output']>;
};

export class TaskReminderSettingsInput {
  enabled: Scalars['Boolean']['input'];
  escalate?: InputMaybe<Scalars['Boolean']['input']>;
  escalationAfterAttemps?: InputMaybe<Scalars['Int']['input']>;
  firstReminderInDays: Scalars['Int']['input'];
  followUpReminderInDays?: InputMaybe<Scalars['Int']['input']>;
};

export class TaskReminderState {
  __typename?: 'TaskReminderState';
  _etag?: Maybe<Scalars['String']['output']>;
  escalated: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lastReminderDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  maxReminderCountReached?: Maybe<Scalars['Boolean']['output']>;
  nextReminderDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  reminderCount: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
};

export class TaskStateProcessForOrganizationAudit {
  __typename?: 'TaskStateProcessForOrganizationAudit';
  process: Process;
  state: ProcessStateOrganizationAudit;
  task: ProcessTaskOrganizationAudit;
};

export enum TaskTableMode {
  Flat = 'Flat',
  Grouped = 'Grouped'
}

export enum TaskVisibilityEnum {
  UserGroup = 'UserGroup',
  WholeOrganization = 'WholeOrganization'
}

export class TaxRate {
  __typename?: 'TaxRate';
  active?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inclusive: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  stripeId: Scalars['String']['output'];
  taxType: Scalars['String']['output'];
};

export enum TechnicalSourceEnum {
  Api = 'API',
  Application = 'Application',
  Copy = 'Copy',
  Import = 'Import',
  Transfer = 'Transfer',
  Ux = 'UX'
}

export class TemplateConditionInput {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: DocumentTemplateType;
};

export enum TemplateToDocumentTypeConversion {
  OriginalFileType = 'OriginalFileType',
  Pdf = 'PDF'
}

export enum TerminationEmploymentActor {
  Employee = 'Employee',
  Employer = 'Employer'
}

export class TermsAndConditionsForDisplay {
  __typename?: 'TermsAndConditionsForDisplay';
  additionalLogoLink?: Maybe<Scalars['String']['output']>;
  consentDisplayName: Scalars['String']['output'];
  consentGiverId: Scalars['ID']['output'];
  consentIdentifier: KnownConsentIdentifiers;
  consentOptionsHeader?: Maybe<Array<ConsentRenderedText>>;
  consentOptionsToClick: Array<ConsentRenderedOption>;
  consentSections: Array<ConsentRenderedSection>;
  consentWasConfirmedText?: Maybe<Scalars['String']['output']>;
  consentWasRejectedText?: Maybe<Scalars['String']['output']>;
  linkedRenderedTexts?: Maybe<Array<LinkedRenderedText>>;
  organizationId: Scalars['ID']['output'];
  preambleText?: Maybe<Array<ConsentRenderedText>>;
  rejectionMessage?: Maybe<Array<ConsentRenderedText>>;
  showSignature?: Maybe<Scalars['Boolean']['output']>;
  version: Scalars['String']['output'];
};

export class TermsAndConditionsHistoryDetail {
  __typename?: 'TermsAndConditionsHistoryDetail';
  accepted: Scalars['Boolean']['output'];
  additionalLogoLink?: Maybe<Scalars['String']['output']>;
  consentDisplayName: Scalars['String']['output'];
  consentGiverId: Scalars['ID']['output'];
  consentIdentifier: KnownConsentIdentifiers;
  consentOptionsClicked?: Maybe<Array<Scalars['String']['output']>>;
  consentOptionsHeader?: Maybe<Array<ConsentRenderedText>>;
  consentOptionsToClick: Array<ConsentRenderedOption>;
  consentSections: Array<ConsentRenderedSection>;
  consentWasConfirmedText?: Maybe<Scalars['String']['output']>;
  consentWasRejectedText?: Maybe<Scalars['String']['output']>;
  givenSignatureBase64?: Maybe<Scalars['String']['output']>;
  linkedRenderedTexts?: Maybe<Array<LinkedRenderedText>>;
  organizationId: Scalars['ID']['output'];
  preambleText?: Maybe<Array<ConsentRenderedText>>;
  rejectionMessage?: Maybe<Array<ConsentRenderedText>>;
  showSignature?: Maybe<Scalars['Boolean']['output']>;
  version: Scalars['String']['output'];
};

export class TermsAndConditionsHistoryListElement {
  __typename?: 'TermsAndConditionsHistoryListElement';
  accepted: Scalars['Boolean']['output'];
  consentDate: Scalars['AnkaadiaDateTime']['output'];
  consentDisplayName: Scalars['String']['output'];
  consentGiverDisplayName: Scalars['String']['output'];
  consentVersion: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export class Timespan {
  __typename?: 'Timespan';
  days?: Maybe<Scalars['Float']['output']>;
  months?: Maybe<Scalars['Float']['output']>;
};

export class TimespanInput {
  days?: InputMaybe<Scalars['Float']['input']>;
  months?: InputMaybe<Scalars['Float']['input']>;
};

export class ToolBatchStartEmitEvent {
  __typename?: 'ToolBatchStartEmitEvent';
  batchId?: Maybe<Scalars['String']['output']>;
  expectedSize: Scalars['Int']['output'];
};

export class ToolDoneEmitEvent {
  __typename?: 'ToolDoneEmitEvent';
  durationMs: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
};

export class ToolErrorEmitEvent {
  __typename?: 'ToolErrorEmitEvent';
  error?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
};

export class ToolStartEmitEvent {
  __typename?: 'ToolStartEmitEvent';
  args?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
};

export class TrackedWeekdays {
  __typename?: 'TrackedWeekdays';
  day1?: Maybe<Scalars['Boolean']['output']>;
  day2?: Maybe<Scalars['Boolean']['output']>;
  day3?: Maybe<Scalars['Boolean']['output']>;
  day4?: Maybe<Scalars['Boolean']['output']>;
  day5?: Maybe<Scalars['Boolean']['output']>;
  day6?: Maybe<Scalars['Boolean']['output']>;
  day7?: Maybe<Scalars['Boolean']['output']>;
};

export class TrackedWeekdaysInput {
  day1?: InputMaybe<Scalars['Boolean']['input']>;
  day2?: InputMaybe<Scalars['Boolean']['input']>;
  day3?: InputMaybe<Scalars['Boolean']['input']>;
  day4?: InputMaybe<Scalars['Boolean']['input']>;
  day5?: InputMaybe<Scalars['Boolean']['input']>;
  day6?: InputMaybe<Scalars['Boolean']['input']>;
  day7?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TrafficLightType {
  Gray = 'Gray',
  Green = 'Green',
  Red = 'Red',
  Yellow = 'Yellow'
}

export class TransferData {
  __typename?: 'TransferData';
  originalId: Scalars['ID']['output'];
  targetDisplayId: Scalars['String']['output'];
  targetOrganizationId: Scalars['ID']['output'];
  transferDate: Scalars['UTCDate']['output'];
};

export class TransferDataInput {
  originalId: Scalars['ID']['input'];
  targetDisplayId: Scalars['String']['input'];
  targetOrganizationId: Scalars['ID']['input'];
  transferDate: Scalars['UTCDate']['input'];
};

export class TranslationCancellationRequest {
  __typename?: 'TranslationCancellationRequest';
  requestedAt: Scalars['AnkaadiaDateTime']['output'];
};

export class TranslationCancellationRequestInput {
  requestedAt: Scalars['AnkaadiaDateTime']['input'];
};

export class TranslationDocumentStatusHistory {
  __typename?: 'TranslationDocumentStatusHistory';
  changeAt: Scalars['AnkaadiaDateTime']['output'];
  documentStatus: TranslationOrderDocumentState;
};

export class TranslationDocumentStatusHistoryInput {
  changeAt: Scalars['AnkaadiaDateTime']['input'];
  documentStatus: TranslationOrderDocumentState;
};

export class TranslationMetaData {
  __typename?: 'TranslationMetaData';
  _etag?: Maybe<Scalars['String']['output']>;
  charCount: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  propertyPath: Array<Scalars['String']['output']>;
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  sourceTextAsDelta?: Maybe<Scalars['JSONObject']['output']>;
  targetLanguage?: Maybe<Scalars['String']['output']>;
  targetTextAsDelta?: Maybe<Scalars['JSONObject']['output']>;
  translationItemId: Scalars['String']['output'];
  translationProvider?: Maybe<TranslatorType>;
};

export enum TranslationMode {
  All = 'All',
  MissingAndChanged = 'MissingAndChanged'
}

export class TranslationOrderDocument {
  __typename?: 'TranslationOrderDocument';
  blob?: Maybe<Scalars['String']['output']>;
  commentForTranslator?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  documentFormats: Array<Scalars['String']['output']>;
  documentHistory?: Maybe<Array<TranslationDocumentStatusHistory>>;
  documentSet?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  federalState?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  lingokingOrderId?: Maybe<Scalars['String']['output']>;
  logMessages?: Maybe<Array<Scalars['String']['output']>>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  pages?: Maybe<Scalars['Float']['output']>;
  preExistingLingokingCartId?: Maybe<Scalars['String']['output']>;
  preExistingLingokingOrderId?: Maybe<Scalars['String']['output']>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  shippingService?: Maybe<Scalars['String']['output']>;
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  status: TranslationOrderDocumentState;
  tax?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  translationBlob?: Maybe<Scalars['String']['output']>;
  translationContainer?: Maybe<Scalars['String']['output']>;
  translationFileName?: Maybe<Scalars['String']['output']>;
  translationFileSize?: Maybe<Scalars['Float']['output']>;
  translationFileType?: Maybe<Scalars['String']['output']>;
};

export class TranslationOrderDocumentInput {
  blob?: InputMaybe<Scalars['String']['input']>;
  commentForTranslator?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Scalars['String']['input']>;
  documentFormats: Array<Scalars['String']['input']>;
  documentHistory?: InputMaybe<Array<TranslationDocumentStatusHistoryInput>>;
  documentSet?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  federalState?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  lingokingOrderId?: InputMaybe<Scalars['String']['input']>;
  logMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  pages?: InputMaybe<Scalars['Float']['input']>;
  preExistingLingokingCartId?: InputMaybe<Scalars['String']['input']>;
  preExistingLingokingOrderId?: InputMaybe<Scalars['String']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
  shippingService?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  status: TranslationOrderDocumentState;
  tax?: InputMaybe<Scalars['Float']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  translationBlob?: InputMaybe<Scalars['String']['input']>;
  translationContainer?: InputMaybe<Scalars['String']['input']>;
  translationFileName?: InputMaybe<Scalars['String']['input']>;
  translationFileSize?: InputMaybe<Scalars['Float']['input']>;
  translationFileType?: InputMaybe<Scalars['String']['input']>;
};

export enum TranslationOrderDocumentState {
  AlreadyTranslated = 'AlreadyTranslated',
  Cancelled = 'Cancelled',
  Deleted = 'Deleted',
  Delivered = 'Delivered',
  Draft = 'Draft',
  Error = 'Error',
  IncompleteData = 'IncompleteData',
  Init = 'Init',
  MissingDocument = 'MissingDocument',
  OnHold = 'OnHold',
  Processing = 'Processing',
  Setup = 'Setup',
  TranslationInProgress = 'TranslationInProgress',
  Unsupported = 'Unsupported'
}

export class TranslationOrderOverviewItem {
  __typename?: 'TranslationOrderOverviewItem';
  cancellationRequestCount: Scalars['Int']['output'];
  cancellationRequestedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  candidateDisplayId: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  candidateOrganizationId: Scalars['ID']['output'];
  documentLogMessages?: Maybe<Array<Scalars['String']['output']>>;
  documentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLinked: Scalars['Boolean']['output'];
  lingokingCartId?: Maybe<Scalars['String']['output']>;
  lingokingOrderId?: Maybe<Scalars['String']['output']>;
  logMessages?: Maybe<Array<Scalars['String']['output']>>;
  orderStatus?: Maybe<ProcessStateTranslateDocumentsOrderState>;
  orderedAt?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  preExistingLingokingCartId?: Maybe<Scalars['String']['output']>;
  preExistingLingokingOrderId?: Maybe<Scalars['String']['output']>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  processId?: Maybe<Scalars['ID']['output']>;
  provider: DocumentTranslationProvider;
  providerReference?: Maybe<Scalars['String']['output']>;
  shippingService?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['ID']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum TranslationOrderOverviewMode {
  Candidate = 'Candidate',
  Collection = 'Collection'
}

export class TranslationOrderStatusHistory {
  __typename?: 'TranslationOrderStatusHistory';
  changeAt: Scalars['AnkaadiaDateTime']['output'];
  orderStatus: ProcessStateTranslateDocumentsOrderState;
};

export class TranslationOrderStatusHistoryInput {
  changeAt: Scalars['AnkaadiaDateTime']['input'];
  orderStatus: ProcessStateTranslateDocumentsOrderState;
};

export class TranslationProposalInput {
  elementPath: Scalars['String']['input'];
  language: Scalars['String']['input'];
  reasonForCorrection?: InputMaybe<Scalars['String']['input']>;
  textToCorrect: Scalars['String']['input'];
  translationProposal: Scalars['String']['input'];
};

export class TranslationRequirementDocument {
  __typename?: 'TranslationRequirementDocument';
  blob?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  documentFormats: Array<Scalars['String']['output']>;
  documentSet?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
};

export class TranslationRequirementDocumentInput {
  blob?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Scalars['String']['input']>;
  documentFormats: Array<Scalars['String']['input']>;
  documentSet?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export enum TranslatorType {
  Azure = 'Azure',
  Deepl = 'Deepl',
  Google = 'Google',
  Human = 'Human',
  None = 'None'
}

export class TreeDataModel {
  __typename?: 'TreeDataModel';
  children?: Maybe<Array<TreeDataModel>>;
  data: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export class TreeNodeData {
  __typename?: 'TreeNodeData';
  example?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  syntax: Scalars['String']['output'];
};

export class TreeNodeInput {
  children?: InputMaybe<Array<TreeNodeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionOwnRecruitment?: InputMaybe<Scalars['String']['input']>;
  filesAreMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  forEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  forPSA?: InputMaybe<Scalars['Boolean']['input']>;
  helptext?: InputMaybe<Scalars['String']['input']>;
  helptextProof?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  level: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reCertificationOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggerCandidateChangedEventUnion = ProgressEvent | TriggerCandidateChangedResult;

export class TriggerCandidateChangedResult {
  __typename?: 'TriggerCandidateChangedResult';
  candidatesProcessed: Scalars['Float']['output'];
};

export class TriggerCandidatesBillingInput {
  asOfDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  candidateIds: Array<CandidateIdInput>;
  organizationId: Scalars['ID']['input'];
  triggerTypes: Array<BillingEventTriggerType>;
};

export class TriggerContingentBillingInput {
  asOfDate: Scalars['AnkaadiaDateTime']['input'];
  organizationId: Scalars['ID']['input'];
};

export class TriggerLicenseBillingInput {
  asOfDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  organizationId: Scalars['ID']['input'];
  sinceDate: Scalars['AnkaadiaDateTime']['input'];
};

export class TriggerRecurringFeeBillingInput {
  asOfDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  organizationId: Scalars['ID']['input'];
  sinceDate: Scalars['AnkaadiaDateTime']['input'];
};

export class TriggerUserAccountBillingInput {
  asOfDate: Scalars['AnkaadiaDateTime']['input'];
  organizationId: Scalars['ID']['input'];
};

export class TriggerUserAccountBillingResult {
  __typename?: 'TriggerUserAccountBillingResult';
  billedMonth?: Maybe<Scalars['UTCDate']['output']>;
  reason?: Maybe<UserAccountTriggerSkipReason>;
  triggered: Scalars['Boolean']['output'];
};

export class TruncateAiChatSessionInput {
  fromTurnId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export enum TypeOfEmployment {
  Freelancer = 'Freelancer',
  Notrelevant = 'Notrelevant',
  PartTimeJob = 'PartTimeJob',
  Shiftsystem = 'Shiftsystem'
}

export class UpdateAssignedCandidatesInput {
  _etag: Scalars['String']['input'];
  assignedCandidatesIds?: InputMaybe<Array<CandidateIdInput>>;
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class UpdateAssignmentExceptionsInput {
  _etag: Scalars['String']['input'];
  assignmentExceptions: Array<CandidateAssignmentExceptionIdInput>;
  collectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class UpdateBillingSettingsInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  collectionMethod?: InputMaybe<CollectionMethod>;
  debitorId?: InputMaybe<Scalars['String']['input']>;
  dueDays?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['ID']['input'];
  taxRateId?: InputMaybe<Scalars['String']['input']>;
};

export class UpdateCustomContingentDefinitionSetInput {
  _etag: Scalars['String']['input'];
  bookableContingents?: InputMaybe<Array<ContingentDefinitionInput>>;
  id: Scalars['ID']['input'];
  mandatoryContingents?: InputMaybe<Array<ContingentDefinitionInput>>;
  name: Scalars['String']['input'];
};

export class UpdateCustomPlanInput {
  _etag: Scalars['String']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  candidatePrice: CandidatePriceInput;
  currency: SupportedBillingCurrency;
  id: Scalars['ID']['input'];
  labelKey: Scalars['String']['input'];
  licensePrice: LicensePriceInput;
  name: Scalars['String']['input'];
  type: PlanType;
};

export class UpdateDocumentDetectedLanguageInput {
  blob: Scalars['String']['input'];
  candidateId: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export class UpdateInboxTaskTableModeInput {
  tableMode: TaskTableMode;
};

export class UpdateLastSelectedProfileMaskIdInput {
  lastSelectedProfileMaskId?: InputMaybe<Scalars['ID']['input']>;
};

export class UpdateTableColumnsInput {
  columnWidths?: InputMaybe<Array<ColumnWidthInput>>;
  columns: Array<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  table: ConfigurableTable;
};

export class UploadedDocumentType {
  __typename?: 'UploadedDocumentType';
  completionState?: Maybe<CompletionState>;
  documentId?: Maybe<Scalars['ID']['output']>;
  documentType: Scalars['String']['output'];
  files?: Maybe<Array<UploadedFileDescription>>;
  isNotRelevant?: Maybe<Scalars['Boolean']['output']>;
  sentDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  sentTo?: Maybe<Scalars['ID']['output']>;
};

export class UploadedDocumentTypeInput {
  completionState?: InputMaybe<CompletionState>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentType: Scalars['String']['input'];
  files?: InputMaybe<Array<UploadedFileDescriptionInput>>;
  isNotRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  sentDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  sentTo?: InputMaybe<Scalars['ID']['input']>;
};

export class UploadedFileDescription {
  __typename?: 'UploadedFileDescription';
  complainText?: Maybe<Scalars['String']['output']>;
  complaint?: Maybe<Scalars['Boolean']['output']>;
  dateOfReceipt?: Maybe<Scalars['UTCDate']['output']>;
  fileBlob: Scalars['String']['output'];
  fileFormats?: Maybe<Array<Scalars['String']['output']>>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
  isDefaultSet?: Maybe<Scalars['Boolean']['output']>;
  issueDate?: Maybe<Scalars['UTCDate']['output']>;
  resubmissionDate?: Maybe<Scalars['UTCDate']['output']>;
  setName?: Maybe<Scalars['String']['output']>;
  setType?: Maybe<Scalars['String']['output']>;
  singleSetConfig?: Maybe<Array<SingleSetConfig>>;
  validFrom?: Maybe<Scalars['UTCDate']['output']>;
  validUntil?: Maybe<Scalars['UTCDate']['output']>;
};

export class UploadedFileDescriptionInput {
  complainText?: InputMaybe<Scalars['String']['input']>;
  complaint?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfReceipt?: InputMaybe<Scalars['UTCDate']['input']>;
  fileBlob: Scalars['String']['input'];
  fileFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  fileType: Scalars['String']['input'];
  isDefaultSet?: InputMaybe<Scalars['Boolean']['input']>;
  issueDate?: InputMaybe<Scalars['UTCDate']['input']>;
  resubmissionDate?: InputMaybe<Scalars['UTCDate']['input']>;
  setName?: InputMaybe<Scalars['String']['input']>;
  setType?: InputMaybe<Scalars['String']['input']>;
  singleSetConfig?: InputMaybe<Array<SingleSetConfigInput>>;
  validFrom?: InputMaybe<Scalars['UTCDate']['input']>;
  validUntil?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class UploadedProcessDocument {
  __typename?: 'UploadedProcessDocument';
  containerName: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  files?: Maybe<Array<UploadedProcessFileDescription>>;
};

export class UploadedProcessDocumentInput {
  containerName: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  files?: InputMaybe<Array<UploadedProcessFileDescriptionInput>>;
};

export class UploadedProcessFileDescription {
  __typename?: 'UploadedProcessFileDescription';
  fileBlob: Scalars['String']['output'];
  fileFormats?: Maybe<Array<Scalars['String']['output']>>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
};

export class UploadedProcessFileDescriptionInput {
  fileBlob: Scalars['String']['input'];
  fileFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  fileType: Scalars['String']['input'];
};

export class UsedVariablesDownload {
  __typename?: 'UsedVariablesDownload';
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type UsedVariablesDownloadEvent = ProgressEvent | UsedVariablesDownload;

export class User {
  __typename?: 'User';
  _etag?: Maybe<Scalars['String']['output']>;
  auth0Id?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  invitedDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  language: Scalars['String']['output'];
  lastSeenAppVersion?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  salutation: UserSalutation;
  signatureAddition?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userRoles: Array<UserRole>;
};

export enum UserAccountTriggerSkipReason {
  BeforeUserBillingStart = 'BeforeUserBillingStart',
  BilledMonthNotCompleted = 'BilledMonthNotCompleted',
  BillingDisabled = 'BillingDisabled',
  NoBookingsCreated = 'NoBookingsCreated',
  NoContract = 'NoContract',
  NoUserPriceRows = 'NoUserPriceRows',
  NotLicensed = 'NotLicensed',
  PendingEventsExist = 'PendingEventsExist',
  UserBillingDisabled = 'UserBillingDisabled'
}

export class UserBookingDetail {
  __typename?: 'UserBookingDetail';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
  priceRowId?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<Scalars['String']['output']>;
};

export class UserBookingDetailEntity {
  __typename?: 'UserBookingDetailEntity';
  _etag?: Maybe<Scalars['String']['output']>;
  billingTriggerEvent?: Maybe<BillingEventTriggerType>;
  bookingId: Scalars['ID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceInfo?: Maybe<Scalars['String']['output']>;
  priceRowId?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<Scalars['String']['output']>;
};

export class UserBookingDetailGetInputByBookingId {
  bookingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export class UserEnvironment {
  __typename?: 'UserEnvironment';
  _etag?: Maybe<Scalars['String']['output']>;
  auth0Id: Scalars['String']['output'];
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  hasSeenNewAnkaadiaAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  userPrefersNewUi?: Maybe<Scalars['Boolean']['output']>;
};

export class UserFeedbackCreateInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  functionalityRating?: InputMaybe<Scalars['Float']['input']>;
  langfuseTraceId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  overallRating?: InputMaybe<Scalars['Float']['input']>;
  performanceRating?: InputMaybe<Scalars['Float']['input']>;
  usabilityRating?: InputMaybe<Scalars['Float']['input']>;
};

export class UserGroup {
  __typename?: 'UserGroup';
  _etag?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSingle?: Maybe<Scalars['Boolean']['output']>;
  memberCount: Scalars['Float']['output'];
  memberGroups: Array<UserGroup>;
  memberUsers: Array<User>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export class UserGroupConfigurationInput {
  includeCandidateRole?: InputMaybe<Scalars['Boolean']['input']>;
  userGroups?: InputMaybe<Array<OrganizationUserGroupMappingInput>>;
};

export class UserGroupHasMembers {
  __typename?: 'UserGroupHasMembers';
  hasMembers: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export class UserGroupHasMembersInput {
  groups: Array<GroupWithOrgId>;
};

export class UserGroupInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  memberCount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class UserId {
  __typename?: 'UserId';
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
};

export class UserInboxInput {
  candidateId?: InputMaybe<CandidateIdInput>;
  classificationCriteria?: InputMaybe<Array<SortingCriterionInput>>;
  dueDateBuckets?: InputMaybe<Array<TaskDueDateBucket>>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  priorities?: InputMaybe<Array<PriorityEnum>>;
  processId?: InputMaybe<Scalars['ID']['input']>;
  processOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  states?: InputMaybe<Array<InstanceStateEnum>>;
  targetRolesChangedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  taskVisibilityMode?: InputMaybe<UserTaskVisibilityMode>;
};

export class UserInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  invitedDate?: InputMaybe<Scalars['AnkaadiaDateTime']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastSeenAppVersion?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  salutation: UserSalutation;
  signatureAddition?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userRoles: Array<UserRole>;
};

export class UserLogin {
  __typename?: 'UserLogin';
  _etag?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isCandidate: Scalars['Boolean']['output'];
  lastLoginDate: Scalars['AnkaadiaDateTime']['output'];
  organizationId: Scalars['ID']['output'];
  userOrCandidateId: Scalars['ID']['output'];
};

export class UserLoginListInput {
  isCandidate: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export class UserPriceRow {
  __typename?: 'UserPriceRow';
  currency: SupportedBillingCurrency;
  id: Scalars['String']['output'];
  includedUsers: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  validFrom: Scalars['UTCDate']['output'];
};

export class UserPriceRowInput {
  currency: SupportedBillingCurrency;
  id: Scalars['String']['input'];
  includedUsers: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  validFrom: Scalars['UTCDate']['input'];
};

export enum UserRole {
  Administrator = 'Administrator',
  BillingAdministrator = 'BillingAdministrator',
  Candidate = 'Candidate',
  CandidateManager = 'CandidateManager',
  ContentAdministrator = 'ContentAdministrator',
  CourseAdministrator = 'CourseAdministrator',
  CourseObserver = 'CourseObserver',
  CourseTeacher = 'CourseTeacher',
  CrmContributor = 'CrmContributor',
  EmailReceiverOnly = 'EmailReceiverOnly',
  PartnerAdministrator = 'PartnerAdministrator',
  ProcessAdministrator = 'ProcessAdministrator',
  ProcessObserver = 'ProcessObserver',
  TalentpoolUser = 'TalentpoolUser',
  User = 'User'
}

export enum UserSalutation {
  Mr = 'MR',
  Mrs = 'MRS',
  Mx = 'MX'
}

export class UserSavedView {
  __typename?: 'UserSavedView';
  candidateFilter?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tableFilter?: Maybe<UserViewTableFilter>;
  type: UserView;
};

export class UserSettings {
  __typename?: 'UserSettings';
  _etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inboxTaskTableMode?: Maybe<TaskTableMode>;
  inboxTaskVisibilityMode?: Maybe<UserTaskVisibilityMode>;
  lastSelectedProfileMaskId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  tableColumnConfigs?: Maybe<Array<TableColumnConfig>>;
  views?: Maybe<Array<UserSavedView>>;
};

export enum UserTaskVisibilityMode {
  All = 'All',
  Owner = 'Owner',
  OwnerOrganization = 'OwnerOrganization'
}

export enum UserView {
  Inbox = 'Inbox'
}

export class UserViewInput {
  candidateFilter?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tableFilter?: InputMaybe<UserViewTableFilterInput>;
  type: UserView;
};

export class UserViewTableFilter {
  __typename?: 'UserViewTableFilter';
  candidates?: Maybe<Array<Scalars['String']['output']>>;
  classificationCriterion?: Maybe<Array<SortingCriterion>>;
  dueDate?: Maybe<Array<TaskDueDateBucket>>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Array<PriorityEnum>>;
  status?: Maybe<Array<InstanceStateEnum>>;
  targetRolesChangedBy?: Maybe<Array<Scalars['String']['output']>>;
};

export class UserViewTableFilterInput {
  candidates?: InputMaybe<Array<Scalars['String']['input']>>;
  classificationCriterion?: InputMaybe<Array<SortingCriterionInput>>;
  dueDate?: InputMaybe<Array<TaskDueDateBucket>>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<PriorityEnum>>;
  status?: InputMaybe<Array<InstanceStateEnum>>;
  targetRolesChangedBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export class VacancyReportInput {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  linkMode: OrganizationLinkMode;
  organizationId: Scalars['ID']['input'];
};

export class VaccinationStatus {
  __typename?: 'VaccinationStatus';
  status: VaccineStatusEnum;
  vaccine: Scalars['String']['output'];
  vaccineFunction: Scalars['String']['output'];
};

export enum VaccineStatusEnum {
  Available = 'Available',
  Missing = 'Missing',
  MissingNotRequired = 'MissingNotRequired',
  NotShared = 'NotShared',
  Partial = 'Partial'
}

export class VariableMapping {
  __typename?: 'VariableMapping';
  value: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export class VariableMappingForUi {
  __typename?: 'VariableMappingForUI';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export class VariableMappingInput {
  value: Scalars['String']['input'];
  variable: Scalars['String']['input'];
};

export class VirtualBookingForUi {
  __typename?: 'VirtualBookingForUI';
  accrualTreatment?: Maybe<AccrualTreatment>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountType?: Maybe<AmountType>;
  billingEvent?: Maybe<BillingEventType>;
  bookedBy?: Maybe<Scalars['String']['output']>;
  bookingDate: Scalars['AnkaadiaDateTime']['output'];
  bookingText: Scalars['String']['output'];
  bookingType: BookingType;
  candidateBookingDetail?: Maybe<CandidateBookingDetail>;
  candidateDisplayId?: Maybe<Scalars['String']['output']>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateExists?: Maybe<Scalars['Boolean']['output']>;
  candidateId?: Maybe<CandidateId>;
  commissionId?: Maybe<Scalars['String']['output']>;
  contingentId?: Maybe<Scalars['String']['output']>;
  contingentNumber?: Maybe<Scalars['String']['output']>;
  creditNoteId?: Maybe<Scalars['String']['output']>;
  currency: SupportedBillingCurrency;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  recurringFeeId?: Maybe<Scalars['String']['output']>;
  referencedBookingIds?: Maybe<Array<Scalars['ID']['output']>>;
  revenueCategory?: Maybe<RevenueCategory>;
  serviceEndDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  serviceStartDate?: Maybe<Scalars['AnkaadiaDateTime']['output']>;
  source: BookingSource;
  targetInvoiceType?: Maybe<InvoiceType>;
  userBookingDetail?: Maybe<UserBookingDetailEntity>;
  userId?: Maybe<Scalars['String']['output']>;
  valueDate: Scalars['AnkaadiaDateTime']['output'];
};

export class VirtualBookingGetInput {
  filter?: InputMaybe<BillingAccountFilter>;
  forAllOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export class VirtualBookingResultForUi {
  __typename?: 'VirtualBookingResultForUI';
  filteredSumOfVirtualBookings: Scalars['Float']['output'];
  rawSumOfVirtualBookings: Scalars['Float']['output'];
  virtualBookings: Array<VirtualBookingForUi>;
};

export class VisaCandidateDataAt {
  __typename?: 'VisaCandidateDataAT';
  arrivalAirport?: Maybe<Scalars['String']['output']>;
  arrivalTrainStation?: Maybe<Scalars['String']['output']>;
  contactAtArrivalLocation?: Maybe<Scalars['String']['output']>;
  departureAirport?: Maybe<Scalars['String']['output']>;
  departureTrainStation?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  fingerPrintDate?: Maybe<Scalars['UTCDate']['output']>;
  flightArrivalDate?: Maybe<DateWithTime>;
  flightDate?: Maybe<DateWithTime>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  pickUpDetails?: Maybe<Scalars['String']['output']>;
  pickUpVehicle?: Maybe<Scalars['String']['output']>;
  plannedEntryDate?: Maybe<Scalars['UTCDate']['output']>;
  responsibleForTransfer?: Maybe<Scalars['String']['output']>;
  responsibleRoleVisa?: Maybe<Scalars['String']['output']>;
  trainArrivalDate?: Maybe<DateWithTime>;
  trainDepartureDate?: Maybe<DateWithTime>;
  trainNumber?: Maybe<Scalars['String']['output']>;
  visaBookingDate?: Maybe<Scalars['UTCDate']['output']>;
  visaEnquired?: Maybe<Scalars['Boolean']['output']>;
  visaEnquiredDate?: Maybe<Scalars['UTCDate']['output']>;
  visaReceiveDate?: Maybe<Scalars['UTCDate']['output']>;
  visaReceived?: Maybe<Scalars['Boolean']['output']>;
  visaRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  visaRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  visaValidFromDate?: Maybe<Scalars['UTCDate']['output']>;
  visaValidUntilDate?: Maybe<Scalars['UTCDate']['output']>;
};

export class VisaCandidateDataAtInput {
  arrivalAirport?: InputMaybe<Scalars['String']['input']>;
  arrivalTrainStation?: InputMaybe<Scalars['String']['input']>;
  contactAtArrivalLocation?: InputMaybe<Scalars['String']['input']>;
  departureAirport?: InputMaybe<Scalars['String']['input']>;
  departureTrainStation?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  fingerPrintDate?: InputMaybe<Scalars['UTCDate']['input']>;
  flightArrivalDate?: InputMaybe<DateWithTimeInput>;
  flightDate?: InputMaybe<DateWithTimeInput>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  pickUpDetails?: InputMaybe<Scalars['String']['input']>;
  pickUpVehicle?: InputMaybe<Scalars['String']['input']>;
  plannedEntryDate?: InputMaybe<Scalars['UTCDate']['input']>;
  responsibleForTransfer?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleVisa?: InputMaybe<Scalars['String']['input']>;
  trainArrivalDate?: InputMaybe<DateWithTimeInput>;
  trainDepartureDate?: InputMaybe<DateWithTimeInput>;
  trainNumber?: InputMaybe<Scalars['String']['input']>;
  visaBookingDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaEnquired?: InputMaybe<Scalars['Boolean']['input']>;
  visaEnquiredDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaReceiveDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaReceived?: InputMaybe<Scalars['Boolean']['input']>;
  visaRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  visaRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaValidFromDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaValidUntilDate?: InputMaybe<Scalars['UTCDate']['input']>;
};

export class VisaCandidateDataDe {
  __typename?: 'VisaCandidateDataDE';
  arrivalAirport?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<DateWithTime>;
  arrivalTrainStation?: Maybe<Scalars['String']['output']>;
  contactAtArrivalLocation?: Maybe<Scalars['String']['output']>;
  departureAirport?: Maybe<Scalars['String']['output']>;
  departureTrainStation?: Maybe<Scalars['String']['output']>;
  diplomaticMissionOfGermanyInCountry?: Maybe<Scalars['String']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  flightArrivalDate?: Maybe<DateWithTime>;
  flightDate?: Maybe<DateWithTime>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  lastCheckedDate?: Maybe<Scalars['UTCDate']['output']>;
  pickUpVehicle?: Maybe<Scalars['String']['output']>;
  residencePermit?: Maybe<Scalars['String']['output']>;
  responsibleForTransfer?: Maybe<Scalars['String']['output']>;
  responsibleRoleVisa?: Maybe<Scalars['String']['output']>;
  trainArrivalDate?: Maybe<DateWithTime>;
  trainDepartureDate?: Maybe<DateWithTime>;
  trainNumber?: Maybe<Scalars['String']['output']>;
  visaEnquired?: Maybe<Scalars['Boolean']['output']>;
  visaEnquiredDate?: Maybe<Scalars['UTCDate']['output']>;
  visaRelocationRequirements?: Maybe<Array<Scalars['String']['output']>>;
  visaRequestDate?: Maybe<Scalars['UTCDate']['output']>;
  visaRequested?: Maybe<Scalars['Boolean']['output']>;
};

export class VisaCandidateDataDeInput {
  arrivalAirport?: InputMaybe<Scalars['String']['input']>;
  arrivalDate?: InputMaybe<DateWithTimeInput>;
  arrivalTrainStation?: InputMaybe<Scalars['String']['input']>;
  contactAtArrivalLocation?: InputMaybe<Scalars['String']['input']>;
  departureAirport?: InputMaybe<Scalars['String']['input']>;
  departureTrainStation?: InputMaybe<Scalars['String']['input']>;
  diplomaticMissionOfGermanyInCountry?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flightArrivalDate?: InputMaybe<DateWithTimeInput>;
  flightDate?: InputMaybe<DateWithTimeInput>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  lastCheckedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  pickUpVehicle?: InputMaybe<Scalars['String']['input']>;
  residencePermit?: InputMaybe<Scalars['String']['input']>;
  responsibleForTransfer?: InputMaybe<Scalars['String']['input']>;
  responsibleRoleVisa?: InputMaybe<Scalars['String']['input']>;
  trainArrivalDate?: InputMaybe<DateWithTimeInput>;
  trainDepartureDate?: InputMaybe<DateWithTimeInput>;
  trainNumber?: InputMaybe<Scalars['String']['input']>;
  visaEnquired?: InputMaybe<Scalars['Boolean']['input']>;
  visaEnquiredDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaRelocationRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  visaRequestDate?: InputMaybe<Scalars['UTCDate']['input']>;
  visaRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export class VocationalSchoolCandidateDataAt {
  __typename?: 'VocationalSchoolCandidateDataAT';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentTrainingYear?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  expectedEndDate?: Maybe<Scalars['UTCDate']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  medicalCheckAttended?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckAttendedDate?: Maybe<Scalars['UTCDate']['output']>;
  medicalCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckPassedDate?: Maybe<Scalars['UTCDate']['output']>;
  schoolCourse?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  trainingTimeInPartTime?: Maybe<Scalars['Boolean']['output']>;
  trainingTimeInYearsTotal?: Maybe<Scalars['String']['output']>;
  trainingTimeShortened?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class VocationalSchoolCandidateDataAtInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentTrainingYear?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['UTCDate']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  medicalCheckAttended?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckAttendedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  medicalCheckPassed?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckPassedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  schoolCourse?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  trainingTimeInPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  trainingTimeInYearsTotal?: InputMaybe<Scalars['String']['input']>;
  trainingTimeShortened?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export class VocationalSchoolCandidateDataDe {
  __typename?: 'VocationalSchoolCandidateDataDE';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentTrainingYear?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['UTCDate']['output']>;
  expectedEndDate?: Maybe<Scalars['UTCDate']['output']>;
  federalState?: Maybe<Scalars['String']['output']>;
  medicalCheckAttended?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckAttendedDate?: Maybe<Scalars['UTCDate']['output']>;
  medicalCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  medicalCheckPassedDate?: Maybe<Scalars['UTCDate']['output']>;
  schoolCourse?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  trainingTimeInPartTime?: Maybe<Scalars['Boolean']['output']>;
  trainingTimeInYearsTotal?: Maybe<Scalars['String']['output']>;
  trainingTimeShortened?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export class VocationalSchoolCandidateDataDeInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentTrainingYear?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['UTCDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['UTCDate']['input']>;
  federalState?: InputMaybe<Scalars['String']['input']>;
  medicalCheckAttended?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckAttendedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  medicalCheckPassed?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCheckPassedDate?: InputMaybe<Scalars['UTCDate']['input']>;
  schoolCourse?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  trainingTimeInPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  trainingTimeInYearsTotal?: InputMaybe<Scalars['String']['input']>;
  trainingTimeShortened?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum VoteType {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

export class WebhookConfig {
  __typename?: 'WebhookConfig';
  _etag: Scalars['String']['output'];
  authorizationHeader?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['AnkaadiaDateTime']['output'];
  changedBy: Scalars['String']['output'];
  eventTypes: Array<WebhookEventType>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export class WebhookConfigCreateInput {
  authorizationHeader?: InputMaybe<Scalars['String']['input']>;
  eventTypes: Array<WebhookEventType>;
  isActive: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export class WebhookConfigUpdateInput {
  _etag: Scalars['String']['input'];
  authorizationHeader?: InputMaybe<Scalars['String']['input']>;
  eventTypes: Array<WebhookEventType>;
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export enum WebhookEventType {
  CandidateAddedToCollection = 'CandidateAddedToCollection',
  CandidateCreated = 'CandidateCreated',
  CandidateDeleted = 'CandidateDeleted',
  CandidateRemovedFromCollection = 'CandidateRemovedFromCollection',
  CandidateUpdated = 'CandidateUpdated',
  FileDeleted = 'FileDeleted',
  FileUpdated = 'FileUpdated',
  FileUploaded = 'FileUploaded'
}

export class WithdrawContractCancellationInput {
  _etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum WorkExperiencePrecissionEnum {
  Day = 'DAY',
  Month = 'MONTH'
}

export enum WorkingTimeTypeEnum {
  FullTime = 'FullTime',
  MarginalEmployment = 'MarginalEmployment',
  PartTime = 'PartTime'
}

export class XlsxCandidateImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  collectionId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxContractTemplateImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxDocumentImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxImportIssue {
  __typename?: 'XLSXImportIssue';
  columnId?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};

export class XlsxImportIssueInput {
  columnId?: InputMaybe<Scalars['String']['input']>;
  container?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Float']['input']>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export class XlsxImportResult {
  __typename?: 'XLSXImportResult';
  failed: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  importType: Scalars['String']['output'];
  imported: Scalars['Float']['output'];
  issues?: Maybe<Array<XlsxImportIssue>>;
  total: Scalars['Float']['output'];
};

export type XlsxImportResultEvent = ProgressEvent | XlsxImportResult;

export class XlsxImportResultForDocumentImport {
  __typename?: 'XLSXImportResultForDocumentImport';
  downloadFileName?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  importType: Scalars['String']['output'];
  imported: Scalars['Float']['output'];
  issues?: Maybe<Array<XlsxImportIssue>>;
  total: Scalars['Float']['output'];
};

export type XlsxImportResultForDocumentImportEvent = ProgressEvent | XlsxImportResultForDocumentImport;

export class XlsxOrganizationCrmDataImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationContactImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationContactSettingsImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationUserGroupsImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationUserMembershipsImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxOrganizationUsersImportInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxProcessTranslationGetInput {
  languages: Array<Scalars['String']['input']>;
  mode: TranslationMode;
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class XlsxProcessTranslationImportInput {
  blob: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  processId: Scalars['ID']['input'];
};

export class XlsxProcessTranslationUploadUrlInput {
  blob: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForCandidatesGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  collectionId: Scalars['ID']['input'];
  collectionOrganizationId: Scalars['ID']['input'];
  immigrationCountry: Scalars['String']['input'];
  language: Scalars['String']['input'];
  mode: CandidateSheetModeEnum;
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForContractTemplatesGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  immigrationCountry: Scalars['String']['input'];
  language: Scalars['String']['input'];
  myOrganizationOnly: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForDocumentImportGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationCrmDataGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationContactSettingsGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationContactsGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationUserGroupsInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationUserMembershipsInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationUsersInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForOrganizationsGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateForProcessesGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTemplateResult {
  __typename?: 'XLSXTemplateResult';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type XlsxTemplateResultEvent = ProgressEvent | XlsxTemplateResult;

export class XlsxTemplateTriggerExportGetInput {
  addTestData?: InputMaybe<Scalars['Boolean']['input']>;
  exportCategory: ExportCategoryEnum;
  language: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export class XlsxTranslationImportMessage {
  __typename?: 'XLSXTranslationImportMessage';
  language: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  property?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export class XlsxTranslationImportResult {
  __typename?: 'XLSXTranslationImportResult';
  messages: Array<XlsxTranslationImportMessage>;
  success: Scalars['Boolean']['output'];
};

export class YearsAndMonths {
  __typename?: 'YearsAndMonths';
  experiences: Array<ExperienceData>;
  months: Scalars['Float']['output'];
  years: Scalars['Float']['output'];
};

export type GetBillingDataSubscriptionVariables = Exact<{
  input: ExcelAddInBillingDataInput;
}>;


export type GetBillingDataSubscription = { __typename?: 'Subscription', getBillingData:
    | { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type OrganizationListDtoFragment = { __typename?: 'OrganizationListDTO', organizations?: Array<{ __typename?: 'OrganizationListEntry', organizationId: string, isLicensed: boolean, name: string }> | null };

export type OrganizationListEntryFragment = { __typename?: 'OrganizationListEntry', organizationId: string, isLicensed: boolean, name: string };

export type ExcelAddInDtoFragment = { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> };

export type ExcelTableFragment = { __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null };

export type ExcelColumnFragment = { __typename?: 'ExcelColumn', id: string, label: string };

export type GetCandidateDataSubscriptionVariables = Exact<{
  input: ExcelAddInGetCandidateDataInput;
}>;


export type GetCandidateDataSubscription = { __typename?: 'Subscription', getCandidateData:
    | { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type GetCollectionListSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionListSubscription = { __typename?: 'Subscription', getCollectionList:
    | { __typename?: 'CollectionListDTO', orgId: string, collection?: Array<{ __typename?: 'CollectionListEntry', id: string, name: string, organizationId: string }> | null }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type CollectionListDtoFragment = { __typename?: 'CollectionListDTO', orgId: string, collection?: Array<{ __typename?: 'CollectionListEntry', id: string, name: string, organizationId: string }> | null };

export type CollectionListEntryFragment = { __typename?: 'CollectionListEntry', id: string, name: string, organizationId: string };

export type GetChangeStatisticsDataSubscriptionVariables = Exact<{
  input: ExcelAddinGetChangeStatisticsInput;
}>;


export type GetChangeStatisticsDataSubscription = { __typename?: 'Subscription', getChangeStatisticsData:
    | { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type GetKnownVarsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetKnownVarsSubscription = { __typename?: 'Subscription', getKnownVars:
    | { __typename?: 'KnownVarsTreeDTO', metaData?: string | null, knownVars: Array<{ __typename?: 'KnownVarsNode', key: string, label: string, parentKey?: string | null, data: { __typename?: 'TreeNodeData', explanation?: string | null, example?: string | null, syntax: string } }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type KnownVarsTreeDtoFragment = { __typename?: 'KnownVarsTreeDTO', metaData?: string | null, knownVars: Array<{ __typename?: 'KnownVarsNode', key: string, label: string, parentKey?: string | null, data: { __typename?: 'TreeNodeData', explanation?: string | null, example?: string | null, syntax: string } }> };

export type KnownVarsNodeFragment = { __typename?: 'KnownVarsNode', key: string, label: string, parentKey?: string | null, data: { __typename?: 'TreeNodeData', explanation?: string | null, example?: string | null, syntax: string } };

export type TreeNodeDataFragment = { __typename?: 'TreeNodeData', explanation?: string | null, example?: string | null, syntax: string };

export type GetLingokingDataSubscriptionVariables = Exact<{
  input: ExcelAddInLingokingDataInput;
}>;


export type GetLingokingDataSubscription = { __typename?: 'Subscription', getLingokingData:
    | { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type GetAvailableOrganizationsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableOrganizationsSubscription = { __typename?: 'Subscription', getAvailableOrganizations:
    | { __typename?: 'OrganizationListDTO', organizations?: Array<{ __typename?: 'OrganizationListEntry', organizationId: string, isLicensed: boolean, name: string }> | null }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type GetSalesDataSubscriptionVariables = Exact<{
  input: ExcelAddInSalesDataInput;
}>;


export type GetSalesDataSubscription = { __typename?: 'Subscription', getSalesData:
    | { __typename?: 'ExcelAddInDTO', dataTables: Array<{ __typename?: 'ExcelTable', id: string, label: string, dataCells: Array<any>, columns?: Array<{ __typename?: 'ExcelColumn', id: string, label: string }> | null }> }
    | { __typename?: 'ProgressEvent', progress?: number | null, progressMessage?: string | null }
   };

export type GetSettingsQueryVariables = Exact<{
  firstLoadInSession: Scalars['Boolean']['input'];
}>;


export type GetSettingsQuery = { __typename?: 'Query', settings: { __typename?: 'Settings', userPermissions?: Array<string> | null, organizationId?: string | null, auth0UserId?: string | null, isCandidate?: boolean | null, organizationCode?: string | null, organizationName?: string | null, organizationEmail?: string | null, supportEmail?: string | null, supportPhone?: string | null, creatorOrganizationId?: string | null, creatorOrganizationName?: string | null, isCreatorMasterOrganization?: boolean | null, isMasterOrganization?: boolean | null, isMasterUser?: boolean | null, userEmail?: string | null, userDisplayName?: string | null, userInitials?: string | null, userDisplayId?: string | null, userSettings?: { __typename?: 'UserSettings', inboxTaskVisibilityMode?: UserTaskVisibilityMode | null } | null } };

export const OrganizationListEntryFragmentDoc = gql`
    fragment OrganizationListEntry on OrganizationListEntry {
  organizationId
  isLicensed
  name
}
    `;
export const OrganizationListDtoFragmentDoc = gql`
    fragment OrganizationListDTO on OrganizationListDTO {
  organizations {
    ...OrganizationListEntry
  }
}
    ${OrganizationListEntryFragmentDoc}`;
export const ExcelColumnFragmentDoc = gql`
    fragment ExcelColumn on ExcelColumn {
  id
  label
}
    `;
export const ExcelTableFragmentDoc = gql`
    fragment ExcelTable on ExcelTable {
  id
  label
  columns {
    ...ExcelColumn
  }
  dataCells
}
    ${ExcelColumnFragmentDoc}`;
export const ExcelAddInDtoFragmentDoc = gql`
    fragment ExcelAddInDTO on ExcelAddInDTO {
  dataTables {
    ...ExcelTable
  }
}
    ${ExcelTableFragmentDoc}`;
export const CollectionListEntryFragmentDoc = gql`
    fragment CollectionListEntry on CollectionListEntry {
  id
  name
  organizationId
}
    `;
export const CollectionListDtoFragmentDoc = gql`
    fragment CollectionListDTO on CollectionListDTO {
  orgId
  collection {
    ...CollectionListEntry
  }
}
    ${CollectionListEntryFragmentDoc}`;
export const TreeNodeDataFragmentDoc = gql`
    fragment TreeNodeData on TreeNodeData {
  explanation
  example
  syntax
}
    `;
export const KnownVarsNodeFragmentDoc = gql`
    fragment KnownVarsNode on KnownVarsNode {
  key
  label
  data {
    ...TreeNodeData
  }
  parentKey
}
    ${TreeNodeDataFragmentDoc}`;
export const KnownVarsTreeDtoFragmentDoc = gql`
    fragment KnownVarsTreeDTO on KnownVarsTreeDTO {
  knownVars {
    ...KnownVarsNode
  }
  metaData
}
    ${KnownVarsNodeFragmentDoc}`;
export const GetBillingDataDocument = gql`
    subscription getBillingData($input: ExcelAddInBillingDataInput!) {
  getBillingData(input: $input) {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on ExcelAddInDTO {
      ...ExcelAddInDTO
    }
  }
}
    ${ExcelAddInDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBillingDataGQL extends Apollo.Subscription<GetBillingDataSubscription, GetBillingDataSubscriptionVariables> {
    override document = GetBillingDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCandidateDataDocument = gql`
    subscription getCandidateData($input: ExcelAddInGetCandidateDataInput!) {
  getCandidateData(input: $input) {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on ExcelAddInDTO {
      ...ExcelAddInDTO
    }
  }
}
    ${ExcelAddInDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCandidateDataGQL extends Apollo.Subscription<GetCandidateDataSubscription, GetCandidateDataSubscriptionVariables> {
    override document = GetCandidateDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCollectionListDocument = gql`
    subscription getCollectionList {
  getCollectionList {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on CollectionListDTO {
      ...CollectionListDTO
    }
  }
}
    ${CollectionListDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCollectionListGQL extends Apollo.Subscription<GetCollectionListSubscription, GetCollectionListSubscriptionVariables> {
    override document = GetCollectionListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChangeStatisticsDataDocument = gql`
    subscription getChangeStatisticsData($input: ExcelAddinGetChangeStatisticsInput!) {
  getChangeStatisticsData(input: $input) {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on ExcelAddInDTO {
      ...ExcelAddInDTO
    }
  }
}
    ${ExcelAddInDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChangeStatisticsDataGQL extends Apollo.Subscription<GetChangeStatisticsDataSubscription, GetChangeStatisticsDataSubscriptionVariables> {
    override document = GetChangeStatisticsDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKnownVarsDocument = gql`
    subscription getKnownVars {
  getKnownVars {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on KnownVarsTreeDTO {
      ...KnownVarsTreeDTO
    }
  }
}
    ${KnownVarsTreeDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKnownVarsGQL extends Apollo.Subscription<GetKnownVarsSubscription, GetKnownVarsSubscriptionVariables> {
    override document = GetKnownVarsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLingokingDataDocument = gql`
    subscription getLingokingData($input: ExcelAddInLingokingDataInput!) {
  getLingokingData(input: $input) {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on ExcelAddInDTO {
      ...ExcelAddInDTO
    }
  }
}
    ${ExcelAddInDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLingokingDataGQL extends Apollo.Subscription<GetLingokingDataSubscription, GetLingokingDataSubscriptionVariables> {
    override document = GetLingokingDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAvailableOrganizationsDocument = gql`
    subscription getAvailableOrganizations {
  getAvailableOrganizations {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on OrganizationListDTO {
      ...OrganizationListDTO
    }
  }
}
    ${OrganizationListDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAvailableOrganizationsGQL extends Apollo.Subscription<GetAvailableOrganizationsSubscription, GetAvailableOrganizationsSubscriptionVariables> {
    override document = GetAvailableOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSalesDataDocument = gql`
    subscription getSalesData($input: ExcelAddInSalesDataInput!) {
  getSalesData(input: $input) {
    ... on ProgressEvent {
      progress
      progressMessage
    }
    ... on ExcelAddInDTO {
      ...ExcelAddInDTO
    }
  }
}
    ${ExcelAddInDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesDataGQL extends Apollo.Subscription<GetSalesDataSubscription, GetSalesDataSubscriptionVariables> {
    override document = GetSalesDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSettingsDocument = gql`
    query getSettings($firstLoadInSession: Boolean!) {
  settings(firstLoadInSession: $firstLoadInSession) {
    userPermissions
    organizationId
    auth0UserId
    isCandidate
    organizationCode
    organizationName
    organizationEmail
    supportEmail
    supportPhone
    creatorOrganizationId
    creatorOrganizationName
    isCreatorMasterOrganization
    isMasterOrganization
    isMasterUser
    userEmail
    userDisplayName
    userInitials
    userDisplayId
    userSettings {
      inboxTaskVisibilityMode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSettingsGQL extends Apollo.Query<GetSettingsQuery, GetSettingsQueryVariables> {
    override document = GetSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumLookup = {
  "AccountingRecordType": AccountingRecordType,
  "AccrualTreatment": AccrualTreatment,
  "AccrualType": AccrualType,
  "ActivityType": ActivityType,
  "AddOnServiceAvailabilityForPartners": AddOnServiceAvailabilityForPartners,
  "AddOnServiceCategoryEnum": AddOnServiceCategoryEnum,
  "AddOnServiceStatus": AddOnServiceStatus,
  "AddOnServicesEnum": AddOnServicesEnum,
  "AiChatContextType": AiChatContextType,
  "AiChatHistoryRole": AiChatHistoryRole,
  "AiChatTitleSource": AiChatTitleSource,
  "AiChatTurnStatus": AiChatTurnStatus,
  "AiFeedbackRating": AiFeedbackRating,
  "AiResponseType": AiResponseType,
  "AmountType": AmountType,
  "AnabinAssetType": AnabinAssetType,
  "AnonymizationTypeEnum": AnonymizationTypeEnum,
  "ApplicationMaskCustomQuestionAnswerType": ApplicationMaskCustomQuestionAnswerType,
  "ApplicationMaskUploadType": ApplicationMaskUploadType,
  "Asset": Asset,
  "AuditTaskModeEnum": AuditTaskModeEnum,
  "AutoCvResponseStatus": AutoCvResponseStatus,
  "BaseProcessTypeEnum": BaseProcessTypeEnum,
  "BenefitTimeInterval": BenefitTimeInterval,
  "BillingEventTriggerType": BillingEventTriggerType,
  "BillingEventType": BillingEventType,
  "BillingTableType": BillingTableType,
  "BookingPostponeType": BookingPostponeType,
  "BookingSource": BookingSource,
  "BookingType": BookingType,
  "CalculationBasis": CalculationBasis,
  "CandidateAssignmentExceptionOperation": CandidateAssignmentExceptionOperation,
  "CandidateAssignmentExceptionType": CandidateAssignmentExceptionType,
  "CandidateChatGroupConversationType": CandidateChatGroupConversationType,
  "CandidateColumn": CandidateColumn,
  "CandidateColumnDataType": CandidateColumnDataType,
  "CandidateOrigin": CandidateOrigin,
  "CandidateProfileConfigTargetType": CandidateProfileConfigTargetType,
  "CandidateReceiptStatus": CandidateReceiptStatus,
  "CandidateRelation": CandidateRelation,
  "CandidateSheetModeEnum": CandidateSheetModeEnum,
  "CandidateSource": CandidateSource,
  "CandidateStatus": CandidateStatus,
  "CandidateTagColor": CandidateTagColor,
  "CandidateVerificationLevel": CandidateVerificationLevel,
  "ChallengeBookingStatus": ChallengeBookingStatus,
  "ChatConversationTypeEnum": ChatConversationTypeEnum,
  "ChatGroupType": ChatGroupType,
  "ChatMessageRole": ChatMessageRole,
  "ChatUserRole": ChatUserRole,
  "ClaimSigningSlotFailureReason": ClaimSigningSlotFailureReason,
  "ClarificationMode": ClarificationMode,
  "CollectionAutoFilterTemplateDeletionBehavior": CollectionAutoFilterTemplateDeletionBehavior,
  "CollectionAutoFilterTemplateSpecialPurpose": CollectionAutoFilterTemplateSpecialPurpose,
  "CollectionKindEnum": CollectionKindEnum,
  "CollectionMethod": CollectionMethod,
  "CollectionType": CollectionType,
  "CompensationType": CompensationType,
  "CompletionState": CompletionState,
  "CompletionStatus": CompletionStatus,
  "ConfigurableTable": ConfigurableTable,
  "ContactSharingMode": ContactSharingMode,
  "ContingentExpirationType": ContingentExpirationType,
  "ContractTemplateSharingMode": ContractTemplateSharingMode,
  "ContractTermTimePeriod": ContractTermTimePeriod,
  "CopyDataTypeEnum": CopyDataTypeEnum,
  "CreditNoteStatus": CreditNoteStatus,
  "DashboardVisibilityOptions": DashboardVisibilityOptions,
  "DashboardWidgetAudience": DashboardWidgetAudience,
  "DashboardWidgetLogoSize": DashboardWidgetLogoSize,
  "DiscountType": DiscountType,
  "DocumentAccess": DocumentAccess,
  "DocumentDeliveryFormat": DocumentDeliveryFormat,
  "DocumentFinishingMode": DocumentFinishingMode,
  "DocumentGenerationLanguageHandling": DocumentGenerationLanguageHandling,
  "DocumentGenerationMode": DocumentGenerationMode,
  "DocumentLockMode": DocumentLockMode,
  "DocumentMode": DocumentMode,
  "DocumentPurpose": DocumentPurpose,
  "DocumentSelectionCriterion": DocumentSelectionCriterion,
  "DocumentStatusEnum": DocumentStatusEnum,
  "DocumentTemplateMode": DocumentTemplateMode,
  "DocumentTemplateStatus": DocumentTemplateStatus,
  "DocumentTemplateType": DocumentTemplateType,
  "DocumentTranslationMode": DocumentTranslationMode,
  "DocumentTranslationProvider": DocumentTranslationProvider,
  "DocumentWriteMode": DocumentWriteMode,
  "DurationCalculationType": DurationCalculationType,
  "EducationCourseAttendance": EducationCourseAttendance,
  "EducationCourseCandidateStatus": EducationCourseCandidateStatus,
  "EducationCoursePerformanceStatus": EducationCoursePerformanceStatus,
  "EducationCourseTrackingMode": EducationCourseTrackingMode,
  "EducationCourseVisibility": EducationCourseVisibility,
  "EducationMode": EducationMode,
  "EducationModuleStatus": EducationModuleStatus,
  "EducationModuleType": EducationModuleType,
  "EmailEventType": EmailEventType,
  "EmailStopReason": EmailStopReason,
  "EmailTemplateTarget": EmailTemplateTarget,
  "EmailTemplateType": EmailTemplateType,
  "EmploymentRelationshipType": EmploymentRelationshipType,
  "EnterMissingInformation": EnterMissingInformation,
  "ExamModuleType": ExamModuleType,
  "ExamStatus": ExamStatus,
  "ExamType": ExamType,
  "ExperienceType": ExperienceType,
  "ExplanationUnavailableReason": ExplanationUnavailableReason,
  "ExportCategoryEnum": ExportCategoryEnum,
  "ExpressionType": ExpressionType,
  "EzbDataSharingMode": EzbDataSharingMode,
  "FeedbackStatusPhaseOne": FeedbackStatusPhaseOne,
  "FeedbackStatusPhaseTwo": FeedbackStatusPhaseTwo,
  "FileAccess": FileAccess,
  "FileAdjustmentType": FileAdjustmentType,
  "FloorPaymentType": FloorPaymentType,
  "GlobalTalentPoolCategory": GlobalTalentPoolCategory,
  "Granularity": Granularity,
  "InstanceStateEnum": InstanceStateEnum,
  "InvoiceStatus": InvoiceStatus,
  "InvoiceType": InvoiceType,
  "KnownConsentIdentifiers": KnownConsentIdentifiers,
  "KnownFormToken": KnownFormToken,
  "KnownPdfFormTokens": KnownPdfFormTokens,
  "KpiType": KpiType,
  "KpiUnit": KpiUnit,
  "LaborAgreementSharingMode": LaborAgreementSharingMode,
  "LanguageLevelSource": LanguageLevelSource,
  "LanguageTrainingStatus": LanguageTrainingStatus,
  "LingokingTableType": LingokingTableType,
  "ListMultiEditOperation": ListMultiEditOperation,
  "MatchingStatus": MatchingStatus,
  "MessengerEventType": MessengerEventType,
  "MessengerMessageReason": MessengerMessageReason,
  "MetricType": MetricType,
  "MilestoneDashboardSharingTargetGroup": MilestoneDashboardSharingTargetGroup,
  "MilestoneScheduleSegmentName": MilestoneScheduleSegmentName,
  "MilestoneStatus": MilestoneStatus,
  "MilestoneVisibility": MilestoneVisibility,
  "NewUiDashboardBirthdayRange": NewUiDashboardBirthdayRange,
  "NotificationScope": NotificationScope,
  "OccupationSkillType": OccupationSkillType,
  "OnlineApplicationLoginError": OnlineApplicationLoginError,
  "OnlineApplicationStatus": OnlineApplicationStatus,
  "OnlineApplicationToken": OnlineApplicationToken,
  "OrganizationAuditAdditionRequestResult": OrganizationAuditAdditionRequestResult,
  "OrganizationAuditInterviewAssessmentEnum": OrganizationAuditInterviewAssessmentEnum,
  "OrganizationAuditResult": OrganizationAuditResult,
  "OrganizationContactFunction": OrganizationContactFunction,
  "OrganizationLinkInvitationStatus": OrganizationLinkInvitationStatus,
  "OrganizationLinkMode": OrganizationLinkMode,
  "OrganizationSearchType": OrganizationSearchType,
  "OrganizationTagType": OrganizationTagType,
  "PartnerSharingMode": PartnerSharingMode,
  "PaymentPeriod": PaymentPeriod,
  "PaymentTime": PaymentTime,
  "PhaseType": PhaseType,
  "PlanType": PlanType,
  "PlanningType": PlanningType,
  "PriorityEnum": PriorityEnum,
  "ProcessEventEnum": ProcessEventEnum,
  "ProcessGraphConnectionStyle": ProcessGraphConnectionStyle,
  "ProcessInstanceStateEnum": ProcessInstanceStateEnum,
  "ProcessModelCommandEnum": ProcessModelCommandEnum,
  "ProcessModelCopySourceKind": ProcessModelCopySourceKind,
  "ProcessModelValidationSeverity": ProcessModelValidationSeverity,
  "ProcessOperationEnum": ProcessOperationEnum,
  "ProcessPlanningDurationType": ProcessPlanningDurationType,
  "ProcessProgressLevelEnum": ProcessProgressLevelEnum,
  "ProcessReleaseSelectionModeEnum": ProcessReleaseSelectionModeEnum,
  "ProcessRuleTargetType": ProcessRuleTargetType,
  "ProcessRuleTaskTargetType": ProcessRuleTaskTargetType,
  "ProcessRuleTriggerEvent": ProcessRuleTriggerEvent,
  "ProcessRuleType": ProcessRuleType,
  "ProcessStatePrecissionEnum": ProcessStatePrecissionEnum,
  "ProcessStateTranslateDocumentsOrderState": ProcessStateTranslateDocumentsOrderState,
  "ProcessTargetEnum": ProcessTargetEnum,
  "ProcessTaskBulkEditRoleOperation": ProcessTaskBulkEditRoleOperation,
  "ProcessTaskEditableField": ProcessTaskEditableField,
  "ProcessTaskResetMode": ProcessTaskResetMode,
  "ProcessingResultType": ProcessingResultType,
  "ProfessionCategory": ProfessionCategory,
  "ProfessionalFieldAdditionalInformationType": ProfessionalFieldAdditionalInformationType,
  "ProfileDataEditStatus": ProfileDataEditStatus,
  "PropertyTypeEnum": PropertyTypeEnum,
  "QueueType": QueueType,
  "RecognitionProfessionalExperience": RecognitionProfessionalExperience,
  "RecognitionState": RecognitionState,
  "RemoveFromListBehaviorEnum": RemoveFromListBehaviorEnum,
  "ReplyTypeEnum": ReplyTypeEnum,
  "RevenueCategory": RevenueCategory,
  "RuleExecutionErrorReason": RuleExecutionErrorReason,
  "SalesTableType": SalesTableType,
  "ServiceType": ServiceType,
  "SharingRestrictionMode": SharingRestrictionMode,
  "SharingTypeEnum": SharingTypeEnum,
  "SignatureType": SignatureType,
  "SignerStatus": SignerStatus,
  "SigningSubmissionFilterStatus": SigningSubmissionFilterStatus,
  "SigningSubmissionStatus": SigningSubmissionStatus,
  "SortingTypeEnum": SortingTypeEnum,
  "StaticDataType": StaticDataType,
  "StripeErrorMessageKeys": StripeErrorMessageKeys,
  "SupportedBillingCurrency": SupportedBillingCurrency,
  "SupportedImmigrationCountry": SupportedImmigrationCountry,
  "TabPermission": TabPermission,
  "TableMode": TableMode,
  "TalentPoolParticipantType": TalentPoolParticipantType,
  "TalentPoolSharingCvKind": TalentPoolSharingCvKind,
  "TalentPoolType": TalentPoolType,
  "TalentRequestState": TalentRequestState,
  "TaskDueDateBucket": TaskDueDateBucket,
  "TaskTableMode": TaskTableMode,
  "TaskVisibilityEnum": TaskVisibilityEnum,
  "TechnicalSourceEnum": TechnicalSourceEnum,
  "TemplateToDocumentTypeConversion": TemplateToDocumentTypeConversion,
  "TerminationEmploymentActor": TerminationEmploymentActor,
  "TrafficLightType": TrafficLightType,
  "TranslationMode": TranslationMode,
  "TranslationOrderDocumentState": TranslationOrderDocumentState,
  "TranslationOrderOverviewMode": TranslationOrderOverviewMode,
  "TranslatorType": TranslatorType,
  "TypeOfEmployment": TypeOfEmployment,
  "UserAccountTriggerSkipReason": UserAccountTriggerSkipReason,
  "UserRole": UserRole,
  "UserSalutation": UserSalutation,
  "UserTaskVisibilityMode": UserTaskVisibilityMode,
  "UserView": UserView,
  "VaccineStatusEnum": VaccineStatusEnum,
  "VoteType": VoteType,
  "WebhookEventType": WebhookEventType,
  "WorkExperiencePrecissionEnum": WorkExperiencePrecissionEnum,
  "WorkingTimeTypeEnum": WorkingTimeTypeEnum
};

